/*
 @license
 Shaka Player
 Copyright 2016 Google LLC
 SPDX-License-Identifier: Apache-2.0
*/
(function () {
  var innerGlobal = typeof window != "undefined" ? window : global;
  var exportTo = {};
  (function (window, global, module) {
    /*
    Copyright The Closure Library Authors.
    SPDX-License-Identifier: Apache-2.0
    */
    var p;

    function aa(a) {
      var b = 0;
      return function () {
        return b < a.length ? {
          done: !1,
          value: a[b++]
        } : {
          done: !0
        };
      };
    }

    var ba = "function" == typeof Object.defineProperties ? Object.defineProperty : function (a, b, c) {
      if (a == Array.prototype || a == Object.prototype) return a;
      a[b] = c.value;
      return a;
    };

    function ca(a) {
      a = ["object" == typeof globalThis && globalThis, a, "object" == typeof window && window, "object" == typeof self && self, "object" == typeof global && global];

      for (var b = 0; b < a.length; ++b) {
        var c = a[b];
        if (c && c.Math == Math) return c;
      }

      throw Error("Cannot find global object");
    }

    var da = ca(this);

    function ea(a, b) {
      if (b) a: {
        var c = da;
        a = a.split(".");

        for (var d = 0; d < a.length - 1; d++) {
          var e = a[d];
          if (!(e in c)) break a;
          c = c[e];
        }

        a = a[a.length - 1];
        d = c[a];
        b = b(d);
        b != d && null != b && ba(c, a, {
          configurable: !0,
          writable: !0,
          value: b
        });
      }
    }

    ea("Symbol", function (a) {
      function b(f) {
        if (this instanceof b) throw new TypeError("Symbol is not a constructor");
        return new c(d + (f || "") + "_" + e++, f);
      }

      function c(f, g) {
        this.g = f;
        ba(this, "description", {
          configurable: !0,
          writable: !0,
          value: g
        });
      }

      if (a) return a;

      c.prototype.toString = function () {
        return this.g;
      };

      var d = "jscomp_symbol_" + (1E9 * Math.random() >>> 0) + "_",
          e = 0;
      return b;
    });
    ea("Symbol.iterator", function (a) {
      if (a) return a;
      a = Symbol("Symbol.iterator");

      for (var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++) {
        var d = da[b[c]];
        "function" === typeof d && "function" != typeof d.prototype[a] && ba(d.prototype, a, {
          configurable: !0,
          writable: !0,
          value: function () {
            return fa(aa(this));
          }
        });
      }

      return a;
    });

    function fa(a) {
      a = {
        next: a
      };

      a[Symbol.iterator] = function () {
        return this;
      };

      return a;
    }

    function t(a) {
      var b = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];
      return b ? b.call(a) : {
        next: aa(a)
      };
    }

    function w(a) {
      if (!(a instanceof Array)) {
        a = t(a);

        for (var b, c = []; !(b = a.next()).done;) c.push(b.value);

        a = c;
      }

      return a;
    }

    var ha = "function" == typeof Object.create ? Object.create : function (a) {
      function b() {}

      b.prototype = a;
      return new b();
    },
        ia;
    if ("function" == typeof Object.setPrototypeOf) ia = Object.setPrototypeOf;else {
      var ja;

      a: {
        var ka = {
          a: !0
        },
            ma = {};

        try {
          ma.__proto__ = ka;
          ja = ma.a;
          break a;
        } catch (a) {}

        ja = !1;
      }

      ia = ja ? function (a, b) {
        a.__proto__ = b;
        if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
        return a;
      } : null;
    }
    var na = ia;

    function pa(a, b) {
      a.prototype = ha(b.prototype);
      a.prototype.constructor = a;
      if (na) na(a, b);else for (var c in b) if ("prototype" != c) if (Object.defineProperties) {
        var d = Object.getOwnPropertyDescriptor(b, c);
        d && Object.defineProperty(a, c, d);
      } else a[c] = b[c];
      a.lk = b.prototype;
    }

    function qa() {
      this.s = !1;
      this.l = null;
      this.h = void 0;
      this.g = 1;
      this.j = this.m = 0;
      this.C = this.i = null;
    }

    function ra(a) {
      if (a.s) throw new TypeError("Generator is already running");
      a.s = !0;
    }

    qa.prototype.u = function (a) {
      this.h = a;
    };

    function sa(a, b) {
      a.i = {
        Jg: b,
        Sg: !0
      };
      a.g = a.m || a.j;
    }

    qa.prototype.return = function (a) {
      this.i = {
        return: a
      };
      this.g = this.j;
    };

    function D(a, b, c) {
      a.g = c;
      return {
        value: b
      };
    }

    qa.prototype.F = function (a) {
      this.g = a;
    };

    function F(a) {
      a.g = 0;
    }

    function ta(a, b, c) {
      a.m = b;
      void 0 != c && (a.j = c);
    }

    function ua(a, b) {
      a.m = 0;
      a.j = b || 0;
    }

    function va(a, b, c) {
      a.g = b;
      a.m = c || 0;
    }

    function wa(a, b) {
      a.m = b || 0;
      b = a.i.Jg;
      a.i = null;
      return b;
    }

    function xa(a) {
      a.C = [a.i];
      a.m = 0;
      a.j = 0;
    }

    function ya(a, b) {
      var c = a.C.splice(0)[0];
      (c = a.i = a.i || c) ? c.Sg ? a.g = a.m || a.j : void 0 != c.F && a.j < c.F ? (a.g = c.F, a.i = null) : a.g = a.j : a.g = b;
    }

    function za(a) {
      this.g = new qa();
      this.h = a;
    }

    function Ba(a, b) {
      ra(a.g);
      var c = a.g.l;
      if (c) return Ca(a, "return" in c ? c["return"] : function (d) {
        return {
          value: d,
          done: !0
        };
      }, b, a.g.return);
      a.g.return(b);
      return Da(a);
    }

    function Ca(a, b, c, d) {
      try {
        var e = b.call(a.g.l, c);
        if (!(e instanceof Object)) throw new TypeError("Iterator result " + e + " is not an object");
        if (!e.done) return a.g.s = !1, e;
        var f = e.value;
      } catch (g) {
        return a.g.l = null, sa(a.g, g), Da(a);
      }

      a.g.l = null;
      d.call(a.g, f);
      return Da(a);
    }

    function Da(a) {
      for (; a.g.g;) try {
        var b = a.h(a.g);
        if (b) return a.g.s = !1, {
          value: b.value,
          done: !1
        };
      } catch (c) {
        a.g.h = void 0, sa(a.g, c);
      }

      a.g.s = !1;

      if (a.g.i) {
        b = a.g.i;
        a.g.i = null;
        if (b.Sg) throw b.Jg;
        return {
          value: b.return,
          done: !0
        };
      }

      return {
        value: void 0,
        done: !0
      };
    }

    function Ea(a) {
      this.next = function (b) {
        ra(a.g);
        a.g.l ? b = Ca(a, a.g.l.next, b, a.g.u) : (a.g.u(b), b = Da(a));
        return b;
      };

      this.throw = function (b) {
        ra(a.g);
        a.g.l ? b = Ca(a, a.g.l["throw"], b, a.g.u) : (sa(a.g, b), b = Da(a));
        return b;
      };

      this.return = function (b) {
        return Ba(a, b);
      };

      this[Symbol.iterator] = function () {
        return this;
      };
    }

    function Fa(a) {
      function b(d) {
        return a.next(d);
      }

      function c(d) {
        return a.throw(d);
      }

      return new Promise(function (d, e) {
        function f(g) {
          g.done ? d(g.value) : Promise.resolve(g.value).then(b, c).then(f, e);
        }

        f(a.next());
      });
    }

    function K(a) {
      return Fa(new Ea(new za(a)));
    }

    function Ga() {
      for (var a = Number(this), b = [], c = a; c < arguments.length; c++) b[c - a] = arguments[c];

      return b;
    }

    ea("Promise", function (a) {
      function b(g) {
        this.h = 0;
        this.i = void 0;
        this.g = [];
        this.s = !1;
        var h = this.j();

        try {
          g(h.resolve, h.reject);
        } catch (k) {
          h.reject(k);
        }
      }

      function c() {
        this.g = null;
      }

      function d(g) {
        return g instanceof b ? g : new b(function (h) {
          h(g);
        });
      }

      if (a) return a;

      c.prototype.h = function (g) {
        if (null == this.g) {
          this.g = [];
          var h = this;
          this.i(function () {
            h.l();
          });
        }

        this.g.push(g);
      };

      var e = da.setTimeout;

      c.prototype.i = function (g) {
        e(g, 0);
      };

      c.prototype.l = function () {
        for (; this.g && this.g.length;) {
          var g = this.g;
          this.g = [];

          for (var h = 0; h < g.length; ++h) {
            var k = g[h];
            g[h] = null;

            try {
              k();
            } catch (l) {
              this.j(l);
            }
          }
        }

        this.g = null;
      };

      c.prototype.j = function (g) {
        this.i(function () {
          throw g;
        });
      };

      b.prototype.j = function () {
        function g(l) {
          return function (m) {
            k || (k = !0, l.call(h, m));
          };
        }

        var h = this,
            k = !1;
        return {
          resolve: g(this.H),
          reject: g(this.l)
        };
      };

      b.prototype.H = function (g) {
        if (g === this) this.l(new TypeError("A Promise cannot resolve to itself"));else if (g instanceof b) this.J(g);else {
          a: switch (typeof g) {
            case "object":
              var h = null != g;
              break a;

            case "function":
              h = !0;
              break a;

            default:
              h = !1;
          }

          h ? this.G(g) : this.m(g);
        }
      };

      b.prototype.G = function (g) {
        var h = void 0;

        try {
          h = g.then;
        } catch (k) {
          this.l(k);
          return;
        }

        "function" == typeof h ? this.K(h, g) : this.m(g);
      };

      b.prototype.l = function (g) {
        this.u(2, g);
      };

      b.prototype.m = function (g) {
        this.u(1, g);
      };

      b.prototype.u = function (g, h) {
        if (0 != this.h) throw Error("Cannot settle(" + g + ", " + h + "): Promise already settled in state" + this.h);
        this.h = g;
        this.i = h;
        2 === this.h && this.I();
        this.C();
      };

      b.prototype.I = function () {
        var g = this;
        e(function () {
          if (g.D()) {
            var h = da.console;
            "undefined" !== typeof h && h.error(g.i);
          }
        }, 1);
      };

      b.prototype.D = function () {
        if (this.s) return !1;
        var g = da.CustomEvent,
            h = da.Event,
            k = da.dispatchEvent;
        if ("undefined" === typeof k) return !0;
        "function" === typeof g ? g = new g("unhandledrejection", {
          cancelable: !0
        }) : "function" === typeof h ? g = new h("unhandledrejection", {
          cancelable: !0
        }) : (g = da.document.createEvent("CustomEvent"), g.initCustomEvent("unhandledrejection", !1, !0, g));
        g.promise = this;
        g.reason = this.i;
        return k(g);
      };

      b.prototype.C = function () {
        if (null != this.g) {
          for (var g = 0; g < this.g.length; ++g) f.h(this.g[g]);

          this.g = null;
        }
      };

      var f = new c();

      b.prototype.J = function (g) {
        var h = this.j();
        g.Vd(h.resolve, h.reject);
      };

      b.prototype.K = function (g, h) {
        var k = this.j();

        try {
          g.call(h, k.resolve, k.reject);
        } catch (l) {
          k.reject(l);
        }
      };

      b.prototype.then = function (g, h) {
        function k(r, q) {
          return "function" == typeof r ? function (u) {
            try {
              l(r(u));
            } catch (v) {
              m(v);
            }
          } : q;
        }

        var l,
            m,
            n = new b(function (r, q) {
          l = r;
          m = q;
        });
        this.Vd(k(g, l), k(h, m));
        return n;
      };

      b.prototype.catch = function (g) {
        return this.then(void 0, g);
      };

      b.prototype.Vd = function (g, h) {
        function k() {
          switch (l.h) {
            case 1:
              g(l.i);
              break;

            case 2:
              h(l.i);
              break;

            default:
              throw Error("Unexpected state: " + l.h);
          }
        }

        var l = this;
        null == this.g ? f.h(k) : this.g.push(k);
        this.s = !0;
      };

      b.resolve = d;

      b.reject = function (g) {
        return new b(function (h, k) {
          k(g);
        });
      };

      b.race = function (g) {
        return new b(function (h, k) {
          for (var l = t(g), m = l.next(); !m.done; m = l.next()) d(m.value).Vd(h, k);
        });
      };

      b.all = function (g) {
        var h = t(g),
            k = h.next();
        return k.done ? d([]) : new b(function (l, m) {
          function n(u) {
            return function (v) {
              r[u] = v;
              q--;
              0 == q && l(r);
            };
          }

          var r = [],
              q = 0;

          do r.push(void 0), q++, d(k.value).Vd(n(r.length - 1), m), k = h.next(); while (!k.done);
        });
      };

      return b;
    });

    function Ha(a, b) {
      return Object.prototype.hasOwnProperty.call(a, b);
    }

    ea("WeakMap", function (a) {
      function b(k) {
        this.g = (h += Math.random() + 1).toString();

        if (k) {
          k = t(k);

          for (var l; !(l = k.next()).done;) l = l.value, this.set(l[0], l[1]);
        }
      }

      function c() {}

      function d(k) {
        var l = typeof k;
        return "object" === l && null !== k || "function" === l;
      }

      function e(k) {
        if (!Ha(k, g)) {
          var l = new c();
          ba(k, g, {
            value: l
          });
        }
      }

      function f(k) {
        var l = Object[k];
        l && (Object[k] = function (m) {
          if (m instanceof c) return m;
          Object.isExtensible(m) && e(m);
          return l(m);
        });
      }

      if (function () {
        if (!a || !Object.seal) return !1;

        try {
          var k = Object.seal({}),
              l = Object.seal({}),
              m = new a([[k, 2], [l, 3]]);
          if (2 != m.get(k) || 3 != m.get(l)) return !1;
          m.delete(k);
          m.set(l, 4);
          return !m.has(k) && 4 == m.get(l);
        } catch (n) {
          return !1;
        }
      }()) return a;
      var g = "$jscomp_hidden_" + Math.random();
      f("freeze");
      f("preventExtensions");
      f("seal");
      var h = 0;

      b.prototype.set = function (k, l) {
        if (!d(k)) throw Error("Invalid WeakMap key");
        e(k);
        if (!Ha(k, g)) throw Error("WeakMap key fail: " + k);
        k[g][this.g] = l;
        return this;
      };

      b.prototype.get = function (k) {
        return d(k) && Ha(k, g) ? k[g][this.g] : void 0;
      };

      b.prototype.has = function (k) {
        return d(k) && Ha(k, g) && Ha(k[g], this.g);
      };

      b.prototype.delete = function (k) {
        return d(k) && Ha(k, g) && Ha(k[g], this.g) ? delete k[g][this.g] : !1;
      };

      return b;
    });
    ea("Map", function (a) {
      function b() {
        var h = {};
        return h.Jb = h.next = h.head = h;
      }

      function c(h, k) {
        var l = h.g;
        return fa(function () {
          if (l) {
            for (; l.head != h.g;) l = l.Jb;

            for (; l.next != l.head;) return l = l.next, {
              done: !1,
              value: k(l)
            };

            l = null;
          }

          return {
            done: !0,
            value: void 0
          };
        });
      }

      function d(h, k) {
        var l = k && typeof k;
        "object" == l || "function" == l ? f.has(k) ? l = f.get(k) : (l = "" + ++g, f.set(k, l)) : l = "p_" + k;
        var m = h.h[l];
        if (m && Ha(h.h, l)) for (h = 0; h < m.length; h++) {
          var n = m[h];
          if (k !== k && n.key !== n.key || k === n.key) return {
            id: l,
            list: m,
            index: h,
            entry: n
          };
        }
        return {
          id: l,
          list: m,
          index: -1,
          entry: void 0
        };
      }

      function e(h) {
        this.h = {};
        this.g = b();
        this.size = 0;

        if (h) {
          h = t(h);

          for (var k; !(k = h.next()).done;) k = k.value, this.set(k[0], k[1]);
        }
      }

      if (function () {
        if (!a || "function" != typeof a || !a.prototype.entries || "function" != typeof Object.seal) return !1;

        try {
          var h = Object.seal({
            x: 4
          }),
              k = new a(t([[h, "s"]]));
          if ("s" != k.get(h) || 1 != k.size || k.get({
            x: 4
          }) || k.set({
            x: 4
          }, "t") != k || 2 != k.size) return !1;
          var l = k.entries(),
              m = l.next();
          if (m.done || m.value[0] != h || "s" != m.value[1]) return !1;
          m = l.next();
          return m.done || 4 != m.value[0].x || "t" != m.value[1] || !l.next().done ? !1 : !0;
        } catch (n) {
          return !1;
        }
      }()) return a;
      var f = new WeakMap();

      e.prototype.set = function (h, k) {
        h = 0 === h ? 0 : h;
        var l = d(this, h);
        l.list || (l.list = this.h[l.id] = []);
        l.entry ? l.entry.value = k : (l.entry = {
          next: this.g,
          Jb: this.g.Jb,
          head: this.g,
          key: h,
          value: k
        }, l.list.push(l.entry), this.g.Jb.next = l.entry, this.g.Jb = l.entry, this.size++);
        return this;
      };

      e.prototype.delete = function (h) {
        h = d(this, h);
        return h.entry && h.list ? (h.list.splice(h.index, 1), h.list.length || delete this.h[h.id], h.entry.Jb.next = h.entry.next, h.entry.next.Jb = h.entry.Jb, h.entry.head = null, this.size--, !0) : !1;
      };

      e.prototype.clear = function () {
        this.h = {};
        this.g = this.g.Jb = b();
        this.size = 0;
      };

      e.prototype.has = function (h) {
        return !!d(this, h).entry;
      };

      e.prototype.get = function (h) {
        return (h = d(this, h).entry) && h.value;
      };

      e.prototype.entries = function () {
        return c(this, function (h) {
          return [h.key, h.value];
        });
      };

      e.prototype.keys = function () {
        return c(this, function (h) {
          return h.key;
        });
      };

      e.prototype.values = function () {
        return c(this, function (h) {
          return h.value;
        });
      };

      e.prototype.forEach = function (h, k) {
        for (var l = this.entries(), m; !(m = l.next()).done;) m = m.value, h.call(k, m[1], m[0], this);
      };

      e.prototype[Symbol.iterator] = e.prototype.entries;
      var g = 0;
      return e;
    });

    function Ia(a, b) {
      a instanceof String && (a += "");
      var c = 0,
          d = !1,
          e = {
        next: function () {
          if (!d && c < a.length) {
            var f = c++;
            return {
              value: b(f, a[f]),
              done: !1
            };
          }

          d = !0;
          return {
            done: !0,
            value: void 0
          };
        }
      };

      e[Symbol.iterator] = function () {
        return e;
      };

      return e;
    }

    ea("Array.prototype.keys", function (a) {
      return a ? a : function () {
        return Ia(this, function (b) {
          return b;
        });
      };
    });
    ea("Set", function (a) {
      function b(c) {
        this.g = new Map();

        if (c) {
          c = t(c);

          for (var d; !(d = c.next()).done;) this.add(d.value);
        }

        this.size = this.g.size;
      }

      if (function () {
        if (!a || "function" != typeof a || !a.prototype.entries || "function" != typeof Object.seal) return !1;

        try {
          var c = Object.seal({
            x: 4
          }),
              d = new a(t([c]));
          if (!d.has(c) || 1 != d.size || d.add(c) != d || 1 != d.size || d.add({
            x: 4
          }) != d || 2 != d.size) return !1;
          var e = d.entries(),
              f = e.next();
          if (f.done || f.value[0] != c || f.value[1] != c) return !1;
          f = e.next();
          return f.done || f.value[0] == c || 4 != f.value[0].x || f.value[1] != f.value[0] ? !1 : e.next().done;
        } catch (g) {
          return !1;
        }
      }()) return a;

      b.prototype.add = function (c) {
        c = 0 === c ? 0 : c;
        this.g.set(c, c);
        this.size = this.g.size;
        return this;
      };

      b.prototype.delete = function (c) {
        c = this.g.delete(c);
        this.size = this.g.size;
        return c;
      };

      b.prototype.clear = function () {
        this.g.clear();
        this.size = 0;
      };

      b.prototype.has = function (c) {
        return this.g.has(c);
      };

      b.prototype.entries = function () {
        return this.g.entries();
      };

      b.prototype.values = function () {
        return this.g.values();
      };

      b.prototype.keys = b.prototype.values;
      b.prototype[Symbol.iterator] = b.prototype.values;

      b.prototype.forEach = function (c, d) {
        var e = this;
        this.g.forEach(function (f) {
          return c.call(d, f, f, e);
        });
      };

      return b;
    });
    ea("Array.from", function (a) {
      return a ? a : function (b, c, d) {
        c = null != c ? c : function (h) {
          return h;
        };
        var e = [],
            f = "undefined" != typeof Symbol && Symbol.iterator && b[Symbol.iterator];

        if ("function" == typeof f) {
          b = f.call(b);

          for (var g = 0; !(f = b.next()).done;) e.push(c.call(d, f.value, g++));
        } else for (f = b.length, g = 0; g < f; g++) e.push(c.call(d, b[g], g));

        return e;
      };
    });

    function Ja(a, b, c) {
      a instanceof String && (a = String(a));

      for (var d = a.length, e = 0; e < d; e++) {
        var f = a[e];
        if (b.call(c, f, e, a)) return {
          Qg: e,
          v: f
        };
      }

      return {
        Qg: -1,
        v: void 0
      };
    }

    ea("Array.prototype.findIndex", function (a) {
      return a ? a : function (b, c) {
        return Ja(this, b, c).Qg;
      };
    });
    ea("Object.is", function (a) {
      return a ? a : function (b, c) {
        return b === c ? 0 !== b || 1 / b === 1 / c : b !== b && c !== c;
      };
    });
    ea("Array.prototype.includes", function (a) {
      return a ? a : function (b, c) {
        var d = this;
        d instanceof String && (d = String(d));
        var e = d.length;
        c = c || 0;

        for (0 > c && (c = Math.max(c + e, 0)); c < e; c++) {
          var f = d[c];
          if (f === b || Object.is(f, b)) return !0;
        }

        return !1;
      };
    });

    function Ka(a, b, c) {
      if (null == a) throw new TypeError("The 'this' value for String.prototype." + c + " must not be null or undefined");
      if (b instanceof RegExp) throw new TypeError("First argument to String.prototype." + c + " must not be a regular expression");
      return a + "";
    }

    ea("String.prototype.includes", function (a) {
      return a ? a : function (b, c) {
        return -1 !== Ka(this, b, "includes").indexOf(b, c || 0);
      };
    });
    ea("Array.prototype.find", function (a) {
      return a ? a : function (b, c) {
        return Ja(this, b, c).v;
      };
    });
    ea("String.prototype.startsWith", function (a) {
      return a ? a : function (b, c) {
        var d = Ka(this, b, "startsWith"),
            e = d.length,
            f = b.length;
        c = Math.max(0, Math.min(c | 0, d.length));

        for (var g = 0; g < f && c < e;) if (d[c++] != b[g++]) return !1;

        return g >= f;
      };
    });
    ea("WeakSet", function (a) {
      function b(c) {
        this.g = new WeakMap();

        if (c) {
          c = t(c);

          for (var d; !(d = c.next()).done;) this.add(d.value);
        }
      }

      if (function () {
        if (!a || !Object.seal) return !1;

        try {
          var c = Object.seal({}),
              d = Object.seal({}),
              e = new a([c]);
          if (!e.has(c) || e.has(d)) return !1;
          e.delete(c);
          e.add(d);
          return !e.has(c) && e.has(d);
        } catch (f) {
          return !1;
        }
      }()) return a;

      b.prototype.add = function (c) {
        this.g.set(c, !0);
        return this;
      };

      b.prototype.has = function (c) {
        return this.g.has(c);
      };

      b.prototype.delete = function (c) {
        return this.g.delete(c);
      };

      return b;
    });
    var La = "function" == typeof Object.assign ? Object.assign : function (a, b) {
      for (var c = 1; c < arguments.length; c++) {
        var d = arguments[c];
        if (d) for (var e in d) Ha(d, e) && (a[e] = d[e]);
      }

      return a;
    };
    ea("Object.assign", function (a) {
      return a || La;
    });
    ea("Array.prototype.values", function (a) {
      return a ? a : function () {
        return Ia(this, function (b, c) {
          return c;
        });
      };
    });
    ea("Promise.prototype.finally", function (a) {
      return a ? a : function (b) {
        return this.then(function (c) {
          return Promise.resolve(b()).then(function () {
            return c;
          });
        }, function (c) {
          return Promise.resolve(b()).then(function () {
            throw c;
          });
        });
      };
    });
    ea("Array.prototype.entries", function (a) {
      return a ? a : function () {
        return Ia(this, function (b, c) {
          return [b, c];
        });
      };
    });
    ea("String.prototype.repeat", function (a) {
      return a ? a : function (b) {
        var c = Ka(this, null, "repeat");
        if (0 > b || 1342177279 < b) throw new RangeError("Invalid count value");
        b |= 0;

        for (var d = ""; b;) if (b & 1 && (d += c), b >>>= 1) c += c;

        return d;
      };
    });
    ea("Number.isNaN", function (a) {
      return a ? a : function (b) {
        return "number" === typeof b && isNaN(b);
      };
    });
    ea("Number.isFinite", function (a) {
      return a ? a : function (b) {
        return "number" !== typeof b ? !1 : !isNaN(b) && Infinity !== b && -Infinity !== b;
      };
    });
    ea("Object.values", function (a) {
      return a ? a : function (b) {
        var c = [],
            d;

        for (d in b) Ha(b, d) && c.push(b[d]);

        return c;
      };
    });
    ea("Math.log2", function (a) {
      return a ? a : function (b) {
        return Math.log(b) / Math.LN2;
      };
    });
    ea("Number.MAX_SAFE_INTEGER", function () {
      return 9007199254740991;
    });
    ea("Math.trunc", function (a) {
      return a ? a : function (b) {
        b = Number(b);
        if (isNaN(b) || Infinity === b || -Infinity === b || 0 === b) return b;
        var c = Math.floor(Math.abs(b));
        return 0 > b ? -c : c;
      };
    });
    ea("Object.entries", function (a) {
      return a ? a : function (b) {
        var c = [],
            d;

        for (d in b) Ha(b, d) && c.push([d, b[d]]);

        return c;
      };
    });

    function Ma(a) {
      a = Math.trunc(a) || 0;
      0 > a && (a += this.length);
      if (!(0 > a || a >= this.length)) return this[a];
    }

    ea("Array.prototype.at", function (a) {
      return a ? a : Ma;
    });

    function Na(a) {
      return a ? a : Ma;
    }

    ea("Int8Array.prototype.at", Na);
    ea("Uint8Array.prototype.at", Na);
    ea("Uint8ClampedArray.prototype.at", Na);
    ea("Int16Array.prototype.at", Na);
    ea("Uint16Array.prototype.at", Na);
    ea("Int32Array.prototype.at", Na);
    ea("Uint32Array.prototype.at", Na);
    ea("Float32Array.prototype.at", Na);
    ea("Float64Array.prototype.at", Na);
    ea("String.prototype.at", function (a) {
      return a ? a : Ma;
    });
    var Oa = this || self;

    function M(a, b) {
      a = a.split(".");
      var c = Oa;
      a[0] in c || "undefined" == typeof c.execScript || c.execScript("var " + a[0]);

      for (var d; a.length && (d = a.shift());) a.length || void 0 === b ? c[d] && c[d] !== Object.prototype[d] ? c = c[d] : c = c[d] = {} : c[d] = b;
    }

    ;
    /*
    @license
    Shaka Player
    Copyright 2016 Google LLC
    SPDX-License-Identifier: Apache-2.0
    */

    function N(a, b) {
      if (b) if (b instanceof Map) for (var c = t(b.keys()), d = c.next(); !d.done; d = c.next()) d = d.value, Object.defineProperty(this, d, {
        value: b.get(d),
        writable: !0,
        enumerable: !0
      });else for (c in b) Object.defineProperty(this, c, {
        value: b[c],
        writable: !0,
        enumerable: !0
      });
      this.defaultPrevented = this.cancelable = this.bubbles = !1;
      this.timeStamp = window.performance && window.performance.now ? window.performance.now() : Date.now();
      this.type = a;
      this.isTrusted = !1;
      this.target = this.currentTarget = null;
      this.g = !1;
    }

    function Pa(a) {
      var b = new N(a.type),
          c;

      for (c in a) Object.defineProperty(b, c, {
        value: a[c],
        writable: !0,
        enumerable: !0
      });

      return b;
    }

    N.prototype.preventDefault = function () {
      this.cancelable && (this.defaultPrevented = !0);
    };

    N.prototype.stopImmediatePropagation = function () {
      this.g = !0;
    };

    N.prototype.stopPropagation = function () {};

    M("shaka.util.FakeEvent", N);
    var Ra = {
      oj: "abrstatuschanged",
      pj: "adaptation",
      qj: "buffering",
      rj: "complete",
      sj: "downloadfailed",
      tj: "downloadheadersreceived",
      uj: "drmsessionupdate",
      wj: "emsg",
      Mj: "prft",
      Error: "error",
      xj: "expirationupdated",
      yj: "firstquartile",
      zj: "gapjumped",
      Cj: "keystatuschanged",
      Ej: "loaded",
      Fj: "loading",
      Hj: "manifestparsed",
      Ij: "manifestupdated",
      Jj: "mediaqualitychanged",
      Metadata: "metadata",
      Kj: "midpoint",
      Lj: "onstatechange",
      Oj: "ratechange",
      Pj: "segmentappended",
      Qj: "sessiondata",
      Rj: "stalldetected",
      Sj: "started",
      Tj: "statechanged",
      Uj: "streaming",
      Vj: "textchanged",
      Wj: "texttrackvisibility",
      Xj: "thirdquartile",
      Yj: "timelineregionadded",
      Zj: "timelineregionenter",
      $j: "timelineregionexit",
      bk: "trackschanged",
      dk: "unloading",
      fk: "variantchanged"
    };

    function Sa() {}

    function Ta() {}

    function Ua() {}

    function Va(a) {
      var b = Ga.apply(1, arguments);
      Wa.has(a) || (Wa.add(a), Ua.apply(Sa, w(b)));
    }

    function Ya() {}

    function Za() {}

    function $a() {}

    function ab() {}

    var Wa = new Set();
    window.console && (Ua = function () {
      return console.warn.apply(console, w(Ga.apply(0, arguments)));
    }, Ta = function () {
      console.error.apply(console, w(Ga.apply(0, arguments)));
    });

    function bb() {
      this.g = {};
    }

    p = bb.prototype;

    p.push = function (a, b) {
      this.g.hasOwnProperty(a) ? this.g[a].push(b) : this.g[a] = [b];
    };

    p.get = function (a) {
      return (a = this.g[a]) ? a.slice() : null;
    };

    p.remove = function (a, b) {
      a in this.g && (this.g[a] = this.g[a].filter(function (c) {
        return c != b;
      }), 0 == this.g[a].length && delete this.g[a]);
    };

    p.forEach = function (a) {
      for (var b in this.g) a(b, this.g[b]);
    };

    p.size = function () {
      return Object.keys(this.g).length;
    };

    p.keys = function () {
      return Object.keys(this.g);
    };

    function db() {
      this.za = new bb();
      this.me = this;
    }

    db.prototype.addEventListener = function (a, b) {
      this.za && this.za.push(a, b);
    };

    db.prototype.removeEventListener = function (a, b) {
      this.za && this.za.remove(a, b);
    };

    db.prototype.dispatchEvent = function (a) {
      if (!this.za) return !0;
      var b = this.za.get(a.type) || [],
          c = this.za.get("All");
      c && (b = b.concat(c));
      b = t(b);

      for (c = b.next(); !c.done; c = b.next()) {
        c = c.value;
        a.target = this.me;
        a.currentTarget = this.me;

        try {
          c.handleEvent ? c.handleEvent(a) : c.call(this, a);
        } catch (d) {}

        if (a.g) break;
      }

      return a.defaultPrevented;
    };

    db.prototype.release = function () {
      this.za = null;
    };

    function eb(a, b) {
      var c = [];
      a = t(a);

      for (var d = a.next(); !d.done; d = a.next()) c.push(b(d.value));

      return c;
    }

    function fb(a, b) {
      a = t(a);

      for (var c = a.next(); !c.done; c = a.next()) if (!b(c.value)) return !1;

      return !0;
    }

    function gb(a, b) {
      a = t(a);

      for (var c = a.next(); !c.done; c = a.next()) if (b(c.value)) return !0;

      return !1;
    }

    function hb(a, b) {
      var c = [];
      a = t(a);

      for (var d = a.next(); !d.done; d = a.next()) d = d.value, b(d) && c.push(d);

      return c;
    }

    ;
    /*
    @license
    Copyright 2008 The Closure Library Authors
    SPDX-License-Identifier: Apache-2.0
    */

    var jb = RegExp("^(?:([^:/?#.]+):)?(?://(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#(.*))?$");
    /*
    @license
    Copyright 2006 The Closure Library Authors
    SPDX-License-Identifier: Apache-2.0
    */

    function kb(a) {
      var b;
      a instanceof kb ? (mb(this, a.qb), this.xc = a.xc, nb(this, a.Eb), ob(this, a.Qc), this.Va = a.Va, pb(this, a.g.clone()), this.jc = a.jc) : a && (b = String(a).match(jb)) ? (mb(this, b[1] || "", !0), this.xc = sb(b[2] || ""), nb(this, b[3] || "", !0), ob(this, b[4]), this.Va = sb(b[5] || "", !0), pb(this, b[6] || "", !0), this.jc = sb(b[7] || "")) : this.g = new tb(null);
    }

    p = kb.prototype;
    p.qb = "";
    p.xc = "";
    p.Eb = "";
    p.Qc = null;
    p.Va = "";
    p.jc = "";

    p.toString = function () {
      var a = [],
          b = this.qb;
      b && a.push(ub(b, vb, !0), ":");

      if (b = this.Eb) {
        a.push("//");
        var c = this.xc;
        c && a.push(ub(c, vb, !0), "@");
        a.push(encodeURIComponent(b).replace(/%25([0-9a-fA-F]{2})/g, "%$1"));
        b = this.Qc;
        null != b && a.push(":", String(b));
      }

      if (b = this.Va) this.Eb && "/" != b.charAt(0) && a.push("/"), a.push(ub(b, "/" == b.charAt(0) ? yb : zb, !0));
      (b = this.g.toString()) && a.push("?", b);
      (b = this.jc) && a.push("#", ub(b, Ab));
      return a.join("");
    };

    p.resolve = function (a) {
      var b = this.clone();
      "data" === b.qb && (b = new kb());
      var c = !!a.qb;
      c ? mb(b, a.qb) : c = !!a.xc;
      c ? b.xc = a.xc : c = !!a.Eb;
      c ? nb(b, a.Eb) : c = null != a.Qc;
      var d = a.Va;
      if (c) ob(b, a.Qc);else if (c = !!a.Va) {
        if ("/" != d.charAt(0)) if (this.Eb && !this.Va) d = "/" + d;else {
          var e = b.Va.lastIndexOf("/");
          -1 != e && (d = b.Va.substr(0, e + 1) + d);
        }
        if (".." == d || "." == d) d = "";else if (-1 != d.indexOf("./") || -1 != d.indexOf("/.")) {
          e = 0 == d.lastIndexOf("/", 0);
          d = d.split("/");

          for (var f = [], g = 0; g < d.length;) {
            var h = d[g++];
            "." == h ? e && g == d.length && f.push("") : ".." == h ? ((1 < f.length || 1 == f.length && "" != f[0]) && f.pop(), e && g == d.length && f.push("")) : (f.push(h), e = !0);
          }

          d = f.join("/");
        }
      }
      c ? b.Va = d : c = "" !== a.g.toString();
      c ? pb(b, a.g.clone()) : c = !!a.jc;
      c && (b.jc = a.jc);
      return b;
    };

    p.clone = function () {
      return new kb(this);
    };

    function mb(a, b, c) {
      a.qb = c ? sb(b, !0) : b;
      a.qb && (a.qb = a.qb.replace(/:$/, ""));
    }

    function nb(a, b, c) {
      a.Eb = c ? sb(b, !0) : b;
    }

    function ob(a, b) {
      if (b) {
        b = Number(b);
        if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);
        a.Qc = b;
      } else a.Qc = null;
    }

    function pb(a, b, c) {
      b instanceof tb ? a.g = b : (c || (b = ub(b, Bb)), a.g = new tb(b));
    }

    function sb(a, b) {
      return a ? b ? decodeURI(a) : decodeURIComponent(a) : "";
    }

    function ub(a, b, c) {
      return null != a ? (a = encodeURI(a).replace(b, Cb), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
    }

    function Cb(a) {
      a = a.charCodeAt(0);
      return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
    }

    var vb = /[#\/\?@]/g,
        zb = /[#\?:]/g,
        yb = /[#\?]/g,
        Bb = /[#\?@]/g,
        Ab = /#/g;

    function tb(a) {
      this.g = a || null;
    }

    function Db(a) {
      if (!a.Ka && (a.Ka = {}, a.od = 0, a.g)) for (var b = a.g.split("&"), c = 0; c < b.length; c++) {
        var d = b[c].indexOf("="),
            e = null;

        if (0 <= d) {
          var f = b[c].substring(0, d);
          e = b[c].substring(d + 1);
        } else f = b[c];

        f = decodeURIComponent(f.replace(/\+/g, " "));
        e = e || "";
        a.add(f, decodeURIComponent(e.replace(/\+/g, " ")));
      }
    }

    p = tb.prototype;
    p.Ka = null;
    p.od = null;

    function Fb(a) {
      Db(a);
      return a.od;
    }

    p.add = function (a, b) {
      Db(this);
      this.g = null;
      var c = this.Ka.hasOwnProperty(a) ? this.Ka[a] : null;
      c || (this.Ka[a] = c = []);
      c.push(b);
      this.od++;
      return this;
    };

    p.set = function (a, b) {
      Db(this);
      this.g = null;
      this.Ka.hasOwnProperty(a) ? this.Ka[a] = [b] : this.add(a, b);
      return this;
    };

    p.get = function (a) {
      Db(this);
      return this.Ka[a] || [];
    };

    p.toString = function () {
      if (this.g) return this.g;
      if (!this.Ka) return "";
      var a = [],
          b;

      for (b in this.Ka) for (var c = encodeURIComponent(b), d = this.Ka[b], e = 0; e < d.length; e++) {
        var f = c;
        "" !== d[e] && (f += "=" + encodeURIComponent(d[e]));
        a.push(f);
      }

      return this.g = a.join("&");
    };

    p.clone = function () {
      var a = new tb();
      a.g = this.g;

      if (this.Ka) {
        var b = {},
            c;

        for (c in this.Ka) b[c] = this.Ka[c].concat();

        a.Ka = b;
        a.od = this.od;
      }

      return a;
    };

    function P(a, b, c) {
      var d = Ga.apply(3, arguments);
      this.severity = a;
      this.category = b;
      this.code = c;
      this.data = d;
      this.handled = !1;
      this.message = "Shaka Error " + this.code;
      if (Gb) try {
        throw Error(this.message || "Shaka Error");
      } catch (e) {
        this.stack = e.stack;
      }
    }

    P.prototype.toString = function () {
      return "shaka.util.Error " + JSON.stringify(this, null, "  ");
    };

    M("shaka.util.Error", P);
    var Gb = !0;
    P.Severity = {
      RECOVERABLE: 1,
      CRITICAL: 2
    };
    P.Category = {
      NETWORK: 1,
      TEXT: 2,
      MEDIA: 3,
      MANIFEST: 4,
      STREAMING: 5,
      DRM: 6,
      PLAYER: 7,
      CAST: 8,
      STORAGE: 9,
      ADS: 10
    };
    P.Code = {
      UNSUPPORTED_SCHEME: 1E3,
      BAD_HTTP_STATUS: 1001,
      HTTP_ERROR: 1002,
      TIMEOUT: 1003,
      MALFORMED_DATA_URI: 1004,
      REQUEST_FILTER_ERROR: 1006,
      RESPONSE_FILTER_ERROR: 1007,
      MALFORMED_TEST_URI: 1008,
      UNEXPECTED_TEST_REQUEST: 1009,
      ATTEMPTS_EXHAUSTED: 1010,
      SEGMENT_MISSING: 1011,
      INVALID_TEXT_HEADER: 2E3,
      INVALID_TEXT_CUE: 2001,
      UNABLE_TO_DETECT_ENCODING: 2003,
      BAD_ENCODING: 2004,
      INVALID_XML: 2005,
      INVALID_MP4_TTML: 2007,
      INVALID_MP4_VTT: 2008,
      UNABLE_TO_EXTRACT_CUE_START_TIME: 2009,
      INVALID_MP4_CEA: 2010,
      TEXT_COULD_NOT_GUESS_MIME_TYPE: 2011,
      CANNOT_ADD_EXTERNAL_TEXT_TO_SRC_EQUALS: 2012,
      TEXT_ONLY_WEBVTT_SRC_EQUALS: 2013,
      MISSING_TEXT_PLUGIN: 2014,
      CHAPTERS_TRACK_FAILED: 2015,
      UNSUPPORTED_EXTERNAL_THUMBNAILS_URI: 2017,
      BUFFER_READ_OUT_OF_BOUNDS: 3E3,
      JS_INTEGER_OVERFLOW: 3001,
      EBML_OVERFLOW: 3002,
      EBML_BAD_FLOATING_POINT_SIZE: 3003,
      MP4_SIDX_WRONG_BOX_TYPE: 3004,
      MP4_SIDX_INVALID_TIMESCALE: 3005,
      MP4_SIDX_TYPE_NOT_SUPPORTED: 3006,
      WEBM_CUES_ELEMENT_MISSING: 3007,
      WEBM_EBML_HEADER_ELEMENT_MISSING: 3008,
      WEBM_SEGMENT_ELEMENT_MISSING: 3009,
      WEBM_INFO_ELEMENT_MISSING: 3010,
      WEBM_DURATION_ELEMENT_MISSING: 3011,
      WEBM_CUE_TRACK_POSITIONS_ELEMENT_MISSING: 3012,
      WEBM_CUE_TIME_ELEMENT_MISSING: 3013,
      MEDIA_SOURCE_OPERATION_FAILED: 3014,
      MEDIA_SOURCE_OPERATION_THREW: 3015,
      VIDEO_ERROR: 3016,
      QUOTA_EXCEEDED_ERROR: 3017,
      TRANSMUXING_FAILED: 3018,
      CONTENT_TRANSFORMATION_FAILED: 3019,
      MSS_MISSING_DATA_FOR_TRANSMUXING: 3020,
      MSS_TRANSMUXING_CODEC_UNKNOWN: 3021,
      MSS_TRANSMUXING_FAILED: 3022,
      TRANSMUXING_NO_VIDEO_DATA: 3023,
      UNABLE_TO_GUESS_MANIFEST_TYPE: 4E3,
      DASH_INVALID_XML: 4001,
      DASH_NO_SEGMENT_INFO: 4002,
      DASH_EMPTY_ADAPTATION_SET: 4003,
      DASH_EMPTY_PERIOD: 4004,
      DASH_WEBM_MISSING_INIT: 4005,
      DASH_UNSUPPORTED_CONTAINER: 4006,
      DASH_PSSH_BAD_ENCODING: 4007,
      DASH_NO_COMMON_KEY_SYSTEM: 4008,
      DASH_MULTIPLE_KEY_IDS_NOT_SUPPORTED: 4009,
      DASH_CONFLICTING_KEY_IDS: 4010,
      RESTRICTIONS_CANNOT_BE_MET: 4012,
      HLS_PLAYLIST_HEADER_MISSING: 4015,
      INVALID_HLS_TAG: 4016,
      HLS_INVALID_PLAYLIST_HIERARCHY: 4017,
      DASH_DUPLICATE_REPRESENTATION_ID: 4018,
      HLS_MULTIPLE_MEDIA_INIT_SECTIONS_FOUND: 4020,
      HLS_REQUIRED_ATTRIBUTE_MISSING: 4023,
      HLS_REQUIRED_TAG_MISSING: 4024,
      HLS_COULD_NOT_GUESS_CODECS: 4025,
      HLS_KEYFORMATS_NOT_SUPPORTED: 4026,
      DASH_UNSUPPORTED_XLINK_ACTUATE: 4027,
      DASH_XLINK_DEPTH_LIMIT: 4028,
      CONTENT_UNSUPPORTED_BY_BROWSER: 4032,
      CANNOT_ADD_EXTERNAL_TEXT_TO_LIVE_STREAM: 4033,
      NO_VARIANTS: 4036,
      PERIOD_FLATTENING_FAILED: 4037,
      INCONSISTENT_DRM_ACROSS_PERIODS: 4038,
      HLS_VARIABLE_NOT_FOUND: 4039,
      HLS_MSE_ENCRYPTED_MP2T_NOT_SUPPORTED: 4040,
      HLS_MSE_ENCRYPTED_LEGACY_APPLE_MEDIA_KEYS_NOT_SUPPORTED: 4041,
      NO_WEB_CRYPTO_API: 4042,
      CANNOT_ADD_EXTERNAL_THUMBNAILS_TO_LIVE_STREAM: 4045,
      MSS_INVALID_XML: 4046,
      MSS_LIVE_CONTENT_NOT_SUPPORTED: 4047,
      AES_128_INVALID_IV_LENGTH: 4048,
      AES_128_INVALID_KEY_LENGTH: 4049,
      DASH_CONFLICTING_AES_128: 4050,
      DASH_UNSUPPORTED_AES_128: 4051,
      STREAMING_ENGINE_STARTUP_INVALID_STATE: 5006,
      NO_RECOGNIZED_KEY_SYSTEMS: 6E3,
      REQUESTED_KEY_SYSTEM_CONFIG_UNAVAILABLE: 6001,
      FAILED_TO_CREATE_CDM: 6002,
      FAILED_TO_ATTACH_TO_VIDEO: 6003,
      INVALID_SERVER_CERTIFICATE: 6004,
      FAILED_TO_CREATE_SESSION: 6005,
      FAILED_TO_GENERATE_LICENSE_REQUEST: 6006,
      LICENSE_REQUEST_FAILED: 6007,
      LICENSE_RESPONSE_REJECTED: 6008,
      ENCRYPTED_CONTENT_WITHOUT_DRM_INFO: 6010,
      NO_LICENSE_SERVER_GIVEN: 6012,
      OFFLINE_SESSION_REMOVED: 6013,
      EXPIRED: 6014,
      SERVER_CERTIFICATE_REQUIRED: 6015,
      INIT_DATA_TRANSFORM_ERROR: 6016,
      SERVER_CERTIFICATE_REQUEST_FAILED: 6017,
      MIN_HDCP_VERSION_NOT_MATCH: 6018,
      ERROR_CHECKING_HDCP_VERSION: 6019,
      LOAD_INTERRUPTED: 7E3,
      OPERATION_ABORTED: 7001,
      NO_VIDEO_ELEMENT: 7002,
      OBJECT_DESTROYED: 7003,
      CONTENT_NOT_LOADED: 7004,
      CAST_API_UNAVAILABLE: 8E3,
      NO_CAST_RECEIVERS: 8001,
      ALREADY_CASTING: 8002,
      UNEXPECTED_CAST_ERROR: 8003,
      CAST_CANCELED_BY_USER: 8004,
      CAST_CONNECTION_TIMED_OUT: 8005,
      CAST_RECEIVER_APP_UNAVAILABLE: 8006,
      STORAGE_NOT_SUPPORTED: 9E3,
      INDEXED_DB_ERROR: 9001,
      DEPRECATED_OPERATION_ABORTED: 9002,
      REQUESTED_ITEM_NOT_FOUND: 9003,
      MALFORMED_OFFLINE_URI: 9004,
      CANNOT_STORE_LIVE_OFFLINE: 9005,
      NO_INIT_DATA_FOR_OFFLINE: 9007,
      LOCAL_PLAYER_INSTANCE_REQUIRED: 9008,
      NEW_KEY_OPERATION_NOT_SUPPORTED: 9011,
      KEY_NOT_FOUND: 9012,
      MISSING_STORAGE_CELL: 9013,
      STORAGE_LIMIT_REACHED: 9014,
      DOWNLOAD_SIZE_CALLBACK_ERROR: 9015,
      MODIFY_OPERATION_NOT_SUPPORTED: 9016,
      INDEXED_DB_INIT_TIMED_OUT: 9017,
      CS_IMA_SDK_MISSING: 1E4,
      CS_AD_MANAGER_NOT_INITIALIZED: 10001,
      SS_IMA_SDK_MISSING: 10002,
      SS_AD_MANAGER_NOT_INITIALIZED: 10003,
      CURRENT_DAI_REQUEST_NOT_FINISHED: 10004,
      MT_AD_MANAGER_NOT_INITIALIZED: 10005
    };

    function Hb(a, b) {
      if (0 == b.length) return a;

      if (1 == a.length && 1 == b.length) {
        var c = new kb(a[0]);
        b = new kb(b[0]);
        return [c.resolve(b).toString()];
      }

      b = b.map(function (g) {
        return new kb(g);
      });
      c = [];
      a = t(a);

      for (var d = a.next(); !d.done; d = a.next()) {
        d = new kb(d.value);

        for (var e = t(b), f = e.next(); !f.done; f = e.next()) c.push(d.resolve(f.value).toString());
      }

      return c;
    }

    function Ib(a, b) {
      return {
        keySystem: a,
        licenseServerUri: "",
        distinctiveIdentifierRequired: !1,
        persistentStateRequired: !1,
        audioRobustness: "",
        videoRobustness: "",
        serverCertificate: null,
        serverCertificateUri: "",
        sessionType: "",
        initData: b || [],
        keyIds: new Set()
      };
    }

    function Jb(a, b) {
      if (1 == b.length) return b[0];
      a = Kb(a, b);
      if (null != a) return a;
      throw new P(2, 4, 4025, b);
    }

    function Kb(a, b) {
      for (var c = t(Lb[a]), d = c.next(); !d.done; d = c.next()) {
        d = d.value;

        for (var e = t(b), f = e.next(); !f.done; f = e.next()) if (f = f.value, d.test(f.trim())) return f.trim();
      }

      return a == Mb ? "" : null;
    }

    var Mb = "text",
        Nb = {
      ia: "video",
      T: "audio",
      sa: Mb,
      kd: "image",
      mj: "application"
    },
        Lb = {
      audio: [/^vorbis$/, /^Opus$/, /^opus$/, /^fLaC$/, /^flac$/, /^mp4a/, /^[ae]c-3$/, /^ac-4$/, /^dts[cex]$/],
      video: [/^avc/, /^hev/, /^hvc/, /^vp0?[89]/, /^av01/, /^dvh/],
      text: [/^vtt$/, /^wvtt/, /^stpp/]
    };

    function Ob() {}

    function Pb(a, b) {
      a = Qb(a);
      b = Qb(b);
      return a.split("-")[0] == b.split("-")[0];
    }

    function Rb(a, b) {
      a = Qb(a);
      b = Qb(b);
      a = a.split("-");
      b = b.split("-");
      return a[0] == b[0] && 1 == a.length && 2 == b.length;
    }

    function Sb(a, b) {
      a = Qb(a);
      b = Qb(b);
      a = a.split("-");
      b = b.split("-");
      return 2 == a.length && 2 == b.length && a[0] == b[0];
    }

    function Qb(a) {
      var b = a.split("-x-"),
          c = b[0].split("-");
      a = c[0] || "";
      c = c[1] || "";
      b = b[1] ? "x-" + b[1] : "";
      a = a.toLowerCase();
      a = Tb.get(a) || a;
      c = c.toUpperCase();
      return (c ? a + "-" + c : a) + (b ? "-" + b : "");
    }

    function Ub(a, b) {
      var c = Vb(a),
          d = Vb(b);
      return a != c && b != d && c == d;
    }

    function Wb(a, b) {
      a = Qb(a);
      b = Qb(b);
      return b == a ? 4 : Rb(b, a) ? 3 : Sb(b, a) ? 2 : Rb(a, b) ? 1 : 0;
    }

    function Vb(a) {
      var b = a.indexOf("-");
      a = 0 <= b ? a.substring(0, b) : a;
      a = a.toLowerCase();
      return a = Tb.get(a) || a;
    }

    function Xb(a) {
      return a.language ? Qb(a.language) : a.audio && a.audio.language ? Qb(a.audio.language) : a.video && a.video.language ? Qb(a.video.language) : "und";
    }

    function Yb(a, b) {
      a = Qb(a);
      var c = new Set(),
          d = t(b);

      for (b = d.next(); !b.done; b = d.next()) c.add(Qb(b.value));

      d = t(c);

      for (b = d.next(); !b.done; b = d.next()) if (b = b.value, b == a) return b;

      d = t(c);

      for (b = d.next(); !b.done; b = d.next()) if (b = b.value, Rb(b, a)) return b;

      d = t(c);

      for (b = d.next(); !b.done; b = d.next()) if (b = b.value, Sb(b, a)) return b;

      c = t(c);

      for (b = c.next(); !b.done; b = c.next()) if (b = b.value, Rb(a, b)) return b;

      return null;
    }

    M("shaka.util.LanguageUtils", Ob);
    Ob.findClosestLocale = Yb;
    Ob.getLocaleForVariant = Xb;

    Ob.getLocaleForText = function (a) {
      return Qb(a.language || "und");
    };

    Ob.getBase = Vb;
    Ob.relatedness = Wb;
    Ob.areSiblings = Ub;
    Ob.normalize = Qb;
    Ob.isSiblingOf = Sb;
    Ob.isParentOf = Rb;
    Ob.areLanguageCompatible = Pb;

    Ob.areLocaleCompatible = function (a, b) {
      a = Qb(a);
      b = Qb(b);
      return a == b;
    };

    var Tb = new Map([["aar", "aa"], ["abk", "ab"], ["afr", "af"], ["aka", "ak"], ["alb", "sq"], ["amh", "am"], ["ara", "ar"], ["arg", "an"], ["arm", "hy"], ["asm", "as"], ["ava", "av"], ["ave", "ae"], ["aym", "ay"], ["aze", "az"], ["bak", "ba"], ["bam", "bm"], ["baq", "eu"], ["bel", "be"], ["ben", "bn"], ["bih", "bh"], ["bis", "bi"], ["bod", "bo"], ["bos", "bs"], ["bre", "br"], ["bul", "bg"], ["bur", "my"], ["cat", "ca"], ["ces", "cs"], ["cha", "ch"], ["che", "ce"], ["chi", "zh"], ["chu", "cu"], ["chv", "cv"], ["cor", "kw"], ["cos", "co"], ["cre", "cr"], ["cym", "cy"], ["cze", "cs"], ["dan", "da"], ["deu", "de"], ["div", "dv"], ["dut", "nl"], ["dzo", "dz"], ["ell", "el"], ["eng", "en"], ["epo", "eo"], ["est", "et"], ["eus", "eu"], ["ewe", "ee"], ["fao", "fo"], ["fas", "fa"], ["fij", "fj"], ["fin", "fi"], ["fra", "fr"], ["fre", "fr"], ["fry", "fy"], ["ful", "ff"], ["geo", "ka"], ["ger", "de"], ["gla", "gd"], ["gle", "ga"], ["glg", "gl"], ["glv", "gv"], ["gre", "el"], ["grn", "gn"], ["guj", "gu"], ["hat", "ht"], ["hau", "ha"], ["heb", "he"], ["her", "hz"], ["hin", "hi"], ["hmo", "ho"], ["hrv", "hr"], ["hun", "hu"], ["hye", "hy"], ["ibo", "ig"], ["ice", "is"], ["ido", "io"], ["iii", "ii"], ["iku", "iu"], ["ile", "ie"], ["ina", "ia"], ["ind", "id"], ["ipk", "ik"], ["isl", "is"], ["ita", "it"], ["jav", "jv"], ["jpn", "ja"], ["kal", "kl"], ["kan", "kn"], ["kas", "ks"], ["kat", "ka"], ["kau", "kr"], ["kaz", "kk"], ["khm", "km"], ["kik", "ki"], ["kin", "rw"], ["kir", "ky"], ["kom", "kv"], ["kon", "kg"], ["kor", "ko"], ["kua", "kj"], ["kur", "ku"], ["lao", "lo"], ["lat", "la"], ["lav", "lv"], ["lim", "li"], ["lin", "ln"], ["lit", "lt"], ["ltz", "lb"], ["lub", "lu"], ["lug", "lg"], ["mac", "mk"], ["mah", "mh"], ["mal", "ml"], ["mao", "mi"], ["mar", "mr"], ["may", "ms"], ["mkd", "mk"], ["mlg", "mg"], ["mlt", "mt"], ["mon", "mn"], ["mri", "mi"], ["msa", "ms"], ["mya", "my"], ["nau", "na"], ["nav", "nv"], ["nbl", "nr"], ["nde", "nd"], ["ndo", "ng"], ["nep", "ne"], ["nld", "nl"], ["nno", "nn"], ["nob", "nb"], ["nor", "no"], ["nya", "ny"], ["oci", "oc"], ["oji", "oj"], ["ori", "or"], ["orm", "om"], ["oss", "os"], ["pan", "pa"], ["per", "fa"], ["pli", "pi"], ["pol", "pl"], ["por", "pt"], ["pus", "ps"], ["que", "qu"], ["roh", "rm"], ["ron", "ro"], ["rum", "ro"], ["run", "rn"], ["rus", "ru"], ["sag", "sg"], ["san", "sa"], ["sin", "si"], ["slk", "sk"], ["slo", "sk"], ["slv", "sl"], ["sme", "se"], ["smo", "sm"], ["sna", "sn"], ["snd", "sd"], ["som", "so"], ["sot", "st"], ["spa", "es"], ["sqi", "sq"], ["srd", "sc"], ["srp", "sr"], ["ssw", "ss"], ["sun", "su"], ["swa", "sw"], ["swe", "sv"], ["tah", "ty"], ["tam", "ta"], ["tat", "tt"], ["tel", "te"], ["tgk", "tg"], ["tgl", "tl"], ["tha", "th"], ["tib", "bo"], ["tir", "ti"], ["ton", "to"], ["tsn", "tn"], ["tso", "ts"], ["tuk", "tk"], ["tur", "tr"], ["twi", "tw"], ["uig", "ug"], ["ukr", "uk"], ["urd", "ur"], ["uzb", "uz"], ["ven", "ve"], ["vie", "vi"], ["vol", "vo"], ["wel", "cy"], ["wln", "wa"], ["wol", "wo"], ["xho", "xh"], ["yid", "yi"], ["yor", "yo"], ["zha", "za"], ["zho", "zh"], ["zul", "zu"]]);

    function Zb(a) {
      db.call(this);
      this.j = Qb(a);
      this.i = new Map();
      this.g = new Set();
      this.h = new Map();
    }

    pa(Zb, db);
    p = Zb.prototype;

    p.release = function () {
      db.prototype.release.call(this);
    };

    p.Bg = function (a) {
      var b = this;
      this.g.clear();
      a = t(a);

      for (var c = a.next(); !c.done; c = a.next()) this.g.add(Qb(c.value));

      $b(this);
      a = hb(this.g, function (d) {
        return !b.h.has(d);
      });
      a.length && this.dispatchEvent(new N("unknown-locales", new Map().set("locales", a)));
      a = hb(this.g, function (d) {
        return b.h.has(d);
      });
      a = new Map().set("locales", a.length ? a : [this.j]);
      this.dispatchEvent(new N("locale-changed", a));
    };

    p.xa = function (a, b, c) {
      a = Qb(a);
      void 0 === c && (c = ac);
      var d = this.h.get(a) || new Map();
      b.forEach(function (e, f) {
        d.has(f) && c != ac || d.set(f, e);
      });
      this.h.set(a, d);
      $b(this);
      this.dispatchEvent(new N("locale-updated"));
      return this;
    };

    p.Zi = function (a) {
      for (var b = t(a.keys()), c = b.next(); !c.done; c = b.next()) c = c.value, a.set(c, this.resolve(c));
    };

    p.resolve = function (a) {
      var b = this.i.get(a);
      if (b) return b;
      a = new Map().set("locales", Array.from(this.g)).set("missing", a);
      this.dispatchEvent(new N("unknown-localization", a));
      return "";
    };

    p.Th = function () {
      return this.g;
    };

    function $b(a) {
      for (var b = a.h, c = a.j, d = a.g, e = new Set(), f = {}, g = t(d), h = g.next(); !h.done; f = {
        Bc: f.Bc
      }, h = g.next()) {
        f.Bc = h.value;
        e.add(f.Bc);
        e.add(Vb(f.Bc));
        h = hb(b.keys(), function (l) {
          return function (m) {
            return Ub(m, l.Bc);
          };
        }(f));
        h.sort();
        var k = t(h);

        for (h = k.next(); !h.done; h = k.next()) e.add(h.value);

        h = hb(b.keys(), function (l) {
          return function (m) {
            return Vb(m) == l.Bc;
          };
        }(f));
        h.sort();
        k = t(h);

        for (h = k.next(); !h.done; h = k.next()) e.add(h.value);
      }

      e.add(c);
      c = [];
      e = t(e);

      for (h = e.next(); !h.done; h = e.next()) (h = b.get(h.value)) && c.push(h);

      c.reverse();
      a.i.clear();
      b = t(c);

      for (h = b.next(); !h.done; h = b.next()) h.value.forEach(function (l, m) {
        a.i.set(m, l);
      });

      b = a.i.keys();
      e = new Set();
      c = t(a.g);

      for (h = c.next(); !h.done; h = c.next()) h = a.h.get(h.value) || new Map(), bc(h, b, e);

      0 < e.size && (d = new Map().set("locales", Array.from(d)).set("missing", Array.from(e)), a.dispatchEvent(new N("missing-localizations", d)));
    }

    function bc(a, b, c) {
      b = t(b);

      for (var d = b.next(); !d.done; d = b.next()) d = d.value, a.get(d) || c.add(d);
    }

    M("shaka.ui.Localization", Zb);
    Zb.prototype.getCurrentLocales = Zb.prototype.Th;
    Zb.prototype.resolve = Zb.prototype.resolve;
    Zb.prototype.resolveDictionary = Zb.prototype.Zi;
    Zb.prototype.insert = Zb.prototype.xa;
    Zb.prototype.changeLocale = Zb.prototype.Bg;
    Zb.prototype.release = Zb.prototype.release;
    var ac = 1;
    Zb.ConflictResolution = {
      USE_OLD: 0,
      USE_NEW: ac
    };
    Zb.UNKNOWN_LOCALES = "unknown-locales";
    Zb.UNKNOWN_LOCALIZATION = "unknown-localization";
    Zb.MISSING_LOCALIZATIONS = "missing-localizations";
    Zb.LOCALE_CHANGED = "locale-changed";
    Zb.LOCALE_UPDATED = "locale-updated";

    function cc(a) {
      this.g = Math.exp(Math.log(.5) / a);
      this.i = this.h = 0;
    }

    cc.prototype.sample = function (a, b) {
      var c = Math.pow(this.g, a);
      b = b * (1 - c) + c * this.h;
      isNaN(b) || (this.h = b, this.i += a);
    };

    function dc(a) {
      return a.h / (1 - Math.pow(a.g, a.i));
    }

    ;

    function ec() {
      this.h = new cc(2);
      this.j = new cc(5);
      this.g = 0;
      this.i = 128E3;
      this.l = 16E3;
    }

    ec.prototype.configure = function (a) {
      this.i = a.minTotalBytes;
      this.l = a.minBytes;
      this.h.g = Math.exp(Math.log(.5) / a.fastHalfLife);
      this.j.g = Math.exp(Math.log(.5) / a.slowHalfLife);
    };

    ec.prototype.sample = function (a, b) {
      if (!(b < this.l)) {
        var c = 8E3 * b / a;
        a /= 1E3;
        this.g += b;
        this.h.sample(a, c);
        this.j.sample(a, c);
      }
    };

    ec.prototype.getBandwidthEstimate = function (a) {
      return this.g < this.i ? a : Math.min(dc(this.h), dc(this.j));
    };

    function fc(a) {
      if (gc.has(a)) return gc.get(a);

      if (window.ManagedMediaSource) {
        var b = ManagedMediaSource.isTypeSupported(a);
        gc.set(a, b);
        return b;
      }

      return window.MediaSource ? (b = MediaSource.isTypeSupported(a), gc.set(a, b), b) : !1;
    }

    function hc() {
      return !!window.SourceBuffer && !!SourceBuffer.prototype && !!SourceBuffer.prototype.changeType;
    }

    var gc = new Map();

    function ic() {}

    ic.prototype.extract = function () {};

    ic.prototype.decode = function () {
      return [];
    };

    ic.prototype.clear = function () {};

    ic.prototype.getStreams = function () {
      return [];
    };

    function jc() {}

    jc.prototype.init = function () {};

    jc.prototype.parse = function () {
      return [];
    };

    function kc() {}

    function lc(a, b) {
      if (!a && !b) return !0;
      if (!a || !b || a.byteLength != b.byteLength) return !1;
      if (mc(a) == mc(b) && (a.byteOffset || 0) == (b.byteOffset || 0)) return !0;
      var c = nc(a);
      b = nc(b);

      for (var d = 0; d < a.byteLength; d++) if (c[d] != b[d]) return !1;

      return !0;
    }

    function mc(a) {
      return a instanceof ArrayBuffer ? a : a.buffer;
    }

    function oc(a) {
      return a instanceof ArrayBuffer ? a : 0 == a.byteOffset && a.byteLength == a.buffer.byteLength ? a.buffer : new Uint8Array(a).buffer;
    }

    function nc(a, b, c) {
      c = void 0 === c ? Infinity : c;
      return pc(a, void 0 === b ? 0 : b, c, Uint8Array);
    }

    function qc(a, b, c) {
      c = void 0 === c ? Infinity : c;
      return pc(a, void 0 === b ? 0 : b, c, Uint16Array);
    }

    function rc(a, b, c) {
      c = void 0 === c ? Infinity : c;
      return pc(a, void 0 === b ? 0 : b, c, DataView);
    }

    function pc(a, b, c, d) {
      var e = mc(a),
          f = 1;
      "BYTES_PER_ELEMENT" in d && (f = d.BYTES_PER_ELEMENT);
      var g = ((a.byteOffset || 0) + a.byteLength) / f;
      a = Math.floor(Math.max(0, Math.min(((a.byteOffset || 0) + b) / f, g)));
      return new d(e, a, Math.floor(Math.min(a + Math.max(c, 0), g)) - a);
    }

    M("shaka.util.BufferUtils", kc);
    kc.toDataView = rc;
    kc.toUint16 = qc;
    kc.toUint8 = nc;
    kc.toArrayBuffer = oc;
    kc.equal = lc;

    function sc() {}

    sc.prototype.init = function () {};

    sc.prototype.i = function () {};

    sc.prototype.h = function () {};

    sc.prototype.j = function () {};

    M("shaka.media.IClosedCaptionParser", sc);

    function tc(a) {
      this.l = new jc();
      if (a = uc[a.toLowerCase()]) this.l = a();
      this.g = new ic();
      if (a = vc) this.g = a();
    }

    tc.prototype.init = function (a) {
      this.l.init(a);
    };

    tc.prototype.i = function (a) {
      a = this.l.parse(a);
      a = t(a);

      for (var b = a.next(); !b.done; b = a.next()) {
        b = b.value;
        var c = nc(b.packet);
        0 < c.length && this.g.extract(c, b.pts);
      }

      return this.g.decode();
    };

    tc.prototype.h = function () {
      this.g.clear();
    };

    tc.prototype.j = function () {
      return this.g.getStreams();
    };

    M("shaka.media.ClosedCaptionParser", tc);

    tc.findDecoder = function () {
      return vc;
    };

    tc.unregisterDecoder = function () {
      vc = null;
    };

    tc.registerDecoder = function (a) {
      vc = a;
    };

    tc.findParser = function (a) {
      return uc[a];
    };

    tc.unregisterParser = function (a) {
      delete uc[a];
    };

    tc.registerParser = function (a, b) {
      uc[a] = b;
    };

    var uc = {},
        vc = null;

    function wc(a, b) {
      return "number" === typeof a && "number" === typeof b && isNaN(a) && isNaN(b) ? !0 : a === b;
    }

    function xc(a, b) {
      b = a.indexOf(b);
      -1 < b && a.splice(b, 1);
    }

    function yc(a, b, c) {
      c || (c = wc);
      if (a.length != b.length) return !1;
      b = b.slice();
      var d = {};
      a = t(a);

      for (var e = a.next(); !e.done; d = {
        Me: d.Me
      }, e = a.next()) {
        d.Me = e.value;
        e = b.findIndex(function (f) {
          return function (g) {
            return c(f.Me, g);
          };
        }(d));
        if (-1 == e) return !1;
        b[e] = b[b.length - 1];
        b.pop();
      }

      return 0 == b.length;
    }

    function zc(a, b, c) {
      c || (c = wc);
      if (a.length != b.length) return !1;

      for (var d = 0; d < a.length; d++) if (!c(a[d], b[d])) return !1;

      return !0;
    }

    ;

    function Ac(a, b, c) {
      this.startTime = a;
      this.endTime = b;
      this.payload = c;
      this.region = new Bc();
      this.position = null;
      this.positionAlign = Cc;
      this.size = 0;
      this.textAlign = Ec;
      this.direction = Fc;
      this.writingMode = Gc;
      this.lineInterpretation = Hc;
      this.line = null;
      this.lineHeight = "";
      this.lineAlign = Ic;
      this.displayAlign = Jc;
      this.fontSize = this.border = this.backgroundImage = this.backgroundColor = this.color = "";
      this.fontWeight = Kc;
      this.fontStyle = Mc;
      this.linePadding = this.letterSpacing = this.fontFamily = "";
      this.opacity = 1;
      this.textCombineUpright = "";
      this.textDecoration = [];
      this.textStrokeWidth = this.textStrokeColor = this.textShadow = "";
      this.wrapLine = !0;
      this.id = "";
      this.nestedCues = [];
      this.lineBreak = this.isContainer = !1;
      this.rubyTag = null;
      this.cellResolution = {
        hc: 32,
        rows: 15
      };
    }

    function Nc(a, b) {
      a = new Ac(a, b, "");
      a.lineBreak = !0;
      return a;
    }

    Ac.prototype.clone = function () {
      var a = new Ac(0, 0, ""),
          b;

      for (b in this) a[b] = this[b], a[b] && a[b].constructor == Array && (a[b] = a[b].slice());

      return a;
    };

    function Oc(a, b) {
      if (a.startTime != b.startTime || a.endTime != b.endTime || a.payload != b.payload) return !1;

      for (var c in a) if ("startTime" != c && "endTime" != c && "payload" != c) if ("nestedCues" == c) {
        if (!zc(a.nestedCues, b.nestedCues, Oc)) return !1;
      } else if ("region" == c || "cellResolution" == c) for (var d in a[c]) {
        if (a[c][d] != b[c][d]) return !1;
      } else if (Array.isArray(a[c])) {
        if (!zc(a[c], b[c])) return !1;
      } else if (a[c] != b[c]) return !1;

      return !0;
    }

    M("shaka.text.Cue", Ac);
    Ac.equal = Oc;
    Ac.prototype.clone = Ac.prototype.clone;
    var Cc = "auto";
    Ac.positionAlign = {
      LEFT: "line-left",
      RIGHT: "line-right",
      CENTER: "center",
      AUTO: Cc
    };
    var Ec = "center",
        Pc = {
      LEFT: "left",
      RIGHT: "right",
      CENTER: Ec,
      START: "start",
      END: "end"
    };
    Ac.textAlign = Pc;
    var Jc = "after",
        Qc = {
      BEFORE: "before",
      CENTER: "center",
      AFTER: Jc
    };
    Ac.displayAlign = Qc;
    var Fc = "ltr";
    Ac.direction = {
      HORIZONTAL_LEFT_TO_RIGHT: Fc,
      HORIZONTAL_RIGHT_TO_LEFT: "rtl"
    };
    var Gc = "horizontal-tb";
    Ac.writingMode = {
      HORIZONTAL_TOP_TO_BOTTOM: Gc,
      VERTICAL_LEFT_TO_RIGHT: "vertical-lr",
      VERTICAL_RIGHT_TO_LEFT: "vertical-rl"
    };
    var Hc = 0;
    Ac.lineInterpretation = {
      LINE_NUMBER: Hc,
      PERCENTAGE: 1
    };
    var Ic = "start",
        Rc = {
      CENTER: "center",
      START: Ic,
      END: "end"
    };
    Ac.lineAlign = Rc;
    var Sc = {
      white: "white",
      lime: "lime",
      cyan: "cyan",
      red: "red",
      yellow: "yellow",
      magenta: "magenta",
      blue: "blue",
      black: "black"
    };
    Ac.defaultTextColor = Sc;
    var Tc = {
      bg_white: "white",
      bg_lime: "lime",
      bg_cyan: "cyan",
      bg_red: "red",
      bg_yellow: "yellow",
      bg_magenta: "magenta",
      bg_blue: "blue",
      bg_black: "black"
    };
    Ac.defaultTextBackgroundColor = Tc;
    var Kc = 400;
    Ac.fontWeight = {
      NORMAL: Kc,
      BOLD: 700
    };
    var Mc = "normal",
        Uc = {
      NORMAL: Mc,
      ITALIC: "italic",
      OBLIQUE: "oblique"
    };
    Ac.fontStyle = Uc;
    Ac.textDecoration = {
      UNDERLINE: "underline",
      LINE_THROUGH: "lineThrough",
      OVERLINE: "overline"
    };

    function Bc() {
      this.id = "";
      this.regionAnchorY = this.regionAnchorX = this.viewportAnchorY = this.viewportAnchorX = 0;
      this.height = this.width = 100;
      this.viewportAnchorUnits = this.widthUnits = this.heightUnits = Vc;
      this.scroll = Wc;
    }

    M("shaka.text.CueRegion", Bc);
    var Vc = 1;
    Bc.units = {
      PX: 0,
      PERCENTAGE: Vc,
      LINES: 2
    };
    var Wc = "";
    Bc.scrollMode = {
      NONE: Wc,
      UP: "up"
    };

    function Xc() {}

    Xc.prototype.destroy = function () {};

    function Yc(a, b, c) {
      Zc[a.toLowerCase().split(";")[0] + "-" + c] = {
        priority: c,
        Ae: b
      };
    }

    function $c(a, b) {
      for (var c = a.toLowerCase().split(";")[0], d = t([ad, bd, cd, dd]), e = d.next(); !e.done; e = d.next()) if (e = Zc[c + "-" + e.value]) {
        var f = e.Ae(),
            g = f.isSupported(a, b);
        f.destroy();
        if (g) return e.Ae;
      }

      return null;
    }

    M("shaka.transmuxer.TransmuxerEngine", Xc);
    Xc.findTransmuxer = $c;

    Xc.unregisterTransmuxer = function (a, b) {
      delete Zc[a.toLowerCase().split(";")[0] + "-" + b];
    };

    Xc.registerTransmuxer = Yc;
    Xc.prototype.destroy = Xc.prototype.destroy;
    var Zc = {},
        dd = 1,
        cd = 2,
        bd = 3,
        ad = 4;
    Xc.PluginPriority = {
      FALLBACK: dd,
      PREFERRED_SECONDARY: cd,
      PREFERRED: bd,
      APPLICATION: ad
    };

    function ed() {}

    function fd(a, b) {
      var c = a;
      b && !gd.includes(a) && (c += '; codecs="' + b + '"');
      return c;
    }

    function hd(a, b) {
      b && (a += '; codecs="' + b + '"');
      return a;
    }

    function id(a, b, c) {
      var d = fd(a, b);
      b = hd(a, b);
      $c(b) ? (a = $c(b)) ? (a = a(), c = a.convertCodecs(c, b), a.destroy()) : c = b : c = "video/mp2t" != a && "audio" == c ? d.replace("video", "audio") : d;
      return c;
    }

    function ld(a) {
      var b = md(a);
      a = b[0];
      b = b[1].toLowerCase();

      switch (!0) {
        case "mp4a" === a && "69" === b:
        case "mp4a" === a && "6b" === b:
        case "mp4a" === a && "40.34" === b:
          return "mp3";

        case "mp4a" === a && "66" === b:
        case "mp4a" === a && "67" === b:
        case "mp4a" === a && "68" === b:
        case "mp4a" === a && "40.2" === b:
        case "mp4a" === a && "40.02" === b:
        case "mp4a" === a && "40.5" === b:
        case "mp4a" === a && "40.05" === b:
        case "mp4a" === a && "40.29" === b:
        case "mp4a" === a && "40.42" === b:
          return "aac";

        case "mp4a" === a && "a5" === b:
          return "ac-3";

        case "mp4a" === a && "a6" === b:
          return "ec-3";

        case "mp4a" === a && "b2" === b:
          return "dtsx";

        case "mp4a" === a && "a9" === b:
          return "dtsc";

        case "avc1" === a:
        case "avc3" === a:
          return "avc";

        case "hvc1" === a:
        case "hev1" === a:
          return "hevc";

        case "dvh1" === a:
        case "dvhe" === a:
          return "dovi";
      }

      return a;
    }

    function nd(a) {
      var b = [];
      a = t(a.split(","));

      for (var c = a.next(); !c.done; c = a.next()) c = md(c.value), b.push(c[0]);

      return b.sort().join(",");
    }

    function od(a) {
      return a.split(";")[0];
    }

    function pd(a) {
      a = a.split(/ *; */);
      a.shift();
      return (a = a.find(function (b) {
        return b.startsWith("codecs=");
      })) ? a.split("=")[1].replace(/^"|"$/g, "") : "";
    }

    function md(a) {
      a = a.split(".");
      var b = a[0];
      a.shift();
      return [b, a.join(".")];
    }

    M("shaka.util.MimeUtils", ed);
    ed.getFullTypeWithAllCodecs = hd;
    ed.getFullType = fd;
    new Map().set("codecs", "codecs").set("frameRate", "framerate").set("bandwidth", "bitrate").set("width", "width").set("height", "height").set("channelsCount", "channels");
    var gd = ["audio/aac", "audio/ac3", "audio/ec3", "audio/mpeg"];

    function qd(a) {
      this.i = null;
      this.j = a;
      this.C = !1;
      this.l = this.u = 0;
      this.m = Infinity;
      this.h = this.g = null;
      this.D = "";
      this.s = new Map();
    }

    function rd(a) {
      return sd[a] ? !0 : "application/cea-608" == a || "application/cea-708" == a ? !!vc : !1;
    }

    qd.prototype.destroy = function () {
      this.j = this.i = null;
      this.s.clear();
      return Promise.resolve();
    };

    function td(a, b, c, d, e) {
      var f, g, h, k;
      return K(function (l) {
        if (1 == l.g) return D(l, Promise.resolve(), 2);
        if (!a.i || !a.j) return l.return();
        if (null == c || null == d) return a.i.parseInit(nc(b)), l.return();
        f = a.C ? c : a.u;
        g = {
          periodStart: a.u,
          segmentStart: c,
          segmentEnd: d,
          vttOffset: f
        };
        h = a.i.parseMedia(nc(b), g, e);
        k = h.filter(function (m) {
          return m.startTime >= a.l && m.startTime < a.m;
        });
        a.j.append(k);
        null == a.g && (a.g = Math.max(c, a.l));
        a.h = Math.min(d, a.m);
        F(l);
      });
    }

    qd.prototype.remove = function (a, b) {
      var c = this;
      return K(function (d) {
        if (1 == d.g) return D(d, Promise.resolve(), 2);
        !c.j || !c.j.remove(a, b) || null == c.g || b <= c.g || a >= c.h || (a <= c.g && b >= c.h ? c.g = c.h = null : a <= c.g && b < c.h ? c.g = b : a > c.g && b >= c.h && (c.h = a));
        F(d);
      });
    };

    function ud(a, b, c) {
      a.l = b;
      a.m = c;
    }

    function vd(a, b, c) {
      a.D = b;
      if (b = a.s.get(b)) for (var d = t(b.keys()), e = d.next(); !e.done; e = d.next()) (e = b.get(e.value).filter(function (f) {
        return f.endTime <= c;
      })) && a.j.append(e);
    }

    function xd(a, b, c) {
      b.startTime += c;
      b.endTime += c;
      b = t(b.nestedCues);

      for (var d = b.next(); !d.done; d = b.next()) xd(a, d.value, c);
    }

    function yd(a, b, c, d, e) {
      var f = c + " " + d,
          g = new Map();
      b = t(b);

      for (var h = b.next(); !h.done; h = b.next()) {
        var k = h.value;
        h = k.stream;
        k = k.cue;
        g.has(h) || g.set(h, new Map());
        g.get(h).has(f) || g.get(h).set(f, []);
        xd(a, k, e);
        k.startTime >= a.l && k.startTime < a.m && (g.get(h).get(f).push(k), h == a.D && a.j.append([k]));
      }

      e = t(g.keys());

      for (f = e.next(); !f.done; f = e.next()) for (f = f.value, a.s.has(f) || a.s.set(f, new Map()), b = t(g.get(f).keys()), h = b.next(); !h.done; h = b.next()) h = h.value, k = g.get(f).get(h), a.s.get(f).set(h, k);

      a.g = null == a.g ? Math.max(c, a.l) : Math.min(a.g, Math.max(c, a.l));
      a.h = Math.max(a.h, Math.min(d, a.m));
    }

    M("shaka.text.TextEngine", qd);
    qd.prototype.destroy = qd.prototype.destroy;

    qd.findParser = function (a) {
      return sd[a];
    };

    qd.unregisterParser = function (a) {
      delete sd[a];
    };

    qd.registerParser = function (a, b) {
      sd[a] = b;
    };

    var sd = {};

    function zd(a, b) {
      return a.concat(b);
    }

    function Ad() {}

    function Bd(a) {
      return null != a;
    }

    ;

    function Cd(a) {
      function b(d) {
        switch (typeof d) {
          case "undefined":
          case "boolean":
          case "number":
          case "string":
          case "symbol":
          case "function":
            return d;

          default:
            if (!d || d.buffer && d.buffer.constructor == ArrayBuffer) return d;
            if (c.has(d)) return null;
            var e = d.constructor == Array;
            if (d.constructor != Object && !e) return null;
            c.add(d);
            var f = e ? [] : {},
                g;

            for (g in d) f[g] = b(d[g]);

            e && (f.length = d.length);
            return f;
        }
      }

      var c = new WeakSet();
      return b(a);
    }

    function Dd(a) {
      var b = {},
          c;

      for (c in a) b[c] = a[c];

      return b;
    }

    ;

    function Ed(a) {
      this.h = a;
      this.g = null;
    }

    Ed.prototype.R = function (a) {
      var b = this;
      this.stop();
      var c = !0,
          d = null;

      this.g = function () {
        window.clearTimeout(d);
        c = !1;
      };

      d = window.setTimeout(function () {
        c && b.h();
      }, 1E3 * a);
      return this;
    };

    Ed.prototype.stop = function () {
      this.g && (this.g(), this.g = null);
    };

    function Fd(a) {
      this.h = a;
      this.g = null;
    }

    Fd.prototype.Ma = function () {
      this.stop();
      this.h();
      return this;
    };

    Fd.prototype.R = function (a) {
      var b = this;
      this.stop();
      this.g = new Ed(function () {
        b.h();
      }).R(a);
      return this;
    };

    Fd.prototype.ya = function (a) {
      var b = this;
      this.stop();
      this.g = new Ed(function () {
        b.g.R(a);
        b.h();
      }).R(a);
      return this;
    };

    Fd.prototype.stop = function () {
      this.g && (this.g.stop(), this.g = null);
    };

    M("shaka.util.Timer", Fd);
    Fd.prototype.stop = Fd.prototype.stop;
    Fd.prototype.tickEvery = Fd.prototype.ya;
    Fd.prototype.tickAfter = Fd.prototype.R;
    Fd.prototype.tickNow = Fd.prototype.Ma;

    function Gd() {
      var a = window.ManagedMediaSource || window.MediaSource;
      return a && a.isTypeSupported ? !0 : !1;
    }

    function Hd(a) {
      return "" != Id().canPlayType(a);
    }

    function Jd() {
      return navigator.userAgent.match(/Edge?\//) ? !0 : !1;
    }

    function Kd() {
      return Ld("Xbox One");
    }

    function Md() {
      return Ld("Tizen");
    }

    function Nd() {
      return Ld("Tizen 3");
    }

    function Od() {
      return Ld("Tizen 2");
    }

    function Pd() {
      return Ld("Web0S") && Ld("Chrome/38.0.2125.122 Safari/537.36");
    }

    function Qd() {
      return !!navigator.vendor && navigator.vendor.includes("Apple") && !Md() && !Ld("PC=EOS") && !Ld("PC=APL") && !Ld("VirginMedia") && !Ld("SOPOpenBrowser") && !Rd() && !Ld("AFT") && !Ld("WPE");
    }

    function Rd() {
      return Ld("PlayStation 4");
    }

    function Sd() {
      if (!Qd()) return null;
      var a = navigator.userAgent.match(/Version\/(\d+)/);
      return a ? parseInt(a[1], 10) : (a = navigator.userAgent.match(/OS (\d+)(?:_\d+)?/)) ? parseInt(a[1], 10) : null;
    }

    function Ld(a) {
      return (navigator.userAgent || "").includes(a);
    }

    function Id() {
      if (Td) return Td;
      Yd || (Yd = new Fd(function () {
        Td = null;
      }));
      (Td = document.getElementsByTagName("video")[0] || document.getElementsByTagName("audio")[0]) || (Td = document.createElement("video"));
      Yd.R(1);
      return Td;
    }

    var Yd = null,
        Td = null;

    function Zd() {}

    function $d(a, b, c, d) {
      var e = a.variants;
      if (b.length || c.length) e = ae(e, b, c);

      if (d.length) {
        b = new bb();
        c = t(e);

        for (e = c.next(); !e.done; e = c.next()) e = e.value, b.push(String(e.video.width || 0), e);

        var f = [];
        b.forEach(function (u, v) {
          u = 0;
          var y = [],
              z = {};
          v = t(v);

          for (var x = v.next(); !x.done; z = {
            jd: z.jd
          }, x = v.next()) z.jd = x.value, x = d.filter(function (B) {
            return function (A) {
              return B.jd.decodingInfos[0][A];
            };
          }(z)).length, x > u ? (u = x, y = [z.jd]) : x == u && y.push(z.jd);

          f.push.apply(f, w(y));
        });
        e = f;
      }

      c = new Set();
      b = new Set();
      var g = t(e);

      for (e = g.next(); !e.done; e = g.next()) e = e.value, e.audio && c.add(e.audio), e.video && b.add(e.video);

      c = Array.from(c).sort(function (u, v) {
        return u.bandwidth - v.bandwidth;
      });
      var h = [];
      e = new Map();
      c = t(c);

      for (g = c.next(); !g.done; g = c.next()) {
        g = g.value;
        var k = g.language + (g.channelsCount || 0) + (g.audioSamplingRate || 0) + g.roles.join(",") + g.label + g.groupId + g.fastSwitching,
            l = e.get(k) || [];

        if (l.length) {
          var m = l[l.length - 1],
              n = ld(m.codecs),
              r = ld(g.codecs);
          n == r && g.bandwidth > m.bandwidth && (l.push(g), h.push(g.id));
        } else l.push(g), h.push(g.id);

        e.set(k, l);
      }

      c = Array.from(b).sort(function (u, v) {
        return u.bandwidth && v.bandwidth ? u.bandwidth - v.bandwidth : u.width - v.width;
      });
      b = hc();
      var q = [];
      e = new Map();
      c = t(c);

      for (g = c.next(); !g.done; g = c.next()) {
        g = g.value;
        k = Math.round(g.frameRate || 0) + (g.hdr || "") + g.fastSwitching;
        l = e.get(k) || [];

        if (l.length) {
          m = l[l.length - 1];
          if (!b && (n = ld(m.codecs), r = ld(g.codecs), n !== r)) continue;
          g.width > m.width || g.height > m.height ? (l.push(g), q.push(g.id)) : g.width == m.width && g.height == m.height && (n = ld(m.codecs), r = ld(g.codecs), n == r && g.bandwidth < m.bandwidth && (l.push(g), q.push(g.id)));
        } else l.push(g), q.push(g.id);

        e.set(k, l);
      }

      a.variants = a.variants.filter(function (u) {
        var v = u.audio;
        u = u.video;
        return v && !h.includes(v.id) || u && !q.includes(u.id) ? !1 : !0;
      });
    }

    function ae(a, b, c) {
      var d = {};
      b = t(b);

      for (var e = b.next(); !e.done; d = {
        Te: d.Te
      }, e = b.next()) if (d.Te = e.value, e = a.filter(function (f) {
        return function (g) {
          return g.video && g.video.codecs.startsWith(f.Te);
        };
      }(d)), e.length) {
        a = e;
        break;
      }

      d = {};
      c = t(c);

      for (b = c.next(); !b.done; d = {
        Ke: d.Ke
      }, b = c.next()) if (d.Ke = b.value, b = a.filter(function (f) {
        return function (g) {
          return g.audio && g.audio.codecs.startsWith(f.Ke);
        };
      }(d)), b.length) {
        a = b;
        break;
      }

      return a;
    }

    function be(a, b, c) {
      a.variants = a.variants.filter(function (d) {
        return ce(d, b, c);
      });
    }

    function ce(a, b, c) {
      function d(f, g, h) {
        return f >= g && f <= h;
      }

      var e = a.video;
      return e && e.width && e.height && (!d(e.width, b.minWidth, Math.min(b.maxWidth, c.width)) || !d(e.height, b.minHeight, Math.min(b.maxHeight, c.height)) || !d(e.width * e.height, b.minPixels, b.maxPixels)) || a && a.video && a.video.frameRate && !d(a.video.frameRate, b.minFrameRate, b.maxFrameRate) || !d(a.bandwidth, b.minBandwidth, b.maxBandwidth) ? !1 : !0;
    }

    function de(a, b) {
      return K(function (c) {
        if (1 == c.g) return D(c, ee(a, b, 0 < b.offlineSessionIds.length), 2);
        fe(b);
        return D(c, ge(b), 0);
      });
    }

    function ee(a, b, c) {
      var d, e, f, g;
      return K(function (h) {
        if (1 == h.g) return D(h, he(b.variants, c, !1, []), 2);
        d = null;
        a && (e = a.g) && (d = e.keySystem);
        f = Nb;
        g = Kd();
        b.variants = b.variants.filter(function (k) {
          var l = k.video,
              m = l && l.width || 0,
              n = l && l.height || 0;
          if (g && l && (1920 < m || 1080 < n) && (l.codecs.includes("avc1.") || l.codecs.includes("avc3."))) return Za(ie(k)), !1;

          if (l) {
            m = je(l.codecs);

            if (l.codecs.includes(",")) {
              n = l.codecs.split(",");
              m = Jb(f.ia, n);
              m = je(m);
              n = Jb(f.T, n);
              n = ke(n);
              var r = id(l.mimeType, n, f.T);
              if (!fc(r)) return !1;
              m = [m, n].join();
            }

            n = id(l.mimeType, m, f.ia);
            if (!fc(n)) return !1;
            l.codecs = m;
          }

          if (l = k.audio) {
            m = ke(l.codecs);
            n = id(l.mimeType, m, f.T);
            if (!fc(n)) return !1;
            l.codecs = m;
          }

          (l = k.decodingInfos.some(function (q) {
            return !q.supported || d && (q = q.keySystemAccess) && q.keySystem != d ? !1 : !0;
          })) || Za(ie(k));
          return l;
        });
        F(h);
      });
    }

    function le(a) {
      var b = [];

      for (c in a) b.push(c);

      b.sort();
      var c = [];
      b = t(b);

      for (var d = b.next(); !d.done; d = b.next()) {
        var e = d.value;
        d = JSON.stringify(e);
        e = a[e];
        e instanceof Object ? (e = le(e), c.push(d + ":" + e)) : (e = JSON.stringify(e), c.push(d + ":" + e));
      }

      return "{" + c.join(",") + "}";
    }

    function me(a, b) {
      var c, d, e, f, g, h, k;
      return K(function (l) {
        if (1 == l.g) return c = le(b), d = ne, d[c] ? (a.decodingInfos.push(d[c]), l.F(0)) : D(l, oe(b), 3);

        if ((e = l.h) && e.length) {
          f = null;
          g = t(e);

          for (h = g.next(); !h.done; h = g.next()) k = h.value, f ? (f.supported = f.supported && k.supported, f.powerEfficient = f.powerEfficient && k.powerEfficient, f.smooth = f.smooth && k.smooth, k.keySystemAccess || (f.keySystemAccess = null)) : f = k;

          f && (d[c] = f, a.decodingInfos.push(f));
        }

        F(l);
      });
    }

    function oe(a) {
      var b = [""];
      a.video && (b = pd(a.video.contentType).split(","));
      var c = [""];
      a.audio && (c = pd(a.audio.contentType).split(","));
      var d = [];
      b = t(b);

      for (var e = b.next(); !e.done; e = b.next()) {
        e = e.value;

        for (var f = {}, g = t(c), h = g.next(); !h.done; f = {
          cc: f.cc
        }, h = g.next()) h = h.value, f.cc = Cd(a), a.video && (f.cc.video.contentType = fd(od(f.cc.video.contentType), e)), a.audio && (f.cc.audio.contentType = fd(od(f.cc.audio.contentType), h)), d.push(new Promise(function (k) {
          return function (l, m) {
            navigator.mediaCapabilities.decodingInfo(k.cc).then(function (n) {
              l(n);
            }).catch(m);
          };
        }(f)));
      }

      return Promise.all(d).catch(function () {
        JSON.stringify(a);
        return null;
      });
    }

    function he(a, b, c, d) {
      var e, f, g, h, k, l, m, n, r, q, u, v, y, z, x, B, A;
      return K(function (C) {
        switch (C.g) {
          case 1:
            if (e = a.some(function (E) {
              return E.decodingInfos.length;
            })) return C.return();
            f = {};
            g = t(d);
            h = g.next();

          case 2:
            if (h.done) {
              C.F(4);
              break;
            }

            f.Oe = h.value;
            k = !1;
            l = t(a);
            m = l.next();

          case 5:
            if (m.done) {
              C.F(7);
              break;
            }

            n = m.value;
            r = pe(n, b, c).filter(function (E) {
              return function (H) {
                return (H.keySystemConfiguration && H.keySystemConfiguration.keySystem) === E.Oe;
              };
            }(f));
            q = t(r);
            u = q.next();

          case 8:
            if (u.done) {
              C.F(10);
              break;
            }

            v = u.value;
            return D(C, me(n, v), 9);

          case 9:
            u = q.next();
            C.F(8);
            break;

          case 10:
            n.decodingInfos.length && (k = !0);
            m = l.next();
            C.F(5);
            break;

          case 7:
            if (k) return C.return();
            f = {
              Oe: f.Oe
            };
            h = g.next();
            C.F(2);
            break;

          case 4:
            y = t(a), m = y.next();

          case 12:
            if (m.done) {
              C.F(0);
              break;
            }

            z = m.value;
            x = pe(z, b, c).filter(function (E) {
              E = E.keySystemConfiguration && E.keySystemConfiguration.keySystem;
              return !E || !d.includes(E);
            });
            B = t(x);
            u = B.next();

          case 15:
            if (u.done) {
              m = y.next();
              C.F(12);
              break;
            }

            A = u.value;
            return D(C, me(z, A), 16);

          case 16:
            u = B.next(), C.F(15);
        }
      });
    }

    function pe(a, b, c) {
      var d = a.audio,
          e = a.video;
      c = {
        type: c ? "file" : "media-source"
      };

      if (e) {
        var f = e.codecs;

        if (e.codecs.includes(",")) {
          var g = e.codecs.split(",");
          f = Jb("video", g);
          f = je(f);
          g = Jb("audio", g);
          g = ke(g);
          g = id(e.mimeType, g, "audio");
          c.audio = {
            contentType: g,
            channels: 2,
            bitrate: a.bandwidth || 1,
            samplerate: 1,
            spatialRendering: !1
          };
        }

        f = je(f);
        f = id(e.mimeType, f, "video");
        c.video = {
          contentType: f,
          width: e.width || 64,
          height: e.height || 64,
          bitrate: e.bandwidth || a.bandwidth || 1,
          framerate: e.frameRate || 1
        };
        if (e.hdr) switch (e.hdr) {
          case "SDR":
            c.video.transferFunction = "srgb";
            break;

          case "PQ":
            c.video.transferFunction = "pq";
            break;

          case "HLG":
            c.video.transferFunction = "hlg";
        }
      }

      d && (f = ke(d.codecs), f = id(d.mimeType, f, "audio"), c.audio = {
        contentType: f,
        channels: d.channelsCount || 2,
        bitrate: d.bandwidth || a.bandwidth || 1,
        samplerate: d.audioSamplingRate || 1,
        spatialRendering: d.spatialAudio
      });
      g = (a.video ? a.video.drmInfos : []).concat(a.audio ? a.audio.drmInfos : []);
      if (!g.length) return [c];
      a = [];
      f = new Map();
      g = t(g);

      for (var h = g.next(); !h.done; h = g.next()) {
        var k = h.value;
        f.get(k.keySystem) || f.set(k.keySystem, []);
        f.get(k.keySystem).push(k);
      }

      g = b ? "required" : "optional";
      b = b ? ["persistent-license"] : ["temporary"];
      k = t(f.keys());

      for (var l = k.next(); !l.done; l = k.next()) {
        var m = l.value;
        l = Object.assign({}, c);
        var n = f.get(m);
        m = {
          keySystem: m,
          initDataType: "cenc",
          persistentState: g,
          distinctiveIdentifier: "optional",
          sessionTypes: b
        };
        n = t(n);

        for (h = n.next(); !h.done; h = n.next()) {
          h = h.value;

          if (h.initData && h.initData.length) {
            for (var r = new Set(), q = t(h.initData), u = q.next(); !u.done; u = q.next()) r.add(u.value.initDataType);

            m.initDataType = h.initData[0].initDataType;
          }

          h.distinctiveIdentifierRequired && (m.distinctiveIdentifier = "required");
          h.persistentStateRequired && (m.persistentState = "required");
          h.sessionType && (m.sessionTypes = [h.sessionType]);
          d && ("" != h.audioRobustness ? m.audio ? m.audio.robustness = m.audio.robustness || h.audioRobustness : m.audio = {
            robustness: h.audioRobustness
          } : m.audio || (m.audio = {}));
          e && ("" != h.videoRobustness ? m.video ? m.video.robustness = m.video.robustness || h.videoRobustness : m.video = {
            robustness: h.videoRobustness
          } : m.video || (m.video = {}));
        }

        l.keySystemConfiguration = m;
        a.push(l);
      }

      return a;
    }

    function ke(a) {
      return "fLaC" === a ? "flac" : "Opus" === a ? "opus" : Md() ? "ac-3" == a.toLowerCase() ? "ec-3" : a : a;
    }

    function je(a) {
      if (a.includes("avc1")) {
        var b = a.split(".");
        if (3 == b.length) return a = b.shift() + ".", a += parseInt(b.shift(), 10).toString(16), a += ("000" + parseInt(b.shift(), 10).toString(16)).slice(-4);
      } else if ("vp9" == a) return "vp09.00.41.08";

      return a;
    }

    function fe(a) {
      a.textStreams = a.textStreams.filter(function (b) {
        b = fd(b.mimeType, b.codecs);
        return rd(b);
      });
    }

    function ge(a) {
      var b, c, d, e, f, g, h, k;
      return K(function (l) {
        switch (l.g) {
          case 1:
            b = [], c = t(a.imageStreams), d = c.next();

          case 2:
            if (d.done) {
              l.F(4);
              break;
            }

            e = d.value;
            f = e.mimeType;
            "application/mp4" == f && "mjpg" == e.codecs && (f = "image/jpg");

            if (qe.has(f)) {
              l.F(5);
              break;
            }

            g = re.get(f);

            if (!g) {
              qe.set(f, !1);
              l.F(5);
              break;
            }

            return D(l, se(g), 7);

          case 7:
            h = l.h, qe.set(f, h);

          case 5:
            (k = qe.get(f)) && b.push(e);
            d = c.next();
            l.F(2);
            break;

          case 4:
            a.imageStreams = b, F(l);
        }
      });
    }

    function se(a) {
      return new Promise(function (b) {
        var c = new Image();
        c.src = a;
        "decode" in c ? c.decode().then(function () {
          b(!0);
        }).catch(function () {
          b(!1);
        }) : c.onload = c.onerror = function () {
          b(2 === c.height);
        };
      });
    }

    function te(a) {
      var b = a.audio,
          c = a.video,
          d = b ? b.mimeType : null,
          e = c ? c.mimeType : null,
          f = b ? b.codecs : null,
          g = c ? c.codecs : null,
          h = [];
      g && h.push(g);
      f && h.push(f);
      var k = [];
      c && k.push(c.mimeType);
      b && k.push(b.mimeType);
      k = k[0] || null;
      var l = [];
      b && l.push(b.kind);
      c && l.push(c.kind);
      l = l[0] || null;
      var m = new Set();
      if (b) for (var n = t(b.roles), r = n.next(); !r.done; r = n.next()) m.add(r.value);
      if (c) for (n = t(c.roles), r = n.next(); !r.done; r = n.next()) m.add(r.value);
      a = {
        id: a.id,
        active: !1,
        type: "variant",
        bandwidth: a.bandwidth,
        language: a.language,
        label: null,
        kind: l,
        width: null,
        height: null,
        frameRate: null,
        pixelAspectRatio: null,
        hdr: null,
        videoLayout: null,
        mimeType: k,
        audioMimeType: d,
        videoMimeType: e,
        codecs: h.join(", "),
        audioCodec: f,
        videoCodec: g,
        primary: a.primary,
        roles: Array.from(m),
        audioRoles: null,
        forced: !1,
        videoId: null,
        audioId: null,
        channelsCount: null,
        audioSamplingRate: null,
        spatialAudio: !1,
        tilesLayout: null,
        audioBandwidth: null,
        videoBandwidth: null,
        originalVideoId: null,
        originalAudioId: null,
        originalTextId: null,
        originalImageId: null,
        accessibilityPurpose: null,
        originalLanguage: null
      };
      c && (a.videoId = c.id, a.originalVideoId = c.originalId, a.width = c.width || null, a.height = c.height || null, a.frameRate = c.frameRate || null, a.pixelAspectRatio = c.pixelAspectRatio || null, a.videoBandwidth = c.bandwidth || null, a.hdr = c.hdr || null, a.videoLayout = c.videoLayout || null);
      b && (a.audioId = b.id, a.originalAudioId = b.originalId, a.channelsCount = b.channelsCount, a.audioSamplingRate = b.audioSamplingRate, a.audioBandwidth = b.bandwidth || null, a.spatialAudio = b.spatialAudio, a.label = b.label, a.audioRoles = b.roles, a.accessibilityPurpose = b.accessibilityPurpose, a.originalLanguage = b.originalLanguage);
      return a;
    }

    function ue(a) {
      return {
        id: a.id,
        active: !1,
        type: Mb,
        bandwidth: 0,
        language: a.language,
        label: a.label,
        kind: a.kind || null,
        width: null,
        height: null,
        frameRate: null,
        pixelAspectRatio: null,
        hdr: null,
        videoLayout: null,
        mimeType: a.mimeType,
        audioMimeType: null,
        videoMimeType: null,
        codecs: a.codecs || null,
        audioCodec: null,
        videoCodec: null,
        primary: a.primary,
        roles: a.roles,
        audioRoles: null,
        forced: a.forced,
        videoId: null,
        audioId: null,
        channelsCount: null,
        audioSamplingRate: null,
        spatialAudio: !1,
        tilesLayout: null,
        audioBandwidth: null,
        videoBandwidth: null,
        originalVideoId: null,
        originalAudioId: null,
        originalTextId: a.originalId,
        originalImageId: null,
        accessibilityPurpose: a.accessibilityPurpose,
        originalLanguage: a.originalLanguage
      };
    }

    function ve(a) {
      var b = a.width || null,
          c = a.height || null,
          d = null;
      a.segmentIndex && (d = a.segmentIndex.get(0));
      var e = a.tilesLayout;
      d && (e = d.tilesLayout || e);
      e && null != b && (b /= Number(e.split("x")[0]));
      e && null != c && (c /= Number(e.split("x")[1]));
      return {
        id: a.id,
        active: !1,
        type: "image",
        bandwidth: a.bandwidth || 0,
        language: "",
        label: null,
        kind: null,
        width: b,
        height: c,
        frameRate: null,
        pixelAspectRatio: null,
        hdr: null,
        videoLayout: null,
        mimeType: a.mimeType,
        audioMimeType: null,
        videoMimeType: null,
        codecs: a.codecs || null,
        audioCodec: null,
        videoCodec: null,
        primary: !1,
        roles: [],
        audioRoles: null,
        forced: !1,
        videoId: null,
        audioId: null,
        channelsCount: null,
        audioSamplingRate: null,
        spatialAudio: !1,
        tilesLayout: e || null,
        audioBandwidth: null,
        videoBandwidth: null,
        originalVideoId: null,
        originalAudioId: null,
        originalTextId: null,
        originalImageId: a.originalId,
        accessibilityPurpose: null,
        originalLanguage: null
      };
    }

    function we(a) {
      a.__shaka_id || (a.__shaka_id = xe++);
      return a.__shaka_id;
    }

    function ye(a) {
      var b = ze(a);
      b.active = "disabled" != a.mode;
      b.type = "text";
      b.originalTextId = a.id;
      "captions" == a.kind && (b.mimeType = "application/cea-608");
      "subtitles" == a.kind && (b.mimeType = "text/vtt");
      a.kind && (b.roles = [a.kind]);
      "forced" == a.kind && (b.forced = !0);
      return b;
    }

    function Ae(a) {
      var b = ze(a);
      b.active = a.enabled;
      b.type = "variant";
      b.originalAudioId = a.id;
      "main" == a.kind && (b.primary = !0);
      a.kind && (b.roles = [a.kind], b.audioRoles = [a.kind], b.label = a.label);
      return b;
    }

    function ze(a) {
      var b = a.language;
      return {
        id: we(a),
        active: !1,
        type: "",
        bandwidth: 0,
        language: Qb(b || "und"),
        label: a.label,
        kind: a.kind,
        width: null,
        height: null,
        frameRate: null,
        pixelAspectRatio: null,
        hdr: null,
        videoLayout: null,
        mimeType: null,
        audioMimeType: null,
        videoMimeType: null,
        codecs: null,
        audioCodec: null,
        videoCodec: null,
        primary: !1,
        roles: [],
        forced: !1,
        audioRoles: null,
        videoId: null,
        audioId: null,
        channelsCount: null,
        audioSamplingRate: null,
        spatialAudio: !1,
        tilesLayout: null,
        audioBandwidth: null,
        videoBandwidth: null,
        originalVideoId: null,
        originalAudioId: null,
        originalTextId: null,
        originalImageId: null,
        accessibilityPurpose: null,
        originalLanguage: b
      };
    }

    function Be(a) {
      return a.allowedByApplication && a.allowedByKeySystem && 0 == a.disabledUntilTime;
    }

    function Ce(a) {
      return a.filter(function (b) {
        return Be(b);
      });
    }

    function De(a, b, c, d) {
      var e = a,
          f = a.filter(function (k) {
        return k.primary;
      });
      f.length && (e = f);
      var g = e.length ? e[0].language : "";
      e = e.filter(function (k) {
        return k.language == g;
      });

      if (b) {
        var h = Yb(Qb(b), a.map(function (k) {
          return k.language;
        }));
        h && (e = a.filter(function (k) {
          return Qb(k.language) == h;
        }));
      }

      e = e.filter(function (k) {
        return k.forced == d;
      });

      if (c) {
        if (a = Ee(e, c), a.length) return a;
      } else if (a = e.filter(function (k) {
        return 0 == k.roles.length;
      }), a.length) return a;

      a = e.map(function (k) {
        return k.roles;
      }).reduce(zd, []);
      return a.length ? Ee(e, a[0]) : e;
    }

    function Ee(a, b) {
      return a.filter(function (c) {
        return c.roles.includes(b);
      });
    }

    function ie(a) {
      var b = [];
      a.audio && b.push(Fe(a.audio));
      a.video && b.push(Fe(a.video));
      return b.join(", ");
    }

    function Fe(a) {
      return "audio" == a.type ? "type=audio codecs=" + a.codecs + " bandwidth=" + a.bandwidth + " channelsCount=" + a.channelsCount + " audioSamplingRate=" + a.audioSamplingRate : "video" == a.type ? "type=video codecs=" + a.codecs + " bandwidth=" + a.bandwidth + " frameRate=" + a.frameRate + " width=" + a.width + " height=" + a.height : "unexpected stream type";
    }

    M("shaka.util.StreamUtils", Zd);
    Zd.meetsRestrictions = ce;
    var ne = {},
        xe = 0,
        qe = new Map().set("image/svg+xml", !0).set("image/png", !0).set("image/jpeg", !0).set("image/jpg", !0),
        re = new Map().set("image/webp", "data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA").set("image/avif", "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A=");

    function Ge() {
      var a = this;
      this.u = null;
      this.s = !1;
      this.i = new ec();
      this.D = null;
      navigator.connection && navigator.connection.addEventListener && (this.D = function () {
        if (a.s && a.g.useNetworkInformation) {
          a.i = new ec();
          a.g && a.i.configure(a.g.advanced);
          var b = a.chooseVariant();
          b && navigator.onLine && a.u(b, a.g.clearBufferSwitch, a.g.safeMarginSwitch);
        }
      }, navigator.connection.addEventListener("change", this.D));
      this.m = [];
      this.G = 1;
      this.I = !1;
      this.h = this.l = this.g = this.C = null;
      this.H = new Fd(function () {
        if (a.g.restrictToElementSize) {
          var b = a.chooseVariant();
          b && a.u(b, a.g.clearBufferSwitch, a.g.safeMarginSwitch);
        }
      });
      this.j = null;
    }

    p = Ge.prototype;

    p.stop = function () {
      this.u = null;
      this.s = !1;
      this.m = [];
      this.G = 1;
      this.l = this.C = null;
      this.h && (this.h.disconnect(), this.h = null);
      this.H.stop();
      this.j = null;
    };

    p.release = function () {
      navigator.connection && navigator.connection.removeEventListener && (navigator.connection.removeEventListener("change", this.D), this.D = null);
      this.H = null;
    };

    p.init = function (a) {
      this.u = a;
    };

    p.chooseVariant = function (a) {
      a = void 0 === a ? !1 : a;
      var b = Infinity,
          c = Infinity;
      this.g.restrictToScreenSize && (c = this.g.ignoreDevicePixelRatio ? 1 : window.devicePixelRatio, b = window.screen.height * c, c *= window.screen.width);

      if (this.h && this.g.restrictToElementSize) {
        var d = this.g.ignoreDevicePixelRatio ? 1 : window.devicePixelRatio;
        b = Math.min(b, this.l.clientHeight * d);
        c = Math.min(c, this.l.clientWidth * d);
      }

      var e = this.m.filter(function (l) {
        return !(l.audio && l.audio.fastSwitching || l.video && l.video.fastSwitching);
      });
      e.length || (e = this.m);
      d = e;
      a && e.length != this.m.length && (d = this.m.filter(function (l) {
        return l.audio && l.audio.fastSwitching || l.video && l.video.fastSwitching ? !0 : !1;
      }));
      a = He(this, this.g.restrictions, d, Infinity, Infinity);

      if (Infinity != b || Infinity != c) {
        a = Ie(a);
        a = t(a);

        for (e = a.next(); !e.done; e = a.next()) if (e = e.value, e.height >= b && e.width >= c) {
          b = e.height;
          c = e.width;
          break;
        }

        a = He(this, this.g.restrictions, d, b, c);
      }

      b = this.getBandwidthEstimate();
      d.length && !a.length && (a = He(this, null, d, Infinity, Infinity), a = [a[0]]);
      c = a[0] || null;

      for (d = 0; d < a.length; d++) {
        e = a[d];

        for (var f = isNaN(this.G) ? 1 : Math.abs(this.G), g = f * e.bandwidth / this.g.bandwidthDowngradeTarget, h = {
          bandwidth: Infinity
        }, k = d + 1; k < a.length; k++) if (e.bandwidth != a[k].bandwidth) {
          h = a[k];
          break;
        }

        f = f * h.bandwidth / this.g.bandwidthUpgradeTarget;
        b >= g && b <= f && c.bandwidth != e.bandwidth && (c = e);
      }

      this.C = Date.now();
      return c;
    };

    p.enable = function () {
      this.s = !0;
    };

    p.disable = function () {
      this.s = !1;
    };

    p.segmentDownloaded = function (a, b, c) {
      this.i.sample(a, b);
      if (c && null != this.C && this.s) a: {
        if (!this.I) {
          a = this.i;
          if (!(a.g >= a.i)) break a;
          this.I = !0;
        } else if (Date.now() - this.C < 1E3 * this.g.switchInterval) break a;

        a = this.chooseVariant();
        this.getBandwidthEstimate();
        a && this.u(a, this.g.clearBufferSwitch, this.g.safeMarginSwitch);
      }
    };

    p.getBandwidthEstimate = function () {
      var a = this.g.defaultBandwidthEstimate;
      navigator.connection && navigator.connection.downlink && this.g.useNetworkInformation && (a = 1E6 * navigator.connection.downlink);
      a = this.i.getBandwidthEstimate(a);
      return this.j ? this.j.getBandwidthEstimate(a) : a;
    };

    p.setVariants = function (a) {
      this.m = a;
    };

    p.playbackRateChanged = function (a) {
      this.G = a;
    };

    p.setMediaElement = function (a) {
      var b = this;
      this.l = a;
      this.h && (this.h.disconnect(), this.h = null);
      this.l && "ResizeObserver" in window && (this.h = new ResizeObserver(function () {
        b.H.R(Je);
      }), this.h.observe(this.l));
    };

    p.setCmsdManager = function (a) {
      this.j = a;
    };

    p.configure = function (a) {
      this.g = a;
      this.i && this.g && this.i.configure(this.g.advanced);
    };

    function He(a, b, c, d, e) {
      if (a.j) {
        var f = a.j.Ng();
        f && (c = c.filter(function (g) {
          return g.bandwidth && f ? g.bandwidth <= f : !0;
        }));
      }

      b && (c = c.filter(function (g) {
        return ce(g, b, {
          width: e,
          height: d
        });
      }));
      return c.sort(function (g, h) {
        return g.bandwidth - h.bandwidth;
      });
    }

    function Ie(a) {
      var b = [];
      a = t(a);

      for (var c = a.next(); !c.done; c = a.next()) (c = c.value.video) && c.height && c.width && b.push({
        height: c.height,
        width: c.width
      });

      return b.sort(function (d, e) {
        return d.width - e.width;
      });
    }

    M("shaka.abr.SimpleAbrManager", Ge);
    Ge.prototype.configure = Ge.prototype.configure;
    Ge.prototype.setCmsdManager = Ge.prototype.setCmsdManager;
    Ge.prototype.setMediaElement = Ge.prototype.setMediaElement;
    Ge.prototype.playbackRateChanged = Ge.prototype.playbackRateChanged;
    Ge.prototype.setVariants = Ge.prototype.setVariants;
    Ge.prototype.getBandwidthEstimate = Ge.prototype.getBandwidthEstimate;
    Ge.prototype.segmentDownloaded = Ge.prototype.segmentDownloaded;
    Ge.prototype.disable = Ge.prototype.disable;
    Ge.prototype.enable = Ge.prototype.enable;
    Ge.prototype.chooseVariant = Ge.prototype.chooseVariant;
    Ge.prototype.init = Ge.prototype.init;
    Ge.prototype.release = Ge.prototype.release;
    Ge.prototype.stop = Ge.prototype.stop;
    var Je = 1;

    function Ke(a, b) {
      this.g = a;
      this.h = b;
    }

    Ke.prototype.toString = function () {
      return "v" + this.g + "." + this.h;
    };

    function Le(a, b) {
      var c = new Ke(5, 0),
          d = Me,
          e = d.g,
          f = c.h - e.h;
      (0 < (c.g - e.g || f) ? d.i : d.h)(d.g, c, a, b);
    }

    function Ne(a, b, c, d) {
      Ua([c, "has been deprecated and will be removed in", b, ". We are currently at version", a, ". Additional information:", d].join(" "));
    }

    function Oe(a, b, c, d) {
      Ta([c, "has been deprecated and has been removed in", b, ". We are now at version", a, ". Additional information:", d].join(""));
    }

    var Me = null;
    M("shaka.config.AutoShowText", {
      NEVER: 0,
      ALWAYS: 1,
      IF_PREFERRED_TEXT_LANGUAGE: 2,
      IF_SUBTITLES_MAY_BE_NEEDED: 3
    });
    M("shaka.config.CodecSwitchingStrategy", {
      Nj: "reload",
      vh: "smooth"
    });

    function Pe(a, b, c, d) {
      c = void 0 === c ? !0 : c;
      d = void 0 === d ? !1 : d;
      this.h = a;
      this.g = new Set([a]);
      b = b || [];
      a = t(b);

      for (b = a.next(); !b.done; b = a.next()) this.add(b.value, c, d);
    }

    Pe.prototype.add = function (a, b, c) {
      return Qe(this.h, a, void 0 === b ? !0 : b, void 0 === c ? !1 : c) ? (this.g.add(a), !0) : !1;
    };

    function Qe(a, b, c, d) {
      var e;

      if (!(e = !!a.audio != !!b.audio || !!a.video != !!b.video || a.language != b.language) && (e = a.audio && b.audio)) {
        e = a.audio;
        var f = b.audio;
        e = !!((!e.channelsCount || !f.channelsCount || 2 < e.channelsCount || 2 < f.channelsCount) && e.channelsCount != f.channelsCount || c && !Re(e, f) || !Se(e.roles, f.roles) || d && e.groupId !== f.groupId);
      }

      !(d = e) && (d = a.video && b.video) && (a = a.video, b = b.video, d = !((!c || Re(a, b)) && Se(a.roles, b.roles)));
      return d ? !1 : !0;
    }

    Pe.prototype.values = function () {
      return this.g.values();
    };

    function Re(a, b) {
      if (a.mimeType != b.mimeType) return !1;
      a = a.codecs.split(",").map(function (d) {
        return nd(d);
      });
      b = b.codecs.split(",").map(function (d) {
        return nd(d);
      });
      if (a.length != b.length) return !1;
      a.sort();
      b.sort();

      for (var c = 0; c < a.length; c++) if (a[c] != b[c]) return !1;

      return !0;
    }

    function Se(a, b) {
      a = new Set(a);
      b = new Set(b);
      a.delete("main");
      b.delete("main");
      if (a.size != b.size) return !1;
      a = t(a);

      for (var c = a.next(); !c.done; c = a.next()) if (!b.has(c.value)) return !1;

      return !0;
    }

    ;

    function Te(a, b, c) {
      b = void 0 === b ? "reload" : b;
      c = void 0 === c ? !1 : c;
      this.i = a;
      this.h = b;
      this.g = c;
      this.j = new Ue(a.language, "", a.audio && a.audio.channelsCount ? a.audio.channelsCount : 0, "", !1, "", "", "", b, c);
    }

    Te.prototype.create = function (a) {
      var b = this,
          c = "smooth" == this.h && hc(),
          d = a.filter(function (e) {
        return Qe(b.i, e, !c, b.g);
      });
      return d.length ? new Pe(d[0], d, !c, this.g) : this.j.create(a);
    };

    function Ue(a, b, c, d, e, f, g, h, k, l) {
      this.u = a;
      this.C = b;
      this.h = c;
      this.i = d;
      this.D = e;
      this.l = f;
      this.g = void 0 === g ? "" : g;
      this.j = void 0 === h ? "" : h;
      this.m = void 0 === k ? "reload" : k;
      this.s = void 0 === l ? !1 : l;
    }

    Ue.prototype.create = function (a) {
      var b = [];
      b = Ve(a, this.u);
      var c = a.filter(function (d) {
        return d.primary;
      });
      b = b.length ? b : c.length ? c : a;
      a = We(b, this.C);
      a.length && (b = a);
      this.l && (a = Xe(b, this.l), a.length && (b = a));
      this.i && (a = Ze(b, this.i), a.length && (b = a));
      this.h && (a = $e(b, this.h), a.length && (b = a));
      this.g && (a = af(b, this.g), a.length && (b = a));
      this.j && (a = bf(b, this.j), a.length && (b = a));
      a = cf(b, this.D);
      a.length && (b = a);
      return new Pe(b[0], b, !("smooth" == this.m && hc()), this.s);
    };

    function Ve(a, b) {
      b = Qb(b);
      var c = Yb(b, a.map(function (d) {
        return Xb(d);
      }));
      return c ? a.filter(function (d) {
        return c == Xb(d);
      }) : [];
    }

    function We(a, b) {
      return a.filter(function (c) {
        return c.audio ? b ? c.audio.roles.includes(b) : 0 == c.audio.roles.length : !1;
      });
    }

    function af(a, b) {
      return a.filter(function (c) {
        return c.audio && c.audio.label ? c.audio.label.toLowerCase() == b.toLowerCase() : !1;
      });
    }

    function bf(a, b) {
      return a.filter(function (c) {
        return c.video && c.video.label ? c.video.label.toLowerCase() == b.toLowerCase() : !1;
      });
    }

    function $e(a, b) {
      return a.filter(function (c) {
        return c.audio && c.audio.channelsCount && c.audio.channelsCount != b ? !1 : !0;
      });
    }

    function Ze(a, b) {
      "AUTO" == b && (b = window.matchMedia("(color-gamut: p3)").matches ? "PQ" : "SDR");
      return a.filter(function (c) {
        return c.video && c.video.hdr && c.video.hdr != b ? !1 : !0;
      });
    }

    function Xe(a, b) {
      return a.filter(function (c) {
        return c.video && c.video.videoLayout && c.video.videoLayout != b ? !1 : !0;
      });
    }

    function cf(a, b) {
      return a.filter(function (c) {
        return c.audio && c.audio.spatialAudio != b ? !1 : !0;
      });
    }

    ;

    function df() {
      this.g = ef;
      this.h = new Map().set(ef, 2).set(ff, 1);
    }

    function gf(a, b, c) {
      a.h.set(ef, c).set(ff, b);
    }

    var ff = 0,
        ef = 1;

    function hf(a, b) {
      var c = jf();
      this.l = null == a.maxAttempts ? c.maxAttempts : a.maxAttempts;
      this.j = null == a.baseDelay ? c.baseDelay : a.baseDelay;
      this.s = null == a.fuzzFactor ? c.fuzzFactor : a.fuzzFactor;
      this.m = null == a.backoffFactor ? c.backoffFactor : a.backoffFactor;
      this.g = 0;
      this.h = this.j;
      if (this.i = void 0 === b ? !1 : b) this.g = 1;
    }

    function kf(a) {
      var b, c;
      return K(function (d) {
        if (1 == d.g) {
          if (a.g >= a.l) if (a.i) a.g = 1, a.h = a.j;else throw new P(2, 7, 1010);
          b = a.g;
          a.g++;
          if (0 == b) return d.return();
          c = a.h * (1 + (2 * Math.random() - 1) * a.s);
          return D(d, new Promise(function (e) {
            new Fd(e).R(c / 1E3);
          }), 2);
        }

        a.h *= a.m;
        F(d);
      });
    }

    function jf() {
      return {
        maxAttempts: 2,
        baseDelay: 1E3,
        backoffFactor: 2,
        fuzzFactor: .5,
        timeout: 3E4,
        stallTimeout: 5E3,
        connectionTimeout: 1E4
      };
    }

    ;

    function lf() {
      var a,
          b,
          c = new Promise(function (d, e) {
        a = d;
        b = e;
      });
      c.resolve = a;
      c.reject = b;
      return c;
    }

    lf.prototype.resolve = function () {};

    lf.prototype.reject = function () {};

    function mf(a, b) {
      this.promise = a;
      this.i = b;
      this.g = !1;
    }

    function nf(a) {
      return new mf(Promise.reject(a), function () {
        return Promise.resolve();
      });
    }

    function of() {
      var a = Promise.reject(new P(2, 7, 7001));
      a.catch(function () {});
      return new mf(a, function () {
        return Promise.resolve();
      });
    }

    function pf(a) {
      return new mf(Promise.resolve(a), function () {
        return Promise.resolve();
      });
    }

    function qf(a) {
      return new mf(a, function () {
        return a.catch(function () {});
      });
    }

    mf.prototype.abort = function () {
      this.g = !0;
      return this.i();
    };

    function rf(a) {
      return new mf(Promise.all(a.map(function (b) {
        return b.promise;
      })), function () {
        return Promise.all(a.map(function (b) {
          return b.abort();
        }));
      });
    }

    mf.prototype.finally = function (a) {
      this.promise.then(function () {
        return a(!0);
      }, function () {
        return a(!1);
      });
      return this;
    };

    mf.prototype.Da = function (a, b) {
      function c(h) {
        return function (k) {
          if (e.g && h) f.reject(g);else {
            var l = h ? a : b;
            l ? d = sf(l, k, f) : (h ? f.resolve : f.reject)(k);
          }
        };
      }

      function d() {
        f.reject(g);
        return e.abort();
      }

      var e = this,
          f = new lf(),
          g = new P(2, 7, 7001);
      this.promise.then(c(!0), c(!1));
      return new mf(f, function () {
        return d();
      });
    };

    function sf(a, b, c) {
      try {
        var d = a(b);
        if (d && d.promise && d.abort) return c.resolve(d.promise), function () {
          return d.abort();
        };
        c.resolve(d);
        return function () {
          return Promise.resolve(d).then(function () {}, function () {});
        };
      } catch (e) {
        return c.reject(e), function () {
          return Promise.resolve();
        };
      }
    }

    M("shaka.util.AbortableOperation", mf);
    mf.prototype.chain = mf.prototype.Da;
    mf.prototype["finally"] = mf.prototype.finally;
    mf.all = rf;
    mf.prototype.abort = mf.prototype.abort;
    mf.notAbortable = qf;
    mf.completed = pf;
    mf.aborted = of;
    mf.failed = nf;

    function tf() {
      this.g = [];
    }

    function uf(a, b) {
      a.g.push(b.finally(function () {
        xc(a.g, b);
      }));
    }

    tf.prototype.destroy = function () {
      for (var a = [], b = t(this.g), c = b.next(); !c.done; c = b.next()) c = c.value, c.promise.catch(function () {}), a.push(c.abort());

      this.g = [];
      return Promise.all(a);
    };

    function vf(a, b, c, d, e) {
      db.call(this);
      this.i = !1;
      this.m = new tf();
      this.g = new Set();
      this.h = new Set();
      this.l = a || null;
      this.j = b || null;
      this.u = c || null;
      this.C = d || null;
      this.D = e || null;
      this.s = !1;
    }

    pa(vf, db);
    p = vf.prototype;

    p.hg = function (a) {
      this.s = a;
    };

    function wf(a, b, c, d) {
      c = c || xf;
      var e = yf[a];
      if (!e || c >= e.priority) yf[a] = {
        priority: c,
        Ae: b,
        Qi: void 0 === d ? !1 : d
      };
    }

    p.Ri = function (a) {
      this.g.add(a);
    };

    p.ij = function (a) {
      this.g.delete(a);
    };

    p.Dh = function () {
      this.g.clear();
    };

    p.Si = function (a) {
      this.h.add(a);
    };

    p.jj = function (a) {
      this.h.delete(a);
    };

    p.Eh = function () {
      this.h.clear();
    };

    function zf(a, b, c) {
      return {
        uris: a,
        method: "GET",
        body: null,
        headers: {},
        allowCrossSiteCredentials: !1,
        retryParameters: b,
        licenseRequestType: null,
        sessionId: null,
        drmInfo: null,
        initData: null,
        initDataType: null,
        streamDataCallback: void 0 === c ? null : c
      };
    }

    p.destroy = function () {
      this.i = !0;
      this.g.clear();
      this.h.clear();
      db.prototype.release.call(this);
      return this.m.destroy();
    };

    p.request = function (a, b, c) {
      var d = this,
          e = new Af();

      if (this.i) {
        var f = Promise.reject(new P(2, 7, 7001));
        f.catch(function () {});
        return new Bf(f, function () {
          return Promise.resolve();
        }, e);
      }

      b.method = b.method || "GET";
      b.headers = b.headers || {};
      b.retryParameters = b.retryParameters ? Cd(b.retryParameters) : jf();
      b.uris = Cd(b.uris);
      f = Cf(this, a, b, c);
      var g = f.Da(function () {
        return Df(d, a, b, c, new hf(b.retryParameters, !1), 0, null, e);
      }),
          h = g.Da(function (r) {
        return Ef(d, a, r, c);
      }),
          k = Date.now(),
          l = 0;
      f.promise.then(function () {
        l = Date.now() - k;
      }, function () {});
      var m = 0;
      g.promise.then(function () {
        m = Date.now();
      }, function () {});
      var n = h.Da(function (r) {
        var q = Date.now() - m,
            u = r.response;
        u.timeMs += l;
        u.timeMs += q;
        r.wi || !d.l || u.fromCache || "HEAD" == b.method || a != Ff || d.l(u.timeMs, u.data.byteLength, Gf(c));
        return u;
      }, function (r) {
        r && (r.severity = 2);
        throw r;
      });
      f = new Bf(n.promise, function () {
        return n.abort();
      }, e);
      uf(this.m, f);
      return f;
    };

    function Cf(a, b, c, d) {
      function e(h) {
        f = f.Da(function () {
          c.body && (c.body = oc(c.body));
          return h(b, c, d);
        });
      }

      var f = pf(void 0);
      a.C && e(a.C);
      a = t(a.g);

      for (var g = a.next(); !g.done; g = a.next()) e(g.value);

      return f.Da(void 0, function (h) {
        if (h instanceof P && 7001 == h.code) throw h;
        throw new P(2, 1, 1006, h);
      });
    }

    function Df(a, b, c, d, e, f, g, h) {
      a.s && (c.uris[f] = c.uris[f].replace("http://", "https://"));
      0 < f && a.D && a.D(b, d, c.uris[f], c.uris[f - 1]);
      var k = new kb(c.uris[f]),
          l = k.qb,
          m = !1;
      l || (l = location.protocol, l = l.slice(0, -1), mb(k, l), c.uris[f] = k.toString());
      l = l.toLowerCase();
      var n = (l = yf[l]) ? l.Ae : null;
      if (!n) return nf(new P(2, 1, 1E3, k));
      var r = l.Qi,
          q = null,
          u = null,
          v = !1,
          y = !1,
          z;
      return qf(kf(e)).Da(function () {
        if (a.i) return of();
        z = Date.now();
        var x = n(c.uris[f], c, b, function (C, E, H) {
          q && q.stop();
          u && u.R(A / 1E3);
          a.l && b == Ff && (a.l(C, E, Gf(d)), m = !0, h.g = H);
        }, function (C) {
          a.j && a.j(C, c, b);
          y = !0;
        });
        if (!r) return x;
        var B = c.retryParameters.connectionTimeout;
        B && (q = new Fd(function () {
          v = !0;
          x.abort();
        }), q.R(B / 1E3));
        var A = c.retryParameters.stallTimeout;
        A && (u = new Fd(function () {
          v = !0;
          x.abort();
        }));
        return x;
      }).Da(function (x) {
        q && q.stop();
        u && u.stop();
        void 0 == x.timeMs && (x.timeMs = Date.now() - z);
        var B = {
          response: x,
          wi: m
        };
        !y && a.j && a.j(x.headers, c, b);
        return B;
      }, function (x) {
        q && q.stop();
        u && u.stop();

        if (a.u) {
          var B = null,
              A = 0;
          x instanceof P && (B = x, 1001 == x.code && (A = x.data[1]));
          a.u(c, B, A, v);
        }

        if (a.i) return of();
        v && (x = new P(1, 1, 1003, c.uris[f], b));

        if (x instanceof P) {
          if (7001 == x.code) throw x;
          if (1010 == x.code) throw g;
          if (1 == x.severity) return B = new Map().set("error", x), B = new N("retry", B), a.dispatchEvent(B), f = (f + 1) % c.uris.length, Df(a, b, c, d, e, f, x, h);
        }

        throw x;
      });
    }

    function Ef(a, b, c, d) {
      var e = pf(void 0),
          f = {};
      a = t(a.h);

      for (var g = a.next(); !g.done; f = {
        Qe: f.Qe
      }, g = a.next()) f.Qe = g.value, e = e.Da(function (h) {
        return function () {
          var k = c.response;
          k.data && (k.data = oc(k.data));
          return h.Qe(b, k, d);
        };
      }(f));

      return e.Da(function () {
        return c;
      }, function (h) {
        var k = 2;

        if (h instanceof P) {
          if (7001 == h.code) throw h;
          k = h.severity;
        }

        throw new P(k, 1, 1007, h);
      });
    }

    function Gf(a) {
      if (a) {
        var b = a.segment;
        a = a.stream;
        if (b && a && a.fastSwitching && b.D && !b.C) return !1;
      }

      return !0;
    }

    M("shaka.net.NetworkingEngine", vf);
    vf.prototype.request = vf.prototype.request;
    vf.prototype.destroy = vf.prototype.destroy;
    vf.makeRequest = zf;

    vf.defaultRetryParameters = function () {
      return jf();
    };

    vf.prototype.clearAllResponseFilters = vf.prototype.Eh;
    vf.prototype.unregisterResponseFilter = vf.prototype.jj;
    vf.prototype.registerResponseFilter = vf.prototype.Si;
    vf.prototype.clearAllRequestFilters = vf.prototype.Dh;
    vf.prototype.unregisterRequestFilter = vf.prototype.ij;
    vf.prototype.registerRequestFilter = vf.prototype.Ri;

    vf.unregisterScheme = function (a) {
      delete yf[a];
    };

    vf.registerScheme = wf;
    vf.prototype.setForceHTTPS = vf.prototype.hg;

    function Af() {
      this.g = 0;
    }

    vf.NumBytesRemainingClass = Af;

    function Bf(a, b, c) {
      mf.call(this, a, b);
      this.h = c;
    }

    pa(Bf, mf);
    vf.PendingRequest = Bf;
    var Ff = 1;
    vf.RequestType = {
      MANIFEST: 0,
      SEGMENT: Ff,
      LICENSE: 2,
      APP: 3,
      TIMING: 4,
      SERVER_CERTIFICATE: 5,
      KEY: 6,
      ADS: 7,
      CONTENT_STEERING: 8
    };
    vf.AdvancedRequestType = {
      INIT_SEGMENT: 0,
      MEDIA_SEGMENT: 1,
      MEDIA_PLAYLIST: 2,
      MASTER_PLAYLIST: 3,
      MPD: 4,
      MSS: 5
    };
    var xf = 3;
    vf.PluginPriority = {
      FALLBACK: 1,
      PREFERRED: 2,
      APPLICATION: xf
    };
    var yf = {};

    function Hf(a) {
      this.g = !1;
      this.h = new lf();
      this.i = a;
    }

    Hf.prototype.destroy = function () {
      var a = this;
      if (this.g) return this.h;
      this.g = !0;
      return this.i().then(function () {
        a.h.resolve();
      }, function () {
        a.h.resolve();
      });
    };

    function If(a, b) {
      if (a.g) {
        if (b instanceof P && 7003 == b.code) throw b;
        throw new P(2, 7, 7003, b);
      }
    }

    ;

    function Jf() {
      this.g = new bb();
    }

    p = Jf.prototype;

    p.release = function () {
      this.Lb();
      this.g = null;
    };

    p.o = function (a, b, c, d) {
      this.g && (a = new Kf(a, b, c, d), this.g.push(b, a));
    };

    p.na = function (a, b, c, d) {
      function e(g) {
        f.bc(a, b, e);
        c(g);
      }

      var f = this;
      this.o(a, b, e, d);
    };

    p.bc = function (a, b, c) {
      if (this.g) {
        var d = this.g.get(b) || [];
        d = t(d);

        for (var e = d.next(); !e.done; e = d.next()) e = e.value, e.target != a || c != e.listener && c || (e.bc(), this.g.remove(b, e));
      }
    };

    p.Lb = function () {
      if (this.g) {
        var a = this.g,
            b = [],
            c;

        for (c in a.g) b.push.apply(b, w(a.g[c]));

        a = t(b);

        for (b = a.next(); !b.done; b = a.next()) b.value.bc();

        this.g.g = {};
      }
    };

    M("shaka.util.EventManager", Jf);
    Jf.prototype.removeAll = Jf.prototype.Lb;
    Jf.prototype.unlisten = Jf.prototype.bc;
    Jf.prototype.listenOnce = Jf.prototype.na;
    Jf.prototype.listen = Jf.prototype.o;
    Jf.prototype.release = Jf.prototype.release;

    function Kf(a, b, c, d) {
      this.target = a;
      this.type = b;
      this.listener = c;
      this.g = Lf(a, d);
      this.target.addEventListener(b, c, this.g);
    }

    Kf.prototype.bc = function () {
      this.target.removeEventListener(this.type, this.listener, this.g);
      this.listener = this.target = null;
      this.g = !1;
    };

    function Lf(a, b) {
      if (void 0 == b) return !1;
      if ("boolean" == typeof b) return b;
      var c = new Set(["passive", "capture"]);
      Object.keys(b).filter(function (d) {
        return !c.has(d);
      });
      return Mf(a) ? b : b.capture || !1;
    }

    function Mf(a) {
      var b = Nf;

      if (void 0 == b) {
        b = !1;

        try {
          var c = {},
              d = {
            get: function () {
              b = !0;
              return !1;
            }
          };
          Object.defineProperty(c, "passive", d);
          Object.defineProperty(c, "capture", d);

          d = function () {};

          a.addEventListener("test", d, c);
          a.removeEventListener("test", d, c);
        } catch (e) {
          b = !1;
        }

        Nf = b;
      }

      return b || !1;
    }

    var Nf = void 0;

    function Of(a) {
      this.h = a;
      this.g = void 0;
    }

    Of.prototype.value = function () {
      void 0 == this.g && (this.g = this.h());
      return this.g;
    };

    function Pf(a) {
      for (var b = new Map(), c = t(Object.keys(a)), d = c.next(); !d.done; d = c.next()) d = d.value, b.set(d, a[d]);

      return b;
    }

    function Qf(a) {
      var b = {};
      a.forEach(function (c, d) {
        b[d] = c;
      });
      return b;
    }

    function Rf(a, b) {
      if (a || b) {
        if (a && !b || b && !a) return !1;
      } else return !0;

      if (a.size != b.size) return !1;
      a = t(a);

      for (var c = a.next(); !c.done; c = a.next()) {
        var d = t(c.value);
        c = d.next().value;
        d = d.next().value;
        if (!b.has(c)) return !1;
        c = b.get(c);
        if (c != d || void 0 == c) return !1;
      }

      return !0;
    }

    ;

    function Sf() {}

    function Tf(a) {
      if (!a) return "";
      a = nc(a);
      239 == a[0] && 187 == a[1] && 191 == a[2] && (a = a.subarray(3));
      if (window.TextDecoder && !Rd()) return a = new TextDecoder().decode(a), a.includes("\ufffd") && Ta('Decoded string contains an "unknown character" codepoint.  That probably means the UTF8 encoding was incorrect!'), a;

      for (var b = "", c = 0; c < a.length; ++c) {
        var d = 65533;
        0 == (a[c] & 128) ? d = a[c] : a.length >= c + 2 && 192 == (a[c] & 224) && 128 == (a[c + 1] & 192) ? (d = (a[c] & 31) << 6 | a[c + 1] & 63, c += 1) : a.length >= c + 3 && 224 == (a[c] & 240) && 128 == (a[c + 1] & 192) && 128 == (a[c + 2] & 192) ? (d = (a[c] & 15) << 12 | (a[c + 1] & 63) << 6 | a[c + 2] & 63, c += 2) : a.length >= c + 4 && 240 == (a[c] & 241) && 128 == (a[c + 1] & 192) && 128 == (a[c + 2] & 192) && 128 == (a[c + 3] & 192) && (d = (a[c] & 7) << 18 | (a[c + 1] & 63) << 12 | (a[c + 2] & 63) << 6 | a[c + 3] & 63, c += 3);
        if (65535 >= d) b += String.fromCharCode(d);else {
          d -= 65536;
          var e = d & 1023;
          b += String.fromCharCode(55296 + (d >> 10));
          b += String.fromCharCode(56320 + e);
        }
      }

      return b;
    }

    function Uf(a, b, c) {
      if (!a) return "";
      if (!c && 0 != a.byteLength % 2) throw new P(2, 2, 2004);
      c = Math.floor(a.byteLength / 2);
      var d = new Uint16Array(c);
      a = rc(a);

      for (var e = 0; e < c; e++) d[e] = a.getUint16(2 * e, b);

      return Vf.value()(d);
    }

    function Wf(a) {
      function b(d) {
        return c.byteLength <= d || 32 <= c[d] && 126 >= c[d];
      }

      if (!a) return "";
      var c = nc(a);
      if (239 == c[0] && 187 == c[1] && 191 == c[2]) return Tf(c);
      if (254 == c[0] && 255 == c[1]) return Uf(c.subarray(2), !1);
      if (255 == c[0] && 254 == c[1]) return Uf(c.subarray(2), !0);
      if (0 == c[0] && 0 == c[2]) return Uf(a, !1);
      if (0 == c[1] && 0 == c[3]) return Uf(a, !0);
      if (b(0) && b(1) && b(2) && b(3)) return Tf(a);
      throw new P(2, 2, 2003);
    }

    function Xf(a) {
      if (window.TextEncoder && !Rd()) {
        var b = new TextEncoder();
        return oc(b.encode(a));
      }

      a = encodeURIComponent(a);
      a = unescape(a);
      b = new Uint8Array(a.length);

      for (var c = 0; c < a.length; c++) b[c] = a[c].charCodeAt(0);

      return oc(b);
    }

    function Yf(a, b) {
      for (var c = new ArrayBuffer(2 * a.length), d = new DataView(c), e = 0; e < a.length; ++e) d.setUint16(2 * e, a.charCodeAt(e), b);

      return c;
    }

    M("shaka.util.StringUtils", Sf);

    Sf.resetFromCharCode = function () {
      Vf.g = void 0;
    };

    Sf.toUTF16 = Yf;
    Sf.toUTF8 = Xf;
    Sf.fromBytesAutoDetect = Wf;
    Sf.fromUTF16 = Uf;
    Sf.fromUTF8 = Tf;
    var Vf = new Of(function () {
      function a(c) {
        try {
          var d = new Uint8Array(c);
          return 0 < String.fromCharCode.apply(null, d).length;
        } catch (e) {
          return !1;
        }
      }

      for (var b = {
        Pb: 65536
      }; 0 < b.Pb; b = {
        Pb: b.Pb
      }, b.Pb /= 2) if (a(b.Pb)) return function (c) {
        return function (d) {
          for (var e = "", f = 0; f < d.length; f += c.Pb) e += String.fromCharCode.apply(null, d.subarray(f, f + c.Pb));

          return e;
        };
      }(b);

      return null;
    });

    function Zf(a, b) {
      this.h = rc(a);
      this.i = b == $f;
      this.g = 0;
    }

    p = Zf.prototype;

    p.wa = function () {
      return this.g < this.h.byteLength;
    };

    p.Ea = function () {
      return this.g;
    };

    p.getLength = function () {
      return this.h.byteLength;
    };

    p.qa = function () {
      try {
        var a = this.h.getUint8(this.g);
        this.g += 1;
        return a;
      } catch (b) {
        throw ag();
      }
    };

    p.Ra = function () {
      try {
        var a = this.h.getUint16(this.g, this.i);
        this.g += 2;
        return a;
      } catch (b) {
        throw ag();
      }
    };

    p.O = function () {
      try {
        var a = this.h.getUint32(this.g, this.i);
        this.g += 4;
        return a;
      } catch (b) {
        throw ag();
      }
    };

    p.$g = function () {
      try {
        var a = this.h.getInt32(this.g, this.i);
        this.g += 4;
        return a;
      } catch (b) {
        throw ag();
      }
    };

    p.Rc = function () {
      try {
        if (this.i) {
          var a = this.h.getUint32(this.g, !0);
          var b = this.h.getUint32(this.g + 4, !0);
        } else b = this.h.getUint32(this.g, !1), a = this.h.getUint32(this.g + 4, !1);
      } catch (c) {
        throw ag();
      }

      if (2097151 < b) throw new P(2, 3, 3001);
      this.g += 8;
      return b * Math.pow(2, 32) + a;
    };

    p.Kb = function (a) {
      if (this.g + a > this.h.byteLength) throw ag();
      var b = nc(this.h, this.g, a);
      this.g += a;
      return b;
    };

    p.skip = function (a) {
      if (this.g + a > this.h.byteLength) throw ag();
      this.g += a;
    };

    p.$i = function (a) {
      if (this.g < a) throw ag();
      this.g -= a;
    };

    p.seek = function (a) {
      if (0 > a || a > this.h.byteLength) throw ag();
      this.g = a;
    };

    p.Ed = function () {
      for (var a = this.g; this.wa() && 0 != this.h.getUint8(this.g);) this.g += 1;

      a = nc(this.h, a, this.g - a);
      this.g += 1;
      return Tf(a);
    };

    function ag() {
      return new P(2, 3, 3E3);
    }

    M("shaka.util.DataViewReader", Zf);
    Zf.prototype.readTerminatedString = Zf.prototype.Ed;
    Zf.prototype.seek = Zf.prototype.seek;
    Zf.prototype.rewind = Zf.prototype.$i;
    Zf.prototype.skip = Zf.prototype.skip;
    Zf.prototype.readBytes = Zf.prototype.Kb;
    Zf.prototype.readUint64 = Zf.prototype.Rc;
    Zf.prototype.readInt32 = Zf.prototype.$g;
    Zf.prototype.readUint32 = Zf.prototype.O;
    Zf.prototype.readUint16 = Zf.prototype.Ra;
    Zf.prototype.readUint8 = Zf.prototype.qa;
    Zf.prototype.getLength = Zf.prototype.getLength;
    Zf.prototype.getPosition = Zf.prototype.Ea;
    Zf.prototype.hasMoreData = Zf.prototype.wa;
    var $f = 1;
    Zf.Endianness = {
      BIG_ENDIAN: 0,
      LITTLE_ENDIAN: $f
    };

    function bg() {
      this.i = [];
      this.h = [];
      this.g = !1;
    }

    p = bg.prototype;

    p.box = function (a, b) {
      a = cg(a);
      this.i[a] = dg;
      this.h[a] = b;
      return this;
    };

    p.W = function (a, b) {
      a = cg(a);
      this.i[a] = eg;
      this.h[a] = b;
      return this;
    };

    p.stop = function () {
      this.g = !0;
    };

    p.parse = function (a, b, c) {
      a = new Zf(a, 0);

      for (this.g = !1; a.wa() && !this.g;) this.Cd(0, a, b, c);
    };

    p.Cd = function (a, b, c, d) {
      var e = b.Ea();
      if (d && e + 8 > b.getLength()) this.g = !0;else {
        var f = b.O(),
            g = b.O(),
            h = fg(g),
            k = !1;

        switch (f) {
          case 0:
            f = b.getLength() - e;
            break;

          case 1:
            if (d && b.Ea() + 8 > b.getLength()) {
              this.g = !0;
              return;
            }

            f = b.Rc();
            k = !0;
        }

        var l = this.h[g];

        if (l) {
          var m = null,
              n = null;

          if (this.i[g] == eg) {
            if (d && b.Ea() + 4 > b.getLength()) {
              this.g = !0;
              return;
            }

            n = b.O();
            m = n >>> 24;
            n &= 16777215;
          }

          g = e + f;
          c && g > b.getLength() && (g = b.getLength());
          d && g > b.getLength() ? this.g = !0 : (d = g - b.Ea(), b = 0 < d ? b.Kb(d) : new Uint8Array(0), b = new Zf(b, 0), l({
            name: h,
            parser: this,
            partialOkay: c || !1,
            version: m,
            flags: n,
            reader: b,
            size: f,
            start: e + a,
            has64BitSize: k
          }));
        } else b.skip(Math.min(e + f - b.Ea(), b.getLength() - b.Ea()));
      }
    };

    function gg(a) {
      for (var b = hg(a); a.reader.wa() && !a.parser.g;) a.parser.Cd(a.start + b, a.reader, a.partialOkay);
    }

    function ig(a) {
      for (var b = hg(a), c = a.reader.O(), d = 0; d < c && (a.parser.Cd(a.start + b, a.reader, a.partialOkay), !a.parser.g); d++);
    }

    function jg(a) {
      var b = hg(a);

      for (a.reader.skip(78); a.reader.wa() && !a.parser.g;) a.parser.Cd(a.start + b, a.reader, a.partialOkay);
    }

    function mg(a) {
      return function (b) {
        a(b.reader.Kb(b.reader.getLength() - b.reader.Ea()));
      };
    }

    function cg(a) {
      var b = 0;
      a = t(a);

      for (var c = a.next(); !c.done; c = a.next()) b = b << 8 | c.value.charCodeAt(0);

      return b;
    }

    function fg(a) {
      return String.fromCharCode(a >> 24 & 255, a >> 16 & 255, a >> 8 & 255, a & 255);
    }

    function hg(a) {
      return 8 + (a.has64BitSize ? 8 : 0) + (null != a.flags ? 4 : 0);
    }

    M("shaka.util.Mp4Parser", bg);
    bg.headerSize = hg;
    bg.typeToString = fg;
    bg.allData = mg;
    bg.visualSampleEntry = jg;
    bg.sampleDescription = ig;
    bg.children = gg;
    bg.prototype.parseNext = bg.prototype.Cd;
    bg.prototype.parse = bg.prototype.parse;
    bg.prototype.stop = bg.prototype.stop;
    bg.prototype.fullBox = bg.prototype.W;
    bg.prototype.box = bg.prototype.box;
    var dg = 0,
        eg = 1;

    function ng() {}

    function og(a) {
      a = nc(a);
      a = Vf.value()(a);
      return btoa(a);
    }

    function pg(a, b) {
      b = void 0 == b ? !0 : b;
      a = og(a).replace(/\+/g, "-").replace(/\//g, "_");
      return b ? a : a.replace(/[=]*$/, "");
    }

    function qg(a) {
      a = window.atob(a.replace(/-/g, "+").replace(/_/g, "/"));

      for (var b = new Uint8Array(a.length), c = 0; c < a.length; ++c) b[c] = a.charCodeAt(c);

      return b;
    }

    function rg(a) {
      for (var b = a.length / 2, c = new Uint8Array(b), d = 0; d < b; d++) c[d] = window.parseInt(a.substr(2 * d, 2), 16);

      return c;
    }

    function sg(a) {
      var b = nc(a);
      a = "";
      b = t(b);

      for (var c = b.next(); !c.done; c = b.next()) c = c.value, c = c.toString(16), 1 == c.length && (c = "0" + c), a += c;

      return a;
    }

    function tg() {
      for (var a = Ga.apply(0, arguments), b = 0, c = 0; c < a.length; ++c) b += a[c].byteLength;

      b = new Uint8Array(b);

      for (var d = c = 0; d < a.length; ++d) {
        var e = a[d];
        e instanceof Uint8Array ? b.set(e, c) : b.set(nc(e), c);
        c += e.byteLength;
      }

      return b;
    }

    M("shaka.util.Uint8ArrayUtils", ng);
    ng.concat = tg;
    ng.toHex = sg;
    ng.fromHex = rg;
    ng.fromBase64 = qg;
    ng.toBase64 = pg;
    ng.toStandardBase64 = og;

    function ug(a) {
      var b = this;
      this.g = [];
      this.h = [];
      this.data = [];
      new bg().box("moov", gg).box("moof", gg).W("pssh", function (c) {
        if (!(1 < c.version)) {
          var d = nc(c.reader.h, -12, c.size);
          b.data.push(d);
          b.g.push(sg(c.reader.Kb(16)));

          if (0 < c.version) {
            d = c.reader.O();

            for (var e = 0; e < d; e++) {
              var f = sg(c.reader.Kb(16));
              b.h.push(f);
            }
          }
        }
      }).parse(a);
    }

    function vg(a, b, c, d) {
      var e = a.length,
          f = b.length + 16 + e;
      0 < d && (f += 4 + 16 * c.size);
      var g = new Uint8Array(f),
          h = rc(g),
          k = 0;
      h.setUint32(k, f);
      k += 4;
      h.setUint32(k, 1886614376);
      k += 4;
      1 > d ? h.setUint32(k, 0) : h.setUint32(k, 16777216);
      k += 4;
      g.set(b, k);
      k += b.length;
      if (0 < d) for (h.setUint32(k, c.size), k += 4, b = t(c), c = b.next(); !c.done; c = b.next()) c = rg(c.value), g.set(c, k), k += c.length;
      h.setUint32(k, e);
      g.set(a, k + 4);
      return g;
    }

    ;

    function wg(a, b) {
      a = xg(a, b);
      return 1 != a.length ? null : a[0];
    }

    function yg(a, b, c) {
      a = zg(a, b, c);
      return 1 != a.length ? null : a[0];
    }

    function xg(a, b) {
      var c = [];
      a = t(a.childNodes);

      for (var d = a.next(); !d.done; d = a.next()) d = d.value, d instanceof Element && d.tagName == b && c.push(d);

      return c;
    }

    function Ag(a) {
      return Array.from(a.childNodes).filter(function (b) {
        return b instanceof Element;
      });
    }

    function zg(a, b, c) {
      var d = [];
      a = t(a.childNodes);

      for (var e = a.next(); !e.done; e = a.next()) e = e.value, e instanceof Element && e.localName == c && e.namespaceURI == b && d.push(e);

      return d;
    }

    function Bg(a, b, c) {
      return a.hasAttributeNS(b, c) ? a.getAttributeNS(b, c) : null;
    }

    function Cg(a, b, c) {
      b = t(b);

      for (var d = b.next(); !d.done; d = b.next()) if (d = d.value, a.hasAttributeNS(d, c)) return a.getAttributeNS(d, c);

      return null;
    }

    function Dg(a) {
      return Array.from(a.childNodes).every(Eg) ? a.textContent.trim() : null;
    }

    function Eg(a) {
      return a.nodeType == Node.TEXT_NODE || a.nodeType == Node.CDATA_SECTION_NODE;
    }

    function Fg(a, b, c, d) {
      d = void 0 === d ? null : d;
      var e = null;
      a = a.getAttribute(b);
      null != a && (e = c(a));
      return null == e ? d : e;
    }

    function Gg(a) {
      if (!a) return null;
      /^\d+-\d+-\d+T\d+:\d+:\d+(\.\d+)?$/.test(a) && (a += "Z");
      a = Date.parse(a);
      return isNaN(a) ? null : a / 1E3;
    }

    function Hg(a) {
      if (!a) return null;
      a = RegExp("^P(?:([0-9]*)Y)?(?:([0-9]*)M)?(?:([0-9]*)D)?(?:T(?:([0-9]*)H)?(?:([0-9]*)M)?(?:([0-9.]*)S)?)?$").exec(a);
      if (!a) return null;
      a = 31536E3 * Number(a[1] || null) + 2592E3 * Number(a[2] || null) + 86400 * Number(a[3] || null) + 3600 * Number(a[4] || null) + 60 * Number(a[5] || null) + Number(a[6] || null);
      return isFinite(a) ? a : null;
    }

    function Ig(a) {
      var b = /([0-9]+)-([0-9]+)/.exec(a);
      if (!b) return null;
      a = Number(b[1]);
      if (!isFinite(a)) return null;
      b = Number(b[2]);
      return isFinite(b) ? {
        start: a,
        end: b
      } : null;
    }

    function Jg(a) {
      a = Number(a);
      return 0 === a % 1 ? a : null;
    }

    function Kg(a) {
      a = Number(a);
      return 0 === a % 1 && 0 < a ? a : null;
    }

    function Lg(a) {
      a = Number(a);
      return 0 === a % 1 && 0 <= a ? a : null;
    }

    function Mg(a) {
      a = Number(a);
      return isNaN(a) ? null : a;
    }

    function Ng(a) {
      return a ? "true" === a.toLowerCase() : !1;
    }

    function Og(a) {
      var b;
      var c = (b = a.match(/^(\d+)\/(\d+)$/)) ? Number(b[1]) / Number(b[2]) : Number(a);
      return isNaN(c) ? null : c;
    }

    function Pg(a, b) {
      var c = new DOMParser(),
          d = Qg.value()(a);
      a = null;

      try {
        a = c.parseFromString(d, "text/xml");
      } catch (e) {
        return null;
      }

      c = a.documentElement;
      if (!c || c.getElementsByTagName("parsererror").length || c.tagName != b) return null;
      if (!("createNodeIterator" in document)) return c;

      for (b = document.createNodeIterator(a, NodeFilter.SHOW_ALL); a = b.nextNode();) if (a instanceof HTMLElement || a instanceof SVGElement) return null;

      return c;
    }

    function Rg(a, b) {
      try {
        var c = Wf(a);
        return Pg(c, b);
      } catch (d) {
        return null;
      }
    }

    var Qg = new Of(function () {
      if ("undefined" !== typeof trustedTypes) {
        var a = trustedTypes.createPolicy("shaka-player#xml", {
          createHTML: function (b) {
            return b;
          }
        });
        return function (b) {
          return a.createHTML(b);
        };
      }

      return function (b) {
        return b;
      };
    });

    function Sg(a, b) {
      var c = this;
      b = void 0 === b ? 1 : b;
      this.G = a;
      this.I = new Set();
      this.m = this.u = null;
      this.ha = this.$ = !1;
      this.J = 0;
      this.g = null;
      this.D = new Jf();
      this.i = new Map();
      this.C = new Map();
      this.l = new lf();
      this.h = null;

      this.s = function (d) {
        2 == d.severity && c.l.reject(d);
        a.onError(d);
      };

      this.U = new Map();
      this.aa = new Map();
      this.V = new Fd(function () {
        return Tg(c);
      });
      this.M = !1;
      this.L = [];
      this.N = !1;
      this.za = new Fd(function () {
        Ug(c);
      }).ya(b);
      this.l.catch(function () {});
      this.j = new Hf(function () {
        return Vg(c);
      });
      this.Z = !1;
      this.K = this.H = null;
    }

    p = Sg.prototype;

    p.destroy = function () {
      return this.j.destroy();
    };

    function Vg(a) {
      return K(function (b) {
        switch (b.g) {
          case 1:
            return a.D.release(), a.D = null, a.l.reject(), a.za.stop(), a.za = null, a.V.stop(), a.V = null, D(b, Wg(a), 2);

          case 2:
            if (!a.m) {
              b.F(3);
              break;
            }

            ta(b, 4);
            return D(b, a.m.setMediaKeys(null), 6);

          case 6:
            va(b, 5);
            break;

          case 4:
            wa(b);

          case 5:
            a.m = null;

          case 3:
            a.g = null, a.I.clear(), a.u = null, a.C = new Map(), a.h = null, a.s = function () {}, a.G = null, a.Z = !1, a.H = null, F(b);
        }
      });
    }

    p.configure = function (a) {
      this.h = a;
    };

    function Xg(a, b, c) {
      a.ha = !0;
      a.C = new Map();
      a.M = c;
      return Yg(a, b);
    }

    function Zg(a, b, c) {
      a.C = new Map();
      c = t(c);

      for (var d = c.next(); !d.done; d = c.next()) a.C.set(d.value, {
        initData: null,
        initDataType: null
      });

      c = t(a.h.persistentSessionsMetadata);

      for (d = c.next(); !d.done; d = c.next()) d = d.value, a.C.set(d.sessionId, {
        initData: d.initData,
        initDataType: d.initDataType
      });

      a.M = 0 < a.C.size;
      return Yg(a, b);
    }

    function $g(a, b, c, d, e, f) {
      var g = new Map();
      e = {
        audioCapabilities: e,
        videoCapabilities: f,
        distinctiveIdentifier: "optional",
        persistentState: "required",
        sessionTypes: ["persistent-license"],
        label: b
      };
      e.drmInfos = [{
        keySystem: b,
        licenseServerUri: c,
        distinctiveIdentifierRequired: !1,
        persistentStateRequired: !0,
        audioRobustness: "",
        videoRobustness: "",
        serverCertificate: d,
        serverCertificateUri: "",
        initData: null,
        keyIds: null
      }];
      g.set(b, e);
      return ah(a, g, []);
    }

    function Yg(a, b) {
      var c, d, e, f, g, h, k, l, m, n, r, q, u, v, y, z, x;
      return K(function (B) {
        if (1 == B.g) {
          if (c = bh(a)) for (d = t(b), e = d.next(); !e.done; e = d.next()) f = e.value, f.video && (f.video.drmInfos = [c]), f.audio && (f.audio.drmInfos = [c]);
          g = b.some(function (A) {
            return A.video && A.video.drmInfos.length || A.audio && A.audio.drmInfos.length ? !0 : !1;
          });
          g || (h = Pf(a.h.servers), ch(b, h));
          k = new Set();
          l = t(b);

          for (e = l.next(); !e.done; e = l.next()) for (m = e.value, n = dh(m), r = t(n), q = r.next(); !q.done; q = r.next()) u = q.value, k.add(u);

          v = t(k);

          for (q = v.next(); !q.done; q = v.next()) y = q.value, eh(y, Pf(a.h.servers), Pf(a.h.advanced || {}), a.h.keySystemsMapping);

          return D(B, he(b, a.M, a.Z, a.h.preferredKeySystems), 2);
        }

        z = g || Object.keys(a.h.servers).length;
        if (!z) return a.$ = !0, B.return(Promise.resolve());
        x = ah(a, void 0, b);
        return B.return(g ? x : x.catch(function () {}));
      });
    }

    function fh(a) {
      var b;
      return K(function (c) {
        switch (c.g) {
          case 1:
            if (a.m.mediaKeys) return c.return();

            if (!a.H) {
              c.F(2);
              break;
            }

            return D(c, a.H, 3);

          case 3:
            return If(a.j), c.return();

          case 2:
            return ta(c, 4), a.H = a.m.setMediaKeys(a.u), D(c, a.H, 6);

          case 6:
            va(c, 5);
            break;

          case 4:
            b = wa(c), a.s(new P(2, 6, 6003, b.message));

          case 5:
            If(a.j), F(c);
        }
      });
    }

    function gh(a, b) {
      return K(function (c) {
        if (1 == c.g) return D(c, fh(a), 2);
        hh(a, b.initDataType, nc(b.initData));
        F(c);
      });
    }

    p.Cc = function (a) {
      var b = this;
      return K(function (c) {
        if (1 == c.g) {
          if (!b.u) return b.D.na(a, "encrypted", function () {
            b.s(new P(2, 6, 6010));
          }), c.return();
          b.m = a;
          b.D.na(b.m, "play", function () {
            for (var d = t(b.L), e = d.next(); !e.done; e = d.next()) ih(b, e.value);

            b.N = !0;
            b.L = [];
          });
          "webkitCurrentPlaybackTargetIsWireless" in b.m && b.D.o(b.m, "webkitcurrentplaybacktargetiswirelesschanged", function () {
            return Wg(b);
          });
          b.K = b.g ? b.g.initData.find(function (d) {
            return 0 < d.initData.length;
          }) || null : null;
          return b.K || "com.apple.fps" !== b.g.keySystem || b.C.size ? D(c, fh(b), 2) : c.F(2);
        }

        jh(b).catch(function () {});
        b.K || b.C.size || b.h.parseInbandPsshEnabled || b.D.o(b.m, "encrypted", function (d) {
          return gh(b, d);
        });
        F(c);
      });
    };

    function kh(a) {
      var b, c, d, e, f;
      return K(function (g) {
        switch (g.g) {
          case 1:
            if (!a.u || !a.g) return g.return();

            if (!a.g.serverCertificateUri || a.g.serverCertificate && a.g.serverCertificate.length) {
              g.F(2);
              break;
            }

            b = zf([a.g.serverCertificateUri], a.h.retryParameters);
            ta(g, 3);
            c = a.G.vc.request(5, b);
            return D(g, c.promise, 5);

          case 5:
            d = g.h;
            a.g.serverCertificate = nc(d.data);
            va(g, 4);
            break;

          case 3:
            throw e = wa(g), new P(2, 6, 6017, e);

          case 4:
            if (a.j.g) return g.return();

          case 2:
            if (!a.g.serverCertificate || !a.g.serverCertificate.length) return g.return();
            ta(g, 6);
            return D(g, a.u.setServerCertificate(a.g.serverCertificate), 8);

          case 8:
            va(g, 0);
            break;

          case 6:
            throw f = wa(g), new P(2, 6, 6004, f.message);
        }
      });
    }

    function lh(a, b) {
      var c, d, e;
      return K(function (f) {
        if (1 == f.g) return D(f, mh(a, b, {
          initData: null,
          initDataType: null
        }), 2);

        if (3 != f.g) {
          c = f.h;
          if (!c) return f.return();
          d = [];
          if (e = a.i.get(c)) e.wb = new lf(), d.push(e.wb);
          d.push(c.remove());
          return D(f, Promise.all(d), 3);
        }

        a.i.delete(c);
        F(f);
      });
    }

    function jh(a) {
      var b, c, d, e, f;
      return K(function (g) {
        if (1 == g.g) {
          if (!a.C.size) return g.F(2);
          a.C.forEach(function (h, k) {
            mh(a, k, h);
          });
          return D(g, a.l, 3);
        }

        if (2 != g.g) {
          b = a.g && a.g.keyIds || new Set([]);
          if (0 < b.size && nh(a)) return g.return(a.l);
          a.l = new lf();
          a.l.catch(function () {});
        }

        c = (a.g ? a.g.initData : []) || [];
        d = t(c);

        for (e = d.next(); !e.done; e = d.next()) f = e.value, hh(a, f.initDataType, f.initData);

        c.length || a.l.resolve();
        return g.return(a.l);
      });
    }

    function hh(a, b, c) {
      if (c.length) {
        var d = a.i.values();
        d = t(d);

        for (var e = d.next(); !e.done; e = d.next()) if (lc(c, e.value.initData) && a.h.ignoreDuplicateInitData) return;

        0 < a.i.size && oh(a) && (a.l.resolve(), a.l = new lf(), a.l.catch(function () {}));
        ph(a, b, c, a.g.sessionType);
      }
    }

    function qh(a) {
      return a ? !!a.match(/^com\.(microsoft|chromecast)\.playready/) : !1;
    }

    function rh(a) {
      a = a.i.keys();
      a = eb(a, function (b) {
        return b.sessionId;
      });
      return Array.from(a);
    }

    p.xf = function () {
      var a = this,
          b = this.i.keys();
      b = eb(b, function (c) {
        var d = a.i.get(c);
        return {
          sessionId: c.sessionId,
          sessionType: d.type,
          initData: d.initData,
          initDataType: d.initDataType
        };
      });
      return Array.from(b);
    };

    p.rd = function () {
      var a = Infinity,
          b = this.i.keys();
      b = t(b);

      for (var c = b.next(); !c.done; c = b.next()) c = c.value, isNaN(c.expiration) || (a = Math.min(a, c.expiration));

      return a;
    };

    p.ce = function () {
      return Qf(this.aa);
    };

    function ah(a, b, c) {
      var d, e, f, g, h, k, l, m, n, r, q, u, v, y, z;
      return K(function (x) {
        switch (x.g) {
          case 1:
            d = new Map();

            if (c.length) {
              e = sh(a, c, d);
              x.F(2);
              break;
            }

            return D(x, th(a, b), 3);

          case 3:
            e = x.h;

          case 2:
            f = e;
            if (!f) throw new P(2, 6, 6001);
            If(a.j);
            ta(x, 4);
            a.I.clear();
            g = f.getConfiguration();
            h = g.audioCapabilities || [];
            k = g.videoCapabilities || [];
            l = t(h);

            for (m = l.next(); !m.done; m = l.next()) n = m.value, a.I.add(n.contentType.toLowerCase());

            r = t(k);

            for (m = r.next(); !m.done; m = r.next()) q = m.value, a.I.add(q.contentType.toLowerCase());

            if (c.length) {
              var B = f.keySystem;
              var A = d.get(f.keySystem);
              var C = [],
                  E = [],
                  H = [],
                  G = [],
                  I = new Set();
              uh(A, C, H, E, G, I);
              var J = a.M ? "persistent-license" : "temporary";
              B = {
                keySystem: B,
                licenseServerUri: C[0],
                distinctiveIdentifierRequired: A[0].distinctiveIdentifierRequired,
                persistentStateRequired: A[0].persistentStateRequired,
                sessionType: A[0].sessionType || J,
                audioRobustness: A[0].audioRobustness || "",
                videoRobustness: A[0].videoRobustness || "",
                serverCertificate: H[0],
                serverCertificateUri: E[0],
                initData: G,
                keyIds: I
              };
              A = t(A);

              for (C = A.next(); !C.done; C = A.next()) C = C.value, C.distinctiveIdentifierRequired && (B.distinctiveIdentifierRequired = C.distinctiveIdentifierRequired), C.persistentStateRequired && (B.persistentStateRequired = C.persistentStateRequired);

              A = B;
            } else A = f.keySystem, B = b.get(f.keySystem), C = [], E = [], H = [], G = [], I = new Set(), uh(B.drmInfos, C, H, E, G, I), A = {
              keySystem: A,
              licenseServerUri: C[0],
              distinctiveIdentifierRequired: "required" == B.distinctiveIdentifier,
              persistentStateRequired: "required" == B.persistentState,
              sessionType: B.sessionTypes[0] || "temporary",
              audioRobustness: (B.audioCapabilities ? B.audioCapabilities[0].robustness : "") || "",
              videoRobustness: (B.videoCapabilities ? B.videoCapabilities[0].robustness : "") || "",
              serverCertificate: H[0],
              serverCertificateUri: E[0],
              initData: G,
              keyIds: I
            };

            a.g = A;
            if (!a.g.licenseServerUri) throw new P(2, 6, 6012, a.g.keySystem);
            return D(x, f.createMediaKeys(), 6);

          case 6:
            u = x.h;
            If(a.j);
            a.u = u;

            if (!("" != a.h.minHdcpVersion && "getStatusForPolicy" in a.u)) {
              x.F(7);
              break;
            }

            ta(x, 8);
            return D(x, a.u.getStatusForPolicy({
              minHdcpVersion: a.h.minHdcpVersion
            }), 10);

          case 10:
            v = x.h;
            if ("usable" != v) throw new P(2, 6, 6018);
            If(a.j);
            va(x, 7, 4);
            break;

          case 8:
            y = wa(x, 4);
            if (y instanceof P) throw y;
            throw new P(2, 6, 6019, y.message);

          case 7:
            return a.$ = !0, D(x, kh(a), 11);

          case 11:
            If(a.j);
            va(x, 0);
            break;

          case 4:
            z = wa(x);
            If(a.j, z);
            a.g = null;
            a.I.clear();
            if (z instanceof P) throw z;
            throw new P(2, 6, 6002, z.message);
        }
      });
    }

    function sh(a, b, c) {
      for (var d = t(b), e = d.next(); !e.done; e = d.next()) {
        var f = t(dh(e.value));

        for (e = f.next(); !e.done; e = f.next()) e = e.value, c.has(e.keySystem) || c.set(e.keySystem, []), c.get(e.keySystem).push(e);
      }

      if (1 == c.size && c.has("")) throw new P(2, 6, 6E3);
      d = {};
      a = t(a.h.preferredKeySystems);

      for (e = a.next(); !e.done; d = {
        Pe: d.Pe
      }, e = a.next()) for (d.Pe = e.value, f = t(b), e = f.next(); !e.done; e = f.next()) if (e = e.value.decodingInfos.find(function (l) {
        return function (m) {
          return m.supported && null != m.keySystemAccess && m.keySystemAccess.keySystem == l.Pe;
        };
      }(d))) return e.keySystemAccess;

      a = t([!0, !1]);

      for (e = a.next(); !e.done; e = a.next()) for (d = e.value, f = t(b), e = f.next(); !e.done; e = f.next()) {
        var g = t(e.value.decodingInfos);

        for (e = g.next(); !e.done; e = g.next()) {
          var h = e.value;

          if (h.supported && h.keySystemAccess) {
            e = c.get(h.keySystemAccess.keySystem);
            var k = t(e);

            for (e = k.next(); !e.done; e = k.next()) if (!!e.value.licenseServerUri == d) return h.keySystemAccess;
          }
        }
      }

      return null;
    }

    function th(a, b) {
      var c, d, e, f, g, h, k, l, m, n, r, q, u, v, y;
      return K(function (z) {
        switch (z.g) {
          case 1:
            if (1 == b.size && b.has("")) throw new P(2, 6, 6E3);
            d = t(b.values());

            for (e = d.next(); !e.done; e = d.next()) f = e.value, 0 == f.audioCapabilities.length && delete f.audioCapabilities, 0 == f.videoCapabilities.length && delete f.videoCapabilities;

            g = t(a.h.preferredKeySystems);
            h = g.next();

          case 2:
            if (h.done) {
              z.F(4);
              break;
            }

            k = h.value;

            if (!b.has(k)) {
              z.F(3);
              break;
            }

            l = b.get(k);
            ta(z, 6);
            return D(z, navigator.requestMediaKeySystemAccess(k, [l]), 8);

          case 8:
            return c = z.h, z.return(c);

          case 6:
            wa(z);

          case 7:
            If(a.j);

          case 3:
            h = g.next();
            z.F(2);
            break;

          case 4:
            m = t([!0, !1]), n = m.next();

          case 9:
            if (n.done) {
              z.F(11);
              break;
            }

            r = n.value;
            q = t(b.keys());
            h = q.next();

          case 12:
            if (h.done) {
              n = m.next();
              z.F(9);
              break;
            }

            u = h.value;
            v = b.get(u);
            y = v.drmInfos.some(function (x) {
              return !!x.licenseServerUri;
            });

            if (y != r) {
              z.F(13);
              break;
            }

            ta(z, 15);
            return D(z, navigator.requestMediaKeySystemAccess(u, [v]), 17);

          case 17:
            return c = z.h, z.return(c);

          case 15:
            wa(z);

          case 16:
            If(a.j);

          case 13:
            h = q.next();
            z.F(12);
            break;

          case 11:
            return z.return(c);
        }
      });
    }

    function bh(a) {
      a = Pf(a.h.clearKeys);
      if (0 == a.size) return null;
      var b = [],
          c = [];
      a.forEach(function (e, f) {
        var g = f;
        22 != g.length && (g = pg(rg(f), !1));
        f = e;
        22 != f.length && (f = pg(rg(e), !1));
        e = {
          kty: "oct",
          kid: g,
          k: f
        };
        b.push(e);
        c.push(e.kid);
      });
      a = JSON.stringify({
        keys: b
      });
      var d = JSON.stringify({
        kids: c
      });
      d = [{
        initData: nc(Xf(d)),
        initDataType: "keyids"
      }];
      return {
        keySystem: "org.w3.clearkey",
        licenseServerUri: "data:application/json;base64," + window.btoa(a),
        distinctiveIdentifierRequired: !1,
        persistentStateRequired: !1,
        audioRobustness: "",
        videoRobustness: "",
        serverCertificate: null,
        serverCertificateUri: "",
        sessionType: "",
        initData: d,
        keyIds: new Set(c)
      };
    }

    function vh(a) {
      oh(a) && a.l.resolve();
    }

    function wh(a, b) {
      new Fd(function () {
        b.loaded = !0;
        vh(a);
      }).R(xh);
    }

    function mh(a, b, c) {
      var d, e, f, g, h, k, l;
      return K(function (m) {
        switch (m.g) {
          case 1:
            try {
              d = a.u.createSession("persistent-license");
            } catch (n) {
              return e = new P(2, 6, 6005, n.message), a.s(e), m.return(Promise.reject(e));
            }

            a.D.o(d, "message", function (n) {
              a.m && a.h.delayLicenseRequestUntilPlayed && a.m.paused && !a.N ? a.L.push(n) : ih(a, n);
            });
            a.D.o(d, "keystatuseschange", function (n) {
              return yh(a, n);
            });
            f = {
              initData: c.initData,
              initDataType: c.initDataType,
              loaded: !1,
              Sf: Infinity,
              wb: null,
              type: "persistent-license"
            };
            a.i.set(d, f);
            ta(m, 2);
            return D(m, d.load(b), 4);

          case 4:
            return g = m.h, If(a.j), g || (a.i.delete(d), h = a.h.persistentSessionOnlinePlayback ? 1 : 2, a.s(new P(h, 6, 6013)), f.loaded = !0), wh(a, f), vh(a), m.return(d);

          case 2:
            k = wa(m), If(a.j, k), a.i.delete(d), l = a.h.persistentSessionOnlinePlayback ? 1 : 2, a.s(new P(l, 6, 6005, k.message)), f.loaded = !0, vh(a);

          case 3:
            return m.return(Promise.resolve());
        }
      });
    }

    function ph(a, b, c, d) {
      try {
        var e = a.u.createSession(d);
      } catch (f) {
        a.s(new P(2, 6, 6005, f.message));
        return;
      }

      a.D.o(e, "message", function (f) {
        a.m && a.h.delayLicenseRequestUntilPlayed && a.m.paused && !a.N ? a.L.push(f) : ih(a, f);
      });
      a.D.o(e, "keystatuseschange", function (f) {
        return yh(a, f);
      });
      a.i.set(e, {
        initData: c,
        initDataType: b,
        loaded: !1,
        Sf: Infinity,
        wb: null,
        type: d
      });

      try {
        c = a.h.initDataTransform(c, b, a.g);
      } catch (f) {
        b = f;
        f instanceof P || (b = new P(2, 6, 6016, f));
        a.s(b);
        return;
      }

      a.h.logLicenseExchange && pg(c);
      e.generateRequest(b, c).catch(function (f) {
        if (!a.j.g) {
          a.i.delete(e);
          var g = f.errorCode;

          if (g && g.systemCode) {
            var h = g.systemCode;
            0 > h && (h += Math.pow(2, 32));
            h = "0x" + h.toString(16);
          }

          a.s(new P(2, 6, 6006, f.message, f, h));
        }
      });
    }

    function ih(a, b) {
      var c, d, e, f, g, h, k, l, m, n, r, q, u;
      K(function (v) {
        switch (v.g) {
          case 1:
            c = b.target;
            a.h.logLicenseExchange && pg(b.message);
            d = a.i.get(c);
            e = a.g.licenseServerUri;
            f = a.h.advanced[a.g.keySystem];
            "individualization-request" == b.messageType && f && f.individualizationServer && (e = f.individualizationServer);
            g = zf([e], a.h.retryParameters);
            g.body = b.message;
            g.method = "POST";
            g.licenseRequestType = b.messageType;
            g.sessionId = c.sessionId;
            g.drmInfo = a.g;
            d && (g.initData = d.initData, g.initDataType = d.initDataType);

            if (qh(a.g.keySystem)) {
              var y = Uf(g.body, !0, !0);

              if (y.includes("PlayReadyKeyMessage")) {
                y = Pg(y, "PlayReadyKeyMessage");

                for (var z = t(y.getElementsByTagName("HttpHeader")), x = z.next(); !x.done; x = z.next()) x = x.value, g.headers[x.getElementsByTagName("name")[0].textContent] = x.getElementsByTagName("value")[0].textContent;

                g.body = qg(y.getElementsByTagName("Challenge")[0].textContent);
              } else g.headers["Content-Type"] = "text/xml; charset=utf-8";
            }

            h = Date.now();
            ta(v, 2);
            l = a.G.vc.request(2, g);
            return D(v, l.promise, 4);

          case 4:
            k = v.h;
            va(v, 3);
            break;

          case 2:
            return m = wa(v), n = new P(2, 6, 6007, m), a.s(n), d && d.wb && d.wb.reject(n), v.return();

          case 3:
            if (a.j.g) return v.return();
            a.J += (Date.now() - h) / 1E3;
            a.h.logLicenseExchange && pg(k.data);
            ta(v, 5);
            return D(v, c.update(k.data), 7);

          case 7:
            va(v, 6);
            break;

          case 5:
            return r = wa(v), q = new P(2, 6, 6008, r.message), a.s(q), d && d.wb && d.wb.reject(q), v.return();

          case 6:
            if (a.j.g) return v.return();
            u = new N("drmsessionupdate");
            a.G.onEvent(u);
            d && (d.wb && d.wb.resolve(), wh(a, d));
            F(v);
        }
      });
    }

    function yh(a, b) {
      b = b.target;
      var c = a.i.get(b),
          d = !1;
      b.keyStatuses.forEach(function (f, g) {
        if ("string" == typeof g) {
          var h = g;
          g = f;
          f = h;
        }

        if (qh(a.g.keySystem) && 16 == g.byteLength && (Jd() || Rd())) {
          h = rc(g);
          var k = h.getUint32(0, !0),
              l = h.getUint16(4, !0),
              m = h.getUint16(6, !0);
          h.setUint32(0, k, !1);
          h.setUint16(4, l, !1);
          h.setUint16(6, m, !1);
        }

        "status-pending" != f && (c.loaded = !0);
        "expired" == f && (d = !0);
        g = sg(g).slice(0, 32);
        a.U.set(g, f);
      });
      var e = b.expiration - Date.now();
      (0 > e || d && 1E3 > e) && c && !c.wb && (a.i.delete(b), b.close().catch(function () {}));
      oh(a) && (a.l.resolve(), a.V.R(zh));
    }

    function Tg(a) {
      var b = a.U,
          c = a.aa;
      c.clear();
      b.forEach(function (d, e) {
        return c.set(e, d);
      });
      b = Array.from(c.values());
      b.length && b.every(function (d) {
        return "expired" == d;
      }) && a.s(new P(2, 6, 6014));
      a.G.ze(Qf(c));
    }

    function Ah() {
      var a, b, c, d, e, f, g, h;
      return K(function (k) {
        return 1 == k.g ? (a = "org.w3.clearkey com.widevine.alpha com.microsoft.playready com.microsoft.playready.recommendation com.apple.fps.1_0 com.apple.fps com.adobe.primetime".split(" "), b = [{
          contentType: 'video/mp4; codecs="avc1.42E01E"'
        }, {
          contentType: 'video/webm; codecs="vp8"'
        }], c = {
          initDataTypes: ["cenc"],
          videoCapabilities: b
        }, d = {
          videoCapabilities: b,
          persistentState: "required",
          sessionTypes: ["persistent-license"]
        }, e = [d, c], f = new Map(), g = function (l) {
          var m, n, r;
          return K(function (q) {
            switch (q.g) {
              case 1:
                ta(q, 2);
                if ("org.w3.clearkey" === l && Sd()) throw Error("Unsupported keySystem");
                return D(q, navigator.requestMediaKeySystemAccess(l, e), 4);

              case 4:
                return m = q.h, r = (n = m.getConfiguration().sessionTypes) ? n.includes("persistent-license") : !1, Nd() && (r = !1), f.set(l, {
                  persistentState: r
                }), D(q, m.createMediaKeys(), 5);

              case 5:
                va(q, 0);
                break;

              case 2:
                wa(q), f.set(l, null), F(q);
            }
          });
        }, h = a.map(function (l) {
          return g(l);
        }), D(k, Promise.all(h), 2)) : k.return(Qf(f));
      });
    }

    function Bh(a) {
      var b;
      return K(function (c) {
        if (1 == c.g) return b = new Promise(function (d, e) {
          new Fd(e).R(Ch);
        }), ta(c, 2), D(c, Promise.race([Promise.all([a.close(), a.closed]), b]), 4);
        if (2 != c.g) return va(c, 0);
        wa(c);
        F(c);
      });
    }

    function Wg(a) {
      var b;
      return K(function (c) {
        b = Array.from(a.i.entries());
        a.i.clear();
        return D(c, Promise.all(b.map(function (d) {
          d = t(d);
          var e = d.next().value,
              f = d.next().value;
          return K(function (g) {
            if (1 == g.g) return ta(g, 2), a.ha || a.C.has(e.sessionId) || "persistent-license" !== f.type || a.h.persistentSessionOnlinePlayback ? D(g, Bh(e), 5) : D(g, e.remove(), 5);
            if (2 != g.g) return va(g, 0);
            wa(g);
            F(g);
          });
        })), 0);
      });
    }

    function Dh(a, b) {
      return a.length && b.length && a !== b ? 0 < Eh(a, b).length : !0;
    }

    function Eh(a, b) {
      if (!a.length) return b;
      if (!b.length) return a;
      var c = [];
      a = t(a);

      for (var d = a.next(); !d.done; d = a.next()) {
        d = d.value;

        for (var e = t(b), f = e.next(); !f.done; f = e.next()) if (f = f.value, d.keySystem == f.keySystem) {
          e = new Map();

          for (var g = t((d.initData || []).concat(f.initData || [])), h = g.next(); !h.done; h = g.next()) h = h.value, e.set(h.keyId, h);

          e = Array.from(e.values());
          g = d.keyIds && f.keyIds ? new Set([].concat(w(d.keyIds), w(f.keyIds))) : d.keyIds || f.keyIds;
          c.push({
            keySystem: d.keySystem,
            licenseServerUri: d.licenseServerUri || f.licenseServerUri,
            distinctiveIdentifierRequired: d.distinctiveIdentifierRequired || f.distinctiveIdentifierRequired,
            persistentStateRequired: d.persistentStateRequired || f.persistentStateRequired,
            videoRobustness: d.videoRobustness || f.videoRobustness,
            audioRobustness: d.audioRobustness || f.audioRobustness,
            serverCertificate: d.serverCertificate || f.serverCertificate,
            serverCertificateUri: d.serverCertificateUri || f.serverCertificateUri,
            initData: e,
            keyIds: g
          });
          break;
        }
      }

      return c;
    }

    function dh(a) {
      return (a.video ? a.video.drmInfos : []).concat(a.audio ? a.audio.drmInfos : []);
    }

    function Ug(a) {
      a.i.forEach(function (b, c) {
        var d = b.Sf,
            e = c.expiration;
        isNaN(e) && (e = Infinity);
        e != d && (a.G.onExpirationUpdated(c.sessionId, e), b.Sf = e);
      });
    }

    function oh(a) {
      a = a.i.values();
      return fb(a, function (b) {
        return b.loaded;
      });
    }

    function nh(a) {
      for (var b = t(a.g && a.g.keyIds || new Set([])), c = b.next(); !c.done; c = b.next()) if ("usable" !== a.U.get(c.value)) return !1;

      return !0;
    }

    function ch(a, b) {
      var c = [];
      b.forEach(function (d, e) {
        c.push({
          keySystem: e,
          licenseServerUri: d,
          distinctiveIdentifierRequired: !1,
          persistentStateRequired: !1,
          audioRobustness: "",
          videoRobustness: "",
          serverCertificate: null,
          serverCertificateUri: "",
          initData: [],
          keyIds: new Set()
        });
      });
      a = t(a);

      for (b = a.next(); !b.done; b = a.next()) b = b.value, b.video && (b.video.drmInfos = c), b.audio && (b.audio.drmInfos = c);
    }

    function uh(a, b, c, d, e, f) {
      var g = {};
      a = t(a);

      for (var h = a.next(); !h.done; g = {
        Sa: g.Sa
      }, h = a.next()) {
        g.Sa = h.value;
        b.includes(g.Sa.licenseServerUri) || b.push(g.Sa.licenseServerUri);
        d.includes(g.Sa.serverCertificateUri) || d.push(g.Sa.serverCertificateUri);
        g.Sa.serverCertificate && (c.some(function (m) {
          return function (n) {
            return lc(n, m.Sa.serverCertificate);
          };
        }(g)) || c.push(g.Sa.serverCertificate));

        if (g.Sa.initData) {
          h = {};

          for (var k = t(g.Sa.initData), l = k.next(); !l.done; h = {
            Od: h.Od
          }, l = k.next()) h.Od = l.value, e.some(function (m) {
            return function (n) {
              var r = m.Od;
              return n.keyId && n.keyId == r.keyId ? !0 : n.initDataType == r.initDataType && lc(n.initData, r.initData);
            };
          }(h)) || e.push(h.Od);
        }

        if (g.Sa.keyIds) for (h = t(g.Sa.keyIds), k = h.next(); !k.done; k = h.next()) f.add(k.value);
      }
    }

    function eh(a, b, c, d) {
      var e = a.keySystem;

      if (e && ("org.w3.clearkey" != e || !a.licenseServerUri)) {
        b.size && (b = b.get(e) || "", a.licenseServerUri = b);
        a.keyIds || (a.keyIds = new Set());
        if (c = c.get(e)) a.distinctiveIdentifierRequired || (a.distinctiveIdentifierRequired = c.distinctiveIdentifierRequired), a.persistentStateRequired || (a.persistentStateRequired = c.persistentStateRequired), a.videoRobustness || (a.videoRobustness = c.videoRobustness), a.audioRobustness || (a.audioRobustness = c.audioRobustness), a.serverCertificate || (a.serverCertificate = c.serverCertificate), c.sessionType && (a.sessionType = c.sessionType), a.serverCertificateUri || (a.serverCertificateUri = c.serverCertificateUri);
        d[e] && (a.keySystem = d[e]);
        window.cast && window.cast.__platform__ && "com.microsoft.playready" == e && (a.keySystem = "com.chromecast.playready");
      }
    }

    var Ch = 1,
        xh = 5,
        zh = .5,
        Fh = new Of(function () {
      return oc(new Uint8Array([0]));
    });

    function Gh() {}

    function Hh(a, b) {
      if (b && (b = Ih[b.toLowerCase()])) return b;
      throw new P(2, 4, 4E3, a);
    }

    M("shaka.media.ManifestParser", Gh);

    Gh.unregisterParserByMime = function (a) {
      delete Ih[a];
    };

    Gh.registerParserByMime = function (a, b) {
      Ih[a] = b;
    };

    Gh.registerParserByExtension = function () {
      Le("ManifestParser", "Please use an ManifestParser with registerParserByMime function.");
    };

    Gh.AccessibilityPurpose = {
      ek: "visually impaired",
      Aj: "hard of hearing"
    };
    var Ih = {};

    function Jh(a) {
      function b() {
        d = !0;
      }

      function c(l) {
        f.push(l);
        gg(l);
      }

      a = nc(a);
      var d = !1,
          e,
          f = [],
          g = [];
      new bg().box("moov", c).box("trak", c).box("mdia", c).box("minf", c).box("stbl", c).W("stsd", function (l) {
        e = l;
        f.push(l);
        ig(l);
      }).W("encv", b).W("enca", b).W("hev1", function (l) {
        g.push({
          box: l,
          $b: 1701733238
        });
      }).W("hvc1", function (l) {
        g.push({
          box: l,
          $b: 1701733238
        });
      }).W("avc1", function (l) {
        g.push({
          box: l,
          $b: 1701733238
        });
      }).W("avc3", function (l) {
        g.push({
          box: l,
          $b: 1701733238
        });
      }).W("ac-3", function (l) {
        g.push({
          box: l,
          $b: 1701733217
        });
      }).W("ec-3", function (l) {
        g.push({
          box: l,
          $b: 1701733217
        });
      }).W("ac-4", function (l) {
        g.push({
          box: l,
          $b: 1701733217
        });
      }).W("mp4a", function (l) {
        g.push({
          box: l,
          $b: 1701733217
        });
      }).parse(a);
      if (d) return a;
      if (0 == g.length || !e) throw ab(sg(a)), new P(2, 3, 3019);
      g.reverse();

      for (var h = t(g), k = h.next(); !k.done; k = h.next()) k = k.value, a = Kh(a, e, k.box, f, k.$b);

      return a;
    }

    function Kh(a, b, c, d, e) {
      var f = Lh.value(),
          g = a.subarray(c.start, c.start + c.size),
          h = rc(g),
          k = new Uint8Array(c.size + f.byteLength);
      k.set(g, 0);
      g = rc(k);
      g.setUint32(4, e);
      k.set(f, c.size);
      e = h.getUint32(4);
      g.setUint32(c.size + 16, e);
      Mh(k, 0, k.byteLength);
      e = new Uint8Array(a.byteLength + k.byteLength);
      c = Kd() ? c.start : c.start + c.size;
      f = a.subarray(c);
      e.set(a.subarray(0, c));
      e.set(k, c);
      e.set(f, c + k.byteLength);
      a = t(d);

      for (d = a.next(); !d.done; d = a.next()) d = d.value, Mh(e, d.start, d.size + k.byteLength);

      k = rc(e, b.start);
      b = hg(b);
      a = k.getUint32(b);
      k.setUint32(b, a + 1);
      return e;
    }

    function Mh(a, b, c) {
      a = rc(a, b);
      b = a.getUint32(0);
      0 != b && (1 == b ? (a.setUint32(8, c >> 32), a.setUint32(12, c & 4294967295)) : a.setUint32(0, c));
    }

    var Lh = new Of(function () {
      return new Uint8Array([0, 0, 0, 80, 115, 105, 110, 102, 0, 0, 0, 12, 102, 114, 109, 97, 0, 0, 0, 0, 0, 0, 0, 20, 115, 99, 104, 109, 0, 0, 0, 0, 99, 101, 110, 99, 0, 1, 0, 0, 0, 0, 0, 40, 115, 99, 104, 105, 0, 0, 0, 32, 116, 101, 110, 99, 0, 0, 0, 0, 0, 0, 1, 8, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
    });

    function Nh(a, b, c, d, e, f, g) {
      this.ba = a;
      this.cb = b;
      this.Ja = c;
      this.Of = void 0 === d ? null : d;
      this.timescale = void 0 === e ? null : e;
      this.g = void 0 === f ? null : f;
      this.aes128Key = void 0 === g ? null : g;
      this.mimeType = this.codecs = null;
    }

    Nh.prototype.Wb = function () {
      return this.cb;
    };

    Nh.prototype.Sb = function () {
      return this.Ja;
    };

    function Oh(a, b) {
      return a && b ? a.Wb() == b.Wb() && a.Sb() == b.Sb() && zc(a.ba().sort(), b.ba().sort()) && lc(a.g, b.g) : a == b;
    }

    M("shaka.media.InitSegmentReference", Nh);
    Nh.prototype.getEndByte = Nh.prototype.Sb;
    Nh.prototype.getStartByte = Nh.prototype.Wb;

    function Ph(a, b, c, d, e, f, g, h, k, l, m, n, r, q, u, v) {
      l = void 0 === l ? [] : l;
      q = void 0 === q ? Qh : q;
      this.startTime = a;
      this.i = this.endTime = b;
      this.I = c;
      this.cb = d;
      this.Ja = e;
      this.ka = f;
      this.timestampOffset = g;
      this.appendWindowStart = h;
      this.appendWindowEnd = k;
      this.g = l;
      this.tilesLayout = void 0 === m ? "" : m;
      this.H = void 0 === n ? null : n;
      this.h = void 0 === r ? null : r;
      this.status = q;
      this.m = !1;
      this.l = !0;
      this.s = !1;
      this.aes128Key = void 0 === u ? null : u;
      this.G = null;
      this.j = 0;
      this.u = void 0 === v ? !1 : v;
      this.C = this.D = !1;
      a = t(this.g);

      for (b = a.next(); !b.done; b = a.next()) b.value.Wg();

      this.u && this.g.length && this.g[this.g.length - 1].Vg();
      this.mimeType = this.codecs = null;
    }

    p = Ph.prototype;

    p.ba = function () {
      return this.I();
    };

    p.getStartTime = function () {
      return this.startTime;
    };

    p.Vh = function () {
      return this.endTime;
    };

    p.Wb = function () {
      return this.cb;
    };

    p.Sb = function () {
      return this.Ja;
    };

    p.oi = function () {
      return this.tilesLayout;
    };

    p.ni = function () {
      return this.H;
    };

    p.nc = function () {
      return this.status;
    };

    p.Ji = function () {
      this.status = Rh;
    };

    p.Nf = function () {
      this.m = !0;
    };

    p.Ei = function () {
      return this.m;
    };

    p.qe = function () {
      this.l = !1;
    };

    p.Bi = function () {
      return this.l;
    };

    p.Wg = function () {
      this.D = !0;
    };

    p.Di = function () {
      return this.D;
    };

    p.Vg = function () {
      this.C = !0;
    };

    p.Ci = function () {
      return this.C;
    };

    p.Ug = function () {
      this.s = !0;
    };

    p.xi = function () {
      return this.s;
    };

    p.lh = function (a) {
      this.G = a;
    };

    p.mi = function () {
      return this.G;
    };

    p.offset = function (a) {
      this.startTime += a;
      this.endTime += a;
      this.i += a;

      for (var b = t(this.g), c = b.next(); !c.done; c = b.next()) c = c.value, c.startTime += a, c.endTime += a, c.i += a;
    };

    p.ng = function (a) {
      null == this.h ? Ta("Sync attempted without sync time!") : (a = this.h - a - this.startTime, .001 <= Math.abs(a) && this.offset(a));
    };

    M("shaka.media.SegmentReference", Ph);
    Ph.prototype.syncAgainst = Ph.prototype.ng;
    Ph.prototype.offset = Ph.prototype.offset;
    Ph.prototype.getThumbnailSprite = Ph.prototype.mi;
    Ph.prototype.setThumbnailSprite = Ph.prototype.lh;
    Ph.prototype.hasByterangeOptimization = Ph.prototype.xi;
    Ph.prototype.markAsByterangeOptimization = Ph.prototype.Ug;
    Ph.prototype.isLastPartial = Ph.prototype.Ci;
    Ph.prototype.markAsLastPartial = Ph.prototype.Vg;
    Ph.prototype.isPartial = Ph.prototype.Di;
    Ph.prototype.markAsPartial = Ph.prototype.Wg;
    Ph.prototype.isIndependent = Ph.prototype.Bi;
    Ph.prototype.markAsNonIndependent = Ph.prototype.qe;
    Ph.prototype.isPreload = Ph.prototype.Ei;
    Ph.prototype.markAsPreload = Ph.prototype.Nf;
    Ph.prototype.markAsUnavailable = Ph.prototype.Ji;
    Ph.prototype.getStatus = Ph.prototype.nc;
    Ph.prototype.getTileDuration = Ph.prototype.ni;
    Ph.prototype.getTilesLayout = Ph.prototype.oi;
    Ph.prototype.getEndByte = Ph.prototype.Sb;
    Ph.prototype.getStartByte = Ph.prototype.Wb;
    Ph.prototype.getEndTime = Ph.prototype.Vh;
    Ph.prototype.getStartTime = Ph.prototype.getStartTime;
    Ph.prototype.getUris = Ph.prototype.ba;
    var Qh = 0,
        Rh = 1;
    Ph.Status = {
      nj: Qh,
      ck: Rh,
      Gj: 2
    };

    function Sh(a) {
      return !a || 1 == a.length && 1E-6 > a.end(0) - a.start(0) ? null : a.length ? a.end(a.length - 1) : null;
    }

    function Th(a, b) {
      return !a || !a.length || 1 == a.length && 1E-6 > a.end(0) - a.start(0) || b > a.end(a.length - 1) ? !1 : b >= a.start(0);
    }

    function Uh(a, b) {
      if (!a || !a.length || 1 == a.length && 1E-6 > a.end(0) - a.start(0)) return 0;
      var c = 0;
      a = t(Vh(a));

      for (var d = a.next(); !d.done; d = a.next()) {
        var e = d.value;
        d = e.start;
        e = e.end;
        e > b && (c += e - Math.max(d, b));
      }

      return c;
    }

    function Wh(a, b, c) {
      if (!a || !a.length || 1 == a.length && 1E-6 > a.end(0) - a.start(0)) return null;
      a = Vh(a).findIndex(function (d, e, f) {
        return d.start > b && (0 == e || f[e - 1].end - b <= c);
      });
      return 0 <= a ? a : null;
    }

    function Vh(a) {
      if (!a) return [];

      for (var b = [], c = 0; c < a.length; c++) b.push({
        start: a.start(c),
        end: a.end(c)
      });

      return b;
    }

    ;
    /*
    @license
    Shaka Player
    Copyright 2022 Google LLC
    SPDX-License-Identifier: Apache-2.0
    */

    function Xh() {}

    function Yh(a, b) {
      return b + 10 <= a.length && 73 === a[b] && 68 === a[b + 1] && 51 === a[b + 2] && 255 > a[b + 3] && 255 > a[b + 4] && 128 > a[b + 6] && 128 > a[b + 7] && 128 > a[b + 8] && 128 > a[b + 9] ? !0 : !1;
    }

    function Zh(a, b) {
      return b + 10 <= a.length && 51 === a[b] && 68 === a[b + 1] && 73 === a[b + 2] && 255 > a[b + 3] && 255 > a[b + 4] && 128 > a[b + 6] && 128 > a[b + 7] && 128 > a[b + 8] && 128 > a[b + 9] ? !0 : !1;
    }

    function $h(a, b) {
      var c = (a[b] & 127) << 21;
      c |= (a[b + 1] & 127) << 14;
      c |= (a[b + 2] & 127) << 7;
      return c |= a[b + 3] & 127;
    }

    function ai(a) {
      var b = {
        key: a.type,
        description: "",
        data: "",
        mimeType: null,
        pictureType: null
      };

      if ("APIC" === a.type) {
        if (2 > a.size || 3 !== a.data[0]) return null;
        var c = a.data.subarray(1).indexOf(0);
        if (-1 === c) return null;
        var d = Tf(nc(a.data, 1, c)),
            e = a.data[2 + c],
            f = a.data.subarray(3 + c).indexOf(0);
        if (-1 === f) return null;
        var g = Tf(nc(a.data, 3 + c, f)),
            h;
        "--\x3e" === d ? h = Tf(nc(a.data, 4 + c + f)) : h = oc(a.data.subarray(4 + c + f));
        b.mimeType = d;
        b.pictureType = e;
        b.description = g;
        b.data = h;
        return b;
      }

      if ("TXXX" === a.type) {
        if (2 > a.size || 3 !== a.data[0]) return null;
        d = a.data.subarray(1).indexOf(0);
        if (-1 === d) return null;
        c = Tf(nc(a.data, 1, d));
        a = Tf(nc(a.data, 2 + d)).replace(/\0*$/, "");
        b.description = c;
        b.data = a;
        return b;
      }

      if ("WXXX" === a.type) {
        if (2 > a.size || 3 !== a.data[0]) return null;
        d = a.data.subarray(1).indexOf(0);
        if (-1 === d) return null;
        c = Tf(nc(a.data, 1, d));
        a = Tf(nc(a.data, 2 + d)).replace(/\0*$/, "");
        b.description = c;
        b.data = a;
        return b;
      }

      if ("PRIV" === a.type) {
        if (2 > a.size) return null;
        c = a.data.indexOf(0);
        if (-1 === c) return null;
        c = Tf(nc(a.data, 0, c));
        b.description = c;
        "com.apple.streaming.transportStreamTimestamp" == c ? (c = a.data.subarray(c.length + 1), a = c[3] & 1, c = (c[4] << 23) + (c[5] << 15) + (c[6] << 7) + c[7], c /= 45, a && (c += 4.772185884E7), b.data = c) : (a = oc(a.data.subarray(c.length + 1)), b.data = a);
        return b;
      }

      if ("T" === a.type[0]) {
        if (2 > a.size || 3 !== a.data[0]) return null;
        a = Tf(a.data.subarray(1)).replace(/\0*$/, "");
        b.data = a;
        return b;
      }

      return "W" === a.type[0] ? (a = Tf(a.data).replace(/\0*$/, ""), b.data = a, b) : a.data ? (b.data = oc(a.data), b) : null;
    }

    function bi(a) {
      for (var b = 0, c = []; Yh(a, b);) {
        var d = $h(a, b + 6);
        a[b + 5] >> 6 & 1 && (b += 10);
        b += 10;

        for (d = b + d; b + 10 < d;) {
          var e = a.subarray(b),
              f = $h(e, 4);
          e = {
            type: String.fromCharCode(e[0], e[1], e[2], e[3]),
            size: f,
            data: e.subarray(10, 10 + f)
          };
          (f = ai(e)) && c.push(f);
          b += e.size + 10;
        }

        Zh(a, b) && (b += 10);
      }

      return c;
    }

    function ci(a, b) {
      for (var c = b = void 0 === b ? 0 : b, d = 0; Yh(a, b);) a[b + 5] >> 6 & 1 && (d += 10), d += 10, d += $h(a, b + 6), Zh(a, b + 10) && (d += 10), b += d;

      return 0 < d ? a.subarray(c, c + d) : new Uint8Array([]);
    }

    M("shaka.util.Id3Utils", Xh);
    Xh.getID3Data = ci;
    Xh.getID3Frames = bi;

    function di(a, b) {
      var c = null,
          d = null,
          e = null,
          f = a.O();
      b & 1 && (e = a.Rc());
      b & 2 && a.skip(4);
      b & 8 && (c = a.O());
      b & 16 && (d = a.O());
      return {
        trackId: f,
        Hg: c,
        Ih: d,
        gk: e
      };
    }

    function ei(a, b) {
      return 1 == b ? (b = a.O(), a = a.O(), {
        baseMediaDecodeTime: b * Math.pow(2, 32) + a
      }) : {
        baseMediaDecodeTime: a.O()
      };
    }

    function fi(a, b) {
      1 == b ? (a.skip(8), a.skip(8)) : (a.skip(4), a.skip(4));
      b = a.O();
      a.skip(4);
      a = a.Ra();
      return {
        timescale: b,
        language: String.fromCharCode((a >> 10) + 96) + String.fromCharCode(((a & 960) >> 5) + 96) + String.fromCharCode((a & 31) + 96)
      };
    }

    function gi(a, b, c) {
      var d = a.O(),
          e = [],
          f = null;
      c & 1 && (f = a.O());
      c & 4 && a.skip(4);

      for (var g = 0; g < d; g++) {
        var h = {
          cg: null,
          sampleSize: null,
          Ce: null
        };
        c & 256 && (h.cg = a.O());
        c & 512 && (h.sampleSize = a.O());
        c & 1024 && a.skip(4);
        c & 2048 && (h.Ce = 0 == b ? a.O() : a.$g());
        e.push(h);
      }

      return {
        kk: d,
        dh: e,
        Hh: f
      };
    }

    function ii(a, b) {
      1 == b ? (a.skip(8), a.skip(8)) : (a.skip(4), a.skip(4));
      var c = a.O();
      1 == b ? a.skip(8) : a.skip(4);
      a.skip(4);
      a.skip(8);
      a.skip(2);
      a.skip(2);
      a.skip(2);
      a.skip(2);
      a.skip(36);
      b = a.Ra() + a.Ra() / 16;
      a = a.Ra() + a.Ra() / 16;
      return {
        trackId: c,
        width: b,
        height: a
      };
    }

    function ji(a) {
      for (var b = "mp4a", c, d; a.wa();) {
        c = a.qa();

        for (var e = a.qa(); e & 128;) e = a.qa();

        if (3 == c) a.Ra(), e = a.qa(), e & 128 && a.Ra(), e & 64 && a.skip(a.qa()), e & 32 && a.Ra();else if (4 == c) d = a.qa(), a.skip(12);else if (5 == c) break;
      }

      d && (b += "." + this.g(d), 5 == c && a.wa() && (c = a.qa(), d = (c & 248) >> 3, 31 === d && a.wa() && (d = 32 + ((c & 7) << 3) + ((a.qa() & 224) >> 5)), b += "." + d));
      return {
        va: b
      };
    }

    function ki(a, b) {
      a.skip(87);
      return {
        va: b + "." + this.g(a.qa()) + this.g(a.qa()) + this.g(a.qa())
      };
    }

    function li(a) {
      a = a.O();
      return {
        va: fg(a)
      };
    }

    ;
    /*
    Copyright Brightcove, Inc.
    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at
    http://www.apache.org/licenses/LICENSE-2.0
    Unless required by applicable law or agreed to in writing, software
    distributed under the License is distributed on an "AS IS" BASIS,
    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    See the License for the specific language governing permissions and
    limitations under the License.
    */

    function mi(a, b) {
      this.j = a;

      if (void 0 === b ? 0 : b) {
        b = new Uint8Array(a.byteLength);

        for (var c = 0, d = 0; d < a.byteLength; d++) 2 <= d && 3 == a[d] && 0 == a[d - 1] && 0 == a[d - 2] || (b[c] = a[d], c++);

        this.j = nc(b, 0, c);
      }

      this.i = this.j.byteLength;
      this.g = this.h = 0;
    }

    function ni(a) {
      var b = a.j.byteLength - a.i,
          c = new Uint8Array(4),
          d = Math.min(4, a.i);
      0 !== d && (c.set(a.j.subarray(b, b + d)), a.h = new Zf(c, 0).O(), a.g = 8 * d, a.i -= d);
    }

    function oi(a, b) {
      if (a.g <= b) {
        b -= a.g;
        var c = Math.floor(b / 8);
        b -= 8 * c;
        a.g -= c;
        ni(a);
      }

      a.h <<= b;
      a.g -= b;
    }

    function pi(a, b) {
      var c = Math.min(a.g, b),
          d = a.h >>> 32 - c;
      a.g -= c;
      0 < a.g ? a.h <<= c : 0 < a.i && ni(a);
      c = b - c;
      return 0 < c ? d << c | pi(a, c) : d;
    }

    function qi(a) {
      var b;

      for (b = 0; b < a.g; ++b) if (0 !== (a.h & 2147483648 >>> b)) return a.h <<= b, a.g -= b, b;

      ni(a);
      return b + qi(a);
    }

    function ri(a) {
      oi(a, 1 + qi(a));
    }

    function R(a) {
      var b = qi(a);
      return pi(a, b + 1) - 1;
    }

    function si(a) {
      a = R(a);
      return 1 & a ? 1 + a >>> 1 : -1 * (a >>> 1);
    }

    function S(a) {
      return 1 === pi(a, 1);
    }

    function ti(a) {
      return pi(a, 8);
    }

    function ui(a, b) {
      for (var c = 8, d = 8, e = 0; e < b; e++) 0 !== d && (d = si(a), d = (c + d + 256) % 256), c = 0 === d ? c : d;
    }

    function vi(a) {
      ti(a);
      R(a);
      return R(a);
    }

    M("shaka.util.ExpGolomb", mi);

    function wi() {
      this.D = null;
      this.G = !1;
      this.m = this.H = null;
      this.j = [];
      this.g = [];
      this.s = this.u = null;
      this.i = [];
      this.h = [];
      this.C = null;
      this.l = [];
    }

    p = wi.prototype;

    p.clearData = function () {
      this.j = [];
      this.g = [];
      this.i = [];
      this.h = [];
      this.l = [];
    };

    p.parse = function (a) {
      if (564 > a.length) return this;

      for (var b = Math.max(0, xi(a)), c = a.length - (a.length + b) % 188, d = !1, e = b; e < c; e += 188) if (71 == a[e]) {
        var f = !!(a[e + 1] & 64),
            g = ((a[e + 1] & 31) << 8) + a[e + 2];

        if (1 < (a[e + 3] & 48) >> 4) {
          var h = e + 5 + a[e + 4];
          if (h == e + 188) continue;
        } else h = e + 4;

        switch (g) {
          case 0:
            f && (h += a[h] + 1);
            this.D = (a[h + 10] & 31) << 8 | a[h + 11];
            break;

          case 17:
          case 8191:
            break;

          case this.D:
            f && (h += a[h] + 1);
            f = a;
            g = {
              audio: -1,
              video: -1,
              le: -1,
              audioCodec: "",
              videoCodec: ""
            };
            var k = h + 3 + ((f[h + 1] & 15) << 8 | f[h + 2]) - 4;

            for (h += 12 + ((f[h + 10] & 15) << 8 | f[h + 11]); h < k;) {
              var l = (f[h + 1] & 31) << 8 | f[h + 2],
                  m = (f[h + 3] & 15) << 8 | f[h + 4];

              switch (f[h]) {
                case 6:
                  if (-1 == g.audio && 0 < m) for (var n = h + 5, r = m; 2 < r;) {
                    switch (f[n]) {
                      case 106:
                        g.audio = l;
                        g.audioCodec = "ac3";
                        break;

                      case 122:
                        g.audio = l, g.audioCodec = "ec3";
                    }

                    var q = f[n + 1] + 2;
                    n += q;
                    r -= q;
                  }
                  break;

                case 15:
                  -1 == g.audio && (g.audio = l, g.audioCodec = "aac");
                  break;

                case 21:
                  -1 == g.le && (g.le = l);
                  break;

                case 27:
                  -1 == g.video && (g.video = l, g.videoCodec = "avc");
                  break;

                case 3:
                case 4:
                  -1 == g.audio && (g.audio = l, g.audioCodec = "mp3");
                  break;

                case 36:
                  -1 == g.video && (g.video = l, g.videoCodec = "hvc");
                  break;

                case 129:
                  -1 == g.audio && (g.audio = l, g.audioCodec = "ac3");
                  break;

                case 132:
                case 135:
                  -1 == g.audio && (g.audio = l, g.audioCodec = "ec3");
              }

              h += m + 5;
            }

            f = g;
            -1 != f.video && (this.H = f.video, this.m = f.videoCodec);
            -1 != f.audio && (this.u = f.audio, this.s = f.audioCodec);
            -1 != f.le && (this.C = f.le);
            d && !this.G && (d = !1, e = b - 188);
            this.G = !0;
            break;

          case this.H:
            h = a.subarray(h, e + 188);
            f ? this.j.push([h]) : this.j.length && this.j[this.j.length - 1] && this.j[this.j.length - 1].push(h);
            break;

          case this.u:
            h = a.subarray(h, e + 188);
            f ? this.i.push([h]) : this.i.length && this.i[this.i.length - 1] && this.i[this.i.length - 1].push(h);
            break;

          case this.C:
            h = a.subarray(h, e + 188);
            f ? this.l.push([h]) : this.l.length && this.l[this.l.length - 1] && this.l[this.l.length - 1].push(h);
            break;

          default:
            d = !0;
        }
      }

      return this;
    };

    function yi(a) {
      if (1 !== (a[0] << 16 | a[1] << 8 | a[2])) return null;
      var b = {
        data: new Uint8Array(0),
        packetLength: a[4] << 8 | a[5],
        pts: null,
        dts: null,
        nalus: []
      };
      if (b.packetLength && b.packetLength > a.byteLength - 6) return null;
      var c = a[7];
      c & 192 && (b.pts = 536870912 * (a[9] & 14) + 4194304 * (a[10] & 255) + 16384 * (a[11] & 254) + 128 * (a[12] & 255) + (a[13] & 254) / 2, b.dts = b.pts, c & 64 && (b.dts = 536870912 * (a[14] & 14) + 4194304 * (a[15] & 255) + 16384 * (a[16] & 254) + 128 * (a[17] & 255) + (a[18] & 254) / 2));
      c = a[8] + 9;
      if (a.byteLength <= c) return null;
      b.data = a.subarray(c);
      return b;
    }

    p.Pi = function (a) {
      Le("TsParser", "Please use parseNalus function instead.");
      return this.Vf(a);
    };

    p.Vf = function (a, b) {
      var c = a.pts ? a.pts / 9E4 : null;
      a = a.data;
      var d = a.byteLength,
          e = 1;
      "hvc" == this.m && (e = 2);

      for (var f = 0, g = [], h = -1, k = 0, l, m = 0; m < d; ++m) {
        var n = a[m];

        if (n) {
          if (2 <= f && 1 == n) {
            b && !g.length && -1 == h && (n = m - (3 < f ? 3 : f), 0 != n && (n = a.subarray(0, n), b.data = tg(b.data, n), b.fullData = tg(b.fullData, n)));
            0 <= h ? (f = m - ((3 < f ? 3 : f) + 1), g.push({
              data: a.subarray(h + e, f + 1),
              fullData: a.subarray(h, f + 1),
              type: k,
              time: c
            })) : b && !g.length && (h = m - f, 0 < h && (h = a.subarray(0, h), b.data = tg(b.data, h), b.fullData = tg(b.fullData, h)));
            if (m >= d - e) return g;
            m++;
            h = m;
            k = "hvc" == this.m ? a[m] >> 1 & 63 : a[m] & 31;
          }

          f = 0;
        } else f++;

        m >= d - 1 && 0 <= h && 0 <= f && (l = {
          data: a.subarray(h + e, d),
          fullData: a.subarray(h, d),
          type: k,
          time: c
        });
      }

      l && g.push(l);
      !g.length && b && (b.data = tg(b.data, a), b.fullData = tg(b.fullData, a));
      return g;
    };

    p.getMetadata = function () {
      for (var a = [], b = t(this.l), c = b.next(); !c.done; c = b.next()) c = tg.apply(ng, w(c.value)), (c = yi(c)) && a.push({
        cueTime: c.pts ? c.pts / 9E4 : null,
        data: c.data,
        frames: bi(c.data),
        dts: c.dts,
        pts: c.pts
      });

      return a;
    };

    p.kc = function () {
      if (this.i.length && !this.h.length) {
        for (var a = !1, b = t(this.i), c = b.next(); !c.done; c = b.next()) {
          var d = tg.apply(ng, w(c.value)),
              e = yi(d);
          c = this.h.length ? this.h[this.h.length - 1] : null;
          e && null != e.pts && null != e.dts && (!c || c.pts != e.pts && c.dts != e.dts) ? (this.h.length && e.dts < (c.dts || 0) && (a = !0), this.h.push(e)) : this.h.length && (d = e ? e.data : d) && (c = this.h.pop(), c.data = tg(c.data, d), this.h.push(c));
        }

        a && (this.h = this.h.sort(function (f, g) {
          var h = (f.pts || 0) - (g.pts || 0);
          return (f.dts || 0) - (g.dts || 0) || h;
        }));
      }

      return this.h;
    };

    p.Jc = function (a) {
      a = void 0 === a ? !0 : a;

      if (this.j.length && !this.g.length) {
        for (var b = !1, c = t(this.j), d = c.next(); !d.done; d = c.next()) {
          var e = tg.apply(ng, w(d.value)),
              f = yi(e);
          d = this.g.length ? this.g[this.g.length - 1] : null;
          f && null != f.pts && null != f.dts && (!d || d.pts != f.pts && d.dts != f.dts) ? (this.g.length && f.dts < (d.dts || 0) && (b = !0), this.g.push(f)) : this.g.length && (e = f ? f.data : e) && (d = this.g.pop(), d.data = tg(d.data, e), this.g.push(d));
        }

        if (a) {
          var g;
          c = t(this.g);

          for (d = c.next(); !d.done; d = c.next()) d = d.value, d.nalus = this.Vf(d, g), d.nalus.length && (g = d.nalus[d.nalus.length - 1]);

          this.g = this.g.filter(function (h) {
            return h.nalus.length;
          });
        }

        b && (this.g = this.g.sort(function (h, k) {
          var l = (h.pts || 0) - (k.pts || 0);
          return (h.dts || 0) - (k.dts || 0) || l;
        }));
      }

      return a ? this.g : (a = this.g, this.g = [], a);
    };

    p.getStartTime = function (a) {
      if ("audio" == a) {
        a = null;
        var b = this.kc();
        b.length && (a = b[0], a = Math.min(a.dts, a.pts) / 9E4);
        return a;
      }

      return "video" == a ? (a = null, b = this.Jc(!1), b.length && (a = b[0], a = Math.min(a.dts, a.pts) / 9E4), a) : null;
    };

    p.pd = function () {
      return {
        audio: this.s,
        video: this.m
      };
    };

    p.ie = function () {
      for (var a = [], b = t(this.Jc()), c = b.next(); !c.done; c = b.next()) a.push.apply(a, w(c.value.nalus));

      return a;
    };

    p.si = function () {
      Le("TsParser", "Please use getVideoInfo function instead.");
      var a = this.Ef();
      return {
        height: a.height,
        width: a.width
      };
    };

    p.Ef = function () {
      return "hvc" == this.m ? zi(this) : Ai(this);
    };

    function Ai(a) {
      var b = {
        height: null,
        width: null,
        va: null
      };
      a = a.ie();
      if (!a.length) return b;
      a = a.find(function (r) {
        return 7 == r.type;
      });
      if (!a) return b;
      a = new mi(a.data);
      var c = ti(a),
          d = ti(a),
          e = ti(a);
      ri(a);

      if (Bi.includes(c)) {
        var f = R(a);
        3 === f && oi(a, 1);
        ri(a);
        ri(a);
        oi(a, 1);

        if (S(a)) {
          f = 3 !== f ? 8 : 12;

          for (var g = 0; g < f; g++) S(a) && (6 > g ? ui(a, 16) : ui(a, 64));
        }
      }

      ri(a);
      f = R(a);
      if (0 === f) R(a);else if (1 === f) for (oi(a, 1), ri(a), ri(a), f = R(a), g = 0; g < f; g++) ri(a);
      ri(a);
      oi(a, 1);
      f = R(a);
      g = R(a);
      var h = pi(a, 1);
      0 === h && oi(a, 1);
      oi(a, 1);
      var k = 0,
          l = 0,
          m = 0,
          n = 0;
      S(a) && (k = R(a), l = R(a), m = R(a), n = R(a));
      b.height = String((2 - h) * (g + 1) * 16 - 2 * m - 2 * n);
      b.width = String(16 * (f + 1) - 2 * k - 2 * l);
      b.va = "avc1." + ("0" + c.toString(16).toUpperCase()).slice(-2) + ("0" + d.toString(16).toUpperCase()).slice(-2) + ("0" + e.toString(16).toUpperCase()).slice(-2);
      return b;
    }

    function zi(a) {
      var b = {
        height: null,
        width: null,
        va: null
      };
      a = a.ie();
      if (!a.length) return b;
      a = a.find(function (A) {
        return 33 == A.type;
      });
      if (!a) return b;
      var c = new mi(a.fullData, !0);
      ti(c);
      ti(c);
      pi(c, 4);
      var d = pi(c, 3);
      S(c);
      var e = pi(c, 2),
          f = pi(c, 1),
          g = pi(c, 5),
          h = pi(c, 32);
      a = ti(c);

      for (var k = ti(c), l = ti(c), m = ti(c), n = ti(c), r = ti(c), q = ti(c), u = [], v = [], y = 0; y < d; y++) u.push(S(c)), v.push(S(c));

      if (0 < d) for (y = d; 8 > y; y++) pi(c, 2);

      for (y = 0; y < d; y++) u[y] && pi(c, 88), v[y] && ti(c);

      R(c);
      d = R(c);
      3 == d && pi(c, 1);
      u = R(c);
      v = R(c);
      var z = y = 0,
          x = 0,
          B = 0;
      S(c) && (y += R(c), z += R(c), x += R(c), B += R(c));
      b.width = String(u - (y + z) * (1 === d || 2 === d ? 2 : 1));
      b.height = String(v - (x + B) * (1 === d ? 2 : 1));

      c = function (A) {
        for (var C = 0, E = 0; 32 > E; E++) C |= (A >> E & 1) << 31 - E;

        return C >>> 0;
      }(h);

      f = 1 == f ? "H" : "L";
      e = "hvc1" + ("." + ["", "A", "B", "C"][e] + g);
      e += "." + c.toString(16).toUpperCase();
      e += "." + f + q;
      r && (e += "." + r.toString(16).toUpperCase());
      n && (e += "." + n.toString(16).toUpperCase());
      m && (e += "." + m.toString(16).toUpperCase());
      l && (e += "." + l.toString(16).toUpperCase());
      k && (e += "." + k.toString(16).toUpperCase());
      a && (e += "." + a.toString(16).toUpperCase());
      b.va = e;
      return b;
    }

    function Ci(a) {
      return 0 > xi(a) ? !1 : !0;
    }

    function xi(a) {
      for (var b = Math.min(1E3, a.length - 564), c = 0; c < b;) {
        if (71 == a[c] && 71 == a[c + 188] && 71 == a[c + 376]) return c;
        c++;
      }

      return -1;
    }

    M("shaka.util.TsParser", wi);
    wi.syncOffset = xi;
    wi.probe = Ci;
    wi.prototype.getVideoInfo = wi.prototype.Ef;
    wi.prototype.getVideoResolution = wi.prototype.si;
    wi.prototype.getVideoNalus = wi.prototype.ie;
    wi.prototype.getCodecs = wi.prototype.pd;
    wi.prototype.getStartTime = wi.prototype.getStartTime;
    wi.prototype.getVideoData = wi.prototype.Jc;
    wi.prototype.getAudioData = wi.prototype.kc;
    wi.prototype.getMetadata = wi.prototype.getMetadata;
    wi.prototype.parseNalus = wi.prototype.Vf;
    wi.prototype.parseAvcNalus = wi.prototype.Pi;
    wi.prototype.parse = wi.prototype.parse;
    wi.prototype.clearData = wi.prototype.clearData;
    wi.Timescale = 9E4;
    var Bi = [100, 110, 122, 244, 44, 83, 86, 118, 128, 138, 139, 134];

    function Di(a, b, c) {
      this.g = null;
      this.s = -1;
      this.l = a;
      this.i = b;
      this.m = c;
      this.j = !1;

      a: {
        "undefined" === typeof libDPIModule && Ua("Could not find LCEVC Library dependencies on this page");
        if ("undefined" !== typeof LCEVCdec) this.h = LCEVCdec;else if ("undefined" !== typeof LcevcDil) this.h = LcevcDil, this.j = !0, Le("LcevcDil", "lcevc_dil.js is deprecated, please use lcevc_dec.js instead");else {
          Ua("Could not find LCEVC Library on this page");
          a = !1;
          break a;
        }
        "undefined" === typeof this.h.SupportObject ? (Ua("Could not find LCEVC Library on this page"), a = !1) : (this.h.SupportObject.SupportStatus || Ua(this.h.SupportObject.SupportError), a = "undefined" !== typeof this.h && "undefined" !== typeof libDPIModule && this.i instanceof HTMLCanvasElement && this.h.SupportObject.SupportStatus);
      }

      a && !this.g && this.h.SupportObject.webGLSupport(this.i) && (this.i.classList.remove("shaka-hidden"), this.g = this.j ? new this.h.LcevcDil(this.l, this.i, this.m) : new this.h.LCEVCdec(this.l, this.i, this.m));
    }

    function Ei(a) {
      a.g && a.i.classList.add("shaka-hidden");
    }

    Di.prototype.release = function () {
      this.g && (this.g.close(), this.g = null);
    };

    function Fi(a, b, c) {
      var d = Gi,
          e = Hi;

      switch (b.mimeType) {
        case "video/webm":
          d = Ii;
          break;

        case "video/mp4":
          d = Ji;
      }

      switch (c) {
        case "DASH":
          e = Ki;
          break;

        case "HLS":
          e = Li;
      }

      a.g && (a.s = b.id, a.g.setLevelSwitching(b.id, !0), a.g.setContainerFormat(d), a.j || a.g.setStreamingFormat(e));
    }

    M("shaka.lcevc.Dec", Di);
    Di.prototype.release = Di.prototype.release;
    var Gi = 0,
        Ii = 1,
        Ji = 2,
        Li = 0,
        Ki = 1,
        Hi = -1;

    function Mi(a, b, c, d) {
      var e = this;
      this.i = a;
      this.G = null;
      this.H = b;
      this.g = {};
      this.I = {};
      this.ha = {};
      this.h = null;
      this.Z = !1;

      this.ua = c || function () {};

      this.N = d || null;
      this.j = {};
      this.u = new Jf();
      this.m = {};
      this.J = null;
      this.L = new lf();
      this.M = "";
      this.$ = !1;
      this.l = Ni(this, this.L);
      this.D = !1;
      this.K = new Hf(function () {
        return Oi(e);
      });
      this.C = !1;
      this.V = "UNKNOWN";
      this.za = this.ra = !1;
      this.Aa = new lf();
      this.s = !1;
      this.aa = !0;
      this.U = null;
    }

    function Ni(a, b) {
      if (window.ManagedMediaSource) {
        a.i.disableRemotePlayback = !0;
        var c = new ManagedMediaSource();
        a.u.na(c, "sourceopen", function () {
          URL.revokeObjectURL(a.M);
          b.resolve();
        });
        a.u.o(c, "startstreaming", function () {
          a.aa = !0;
        });
        a.u.o(c, "endstreaming", function () {
          a.aa = !1;
        });
        a.u.na(a.i, "playing", function () {
          a.$ = !0;
        });
        a.M = Pi(c);
        a.i.src = a.M;
        return c;
      }

      c = new MediaSource();
      a.u.na(c, "sourceopen", function () {
        URL.revokeObjectURL(a.M);
        b.resolve();
      });
      a.u.na(a.i, "playing", function () {
        a.$ = !0;
      });
      a.M = Pi(c);
      a.i.src = a.M;
      return c;
    }

    p = Mi.prototype;

    p.destroy = function () {
      return this.K.destroy();
    };

    function Oi(a) {
      var b, c, d, e, f, g, h, k;
      return K(function (l) {
        if (1 == l.g) {
          b = [];

          for (c in a.j) for (d = a.j[c], e = d[0], a.j[c] = d.slice(0, 1), e && b.push(e.p.catch(Ad)), f = t(d.slice(1)), g = f.next(); !g.done; g = f.next()) h = g.value, h.p.reject(new P(2, 7, 7003, void 0));

          a.h && b.push(a.h.destroy());
          a.H && b.push(a.H.destroy());

          for (k in a.m) b.push(a.m[k].destroy());

          return D(l, Promise.all(b), 2);
        }

        a.u && (a.u.release(), a.u = null);
        a.i && (a.i.removeAttribute("src"), a.i.load(), a.i = null);
        a.G = null;
        a.l = null;
        a.h = null;
        a.H = null;
        a.g = {};
        a.m = {};
        a.J = null;
        a.j = {};
        a.N = null;
        F(l);
      });
    }

    p.init = function (a, b, c, d) {
      b = void 0 === b ? !1 : b;
      c = void 0 === c ? "UNKNOWN" : c;
      d = void 0 === d ? !1 : d;
      var e = this,
          f,
          g,
          h,
          k,
          l;
      return K(function (m) {
        if (1 == m.g) return f = Nb, D(m, e.L, 2);
        e.C = b;
        e.V = c;
        e.ra = d;
        e.za = !e.C && "HLS" == e.V && !e.ra;
        g = t(a.keys());

        for (h = g.next(); !h.done; h = g.next()) k = h.value, l = a.get(k), Qi(e, k, l, l.codecs), e.s ? (e.j[f.T] = [], e.j[f.ia] = []) : e.j[k] = [];

        F(m);
      });
    };

    function Qi(a, b, c, d) {
      var e = fd(c.mimeType, d);
      if (b == Mb) Ri(a, e, a.C, c.external);else {
        var f = a.G.forceTransmux;
        if (!fc(e) || !a.C && gd.includes(e)) f = !0;
        var g = hd(c.mimeType, d);

        if (f) {
          f = Kb("audio", (d || "").split(","));
          d = Kb("video", (d || "").split(","));

          if (f && d) {
            a.s = !0;
            Qi(a, "audio", c, f);
            Qi(a, "video", c, d);
            return;
          }

          if (d = $c(g)) e = d(), a.m[b] = e, e = e.convertCodecs(b, g);
        }

        g = e + a.G.sourceBufferExtraFeatures;
        If(a.K);

        try {
          var h = a.l.addSourceBuffer(g);
        } catch (k) {
          throw new P(2, 3, 3015, k, "The mediaSource_ status was " + a.l.readyState + " expected 'open'");
        }

        a.C && (h.mode = Si);
        a.u.o(h, "error", function () {
          a.j[b][0].p.reject(new P(2, 3, 3014, a.i.error ? a.i.error.code : 0));
        });
        a.u.o(h, "updateend", function () {
          return Ti(a, b);
        });
        a.g[b] = h;
        a.I[b] = e;
        a.ha[b] = !!c.drmInfos.length;
      }
    }

    p.configure = function (a) {
      this.G = a;
    };

    function Ri(a, b, c, d) {
      a.h || (a.h = new qd(a.H));
      var e = a.h;
      d = d || a.Z;
      a = a.V;
      "application/cea-608" == b || "application/cea-708" == b ? e.i = null : (e.i = (0, sd[b])(), e.i.setSequenceMode ? e.i.setSequenceMode(c) : Ua('Text parsers should have a "setSequenceMode" method!'), e.i.setManifestType ? e.i.setManifestType(a) : Ua('Text parsers should have a "setManifestType" method!'), e.C = d);
    }

    function Ui(a) {
      return a.D ? !1 : a.l ? "ended" == a.l.readyState : !0;
    }

    function Vi(a, b) {
      a.D || !Object.keys(a.g).length ? a = null : b == Mb ? a = a.h.g : (a = Wi(a, b), a = !a || 1 == a.length && 1E-6 > a.end(0) - a.start(0) ? null : 1 == a.length && 0 > a.start(0) ? 0 : a.length ? a.start(0) : null);
      return a;
    }

    function Xi(a, b) {
      return a.D ? null : b == Mb ? a.h.h : Sh(Wi(a, b));
    }

    function Yi(a, b, c) {
      if (a.D) return 0;
      if (b == Mb) return a = a.h, null == a.h || a.h < c ? 0 : a.h - Math.max(c, a.g);
      a = Wi(a, b);
      return Uh(a, c);
    }

    p.Fb = function () {
      var a = {
        total: this.D ? [] : Vh(this.i.buffered),
        audio: this.D ? [] : Vh(Wi(this, "audio")),
        video: this.D ? [] : Vh(Wi(this, "video")),
        text: []
      };

      if (this.h) {
        var b = this.h.g,
            c = this.h.h;
        null != b && null != c && a.text.push({
          start: b,
          end: c
        });
      }

      return a;
    };

    function Wi(a, b) {
      try {
        return a.g[b].buffered;
      } catch (c) {
        return null;
      }
    }

    function Zi(a, b, c, d, e, f) {
      var g = null,
          h = nc(c);
      if (gd.includes(e)) f = bi(h), f.length && d && ((b = f.find(function (n) {
        return "com.apple.streaming.transportStreamTimestamp" === n.description;
      })) && b.data && (g = Math.round(b.data) / 1E3), a.ua([{
        cueTime: d.startTime,
        data: h,
        frames: f,
        dts: d.startTime,
        pts: d.startTime
      }], 0, d.endTime));else if (e.includes("/mp4") && d && 0 == d.timestampOffset && d.ka && d.ka.timescale) {
        var k = d.ka.timescale;

        if (!isNaN(k)) {
          var l = 0,
              m = !1;
          new bg().box("moof", gg).box("traf", gg).W("tfdt", function (n) {
            l = ei(n.reader, n.version).baseMediaDecodeTime / k;
            m = !0;
            n.parser.stop();
          }).parse(c, !0);
          m && (g = l);
        }
      } else e.includes("/mp4") || e.includes("/webm") || !Ci(h) || (h = new wi().parse(h), b = h.getStartTime(b), null != b && (g = b), h = h.getMetadata(), h.length && a.ua(h, f, d ? d.endTime : null));
      return g;
    }

    function $i(a, b, c, d, e, f, g, h, k, l) {
      g = void 0 === g ? !1 : g;
      h = void 0 === h ? !1 : h;
      k = void 0 === k ? !1 : k;
      l = void 0 === l ? !1 : l;
      var m, n, r, q, u, v, y, z, x, B, A;
      return K(function (C) {
        switch (C.g) {
          case 1:
            m = Nb;

            if (b != m.sa) {
              C.F(2);
              break;
            }

            if (!a.C) {
              C.F(3);
              break;
            }

            return D(C, a.Aa, 4);

          case 4:
            n = C.h, a.h.u = n;

          case 3:
            return D(C, td(a.h, c, d ? d.startTime : null, d ? d.endTime : null, d ? d.ba()[0] : null), 5);

          case 5:
            return C.return();

          case 2:
            if (l || !a.s) {
              C.F(6);
              break;
            }

            return D(C, $i(a, m.T, c, d, e, f, g, h, k, !0), 7);

          case 7:
            return D(C, $i(a, m.ia, c, d, e, f, g, h, k, !0), 8);

          case 8:
            return C.return();

          case 6:
            if (!a.g[b]) return C.return();
            r = a.g[b].timestampOffset;
            q = a.I[b];
            a.m[b] && (q = a.m[b].getOriginalMimeType());
            d && (u = Zi(a, b, c, d, q, r), null != u && (v = d.startTime - u, y = Math.abs(r - v), (.001 <= y || g || h) && (!k || 0 < v || !r) && (r = v, a.za && (aj(a, b, function () {
              return bj(a, b);
            }), aj(a, b, function () {
              return cj(a, b, r);
            }))), z = b == m.ia || !(m.ia in a.g), a.C && z && a.Aa.resolve(r)));
            f && b == m.ia && (a.h || Ri(a, "application/cea-608", a.C, !1), a.J || (x = q.split(";", 1)[0], a.J = new tc(x)), d ? (B = a.J.i(c), B.length && yd(a.h, B, d.startTime, d.endTime, r)) : a.J.init(c));

            if (!a.m[b]) {
              C.F(9);
              break;
            }

            return D(C, a.m[b].transmux(c, e, d, a.l.duration, b), 10);

          case 10:
            c = C.h;

          case 9:
            return c = dj(a, c, d ? d.startTime : null, b), d && a.C && b != m.sa && (g || h) && (A = d.startTime, aj(a, b, function () {
              return bj(a, b);
            }), aj(a, b, function () {
              return cj(a, b, A);
            })), D(C, aj(a, b, function () {
              var E = c;

              if ("video" == b && a.N) {
                var H = a.N;
                H.g && H.g.appendBuffer(E, "video", H.s, -r);
              }

              a.g[b].appendBuffer(E);
            }), 11);

          case 11:
            F(C);
        }
      });
    }

    function ej(a, b) {
      var c = Xi(a, "video") || 0;
      vd(a.h, b, c);
    }

    function fj(a) {
      a.h && vd(a.h, "", 0);
    }

    p.remove = function (a, b, c) {
      var d = this,
          e;
      return K(function (f) {
        return 1 == f.g ? (e = Nb, a == e.sa ? D(f, d.h.remove(b, c), 0) : D(f, aj(d, a, function () {
          return gj(d, a, b, c);
        }), 4)) : d.s ? D(f, aj(d, e.T, function () {
          return gj(d, e.T, b, c);
        }), 0) : f.F(0);
      });
    };

    function hj(a, b) {
      var c;
      return K(function (d) {
        return 1 == d.g ? (c = Nb, b == c.sa ? a.h ? D(d, a.h.remove(0, Infinity), 0) : d.return() : D(d, aj(a, b, function () {
          return gj(a, b, 0, a.l.duration);
        }), 4)) : a.s ? D(d, aj(a, c.T, function () {
          return gj(a, c.T, 0, a.l.duration);
        }), 0) : d.F(0);
      });
    }

    p.flush = function (a) {
      var b = this,
          c;
      return K(function (d) {
        return 1 == d.g ? (c = Nb, a == c.sa ? d.return() : D(d, aj(b, a, function () {
          b.i.currentTime -= .001;
          Ti(b, a);
        }), 2)) : b.s ? D(d, aj(b, c.T, function () {
          var e = c.T;
          b.i.currentTime -= .001;
          Ti(b, e);
        }), 0) : d.F(0);
      });
    };

    function ij(a, b, c, d, e, f, g, h, k) {
      var l, m, n;
      return K(function (r) {
        if (1 == r.g) {
          l = Nb;
          if (b == l.sa) return f || (a.h.u = c), ud(a.h, d, e), r.return();
          m = [];
          return D(r, jj(a, b, g, h, k), 2);
        }

        n = r.h;
        n || (m.push(aj(a, b, function () {
          return bj(a, b);
        })), a.s && m.push(aj(a, l.T, function () {
          return bj(a, l.T);
        })));
        f || (m.push(aj(a, b, function () {
          return cj(a, b, c);
        })), a.s && m.push(aj(a, l.T, function () {
          return cj(a, l.T, c);
        })));
        m.push(aj(a, b, function () {
          a.g[b].appendWindowStart = 0;
          a.g[b].appendWindowEnd = e;
          a.g[b].appendWindowStart = d;
          Ti(a, b);
        }));
        a.s && m.push(aj(a, l.T, function () {
          var q = l.T;
          a.g[q].appendWindowStart = 0;
          a.g[q].appendWindowEnd = e;
          a.g[q].appendWindowStart = d;
          Ti(a, q);
        }));
        return D(r, Promise.all(m), 0);
      });
    }

    function kj(a, b, c) {
      var d;
      return K(function (e) {
        if (1 == e.g) {
          d = Nb;
          if (b == d.sa) return e.return();
          aj(a, b, function () {
            return bj(a, b);
          });
          a.s && aj(a, d.T, function () {
            return bj(a, d.T);
          });
          return D(e, aj(a, b, function () {
            return cj(a, b, c);
          }), 2);
        }

        return a.s ? D(e, aj(a, d.T, function () {
          return cj(a, d.T, c);
        }), 0) : e.F(0);
      });
    }

    p.endOfStream = function (a) {
      var b = this;
      return K(function (c) {
        return D(c, lj(b, function () {
          Ui(b) || "closed" === b.l.readyState || (a ? b.l.endOfStream(a) : b.l.endOfStream());
        }), 0);
      });
    };

    p.bb = function (a) {
      var b = this;
      return K(function (c) {
        return D(c, lj(b, function () {
          if (a < b.l.duration) for (var d in b.g) {
            var e = {
              start: function () {},
              p: new lf()
            };
            b.j[d].unshift(e);
          }
          b.l.duration = a;
          b.U = a;
        }), 0);
      });
    };

    p.getDuration = function () {
      return this.l.duration;
    };

    function gj(a, b, c, d) {
      d <= c ? Ti(a, b) : a.g[b].remove(c, d);
    }

    function bj(a, b) {
      var c = a.g[b].appendWindowStart,
          d = a.g[b].appendWindowEnd;
      a.g[b].abort();
      a.g[b].appendWindowStart = c;
      a.g[b].appendWindowEnd = d;
      Ti(a, b);
    }

    function cj(a, b, c) {
      0 > c && (c += .001);
      a.g[b].timestampOffset = c;
      Ti(a, b);
    }

    function Ti(a, b) {
      if (!a.D) {
        var c = a.j[b][0];
        c && (c.p.resolve(), mj(a, b));
      }
    }

    function aj(a, b, c) {
      If(a.K);
      c = {
        start: c,
        p: new lf()
      };
      a.j[b].push(c);
      1 == a.j[b].length && nj(a, b);
      return c.p;
    }

    function lj(a, b) {
      var c, d, e, f, g, h, k;
      return K(function (l) {
        switch (l.g) {
          case 1:
            If(a.K);
            c = [];
            d = {};

            for (e in a.g) d.bd = new lf(), f = {
              start: function (m) {
                return function () {
                  return m.bd.resolve();
                };
              }(d),
              p: d.bd
            }, a.j[e].push(f), c.push(d.bd), 1 == a.j[e].length && f.start(), d = {
              bd: d.bd
            };

            ta(l, 2);
            return D(l, Promise.all(c), 4);

          case 4:
            va(l, 3);
            break;

          case 2:
            throw g = wa(l), g;

          case 3:
            return ta(l, 5, 6), D(l, b(), 6);

          case 6:
            xa(l);

            for (h in a.g) mj(a, h);

            ya(l, 0);
            break;

          case 5:
            throw k = wa(l), new P(2, 3, 3015, k, a.i.error || "No error in the media element");
        }
      });
    }

    function mj(a, b) {
      a.j[b].shift();
      nj(a, b);
    }

    function nj(a, b) {
      var c = a.j[b][0];
      if (c) try {
        c.start();
      } catch (d) {
        "QuotaExceededError" == d.name ? c.p.reject(new P(2, 3, 3017, b)) : c.p.reject(new P(2, 3, 3015, d, a.i.error || "No error in the media element")), mj(a, b);
      }
    }

    function dj(a, b, c, d) {
      var e = a.ha[d];
      a.G.insertFakeEncryptionInInit && null == c && e && (Md() || Kd() || Ld("SOPOpenBrowser")) && "mp4" == a.I[d].split(";")[0].split("/")[1] && (b = Jh(b));
      return b;
    }

    function oj(a, b, c, d) {
      return aj(a, b, function () {
        b !== Mb && (hc() && (a.m[b] && (a.m[b].destroy(), delete a.m[b]), d && (a.m[b] = d), a.g[b].changeType(c + a.G.sourceBufferExtraFeatures), a.I[b] = c), Ti(a, b));
      });
    }

    function pj(a, b) {
      var c, d, e, f, g, h, k, l, m, n, r, q, u, v, y, z, x, B, A, C, E, H, G;
      return K(function (I) {
        switch (I.g) {
          case 1:
            c = Nb;
            a.D = !0;
            a.s = !1;
            d = a.i.currentTime;
            e = a.i.autoplay;
            f = a.i.paused;
            a.$ && (a.i.autoplay = !1);
            ua(I, 2);
            a.u.Lb();
            g = [];

            for (h in a.m) g.push(a.m[h].destroy());

            for (k in a.j) for (l = a.j[k], m = l[0], a.j[k] = l.slice(0, 1), m && g.push(m.p.catch(Ad)), n = t(l.slice(1)), r = n.next(); !r.done; r = n.next()) q = r.value, q.p.reject(new P(2, 7, 7003, void 0));

            for (u in a.g) {
              v = a.g[u];

              try {
                a.l.removeSourceBuffer(v);
              } catch (J) {}
            }

            return D(I, Promise.all(g), 4);

          case 4:
            return a.m = {}, a.g = {}, y = a.l.duration, a.L = new lf(), a.l = Ni(a, a.L), D(I, a.L, 5);

          case 5:
            !isNaN(y) && y ? a.l.duration = y : !isNaN(a.U) && a.U && (a.l.duration = a.U);
            z = new lf();
            x = a.l.sourceBuffers;
            B = b.size;
            A = 0;
            a.u.o(x, "addsourcebuffer", function () {
              A++;
              A === B && z.resolve();
            });
            C = t(b.keys());

            for (E = C.next(); !E.done; E = C.next()) H = E.value, G = b.get(H), Qi(a, H, G, G.codecs), a.s ? (a.j[c.T] = [], a.j[c.ia] = []) : a.j[H] = [];

            a.i.currentTime = d;
            return D(I, z, 2);

          case 2:
            xa(I), a.D = !1, If(a.K), a.u.na(a.i, "canplay", function () {
              If(a.K);
              a.i.autoplay = e;
              f || a.i.play();
            }), ya(I, 0);
        }
      });
    }

    function qj(a, b) {
      return lj(a, function () {
        return pj(a, b);
      });
    }

    function jj(a, b, c, d, e) {
      var f, g, h, k, l, m, n, r, q, u, v, y, z, x, B;
      return K(function (A) {
        if (1 == A.g) {
          f = Nb;
          if (b == f.sa) return A.return(!1);
          g = nd(pd(a.I[b]));
          h = od(a.I[b]);
          l = !1;
          m = fd(c, d);
          n = a.G.forceTransmux;
          if (!fc(m) || !a.C && gd.includes(m)) n = !0;
          n && (r = hd(c, d), q = $c(r)) && (k = q(), u = Kb(f.T, (d || "").split(",")), v = Kb(f.ia, (d || "").split(",")), u && v ? (l = !0, y = v, b == f.T && (y = u), m = k.convertCodecs(b, hd(c, y))) : m = k.convertCodecs(b, r));
          z = nd(pd(m));
          x = od(m);
          if (g === z && h === x) return A.return(!1);
          B = !0;
          if (a.s || l && k && !a.m[b]) B = !1;
          if (B && "smooth" === a.G.codecSwitchingStrategy && hc()) return D(A, oj(a, b, m, k), 3);
          k && k.destroy();
          return D(A, qj(a, e), 3);
        }

        return A.return(!0);
      });
    }

    function rj(a, b, c) {
      if (b == Mb) var d = !1;else {
        d = nd(pd(a.I[b]));
        var e = od(a.I[b]),
            f = fd(c.mimeType, c.codecs),
            g = a.G.forceTransmux;
        if (!fc(f) || !a.C && gd.includes(f)) g = !0;
        c = hd(c.mimeType, c.codecs);
        g && (g = $c(c)) && (g = g(), f = g.convertCodecs(b, c), g.destroy());
        b = nd(pd(f));
        f = od(f);
        d = d !== b || e !== f;
      }
      return d ? "smooth" !== a.G.codecSwitchingStrategy || !hc() || a.s : !1;
    }

    var Pi = window.URL.createObjectURL,
        Si = "sequence";

    function sj(a, b, c) {
      this.i = a;
      this.m = b;
      this.u = this.j = Infinity;
      this.g = 1;
      this.h = this.l = null;
      this.s = 0;
      this.G = !0;
      this.H = 0;
      this.C = void 0 === c ? !0 : c;
      this.I = 0;
      this.D = !1;
    }

    p = sj.prototype;

    p.getDuration = function () {
      return this.j;
    };

    p.bi = function () {
      return this.g;
    };

    p.kh = function (a) {
      this.i = a;
    };

    p.bb = function (a) {
      this.j = a;
    };

    p.ei = function () {
      return this.i;
    };

    p.gh = function (a) {
      this.s = a;
    };

    p.Sc = function (a) {
      this.G = a;
    };

    p.Fe = function (a) {
      this.u = a;
    };

    p.hh = function (a) {
      this.m = a;
    };

    p.Uh = function () {
      return this.m;
    };

    p.Zg = function (a, b) {
      if (0 != a.length) {
        var c = a[a.length - 1].end + b;
        this.we(a[0].start + b);
        this.g = a.reduce(function (d, e) {
          return Math.max(d, e.end - e.start);
        }, this.g);
        this.h = Math.max(this.h, c);
        null != this.i && this.C && !this.D && (this.i = (Date.now() + this.s) / 1E3 - this.h - this.g);
      }
    };

    p.Bd = function (a) {
      if (0 != a.length) {
        var b = a[0].startTime,
            c = a[0].endTime,
            d = (Date.now() + this.s) / 1E3;
        a = t(a);

        for (var e = a.next(); !e.done; e = a.next()) e = e.value, d < e.startTime || (b = Math.min(b, e.startTime), c = Math.max(c, e.endTime), this.g = Math.max(this.g, e.endTime - e.startTime));

        this.we(b);
        this.h = Math.max(this.h, c);
        null != this.i && this.C && !this.D && (this.i = d - this.h - this.g);
      }
    };

    p.oe = function () {
      this.D = !0;
    };

    p.we = function (a) {
      this.l = null == this.l ? a : Math.min(this.l, a);
    };

    p.Qf = function (a) {
      this.g = Math.max(this.g, a);
    };

    p.offset = function (a) {
      null != this.l && (this.l += a);
      null != this.h && (this.h += a);
    };

    p.S = function () {
      return Infinity == this.j && !this.G;
    };

    p.rc = function () {
      return Infinity != this.j && !this.G;
    };

    p.Hb = function () {
      return Math.max(this.H, this.Vb() - this.u);
    };

    p.mh = function (a) {
      this.H = a;
    };

    p.Vb = function () {
      return this.S() || this.rc() ? Math.min(Math.max(0, (Date.now() + this.s) / 1E3 - this.g - this.i) + this.I, this.j) : this.h ? Math.min(this.h, this.j) : this.j;
    };

    p.sd = function (a) {
      var b = Math.max(this.l, this.H);
      return Infinity == this.u ? Math.ceil(1E3 * b) / 1E3 : Math.max(b, Math.min(this.Vb() - this.u + a, this.Gb()));
    };

    p.Ic = function () {
      return this.sd(0);
    };

    p.Gb = function () {
      return Math.max(0, this.Vb() - (this.S() || this.rc() ? this.m : 0));
    };

    p.qh = function () {
      return null == this.i || null != this.h && this.C ? !1 : !0;
    };

    p.fh = function (a) {
      this.I = a;
    };

    M("shaka.media.PresentationTimeline", sj);
    sj.prototype.setAvailabilityTimeOffset = sj.prototype.fh;
    sj.prototype.usingPresentationStartTime = sj.prototype.qh;
    sj.prototype.getSeekRangeEnd = sj.prototype.Gb;
    sj.prototype.getSeekRangeStart = sj.prototype.Ic;
    sj.prototype.getSafeSeekRangeStart = sj.prototype.sd;
    sj.prototype.getSegmentAvailabilityEnd = sj.prototype.Vb;
    sj.prototype.setUserSeekStart = sj.prototype.mh;
    sj.prototype.getSegmentAvailabilityStart = sj.prototype.Hb;
    sj.prototype.isInProgress = sj.prototype.rc;
    sj.prototype.isLive = sj.prototype.S;
    sj.prototype.offset = sj.prototype.offset;
    sj.prototype.notifyMaxSegmentDuration = sj.prototype.Qf;
    sj.prototype.notifyMinSegmentStartTime = sj.prototype.we;
    sj.prototype.lockStartTime = sj.prototype.oe;
    sj.prototype.notifySegments = sj.prototype.Bd;
    sj.prototype.notifyTimeRange = sj.prototype.Zg;
    sj.prototype.getDelay = sj.prototype.Uh;
    sj.prototype.setDelay = sj.prototype.hh;
    sj.prototype.setSegmentAvailabilityDuration = sj.prototype.Fe;
    sj.prototype.setStatic = sj.prototype.Sc;
    sj.prototype.setClockOffset = sj.prototype.gh;
    sj.prototype.getPresentationStartTime = sj.prototype.ei;
    sj.prototype.setDuration = sj.prototype.bb;
    sj.prototype.setPresentationStartTime = sj.prototype.kh;
    sj.prototype.getMaxSegmentDuration = sj.prototype.bi;
    sj.prototype.getDuration = sj.prototype.getDuration;

    function tj(a, b, c) {
      this.j = c;
      this.l = a;
      this.u = uj(a);
      this.g = a.g.currentTime;
      this.m = Date.now() / 1E3;
      this.h = !1;
      this.s = 0;
      this.C = b;

      this.i = function () {};
    }

    tj.prototype.release = function () {
      this.j = this.l = null;

      this.i = function () {};
    };

    function vj(a, b) {
      a.i = b;
    }

    function wj(a) {
      this.g = a;
    }

    function uj(a) {
      if (a.g.paused || 0 == a.g.buffered.length) var b = !1;else a: {
        b = a.g.currentTime;
        a = t(Vh(a.g.buffered));

        for (var c = a.next(); !c.done; c = a.next()) if (c = c.value, !(b < c.start - .1 || b > c.end - .5)) {
          b = !0;
          break a;
        }

        b = !1;
      }
      return b;
    }

    ;

    function xj(a, b, c, d, e) {
      var f = this;
      this.C = e;
      this.g = a;
      this.D = b;
      this.u = c;
      this.l = new Jf();
      this.j = !1;
      this.H = a.readyState;
      this.G = this.i = 0;
      this.h = d;
      this.s = !1;
      this.l.o(a, "waiting", function () {
        return yj(f);
      });
      this.m = new Fd(function () {
        yj(f);
      }).ya(this.u.gapJumpTimerTime);
    }

    xj.prototype.release = function () {
      this.l && (this.l.release(), this.l = null);
      null != this.m && (this.m.stop(), this.m = null);
      this.h && (this.h.release(), this.h = null);
      this.g = this.D = this.C = null;
    };

    xj.prototype.Tf = function () {
      this.s = !0;
      yj(this);
    };

    function yj(a) {
      if (0 != a.g.readyState) {
        if (a.g.seeking) {
          if (!a.j) return;
        } else a.j = !1;

        if (!a.g.paused || a.g.currentTime == a.i && (a.g.autoplay || a.g.currentTime != a.i)) {
          a.g.readyState != a.H && (a.H = a.g.readyState);
          var b;

          if (!(b = !a.h)) {
            b = a.h;
            var c = b.l,
                d = uj(c),
                e = c.g.currentTime,
                f = Date.now() / 1E3;
            if (b.g != e || b.u != d) b.m = f, b.g = e, b.u = d, b.h = !1;
            e = f - b.m;
            if (d = e >= b.C && d && !b.h) b.i(b.g, e), b.h = !0, b.g = c.g.currentTime, b.s++, b.j(new N("stalldetected"));
            b = !d;
          }

          b && (b = a.g.currentTime, c = a.g.buffered, d = Wh(c, b, a.u.gapDetectionThreshold), null == d || 0 == d && !a.s || (e = c.start(d), e >= a.D.Gb() || .001 > e - b || (0 != d && c.end(d - 1), a.g.currentTime = e, b == a.i && (a.i = e), a.G++, a.C(new N("gapjumped")))));
        }
      }
    }

    ;

    function zj(a, b, c, d) {
      b == HTMLMediaElement.HAVE_NOTHING || a.readyState >= b ? d() : (b = Aj.value().get(b), c.na(a, b, d));
    }

    var Aj = new Of(function () {
      return new Map([[HTMLMediaElement.HAVE_METADATA, "loadedmetadata"], [HTMLMediaElement.HAVE_CURRENT_DATA, "loadeddata"], [HTMLMediaElement.HAVE_FUTURE_DATA, "canplay"], [HTMLMediaElement.HAVE_ENOUGH_DATA, "canplaythrough"]]);
    });

    function Bj(a, b, c, d) {
      var e = this;
      this.g = a;
      this.m = b;
      this.u = c;
      this.l = null;

      this.j = function () {
        null == e.l && (e.l = d());
        return e.l;
      };

      this.s = !1;
      this.h = new Jf();
      this.i = new Cj(a);
      zj(this.g, HTMLMediaElement.HAVE_METADATA, this.h, function () {
        Dj(e, e.j());
      });
    }

    Bj.prototype.release = function () {
      this.h && (this.h.release(), this.h = null);
      null != this.i && (this.i.release(), this.i = null);

      this.m = function () {};

      this.g = null;
    };

    function Ej(a) {
      return a.s ? a.g.currentTime : a.j();
    }

    function Fj(a, b) {
      0 < a.g.readyState ? Gj(a.i, b) : zj(a.g, HTMLMediaElement.HAVE_METADATA, a.h, function () {
        Dj(a, a.j());
      });
    }

    function Dj(a, b) {
      .001 > Math.abs(a.g.currentTime - b) ? Hj(a) : (a.h.na(a.g, "seeking", function () {
        Hj(a);
      }), Gj(a.i, a.g.currentTime && 0 != a.g.currentTime ? a.g.currentTime : b));
    }

    function Hj(a) {
      a.s = !0;
      a.h.o(a.g, "seeking", function () {
        return a.m();
      });
      a.u(a.g.currentTime);
    }

    function Cj(a) {
      var b = this;
      this.h = a;
      this.m = 10;
      this.l = this.j = this.i = 0;
      this.g = new Fd(function () {
        0 >= b.i ? b.g.stop() : b.h.currentTime != b.j ? b.g.stop() : (b.h.currentTime = b.l, b.i--);
      });
    }

    Cj.prototype.release = function () {
      this.g && (this.g.stop(), this.g = null);
      this.h = null;
    };

    function Gj(a, b) {
      a.j = a.h.currentTime;
      a.l = b;
      a.i = a.m;
      a.h.currentTime = b;
      a.g.ya(.1);
    }

    ;

    function Ij(a) {
      this.g = a;
      this.j = !1;
      this.h = null;
      this.i = new Jf();
    }

    p = Ij.prototype;

    p.Ue = function () {
      function a() {
        null == b.h || 0 == b.h ? b.j = !0 : (b.i.na(b.g, "seeking", function () {
          b.j = !0;
        }), b.g.currentTime = Math.max(0, b.g.currentTime + b.h));
      }

      var b = this;
      zj(this.g, HTMLMediaElement.HAVE_CURRENT_DATA, this.i, function () {
        a();
      });
    };

    p.release = function () {
      this.i && (this.i.release(), this.i = null);
      this.g = null;
    };

    p.Ve = function (a) {
      this.h = this.j ? this.h : a;
    };

    p.Ud = function () {
      return (this.j ? this.g.currentTime : this.h) || 0;
    };

    p.wg = function () {
      return 0;
    };

    p.vg = function () {
      return 0;
    };

    p.Yg = function () {};

    function Jj(a, b, c, d, e, f) {
      var g = this;
      this.i = a;
      this.g = b.presentationTimeline;
      this.D = b.minBufferTime || 0;
      this.l = c;
      this.C = e;
      this.u = null;
      this.s = Kj(a, c, f);
      this.j = new xj(a, b.presentationTimeline, c, this.s, f);
      this.h = new Bj(a, function () {
        a: {
          var h = g.j;
          h.j = !0;
          h.s = !1;
          var k = Ej(g.h);
          h = Lj(g, k);

          if (.001 < Math.abs(h - k) && (k = Date.now() / 1E3, !g.u || g.u < k - 1)) {
            g.u = k;
            Fj(g.h, h);
            h = void 0;
            break a;
          }

          g.C();
          h = void 0;
        }

        return h;
      }, function (h) {
        var k = g.j;
        k.g.seeking && !k.j && (k.j = !0, k.i = h);
      }, function () {
        var h = d;
        null == h ? h = Infinity > g.g.getDuration() ? g.g.Ic() : g.g.Gb() : 0 > h && (h = g.g.Gb() + h);
        return Mj(g, Nj(g, h));
      });
      this.m = new Fd(function () {
        if (0 != g.i.readyState && !g.i.paused) {
          var h = Ej(g.h),
              k = g.g.Ic(),
              l = g.g.Gb();
          3 > l - k && (k = l - 3);
          h < k && (h = Lj(g, h), g.i.currentTime = h);
        }
      });
    }

    p = Jj.prototype;

    p.Ue = function () {
      this.m.ya(.25);
    };

    p.release = function () {
      this.h && (this.h.release(), this.h = null);
      this.j && (this.j.release(), this.j = null);
      this.m && (this.m.stop(), this.m = null);
      this.i = this.h = this.g = this.l = null;

      this.C = function () {};
    };

    p.Ve = function (a) {
      Fj(this.h, a);
    };

    p.Ud = function () {
      var a = Ej(this.h);
      return 0 < this.i.readyState && !this.i.paused ? Nj(this, a) : a;
    };

    p.wg = function () {
      return this.s ? this.s.s : 0;
    };

    p.vg = function () {
      return this.j.G;
    };

    p.Yg = function () {
      this.j.Tf();
    };

    function Mj(a, b) {
      var c = a.g.getDuration();
      return b >= c ? c - a.l.durationBackoff : b;
    }

    function Lj(a, b) {
      var c = Math.max(a.D, a.l.rebufferingGoal),
          d = a.l.safeSeekOffset,
          e = a.g.Ic(),
          f = a.g.Gb(),
          g = a.g.getDuration();
      3 > f - e && (e = f - 3);
      var h = a.g.sd(c),
          k = a.g.sd(d);
      c = a.g.sd(c + d);
      return b >= g ? Mj(a, b) : b > f ? f : b < e ? Th(a.i.buffered, k) ? k : c : b >= h || Th(a.i.buffered, b) ? b : c;
    }

    function Nj(a, b) {
      var c = a.g.Ic();
      if (b < c) return c;
      a = a.g.Gb();
      return b > a ? a : b;
    }

    function Kj(a, b, c) {
      if (!b.stallEnabled) return null;
      var d = b.stallSkip;
      b = new tj(new wj(a), b.stallThreshold, c);
      vj(b, function () {
        d ? a.currentTime += d : (a.pause(), a.play());
      });
      return b;
    }

    ;

    function Oj(a) {
      this.g = a;
      this.l = null;
      this.j = 0;
      this.s = !1;
    }

    p = Oj.prototype;

    p.mc = function () {
      return this.g.length;
    };

    p.release = function () {
      this.s || (this.g = [], this.l && this.l.stop(), this.l = null);
    };

    p.Ki = function () {
      this.s = !0;
    };

    function Pj(a, b) {
      a = t(a.g);

      for (var c = a.next(); !c.done; c = a.next()) b(c.value);
    }

    p.find = function (a) {
      for (var b = this.g.length - 1, c = b; 0 <= c; --c) {
        var d = this.g[c],
            e = c < b ? this.g[c + 1].startTime : d.endTime;
        if (a >= d.startTime && a < e) return c + this.j;
      }

      return this.g.length && a < this.g[0].startTime ? this.j : null;
    };

    p.get = function (a) {
      if (0 == this.g.length) return null;
      a -= this.j;
      return 0 > a || a >= this.g.length ? null : this.g[a];
    };

    p.offset = function (a) {
      if (!this.s) for (var b = t(this.g), c = b.next(); !c.done; c = b.next()) c.value.offset(a);
    };

    p.se = function (a) {
      if (!this.s && a.length) {
        var b = Math.round(1E3 * a[0].startTime) / 1E3;
        this.g = this.g.filter(function (c) {
          return Math.round(1E3 * c.startTime) / 1E3 < b;
        });
        this.g.push.apply(this.g, w(a));
      }
    };

    p.zd = function (a, b) {
      var c = this;
      a = a.filter(function (d) {
        return d.endTime > b && (0 == c.g.length || d.endTime > c.g[0].startTime);
      });
      this.se(a);
      this.rb(b);
    };

    p.rb = function (a) {
      if (!this.s) {
        var b = this.g.length;
        this.g = this.g.filter(function (c) {
          return c.endTime > a;
        });
        this.j += b - this.g.length;
      }
    };

    p.Ec = function (a, b, c) {
      c = void 0 === c ? !1 : c;

      if (!this.s) {
        for (; this.g.length;) if (this.g[this.g.length - 1].startTime >= b) this.g.pop();else break;

        for (; this.g.length;) if (this.g[0].endTime <= a) this.g.shift(), c || this.j++;else break;

        0 != this.g.length && (a = this.g[this.g.length - 1], this.g[this.g.length - 1] = new Ph(a.startTime, b, a.I, a.cb, a.Ja, a.ka, a.timestampOffset, a.appendWindowStart, a.appendWindowEnd, a.g, a.tilesLayout, a.H, a.h, a.status, a.aes128Key), this.g[this.g.length - 1].j = a.j);
      }
    };

    p.Ie = function (a, b) {
      var c = this;
      this.s || (this.l && this.l.stop(), this.l = new Fd(function () {
        var d = b();
        d ? c.g.push.apply(c.g, w(d)) : (c.l.stop(), c.l = null);
      }), this.l.ya(a));
    };

    Oj.prototype[Symbol.iterator] = function () {
      return this.lc(0);
    };

    Oj.prototype.lc = function (a) {
      var b = this.find(a);
      if (null == b) return null;
      b--;
      var c = this.get(b + 1),
          d = -1;
      if (c && 0 < c.g.length) for (var e = c.g.length - 1; 0 <= e; --e) {
        var f = c.g[e];

        if (a >= f.startTime && a < f.endTime) {
          for (; e && !f.l;) e--, f = c.g[e];

          if (!f.l) return Ta("No independent partial segment found!"), null;
          b++;
          d = e - 1;
          break;
        }
      }
      return new Qj(this, b, d);
    };

    function Rj(a, b, c) {
      a = new Ph(a, a + b, function () {
        return c;
      }, 0, null, null, a, a, a + b);
      return new Oj([a]);
    }

    M("shaka.media.SegmentIndex", Oj);
    Oj.forSingleSegment = Rj;
    Oj.prototype.getIteratorForTime = Oj.prototype.lc;
    Oj.prototype.updateEvery = Oj.prototype.Ie;
    Oj.prototype.fit = Oj.prototype.Ec;
    Oj.prototype.evict = Oj.prototype.rb;
    Oj.prototype.mergeAndEvict = Oj.prototype.zd;
    Oj.prototype.offset = Oj.prototype.offset;
    Oj.prototype.get = Oj.prototype.get;
    Oj.prototype.find = Oj.prototype.find;
    Oj.prototype.markImmutable = Oj.prototype.Ki;
    Oj.prototype.release = Oj.prototype.release;

    function Qj(a, b, c) {
      this.i = a;
      this.g = b;
      this.h = c;
    }

    Qj.prototype.Gh = function () {
      return this.g;
    };

    Qj.prototype.current = function () {
      var a = this.i.get(this.g);
      a && 0 < a.g.length && a.u && this.h >= a.g.length && (this.g++, this.h = 0, a = this.i.get(this.g));
      return a && 0 < a.g.length ? a.g[this.h] : a;
    };

    Qj.prototype.next = function () {
      var a = this.i.get(this.g);
      a && 0 < a.g.length ? (this.h++, a.u && this.h == a.g.length && (this.g++, this.h = 0)) : (this.g++, this.h = 0);
      a = this.current();
      return {
        value: a,
        done: !a
      };
    };

    M("shaka.media.SegmentIterator", Qj);
    Qj.prototype.next = Qj.prototype.next;
    Qj.prototype.current = Qj.prototype.current;
    Qj.prototype.currentPosition = Qj.prototype.Gh;

    function Sj() {
      Oj.call(this, []);
      this.h = [];
    }

    pa(Sj, Oj);
    p = Sj.prototype;

    p.clone = function () {
      var a = new Sj();
      a.h = this.h.slice();
      return a;
    };

    p.release = function () {
      for (var a = t(this.h), b = a.next(); !b.done; b = a.next()) b.value.release();

      this.h = [];
    };

    p.find = function (a) {
      for (var b = 0, c = t(this.h), d = c.next(); !d.done; d = c.next()) {
        d = d.value;
        var e = d.find(a);
        if (null != e) return e + b;
        b += d.j + d.mc();
      }

      return null;
    };

    p.get = function (a) {
      for (var b = 0, c = t(this.h), d = c.next(); !d.done; d = c.next()) {
        d = d.value;
        var e = d.get(a - b);
        if (e) return e;
        b += d.j + d.mc();
      }

      return null;
    };

    p.offset = function () {};

    p.se = function () {};

    p.rb = function () {};

    p.zd = function () {};

    p.Ec = function () {};

    p.Ie = function () {};

    M("shaka.media.MetaSegmentIndex", Sj);
    Sj.prototype.updateEvery = Sj.prototype.Ie;
    Sj.prototype.fit = Sj.prototype.Ec;
    Sj.prototype.mergeAndEvict = Sj.prototype.zd;
    Sj.prototype.evict = Sj.prototype.rb;
    Sj.prototype.merge = Sj.prototype.se;
    Sj.prototype.offset = Sj.prototype.offset;
    Sj.prototype.get = Sj.prototype.get;
    Sj.prototype.find = Sj.prototype.find;
    Sj.prototype.release = Sj.prototype.release;

    function Tj(a) {
      var b = this;
      this.g = a;
      this.h = this.g.ge();
      this.i = new Fd(function () {
        b.g.Xg(.25 * b.h);
      });
    }

    Tj.prototype.release = function () {
      this.i && (this.i.stop(), this.i = null);
      this.g = null;
    };

    Tj.prototype.set = function (a) {
      if (this.h != a) a: {
        this.h = a, this.i.stop();
        if (0 <= this.h) try {
          var b = this.h;
          this.g.ge() != b && this.g.jg(b);
          break a;
        } catch (c) {}
        this.i.ya(.25);
        0 != this.g.ge() && this.g.jg(0);
      }
    };

    Tj.prototype.qd = function () {
      return this.g.qd();
    };

    function Uj(a) {
      var b = this;
      this.h = a;
      this.g = new Set();
      this.i = new Fd(function () {
        Vj(b, !1);
      }).ya(.25);
    }

    Uj.prototype.release = function () {
      this.i.stop();

      for (var a = t(this.g), b = a.next(); !b.done; b = a.next()) b.value.release();

      this.g.clear();
    };

    function Vj(a, b) {
      for (var c = t(a.g), d = c.next(); !d.done; d = c.next()) d.value.j(a.h.currentTime, b);
    }

    ;

    function Wj(a) {
      db.call(this);
      this.g = new Map();
      this.h = a;
    }

    pa(Wj, db);

    Wj.prototype.release = function () {
      this.g.clear();
      db.prototype.release.call(this);
    };

    function Xj(a, b) {
      var c = a.g.get(b);
      c || (c = {
        Dd: [],
        Fg: null,
        contentType: b
      }, a.g.set(b, c));
      return c;
    }

    function Yj(a, b, c) {
      var d = Xj(a, b.contentType);
      Zj(a, d);
      a = {
        Of: b,
        position: c
      };
      d = d.Dd;
      b = d.findIndex(function (e) {
        return e.position >= c;
      });
      0 <= b ? d.splice(b, d[b].position == c ? 1 : 0, a) : d.push(a);
    }

    Wj.prototype.j = function (a) {
      for (var b = t(this.g.values()), c = b.next(); !c.done; c = b.next()) {
        c = c.value;

        a: {
          var d = c.Dd;

          for (var e = d.length - 1; 0 <= e; e--) {
            var f = d[e];

            if (f.position <= a) {
              d = f.Of;
              break a;
            }
          }

          d = null;
        }

        if (e = d) e = c.Fg, e = !(e === d || e && d && e.bandwidth == d.bandwidth && e.audioSamplingRate == d.audioSamplingRate && e.codecs == d.codecs && e.contentType == d.contentType && e.frameRate == d.frameRate && e.height == d.height && e.mimeType == d.mimeType && e.channelsCount == d.channelsCount && e.pixelAspectRatio == d.pixelAspectRatio && e.width == d.width);
        if (e) a: {
          e = a;
          f = d.contentType;

          if ((f = this.h()[f]) && 0 < f.length) {
            var g = f[f.length - 1].end;

            if (e >= f[0].start && e < g) {
              e = !0;
              break a;
            }
          }

          e = !1;
        }
        e && (c.Fg = d, JSON.stringify(d), c = new N("qualitychange", new Map([["quality", d], ["position", a]])), this.dispatchEvent(c));
      }
    };

    function Zj(a, b) {
      if ((a = a.h()[b.contentType]) && 0 < a.length) {
        var c = a[0].start,
            d = a[a.length - 1].end,
            e = b.Dd;
        b.Dd = e.filter(function (f, g) {
          return f.position <= c && g + 1 < e.length && e[g + 1].position <= c || f.position >= d ? !1 : !0;
        });
      } else b.Dd = [];
    }

    ;

    function ak(a) {
      db.call(this);
      var b = this;
      this.g = new Set();
      this.i = a;
      this.h = new Fd(function () {
        for (var c = b.i(), d = t(b.g), e = d.next(); !e.done; e = d.next()) e = e.value, e.endTime < c.start && (b.g.delete(e), e = new N("regionremove", new Map([["region", e]])), b.dispatchEvent(e));
      }).ya(2);
    }

    pa(ak, db);

    ak.prototype.release = function () {
      this.g.clear();
      this.h.stop();
      db.prototype.release.call(this);
    };

    function bk(a, b) {
      db.call(this);
      var c = this;
      this.i = a;
      this.l = b;
      this.g = new Map();
      this.m = [{
        zc: null,
        yc: ck,
        qc: function (d, e) {
          return dk(c, "enter", d, e);
        }
      }, {
        zc: ek,
        yc: ck,
        qc: function (d, e) {
          return dk(c, "enter", d, e);
        }
      }, {
        zc: fk,
        yc: ck,
        qc: function (d, e) {
          return dk(c, "enter", d, e);
        }
      }, {
        zc: ck,
        yc: ek,
        qc: function (d, e) {
          return dk(c, "exit", d, e);
        }
      }, {
        zc: ck,
        yc: fk,
        qc: function (d, e) {
          return dk(c, "exit", d, e);
        }
      }, {
        zc: ek,
        yc: fk,
        qc: function (d, e) {
          return dk(c, "skip", d, e);
        }
      }, {
        zc: fk,
        yc: ek,
        qc: function (d, e) {
          return dk(c, "skip", d, e);
        }
      }];
      this.h = new Jf();
      this.h.o(this.i, "regionremove", function (d) {
        c.g.delete(d.region);
      });
    }

    pa(bk, db);

    bk.prototype.release = function () {
      this.i = null;
      this.g.clear();
      this.h.release();
      this.h = null;
      db.prototype.release.call(this);
    };

    bk.prototype.j = function (a, b) {
      if (!this.l || 0 != a) {
        this.l = !1;

        for (var c = t(this.i.g), d = c.next(); !d.done; d = c.next()) {
          d = d.value;
          var e = this.g.get(d),
              f = a < d.startTime ? ek : a > d.endTime ? fk : ck;
          this.g.set(d, f);

          for (var g = t(this.m), h = g.next(); !h.done; h = g.next()) h = h.value, h.zc == e && h.yc == f && h.qc(d, b);
        }
      }
    };

    function dk(a, b, c, d) {
      b = new N(b, new Map([["region", c], ["seeking", d]]));
      a.dispatchEvent(b);
    }

    var ek = 1,
        ck = 2,
        fk = 3;

    function gk(a, b, c) {
      this.i = a;
      this.h = b;
      this.j = 0;
      this.l = c;
      this.g = new Map();
    }

    function hk(a, b, c) {
      c = void 0 === c ? !1 : c;

      if (a.h.segmentIndex) {
        var d = a.h.segmentIndex.lc(Math.max(b.startTime, a.j));

        if (d) {
          var e = b;
          c && (e = d.next().value) && e.startTime == b.startTime && e.endTime == b.endTime && (e = null);

          for (; a.g.size < a.i && null != e;) b = !0, e.m && null != e.Ja && (b = !1), 2 == e.nc() && (b = !1), b && !a.g.has(e) && (b = new ik(a.l), jk(b, e, a.h), a.g.set(e, b)), a.j = e.startTime, e = d.next().value;
        }
      }
    }

    function kk(a, b) {
      if (a.h.segmentIndex && a.g.size < a.i && !a.g.has(b)) {
        var c = new ik(a.l);
        jk(c, b, a.h);
        a.g.set(b, c);
      }
    }

    function lk(a) {
      if (0 !== a.g.size) {
        for (var b = t(a.g.keys()), c = b.next(); !c.done; c = b.next()) (c = c.value) && mk(a, c);

        a.j = 0;
      }
    }

    function nk(a, b) {
      b && b !== a.h && (lk(a), a.h = b);
    }

    function mk(a, b) {
      var c = a.g.get(b);
      a.g.delete(b);
      c && c.abort();
    }

    function ik(a) {
      this.i = a;
      this.g = this.h = null;
    }

    function jk(a, b, c) {
      var d = new Uint8Array(0);
      a.g = a.i(b, c, function (e) {
        return K(function (f) {
          if (1 == f.g) return 0 < d.byteLength ? d = tg(d, e) : d = e, a.h ? D(f, a.h(d), 3) : f.F(0);
          d = new Uint8Array(0);
          F(f);
        });
      });
    }

    ik.prototype.abort = function () {
      this.g && this.g.abort();
    };

    function ok(a, b, c, d, e) {
      a = zf(a, d, e);
      if (0 != b || null != c) a.headers.Range = c ? "bytes=" + b + "-" + c : "bytes=" + b + "-";
      return a;
    }

    ;

    function pk(a, b) {
      var c = this;
      this.g = b;
      this.m = a;
      this.h = null;
      this.C = 1;
      this.s = this.j = null;
      this.H = 0;
      this.G = !1;
      this.i = new Map();
      this.D = !1;
      this.I = null;
      this.u = !1;
      this.l = new Hf(function () {
        return qk(c);
      });
      this.J = 0;
    }

    p = pk.prototype;

    p.destroy = function () {
      return this.l.destroy();
    };

    function qk(a) {
      var b, c, d, e;
      return K(function (f) {
        if (1 == f.g) {
          b = [];
          c = t(a.i.values());

          for (d = c.next(); !d.done; d = c.next()) e = d.value, rk(e), b.push(sk(e));

          return D(f, Promise.all(b), 2);
        }

        a.i.clear();
        a.g = null;
        a.m = null;
        a.h = null;
        F(f);
      });
    }

    p.configure = function (a) {
      this.h = a;
      this.I = new hf({
        maxAttempts: Math.max(a.retryParameters.maxAttempts, 2),
        baseDelay: a.retryParameters.baseDelay,
        backoffFactor: a.retryParameters.backoffFactor,
        fuzzFactor: a.retryParameters.fuzzFactor,
        timeout: 0,
        stallTimeout: 0,
        connectionTimeout: 0
      }, !0);

      for (var b = t(this.i.keys()), c = b.next(); !c.done; c = b.next()) if (c = this.i.get(c.value), c.Ha) {
        var d = c.Ha,
            e = a.segmentPrefetchLimit;
        d.i = e;

        for (var f = Array.from(d.g.keys()); f.length > e;) {
          var g = f.pop();
          g && mk(d, g);
        }

        0 < a.segmentPrefetchLimit || (c.Ha = null);
      } else 0 < a.segmentPrefetchLimit && (c.Ha = tk(this, c.stream));
    };

    p.start = function () {
      var a = this;
      return K(function (b) {
        if (1 == b.g) return D(b, uk(a), 2);
        If(a.l);
        a.D = !0;
        F(b);
      });
    };

    function vk(a, b) {
      var c, d, e, f, g, h, k;
      K(function (l) {
        switch (l.g) {
          case 1:
            return c = Nb, a.H++, d = a.H, ta(l, 2), D(l, hj(a.g.Y, c.sa), 4);

          case 4:
            va(l, 3);
            break;

          case 2:
            if (e = wa(l), a.g) a.g.onError(e);

          case 3:
            f = fd(b.mimeType, b.codecs), Ri(a.g.Y, f, a.m.sequenceMode, b.external), g = a.g.Y.H, (h = g.isTextVisible() || a.h.alwaysStreamText) && a.H == d && (k = wk(a, b), a.i.set(c.sa, k), xk(a, k, 0)), F(l);
        }
      });
    }

    function yk(a) {
      var b = a.i.get(Mb);
      b && (rk(b), sk(b).catch(function () {}), a.i.delete(Mb));
      a.s = null;
    }

    function zk(a, b) {
      var c = a.i.get("video");

      if (c) {
        var d = c.stream;
        if (d) if (b) (b = d.trickModeVideo) && !c.wc && (Ak(a, b, !1, 0, !1), c.wc = d);else if (d = c.wc) c.wc = null, Ak(a, d, !0, 0, !1);
      }
    }

    function Bk(a, b, c, d, e, f) {
      c = void 0 === c ? !1 : c;
      d = void 0 === d ? 0 : d;
      e = void 0 === e ? !1 : e;
      f = void 0 === f ? !1 : f;
      a.j = b;
      a.D && (b.video && Ak(a, b.video, c, d, e, f), b.audio && Ak(a, b.audio, c, d, e, f));
    }

    function Ck(a, b) {
      K(function (c) {
        if (1 == c.g) return a.s = b, a.D ? b.segmentIndex ? c.F(2) : D(c, b.createSegmentIndex(), 2) : c.return();
        Ak(a, b, !0, 0, !1);
        F(c);
      });
    }

    function Ak(a, b, c, d, e, f) {
      var g = a.i.get(b.type);
      g || b.type != Mb ? g && (g.wc && (b.trickModeVideo ? (g.wc = b, b = b.trickModeVideo) : g.wc = null), g.stream != b || e) && (g.Ha && nk(g.Ha, b), b.type == Mb && (e = fd(b.mimeType, b.codecs), Ri(a.g.Y, e, a.m.sequenceMode, b.external)), g.stream.closeSegmentIndex && g.stream.closeSegmentIndex(), g.stream = b, g.ea = null, g.xg = !!f, c && (g.md ? g.Je = !0 : g.Qa ? (g.Nb = !0, g.Yd = d, g.Je = !0) : (rk(g), Dk(a, g, !0, d).catch(function (h) {
        if (a.g) a.g.onError(h);
      }))), Ek(a, g).catch(function (h) {
        if (a.g) a.g.onError(h);
      })) : vk(a, b);
    }

    function Ek(a, b) {
      var c, d;
      return K(function (e) {
        if (1 == e.g) {
          if (!b.$a) return e.return();
          c = b.stream;
          d = b.$a;
          return c.segmentIndex ? e.F(2) : D(e, c.createSegmentIndex(), 2);
        }

        if (b.$a != d || b.stream != c) return e.return();
        var f = a.g.fe();
        var g = Xi(a.g.Y, b.type),
            h = b.stream.segmentIndex.find(b.Pa ? b.Pa.endTime : f),
            k = null == h ? null : b.stream.segmentIndex.get(h);
        h = k ? k.Ja ? k.Ja - k.cb : null : null;
        k && !h && (h = (k.endTime - k.getStartTime()) * (b.stream.bandwidth || 0) / 8);
        h ? ((k = k.ka) && (h += (k.Ja ? k.Ja - k.cb : null) || 0), k = a.g.getBandwidthEstimate(), f = 8 * h / k < (g || 0) - f - Math.max(a.m.minBufferTime || 0, a.h.rebufferingGoal) || b.$a.h.g > h ? !0 : !1) : f = !1;
        f && b.$a.abort();
        F(e);
      });
    }

    p.Hd = function () {
      if (this.g) for (var a = this.g.fe(), b = t(this.i.keys()), c = b.next(); !c.done; c = b.next()) {
        var d = c.value;
        c = this.i.get(d);
        var e = null;
        c.ea && (e = c.ea.current());
        if (!e || e.startTime > a || e.endTime < a) c.ea = null;
        e = this.g.Y;
        e.D ? e = !1 : d == Mb ? (e = e.h, e = null == e.g || null == e.h ? !1 : a >= e.g && a < e.h) : (e = Wi(e, d), e = Th(e, a));
        e || ((null != Xi(this.g.Y, d) || c.Qa) && Fk(this, c), c.$a && (c.$a.abort(), c.$a = null), d === Mb && (d = this.g.Y, d.J && d.J.h()), c.Hd = !0);
      }
    };

    function Fk(a, b) {
      b.md || b.Nb || (b.Qa ? (b.Nb = !0, b.Yd = 0) : null == Vi(a.g.Y, b.type) ? null == b.xb && xk(a, b, 0) : (rk(b), Dk(a, b, !1, 0).catch(function (c) {
        if (a.g) a.g.onError(c);
      })));
    }

    function uk(a) {
      var b, c, d, e, f, g, h, k, l;
      return K(function (m) {
        if (1 == m.g) {
          b = Nb;
          if (!a.j) throw new P(2, 5, 5006);
          c = new Map();
          d = new Set();
          a.j.audio && (c.set(b.T, a.j.audio), d.add(a.j.audio));
          a.j.video && (c.set(b.ia, a.j.video), d.add(a.j.video));
          a.s && (c.set(b.sa, a.s), d.add(a.s));
          e = a.g.Y;
          return D(m, e.init(c, a.m.sequenceMode, a.m.type, a.m.ignoreManifestTimestampsInSegmentsMode), 2);
        }

        If(a.l);
        a.updateDuration();
        f = t(c.keys());

        for (g = f.next(); !g.done; g = f.next()) h = g.value, k = c.get(h), a.i.has(h) || (l = wk(a, k), a.i.set(h, l), xk(a, l, 0));

        F(m);
      });
    }

    function wk(a, b) {
      return {
        stream: b,
        type: b.type,
        ea: null,
        Ha: tk(a, b),
        Pa: null,
        Zb: null,
        Lf: null,
        Jf: null,
        If: null,
        wc: null,
        endOfStream: !1,
        Qa: !1,
        xb: null,
        Nb: !1,
        Yd: 0,
        Je: !1,
        md: !1,
        Hd: !0,
        Pf: !1,
        Zf: !1,
        ud: !1,
        $a: null
      };
    }

    function tk(a, b) {
      return "video" !== b.type && "audio" !== b.type ? null : 0 < a.h.segmentPrefetchLimit ? new gk(a.h.segmentPrefetchLimit, b, function (c, d, e) {
        return Gk(a, c, d, e);
      }) : null;
    }

    p.updateDuration = function () {
      var a = this.m.presentationTimeline.getDuration();
      Infinity > a ? this.g.Y.bb(a) : this.g.Y.bb(Math.pow(2, 32));
    };

    function Hk(a, b) {
      var c, d, e, f, g;
      return K(function (h) {
        switch (h.g) {
          case 1:
            If(a.l);
            if (b.Qa || null == b.xb || b.md) return h.return();
            b.xb = null;

            if (!b.Nb) {
              h.F(2);
              break;
            }

            return D(h, Dk(a, b, b.Je, b.Yd), 3);

          case 3:
            return h.return();

          case 2:
            if (b.stream.segmentIndex) {
              h.F(4);
              break;
            }

            c = b.stream;
            return D(h, b.stream.createSegmentIndex(), 5);

          case 5:
            if (c != b.stream) return c.closeSegmentIndex && c.closeSegmentIndex(), b.Qa || b.xb || xk(a, b, 0), h.return();

          case 4:
            ta(h, 6);
            d = Ik(a, b);
            null != d && (xk(a, b, d), b.ud = !1);
            va(h, 7);
            break;

          case 6:
            return e = wa(h), D(h, Jk(a, b, e), 8);

          case 8:
            return h.return();

          case 7:
            f = Array.from(a.i.values());

            if (!a.D || !f.every(function (k) {
              return k.endOfStream;
            })) {
              h.F(0);
              break;
            }

            return D(h, a.g.Y.endOfStream(), 10);

          case 10:
            If(a.l), g = a.g.Y.getDuration(), 0 != g && g < a.m.presentationTimeline.getDuration() && a.m.presentationTimeline.bb(g), F(h);
        }
      });
    }

    function Ik(a, b) {
      if (Kk(b)) return ej(a.g.Y, b.stream.originalId || ""), null;
      b.type == Mb && fj(a.g.Y);
      if (!a.g.Y.aa && b.type != Mb) return a.h.updateIntervalSeconds / 2;
      var c = a.g.fe(),
          d = b.Pa ? b.Pa.endTime : c,
          e = Yi(a.g.Y, b.type, c),
          f = Math.max(1, Math.max(a.m.minBufferTime || 0, a.h.rebufferingGoal, a.h.bufferingGoal) * a.C),
          g = a.m.presentationTimeline.getDuration() - d,
          h = Xi(a.g.Y, b.type);
      if (1E-6 > g && h) return b.endOfStream = !0, "video" == b.type && (a = a.i.get(Mb)) && Kk(a) && (a.endOfStream = !0), null;
      b.endOfStream = !1;
      if (e >= f) return a.h.updateIntervalSeconds / 2;
      e = Lk(a, b, c, h);
      if (!e) return a.h.updateIntervalSeconds;
      f = Infinity;
      g = Array.from(a.i.values());
      g = t(g);

      for (h = g.next(); !h.done; h = g.next()) h = h.value, Kk(h) || h.ea && !h.ea.current() || (f = Math.min(f, h.Pa ? h.Pa.endTime : c));

      if (d >= f + a.m.presentationTimeline.g) return a.h.updateIntervalSeconds;
      b.Ha && b.ea && (d = e.ka, !d || b.Pa && Oh(d, b.Zb) || kk(b.Ha, d), hk(b.Ha, e));
      Mk(a, b, c, e).catch(function () {});
      return null;
    }

    function Lk(a, b, c, d) {
      if (b.ea) return b.ea.current();
      if (b.Pa || d) return c = b.Pa ? b.Pa.endTime : d, b.Pf = !0, b.ea = b.stream.segmentIndex.lc(c), b.ea && b.ea.next().value;
      a = a.h.inaccurateManifestTolerance;
      d = Math.max(c - a, 0);
      var e = null;
      a && (b.ea = b.stream.segmentIndex.lc(d), e = b.ea && b.ea.next().value);
      e || (b.ea = b.stream.segmentIndex.lc(c), e = b.ea && b.ea.next().value);
      return e;
    }

    function Mk(a, b, c, d) {
      var e, f, g, h, k, l, m, n, r, q, u, v, y, z, x, B;
      return K(function (A) {
        switch (A.g) {
          case 1:
            e = Nb;
            f = b.stream;
            g = b.ea;
            b.Qa = !0;
            ta(A, 2);
            if (2 == d.nc()) throw new P(1, 1, 1011);
            return D(A, Nk(a, b, d), 4);

          case 4:
            If(a.l);
            if (a.u) return A.return();
            h = "video/mp4" == f.mimeType || "audio/mp4" == f.mimeType;
            k = window.ReadableStream;
            if (a.h.lowLatencyMode && k && h && ("HLS" != a.m.type || d.s)) return n = new Uint8Array(0), q = r = !1, v = function (C) {
              var E, H, G, I;
              return K(function (J) {
                switch (J.g) {
                  case 1:
                    if (r) return J.return();
                    q = !0;
                    If(a.l);
                    if (a.u) return J.return();
                    ta(J, 2);
                    n = Ok(n, C);
                    E = !1;
                    H = 0;
                    new bg().box("mdat", function (L) {
                      H = L.size + L.start;
                      E = !0;
                    }).parse(n, !1, !0);

                    if (!E) {
                      J.F(4);
                      break;
                    }

                    G = n.subarray(0, H);
                    n = n.subarray(H);
                    return D(J, Pk(a, b, c, f, d, G, !0), 5);

                  case 5:
                    b.Ha && b.ea && hk(b.Ha, d, !0);

                  case 4:
                    va(J, 0);
                    break;

                  case 2:
                    u = I = wa(J), F(J);
                }
              });
            }, D(A, Qk(a, b, d, v), 9);
            l = Qk(a, b, d);
            return D(A, l, 7);

          case 7:
            m = A.h;
            If(a.l);
            if (a.u) return A.return();
            If(a.l);
            return b.Nb ? (b.Qa = !1, xk(a, b, 0), A.return()) : D(A, Pk(a, b, c, f, d, m), 6);

          case 9:
            y = A.h;
            if (u) throw u;

            if (q) {
              A.F(10);
              break;
            }

            r = !0;
            If(a.l);
            return a.u ? A.return() : b.Nb ? (b.Qa = !1, xk(a, b, 0), A.return()) : D(A, Pk(a, b, c, f, d, y), 10);

          case 10:
            b.Ha && b.ea && hk(b.Ha, d, !0);

          case 6:
            If(a.l);
            if (a.u) return A.return();
            b.Pa = d;
            g.next();
            b.Qa = !1;
            b.Zf = !1;
            z = a.g.Y.Fb();
            x = z[b.type];
            $a(JSON.stringify(x));
            b.Nb || a.g.Tf(d.startTime, d.endTime, b.type);
            xk(a, b, 0);
            va(A, 0);
            break;

          case 2:
            B = wa(A);
            If(a.l, B);
            if (a.u) return A.return();
            b.Qa = !1;
            if (7001 == B.code) b.Qa = !1, rk(b), xk(a, b, 0), A.F(0);else if (b.type == e.sa && a.h.ignoreTextStreamFailures) a.i.delete(e.sa), A.F(0);else if (3017 == B.code) Rk(a, b, B), A.F(0);else return b.ud = !0, B.severity = 2, D(A, Jk(a, b, B), 0);
        }
      });
    }

    function Sk(a, b, c) {
      var d, e, f, g;
      return K(function (h) {
        if (1 == h.g) return d = b, d.cryptoKey ? h.F(2) : D(h, d.fetchKey(), 3);
        e = d.iv;
        if (!e) for (e = nc(new ArrayBuffer(16)), f = d.firstMediaSequenceNumber + c, g = e.byteLength - 1; 0 <= g; g--) e[g] = f & 255, f >>= 8;
        return h.return(window.crypto.subtle.decrypt({
          name: "AES-CBC",
          iv: e
        }, d.cryptoKey, a));
      });
    }

    function Ok(a, b) {
      var c = new Uint8Array(a.length + b.length);
      c.set(a);
      c.set(b, a.length);
      return c;
    }

    function Rk(a, b, c) {
      if (!Array.from(a.i.values()).some(function (e) {
        return e != b && e.Zf;
      })) {
        if (0 < a.h.maxDisabledTime && a.g.Zd(b.stream, a.h.maxDisabledTime)) return;
        var d = Math.round(100 * a.C);
        if (20 < d) a.C -= .2;else if (4 < d) a.C -= .04;else {
          b.ud = !0;
          a.u = !0;
          a.g.onError(c);
          return;
        }
        b.Zf = !0;
      }

      xk(a, b, 4);
    }

    function Nk(a, b, c) {
      var d, e, f, g, h, k, l, m, n, r, q, u, v;
      return K(function (y) {
        if (1 == y.g) {
          d = Nb;
          e = [];
          f = Math.max(0, c.appendWindowStart - .1);
          g = c.appendWindowEnd + .01;
          h = nd(b.stream.codecs);
          k = od(b.stream.mimeType);
          l = c.timestampOffset;
          if (l == b.Lf && f == b.Jf && g == b.If && h == b.Kf && k == b.Tg) return y.F(2);
          if (m = b.Kf && b.Tg && rj(a.g.Y, b.type, b.stream)) n = null, b.type === d.ia ? n = a.i.get(d.T) : b.type === d.T && (n = a.i.get(d.ia)), n && (n.Zb = null, Fk(a, n), sk(n).catch(function () {}));

          r = function () {
            var z, x, B, A;
            return K(function (C) {
              if (1 == C.g) return z = new Map(), a.j.audio && z.set(d.T, a.j.audio), a.j.video && z.set(d.ia, a.j.video), ta(C, 2), b.Jf = f, b.If = g, b.Kf = h, b.Tg = k, b.Lf = l, x = a.m.sequenceMode || "HLS" == a.m.type, D(C, ij(a.g.Y, b.type, l, f, g, x, c.mimeType || b.stream.mimeType, c.codecs || b.stream.codecs, z), 4);
              if (2 != C.g) return m && (B = null, b.type === d.ia ? B = a.i.get(d.T) : b.type === d.T && (B = a.i.get(d.ia)), B && (B.Nb = !1, B.Qa = !1, Fk(a, B))), va(C, 0);
              A = wa(C);
              b.Jf = null;
              b.If = null;
              b.Kf = null;
              b.Lf = null;
              throw A;
            });
          };

          return D(y, r(), 2);
        }

        Oh(c.ka, b.Zb) || (b.Zb = c.ka, c.l && c.ka && (q = Qk(a, b, c.ka), u = function () {
          var z, x, B, A, C, E;
          return K(function (H) {
            switch (H.g) {
              case 1:
                return ta(H, 2), D(H, q, 4);

              case 4:
                return z = H.h, If(a.l), x = null, B = new Map(), A = new bg(), A.box("moov", gg).box("trak", gg).box("mdia", gg).W("mdhd", function (G) {
                  x = fi(G.reader, G.version).timescale;
                }).box("hdlr", function (G) {
                  G = G.reader;
                  G.skip(8);
                  G = G.Kb(4);
                  var I = String.fromCharCode(G[0]);
                  I += String.fromCharCode(G[1]);
                  I += String.fromCharCode(G[2]);
                  I += String.fromCharCode(G[3]);

                  switch (I) {
                    case "soun":
                      B.set(d.T, x);
                      break;

                    case "vide":
                      B.set(d.ia, x);
                  }

                  x = null;
                }).parse(z), B.has(b.type) ? c.ka.timescale = B.get(b.type) : null != x && (c.ka.timescale = x), C = b.stream.closedCaptions && 0 < b.stream.closedCaptions.size, D(H, a.g.zg(b.type, z), 5);

              case 5:
                return D(H, $i(a.g.Y, b.type, z, null, b.stream, C), 6);

              case 6:
                va(H, 0);
                break;

              case 2:
                throw E = wa(H), b.Zb = null, E;
            }
          });
        }, a.g.Mi(c.startTime, c.ka), e.push(u())));
        a.m.sequenceMode && (v = b.Pa ? b.Pa.j : null, c.j != v || b.Pf) && (b.Pf = !1, e.push(kj(a.g.Y, b.type, c.startTime)));
        return D(y, Promise.all(e), 0);
      });
    }

    function Pk(a, b, c, d, e, f, g) {
      g = void 0 === g ? !1 : g;
      var h, k, l, m, n, r;
      return K(function (q) {
        switch (q.g) {
          case 1:
            h = d.closedCaptions && 0 < d.closedCaptions.size;
            l = null != d.emsgSchemeIdUris && 0 < d.emsgSchemeIdUris.length || a.h.dispatchAllEmsgBoxes;
            m = a.h.parsePrftBox && !a.G;
            if (l || m) k = new bg();
            l && k.W("emsg", function (u) {
              var v = d.emsgSchemeIdUris;

              if (0 === u.version) {
                var y = u.reader.Ed();
                var z = u.reader.Ed();
                var x = u.reader.O();
                var B = u.reader.O();
                var A = u.reader.O();
                var C = u.reader.O();
                var E = e.startTime + B / x;
              } else x = u.reader.O(), E = u.reader.Rc() / x + e.timestampOffset, B = E - e.startTime, A = u.reader.O(), C = u.reader.O(), y = u.reader.Ed(), z = u.reader.Ed();

              u = u.reader.Kb(u.reader.getLength() - u.reader.Ea());
              if (v && v.includes(y) || a.h.dispatchAllEmsgBoxes) "urn:mpeg:dash:event:2012" == y ? a.g.Ni() : (v = new Map().set("detail", {
                startTime: E,
                endTime: E + A / x,
                schemeIdUri: y,
                value: z,
                timescale: x,
                presentationTimeDelta: B,
                eventDuration: A,
                id: C,
                messageData: u
              }), v = new N("emsg", v), v.cancelable = !0, a.g.onEvent(v), v.defaultPrevented || "https://aomedia.org/emsg/ID3" != y && "https://developer.apple.com/streaming/emsg-id3" != y || (y = bi(u), y.length && e && a.g.Oi([{
                cueTime: e.startTime,
                data: u,
                frames: y,
                dts: e.startTime,
                pts: e.startTime
              }], 0, e.endTime)));
            });
            m && k.W("prft", function (u) {
              if (!a.G && e.ka.timescale) {
                var v = u.reader,
                    y = u.version;
                v.O();
                u = v.O();
                var z = v.O();
                u = 1E3 * u + z / Math.pow(2, 32) * 1E3;
                0 === y ? v = v.O() : (y = v.O(), v = v.O(), v = y * Math.pow(2, 32) + v);
                u = new Date(new Date(Date.UTC(1900, 0, 1, 0, 0, 0)).getTime() + u).getTime();
                v = new Map().set("detail", {
                  wallClockTime: u,
                  programStartDate: new Date(u - v / e.ka.timescale * 1E3)
                });
                v = new N("prft", v);
                a.g.onEvent(v);
                a.G = !0;
              }
            });
            (l || m) && k.parse(f);
            return D(q, Tk(a, b, c), 2);

          case 2:
            return If(a.l), n = b.Hd, b.Hd = !1, r = b.xg, b.xg = !1, D(q, a.g.zg(b.type, f), 3);

          case 3:
            return D(q, $i(a.g.Y, b.type, f, e, d, h, n, r, g), 4);

          case 4:
            If(a.l), F(q);
        }
      });
    }

    function Tk(a, b, c) {
      var d, e, f, g;
      return K(function (h) {
        if (1 == h.g) {
          d = Math.max(a.h.bufferBehind, a.m.presentationTimeline.g);
          e = Vi(a.g.Y, b.type);
          if (null == e) return h.return();
          f = c - e;
          g = f - d;
          return .01 >= g ? h.return() : D(h, a.g.Y.remove(b.type, e, e + g), 2);
        }

        If(a.l);
        F(h);
      });
    }

    function Kk(a) {
      return a && a.type == Mb && ("application/cea-608" == a.stream.mimeType || "application/cea-708" == a.stream.mimeType);
    }

    function Qk(a, b, c, d) {
      var e, f, g, h, k;
      return K(function (l) {
        switch (l.g) {
          case 1:
            if (c instanceof Nh && (e = c.g)) return l.return(e);
            f = null;

            if (b.Ha) {
              var m = b.Ha;

              if (m.g.has(c)) {
                var n = m.g.get(c);
                d && (n.h = d);
                m.g.delete(c);
                f = n.g;
              } else f = null;
            }

            f || (f = Gk(a, c, b.stream, d));
            g = 0;
            b.ea && (g = b.ea.g);
            b.$a = f;
            return D(l, f.promise, 2);

          case 2:
            h = l.h;
            b.$a = null;
            k = h.data;

            if (!c.aes128Key) {
              l.F(3);
              break;
            }

            return D(l, Sk(k, c.aes128Key, g), 4);

          case 4:
            k = l.h;

          case 3:
            return l.return(k);
        }
      });
    }

    function Gk(a, b, c, d) {
      var e = b instanceof Ph ? b : void 0,
          f = e ? 1 : 0;
      b = ok(b.ba(), b.cb, b.Ja, a.h.retryParameters, d);
      return a.g.vc.request(Ff, b, {
        type: f,
        stream: c,
        segment: e
      });
    }

    function Dk(a, b, c, d) {
      var e, f;
      return K(function (g) {
        if (1 == g.g) return b.Nb = !1, b.Je = !1, b.Yd = 0, b.md = !0, b.Pa = null, b.Zb = null, b.ea = null, b.Ha && lk(b.Ha), d ? (e = a.g.fe(), f = a.g.Y.getDuration(), D(g, a.g.Y.remove(b.type, e + d, f), 3)) : D(g, hj(a.g.Y, b.type), 4);
        if (3 != g.g) return If(a.l), c ? D(g, a.g.Y.flush(b.type), 3) : g.F(3);
        If(a.l);
        b.md = !1;
        b.endOfStream = !1;
        b.Qa || b.xb || xk(a, b, 0);
        F(g);
      });
    }

    function xk(a, b, c) {
      var d = b.type;
      if (d != Mb || a.i.has(d)) b.xb = new Ed(function () {
        var e;
        return K(function (f) {
          if (1 == f.g) return ta(f, 2), D(f, Hk(a, b), 4);
          if (2 != f.g) return va(f, 0);
          e = wa(f);
          if (a.g) a.g.onError(e);
          F(f);
        });
      }).R(c);
    }

    function rk(a) {
      null != a.xb && (a.xb.stop(), a.xb = null);
    }

    function sk(a) {
      return K(function (b) {
        return a.$a ? D(b, a.$a.abort(), 0) : b.F(0);
      });
    }

    function Jk(a, b, c) {
      var d;
      return K(function (e) {
        if (1 == e.g) return D(e, kf(a.I), 2);
        If(a.l);
        d = 0 === a.h.maxDisabledTime && 1011 == c.code ? 1 : a.h.maxDisabledTime;
        1 === c.category && 0 < d && (c.handled = a.g.Zd(b.stream, d), c.handled && (c.severity = 1));
        a.g.onError(c);
        c.handled || a.h.failureCallback(c);
        F(e);
      });
    }

    function Uk(a) {
      var b, c, d, e, f, g;
      return K(function (h) {
        if (1 == h.g) {
          b = Date.now() / 1E3;
          c = a.h.minTimeBetweenRecoveries;
          if (!a.h.allowMediaSourceRecoveries || b - a.J < c) return h.return(!1);
          a.J = b;
          d = Nb;
          if (e = a.i.get(d.T)) e.Zb = null, Fk(a, e), sk(e).catch(function () {});
          if (f = a.i.get(d.ia)) f.Zb = null, Fk(a, f), sk(f).catch(function () {});
          g = new Map();
          a.j.audio && g.set(d.T, a.j.audio);
          a.j.video && g.set(d.ia, a.j.video);
          return D(h, qj(a.g.Y, g), 2);
        }

        return h.return(!0);
      });
    }

    ;

    function Vk(a, b, c) {
      var d, e, f, g, h, k, l;
      return K(function (m) {
        switch (m.g) {
          case 1:
            var n = new kb(a).Va.split("/").pop().split(".");
            d = 1 == n.length ? "" : n.pop().toLowerCase();
            if (e = Wk[d]) return m.return(e);
            f = 0;
            g = zf([a], c);
            ta(m, 2);
            g.method = "HEAD";
            return D(m, b.request(f, g).promise, 4);

          case 4:
            h = m.h;
            e = h.headers["content-type"];
            va(m, 3);
            break;

          case 2:
            k = wa(m);

            if (!k || 1002 != k.code) {
              m.F(3);
              break;
            }

            g.method = "GET";
            return D(m, b.request(f, g).promise, 6);

          case 6:
            l = m.h, e = l.headers["content-type"];

          case 3:
            return m.return(e ? e.toLowerCase().split(";").shift() : "");
        }
      });
    }

    var Wk = {
      mp4: "video/mp4",
      m4v: "video/mp4",
      m4a: "audio/mp4",
      webm: "video/webm",
      weba: "audio/webm",
      mkv: "video/webm",
      ts: "video/mp2t",
      ogv: "video/ogg",
      ogg: "audio/ogg",
      mpg: "video/mpeg",
      mpeg: "video/mpeg",
      m3u8: "application/x-mpegurl",
      mpd: "application/dash+xml",
      ism: "application/vnd.ms-sstr+xml",
      mp3: "audio/mpeg",
      aac: "audio/aac",
      flac: "audio/flac",
      wav: "audio/wav",
      sbv: "text/x-subviewer",
      srt: "text/srt",
      vtt: "text/vtt",
      webvtt: "text/vtt",
      ttml: "application/ttml+xml",
      lrc: "application/x-subtitle-lrc",
      ssa: "text/x-ssa",
      ass: "text/x-ssa"
    };

    function Xk(a, b) {
      if (a.lineBreak) return "\n";
      if (a.nestedCues.length) return a.nestedCues.map(function (g) {
        return Xk(g, a);
      }).join("");
      var c = [],
          d = 700 <= a.fontWeight,
          e = "italic" == a.fontStyle,
          f = a.textDecoration.includes("underline");
      d && c.push(["b"]);
      e && c.push(["i"]);
      f && c.push(["u"]);
      e = a.color;
      "" == e && b && (e = b.color);
      d = "";
      (e = Yk(e)) && (d += "." + e);
      e = a.backgroundColor;
      "" == e && b && (e = b.backgroundColor);
      (b = Yk(e)) && (d += ".bg_" + b);
      d && c.push(["c", d]);
      return c.reduceRight(function (g, h) {
        var k = t(h);
        h = k.next().value;
        k = k.next().value;
        return "<" + h + (void 0 === k ? "" : k) + ">" + g + "</" + h + ">";
      }, a.payload);
    }

    function Yk(a) {
      a = a.toLowerCase();
      var b = a.replace(/\s/g, "").match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i);
      b ? a = "#" + (parseInt(b[1], 10) | 256).toString(16).slice(1) + (parseInt(b[2], 10) | 256).toString(16).slice(1) + (parseInt(b[3], 10) | 256).toString(16).slice(1) : a.startsWith("#") && 7 < a.length && (a = a.slice(0, 7));

      switch (a) {
        case "white":
        case "#fff":
        case "#ffffff":
          return "white";

        case "lime":
        case "#0f0":
        case "#00ff00":
          return "lime";

        case "cyan":
        case "#0ff":
        case "#00ffff":
          return "cyan";

        case "red":
        case "#f00":
        case "#ff0000":
          return "red";

        case "yellow":
        case "#ff0":
        case "#ffff00":
          return "yellow";

        case "magenta":
        case "#f0f":
        case "#ff00ff":
          return "magenta";

        case "blue":
        case "#00f":
        case "#0000ff":
          return "blue";

        case "black":
        case "#000":
        case "#000000":
          return "black";
      }

      return null;
    }

    function Zk(a, b) {
      var c = [];
      a = t(a);

      for (var d = a.next(); !d.done; d = a.next()) if (d = d.value, d.isContainer) c.push.apply(c, w(Zk(d.nestedCues, d)));else {
        var e = d.clone();
        e.nestedCues = [];
        e.payload = Xk(d, b);
        c.push(e);
      }

      return c;
    }

    ;

    function $k(a, b) {
      this.g = null;

      for (var c = t(Array.from(a.textTracks)), d = c.next(); !d.done; d = c.next()) d = d.value, d.mode = "disabled", d.label == b && (this.g = d);

      this.g || (this.g = a.addTextTrack("subtitles", b));
      this.g.mode = "hidden";
    }

    p = $k.prototype;

    p.remove = function (a, b) {
      if (!this.g) return !1;
      al(this.g, function (c) {
        return c.startTime < b && c.endTime > a;
      });
      return !0;
    };

    p.append = function (a) {
      var b = Zk(a),
          c = [];
      a = this.g.cues ? Array.from(this.g.cues) : [];
      var d = {};
      b = t(b);

      for (var e = b.next(); !e.done; d = {
        Ac: d.Ac
      }, e = b.next()) d.Ac = e.value, a.some(function (f) {
        return function (g) {
          return g.startTime == f.Ac.startTime && g.endTime == f.Ac.endTime && g.text == f.Ac.payload ? !0 : !1;
        };
      }(d)) || (e = bl(d.Ac)) && c.push(e);

      a = c.slice().sort(function (f, g) {
        return f.startTime != g.startTime ? f.startTime - g.startTime : f.endTime != g.endTime ? f.endTime - g.startTime : "line" in VTTCue.prototype ? c.indexOf(g) - c.indexOf(f) : c.indexOf(f) - c.indexOf(g);
      });
      a = t(a);

      for (d = a.next(); !d.done; d = a.next()) this.g.addCue(d.value);
    };

    p.destroy = function () {
      this.g && (al(this.g, function () {
        return !0;
      }), this.g.mode = "disabled");
      this.g = null;
      return Promise.resolve();
    };

    p.isTextVisible = function () {
      return "showing" == this.g.mode;
    };

    p.setTextVisibility = function (a) {
      this.g.mode = a ? "showing" : "hidden";
    };

    function bl(a) {
      if (a.startTime >= a.endTime) return null;
      var b = new VTTCue(a.startTime, a.endTime, a.payload);
      b.lineAlign = a.lineAlign;
      b.positionAlign = a.positionAlign;
      a.size && (b.size = a.size);

      try {
        b.align = a.textAlign;
      } catch (c) {}

      "center" == a.textAlign && "center" != b.align && (b.align = "middle");
      "vertical-lr" == a.writingMode ? b.vertical = "lr" : "vertical-rl" == a.writingMode && (b.vertical = "rl");
      1 == a.lineInterpretation && (b.snapToLines = !1);
      null != a.line && (b.line = a.line);
      null != a.position && (b.position = a.position);
      return b;
    }

    function al(a, b) {
      var c = a.mode;
      a.mode = "showing" == c ? "showing" : "hidden";

      for (var d = t(Array.from(a.cues)), e = d.next(); !e.done; e = d.next()) (e = e.value) && b(e) && a.removeCue(e);

      a.mode = c;
    }

    M("shaka.text.SimpleTextDisplayer", $k);
    $k.prototype.setTextVisibility = $k.prototype.setTextVisibility;
    $k.prototype.isTextVisible = $k.prototype.isTextVisible;
    $k.prototype.destroy = $k.prototype.destroy;
    $k.prototype.append = $k.prototype.append;
    $k.prototype.remove = $k.prototype.remove;
    /*
    @license
    Shaka Player
    Copyright 2023 Google LLC
    SPDX-License-Identifier: Apache-2.0
    */

    function cl() {}

    p = cl.prototype;

    p.remove = function () {};

    p.append = function () {};

    p.destroy = function () {};

    p.isTextVisible = function () {
      return !1;
    };

    p.setTextVisibility = function () {};

    M("shaka.text.StubTextDisplayer", cl);
    cl.prototype.setTextVisibility = cl.prototype.setTextVisibility;
    cl.prototype.isTextVisible = cl.prototype.isTextVisible;
    cl.prototype.destroy = cl.prototype.destroy;
    cl.prototype.append = cl.prototype.append;
    cl.prototype.remove = cl.prototype.remove;

    function dl() {}

    function T(a) {
      return document.createElement(a);
    }

    function el() {
      var a = document.createElement("button");
      a.setAttribute("type", "button");
      return a;
    }

    function fl(a) {
      for (; a.firstChild;) a.removeChild(a.firstChild);
    }

    M("shaka.util.Dom", dl);
    dl.removeAllChildren = fl;

    function gl(a, b) {
      var c = this;
      this.m = !1;
      this.i = [];
      this.D = a;
      this.u = b;
      this.j = null;
      this.g = T("div");
      this.g.classList.add("shaka-text-container");
      this.g.style.textAlign = "center";
      this.g.style.display = "flex";
      this.g.style.flexDirection = "column";
      this.g.style.alignItems = "center";
      this.g.style.justifyContent = "flex-end";
      this.u.appendChild(this.g);
      this.G = new Fd(function () {
        hl(c);
      }).ya(.25);
      this.h = new Map();
      this.l = new Jf();
      this.l.o(document, "fullscreenchange", function () {
        hl(c, !0);
      });
      this.l.o(this.D, "resize", function () {
        var d = c.D,
            e = d.videoWidth;
        d = d.videoHeight;
        e && d ? c.j = e / d : c.j = null;
      });
      this.s = null;
      "ResizeObserver" in window && (this.s = new ResizeObserver(function () {
        hl(c, !0);
      }), this.s.observe(this.g));
      this.C = new Map();
    }

    p = gl.prototype;

    p.append = function (a) {
      var b = [].concat(w(this.i)),
          c = {};
      a = t(a);

      for (var d = a.next(); !d.done; c = {
        Nd: c.Nd
      }, d = a.next()) c.Nd = d.value, b.some(function (e) {
        return function (f) {
          return Oc(f, e.Nd);
        };
      }(c)) || this.i.push(c.Nd);

      hl(this);
    };

    p.destroy = function () {
      if (!this.g) return Promise.resolve();
      this.u.removeChild(this.g);
      this.g = null;
      this.m = !1;
      this.i = [];
      this.G && this.G.stop();
      this.h.clear();
      this.l && (this.l.release(), this.l = null);
      this.s && (this.s.disconnect(), this.s = null);
      return Promise.resolve();
    };

    p.remove = function (a, b) {
      if (!this.g) return !1;
      var c = this.i.length;
      this.i = this.i.filter(function (d) {
        return d.startTime < a || d.endTime >= b;
      });
      hl(this, c > this.i.length);
      return !0;
    };

    p.isTextVisible = function () {
      return this.m;
    };

    p.setTextVisibility = function (a) {
      this.m = a;
    };

    function il(a, b) {
      for (; null != b;) {
        if (b == a.g) return !0;
        b = b.parentElement;
      }

      return !1;
    }

    function jl(a, b, c, d, e) {
      var f = !1,
          g = [],
          h = [];
      b = t(b);

      for (var k = b.next(); !k.done; k = b.next()) {
        k = k.value;
        e.push(k);
        var l = a.h.get(k),
            m = k.startTime <= d && k.endTime > d,
            n = l ? l.sh : null;
        l && (g.push(l.df), l.Fd && g.push(l.Fd), m || (f = !0, a.h.delete(k), l = null));
        m && (h.push(k), l ? il(a, n) || (f = !0) : (kl(a, k, e), l = a.h.get(k), n = l.sh, f = !0));
        0 < k.nestedCues.length && n && jl(a, k.nestedCues, n, d, e);
        e.pop();
      }

      if (f) {
        d = t(g);

        for (e = d.next(); !e.done; e = d.next()) e = e.value, e.parentElement && e.parentElement.removeChild(e);

        h.sort(function (r, q) {
          return r.startTime != q.startTime ? r.startTime - q.startTime : r.endTime - q.endTime;
        });
        h = t(h);

        for (k = h.next(); !k.done; k = h.next()) d = a.h.get(k.value), d.Fd ? (c.appendChild(d.Fd), d.Fd.appendChild(d.df)) : c.appendChild(d.df);
      }
    }

    function hl(a, b) {
      if (a.g) {
        var c = a.D.currentTime;

        if (!a.m || (void 0 === b ? 0 : b)) {
          b = t(a.C.values());

          for (var d = b.next(); !d.done; d = b.next()) fl(d.value);

          fl(a.g);
          a.h.clear();
          a.C.clear();
        }

        if (a.m) {
          b = new Map();
          d = t(a.h.keys());

          for (var e = d.next(); !e.done; e = d.next()) e = e.value, b.set(e, a.h.get(e));

          jl(a, a.i, a.g, c, []);
        }
      }
    }

    function kl(a, b, c) {
      var d = 1 < c.length,
          e = d ? "span" : "div";
      b.lineBreak && (e = "br");
      b.rubyTag && (e = b.rubyTag);
      d = !d && 0 < b.nestedCues.length;
      var f = T(e);
      "br" != e && ll(a, f, b, c, d);
      c = null;

      if (b.region && b.region.id) {
        c = b.region;
        e = a.j === 4 / 3 ? 2.5 : 1.9;
        var g = c.id + "_" + c.width + "x" + c.height + (c.heightUnits == Vc ? "%" : "px") + "-" + c.viewportAnchorX + "x" + c.viewportAnchorY + (c.viewportAnchorUnits == Vc ? "%" : "px");
        if (a.C.has(g)) c = a.C.get(g);else {
          var h = T("span"),
              k = c.heightUnits == Vc ? "%" : "px",
              l = c.widthUnits == Vc ? "%" : "px",
              m = c.viewportAnchorUnits == Vc ? "%" : "px";
          h.id = "shaka-text-region---" + g;
          h.classList.add("shaka-text-region");
          h.style.position = "absolute";
          2 === c.heightUnits && 2 === c.widthUnits ? (h.style.height = 5.33 * c.height + "%", h.style.width = c.width * e + "%") : (h.style.height = c.height + k, h.style.width = c.width + l);
          2 === c.viewportAnchorUnits ? (k = c.viewportAnchorY / 75 * 100, l = c.viewportAnchorX / (a.j === 4 / 3 ? 160 : 210) * 100, k -= c.regionAnchorY * c.height * 5.33 / 100, l -= c.regionAnchorX * c.width * e / 100, h.style.top = k + "%", h.style.left = l + "%") : (h.style.top = c.viewportAnchorY - c.regionAnchorY * c.height / 100 + m, h.style.left = c.viewportAnchorX - c.regionAnchorX * c.width / 100 + m);
          h.style.display = "flex";
          h.style.flexDirection = "column";
          h.style.alignItems = "center";
          h.style.justifyContent = "before" == b.displayAlign ? "flex-start" : "center" == b.displayAlign ? "center" : "flex-end";
          a.C.set(g, h);
          c = h;
        }
      }

      e = f;
      d && (e = T("span"), e.classList.add("shaka-text-wrapper"), e.style.backgroundColor = b.backgroundColor, e.style.lineHeight = "normal", f.appendChild(e));
      a.h.set(b, {
        df: f,
        sh: e,
        Fd: c
      });
    }

    function ml(a) {
      var b = a.direction,
          c = a.positionAlign;
      a = a.textAlign;
      return c !== Cc ? c : "left" === a || "start" === a && b === Fc || "end" === a && "rtl" === b ? "line-left" : "right" === a || "start" === a && "rtl" === b || "end" === a && b === Fc ? "line-right" : "center";
    }

    function ll(a, b, c, d, e) {
      var f = b.style,
          g = 0 == c.nestedCues.length,
          h = 1 < d.length;
      f.whiteSpace = "pre-wrap";
      var k = c.payload.replace(/\s+$/g, function (m) {
        return "\u00a0".repeat(m.length);
      });
      f.webkitTextStrokeColor = c.textStrokeColor;
      f.webkitTextStrokeWidth = c.textStrokeWidth;
      f.color = c.color;
      f.direction = c.direction;
      f.opacity = c.opacity;
      f.paddingLeft = nl(c.linePadding, c, a.u);
      f.paddingRight = nl(c.linePadding, c, a.u);
      f.textCombineUpright = c.textCombineUpright;
      f.textShadow = c.textShadow;
      if (c.backgroundImage) f.backgroundImage = "url('" + c.backgroundImage + "')", f.backgroundRepeat = "no-repeat", f.backgroundSize = "contain", f.backgroundPosition = "center", f.width = "100%", f.height = "100%";else {
        if (c.nestedCues.length) var l = b;else l = T("span"), b.appendChild(l);
        c.border && (l.style.border = c.border);
        !e && ((b = ol(d, function (m) {
          return m.backgroundColor;
        })) ? l.style.backgroundColor = b : k && (l.style.backgroundColor = "rgba(0, 0, 0, 0.8)"), b = ol(d, function (m) {
          return m.fontFamily;
        })) && (l.style.fontFamily = b);
        k && (l.textContent = k);
      }
      h && !d[d.length - 1].isContainer ? f.display = "inline" : (f.display = "flex", f.flexDirection = "column", f.alignItems = "center", f.justifyContent = "before" == c.displayAlign ? "flex-start" : "center" == c.displayAlign ? "center" : "flex-end");
      g || (f.margin = "0");
      f.fontFamily = c.fontFamily;
      f.fontWeight = c.fontWeight.toString();
      f.fontStyle = c.fontStyle;
      f.letterSpacing = c.letterSpacing;
      f.fontSize = nl(c.fontSize, c, a.u);
      d = c.line;
      null != d && (g = c.lineInterpretation, g == Hc && (g = 1, h = 16, a.j && 1 > a.j && (h = 32), d = 0 > d ? 100 + d / h * 100 : d / h * 100), 1 == g && (f.position = "absolute", c.writingMode == Gc ? (f.width = "100%", c.lineAlign == Ic ? f.top = d + "%" : "end" == c.lineAlign && (f.bottom = 100 - d + "%")) : "vertical-lr" == c.writingMode ? (f.height = "100%", c.lineAlign == Ic ? f.left = d + "%" : "end" == c.lineAlign && (f.right = 100 - d + "%")) : (f.height = "100%", c.lineAlign == Ic ? f.right = d + "%" : "end" == c.lineAlign && (f.left = 100 - d + "%"))));
      f.lineHeight = c.lineHeight;
      null != c.position && (c.writingMode == Gc ? f.paddingLeft = c.position : f.paddingTop = c.position);
      a = ml(c);
      "line-left" == a ? f.cssFloat = "left" : "line-right" == a && (f.cssFloat = "right");
      f.textAlign = c.textAlign;
      f.textDecoration = c.textDecoration.join(" ");
      f.writingMode = c.writingMode;
      "writingMode" in document.documentElement.style && f.writingMode == c.writingMode || (f.webkitWritingMode = c.writingMode);
      c.size && (c.writingMode == Gc ? f.width = c.size + "%" : f.height = c.size + "%");
    }

    function nl(a, b, c) {
      var d = (d = new RegExp(/(\d*\.?\d+)([a-z]+|%+)/).exec(a)) ? {
        value: Number(d[1]),
        unit: d[2]
      } : null;
      if (!d) return a;
      var e = d.value;

      switch (d.unit) {
        case "%":
          return e / 100 * c.clientHeight / b.cellResolution.rows + "px";

        case "c":
          return c.clientHeight * e / b.cellResolution.rows + "px";

        default:
          return a;
      }
    }

    function ol(a, b) {
      for (var c = a.length - 1; 0 <= c; c--) {
        var d = b(a[c]);
        if (d || 0 === d) return d;
      }

      return null;
    }

    M("shaka.text.UITextDisplayer", gl);
    gl.prototype.setTextVisibility = gl.prototype.setTextVisibility;
    gl.prototype.isTextVisible = gl.prototype.isTextVisible;
    gl.prototype.remove = gl.prototype.remove;
    gl.prototype.destroy = gl.prototype.destroy;
    gl.prototype.append = gl.prototype.append;

    function pl(a, b) {
      function c(f) {
        for (var g = f, h = t(b), k = h.next(); !k.done; k = h.next()) k = k.value, k.end && k.start < f && (g += k.end - k.start);

        f = Math.floor(g / 3600);
        h = Math.floor(g / 60 % 60);
        k = Math.floor(g % 60);
        g = Math.floor(1E3 * g % 1E3);
        return (10 > f ? "0" : "") + f + ":" + (10 > h ? "0" : "") + h + ":" + (10 > k ? "0" : "") + k + "." + (100 > g ? 10 > g ? "00" : "0" : "") + g;
      }

      var d = Zk(a);
      a = "WEBVTT\n\n";
      d = t(d);

      for (var e = d.next(); !e.done; e = d.next()) e = e.value, a += c(e.startTime) + " --\x3e " + c(e.endTime) + function (f) {
        var g = [];

        switch (f.textAlign) {
          case "left":
            g.push("align:left");
            break;

          case "right":
            g.push("align:right");
            break;

          case Ec:
            g.push("align:middle");
            break;

          case "start":
            g.push("align:start");
            break;

          case "end":
            g.push("align:end");
        }

        switch (f.writingMode) {
          case "vertical-lr":
            g.push("vertical:lr");
            break;

          case "vertical-rl":
            g.push("vertical:rl");
        }

        return g.length ? " " + g.join(" ") : "";
      }(e) + "\n", a += e.payload + "\n\n";

      return a;
    }

    M("shaka.text.WebVttGenerator", function () {});

    function ql(a, b) {
      this.h = a;
      this.g = b;
      this.j = "";
      this.s = void 0;
      this.i = !1;
      this.m = !0;
      this.l = !1;
    }

    ql.prototype.configure = function (a) {
      this.g = a;
    };

    function rl(a, b, c) {
      try {
        if (!a.g.enabled) return b;
        var d = tl(a);

        a: {
          switch (c.toLowerCase()) {
            case "video/webm":
            case "video/mp4":
            case "video/mpeg":
            case "video/mp2t":
              var e = ul;
              break a;

            case "application/x-mpegurl":
            case "application/vnd.apple.mpegurl":
            case "application/dash+xml":
            case "video/vnd.mpeg.dash.mpd":
              e = vl;
              break a;
          }

          e = void 0;
        }

        d.ot = e;
        d.su = !0;
        var f = wl(d);
        return xl(b, f);
      } catch (g) {
        return Va("CMCD_SRC_ERROR", "Could not generate src CMCD data.", g), b;
      }
    }

    function tl(a) {
      a.j || (a.j = a.g.sessionId || window.crypto.randomUUID());
      return {
        v: 1,
        sf: a.s,
        sid: a.j,
        cid: a.g.contentId,
        mtp: a.h.getBandwidthEstimate() / 1E3
      };
    }

    function yl(a, b, c) {
      c = void 0 === c ? {} : c;
      var d = void 0 === d ? a.g.useHeaders : d;

      if (a.g.enabled) {
        Object.assign(c, tl(a));
        c.pr = a.h.Ub();
        var e = c.ot === zl || c.ot === ul;
        a.l && e && (c.bs = !0, c.su = !0, a.l = !1);
        null == c.su && (c.su = a.m);
        if (d) a = Al(c), Object.keys(a).length && Object.assign(b.headers, a);else {
          var f = wl(c);
          f && (b.uris = b.uris.map(function (g) {
            return xl(g, f);
          }));
        }
      }
    }

    function Bl(a) {
      if (0 === a.type) return Cl;

      if (a = a.stream) {
        var b = a.type;
        if ("video" == b) return a.codecs && a.codecs.includes(",") ? ul : zl;
        if ("audio" == b) return Dl;
        if ("text" == b) return "application/mp4" === a.mimeType ? El : Fl;
      }
    }

    function Gl(a, b) {
      b = a.h.Fb()[b];
      if (!b.length) return NaN;
      var c = a.h.getCurrentTime();
      return (a = b.find(function (d) {
        return d.start <= c && d.end >= c;
      })) ? 1E3 * (a.end - c) : NaN;
    }

    function Hl(a, b) {
      var c = a.h.hb();
      if (!c.length) return NaN;
      a = c[0];
      c = t(c);

      for (var d = c.next(); !d.done; d = c.next()) d = d.value, "variant" === d.type && d.bandwidth > a.bandwidth && (a = d);

      switch (b) {
        case zl:
          return a.videoBandwidth || NaN;

        case Dl:
          return a.audioBandwidth || NaN;

        default:
          return a.bandwidth;
      }
    }

    function wl(a) {
      function b(n) {
        return 100 * c(n / 100);
      }

      function c(n) {
        return Math.round(n);
      }

      function d(n) {
        return !Number.isNaN(n) && null != n && "" !== n && !1 !== n;
      }

      var e = [],
          f = {
        br: c,
        d: c,
        bl: b,
        dl: b,
        mtp: b,
        nor: function (n) {
          return encodeURIComponent(n);
        },
        rtp: b,
        tb: c
      },
          g = Object.keys(a || {}).sort();
      g = t(g);

      for (var h = g.next(); !h.done; h = g.next()) {
        h = h.value;
        var k = a[h];

        if (d(k) && ("v" !== h || 1 !== k) && ("pr" != h || 1 !== k)) {
          var l = f[h];
          l && (k = l(k));
          l = typeof k;
          var m = void 0;
          m = "string" === l && "ot" !== h && "sf" !== h && "st" !== h ? h + "=" + JSON.stringify(k) : "boolean" === l ? h : "symbol" === l ? h + "=" + k.description : h + "=" + k;
          e.push(m);
        }
      }

      return e.join(",");
    }

    function Al(a) {
      var b = Object.keys(a),
          c = {},
          d = ["Object", "Request", "Session", "Status"],
          e = [{}, {}, {}, {}],
          f = {
        br: 0,
        d: 0,
        ot: 0,
        tb: 0,
        bl: 1,
        dl: 1,
        mtp: 1,
        nor: 1,
        nrr: 1,
        su: 1,
        cid: 2,
        pr: 2,
        sf: 2,
        sid: 2,
        st: 2,
        v: 2,
        bs: 3,
        rtp: 3
      };
      b = t(b);

      for (var g = b.next(); !g.done; g = b.next()) g = g.value, e[null != f[g] ? f[g] : 1][g] = a[g];

      for (a = 0; a < e.length; a++) (f = wl(e[a])) && (c["CMCD-" + d[a]] = f);

      return c;
    }

    function xl(a, b) {
      if (!b || a.includes("offline:")) return a;
      a = new kb(a);
      a.g.set("CMCD", b);
      return a.toString();
    }

    var vl = "m",
        Dl = "a",
        zl = "v",
        ul = "av",
        Cl = "i",
        Fl = "c",
        El = "tt";
    M("shaka.util.CmcdManager.StreamingFormat", {
      DASH: "d",
      HLS: "h",
      vh: "s",
      OTHER: "o"
    });

    function Il(a) {
      this.h = a;
      this.g = null;
    }

    p = Il.prototype;

    p.configure = function (a) {
      this.h = a;
    };

    p.Ng = function () {
      return this.h.enabled && this.h.applyMaximumSuggestedBitrate && this.g && this.g.has(Jl) ? 1E3 * this.g.get(Jl) : null;
    };

    p.Mg = function () {
      return this.h.enabled && this.g && this.g.has(Kl) ? 1E3 * this.g.get(Kl) : null;
    };

    p.gi = function () {
      return this.h.enabled && this.g && this.g.has(Ll) ? this.g.get(Ll) : null;
    };

    p.ii = function () {
      return this.h.enabled && this.g && this.g.has(Ml) ? this.g.get(Ml) : null;
    };

    p.getBandwidthEstimate = function (a) {
      var b = this.Mg();
      if (!b) return a;
      var c = this.h.estimatedThroughputWeightRatio;
      return 0 < c && 1 >= c ? a * (1 - c) + b * c : a;
    };

    function Nl(a) {
      return a ? "false" === a.toLowerCase() ? !1 : /^[-0-9]/.test(a) ? parseInt(a, 10) : a.replace(/["]+/g, "") : !0;
    }

    M("shaka.util.CmsdManager", Il);
    Il.prototype.getBandwidthEstimate = Il.prototype.getBandwidthEstimate;
    Il.prototype.getRoundTripTime = Il.prototype.ii;
    Il.prototype.getResponseDelay = Il.prototype.gi;
    Il.prototype.getEstimatedThroughput = Il.prototype.Mg;
    Il.prototype.getMaxBitrate = Il.prototype.Ng;
    var Kl = "etp",
        Jl = "mb",
        Ll = "rd",
        Ml = "rtt";

    function Ol() {}

    function Pl(a, b, c, d, e) {
      var f = (e in d),
          g = !0,
          h;

      for (h in b) {
        var k = e + "." + h,
            l = f ? d[e] : c[h];
        f || h in c ? void 0 === b[h] ? void 0 === l || f ? delete a[h] : a[h] = Cd(l) : l.constructor == Object && b[h] && b[h].constructor == Object ? (a[h] || (a[h] = Cd(l)), k = Pl(a[h], b[h], l, d, k), g = g && k) : typeof b[h] != typeof l || null == b[h] || "function" != typeof b[h] && b[h].constructor != l.constructor ? (Ta("Invalid config, wrong type for " + k), g = !1) : ("function" == typeof c[h] && c[h].length != b[h].length && Ua("Unexpected number of arguments for " + k), a[h] = b[h]) : (Ta("Invalid config, unrecognized key " + k), g = !1);
      }

      return g;
    }

    function Ql(a, b) {
      for (var c = {}, d = c, e = 0, f = 0;;) {
        e = a.indexOf(".", e);
        if (0 > e) break;
        if (0 == e || "\\" != a[e - 1]) f = a.substring(f, e).replace(/\\\./g, "."), d[f] = {}, d = d[f], f = e + 1;
        e += 1;
      }

      d[a.substring(f).replace(/\\\./g, ".")] = b;
      return c;
    }

    function Rl(a, b) {
      return a && b;
    }

    M("shaka.util.ConfigUtils", Ol);
    Ol.convertToConfigObject = Ql;
    Ol.mergeConfigObjects = Pl;

    function Sl() {
      this.g = null;
      this.h = [];
    }

    function Tl(a, b) {
      return K(function (c) {
        if (1 == c.g) return a.g ? D(c, new Promise(function (d) {
          return a.h.push(d);
        }), 2) : c.F(2);
        a.g = b;
        F(c);
      });
    }

    Sl.prototype.release = function () {
      0 < this.h.length ? this.h.shift()() : this.g = null;
    };

    function Ul() {}

    function Vl(a) {
      a = Wf(a);
      return new kb(a).Eb;
    }

    function Wl(a, b, c) {
      function d(h) {
        rc(f).setUint32(g, h.byteLength, !0);
        g += 4;
        f.set(nc(h), g);
        g += h.byteLength;
      }

      if (!c || !c.byteLength) throw new P(2, 6, 6015);
      var e;
      "string" == typeof b ? e = Yf(b, !0) : e = b;
      a = Wf(a);
      a = Yf(a, !0);
      var f = new Uint8Array(12 + a.byteLength + e.byteLength + c.byteLength),
          g = 0;
      d(a);
      d(e);
      d(c);
      return f;
    }

    function Xl(a, b, c) {
      if ("skd" !== b) return a;
      b = c.serverCertificate;
      c = Wf(a).split("skd://").pop();
      return Wl(a, c, b);
    }

    function Yl(a, b) {
      2 === a && (b.headers["Content-Type"] = "application/octet-stream");
    }

    M("shaka.util.FairPlayUtils", Ul);

    Ul.commonFairPlayResponse = function (a, b) {
      if (2 === a) {
        try {
          var c = Tf(b.data);
        } catch (e) {
          return;
        }

        a = !1;
        c = c.trim();
        "<ckc>" === c.substr(0, 5) && "</ckc>" === c.substr(-6) && (c = c.slice(5, -6), a = !0);

        try {
          var d = JSON.parse(c);
          d.ckc && (c = d.ckc, a = !0);
          d.CkcMessage && (c = d.CkcMessage, a = !0);
          d.License && (c = d.License, a = !0);
        } catch (e) {}

        a && (b.data = oc(qg(c)));
      }
    };

    Ul.expressplayFairPlayRequest = function (a, b) {
      Yl(a, b);
    };

    Ul.conaxFairPlayRequest = function (a, b) {
      Yl(a, b);
    };

    Ul.ezdrmFairPlayRequest = function (a, b) {
      Yl(a, b);
    };

    Ul.verimatrixFairPlayRequest = function (a, b) {
      2 === a && (a = nc(b.body), a = pg(a), b.headers["Content-Type"] = "application/x-www-form-urlencoded", b.body = Xf("spc=" + a));
    };

    Ul.expressplayInitDataTransform = function (a, b, c) {
      return Xl(a, b, c);
    };

    Ul.conaxInitDataTransform = function (a, b, c) {
      if ("skd" !== b) return a;
      b = c.serverCertificate;
      c = Wf(a).split("skd://").pop().split("?").shift();
      c = window.atob(c);
      var d = new ArrayBuffer(2 * c.length);
      d = qc(d);

      for (var e = 0, f = c.length; e < f; e++) d[e] = c.charCodeAt(e);

      return Wl(a, d, b);
    };

    Ul.ezdrmInitDataTransform = function (a, b, c) {
      if ("skd" !== b) return a;
      b = c.serverCertificate;
      c = Wf(a).split(";").pop();
      return Wl(a, c, b);
    };

    Ul.verimatrixInitDataTransform = function (a, b, c) {
      return Xl(a, b, c);
    };

    Ul.initDataTransform = Wl;
    Ul.defaultGetContentId = Vl;

    Ul.isFairPlaySupported = function () {
      var a;
      return K(function (b) {
        if (1 == b.g) return a = {
          initDataTypes: ["cenc", "sinf", "skd"],
          videoCapabilities: [{
            contentType: 'video/mp4; codecs="avc1.42E01E"'
          }]
        }, ta(b, 2), D(b, navigator.requestMediaKeySystemAccess("com.apple.fps", [a]), 4);
        if (2 != b.g) return b.return(!0);
        wa(b);
        return b.return(!1);
      });
    };

    function Zl() {}

    function $l() {
      var a = Infinity;
      navigator.connection && navigator.connection.saveData && (a = 360);
      var b = {
        retryParameters: jf(),
        servers: {},
        clearKeys: {},
        advanced: {},
        delayLicenseRequestUntilPlayed: !1,
        persistentSessionOnlinePlayback: !1,
        persistentSessionsMetadata: [],
        initDataTransform: function (h, k, l) {
          window.shakaMediaKeysPolyfill && "skd" == k && (k = l.serverCertificate, l = Vl(h), h = Wl(h, l, k));
          return h;
        },
        logLicenseExchange: !1,
        updateExpirationTime: 1,
        preferredKeySystems: [],
        keySystemsMapping: {},
        parseInbandPsshEnabled: Kd(),
        minHdcpVersion: "",
        ignoreDuplicateInitData: !Od()
      },
          c = "reload",
          d = !1;
      Od() || Nd() || Ld("Tizen 4") || Pd() || navigator.userAgent.match(/webOS\/4/i) || navigator.userAgent.match(/webOS\/5/i) || (c = "smooth", d = !0);
      d = {
        retryParameters: jf(),
        availabilityWindowOverride: NaN,
        disableAudio: !1,
        disableVideo: !1,
        disableText: !1,
        disableThumbnails: !1,
        defaultPresentationDelay: 0,
        segmentRelativeVttTiming: !1,
        raiseFatalErrorOnManifestUpdateRequestFailure: !1,
        dash: {
          clockSyncUri: "",
          ignoreDrmInfo: !1,
          disableXlinkProcessing: !1,
          xlinkFailGracefully: !1,
          ignoreMinBufferTime: !1,
          autoCorrectDrift: !0,
          initialSegmentLimit: 1E3,
          ignoreSuggestedPresentationDelay: !1,
          ignoreEmptyAdaptationSet: !1,
          ignoreMaxSegmentDuration: !1,
          keySystemsByURI: {
            "urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b": "org.w3.clearkey",
            "urn:uuid:e2719d58-a985-b3c9-781a-b030af78d30e": "org.w3.clearkey",
            "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed": "com.widevine.alpha",
            "urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95": "com.microsoft.playready",
            "urn:uuid:79f0049a-4098-8642-ab92-e65be0885f95": "com.microsoft.playready",
            "urn:uuid:f239e769-efa3-4850-9c16-a903c6932efb": "com.adobe.primetime"
          },
          manifestPreprocessor: function (h) {
            return Rl([h], h);
          },
          sequenceMode: !1,
          enableAudioGroups: !1,
          multiTypeVariantsAllowed: d
        },
        hls: {
          ignoreTextStreamFailures: !1,
          ignoreImageStreamFailures: !1,
          defaultAudioCodec: "mp4a.40.2",
          defaultVideoCodec: "avc1.42E01E",
          ignoreManifestProgramDateTime: !1,
          mediaPlaylistFullMimeType: 'video/mp2t; codecs="avc1.42E01E, mp4a.40.2"',
          useSafariBehaviorForLive: !0,
          liveSegmentsDelay: 3,
          sequenceMode: Nd() || Od() || Pd() || Rd() ? !1 : !0,
          ignoreManifestTimestampsInSegmentsMode: !1,
          disableCodecGuessing: !1,
          allowLowLatencyByteRangeOptimization: !0
        },
        mss: {
          manifestPreprocessor: function (h) {
            return Rl([h], h);
          },
          sequenceMode: !1,
          keySystemsBySystemId: {
            "9a04f079-9840-4286-ab92-e65be0885f95": "com.microsoft.playready",
            "79f0049a-4098-8642-ab92-e65be0885f95": "com.microsoft.playready"
          }
        }
      };
      var e = {
        retryParameters: jf(),
        failureCallback: function (h) {
          return Rl([h]);
        },
        rebufferingGoal: 2,
        bufferingGoal: 10,
        bufferBehind: 30,
        ignoreTextStreamFailures: !1,
        alwaysStreamText: !1,
        startAtSegmentBoundary: !1,
        gapDetectionThreshold: .5,
        gapJumpTimerTime: .25,
        durationBackoff: 1,
        safeSeekOffset: 5,
        stallEnabled: !0,
        stallThreshold: 1,
        stallSkip: .1,
        useNativeHlsOnSafari: !0,
        inaccurateManifestTolerance: 2,
        lowLatencyMode: !1,
        autoLowLatencyMode: !1,
        forceHTTPS: !1,
        preferNativeHls: !1,
        updateIntervalSeconds: 1,
        dispatchAllEmsgBoxes: !1,
        observeQualityChanges: !1,
        maxDisabledTime: 30,
        parsePrftBox: !1,
        segmentPrefetchLimit: 0,
        liveSync: !1,
        liveSyncMaxLatency: 1,
        liveSyncPlaybackRate: 1.1,
        liveSyncMinLatency: 0,
        liveSyncMinPlaybackRate: 1,
        allowMediaSourceRecoveries: !0,
        minTimeBetweenRecoveries: 5
      };
      if (Ld("Web0S") || Md() || Ld("CrKey") || Ld("Hisense") || Ld("VIDAA")) e.stallSkip = 0;
      var f = {
        trackSelectionCallback: function (h) {
          return K(function (k) {
            return k.return(h);
          });
        },
        downloadSizeCallback: function (h) {
          var k;
          return K(function (l) {
            if (1 == l.g) return navigator.storage && navigator.storage.estimate ? D(l, navigator.storage.estimate(), 3) : l.return(!0);
            k = l.h;
            return l.return(k.usage + h < .95 * k.quota);
          });
        },
        progressCallback: function (h, k) {
          return Rl([h, k]);
        },
        usePersistentLicense: !0,
        numberOfParallelDownloads: 5
      },
          g = {
        drm: b,
        manifest: d,
        streaming: e,
        mediaSource: {
          codecSwitchingStrategy: c,
          sourceBufferExtraFeatures: "",
          forceTransmux: !1,
          insertFakeEncryptionInInit: !0
        },
        offline: f,
        abrFactory: function () {
          return new Ge();
        },
        abr: {
          enabled: !0,
          useNetworkInformation: !0,
          defaultBandwidthEstimate: 1E6,
          switchInterval: 8,
          bandwidthUpgradeTarget: .85,
          bandwidthDowngradeTarget: .95,
          restrictions: {
            minWidth: 0,
            maxWidth: Infinity,
            minHeight: 0,
            maxHeight: a,
            minPixels: 0,
            maxPixels: Infinity,
            minFrameRate: 0,
            maxFrameRate: Infinity,
            minBandwidth: 0,
            maxBandwidth: Infinity
          },
          advanced: {
            minTotalBytes: 128E3,
            minBytes: 16E3,
            fastHalfLife: 2,
            slowHalfLife: 5
          },
          restrictToElementSize: !1,
          restrictToScreenSize: !1,
          ignoreDevicePixelRatio: !1,
          clearBufferSwitch: !1,
          safeMarginSwitch: 0
        },
        autoShowText: 3,
        preferredAudioLanguage: "",
        preferredAudioLabel: "",
        preferredTextLanguage: "",
        preferredVariantRole: "",
        preferredTextRole: "",
        preferredAudioChannelCount: 2,
        preferredVideoHdrLevel: "AUTO",
        preferredVideoLayout: "",
        preferredVideoLabel: "",
        preferredVideoCodecs: [],
        preferredAudioCodecs: [],
        preferForcedSubs: !1,
        preferSpatialAudio: !1,
        preferredDecodingAttributes: [],
        restrictions: {
          minWidth: 0,
          maxWidth: Infinity,
          minHeight: 0,
          maxHeight: Infinity,
          minPixels: 0,
          maxPixels: Infinity,
          minFrameRate: 0,
          maxFrameRate: Infinity,
          minBandwidth: 0,
          maxBandwidth: Infinity
        },
        playRangeStart: 0,
        playRangeEnd: Infinity,
        textDisplayFactory: function () {
          return null;
        },
        cmcd: {
          enabled: !1,
          sessionId: "",
          contentId: "",
          useHeaders: !1
        },
        cmsd: {
          enabled: !0,
          applyMaximumSuggestedBitrate: !0,
          estimatedThroughputWeightRatio: .5
        },
        lcevc: {
          enabled: !1,
          dynamicPerformanceScaling: !0,
          logLevel: 0,
          drawLogo: !1
        },
        ads: {
          customPlayheadTracker: !1
        }
      };

      f.trackSelectionCallback = function (h) {
        return K(function (k) {
          return k.return(am(h, g.preferredAudioLanguage, g.preferredVideoHdrLevel));
        });
      };

      return g;
    }

    function bm(a, b, c) {
      var d = {
        ".drm.keySystemsMapping": "",
        ".drm.servers": "",
        ".drm.clearKeys": "",
        ".drm.advanced": {
          distinctiveIdentifierRequired: !1,
          persistentStateRequired: !1,
          videoRobustness: "",
          audioRobustness: "",
          sessionType: "",
          serverCertificate: new Uint8Array(0),
          serverCertificateUri: "",
          individualizationServer: ""
        }
      };
      return Pl(a, b, c || $l(), d, "");
    }

    function am(a, b, c) {
      var d = c;
      "AUTO" == d && (d = window.matchMedia("(color-gamut: p3)").matches ? "PQ" : "SDR");
      var e = a.filter(function (h) {
        return "variant" != h.type || h.hdr && h.hdr != d ? !1 : !0;
      });
      c = [];
      var f = Yb(b, e.map(function (h) {
        return h.language;
      }));
      f && (c = e.filter(function (h) {
        return Qb(h.language) == f;
      }));
      0 == c.length && (c = e.filter(function (h) {
        return h.primary;
      }));
      0 == c.length && (e.map(function (h) {
        return h.language;
      }), c = e);
      var g = c.filter(function (h) {
        return h.height && 480 >= h.height;
      });
      g.length && (g.sort(function (h, k) {
        return k.height - h.height;
      }), c = g.filter(function (h) {
        return h.height == g[0].height;
      }));
      b = [];
      c.length && (e = Math.floor(c.length / 2), c.sort(function (h, k) {
        return h.bandwidth - k.bandwidth;
      }), b.push(c[e]));
      a = t(a);

      for (c = a.next(); !c.done; c = a.next()) c = c.value, c.type != Mb && "image" != c.type || b.push(c);

      return b;
    }

    M("shaka.util.PlayerConfiguration", Zl);
    Zl.mergeConfigObjects = bm;
    Zl.createDefault = $l;

    function cm() {
      this.g = null;
      this.h = [];
    }

    function dm(a, b) {
      var c = 0;
      a.g && a.g.state == b && (c += a.g.duration);
      a = t(a.h);

      for (var d = a.next(); !d.done; d = a.next()) d = d.value, c += d.state == b ? d.duration : 0;

      return c;
    }

    function em(a) {
      function b(f) {
        return {
          timestamp: f.timestamp,
          state: f.state,
          duration: f.duration
        };
      }

      for (var c = [], d = t(a.h), e = d.next(); !e.done; e = d.next()) c.push(b(e.value));

      a.g && c.push(b(a.g));
      return c;
    }

    ;

    function fm() {
      this.i = this.h = null;
      this.g = [];
    }

    function gm(a, b, c) {
      a.i != b && (a.i = b, a.g.push({
        timestamp: Date.now() / 1E3,
        id: b.id,
        type: "text",
        fromAdaptation: c,
        bandwidth: null
      }));
    }

    ;

    function hm() {
      this.C = this.D = this.I = this.G = this.u = this.j = this.H = this.m = this.i = this.M = this.N = this.J = this.K = this.L = this.l = this.s = NaN;
      this.g = new cm();
      this.h = new fm();
    }

    ;

    function W(a, b) {
      db.call(this);
      var c = this;
      this.l = im;
      this.Kc = this.g = null;
      this.$ = !1;
      this.pe = new Jf();
      this.Bb = new Jf();
      this.m = new Jf();
      this.G = this.I = this.s = this.J = null;
      this.ve = 0;
      this.V = new Sl();
      this.ha = this.aa = this.i = this.ye = this.H = this.j = this.ra = this.L = this.rh = this.Z = this.U = this.ua = this.M = this.K = this.Ua = null;
      this.Ta = !1;
      this.Xf = this.u = null;
      this.rg = 1E9;
      this.ic = [];
      this.N = NaN;
      this.h = jm(this);
      this.ag = {
        width: Infinity,
        height: Infinity
      };
      this.C = null;
      this.Aa = new Ue(this.h.preferredAudioLanguage, this.h.preferredVariantRole, this.h.preferredAudioChannelCount, this.h.preferredVideoHdrLevel, this.h.preferSpatialAudio, this.h.preferredVideoLayout, this.h.preferredAudioLabel, this.h.preferredVideoLabel, this.h.mediaSource.codecSwitchingStrategy, this.h.manifest.dash.enableAudioGroups);
      this.Na = this.h.preferredTextLanguage;
      this.Qb = this.h.preferredTextRole;
      this.Cb = this.h.preferForcedSubs;
      this.yb = [];
      b && b(this);
      this.U = km(this);
      this.Z = new Il(this.h.cmsd);
      this.J = lm(this);
      this.J.hg(this.h.streaming.forceHTTPS);
      this.D = null;
      mm && (this.D = mm());
      this.pe.o(window, "online", function () {
        nm(c);
        c.$f();
      });
      this.ke = new Fd(function () {
        return om(c);
      });
      a && (Le("Player", "Please migrate from initializing Player with a mediaElement; use the attach method instead."), this.Cc(a, !0));
    }

    pa(W, db);

    function pm(a) {
      null != a.L && (Ei(a.L), a.L.release(), a.L = null);
    }

    function qm(a, b) {
      if (b.lcevc.enabled) {
        var c = a.hb();
        c && c[0] && "video/mp2t" == c[0].videoMimeType && (Jd() || navigator.userAgent.match(/Edge\//)) && (b.mediaSource.forceTransmux || Ua("LCEVC Warning: For MPEG-2 TS decoding the config.mediaSource.forceTransmux must be enabled."));
        pm(a);
        null == a.L && (a.L = new Di(a.g, a.rh, b.lcevc), a.I && (a.I.N = a.L));
      } else pm(a);
    }

    function rm(a, b) {
      return new N(a, b);
    }

    p = W.prototype;

    p.destroy = function () {
      var a = this,
          b;
      return K(function (c) {
        switch (c.g) {
          case 1:
            if (a.l == sm) return c.return();
            pm(a);
            b = a.detach();
            a.l = sm;
            return D(c, b, 2);

          case 2:
            a.pe && (a.pe.release(), a.pe = null);
            a.Bb && (a.Bb.release(), a.Bb = null);
            a.m && (a.m.release(), a.m = null);
            a.Xf = null;
            a.h = null;
            a.C = null;
            a.Kc = null;
            a.U = null;
            a.Z = null;

            if (!a.J) {
              c.F(3);
              break;
            }

            return D(c, a.J.destroy(), 4);

          case 4:
            a.J = null;

          case 3:
            a.u && (a.u.release(), a.u = null), db.prototype.release.call(a), F(c);
        }
      });
    };

    function tm() {
      window.Promise || Ua("A Promise implementation or polyfill is required");
      if (!(window.Promise && window.Uint8Array && Array.prototype.forEach) || Ld("Trident/")) return !1;
      var a = Sd();
      return a && 9 > a || !(window.MediaKeys && window.navigator && window.navigator.requestMediaKeySystemAccess && window.MediaKeySystemAccess && window.MediaKeySystemAccess.prototype.getConfiguration) ? !1 : Gd() ? !0 : Hd("application/x-mpegurl");
    }

    function um(a, b) {
      a.dispatchEvent(rm("onstatechange", new Map().set("state", b)));
    }

    p.Cc = function (a, b) {
      b = void 0 === b ? !0 : b;
      var c = this,
          d,
          e;
      return K(function (f) {
        switch (f.g) {
          case 1:
            if (c.l == sm) throw new P(2, 7, 7E3);

            if (!c.g || c.g == a) {
              f.F(2);
              break;
            }

            return D(f, c.detach(), 2);

          case 2:
            return D(f, vm(c, "attach"), 4);

          case 4:
            if (f.h) return f.return();
            ta(f, 5, 6);
            um(c, "attach");

            d = function () {
              var g = wm(c);
              g && xm(c, g);
            };

            c.Bb.o(a, "error", d);
            c.g = a;

            if (!b || !Gd() || c.I) {
              f.F(6);
              break;
            }

            return D(f, ym(c), 6);

          case 6:
            xa(f);
            c.V.release();
            ya(f, 0);
            break;

          case 5:
            return e = wa(f), D(f, c.detach(), 10);

          case 10:
            throw e;
        }
      });
    };

    p.yg = function (a) {
      this.rh = a;
    };

    p.detach = function (a) {
      a = void 0 === a ? !1 : a;
      var b = this;
      return K(function (c) {
        if (1 == c.g) {
          if (b.l == sm) throw new P(2, 7, 7E3);
          return D(c, b.Tc(!1, a), 2);
        }

        if (3 != c.g) return D(c, vm(b, "detach"), 3);
        if (c.h) return c.return();

        try {
          b.g && (b.Bb.Lb(), b.g = null), um(b, "detach"), b.D && !a && b.D.release();
        } finally {
          b.V.release();
        }

        F(c);
      });
    };

    function vm(a, b) {
      var c;
      return K(function (d) {
        return 1 == d.g ? (c = ++a.ve, D(d, Tl(a.V, b), 2)) : c != a.ve ? (a.V.release(), d.return(!0)) : d.return(!1);
      });
    }

    p.Tc = function (a, b) {
      a = void 0 === a ? !0 : a;
      b = void 0 === b ? !1 : b;
      var c = this,
          d,
          e,
          f,
          g,
          h,
          k,
          l,
          m,
          n;
      return K(function (r) {
        switch (r.g) {
          case 1:
            return c.l != sm && (c.l = im), D(r, vm(c, "unload"), 2);

          case 2:
            if (r.h) return r.return();
            ua(r, 3);
            c.Ta = !1;
            um(c, "unload");
            a && !Gd() && (a = !1);
            pm(c);
            d = c.yb.map(function (q) {
              return q();
            });
            c.yb = [];
            return D(r, Promise.all(d), 5);

          case 5:
            c.dispatchEvent(rm("unloading"));
            c.ua && (c.ua.release(), c.ua = null);
            c.g && c.m.Lb();
            c.ke.stop();
            c.Ua && (c.Ua.release(), c.Ua = null);

            if (!c.H) {
              r.F(6);
              break;
            }

            return D(r, c.H.stop(), 7);

          case 7:
            c.H = null, c.ye = null;

          case 6:
            if (!c.u) {
              r.F(8);
              break;
            }

            return D(r, c.u.stop(), 8);

          case 8:
            if (!c.j) {
              r.F(10);
              break;
            }

            return D(r, c.j.destroy(), 11);

          case 11:
            c.j = null;

          case 10:
            c.K && (c.K.release(), c.K = null);
            c.G && (c.G.release(), c.G = null);

            if (!c.I) {
              r.F(12);
              break;
            }

            return D(r, c.I.destroy(), 13);

          case 13:
            c.I = null;

          case 12:
            if (c.D && !b) c.D.onAssetUnload();
            c.Z && (c.Z.g = null);
            c.g && fl(c.g);

            if (!c.g || !c.g.src) {
              r.F(14);
              break;
            }

            return D(r, new Promise(function (q) {
              return new Fd(q).R(.1);
            }), 15);

          case 15:
            c.g.removeAttribute("src"), c.g.load();

          case 14:
            if (!c.s) {
              r.F(16);
              break;
            }

            return D(r, c.s.destroy(), 17);

          case 17:
            c.s = null;

          case 16:
            c.aa = null;
            c.M = null;

            if (c.i) {
              e = t(c.i.variants);

              for (f = e.next(); !f.done; f = e.next()) for (g = f.value, h = t([g.audio, g.video]), k = h.next(); !k.done; k = h.next()) (l = k.value) && l.segmentIndex && l.segmentIndex.release();

              m = t(c.i.textStreams);

              for (k = m.next(); !k.done; k = m.next()) n = k.value, n.segmentIndex && n.segmentIndex.release();
            }

            c.i = null;
            c.C = new hm();
            c.Yf = null;
            c.ic = [];
            c.N = NaN;
            zm(c);

          case 3:
            xa(r);
            c.V.release();
            ya(r, 4);
            break;

          case 4:
            if (a && Gd() && !c.I) return D(r, ym(c), 0);
            r.F(0);
        }
      });
    };

    p.lj = function (a) {
      this.ha = a;
    };

    p.load = function (a, b, c) {
      b = void 0 === b ? null : b;
      var d = this,
          e,
          f,
          g,
          h,
          k,
          l;
      return K(function (m) {
        switch (m.g) {
          case 1:
            if (d.l == sm) throw new P(2, 7, 7E3);
            return D(m, Tl(d.V, "load"), 2);

          case 2:
            d.V.release();
            if (!d.g) throw new P(2, 7, 7002);

            if (!d.aa) {
              m.F(3);
              break;
            }

            return D(m, d.Tc(!1), 3);

          case 3:
            e = ++d.ve;

            f = function () {
              if (d.ve != e) throw new P(2, 7, 7E3);
            };

            g = function (n, r) {
              return K(function (q) {
                switch (q.g) {
                  case 1:
                    return ua(q, 2), D(q, Tl(d.V, r), 4);

                  case 4:
                    return f(), D(q, n(), 5);

                  case 5:
                    f();

                  case 2:
                    xa(q), d.V.release(), ya(q, 0);
                }
              });
            };

            ta(m, 5);
            d.ha = b;
            d.Ta = !1;
            d.dispatchEvent(rm("loading"));
            h = Date.now() / 1E3;
            d.C = new hm();
            d.aa = a;

            if (c) {
              m.F(7);
              break;
            }

            return D(m, g(function () {
              return K(function (n) {
                if (1 == n.g) return D(n, Am(d), 2);
                c = n.h;
                F(n);
              });
            }, "guessMimeType_"), 7);

          case 7:
            if (k = Bm(d, c)) return D(m, g(function () {
              return K(function (n) {
                return D(n, Cm(d, c), 0);
              });
            }, "initializeSrcEqualsDrmInner_"), 16);

            if (d.I) {
              m.F(11);
              break;
            }

            return D(m, g(function () {
              return K(function (n) {
                return D(n, ym(d), 0);
              });
            }, "initializeMediaSourceEngineInner_"), 11);

          case 11:
            return D(m, g(function () {
              return K(function (n) {
                return D(n, Dm(d, c), 0);
              });
            }, "parseManifestInner_"), 13);

          case 13:
            return D(m, g(function () {
              return K(function (n) {
                return D(n, Em(d), 0);
              });
            }, "initializeDrmInner_"), 14);

          case 14:
            return D(m, g(function () {
              return K(function (n) {
                return D(n, Fm(d, h), 0);
              });
            }, "loadInner_"), 10);

          case 16:
            return D(m, g(function () {
              return K(function (n) {
                return D(n, Gm(d, h, c), 0);
              });
            }, "srcEqualsInner_"), 10);

          case 10:
            d.dispatchEvent(rm("loaded"));
            va(m, 0);
            break;

          case 5:
            l = wa(m);

            if (7E3 == l.code) {
              m.F(18);
              break;
            }

            return D(m, d.Tc(!1), 18);

          case 18:
            throw l;
        }
      });
    };

    function Am(a) {
      var b, c;
      return K(function (d) {
        if (1 == d.g) return b = a.h.manifest.retryParameters, D(d, Vk(a.aa, a.J, b), 2);
        c = d.h;
        "application/x-mpegurl" == c && Qd() && (c = "application/vnd.apple.mpegurl");
        return d.return(c);
      });
    }

    function Bm(a, b) {
      if (!Gd()) return !0;

      if (b) {
        if ("" == (a.g || Id()).canPlayType(b)) return !1;
        if (!(Gd() && b in Ih)) return !0;

        if ("application/x-mpegurl" === b || "application/vnd.apple.mpegurl" === b) {
          if (a.h.streaming.preferNativeHls) return !0;
          if (Qd()) return a.h.streaming.useNativeHlsOnSafari;
        }
      }

      return !1;
    }

    function ym(a) {
      var b, c, d, e, f;
      return K(function (g) {
        if (1 == g.g) return um(a, "media-source"), b = a.h.textDisplayFactory, c = b(), a.Yf = b, d = Hm(a.g, c, function (h, k, l) {
          Im(a, h, k, l);
        }, a.L), d.configure(a.h.mediaSource), e = a.h.manifest, f = e.segmentRelativeVttTiming, d.Z = f, D(g, d.L, 2);
        a.I = d;
        F(g);
      });
    }

    function Dm(a, b) {
      var c, d, e, f, g, h, k, l;
      return K(function (m) {
        if (1 == m.g) return c = a.J, um(a, "manifest-parser"), a.ye = Hh(a.aa, b || null), a.H = a.ye(), d = Cd(a.h.manifest), a.g && "AUDIO" === a.g.nodeName && (d.disableVideo = !0), a.H.configure(d), a.ua = new ak(function () {
          return a.Ga();
        }), a.ua.addEventListener("regionadd", function (n) {
          n = n.region;
          Jm(a, "timelineregionadded", n);
          if (a.D) a.D.onDashTimedMetadata(n);
        }), a.ra = null, a.h.streaming.observeQualityChanges && (a.ra = new Wj(function () {
          return a.Fb();
        }), a.ra.addEventListener("qualitychange", function (n) {
          var r = n.quality;
          n = n.position;
          r = new Map().set("mediaQuality", {
            bandwidth: r.bandwidth,
            audioSamplingRate: r.audioSamplingRate,
            codecs: r.codecs,
            contentType: r.contentType,
            frameRate: r.frameRate,
            height: r.height,
            mimeType: r.mimeType,
            channelsCount: r.channelsCount,
            pixelAspectRatio: r.pixelAspectRatio,
            width: r.width
          }).set("position", n);
          a.dispatchEvent(rm("mediaqualitychanged", r));
        })), e = {
          networkingEngine: c,
          filter: function (n) {
            return Km(a, n);
          },
          makeTextStreamsForClosedCaptions: function (n) {
            return Lm(a, n);
          },
          onTimelineRegionAdded: function (n) {
            var r = a.ua;

            a: {
              var q = t(r.g);

              for (var u = q.next(); !u.done; u = q.next()) if (u = u.value, u.schemeIdUri == n.schemeIdUri && u.id == n.id && u.startTime == n.startTime && u.endTime == n.endTime) {
                q = u;
                break a;
              }

              q = null;
            }

            null == q && (r.g.add(n), n = new N("regionadd", new Map([["region", n]])), r.dispatchEvent(n));
          },
          onEvent: function (n) {
            return a.dispatchEvent(n);
          },
          onError: function (n) {
            return xm(a, n);
          },
          isLowLatencyMode: function () {
            return a.h.streaming.lowLatencyMode;
          },
          isAutoLowLatencyMode: function () {
            return a.h.streaming.autoLowLatencyMode;
          },
          enableLowLatencyMode: function () {
            a.configure("streaming.lowLatencyMode", !0);
          },
          updateDuration: function () {
            a.j && a.j.updateDuration();
          },
          newDrmInfo: function (n) {
            var r = a.s ? a.s.g : null;
            r && a.s.u && Mm(a, r.keySystem, n);
          },
          onManifestUpdated: function () {
            var n = new Map().set("isLive", a.S());
            a.dispatchEvent(rm("manifestupdated", n));
            if (a.D) a.D.onManifestUpdated(a.S());
          },
          getBandwidthEstimate: function () {
            return a.u.getBandwidthEstimate();
          }
        }, f = Date.now() / 1E3, um(a, "manifest"), g = a, D(m, a.H.start(a.aa, e), 2);
        g.i = m.h;
        h = rm("manifestparsed");
        a.dispatchEvent(h);
        if (0 == a.i.variants.length) throw new P(2, 4, 4036);
        Nm(a.i);
        k = Date.now() / 1E3;
        l = k - f;
        a.C.H = l;
        F(m);
      });
    }

    function Em(a) {
      var b, c;
      return K(function (d) {
        return 1 == d.g ? (um(a, "drm-engine"), b = Date.now() / 1E3, c = !0, a.s = Om(a, {
          vc: a.J,
          onError: function (e) {
            xm(a, e);
          },
          ze: function (e) {
            Pm(a, e);
          },
          onExpirationUpdated: function (e, f) {
            Qm(a, e, f);
          },
          onEvent: function (e) {
            a.dispatchEvent(e);
            "drmsessionupdate" == e.type && c && (c = !1, a.C.j = Date.now() / 1E3 - b, a.L && Ei(a.L));
          }
        }), a.s.configure(a.h.drm), D(d, Zg(a.s, a.i.variants, a.i.offlineSessionIds), 2)) : 3 != d.g ? D(d, a.s.Cc(a.g), 3) : D(d, Km(a, a.i), 0);
      });
    }

    function Fm(a, b) {
      var c, d, e, f, g, h, k, l, m, n, r, q, u, v, y, z, x, B, A;
      return K(function (C) {
        switch (C.g) {
          case 1:
            um(a, "load");
            c = a.g;
            a.K = new Tj({
              ge: function () {
                return c.playbackRate;
              },
              qd: function () {
                return c.defaultPlaybackRate;
              },
              jg: function (E) {
                c.playbackRate = E;
              },
              Xg: function (E) {
                c.currentTime += E;
              }
            });

            d = function () {
              return Rm(a);
            };

            e = function () {
              return Sm(a);
            };

            a.m.o(c, "playing", d);
            a.m.o(c, "pause", d);
            a.m.o(c, "ended", d);
            a.m.o(c, "ratechange", e);
            qm(a, a.h);
            f = a.h.abrFactory;
            a.u && a.Xf == f || (a.Xf = f, a.u = f(), "function" != typeof a.u.setMediaElement && (Le("AbrManager", "Please use an AbrManager with setMediaElement function."), a.u.setMediaElement = function () {}), "function" != typeof a.u.setCmsdManager && (Le("AbrManager", "Please use an AbrManager with setCmsdManager function."), a.u.setCmsdManager = function () {}), a.u.configure(a.h.abr));
            a.Aa = new Ue(a.h.preferredAudioLanguage, a.h.preferredVariantRole, a.h.preferredAudioChannelCount, a.h.preferredVideoHdrLevel, a.h.preferSpatialAudio, a.h.preferredVideoLayout, a.h.preferredAudioLabel, a.h.preferredVideoLabel, a.h.mediaSource.codecSwitchingStrategy, a.h.manifest.dash.enableAudioGroups);
            a.Na = a.h.preferredTextLanguage;
            a.Qb = a.h.preferredTextRole;
            a.Cb = a.h.preferForcedSubs;
            Tm(a.i.presentationTimeline, a.h.playRangeStart, a.h.playRangeEnd);
            a.u.init(function (E, H, G) {
              a.j && E != a.j.j && Um(a, E, !0, void 0 === H ? !1 : H, void 0 === G ? 0 : G);
            });
            a.u.setMediaElement(c);
            a.u.setCmsdManager(a.Z);
            $d(a.i, a.h.preferredVideoCodecs, a.h.preferredAudioCodecs, a.h.preferredDecodingAttributes);
            a.j = Vm(a);
            a.j.configure(a.h.streaming);
            a.l = Wm;
            c.textTracks && a.m.o(c.textTracks, "addtrack", function (E) {
              if (E.track) switch (E = E.track, E.kind) {
                case "chapters":
                  Xm(a, E);
              }
            });
            a.dispatchEvent(rm("streaming"));
            g = null;
            (h = a.j.j) || (g = Ym(a, !0));
            k = [];
            l = h || g;
            m = t([l.video, l.audio]);

            for (n = m.next(); !n.done; n = m.next()) (r = n.value) && !r.segmentIndex && k.push(r.createSegmentIndex());

            if (!(0 < k.length)) {
              C.F(2);
              break;
            }

            return D(C, Promise.all(k), 2);

          case 2:
            if (a.H && a.H.onInitialVariantChosen) a.H.onInitialVariantChosen(l);
            Tm(a.i.presentationTimeline, a.h.playRangeStart, a.h.playRangeEnd);
            a.G = Zm(a, a.ha);
            a.Ua = $m(a, b);
            q = Math.max(a.i.minBufferTime, a.h.streaming.rebufferingGoal);
            an(a, c, q);

            if (h) {
              C.F(4);
              break;
            }

            Um(a, g, !0, !1, 0);

            if (!a.h.streaming.startAtSegmentBoundary) {
              C.F(4);
              break;
            }

            u = a.G;
            v = u.Ve;
            return D(C, bn(g, a.G.Ud()), 6);

          case 6:
            v.call(u, C.h);

          case 4:
            return a.G.Ue(), y = a.Xb().find(function (E) {
              return E.active;
            }), y || ((z = De(a.i.textStreams, a.Na, a.Qb, a.Cb)[0] || null) && gm(a.C.h, z, !0), g && (z ? (g.audio && cn(a, g.audio, z) && (a.$ = !0), a.$ && a.I.H.setTextVisibility(!0), dn(a)) : a.$ = !1), z && (a.h.streaming.alwaysStreamText || a.tc()) && Ck(a.j, z)), D(C, a.j.start(), 7);

          case 7:
            a.h.abr.enabled && (a.u.enable(), en(a));
            fn(a);
            gn(a);
            a.i.variants.some(function (E) {
              return E.primary;
            });
            (x = a.S()) && (a.h.streaming.liveSync || a.i.serviceDescription) ? (B = function () {
              return hn(a);
            }, a.m.o(c, "timeupdate", B)) : x || (A = function () {
              return jn(a);
            }, a.m.o(c, "timeupdate", A), jn(a));
            if (a.D) a.D.onManifestUpdated(x);
            a.Ta = !0;
            a.m.na(c, "loadedmetadata", function () {
              a.C.m = Date.now() / 1E3 - b;
            });
            F(C);
        }
      });
    }

    function Cm(a, b) {
      var c, d, e, f;
      return K(function (g) {
        return 1 == g.g ? (c = Nb, d = Date.now() / 1E3, e = !0, a.s = Om(a, {
          vc: a.J,
          onError: function (h) {
            xm(a, h);
          },
          ze: function (h) {
            Pm(a, h);
          },
          onExpirationUpdated: function (h, k) {
            Qm(a, h, k);
          },
          onEvent: function (h) {
            a.dispatchEvent(h);
            "drmsessionupdate" == h.type && e && (e = !1, a.C.j = Date.now() / 1E3 - d);
          }
        }), a.s.configure(a.h.drm), f = {
          id: 0,
          language: "und",
          disabledUntilTime: 0,
          primary: !1,
          audio: null,
          video: {
            id: 0,
            originalId: null,
            groupId: null,
            createSegmentIndex: function () {
              return Promise.resolve();
            },
            segmentIndex: null,
            mimeType: b ? od(b) : "",
            codecs: b ? pd(b) : "",
            encrypted: !0,
            drmInfos: [],
            keyIds: new Set(),
            language: "und",
            originalLanguage: null,
            label: null,
            type: c.ia,
            primary: !1,
            trickModeVideo: null,
            emsgSchemeIdUris: null,
            roles: [],
            forced: !1,
            channelsCount: null,
            audioSamplingRate: null,
            spatialAudio: !1,
            closedCaptions: null,
            accessibilityPurpose: null,
            external: !1,
            fastSwitching: !1
          },
          bandwidth: 100,
          allowedByApplication: !0,
          allowedByKeySystem: !0,
          decodingInfos: []
        }, a.s.Z = !0, D(g, Zg(a.s, [f], []), 2)) : D(g, a.s.Cc(a.g), 0);
      });
    }

    function Gm(a, b, c) {
      var d, e, f, g, h, k, l, m, n, r;
      return K(function (q) {
        if (1 == q.g) return um(a, "src-equals"), d = a.g, a.G = new Ij(d), e = !1, a.yb.push(function () {
          e = !0;
        }), null != a.ha && a.G.Ve(a.ha), a.K = new Tj({
          ge: function () {
            return d.playbackRate;
          },
          qd: function () {
            return d.defaultPlaybackRate;
          },
          jg: function (u) {
            d.playbackRate = u;
          },
          Xg: function (u) {
            d.currentTime += u;
          }
        }), f = a.h.streaming.rebufferingGoal, an(a, d, f), g = function () {
          return Rm(a);
        }, h = function () {
          return Sm(a);
        }, a.m.o(d, "playing", g), a.m.o(d, "pause", g), a.m.o(d, "ended", g), a.m.o(d, "ratechange", h), "none" != d.preload && a.m.na(d, "loadedmetadata", function () {
          a.C.m = Date.now() / 1E3 - b;
        }), d.audioTracks && (a.m.o(d.audioTracks, "addtrack", function () {
          return fn(a);
        }), a.m.o(d.audioTracks, "removetrack", function () {
          return fn(a);
        }), a.m.o(d.audioTracks, "change", function () {
          return fn(a);
        })), d.textTracks && (a.m.o(d.textTracks, "addtrack", function (u) {
          if (u.track) switch (u = u.track, u.kind) {
            case "metadata":
              kn(a, u);
              break;

            case "chapters":
              Xm(a, u);
              break;

            default:
              fn(a);
          }
        }), a.m.o(d.textTracks, "removetrack", function () {
          return fn(a);
        }), a.m.o(d.textTracks, "change", function () {
          return fn(a);
        })), d.src = rl(a.U, a.aa, c), (Md() || Ld("Web0S")) && d.load(), a.l = ln, a.dispatchEvent(rm("streaming")), k = new lf(), zj(d, HTMLMediaElement.HAVE_METADATA, a.m, function () {
          a.G.Ue();
          k.resolve();
        }), zj(d, HTMLMediaElement.HAVE_CURRENT_DATA, a.m, function () {
          var u;
          return K(function (v) {
            if (1 == v.g) return mn(a), u = nn(a), u.find(function (y) {
              return "disabled" != y.mode;
            }) ? (0 < u.length && (a.$ = !0), v.F(2)) : D(v, new Promise(function (y) {
              a.m.na(d.textTracks, "change", y);
              new Fd(y).R(1);
            }), 2);
            if (e) return v.return();
            on(a);
            F(v);
          });
        }), d.error ? k.reject(wm(a)) : "none" == d.preload && (Ua('With <video preload="none">, the browser will not load anything until play() is called. We are unable to measure load latency in a meaningful way, and we cannot provide track info yet. Please do not use preload="none" with Shaka Player.'), k.resolve()), a.m.na(d, "error", function () {
          k.reject(wm(a));
        }), D(q, k, 2);
        (l = a.S()) && a.h.streaming.liveSync ? (m = function () {
          return hn(a);
        }, a.m.o(d, "timeupdate", m)) : l || (n = function () {
          return jn(a);
        }, a.m.o(d, "timeupdate", n), jn(a));
        a.D && (a.D.onManifestUpdated(l), l && (r = a.Ga().end, a.m.o(d, "progress", function () {
          var u = a.Ga().end;
          r != u && (a.D.onManifestUpdated(a.S()), r = u);
        })));
        a.Ta = !0;
        F(q);
      });
    }

    function mn(a) {
      var b = a.h.preferredAudioLanguage;
      "" != b && a.De(b, a.h.preferredVariantRole);
    }

    function on(a) {
      var b = a.h.preferredTextLanguage;
      "" != b && a.eh(b, a.h.preferredTextRole, a.h.preferForcedSubs);
    }

    function kn(a, b) {
      if ("metadata" == b.kind) {
        b.mode = "hidden";
        a.m.o(b, "cuechange", function () {
          if (b.activeCues) for (var d = t(b.activeCues), e = d.next(); !e.done; e = d.next()) if (e = e.value, pn(a, e.startTime, e.endTime, e.type, e.value), a.D) a.D.onCueMetadataChange(e.value);
        });
        var c = new Fd(function () {
          var d = qn(a);
          d = t(d);

          for (var e = d.next(); !e.done; e = d.next()) e.value.mode = "hidden";
        }).Ma().R(.5);
        a.yb.push(function () {
          c.stop();
        });
      }
    }

    function Im(a, b, c, d) {
      b = t(b);

      for (var e = b.next(); !e.done; e = b.next()) if (e = e.value, e.data && e.cueTime && e.frames) {
        var f = e.cueTime + c,
            g = d;
        g && f > g && (g = f);

        for (var h = t(e.frames), k = h.next(); !k.done; k = h.next()) pn(a, f, g, "org.id3", k.value);

        if (a.D) a.D.onHlsTimedMetadata(e, f);
      }
    }

    function pn(a, b, c, d, e) {
      b = new Map().set("startTime", b).set("endTime", c).set("metadataType", d).set("payload", e);
      a.dispatchEvent(rm("metadata", b));
    }

    function Xm(a, b) {
      if (b && "chapters" == b.kind) {
        b.mode = "hidden";
        var c = new Fd(function () {
          b.mode = "hidden";
        }).Ma().R(.5);
        a.yb.push(function () {
          c.stop();
        });
      }
    }

    function Nm(a) {
      function b(c) {
        return c.video && c.audio || c.video && c.video.codecs.includes(",");
      }

      a.variants.some(b) && (a.variants = a.variants.filter(b));
    }

    p.Ui = function () {
      for (var a = this.V; a.g;) a.release();
    };

    function Om(a, b) {
      return new Sg(b, a.h.drm.updateExpirationTime);
    }

    function lm(a) {
      return new vf(function (b, c, d) {
        a.u && a.u.segmentDownloaded(b, c, d);
      }, function (b, c, d) {
        c = new Map().set("headers", b).set("request", c).set("requestType", d);
        a.dispatchEvent(rm("downloadheadersreceived", c));

        if (a.Z && (c = a.Z, c.h.enabled)) {
          if (d = b["cmsd-static"]) try {
            var e = new Map(),
                f = d.split(",");

            for (d = 0; d < f.length; d++) {
              var g = f[d].split("=");
              e.set(g[0], Nl(g[1]));
            }
          } catch (n) {}

          if (b = b["cmsd-dynamic"]) {
            try {
              var h = new Map(),
                  k = b.split(";");

              for (b = 1; b < k.length; b++) {
                var l = k[b].split("=");
                h.set(l[0], Nl(l[1]));
              }

              var m = h;
            } catch (n) {
              m = null;
            }

            m && (c.g = m);
          }
        }
      }, function (b, c, d, e) {
        b = new Map().set("request", b).set("error", c).set("httpResponseCode", d).set("aborted", e);
        a.dispatchEvent(rm("downloadfailed", b));
      }, function (b, c, d) {
        var e = a.U;
        d = void 0 === d ? {} : d;
        if (e.g.enabled) if ("HEAD" === c.method) yl(e, c);else switch (b) {
          case 0:
            try {
              if (e.g.enabled) {
                if (d.type) {
                  a: {
                    switch (d.type) {
                      case 4:
                        var f = "d";
                        break a;

                      case 3:
                      case 2:
                        f = "h";
                        break a;

                      case 5:
                        f = "s";
                        break a;
                    }

                    f = void 0;
                  }

                  e.s = f;
                }

                yl(e, c, {
                  ot: vl,
                  su: !e.i
                });
              }
            } catch (m) {
              Va("CMCD_MANIFEST_ERROR", "Could not generate manifest CMCD data.", m);
            }

            break;

          case Ff:
            b = d;

            try {
              if (e.g.enabled) {
                var g = b.segment;
                f = 0;
                g && (f = g.endTime - g.startTime);
                var h = {
                  d: 1E3 * f,
                  st: e.h.S() ? "l" : "v"
                };
                h.ot = Bl(b);
                var k = h.ot === zl || h.ot === Dl || h.ot === ul || h.ot === El,
                    l = b.stream;
                l && (k && (h.bl = Gl(e, l.type)), l.bandwidth && (h.br = l.bandwidth / 1E3));
                k && h.ot !== El && (h.tb = Hl(e, h.ot) / 1E3);
                yl(e, c, h);
              }
            } catch (m) {
              Va("CMCD_SEGMENT_ERROR", "Could not generate segment CMCD data.", m);
            }

            break;

          case 2:
          case 5:
          case 6:
            yl(e, c, {
              ot: "k"
            });
            break;

          case 4:
            yl(e, c, {
              ot: "o"
            });
        }
      }, function (b, c, d, e) {
        a.H && a.H.banLocation && a.H.banLocation(e);
      });
    }

    function Zm(a, b) {
      return new Jj(a.g, a.i, a.h.streaming, b, function () {
        a.Ua && Vj(a.Ua, !0);
        a.j && a.j.Hd();
        a.M && rn(a);
      }, function (c) {
        return a.dispatchEvent(c);
      });
    }

    function $m(a, b) {
      b = new bk(a.ua, a.S() || 0 < b);
      b.addEventListener("enter", function (d) {
        Jm(a, "timelineregionenter", d.region);
      });
      b.addEventListener("exit", function (d) {
        Jm(a, "timelineregionexit", d.region);
      });
      b.addEventListener("skip", function (d) {
        var e = d.region;
        d.seeking || (Jm(a, "timelineregionenter", e), Jm(a, "timelineregionexit", e));
      });
      var c = new Uj(a.g);
      c.g.add(b);
      a.ra && c.g.add(a.ra);
      return c;
    }

    function an(a, b, c) {
      a.M = new df();
      a.M.g = ff;
      gf(a.M, c, Math.min(.5, c / 2));
      zm(a);
      a.m.o(b, "waiting", function () {
        return rn(a);
      });
      a.m.o(b, "stalled", function () {
        return rn(a);
      });
      a.m.o(b, "canplaythrough", function () {
        return rn(a);
      });
      a.m.o(b, "progress", function () {
        return rn(a);
      });
    }

    function rn(a) {
      switch (a.l) {
        case ln:
          if (a.g.ended) var b = !0;else {
            var c = Sh(a.g.buffered);
            b = null != c && c >= a.g.duration - 1;
          }
          break;

        case Wm:
          a: if (a.g.ended || Ui(a.I)) b = !0;else {
            if (a.i.presentationTimeline.S()) {
              c = a.i.presentationTimeline.Vb();
              var d = Sh(a.g.buffered);

              if (null != d && d >= c) {
                b = !0;
                break a;
              }
            }

            b = !1;
          }

          break;

        default:
          b = !1;
      }

      d = Uh(a.g.buffered, a.g.currentTime);
      c = a.M;
      var e = b,
          f = c.h.get(c.g);
      b = c.g;
      d = e || d >= f ? ef : ff;
      c.g = d;
      b != d && zm(a);
    }

    function Hm(a, b, c, d) {
      return new Mi(a, b, c, d);
    }

    function km(a) {
      return new ql({
        getBandwidthEstimate: function () {
          return a.u ? a.u.getBandwidthEstimate() : NaN;
        },
        Fb: function () {
          return a.Fb();
        },
        getCurrentTime: function () {
          return a.g ? a.g.currentTime : 0;
        },
        Ub: function () {
          return a.Ub();
        },
        Tb: function () {
          return a.Tb();
        },
        hb: function () {
          return a.hb();
        },
        S: function () {
          return a.S();
        }
      }, a.h.cmcd);
    }

    function Vm(a) {
      return new pk(a.i, {
        fe: function () {
          return a.G ? a.G.Ud() : 0;
        },
        getBandwidthEstimate: function () {
          return a.u.getBandwidthEstimate();
        },
        Y: a.I,
        vc: a.J,
        onError: function (b) {
          return xm(a, b);
        },
        onEvent: function (b) {
          return a.dispatchEvent(b);
        },
        Ni: function () {
          a.H && a.H.update && a.H.update();
        },
        Tf: function (b, c, d) {
          a.G && a.G.Yg();
          rn(a);
          b = new Map().set("start", b).set("end", c).set("contentType", d);
          a.dispatchEvent(rm("segmentappended", b));
        },
        Mi: function (b, c) {
          (c = c.Of) && a.ra && Yj(a.ra, c, b);
        },
        zg: function (b, c) {
          var d = a.s;

          if (d.h.parseInbandPsshEnabled && !d.K && ["audio", "video"].includes(b)) {
            c = new ug(nc(c));
            var e = 0,
                f = t(c.data);

            for (b = f.next(); !b.done; b = f.next()) e += b.value.length;

            if (0 == e) d = Promise.resolve();else {
              e = new Uint8Array(e);
              f = 0;
              c = t(c.data);

              for (b = c.next(); !b.done; b = c.next()) b = b.value, e.set(b, f), f += b.length;

              hh(d, "cenc", e);
              d = d.l;
            }
          } else d = Promise.resolve();

          return d;
        },
        Oi: function (b, c, d) {
          Im(a, b, c, d);
        },
        Zd: function (b, c) {
          return a.Zd(b, c);
        }
      });
    }

    p.configure = function (a, b) {
      2 == arguments.length && "string" == typeof a && (a = Ql(a, b));
      a.streaming && "forceTransmuxTS" in a.streaming && (Le("streaming.forceTransmuxTS configuration", "Please Use mediaSource.forceTransmux instead."), a.mediaSource.mediaSource = a.streaming.forceTransmuxTS, delete a.streaming.forceTransmuxTS);
      a.streaming && "forceTransmux" in a.streaming && (Le("streaming.forceTransmux configuration", "Please Use mediaSource.forceTransmux instead."), a.mediaSource.mediaSource = a.streaming.forceTransmux, delete a.streaming.forceTransmux);
      a.streaming && a.streaming.lowLatencyMode && (void 0 == a.streaming.inaccurateManifestTolerance && (a.streaming.inaccurateManifestTolerance = 0), void 0 == a.streaming.rebufferingGoal && (a.streaming.rebufferingGoal = .01), void 0 == a.streaming.segmentPrefetchLimit && (a.streaming.segmentPrefetchLimit = 2), void 0 == a.streaming.retryParameters && (a.streaming.retryParameters = {}), void 0 == a.streaming.retryParameters.baseDelay && (a.streaming.retryParameters.baseDelay = 100), void 0 == a.manifest && (a.manifest = {}), void 0 == a.manifest.retryParameters && (a.manifest.retryParameters = {}), void 0 == a.manifest.retryParameters.baseDelay && (a.manifest.retryParameters.baseDelay = 100), void 0 == a.drm && (a.drm = {}), void 0 == a.drm.retryParameters && (a.drm.retryParameters = {}), void 0 == a.drm.retryParameters.baseDelay && (a.drm.retryParameters.baseDelay = 100));
      var c = bm(this.h, a, jm(this));
      sn(this);
      return c;
    };

    function sn(a) {
      if (a.H) {
        var b = Cd(a.h.manifest);
        a.g && "AUDIO" === a.g.nodeName && (b.disableVideo = !0);
        a.H.configure(b);
      }

      a.s && a.s.configure(a.h.drm);

      if (a.j) {
        a.j.configure(a.h.streaming);

        try {
          tn(a, a.i);
        } catch (f) {
          xm(a, f);
        }

        a.u && gn(a);
        b = a.j.j;
        !b || b.allowedByApplication && b.allowedByKeySystem || un(a);
      }

      a.J && a.J.hg(a.h.streaming.forceHTTPS);

      if (a.I && (a.I.configure(a.h.mediaSource), a.I.Z = a.h.manifest.segmentRelativeVttTiming, b = a.h.textDisplayFactory, a.Yf != b)) {
        var c = b(),
            d = a.I,
            e = d.H;
        d.H = c;
        e && (c.setTextVisibility(e.isTextVisible()), e.destroy());
        d.h && (d.h.j = c);
        a.Yf = b;
        a.j && (b = a.j, (c = b.i.get(Mb)) && Ak(b, c.stream, !0, 0, !0));
      }

      a.u && (a.u.configure(a.h.abr), a.h.abr.enabled ? a.u.enable() : a.u.disable(), en(a));
      a.M && (b = a.h.streaming.rebufferingGoal, a.i && (b = Math.max(b, a.i.minBufferTime)), gf(a.M, b, Math.min(.5, b / 2)));
      a.i && Tm(a.i.presentationTimeline, a.h.playRangeStart, a.h.playRangeEnd);
      a.D && a.D.configure(a.h.ads);
      a.U && a.U.configure(a.h.cmcd);
      a.Z && a.Z.configure(a.h.cmsd);
    }

    p.getConfiguration = function () {
      var a = jm(this);
      bm(a, this.h, jm(this));
      return a;
    };

    p.Mh = function () {
      if (this.g) {
        var a = this.g.buffered.length;
        a = a ? this.g.buffered.end(a - 1) : 0;
        var b = this.getConfiguration().streaming.bufferingGoal;
        b = Math.min(this.g.currentTime + b, this.Ga().end);
        if (a >= b) return 1;
        if (!(a <= this.g.currentTime) && a < b) return (a - this.g.currentTime) / (b - this.g.currentTime);
      }

      return 0;
    };

    p.Yi = function () {
      for (var a in this.h) delete this.h[a];

      bm(this.h, jm(this), jm(this));
      sn(this);
    };

    p.ee = function () {
      return this.l;
    };

    p.Bf = function () {
      return this.i ? this.i.type : null;
    };

    p.ci = function () {
      return this.g;
    };

    p.Tb = function () {
      return this.J;
    };

    p.yf = function () {
      return this.aa;
    };

    p.ae = function () {
      return this.D ? this.D : null;
    };

    p.S = function () {
      return this.i ? this.i.presentationTimeline.S() : this.g && this.g.src ? Infinity == this.g.duration : !1;
    };

    p.rc = function () {
      return this.i ? this.i.presentationTimeline.rc() : !1;
    };

    p.Lc = function () {
      if (this.i) {
        var a = this.i.variants;
        return a.length ? !a[0].video : !1;
      }

      return this.g && this.g.src ? this.g.videoTracks ? 0 == this.g.videoTracks.length : 0 == this.g.videoHeight : !1;
    };

    p.Ga = function () {
      if (this.i) {
        if (!this.Ta && "HLS" == this.i.type) return {
          start: 0,
          end: 0
        };
        var a = this.i.presentationTimeline;
        return {
          start: a.Ic(),
          end: a.Gb()
        };
      }

      return this.g && this.g.src && (a = this.g.seekable, a.length) ? {
        start: a.start(0),
        end: a.end(a.length - 1)
      } : {
        start: 0,
        end: 0
      };
    };

    p.ti = function () {
      this.S() && (this.g.currentTime = this.Ga().end);
    };

    p.keySystem = function () {
      var a = this.drmInfo();
      return a ? a.keySystem : "";
    };

    p.drmInfo = function () {
      return this.s ? this.s.g : null;
    };

    p.rd = function () {
      return this.s ? this.s.rd() : Infinity;
    };

    p.xf = function () {
      return this.s ? this.s.xf() : [];
    };

    p.ce = function () {
      return this.s ? this.s.ce() : {};
    };

    p.wd = function () {
      return this.M ? this.M.g == ff : !1;
    };

    p.Ub = function () {
      return this.g ? this.K ? this.K.h : 1 : 0;
    };

    p.Ld = function (a) {
      0 == a ? Ua("A trick play rate of 0 is unsupported!") : (this.g.paused && this.g.play(), this.K.set(a), this.l == Wm && (this.u.playbackRateChanged(a), zk(this.j, 1 < Math.abs(a))));
    };

    p.$e = function () {
      var a = this.K.qd();
      this.l == ln && this.K.set(a);
      this.l == Wm && (this.K.set(a), this.u.playbackRateChanged(a), zk(this.j, !1));
    };

    p.hb = function () {
      if (this.i) {
        for (var a = this.j ? this.j.j : null, b = [], c = 0, d = t(this.i.variants), e = d.next(); !e.done; e = d.next()) if (e = e.value, Be(e)) {
          var f = te(e);
          f.active = e == a;
          f.active || 1 == c || null == a || e.video != a.video || e.audio != a.audio || (f.active = !0);
          f.active && c++;
          b.push(f);
        }

        return b;
      }

      return this.g && this.g.audioTracks ? Array.from(this.g.audioTracks).map(function (g) {
        return Ae(g);
      }) : [];
    };

    p.Xb = function () {
      if (this.i) {
        for (var a = this.j ? this.j.s : null, b = [], c = t(this.i.textStreams), d = c.next(); !d.done; d = c.next()) {
          d = d.value;
          var e = ue(d);
          e.active = d == a;
          b.push(e);
        }

        return b;
      }

      return this.g && this.g.src && this.g.textTracks ? nn(this).map(function (f) {
        return ye(f);
      }) : [];
    };

    p.be = function () {
      var a = this.ic;
      this.i && (a = this.i.imageStreams);
      return a.map(function (b) {
        return ve(b);
      });
    };

    p.Jh = function (a) {
      var b = this,
          c,
          d,
          e,
          f;
      return K(function (g) {
        if (1 == g.g) {
          if (b.l != Wm && b.l != ln) return g.return(null);
          c = b.ic;
          b.i && (c = b.i.imageStreams);
          return (d = c.find(function (h) {
            return h.id == a;
          })) ? d.segmentIndex ? g.F(2) : D(g, d.createSegmentIndex(), 2) : g.return(null);
        }

        if (4 != g.g) return e = [], Pj(d.segmentIndex, function (h) {
          var k = vn(h.tilesLayout || d.tilesLayout);

          if (k) {
            k = k.rows * k.hc;

            for (var l = h.i - h.startTime, m = 0; m < k; m++) e.push(b.Df(a, h.startTime + l * m / k));
          }
        }), D(g, Promise.all(e), 4);
        f = g.h;
        return g.return(f.filter(function (h) {
          return h;
        }));
      });
    };

    function vn(a) {
      return a ? (a = /(\d+)x(\d+)/.exec(a)) ? {
        hc: parseInt(a[1], 10),
        rows: parseInt(a[2], 10)
      } : null : null;
    }

    p.Df = function (a, b) {
      var c = this,
          d,
          e,
          f,
          g,
          h,
          k,
          l,
          m,
          n,
          r,
          q,
          u,
          v,
          y,
          z,
          x,
          B,
          A;
      return K(function (C) {
        if (1 == C.g) {
          if (c.l != Wm && c.l != ln) return C.return(null);
          d = c.ic;
          c.i && (d = c.i.imageStreams);
          return (e = d.find(function (E) {
            return E.id == a;
          })) ? e.segmentIndex ? C.F(2) : D(C, e.createSegmentIndex(), 2) : C.return(null);
        }

        f = e.segmentIndex.find(b);
        if (null == f) return C.return(null);
        g = e.segmentIndex.get(f);
        h = vn(g.tilesLayout || e.tilesLayout);
        if (!h) return C.return(null);
        k = e.width || 0;
        l = e.height || 0;
        m = k / h.hc;
        n = l / h.rows;
        r = h.hc * h.rows;
        q = g.i - g.startTime;
        u = g.H || q / r;
        v = g.startTime;
        z = y = 0;
        1 < r && (x = Math.floor((b - g.startTime) / u), v = g.startTime + x * u, y = x % h.hc * m, z = Math.floor(x / h.hc) * n);
        B = !1;
        if (A = g.G) B = !0, n = A.height, y = A.positionX, z = A.positionY, m = A.width;
        return C.return({
          segment: g,
          imageHeight: l,
          imageWidth: k,
          height: n,
          positionX: y,
          positionY: z,
          startTime: v,
          duration: u,
          uris: g.ba(),
          width: m,
          sprite: B
        });
      });
    };

    p.eg = function (a) {
      if (this.i && this.j) {
        var b = this.i.textStreams.find(function (d) {
          return d.id == a.id;
        });
        b && b != this.j.s && (gm(this.C.h, b, !1), Ck(this.j, b), wn(this), this.Na = b.language);
      } else if (this.g && this.g.src && this.g.textTracks) {
        b = nn(this);
        b = t(b);

        for (var c = b.next(); !c.done; c = b.next()) c = c.value, we(c) == a.id ? c.mode = this.$ ? "showing" : "hidden" : c.mode = "disabled";

        wn(this);
      }
    };

    p.Ee = function (a, b, c) {
      b = void 0 === b ? !1 : b;
      c = void 0 === c ? 0 : c;

      if (this.i && this.j) {
        this.h.abr.enabled && Ua("Changing tracks while abr manager is enabled will likely result in the selected track being overriden. Consider disabling abr before calling selectVariantTrack().");
        var d = this.i.variants.find(function (e) {
          return e.id == a.id;
        });
        d && Be(d) && (Um(this, d, !1, b, c), this.Aa = new Te(d, this.h.mediaSource.codecSwitchingStrategy, this.h.manifest.dash.enableAudioGroups), gn(this));
      } else if (this.g && this.g.audioTracks) for (b = Array.from(this.g.audioTracks), b = t(b), c = b.next(); !c.done; c = b.next()) if (c = c.value, we(c) == a.id) {
        xn(this, c);
        break;
      }
    };

    p.Lh = function () {
      return yn(this.hb());
    };

    p.li = function () {
      return yn(this.Xb());
    };

    p.Kh = function () {
      return Array.from(zn(this.hb()));
    };

    p.ki = function () {
      return Array.from(zn(this.Xb()));
    };

    p.De = function (a, b, c, d) {
      c = void 0 === c ? 0 : c;
      d = void 0 === d ? 0 : d;

      if (this.i && this.G) {
        this.Aa = new Ue(a, b || "", c, "", !1, "", "", "", this.h.mediaSource.codecSwitchingStrategy, this.h.manifest.dash.enableAudioGroups);

        a = function (g, h) {
          return g.video || h.video ? g.video && h.video ? Math.abs((g.video.height || 0) - (h.video.height || 0)) + Math.abs((g.video.width || 0) - (h.video.width || 0)) : Infinity : 0;
        };

        b = this.j.j;
        var e = this.Aa.create(this.i.variants);
        c = null;
        e = t(e.values());

        for (var f = e.next(); !f.done; f = e.next()) if (f = f.value, !c || a(c, b) > a(f, b)) c = f;

        c ? (a = te(c), this.Ee(a, !0, d)) : un(this);
      } else this.g && this.g.audioTracks && (d = De(this.hb(), a, b || "", !1)[0]) && this.Ee(d);
    };

    p.eh = function (a, b, c) {
      c = void 0 === c ? !1 : c;

      if (this.i && this.G) {
        if (this.Na = a, this.Qb = b || "", this.Cb = c, (a = De(this.i.textStreams, this.Na, this.Qb, this.Cb)[0] || null) && a != this.j.s && (gm(this.C.h, a, !1), this.h.streaming.alwaysStreamText || this.tc())) Ck(this.j, a), wn(this);
      } else (a = De(this.Xb(), a, b || "", c)[0]) && this.eg(a);
    };

    p.cj = function (a, b, c) {
      b = void 0 === b ? !0 : b;
      c = void 0 === c ? 0 : c;

      if (this.i && this.G) {
        for (var d = null, e = t(this.i.variants), f = e.next(); !f.done; f = e.next()) if (f = f.value, f.audio.label == a) {
          d = f;
          break;
        }

        null != d && (this.Aa = new Ue(d.language, "", 0, "", !1, "", a, "", this.h.mediaSource.codecSwitchingStrategy, this.h.manifest.dash.enableAudioGroups), un(this, b, c));
      } else if (this.g && this.g.audioTracks) {
        c = Array.from(this.g.audioTracks);
        b = null;
        c = t(c);

        for (d = c.next(); !d.done; d = c.next()) d = d.value, d.label == a && (b = d);

        b && xn(this, b);
      }
    };

    p.tc = function () {
      var a = this.$;
      return this.I && this.l == Wm ? this.I.H.isTextVisible() : this.g && this.g.src && this.g.textTracks ? nn(this).some(function (b) {
        return "showing" == b.mode;
      }) : a;
    };

    p.Lg = function () {
      return this.g && this.g.src && this.g.textTracks ? An(this).map(function (a) {
        return ye(a);
      }) : [];
    };

    p.zf = function (a) {
      if (!this.g || !this.g.src || !this.g.textTracks) return [];
      var b = Qb(a),
          c = An(this).filter(function (h) {
        return Qb(h.language) == b;
      });
      if (!c || !c.length) return [];
      a = [];
      var d = new Set();
      c = t(c);

      for (var e = c.next(); !e.done; e = c.next()) if ((e = e.value) && e.cues) {
        e = t(e.cues);

        for (var f = e.next(); !f.done; f = e.next()) {
          var g = f.value;
          (f = g.id) && "" != f || (f = g.startTime + "-" + g.endTime + "-" + g.text);
          g = {
            id: f,
            title: g.text,
            startTime: g.startTime,
            endTime: g.endTime
          };
          d.has(f) || (a.push(g), d.add(f));
        }
      }

      return a;
    };

    function nn(a) {
      return Array.from(a.g.textTracks).filter(function (b) {
        return "metadata" != b.kind && "chapters" != b.kind && "Shaka Player TextTrack" != b.label;
      });
    }

    function qn(a) {
      return Array.from(a.g.textTracks).filter(function (b) {
        return "metadata" == b.kind;
      });
    }

    function An(a) {
      return Array.from(a.g.textTracks).filter(function (b) {
        return "chapters" == b.kind;
      });
    }

    p.lg = function (a) {
      a = !!a;

      if (this.$ != a) {
        this.$ = a;
        if (this.l == Wm) this.I.H.setTextVisibility(a), this.h.streaming.alwaysStreamText || (a ? this.j.s || (a = De(this.i.textStreams, this.Na, this.Qb, this.Cb), 0 < a.length && (Ck(this.j, a[0]), wn(this))) : yk(this.j));else if (this.g && this.g.src && this.g.textTracks) {
          var b = nn(this);
          b = t(b);

          for (var c = b.next(); !c.done; c = b.next()) c = c.value, "disabled" != c.mode && (c.mode = a ? "showing" : "hidden");
        }
        dn(this);
      }
    };

    p.di = function () {
      if (!this.S()) return null;
      if (this.G) var a = this.G.Ud();else {
        if (null == this.ha) return new Date();
        a = this.ha;
      }
      if (this.i) return new Date(1E3 * (this.i.presentationTimeline.i + a));

      if (this.g && this.g.getStartDate) {
        var b = this.g.getStartDate();
        return isNaN(b.getTime()) ? null : new Date(b.getTime() + 1E3 * a);
      }

      return null;
    };

    p.Og = function () {
      if (!this.S()) return null;
      if (this.i) return new Date(1E3 * this.i.presentationTimeline.i);

      if (this.g && this.g.getStartDate) {
        var a = this.g.getStartDate();
        return isNaN(a.getTime()) ? null : a;
      }

      return null;
    };

    p.Fb = function () {
      if (this.l == Wm) return this.I.Fb();
      var a = {
        total: [],
        audio: [],
        video: [],
        text: []
      };
      this.l == ln && (a.total = Vh(this.g.buffered));
      return a;
    };

    p.getStats = function () {
      if (this.l != Wm && this.l != ln) return {
        width: NaN,
        height: NaN,
        streamBandwidth: NaN,
        decodedFrames: NaN,
        droppedFrames: NaN,
        corruptedFrames: NaN,
        stallsDetected: NaN,
        gapsJumped: NaN,
        estimatedBandwidth: NaN,
        completionPercent: NaN,
        loadLatency: NaN,
        manifestTimeSeconds: NaN,
        drmTimeSeconds: NaN,
        playTime: NaN,
        pauseTime: NaN,
        bufferingTime: NaN,
        licenseTime: NaN,
        liveLatency: NaN,
        maxSegmentDuration: NaN,
        switchHistory: [],
        stateHistory: []
      };
      Rm(this);
      var a = this.g,
          b = a.currentTime / a.duration;

      if (!isNaN(b)) {
        var c = this.C;
        b = Math.round(100 * b);
        c.i = isNaN(c.i) ? b : Math.max(c.i, b);
      }

      this.G && (this.C.M = this.G.vg(), this.C.N = this.G.wg());

      if (a.getVideoPlaybackQuality) {
        c = a.getVideoPlaybackQuality();
        b = this.C;
        var d = Number(c.totalVideoFrames);
        b.L = Number(c.droppedVideoFrames);
        b.K = d;
        this.C.J = Number(c.corruptedVideoFrames);
      }

      this.s ? (c = this.s, c = c.J ? c.J : NaN) : c = NaN;
      this.C.u = c;

      if (this.l == Wm) {
        if (c = this.j.j) this.C.D = (this.K ? this.K.h : 1) * c.bandwidth;
        c && c.video && (b = this.C, d = c.video.height || NaN, b.s = c.video.width || NaN, b.l = d);
        this.S() && (c = this.Og().valueOf() + 1E3 * a.currentTime, this.C.G = (Date.now() - c) / 1E3);
        this.i && this.i.presentationTimeline && (this.C.I = this.i.presentationTimeline.g);
        c = this.u.getBandwidthEstimate();
        this.C.C = c;
      }

      this.l == ln && (c = this.C, b = a.videoHeight || NaN, c.s = a.videoWidth || NaN, c.l = b);
      var e = this.C;
      a = e.s;
      c = e.l;
      b = e.D;
      d = e.K;
      var f = e.L,
          g = e.J,
          h = e.N,
          k = e.M,
          l = e.C,
          m = e.i,
          n = e.m,
          r = e.H,
          q = e.j,
          u = dm(e.g, "playing"),
          v = dm(e.g, "paused"),
          y = dm(e.g, "buffering"),
          z = e.u,
          x = e.G,
          B = e.I,
          A = em(e.g),
          C = [];
      e = t(e.h.g);

      for (var E = e.next(); !E.done; E = e.next()) E = E.value, C.push({
        timestamp: E.timestamp,
        id: E.id,
        type: E.type,
        fromAdaptation: E.fromAdaptation,
        bandwidth: E.bandwidth
      });

      return {
        width: a,
        height: c,
        streamBandwidth: b,
        decodedFrames: d,
        droppedFrames: f,
        corruptedFrames: g,
        stallsDetected: h,
        gapsJumped: k,
        estimatedBandwidth: l,
        completionPercent: m,
        loadLatency: n,
        manifestTimeSeconds: r,
        drmTimeSeconds: q,
        playTime: u,
        pauseTime: v,
        bufferingTime: y,
        licenseTime: z,
        liveLatency: x,
        maxSegmentDuration: B,
        stateHistory: A,
        switchHistory: C
      };
    };

    p.yh = function (a, b, c, d, e, f, g) {
      g = void 0 === g ? !1 : g;
      var h = this,
          k,
          l,
          m,
          n,
          r,
          q,
          u,
          v,
          y,
          z,
          x,
          B;
      return K(function (A) {
        switch (A.g) {
          case 1:
            if (h.l != Wm && h.l != ln) throw new P(1, 7, 7004);

            if (d) {
              A.F(2);
              break;
            }

            return D(A, Bn(h, a), 3);

          case 3:
            d = A.h;

          case 2:
            k = [];
            h.D && (k = h.D.getCuePoints());

            if (h.l != ln) {
              A.F(4);
              break;
            }

            g && (c = "forced");
            return D(A, Cn(h, a, b, c, d, f || "", k), 5);

          case 5:
            l = Qb(b);
            m = h.Xb();
            if (n = m.find(function (C) {
              return Qb(C.language) == l && C.label == (f || "") && C.kind == c;
            })) return fn(h), A.return(n);
            throw new P(1, 2, 2012);

          case 4:
            r = Nb;
            q = h.g.duration;
            h.i && (q = h.i.presentationTimeline.getDuration());
            if (Infinity == q) throw new P(1, 4, 4033);

            if (!k.length) {
              A.F(6);
              break;
            }

            return D(A, Dn(h, a, h.J, h.h.streaming.retryParameters), 7);

          case 7:
            u = A.h, v = En(h, u, d, k), y = new Blob([v], {
              type: "text/vtt"
            }), a = Pi(y), d = "text/vtt";

          case 6:
            z = {
              id: h.rg++,
              originalId: null,
              groupId: null,
              createSegmentIndex: function () {
                return Promise.resolve();
              },
              segmentIndex: Rj(0, q, [a]),
              mimeType: d || "",
              codecs: e || "",
              kind: c,
              encrypted: !1,
              drmInfos: [],
              keyIds: new Set(),
              language: b,
              originalLanguage: b,
              label: f || null,
              type: r.sa,
              primary: !1,
              trickModeVideo: null,
              emsgSchemeIdUris: null,
              roles: [],
              forced: !!g,
              channelsCount: null,
              audioSamplingRate: null,
              spatialAudio: !1,
              closedCaptions: null,
              accessibilityPurpose: null,
              external: !0,
              fastSwitching: !1
            };
            x = fd(z.mimeType, z.codecs);
            B = rd(x);
            if (!B) throw new P(2, 2, 2014, d);
            h.i.textStreams.push(z);
            fn(h);
            return A.return(ue(z));
        }
      });
    };

    p.Ah = function (a, b) {
      var c = this,
          d,
          e,
          f,
          g,
          h,
          k,
          l,
          m,
          n,
          r,
          q,
          u,
          v,
          y,
          z,
          x;
      return K(function (B) {
        switch (B.g) {
          case 1:
            if (c.l != Wm && c.l != ln) throw new P(1, 7, 7004);

            if (b) {
              B.F(2);
              break;
            }

            return D(B, Bn(c, a), 3);

          case 3:
            b = B.h;

          case 2:
            if ("text/vtt" != b) throw new P(1, 2, 2017, a);
            d = Nb;
            e = c.g.duration;
            c.i && (e = c.i.presentationTimeline.getDuration());
            if (Infinity == e) throw new P(1, 4, 4045);
            return D(B, Dn(c, a, c.J, c.h.streaming.retryParameters), 4);

          case 4:
            f = B.h;
            g = sd[b];
            if (!g) throw new P(2, 2, 2014, b);
            h = g();
            k = {
              periodStart: 0,
              segmentStart: 0,
              segmentEnd: e,
              vttOffset: 0
            };
            l = nc(f);
            m = h.parseMedia(l, k, a);
            n = [];
            r = {};
            q = t(m);

            for (u = q.next(); !u.done; r = {
              Xc: r.Xc
            }, u = q.next()) v = u.value, r.Xc = Hb([a], [v.payload])[0], y = new Ph(v.startTime, v.endTime, function (A) {
              return function () {
                return [A.Xc];
              };
            }(r), 0, null, null, 0, 0, Infinity), r.Xc.includes("#xywh") && (z = r.Xc.split("#xywh=")[1].split(","), 4 === z.length && y.lh({
              height: parseInt(z[3], 10),
              positionX: parseInt(z[0], 10),
              positionY: parseInt(z[1], 10),
              width: parseInt(z[2], 10)
            })), n.push(y);

            x = {
              id: c.rg++,
              originalId: null,
              groupId: null,
              createSegmentIndex: function () {
                return Promise.resolve();
              },
              segmentIndex: new Oj(n),
              mimeType: b || "",
              codecs: "",
              kind: "",
              encrypted: !1,
              drmInfos: [],
              keyIds: new Set(),
              language: "und",
              originalLanguage: null,
              label: null,
              type: d.kd,
              primary: !1,
              trickModeVideo: null,
              emsgSchemeIdUris: null,
              roles: [],
              forced: !1,
              channelsCount: null,
              audioSamplingRate: null,
              spatialAudio: !1,
              closedCaptions: null,
              tilesLayout: "1x1",
              accessibilityPurpose: null,
              external: !0,
              fastSwitching: !1
            };
            c.l == ln ? c.ic.push(x) : c.i.imageStreams.push(x);
            fn(c);
            return B.return(ve(x));
        }
      });
    };

    p.xh = function (a, b, c) {
      var d = this,
          e,
          f,
          g,
          h;
      return K(function (k) {
        switch (k.g) {
          case 1:
            if (d.l != Wm && d.l != ln) throw new P(1, 7, 7004);

            if (c) {
              k.F(2);
              break;
            }

            return D(k, Bn(d, a), 3);

          case 3:
            c = k.h;

          case 2:
            return e = [], d.D && (e = d.D.getCuePoints()), D(k, Cn(d, a, b, "chapters", c, "", e), 4);

          case 4:
            f = k.h;
            g = d.Lg();
            h = g.find(function (l) {
              return l.language == b;
            });

            if (!h) {
              k.F(5);
              break;
            }

            return D(k, new Promise(function (l, m) {
              d.m.na(f, "load", l);
              d.m.na(f, "error", function () {
                m(new P(1, 2, 2015));
              });
            }), 6);

          case 6:
            return fn(d), k.return(h);

          case 5:
            throw new P(1, 2, 2012);
        }
      });
    };

    function Bn(a, b) {
      var c;
      return K(function (d) {
        switch (d.g) {
          case 1:
            return ta(d, 2), D(d, Vk(b, a.J, a.h.streaming.retryParameters), 4);

          case 4:
            c = d.h;
            va(d, 3);
            break;

          case 2:
            wa(d);

          case 3:
            if (c) return d.return(c);
            throw new P(1, 2, 2011, b);
        }
      });
    }

    function Cn(a, b, c, d, e, f, g) {
      var h, k, l, m;
      return K(function (n) {
        if (1 == n.g) return "text/vtt" != e || g.length ? D(n, Dn(a, b, a.J, a.h.streaming.retryParameters), 3) : n.F(2);
        2 != n.g && (h = n.h, k = En(a, h, e, g), l = new Blob([k], {
          type: "text/vtt"
        }), b = Pi(l), e = "text/vtt");
        m = document.createElement("track");
        var r = a.U,
            q = b;

        try {
          if (r.g.enabled) {
            var u = tl(r);
            u.ot = Fl;
            u.su = !0;
            var v = wl(u);
            var y = xl(q, v);
          } else y = q;
        } catch (z) {
          Va("CMCD_TEXT_TRACK_ERROR", "Could not generate text track CMCD data.", z), y = q;
        }

        m.src = y;
        m.label = f;
        m.kind = d;
        m.srclang = c;
        a.g.getAttribute("crossorigin") || a.g.setAttribute("crossorigin", "anonymous");
        a.g.appendChild(m);
        return n.return(m);
      });
    }

    function Dn(a, b, c, d) {
      var e, f, g;
      return K(function (h) {
        if (1 == h.g) {
          e = Ff;
          f = zf([b], d);
          f.method = "GET";
          var k = a.U;

          try {
            k.g.enabled && yl(k, f, {
              ot: Fl,
              su: !0
            });
          } catch (l) {
            Va("CMCD_TEXT_ERROR", "Could not generate text CMCD data.", l);
          }

          return D(h, c.request(e, f).promise, 2);
        }

        g = h.h;
        return h.return(g.data);
      });
    }

    function En(a, b, c, d) {
      var e = sd[c];
      if (e) return c = e(), a = {
        periodStart: 0,
        segmentStart: 0,
        segmentEnd: a.g.duration,
        vttOffset: 0
      }, b = nc(b), b = c.parseMedia(b, a, null), pl(b, d);
      throw new P(2, 2, 2014, c);
    }

    p.ig = function (a, b) {
      this.ag.width = a;
      this.ag.height = b;
    };

    p.$f = function (a) {
      if (this.l == Wm) {
        var b = this.j;
        a = void 0 === a ? .1 : a;
        if (b.l.g) b = !1;else if (b.u) b = !1;else {
          for (var c = t(b.i.values()), d = c.next(); !d.done; d = c.next()) d = d.value, !d.ud || d.Qa || d.xb || (d.ud = !1, xk(b, d, a));

          b = !0;
        }
      } else b = !1;

      return b;
    };

    p.$h = function () {
      Ua("Shaka Player's internal Manifest structure is NOT covered by semantic versioning compatibility guarantees.  It may change at any time!  Please consider filing a feature request for whatever you use getManifest() for.");
      return this.i;
    };

    p.ai = function () {
      return this.ye;
    };

    function jm(a) {
      var b = $l();

      b.streaming.failureCallback = function (c) {
        if (a.S()) {
          var d = null;
          1001 == c.code || 1002 == c.code ? d = 1 : 1003 == c.code && (d = .1);
          null != d && (c.severity = 1, a.$f(d));
        }
      };

      b.textDisplayFactory = function () {
        return a.Kc ? new gl(a.g, a.Kc) : HTMLMediaElement.prototype.addTextTrack ? new $k(a.g, "Shaka Player TextTrack") : new cl();
      };

      return b;
    }

    p.mg = function (a) {
      this.Kc = a;
    };

    function Lm(a, b) {
      for (var c = new Set(), d = t(b.textStreams), e = d.next(); !e.done; e = d.next()) e = e.value, "application/cea-608" != e.mimeType && "application/cea-708" != e.mimeType || c.add(e.originalId);

      d = t(b.variants);

      for (e = d.next(); !e.done; e = d.next()) if ((e = e.value.video) && e.closedCaptions) for (var f = t(e.closedCaptions.keys()), g = f.next(); !g.done; g = f.next()) if (g = g.value, !c.has(g)) {
        var h = g.startsWith("CC") ? "application/cea-608" : "application/cea-708",
            k = new Sj(),
            l = e.closedCaptions.get(g);
        h = {
          id: a.rg++,
          originalId: g,
          groupId: null,
          createSegmentIndex: function () {
            return Promise.resolve();
          },
          segmentIndex: k,
          mimeType: h,
          codecs: "",
          kind: "caption",
          encrypted: !1,
          drmInfos: [],
          keyIds: new Set(),
          language: l,
          originalLanguage: l,
          label: null,
          type: Mb,
          primary: !1,
          trickModeVideo: null,
          emsgSchemeIdUris: null,
          roles: e.roles,
          forced: !1,
          channelsCount: null,
          audioSamplingRate: null,
          spatialAudio: !1,
          closedCaptions: null,
          accessibilityPurpose: null,
          external: !1,
          fastSwitching: !1
        };
        b.textStreams.push(h);
        c.add(g);
      }
    }

    function Km(a, b) {
      return K(function (c) {
        if (1 == c.g) return D(c, Fn(a, b), 2);
        tn(a, b);
        F(c);
      });
    }

    function Fn(a, b) {
      return K(function (c) {
        if (1 == c.g) return D(c, de(a.s, b), 2);
        if (!b.variants.some(Be)) throw new P(2, 4, 4032);
        F(c);
      });
    }

    function tn(a, b) {
      if (a.l != sm) {
        for (var c = a.h.restrictions, d = a.ag, e = !1, f = t(b.variants), g = f.next(); !g.done; g = f.next()) {
          g = g.value;
          var h = g.allowedByApplication;
          g.allowedByApplication = ce(g, c, d);
          h != g.allowedByApplication && (e = !0);
        }

        e && a.j && fn(a);
        if ((c = a.s ? a.s.g : null) && a.s.u) for (d = t(b.variants), e = d.next(); !e.done; e = d.next()) e = e.value, Mm(a, c.keySystem, e.video), Mm(a, c.keySystem, e.audio);
        Gn(a, b);
      }
    }

    function Mm(a, b, c) {
      if (c) {
        c = t(c.drmInfos);

        for (var d = c.next(); !d.done; d = c.next()) if (d = d.value, d.keySystem == b) {
          d = t(d.initData || []);

          for (var e = d.next(); !e.done; e = d.next()) e = e.value, hh(a.s, e.initDataType, e.initData);
        }
      }
    }

    function bn(a, b) {
      var c, d, e, f, g;
      return K(function (h) {
        if (1 == h.g) return c = a.audio, d = a.video, e = function (k, l) {
          var m, n, r;
          return K(function (q) {
            if (1 == q.g) return k ? D(q, k.createSegmentIndex(), 2) : q.return(null);
            n = (m = k.segmentIndex.lc(l)) ? m.next().value : null;
            if (!n) return q.return(null);
            r = n.startTime;
            return q.return(r);
          });
        }, D(h, e(c, b), 2);
        if (3 != h.g) return f = h.h, D(h, e(d, b), 3);
        g = h.h;
        return null != g && null != f ? h.return(Math.max(g, f)) : null != g ? h.return(g) : null != f ? h.return(f) : h.return(b);
      });
    }

    function zm(a) {
      var b = a.wd();

      if (a.C && a.M && a.G) {
        if (a.U) {
          var c = a.U;
          b || c.i || (c.i = !0);
          c.i && b && (c.l = !0);
          c.m = b;
        }

        Rm(a);
      }

      b = new Map().set("buffering", b);
      a.dispatchEvent(rm("buffering", b));
    }

    function Sm(a) {
      var b = a.g.playbackRate;
      0 != b && (a.K && a.K.set(b), b = rm("ratechange"), a.dispatchEvent(b));
    }

    function Rm(a) {
      if (a.C && a.M) {
        var b = a.C.g,
            c = "playing";
        a.M.g == ff ? c = "buffering" : a.g.paused ? c = "paused" : a.g.ended && (c = "ended");
        var d = c;
        if (null == b.g) b.g = {
          timestamp: Date.now() / 1E3,
          state: d,
          duration: 0
        }, b = !0;else {
          var e = Date.now() / 1E3;
          b.g.duration = e - b.g.timestamp;
          b.g.state == d ? b = !1 : (b.h.push(b.g), b.g = {
            timestamp: e,
            state: d,
            duration: 0
          }, b = !0);
        }
        b && (c = new Map().set("newstate", c), a.dispatchEvent(rm("statechanged", c)));
      }
    }

    function hn(a) {
      if (a.S()) {
        var b = a.Ga();

        if (Number.isFinite(b.end) && !(a.g.currentTime < b.start)) {
          if (a.h.streaming.liveSync) {
            var c = a.h.streaming.liveSyncMaxLatency;
            var d = a.h.streaming.liveSyncPlaybackRate;
          } else a.i && a.i.serviceDescription && (c = a.i.serviceDescription.maxLatency || a.h.streaming.liveSyncMaxLatency, d = a.i.serviceDescription.maxPlaybackRate || a.h.streaming.liveSyncPlaybackRate);

          if (a.h.streaming.liveSync) {
            var e = a.h.streaming.liveSyncMinLatency;
            var f = a.h.streaming.liveSyncMinPlaybackRate;
          } else a.i && a.i.serviceDescription && (e = a.i.serviceDescription.minLatency || a.h.streaming.liveSyncMinLatency, f = a.i.serviceDescription.minPlaybackRate || a.h.streaming.liveSyncMinPlaybackRate);

          var g = a.g.playbackRate,
              h = b.end - a.g.currentTime,
              k = 0;

          if (a.l == ln) {
            var l = a.g.buffered;
            0 < l.length && (k = l.end(l.length - 1), k = Math.max(d, k - b.end));
          }

          c && d && h - k > c ? g != d && a.Ld(d) : e && f && h - k < e ? g != f && a.Ld(f) : g !== a.K.qd() && a.$e();
        }
      }
    }

    function jn(a) {
      if (a.g) {
        var b = !1,
            c = a.g.currentTime / a.g.duration;
        isNaN(c) || (c = Math.round(100 * c), isNaN(a.N) ? (a.N = c, b = !0) : (c = Math.max(a.N, c), a.N != c && (a.N = c, b = !0)));

        if (b) {
          var d;
          0 == a.N ? d = rm("started") : 25 == a.N ? d = rm("firstquartile") : 50 == a.N ? d = rm("midpoint") : 75 == a.N ? d = rm("thirdquartile") : 100 == a.N && (d = rm("complete"));
          d && a.dispatchEvent(d);
        }
      }
    }

    function gn(a) {
      try {
        Gn(a, a.i);
      } catch (c) {
        return xm(a, c), !1;
      }

      var b = Ce(a.i.variants);
      b = a.Aa.create(b);
      a.u.setVariants(Array.from(b.values()));
      return !0;
    }

    function Ym(a, b) {
      b = void 0 === b ? !1 : b;
      return gn(a) ? a.u.chooseVariant(b) : null;
    }

    function om(a) {
      function b(g) {
        var h = "";
        g.video && (h += "video:" + g.video.id);
        g.audio && (h = h + (h ? "&" : "") + ("audio:" + g.audio.id));
        return h;
      }

      for (var c = Date.now() / 1E3, d = !1, e = t(a.i.variants), f = e.next(); !f.done; f = e.next()) f = f.value, 0 < f.disabledUntilTime && f.disabledUntilTime <= c && (f.disabledUntilTime = 0, d = !0, ab("Re-enabled variant with " + b(f)));

      a.i.variants.every(function (g) {
        return 0 === g.disabledUntilTime;
      }) && a.ke.stop();
      d && un(a, !0, void 0, !1, !1);
    }

    function un(a, b, c, d, e) {
      b = void 0 === b ? !0 : b;
      c = void 0 === c ? 0 : c;
      d = void 0 === d ? !1 : d;
      e = void 0 === e ? !0 : e;
      var f = Ym(a);
      f && Um(a, f, e, b, c, d);
    }

    function Um(a, b, c, d, e, f) {
      f = void 0 === f ? !1 : f;
      var g = a.j.j;
      if (b == g) d && Bk(a.j, b, d, e, !0);else {
        var h = a.C.h;
        h.h != b && (h.h = b, h.g.push({
          timestamp: Date.now() / 1E3,
          id: b.id,
          type: "variant",
          fromAdaptation: c,
          bandwidth: b.bandwidth
        }));
        Bk(a.j, b, d, e, f, c);
        d = null;
        g && (d = te(g));
        b = te(b);
        c ? (c = new Map().set("oldTrack", d).set("newTrack", b), a.L && Fi(a.L, b, a.Bf()), c = rm("adaptation", c), Hn(a, c)) : In(a, d, b);
      }
    }

    function xn(a, b) {
      var c = Array.from(a.g.audioTracks).find(function (d) {
        return d.enabled;
      });
      b.enabled = !0;
      b.id !== c.id && (c.enabled = !1);
      c = Ae(c);
      b = Ae(b);
      In(a, c, b);
    }

    function cn(a, b, c) {
      if (0 == a.h.autoShowText) return !1;
      if (1 == a.h.autoShowText) return !0;
      var d = Qb(a.h.preferredTextLanguage);
      c = Qb(c.language);
      if (2 == a.h.autoShowText) return Pb(c, d);
      if (3 == a.h.autoShowText) return a = Qb(b.language), Pb(c, d) && !Pb(a, c);
      Ua("Invalid autoShowText setting!");
      return !1;
    }

    function fn(a) {
      var b = rm("trackschanged");
      Hn(a, b);
    }

    function In(a, b, c) {
      b = new Map().set("oldTrack", b).set("newTrack", c);
      a.L && Fi(a.L, c, a.Bf());
      c = rm("variantchanged", b);
      Hn(a, c);
    }

    function wn(a) {
      var b = rm("textchanged");
      Hn(a, b);
    }

    function dn(a) {
      var b = rm("texttrackvisibility");
      Hn(a, b);
    }

    function en(a) {
      a.h.abr.enabled || nm(a);
      var b = new Map().set("newStatus", a.h.abr.enabled);
      Hn(a, rm("abrstatuschanged", b));
    }

    function nm(a, b) {
      b = void 0 === b ? !0 : b;

      if (a.l == Wm) {
        a.ke.stop();

        for (var c = t(a.i.variants), d = c.next(); !d.done; d = c.next()) d.value.disabledUntilTime = 0;

        b && gn(a);
      }
    }

    p.Zd = function (a, b) {
      if (!this.h.abr.enabled || this.l === sm || !navigator.onLine) return !1;

      if (this.i.variants.some(function (f) {
        return (f = f[a.type]) && f.id !== a.id ? "audio" == a.type ? a.language === f.language : !0 : !1;
      })) {
        for (var c = t(this.i.variants), d = c.next(); !d.done; d = c.next()) {
          d = d.value;
          var e = d[a.type];
          e && e.id === a.id && (d.disabledUntilTime = Date.now() / 1E3 + b);
        }

        this.ke.ya(1);
        b = this.Fb().video.reduce(function (f, g) {
          return f + g.end - g.start;
        }, 0);
        un(this, !0, b, !0, !1);
        return !0;
      }

      return !1;
    };

    function xm(a, b) {
      var c, d, e;
      return K(function (f) {
        switch (f.g) {
          case 1:
            if (a.l == sm) return f.return();
            c = !0;

            if (!(a.Ta && a.i && a.j) || 3016 != b.code && 3014 != b.code && 3015 != b.code && 3018 != b.code) {
              f.F(2);
              break;
            }

            ta(f, 3);
            return D(f, Uk(a.j), 5);

          case 5:
            d = f.h;
            c = !d;
            va(f, 2);
            break;

          case 3:
            wa(f), c = !0;

          case 2:
            if (!c) return f.return();
            2 === b.severity && nm(a, !1);
            e = rm("error", new Map().set("detail", b));
            a.dispatchEvent(e);
            e.defaultPrevented && (b.handled = !0);
            F(f);
        }
      });
    }

    function Jm(a, b, c) {
      c = new Map().set("detail", {
        schemeIdUri: c.schemeIdUri,
        value: c.value,
        startTime: c.startTime,
        endTime: c.endTime,
        id: c.id,
        eventElement: c.eventElement
      });
      a.dispatchEvent(rm(b, c));
    }

    function wm(a) {
      if (!a.g.error) return null;
      var b = a.g.error.code;
      if (1 == b) return null;
      var c = a.g.error.msExtendedCode;
      c && (0 > c && (c += Math.pow(2, 32)), c = c.toString(16));
      return new P(2, 3, 3016, b, c, a.g.error.message);
    }

    function Pm(a, b) {
      if (a.j) {
        var c = rm("keystatuschanged");
        a.dispatchEvent(c);
        var d = Object.keys(b);
        c = 1 == d.length && "00" == d[0];
        var e = !1;

        if (d.length) {
          d = t(a.i.variants);

          for (var f = d.next(); !f.done; f = d.next()) {
            f = f.value;
            var g = [];
            f.audio && g.push(f.audio);
            f.video && g.push(f.video);
            g = t(g);

            for (var h = g.next(); !h.done; h = g.next()) {
              var k = h.value;
              h = f.allowedByKeySystem;

              if (k.keyIds.size) {
                f.allowedByKeySystem = !0;
                k = t(k.keyIds);

                for (var l = k.next(); !l.done; l = k.next()) l = l.value, l = b[c ? "00" : l], f.allowedByKeySystem = f.allowedByKeySystem && !!l && !Jn.includes(l);
              }

              h != f.allowedByKeySystem && (e = !0);
            }
          }
        }

        if (e && (fn(a), !gn(a))) return;
        (b = a.j.j) && !b.allowedByKeySystem && un(a);
      }
    }

    function Qm(a, b, c) {
      if (a.H && a.H.onExpirationUpdated) a.H.onExpirationUpdated(b, c);
      b = rm("expirationupdated");
      a.dispatchEvent(b);
    }

    function Tm(a, b, c) {
      0 < b && (a.S() || a.mh(b));
      b = a.getDuration();
      c < b && (a.S() || a.bb(c));
    }

    function Gn(a, b) {
      a = a.s ? a.s.ce() : {};
      var c = Object.keys(a);
      c = c.length && "00" == c[0];
      var d = !1,
          e = !1,
          f = new Set(),
          g = new Set();
      b = t(b.variants);

      for (var h = b.next(); !h.done; h = b.next()) {
        h = h.value;
        var k = [];
        h.audio && k.push(h.audio);
        h.video && k.push(h.video);
        k = t(k);

        for (var l = k.next(); !l.done; l = k.next()) if (l = l.value, l.keyIds.size) {
          l = t(l.keyIds);

          for (var m = l.next(); !m.done; m = l.next()) {
            m = m.value;
            var n = a[c ? "00" : m];
            n ? Jn.includes(n) && g.add(n) : f.add(m);
          }
        }

        h.allowedByApplication ? h.allowedByKeySystem && (d = !0) : e = !0;
      }

      if (!d) throw a = {
        hasAppRestrictions: e,
        missingKeys: Array.from(f),
        restrictedKeyStatuses: Array.from(g)
      }, new P(2, 4, 4012, a);
    }

    function Hn(a, b) {
      K(function (c) {
        if (1 == c.g) return D(c, Promise.resolve(), 2);
        a.l != sm && a.dispatchEvent(b);
        F(c);
      });
    }

    function zn(a) {
      var b = new Set();
      a = t(a);

      for (var c = a.next(); !c.done; c = a.next()) c = c.value, c.language ? b.add(Qb(c.language)) : b.add("und");

      return b;
    }

    function yn(a) {
      var b = new Map(),
          c = new Map();
      a = t(a);

      for (var d = a.next(); !d.done; d = a.next()) {
        d = d.value;
        var e = "und",
            f = [];
        d.language && (e = Qb(d.language));
        "variant" == d.type ? f = d.audioRoles : f = d.roles;
        f && f.length || (f = [""]);
        b.has(e) || b.set(e, new Set());
        f = t(f);

        for (var g = f.next(); !g.done; g = f.next()) g = g.value, b.get(e).add(g), d.label && (c.has(e) || c.set(e, new Map()), c.get(e).set(g, d.label));
      }

      var h = [];
      b.forEach(function (k, l) {
        k = t(k);

        for (var m = k.next(); !m.done; m = k.next()) {
          m = m.value;
          var n = null;
          c.has(l) && c.get(l).has(m) && (n = c.get(l).get(m));
          h.push({
            language: l,
            role: m,
            label: n
          });
        }
      });
      return h;
    }

    M("shaka.Player", W);
    W.prototype.setVideoContainer = W.prototype.mg;
    W.prototype.getManifestParserFactory = W.prototype.ai;
    W.prototype.getManifest = W.prototype.$h;
    W.prototype.retryStreaming = W.prototype.$f;
    W.prototype.setMaxHardwareResolution = W.prototype.ig;
    W.prototype.addChaptersTrack = W.prototype.xh;
    W.prototype.addThumbnailsTrack = W.prototype.Ah;
    W.prototype.addTextTrackAsync = W.prototype.yh;
    W.prototype.getStats = W.prototype.getStats;
    W.prototype.getBufferedInfo = W.prototype.Fb;
    W.prototype.getPresentationStartTimeAsDate = W.prototype.Og;
    W.prototype.getPlayheadTimeAsDate = W.prototype.di;
    W.prototype.setTextTrackVisibility = W.prototype.lg;
    W.prototype.getChapters = W.prototype.zf;
    W.prototype.getChaptersTracks = W.prototype.Lg;
    W.prototype.isTextTrackVisible = W.prototype.tc;
    W.prototype.selectVariantsByLabel = W.prototype.cj;
    W.prototype.selectTextLanguage = W.prototype.eh;
    W.prototype.selectAudioLanguage = W.prototype.De;
    W.prototype.getTextLanguages = W.prototype.ki;
    W.prototype.getAudioLanguages = W.prototype.Kh;
    W.prototype.getTextLanguagesAndRoles = W.prototype.li;
    W.prototype.getAudioLanguagesAndRoles = W.prototype.Lh;
    W.prototype.selectVariantTrack = W.prototype.Ee;
    W.prototype.selectTextTrack = W.prototype.eg;
    W.prototype.getThumbnails = W.prototype.Df;
    W.prototype.getAllThumbnails = W.prototype.Jh;
    W.prototype.getImageTracks = W.prototype.be;
    W.prototype.getTextTracks = W.prototype.Xb;
    W.prototype.getVariantTracks = W.prototype.hb;
    W.prototype.cancelTrickPlay = W.prototype.$e;
    W.prototype.trickPlay = W.prototype.Ld;
    W.prototype.getPlaybackRate = W.prototype.Ub;
    W.prototype.isBuffering = W.prototype.wd;
    W.prototype.getKeyStatuses = W.prototype.ce;
    W.prototype.getActiveSessionsMetadata = W.prototype.xf;
    W.prototype.getExpiration = W.prototype.rd;
    W.prototype.drmInfo = W.prototype.drmInfo;
    W.prototype.keySystem = W.prototype.keySystem;
    W.prototype.goToLive = W.prototype.ti;
    W.prototype.seekRange = W.prototype.Ga;
    W.prototype.isAudioOnly = W.prototype.Lc;
    W.prototype.isInProgress = W.prototype.rc;
    W.prototype.isLive = W.prototype.S;
    W.prototype.getAdManager = W.prototype.ae;
    W.prototype.getAssetUri = W.prototype.yf;
    W.prototype.getNetworkingEngine = W.prototype.Tb;
    W.prototype.getMediaElement = W.prototype.ci;
    W.prototype.getManifestType = W.prototype.Bf;
    W.prototype.getLoadMode = W.prototype.ee;
    W.prototype.resetConfiguration = W.prototype.Yi;
    W.prototype.getBufferFullness = W.prototype.Mh;
    W.prototype.getConfiguration = W.prototype.getConfiguration;
    W.prototype.configure = W.prototype.configure;
    W.prototype.releaseAllMutexes = W.prototype.Ui;
    W.prototype.load = W.prototype.load;
    W.prototype.updateStartTime = W.prototype.lj;
    W.prototype.unload = W.prototype.Tc;
    W.prototype.detach = W.prototype.detach;
    W.prototype.attachCanvas = W.prototype.yg;
    W.prototype.attach = W.prototype.Cc;

    W.probeSupport = function (a) {
      a = void 0 === a ? !0 : a;
      var b, c, d, e, f, g;
      return K(function (h) {
        if (1 == h.g) return b = {}, a ? D(h, Ah(), 3) : h.F(2);
        2 != h.g && (b = h.h);
        var k = {};
        if (Gd()) for (var l in Ih) k[l] = !0;
        l = t(["application/dash+xml", "application/x-mpegurl", "application/vnd.apple.mpegurl", "application/vnd.ms-sstr+xml"]);

        for (var m = l.next(); !m.done; m = l.next()) m = m.value, k[m] = Gd() ? !!Ih[m] : Hd(m);

        c = k;
        l = 'video/mp4; codecs="avc1.42E01E",video/mp4; codecs="avc3.42E01E",video/mp4; codecs="hev1.1.6.L93.90",video/mp4; codecs="hvc1.1.6.L93.90",video/mp4; codecs="hev1.2.4.L153.B0"; eotf="smpte2084",video/mp4; codecs="hvc1.2.4.L153.B0"; eotf="smpte2084",video/mp4; codecs="vp9",video/mp4; codecs="vp09.00.10.08",video/mp4; codecs="av01.0.01M.08",video/mp4; codecs="dvh1.20.01",audio/mp4; codecs="mp4a.40.2",audio/mp4; codecs="ac-3",audio/mp4; codecs="ec-3",audio/mp4; codecs="ac-4",audio/mp4; codecs="opus",audio/mp4; codecs="flac",audio/mp4; codecs="dtsc",audio/mp4; codecs="dtse",audio/mp4; codecs="dtsx",video/webm; codecs="vp8",video/webm; codecs="vp9",video/webm; codecs="vp09.00.10.08",audio/webm; codecs="vorbis",audio/webm; codecs="opus",video/mp2t; codecs="avc1.42E01E",video/mp2t; codecs="avc3.42E01E",video/mp2t; codecs="hvc1.1.6.L93.90",video/mp2t; codecs="mp4a.40.2",video/mp2t; codecs="ac-3",video/mp2t; codecs="ec-3",text/vtt,application/mp4; codecs="wvtt",application/ttml+xml,application/mp4; codecs="stpp"'.split(",").concat(w(gd));
        k = {};
        l = t(l);

        for (m = l.next(); !m.done; m = l.next()) {
          m = m.value;
          k[m] = Gd() ? rd(m) ? !0 : fc(m) || ($c(m) ? !0 : !1) : Hd(m);
          var n = m.split(";")[0];
          k[n] = k[n] || k[m];
        }

        d = k;
        e = {
          manifest: c,
          media: d,
          drm: b
        };
        f = Kn;

        for (g in f) e[g] = f[g]();

        return h.return(e);
      });
    };

    W.isBrowserSupported = tm;

    W.setAdManagerFactory = function (a) {
      mm = a;
    };

    W.registerSupportPlugin = function (a, b) {
      Kn[a] = b;
    };

    W.prototype.destroy = W.prototype.destroy;
    var sm = 0,
        im = 1,
        Wm = 2,
        ln = 3;
    W.LoadMode = {
      DESTROYED: sm,
      NOT_LOADED: im,
      MEDIA_SOURCE: Wm,
      SRC_EQUALS: ln
    };
    W.version = "v4.7.2";
    var Ln = ["4", "7"];
    Me = new function (a) {
      this.g = a;
      this.i = Ne;
      this.h = Oe;
    }(new Ke(Number(Ln[0]), Number(Ln[1])));
    var Jn = ["output-restricted", "internal-error"],
        Kn = {},
        mm = null;

    function Mn() {
      this.h = [];
      this.j = this.i = this.g = 0;
    }

    ;

    function Nn(a, b, c) {
      var d = this;
      this.g = a;
      this.h = b;
      this.m = c;
      this.i = !1;
      this.l = this.h.getVolume();
      this.j = new Jf();
      this.j.o(this.h, google.ima.AdEvent.Type.PAUSED, function () {
        d.i = !0;
      });
      this.j.o(this.h, google.ima.AdEvent.Type.RESUMED, function () {
        d.i = !1;
      });
    }

    p = Nn.prototype;

    p.getDuration = function () {
      return this.g.getDuration();
    };

    p.getMinSuggestedDuration = function () {
      return this.g.getMinSuggestedDuration();
    };

    p.getRemainingTime = function () {
      return this.h.getRemainingTime();
    };

    p.isPaused = function () {
      return this.i;
    };

    p.isSkippable = function () {
      return 0 <= this.g.getSkipTimeOffset();
    };

    p.getTimeUntilSkippable = function () {
      var a = this.g.getSkipTimeOffset();
      a = this.getRemainingTime() - a;
      return Math.max(a, 0);
    };

    p.canSkipNow = function () {
      return this.h.getAdSkippableState();
    };

    p.skip = function () {
      return this.h.skip();
    };

    p.pause = function () {
      return this.h.pause();
    };

    p.play = function () {
      return this.h.resume();
    };

    p.getVolume = function () {
      return this.h.getVolume();
    };

    p.setVolume = function (a) {
      return this.h.setVolume(a);
    };

    p.isMuted = function () {
      return 0 == this.h.getVolume();
    };

    p.isLinear = function () {
      return this.g.isLinear();
    };

    p.resize = function (a, b) {
      var c = !1,
          d = this.m;
      document.fullscreenEnabled ? c = !!document.fullscreenElement : d.webkitSupportsFullscreen && (c = d.webkitDisplayingFullscreen);
      this.h.resize(a, b, c ? google.ima.ViewMode.FULLSCREEN : google.ima.ViewMode.NORMAL);
    };

    p.setMuted = function (a) {
      a ? (this.l = this.getVolume(), this.setVolume(0)) : this.setVolume(this.l);
    };

    p.getSequenceLength = function () {
      var a = this.g.getAdPodInfo();
      return null == a ? 1 : a.getTotalAds();
    };

    p.getPositionInSequence = function () {
      var a = this.g.getAdPodInfo();
      return null == a ? 1 : a.getAdPosition();
    };

    p.getTitle = function () {
      return this.g.getTitle();
    };

    p.getDescription = function () {
      return this.g.getDescription();
    };

    p.getVastMediaBitrate = function () {
      return this.g.getVastMediaBitrate();
    };

    p.getVastMediaHeight = function () {
      return this.g.getVastMediaHeight();
    };

    p.getVastMediaWidth = function () {
      return this.g.getVastMediaWidth();
    };

    p.getAdId = function () {
      return this.g.getAdId();
    };

    p.getCreativeAdId = function () {
      return this.g.getCreativeAdId();
    };

    p.getAdvertiserName = function () {
      return this.g.getAdvertiserName();
    };

    p.getMediaUrl = function () {
      return this.g.getMediaUrl();
    };

    p.getTimeOffset = function () {
      var a = this.g.getAdPodInfo();
      return null == a ? 0 : a.getTimeOffset();
    };

    p.getPodIndex = function () {
      var a = this.g.getAdPodInfo();
      return null == a ? 0 : a.getPodIndex();
    };

    p.release = function () {
      this.h = this.g = null;
    };

    M("shaka.ads.ClientSideAd", Nn);
    Nn.prototype.release = Nn.prototype.release;
    Nn.prototype.getPodIndex = Nn.prototype.getPodIndex;
    Nn.prototype.getTimeOffset = Nn.prototype.getTimeOffset;
    Nn.prototype.getMediaUrl = Nn.prototype.getMediaUrl;
    Nn.prototype.getAdvertiserName = Nn.prototype.getAdvertiserName;
    Nn.prototype.getCreativeAdId = Nn.prototype.getCreativeAdId;
    Nn.prototype.getAdId = Nn.prototype.getAdId;
    Nn.prototype.getVastMediaWidth = Nn.prototype.getVastMediaWidth;
    Nn.prototype.getVastMediaHeight = Nn.prototype.getVastMediaHeight;
    Nn.prototype.getVastMediaBitrate = Nn.prototype.getVastMediaBitrate;
    Nn.prototype.getDescription = Nn.prototype.getDescription;
    Nn.prototype.getTitle = Nn.prototype.getTitle;
    Nn.prototype.getPositionInSequence = Nn.prototype.getPositionInSequence;
    Nn.prototype.getSequenceLength = Nn.prototype.getSequenceLength;
    Nn.prototype.setMuted = Nn.prototype.setMuted;
    Nn.prototype.resize = Nn.prototype.resize;
    Nn.prototype.isLinear = Nn.prototype.isLinear;
    Nn.prototype.isMuted = Nn.prototype.isMuted;
    Nn.prototype.setVolume = Nn.prototype.setVolume;
    Nn.prototype.getVolume = Nn.prototype.getVolume;
    Nn.prototype.play = Nn.prototype.play;
    Nn.prototype.pause = Nn.prototype.pause;
    Nn.prototype.skip = Nn.prototype.skip;
    Nn.prototype.canSkipNow = Nn.prototype.canSkipNow;
    Nn.prototype.getTimeUntilSkippable = Nn.prototype.getTimeUntilSkippable;
    Nn.prototype.isSkippable = Nn.prototype.isSkippable;
    Nn.prototype.isPaused = Nn.prototype.isPaused;
    Nn.prototype.getRemainingTime = Nn.prototype.getRemainingTime;
    Nn.prototype.getMinSuggestedDuration = Nn.prototype.getMinSuggestedDuration;
    Nn.prototype.getDuration = Nn.prototype.getDuration;

    function On(a, b, c, d, e) {
      var f = this;
      this.s = a;
      this.i = b;
      this.D = !1;
      this.u = this.G = null;
      this.H = NaN;
      this.m = e;
      this.j = null;
      this.h = new Jf();
      google.ima.settings.setLocale(c);
      google.ima.settings.setDisableCustomPlaybackForIOS10Plus(!0);
      a = new google.ima.AdDisplayContainer(this.s, this.i);
      a.initialize();
      this.l = new google.ima.AdsLoader(a);
      this.l.getSettings().setPlayerType("shaka-player");
      this.l.getSettings().setPlayerVersion("v4.7.2");
      this.g = null;
      this.C = d || new google.ima.AdsRenderingSettings();
      this.h.o(this.l, google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, function (g) {
        Pn(f, g);
      });
      this.h.o(this.l, google.ima.AdErrorEvent.Type.AD_ERROR, function (g) {
        Qn(f, g);
      });
      this.h.o(this.i, "ended", function () {
        f.l.contentComplete();
      });
      this.h.na(this.i, "play", function () {
        f.D = !0;
      });
    }

    On.prototype.configure = function (a) {
      this.G = a;
    };

    On.prototype.stop = function () {
      this.g && this.g.stop();
      this.s && fl(this.s);
    };

    On.prototype.release = function () {
      this.stop();
      this.u && this.u.disconnect();
      this.h && this.h.release();
      this.g && this.g.destroy();
      this.l.destroy();
    };

    function Qn(a, b) {
      b.getError();
      b = new Map().set("originalEvent", b);
      a.m(new N("ad-error", b));
      Rn(a, null);
      a.m(new N("ad-cue-points-changed", new Map().set("cuepoints", [])));
    }

    function Pn(a, b) {
      a.m(new N("ads-loaded", new Map().set("loadTime", Date.now() / 1E3 - a.H)));

      if (a.G.customPlayheadTracker) {
        var c = {
          currentTime: a.i.currentTime
        };
        a.g = b.getAdsManager(c, a.C);
        a.i.muted ? a.g.setVolume(0) : a.g.setVolume(a.i.volume);
        a.h.o(a.i, "timeupdate", function () {
          a.i.duration && (c.currentTime = a.i.currentTime);
        });
        a.h.o(a.i, "volumechange", function () {
          a.i.muted ? a.g.setVolume(0) : a.g.setVolume(a.i.volume);
        });
      } else a.g = b.getAdsManager(a.i, a.C);

      a.m(new N("ima-ad-manager-loaded", new Map().set("imaAdManager", a.g)));
      var d = a.g.getCuePoints();

      if (d.length) {
        b = [];
        d = t(d);

        for (var e = d.next(); !e.done; e = d.next()) b.push({
          start: e.value,
          end: null
        });

        a.m(new N("ad-cue-points-changed", new Map().set("cuepoints", b)));
      }

      Sn(a);

      try {
        a.g.init(a.i.offsetWidth, a.i.offsetHeight, Tn(a) ? google.ima.ViewMode.FULLSCREEN : google.ima.ViewMode.NORMAL), a.h.o(a.i, "loadeddata", function () {
          a.g.resize(a.i.offsetWidth, a.i.offsetHeight, Tn(a) ? google.ima.ViewMode.FULLSCREEN : google.ima.ViewMode.NORMAL);
        }), "ResizeObserver" in window ? (a.u = new ResizeObserver(function () {
          a.g.resize(a.i.offsetWidth, a.i.offsetHeight, Tn(a) ? google.ima.ViewMode.FULLSCREEN : google.ima.ViewMode.NORMAL);
        }), a.u.observe(a.i)) : a.h.o(document, "fullscreenchange", function () {
          a.g.resize(a.i.offsetWidth, a.i.offsetHeight, Tn(a) ? google.ima.ViewMode.FULLSCREEN : google.ima.ViewMode.NORMAL);
        }), a.D ? a.g.start() : a.h.na(a.i, "play", function () {
          a.D = !0;
          a.g.start();
        });
      } catch (f) {
        Rn(a, null);
      }
    }

    function Tn(a) {
      if (document.fullscreenEnabled) return !!document.fullscreenElement;
      a = a.i;
      return a.webkitSupportsFullscreen ? a.webkitDisplayingFullscreen : !1;
    }

    function Sn(a) {
      function b(c, d) {
        c = new Map().set("originalEvent", c);
        a.m(new N(d, c));
      }

      a.h.o(a.g, google.ima.AdErrorEvent.Type.AD_ERROR, function (c) {
        Qn(a, c);
      });
      a.h.o(a.g, google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED, function (c) {
        Un(a, c);
      });
      a.h.o(a.g, google.ima.AdEvent.Type.STARTED, function (c) {
        Un(a, c);
      });
      a.h.o(a.g, google.ima.AdEvent.Type.FIRST_QUARTILE, function (c) {
        b(c, "ad-first-quartile");
      });
      a.h.o(a.g, google.ima.AdEvent.Type.MIDPOINT, function (c) {
        b(c, "ad-midpoint");
      });
      a.h.o(a.g, google.ima.AdEvent.Type.THIRD_QUARTILE, function (c) {
        b(c, "ad-third-quartile");
      });
      a.h.o(a.g, google.ima.AdEvent.Type.COMPLETE, function (c) {
        b(c, "ad-complete");
      });
      a.h.o(a.g, google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED, function (c) {
        Rn(a, c);
      });
      a.h.o(a.g, google.ima.AdEvent.Type.ALL_ADS_COMPLETED, function (c) {
        Rn(a, c);
      });
      a.h.o(a.g, google.ima.AdEvent.Type.SKIPPED, function (c) {
        b(c, "ad-skipped");
      });
      a.h.o(a.g, google.ima.AdEvent.Type.VOLUME_CHANGED, function (c) {
        b(c, "ad-volume-changed");
      });
      a.h.o(a.g, google.ima.AdEvent.Type.VOLUME_MUTED, function (c) {
        b(c, "ad-muted");
      });
      a.h.o(a.g, google.ima.AdEvent.Type.PAUSED, function (c) {
        a.j && (a.j.i = !0, b(c, "ad-paused"));
      });
      a.h.o(a.g, google.ima.AdEvent.Type.RESUMED, function (c) {
        a.j && (a.j.i = !1, b(c, "ad-resumed"));
      });
      a.h.o(a.g, google.ima.AdEvent.Type.SKIPPABLE_STATE_CHANGED, function (c) {
        a.j && b(c, "ad-skip-state-changed");
      });
      a.h.o(a.g, google.ima.AdEvent.Type.CLICK, function (c) {
        b(c, "ad-clicked");
      });
      a.h.o(a.g, google.ima.AdEvent.Type.AD_PROGRESS, function (c) {
        b(c, "ad-progress");
      });
      a.h.o(a.g, google.ima.AdEvent.Type.AD_BUFFERING, function (c) {
        b(c, "ad-buffering");
      });
      a.h.o(a.g, google.ima.AdEvent.Type.IMPRESSION, function (c) {
        b(c, "ad-impression");
      });
      a.h.o(a.g, google.ima.AdEvent.Type.DURATION_CHANGE, function (c) {
        b(c, "ad-duration-changed");
      });
      a.h.o(a.g, google.ima.AdEvent.Type.USER_CLOSE, function (c) {
        b(c, "ad-closed");
      });
      a.h.o(a.g, google.ima.AdEvent.Type.LOADED, function (c) {
        b(c, "ad-loaded");
      });
      a.h.o(a.g, google.ima.AdEvent.Type.ALL_ADS_COMPLETED, function (c) {
        b(c, "all-ads-completed");
      });
      a.h.o(a.g, google.ima.AdEvent.Type.LINEAR_CHANGED, function (c) {
        b(c, "ad-linear-changed");
      });
      a.h.o(a.g, google.ima.AdEvent.Type.AD_METADATA, function (c) {
        b(c, "ad-metadata");
      });
      a.h.o(a.g, google.ima.AdEvent.Type.LOG, function (c) {
        b(c, "ad-recoverable-error");
      });
      a.h.o(a.g, google.ima.AdEvent.Type.AD_BREAK_READY, function (c) {
        b(c, "ad-break-ready");
      });
      a.h.o(a.g, google.ima.AdEvent.Type.INTERACTION, function (c) {
        b(c, "ad-interaction");
      });
    }

    function Un(a, b) {
      var c = b.getAd();
      c ? (a.j = new Nn(c, a.g, a.i), b = new Map().set("ad", a.j).set("sdkAdObject", c).set("originalEvent", b), a.m(new N("ad-started", b)), a.j.isLinear() && (a.s.setAttribute("ad-active", "true"), a.i.pause(), a.j.setVolume(a.i.volume), a.i.muted && a.j.setMuted(!0))) : Ua("The IMA SDK fired a " + b.type + " event with no associated ad. Unable to play ad!");
    }

    function Rn(a, b) {
      a.m(new N("ad-stopped", new Map().set("originalEvent", b)));
      a.j && a.j.isLinear() && (a.s.removeAttribute("ad-active"), a.i.ended || a.i.play());
    }

    ;

    function Vn(a, b, c, d, e) {
      this.h = a;
      this.g = e;
      this.i = b;
      this.j = c;
      this.l = d;
    }

    p = Vn.prototype;

    p.getDuration = function () {
      return this.h.durationInSeconds;
    };

    p.getMinSuggestedDuration = function () {
      return this.getDuration();
    };

    p.getRemainingTime = function () {
      return this.h.startTimeInSeconds + this.h.durationInSeconds - this.g.currentTime;
    };

    p.isPaused = function () {
      return this.g.paused;
    };

    p.isSkippable = function () {
      return this.h.skipOffset ? !0 : !1;
    };

    p.getTimeUntilSkippable = function () {
      if (!this.h.skipOffset) return this.getRemainingTime();
      var a = this.getRemainingTime() - this.h.skipOffset;
      return Math.max(a, 0);
    };

    p.canSkipNow = function () {
      return 0 == this.getTimeUntilSkippable();
    };

    p.skip = function () {
      this.g.currentTime += this.getRemainingTime();
    };

    p.pause = function () {
      return this.g.pause();
    };

    p.play = function () {
      return this.g.play();
    };

    p.getVolume = function () {
      return this.g.volume;
    };

    p.setVolume = function (a) {
      this.g.volume = a;
    };

    p.isMuted = function () {
      return this.g.muted;
    };

    p.isLinear = function () {
      return this.l;
    };

    p.resize = function () {};

    p.setMuted = function (a) {
      this.g.muted = a;
    };

    p.getSequenceLength = function () {
      return this.j ? this.j : 1;
    };

    p.getPositionInSequence = function () {
      return this.i ? this.i : 1;
    };

    p.getTitle = function () {
      return this.h.adTitle;
    };

    p.getDescription = function () {
      return "";
    };

    p.getVastMediaBitrate = function () {
      return 0;
    };

    p.getVastMediaHeight = function () {
      return 0;
    };

    p.getVastMediaWidth = function () {
      return 0;
    };

    p.getAdId = function () {
      return this.h.adId;
    };

    p.getCreativeAdId = function () {
      return this.h.creativeId;
    };

    p.getAdvertiserName = function () {
      return "";
    };

    p.getMediaUrl = function () {
      return null;
    };

    p.getTimeOffset = function () {
      return 0;
    };

    p.getPodIndex = function () {
      return 0;
    };

    p.release = function () {
      this.j = this.i = this.g = this.h = null;
    };

    M("shaka.ads.MediaTailorAd", Vn);
    Vn.prototype.release = Vn.prototype.release;
    Vn.prototype.getPodIndex = Vn.prototype.getPodIndex;
    Vn.prototype.getTimeOffset = Vn.prototype.getTimeOffset;
    Vn.prototype.getMediaUrl = Vn.prototype.getMediaUrl;
    Vn.prototype.getAdvertiserName = Vn.prototype.getAdvertiserName;
    Vn.prototype.getCreativeAdId = Vn.prototype.getCreativeAdId;
    Vn.prototype.getAdId = Vn.prototype.getAdId;
    Vn.prototype.getVastMediaWidth = Vn.prototype.getVastMediaWidth;
    Vn.prototype.getVastMediaHeight = Vn.prototype.getVastMediaHeight;
    Vn.prototype.getVastMediaBitrate = Vn.prototype.getVastMediaBitrate;
    Vn.prototype.getDescription = Vn.prototype.getDescription;
    Vn.prototype.getTitle = Vn.prototype.getTitle;
    Vn.prototype.getPositionInSequence = Vn.prototype.getPositionInSequence;
    Vn.prototype.getSequenceLength = Vn.prototype.getSequenceLength;
    Vn.prototype.setMuted = Vn.prototype.setMuted;
    Vn.prototype.resize = Vn.prototype.resize;
    Vn.prototype.isLinear = Vn.prototype.isLinear;
    Vn.prototype.isMuted = Vn.prototype.isMuted;
    Vn.prototype.setVolume = Vn.prototype.setVolume;
    Vn.prototype.getVolume = Vn.prototype.getVolume;
    Vn.prototype.play = Vn.prototype.play;
    Vn.prototype.pause = Vn.prototype.pause;
    Vn.prototype.skip = Vn.prototype.skip;
    Vn.prototype.canSkipNow = Vn.prototype.canSkipNow;
    Vn.prototype.getTimeUntilSkippable = Vn.prototype.getTimeUntilSkippable;
    Vn.prototype.isSkippable = Vn.prototype.isSkippable;
    Vn.prototype.isPaused = Vn.prototype.isPaused;
    Vn.prototype.getRemainingTime = Vn.prototype.getRemainingTime;
    Vn.prototype.getMinSuggestedDuration = Vn.prototype.getMinSuggestedDuration;
    Vn.prototype.getDuration = Vn.prototype.getDuration;

    function Wn(a, b, c, d) {
      this.D = a;
      this.K = b;
      this.g = c;
      this.l = null;
      this.V = NaN;
      this.i = d;
      this.J = !1;
      this.C = null;
      this.j = [];
      this.M = [];
      this.L = this.G = this.h = null;
      this.H = new Map();
      this.m = [];
      this.u = [];
      this.N = "";
      this.U = !0;
      this.I = "";
      this.s = new Jf();
    }

    Wn.prototype.stop = function () {
      for (var a = t(this.m), b = a.next(); !b.done; b = a.next()) b = b.value, this.s.bc(b.target, b.type, b.listener);

      Xn(this);
      this.m = [];
      this.u = [];
      this.N = "";
      this.U = !0;
      this.I = "";
      this.C = null;
      this.j = [];
      this.M = [];
      this.H.clear();
    };

    Wn.prototype.release = function () {
      this.stop();
      this.s && this.s.release();
    };

    Wn.prototype.onManifestUpdated = function (a) {
      this.J = a;
      "" != this.N && (Yn(this, this.N, this.U), this.U = !1);
    };

    Wn.prototype.getCuePoints = function () {
      for (var a = [], b = t(this.j), c = b.next(); !c.done; c = b.next()) {
        c = t(c.value.ads);

        for (var d = c.next(); !d.done; d = c.next()) d = d.value, a.push({
          start: d.startTimeInSeconds,
          end: d.startTimeInSeconds + d.durationInSeconds
        });
      }

      return a;
    };

    function Zn(a, b, c) {
      var d, e, f, g, h, k, l, m, n, r, q;
      K(function (u) {
        if (1 == u.g) return d = zf([b], jf()), d.method = "POST", c && (e = JSON.stringify(c), d.body = Xf(e)), f = a.K.request(7, d), ta(u, 2), D(u, f.promise, 4);

        if (2 != u.g) {
          g = u.h;
          h = Tf(g.data);
          k = JSON.parse(h);
          if (k.manifestUrl && k.trackingUrl) l = new kb(b), m = new kb(k.trackingUrl), a.N = l.resolve(m).toString(), n = Date.now() / 1E3, r = n - a.V, a.i(new N("ads-loaded", new Map().set("loadTime", r))), q = new kb(k.manifestUrl), a.l.resolve(l.resolve(q).toString()), a.l = null;else throw Error("Insufficient data from MediaTailor.");
          return va(u, 0);
        }

        wa(u);
        if (!a.I.length) return a.l.reject("MediaTailor request returned an error and there was no backup asset uri provided."), a.l = null, u.return();
        a.l.resolve(a.I);
        a.l = null;
        F(u);
      });
    }

    function Yn(a, b, c) {
      var d, e, f, g, h, k, l, m, n, r, q, u, v, y, z;
      K(function (x) {
        if (1 == x.g) return d = zf([b], jf()), e = a.K.request(7, d), ta(x, 2), D(x, e.promise, 4);

        if (2 != x.g) {
          f = x.h;
          g = [];
          h = Tf(f.data);
          k = JSON.parse(h);

          if (0 < k.avails.length) {
            if (JSON.stringify(a.j) != JSON.stringify(k.avails)) {
              a.j = k.avails;
              l = t(a.j);

              for (m = l.next(); !m.done; m = l.next()) for (n = m.value, r = t(n.nonLinearAdsList), q = r.next(); !q.done; q = r.next()) for (u = q.value, v = t(u.nonLinearAdList), y = v.next(); !y.done; y = v.next()) z = y.value, $n(a, z);

              g = a.getCuePoints();
              a.i(new N("ad-cue-points-changed", new Map().set("cuepoints", g)));
            }
          } else a.j.length && a.i(new N("ad-cue-points-changed", new Map().set("cuepoints", g))), Xn(a), a.j = [];

          c && (a.J || 0 < g.length) && ao(a);
          return va(x, 0);
        }

        wa(x);
        F(x);
      });
    }

    function $n(a, b) {
      var c, d, e, f, g, h, k, l;
      K(function (m) {
        if (1 == m.g) {
          if (!b.staticResource) return m.return();
          c = bo(b);
          if (d = a.H.get(c)) return m.return();
          e = zf([b.staticResource], jf());
          f = a.K.request(7, e);
          ta(m, 2);
          a.H.set(c, []);
          return D(m, f.promise, 4);
        }

        if (2 != m.g) return g = m.h, h = Tf(g.data), k = JSON.parse(h), l = k.apps, a.H.set(c, l), va(m, 0);
        wa(m);
        a.H.delete(c);
        F(m);
      });
    }

    function bo(a) {
      return [a.adId, a.adParameters, a.adSystem, a.adTitle, a.creativeAdId, a.creativeId, a.creativeSequence, a.height, a.width, a.staticResource].join("");
    }

    function ao(a) {
      co(a);
      a.J || (eo(a), a.s.o(a.g, "seeked", function () {
        eo(a);
      }), a.s.o(a.g, "ended", function () {
        Xn(a);
      }));
      a.s.o(a.g, "timeupdate", function () {
        co(a);
      });
    }

    function eo(a) {
      var b = a.g.currentTime;

      if (0 != b && null == a.C) {
        for (var c, d, e = t(a.j), f = e.next(); !f.done; f = e.next()) {
          f = f.value;

          for (var g = t(f.ads), h = g.next(); !h.done; h = g.next()) if (h = h.value, !d) h.startTimeInSeconds < b && (d = h, c = f);else if (h.startTimeInSeconds < b && h.startTimeInSeconds > d.startTimeInSeconds + d.durationInSeconds) {
            d = h;
            c = f;
            break;
          }
        }

        c && d && !a.M.includes(d.adId) && (a.C = b, a.g.currentTime = c.startTimeInSeconds);
      }
    }

    function co(a) {
      if (a.g.duration && (a.h || a.j.length)) {
        var b = a.g.currentTime,
            c = !1;

        if (a.h) {
          c = !0;
          var d = a.G,
              e = d.startTimeInSeconds + .5 * d.durationInSeconds,
              f = d.startTimeInSeconds + .75 * d.durationInSeconds;
          b >= d.startTimeInSeconds + .25 * d.durationInSeconds && !a.u.includes("firstQuartile") ? (a.u.push("firstQuartile"), fo(a, "firstQuartile")) : b >= e && !a.u.includes("midpoint") ? (a.u.push("midpoint"), fo(a, "midpoint")) : b >= f && !a.u.includes("thirdQuartile") && (a.u.push("thirdQuartile"), fo(a, "thirdQuartile"));
          d = a.h.getRemainingTime();
          e = a.h.getDuration();
          0 < e && (0 >= d || d > e) && Xn(a);
        }

        if (!a.h || !a.h.isLinear()) {
          a: for (d = t(a.j), e = d.next(); !e.done; e = d.next()) {
            e = e.value;
            if (a.h && a.h.isLinear()) break;

            for (f = 0; f < e.ads.length; f++) {
              var g = e.ads[f],
                  h = g.startTimeInSeconds + g.durationInSeconds;

              if (g.startTimeInSeconds <= b && h > b) {
                if (a.M.includes(g.adId)) {
                  if (a.g.ended) continue;
                  a.g.currentTime = h;
                  break a;
                }

                Xn(a);
                a.L = e;
                a.h = new Vn(g, f + 1, e.ads.length, !0, a.g);
                a.G = g;
                0 === f && fo(a, "breakStart");
                go(a);
                break;
              }
            }
          }

          if (!a.h) for (d = t(a.j), e = d.next(); !e.done; e = d.next()) {
            e = e.value;
            if (a.h) break;

            for (f = 0; f < e.nonLinearAdsList.length; f++) if (g = e.nonLinearAdsList[f], g.nonLinearAdList.length) {
              h = e.startTimeInSeconds;
              var k = a.H.get(bo(g.nonLinearAdList[0]));

              if (h <= b && k && k.length) {
                Xn(a);
                h = a;
                k = t(k);

                for (var l = k.next(); !l.done; l = k.next()) if (l = l.value, l.data.source.length) {
                  var m = document.createElement("img");
                  m.src = l.data.source[0].url;
                  m.style.top = (l.placeholder.top || 0) + "%";
                  m.style.height = 100 - (l.placeholder.top || 0) + "%";
                  m.style.left = (l.placeholder.left || 0) + "%";
                  m.style.maxWidth = 100 - (l.placeholder.left || 0) + "%";
                  m.style.objectFit = "contain";
                  m.style.position = "absolute";
                  h.D.appendChild(m);
                }

                a.L = e;
                a.h = new Vn(g, f + 1, e.ads.length, !1, a.g);
                a.G = g;
                0 === f && fo(a, "breakStart");
                go(a);
                break;
              }
            }
          }
          c && !a.h && (b = a.g.currentTime, a.C && a.C > b && (a.g.currentTime = a.C), a.C = null);
        }
      }
    }

    function Xn(a) {
      if (a.h) {
        for (; a.D.lastChild;) a.D.removeChild(a.D.firstChild);

        a.J || a.M.push(a.G.adId);
        fo(a, "complete");

        for (var b = t(a.m), c = b.next(); !c.done; c = b.next()) c = c.value, a.s.bc(c.target, c.type, c.listener);

        a.m = [];
        a.u = [];
        b = a.h.getPositionInSequence();
        c = a.h.getSequenceLength();
        b === c && fo(a, "breakEnd");
        a.h = null;
        a.G = null;
        a.L = null;
      }
    }

    function go(a) {
      var b = !1;
      a.g.paused ? b = !0 : (fo(a, "impression"), fo(a, "start"));
      a.m.push({
        target: a.g,
        type: "volumechange",
        listener: function () {
          a.g.muted && fo(a, "mute");
        }
      });
      a.m.push({
        target: a.g,
        type: "volumechange",
        listener: function () {
          a.g.muted || fo(a, "unmute");
        }
      });
      a.m.push({
        target: a.g,
        type: "play",
        listener: function () {
          b ? (fo(a, "impression"), fo(a, "start"), b = !1) : fo(a, "resume");
        }
      });
      a.m.push({
        target: a.g,
        type: "pause",
        listener: function () {
          fo(a, "pause");
        }
      });

      for (var c = t(a.m), d = c.next(); !d.done; d = c.next()) d = d.value, a.s.o(d.target, d.type, d.listener);
    }

    function fo(a, b) {
      var c = a.G.trackingEvents.find(function (e) {
        return e.eventType == b;
      });
      c || (c = a.L.adBreakTrackingEvents.find(function (e) {
        return e.eventType == b;
      }));

      if (c) {
        c = t(c.beaconUrls);

        for (var d = c.next(); !d.done; d = c.next()) (d = d.value) && "" != d && (d = zf([d], jf()), d.method = "POST", a.K.request(7, d));
      }

      switch (b) {
        case "impression":
          a.i(new N("ad-impression"));
          break;

        case "start":
          a.i(new N("ad-started", new Map().set("ad", a.h)));
          break;

        case "mute":
          a.i(new N("ad-muted"));
          break;

        case "unmute":
          a.i(new N("ad-volume-changed"));
          break;

        case "resume":
          a.i(new N("ad-resumed"));
          break;

        case "pause":
          a.i(new N("ad-paused"));
          break;

        case "firstQuartile":
          a.i(new N("ad-first-quartile"));
          break;

        case "midpoint":
          a.i(new N("ad-midpoint"));
          break;

        case "thirdQuartile":
          a.i(new N("ad-third-quartile"));
          break;

        case "complete":
          a.i(new N("ad-complete"));
          a.i(new N("ad-stopped"));
          break;

        case "breakStart":
          a.D.setAttribute("ad-active", "true");
          break;

        case "breakEnd":
          a.D.removeAttribute("ad-active");
      }
    }

    ;

    function ho(a, b) {
      this.g = a;
      this.i = null;
      this.h = b;
    }

    p = ho.prototype;

    p.getDuration = function () {
      return this.i ? this.i.duration : -1;
    };

    p.getMinSuggestedDuration = function () {
      return this.getDuration();
    };

    p.getRemainingTime = function () {
      return this.i ? this.i.duration - this.i.currentTime : -1;
    };

    p.isPaused = function () {
      return this.h.paused;
    };

    p.isSkippable = function () {
      return this.g.isSkippable();
    };

    p.getTimeUntilSkippable = function () {
      var a = this.g.getSkipTimeOffset();
      a = this.getRemainingTime() - a;
      return Math.max(a, 0);
    };

    p.canSkipNow = function () {
      return 0 == this.getTimeUntilSkippable();
    };

    p.skip = function () {
      this.h.currentTime += this.getRemainingTime();
    };

    p.pause = function () {
      return this.h.pause();
    };

    p.play = function () {
      return this.h.play();
    };

    p.getVolume = function () {
      return this.h.volume;
    };

    p.setVolume = function (a) {
      this.h.volume = a;
    };

    p.isMuted = function () {
      return this.h.muted;
    };

    p.isLinear = function () {
      return !0;
    };

    p.resize = function () {};

    p.setMuted = function (a) {
      this.h.muted = a;
    };

    p.getSequenceLength = function () {
      var a = this.g.getAdPodInfo();
      return null == a ? 1 : a.getTotalAds();
    };

    p.getPositionInSequence = function () {
      var a = this.g.getAdPodInfo();
      return null == a ? 1 : a.getAdPosition();
    };

    p.getTitle = function () {
      return this.g.getTitle();
    };

    p.getDescription = function () {
      return this.g.getDescription();
    };

    p.getVastMediaBitrate = function () {
      return 0;
    };

    p.getVastMediaHeight = function () {
      return this.g.getVastMediaHeight();
    };

    p.getVastMediaWidth = function () {
      return this.g.getVastMediaWidth();
    };

    p.getAdId = function () {
      return this.g.getAdId();
    };

    p.getCreativeAdId = function () {
      return this.g.getCreativeAdId();
    };

    p.getAdvertiserName = function () {
      return this.g.getAdvertiserName();
    };

    p.getMediaUrl = function () {
      return null;
    };

    p.getTimeOffset = function () {
      var a = this.g.getAdPodInfo();
      return null == a ? 0 : a.getTimeOffset();
    };

    p.getPodIndex = function () {
      var a = this.g.getAdPodInfo();
      return null == a ? 0 : a.getPodIndex();
    };

    p.release = function () {
      this.h = this.i = this.g = null;
    };

    M("shaka.ads.ServerSideAd", ho);
    ho.prototype.release = ho.prototype.release;
    ho.prototype.getPodIndex = ho.prototype.getPodIndex;
    ho.prototype.getTimeOffset = ho.prototype.getTimeOffset;
    ho.prototype.getMediaUrl = ho.prototype.getMediaUrl;
    ho.prototype.getAdvertiserName = ho.prototype.getAdvertiserName;
    ho.prototype.getCreativeAdId = ho.prototype.getCreativeAdId;
    ho.prototype.getAdId = ho.prototype.getAdId;
    ho.prototype.getVastMediaWidth = ho.prototype.getVastMediaWidth;
    ho.prototype.getVastMediaHeight = ho.prototype.getVastMediaHeight;
    ho.prototype.getVastMediaBitrate = ho.prototype.getVastMediaBitrate;
    ho.prototype.getDescription = ho.prototype.getDescription;
    ho.prototype.getTitle = ho.prototype.getTitle;
    ho.prototype.getPositionInSequence = ho.prototype.getPositionInSequence;
    ho.prototype.getSequenceLength = ho.prototype.getSequenceLength;
    ho.prototype.setMuted = ho.prototype.setMuted;
    ho.prototype.resize = ho.prototype.resize;
    ho.prototype.isLinear = ho.prototype.isLinear;
    ho.prototype.isMuted = ho.prototype.isMuted;
    ho.prototype.setVolume = ho.prototype.setVolume;
    ho.prototype.getVolume = ho.prototype.getVolume;
    ho.prototype.play = ho.prototype.play;
    ho.prototype.pause = ho.prototype.pause;
    ho.prototype.skip = ho.prototype.skip;
    ho.prototype.canSkipNow = ho.prototype.canSkipNow;
    ho.prototype.getTimeUntilSkippable = ho.prototype.getTimeUntilSkippable;
    ho.prototype.isSkippable = ho.prototype.isSkippable;
    ho.prototype.isPaused = ho.prototype.isPaused;
    ho.prototype.getRemainingTime = ho.prototype.getRemainingTime;
    ho.prototype.getMinSuggestedDuration = ho.prototype.getMinSuggestedDuration;
    ho.prototype.getDuration = ho.prototype.getDuration;

    function io(a, b, c, d) {
      var e = this;
      this.u = a;
      this.l = b;
      this.j = null;
      this.H = NaN;
      this.i = d;
      this.I = !1;
      this.C = this.m = this.s = null;
      this.D = "";
      this.G = [];
      this.h = new Jf();
      a = new google.ima.dai.api.UiSettings();
      a.setLocale(c);
      this.g = new google.ima.dai.api.StreamManager(this.l, this.u, a);
      this.i(new N("ima-stream-manager-loaded", new Map().set("imaStreamManager", this.g)));
      this.h.o(this.g, google.ima.dai.api.StreamEvent.Type.LOADED, function (f) {
        jo(e, f);
      });
      this.h.o(this.g, google.ima.dai.api.StreamEvent.Type.ERROR, function () {
        e.D.length ? e.j.resolve(e.D) : e.j.reject("IMA Stream request returned an error and there was no backup asset uri provided.");
        e.j = null;
      });
      this.h.o(this.g, google.ima.dai.api.StreamEvent.Type.AD_BREAK_STARTED, function () {});
      this.h.o(this.g, google.ima.dai.api.StreamEvent.Type.STARTED, function (f) {
        f = f.getAd();
        e.m = new ho(f, e.l);
        e.C && (e.m.i = e.C);
        e.i(new N("ad-started", new Map().set("ad", e.m)));
        e.u.setAttribute("ad-active", "true");
      });
      this.h.o(this.g, google.ima.dai.api.StreamEvent.Type.AD_BREAK_ENDED, function () {
        e.u.removeAttribute("ad-active");
        var f = e.l.currentTime;
        e.s && e.s > f && (e.l.currentTime = e.s, e.s = null);
      });
      this.h.o(this.g, google.ima.dai.api.StreamEvent.Type.AD_PROGRESS, function (f) {
        e.C = f.getStreamData().adProgressData;
        e.m && (e.m.i = e.C);
      });
      this.h.o(this.g, google.ima.dai.api.StreamEvent.Type.FIRST_QUARTILE, function () {
        e.i(new N("ad-first-quartile"));
      });
      this.h.o(this.g, google.ima.dai.api.StreamEvent.Type.MIDPOINT, function () {
        e.i(new N("ad-midpoint"));
      });
      this.h.o(this.g, google.ima.dai.api.StreamEvent.Type.THIRD_QUARTILE, function () {
        e.i(new N("ad-third-quartile"));
      });
      this.h.o(this.g, google.ima.dai.api.StreamEvent.Type.COMPLETE, function () {
        e.i(new N("ad-complete"));
        e.i(new N("ad-stopped"));
        e.u.removeAttribute("ad-active");
        e.m = null;
      });
      this.h.o(this.g, google.ima.dai.api.StreamEvent.Type.SKIPPED, function () {
        e.i(new N("ad-skipped"));
        e.i(new N("ad-stopped"));
      });
      this.h.o(this.g, google.ima.dai.api.StreamEvent.Type.CUEPOINTS_CHANGED, function (f) {
        var g = f.getStreamData();
        f = [];
        g = t(g.cuepoints);

        for (var h = g.next(); !h.done; h = g.next()) h = h.value, f.push({
          start: h.start,
          end: h.end
        });

        e.G = f;
        e.i(new N("ad-cue-points-changed", new Map().set("cuepoints", f)));
      });
    }

    p = io.prototype;

    p.configure = function () {};

    p.stop = function () {
      this.D = "";
      this.s = null;
      this.G = [];
    };

    p.release = function () {
      this.stop();
      this.h && this.h.release();
    };

    p.onCueMetadataChange = function (a) {
      if (a.key && a.data) {
        var b = {};
        b[a.key] = a.data;
        this.g.onTimedMetadata(b);
      }
    };

    p.getCuePoints = function () {
      return this.G;
    };

    function jo(a, b) {
      a.i(new N("ads-loaded", new Map().set("loadTime", Date.now() / 1E3 - a.H)));
      b = b.getStreamData().url;
      a.j.resolve(b);
      a.j = null;
      a.I || a.h.o(a.l, "seeked", function () {
        var c = a.l.currentTime;

        if (0 != c) {
          a.g.streamTimeForContentTime(c);
          var d = a.g.previousCuePointForStreamTime(c);
          d && !d.played && (a.s = c, a.l.currentTime = d.start);
        }
      });
    }

    ;

    function X() {
      db.call(this);
      this.g = this.i = this.h = null;
      this.j = new Mn();
      this.m = navigator.language;
      this.l = null;
    }

    pa(X, db);
    p = X.prototype;

    p.setLocale = function (a) {
      this.m = a;
    };

    p.configure = function (a) {
      this.l = a;
      this.h && this.h.configure(this.l);
      this.g && this.g.configure(this.l);
    };

    p.initClientSide = function (a, b, c) {
      var d = this;
      if (!window.google || !google.ima || !google.ima.AdsLoader) throw new P(2, 10, 1E4);
      this.h && this.h.release();
      this.h = new On(a, b, this.m, c, function (e) {
        return ko(d, e);
      });
      this.h.configure(this.l);
    };

    p.release = function () {
      this.h && (this.h.release(), this.h = null);
      this.i && (this.i.release(), this.i = null);
      this.g && (this.g.release(), this.g = null);
      db.prototype.release.call(this);
    };

    p.onAssetUnload = function () {
      this.h && this.h.stop();
      this.i && this.i.stop();
      this.g && this.g.stop();
      this.dispatchEvent(new N("ad-stopped"));
      this.j = new Mn();
    };

    p.requestClientSideAds = function (a) {
      if (!this.h) throw new P(1, 10, 10001);
      var b = this.h;
      b.g && b.g.destroy();
      b.l && b.l.contentComplete();
      b.H = Date.now() / 1E3;
      b.l.requestAds(a);
    };

    p.updateClientSideAdsRenderingSettings = function (a) {
      if (!this.h) throw new P(1, 10, 10001);
      var b = this.h;
      b.C = a;
      b.g && b.g.updateAdsRenderingSettings(b.C);
    };

    p.initMediaTailor = function (a, b, c) {
      var d = this;
      this.i && this.i.release();
      this.i = new Wn(a, b, c, function (e) {
        return ko(d, e);
      });
    };

    p.requestMediaTailorStream = function (a, b, c) {
      if (!this.i) throw new P(1, 10, 10005);
      var d = this.i;
      c = void 0 === c ? "" : c;
      d.l ? a = Promise.reject(new P(1, 10, 10004)) : (d.l = new lf(), Zn(d, a, b), d.I = c || "", d.V = Date.now() / 1E3, a = d.l);
      return a;
    };

    p.initServerSide = function (a, b) {
      var c = this;
      if (!window.google || !google.ima || !google.ima.dai) throw new P(2, 10, 10002);
      this.g && this.g.release();
      this.g = new io(a, b, this.m, function (d) {
        return ko(c, d);
      });
      this.g.configure(this.l);
    };

    p.requestServerSideStream = function (a, b) {
      b = void 0 === b ? "" : b;
      if (!this.g) throw new P(1, 10, 10003);
      a.adTagParameters || (a.adTagParameters = {});
      var c = a.adTagParameters;
      (c.mpt || c.mpv) && Ua('You have attempted to set "mpt" and/or "mpv" parameters of the ad tag. Please note that those parameters are used for Shaka adoption tracking and will be overriden.');
      a.adTagParameters.mpt = "shaka-player";
      a.adTagParameters.mpv = "v4.7.2";
      c = this.g;
      c.j ? a = Promise.reject(new P(1, 10, 10004)) : (a instanceof google.ima.dai.api.LiveStreamRequest && (c.I = !0), c.j = new lf(), c.g.requestStream(a), c.D = b || "", c.H = Date.now() / 1E3, a = c.j);
      return a;
    };

    p.replaceServerSideAdTagParameters = function (a) {
      if (!this.g) throw new P(1, 10, 10003);
      (a.mpt || a.mpv) && Ua('You have attempted to set "mpt" and/or "mpv" parameters of the ad tag. Please note that those parameters are used for Shaka adoption tracking and will be overriden.');
      a.mpt = "Shaka Player";
      a.mpv = "v4.7.2";
      this.g.g.replaceAdTagParameters(a);
    };

    p.getServerSideCuePoints = function () {
      Le("AdManager", "Please use getCuePoints function.");
      return this.getCuePoints();
    };

    p.getCuePoints = function () {
      var a = [];
      this.g && (a = a.concat(this.g.getCuePoints()));
      this.i && (a = a.concat(this.i.getCuePoints()));
      return a;
    };

    p.getStats = function () {
      var a = this.j;
      return {
        loadTimes: a.h,
        started: a.g,
        playedCompletely: a.i,
        skipped: a.j
      };
    };

    p.onManifestUpdated = function (a) {
      if (this.i) this.i.onManifestUpdated(a);
    };

    p.onDashTimedMetadata = function (a) {
      if (this.g && "urn:google:dai:2018" == a.schemeIdUri) {
        var b = a.schemeIdUri,
            c = a.eventElement ? a.eventElement.getAttribute("messageData") : null;
        this.g.g.processMetadata(b, c, a.startTime);
      }
    };

    p.onHlsTimedMetadata = function (a, b) {
      this.g && this.g.g.processMetadata("ID3", a.data, b);
    };

    p.onCueMetadataChange = function (a) {
      if (this.g) this.g.onCueMetadataChange(a);
    };

    function ko(a, b) {
      if (b && b.type) switch (b.type) {
        case "ads-loaded":
          a.j.h.push(b.loadTime);
          break;

        case "ad-started":
          a.j.g++;
          break;

        case "ad-complete":
          a.j.i++;
          break;

        case "ad-skipped":
          a.j.j++;
      }
      a.dispatchEvent(b);
    }

    M("shaka.ads.AdManager", X);
    X.prototype.onCueMetadataChange = X.prototype.onCueMetadataChange;
    X.prototype.onHlsTimedMetadata = X.prototype.onHlsTimedMetadata;
    X.prototype.onDashTimedMetadata = X.prototype.onDashTimedMetadata;
    X.prototype.onManifestUpdated = X.prototype.onManifestUpdated;
    X.prototype.getStats = X.prototype.getStats;
    X.prototype.getCuePoints = X.prototype.getCuePoints;
    X.prototype.getServerSideCuePoints = X.prototype.getServerSideCuePoints;
    X.prototype.replaceServerSideAdTagParameters = X.prototype.replaceServerSideAdTagParameters;
    X.prototype.requestServerSideStream = X.prototype.requestServerSideStream;
    X.prototype.initServerSide = X.prototype.initServerSide;
    X.prototype.requestMediaTailorStream = X.prototype.requestMediaTailorStream;
    X.prototype.initMediaTailor = X.prototype.initMediaTailor;
    X.prototype.updateClientSideAdsRenderingSettings = X.prototype.updateClientSideAdsRenderingSettings;
    X.prototype.requestClientSideAds = X.prototype.requestClientSideAds;
    X.prototype.onAssetUnload = X.prototype.onAssetUnload;
    X.prototype.release = X.prototype.release;
    X.prototype.initClientSide = X.prototype.initClientSide;
    X.prototype.configure = X.prototype.configure;
    X.prototype.setLocale = X.prototype.setLocale;
    X.ADS_LOADED = "ads-loaded";
    X.AD_STARTED = "ad-started";
    X.AD_FIRST_QUARTILE = "ad-first-quartile";
    X.AD_MIDPOINT = "ad-midpoint";
    X.AD_THIRD_QUARTILE = "ad-third-quartile";
    X.AD_COMPLETE = "ad-complete";
    X.AD_STOPPED = "ad-stopped";
    X.AD_SKIPPED = "ad-skipped";
    X.AD_VOLUME_CHANGED = "ad-volume-changed";
    X.AD_MUTED = "ad-muted";
    X.AD_PAUSED = "ad-paused";
    X.AD_RESUMED = "ad-resumed";
    X.AD_SKIP_STATE_CHANGED = "ad-skip-state-changed";
    X.CUEPOINTS_CHANGED = "ad-cue-points-changed";
    X.IMA_AD_MANAGER_LOADED = "ima-ad-manager-loaded";
    X.IMA_STREAM_MANAGER_LOADED = "ima-stream-manager-loaded";
    X.AD_CLICKED = "ad-clicked";
    X.AD_PROGRESS = "ad-progress";
    X.AD_BUFFERING = "ad-buffering";
    X.AD_IMPRESSION = "ad-impression";
    X.AD_DURATION_CHANGED = "ad-duration-changed";
    X.AD_CLOSED = "ad-closed";
    X.AD_LOADED = "ad-loaded";
    X.ALL_ADS_COMPLETED = "all-ads-completed";
    X.AD_LINEAR_CHANGED = "ad-linear-changed";
    X.AD_METADATA = "ad-metadata";
    X.AD_RECOVERABLE_ERROR = "ad-recoverable-error";
    X.AD_ERROR = "ad-error";
    X.AD_BREAK_READY = "ad-break-ready";
    X.AD_INTERACTION = "ad-interaction";

    mm = function () {
      return new X();
    };

    function lo(a) {
      return JSON.stringify(a, function (b, c) {
        if ("function" != typeof c) {
          if (c instanceof Event || c instanceof N) {
            var d = {};

            for (e in c) (b = c[e]) && "object" == typeof b ? "detail" == e && (d[e] = b) : e in Event || (d[e] = b);

            return d;
          }

          if (c instanceof Error) {
            var e = new Set(["name", "message", "stack"]);

            for (d in c) e.add(d);

            b = t(Object.getOwnPropertyNames(c));

            for (d = b.next(); !d.done; d = b.next()) e.add(d.value);

            b = {};
            e = t(e);

            for (d = e.next(); !d.done; d = e.next()) d = d.value, b[d] = c[d];

            c = {
              __type__: "Error",
              contents: b
            };
          } else if (c instanceof TimeRanges) {
            e = {
              __type__: "TimeRanges",
              length: c.length,
              start: [],
              end: []
            };
            c = t(Vh(c));

            for (d = c.next(); !d.done; d = c.next()) d = d.value, b = d.end, e.start.push(d.start), e.end.push(b);

            c = e;
          } else c = c instanceof Uint8Array ? {
            __type__: "Uint8Array",
            entries: Array.from(c)
          } : "number" == typeof c ? isNaN(c) ? "NaN" : isFinite(c) ? c : 0 > c ? "-Infinity" : "Infinity" : c;

          return c;
        }
      });
    }

    function mo(a) {
      return JSON.parse(a, function (b, c) {
        if ("NaN" == c) var d = NaN;else if ("-Infinity" == c) d = -Infinity;else if ("Infinity" == c) d = Infinity;else if (c && "object" == typeof c && "TimeRanges" == c.__type__) d = no(c);else if (c && "object" == typeof c && "Uint8Array" == c.__type__) d = new Uint8Array(c.entries);else if (c && "object" == typeof c && "Error" == c.__type__) {
          b = c.contents;
          c = Error(b.message);

          for (d in b) c[d] = b[d];

          d = c;
        } else d = c;
        return d;
      });
    }

    function no(a) {
      return {
        length: a.length,
        start: function (b) {
          return a.start[b];
        },
        end: function (b) {
          return a.end[b];
        }
      };
    }

    var oo = "ended play playing pause pausing ratechange seeked seeking timeupdate volumechange".split(" "),
        po = "buffered currentTime duration ended loop muted paused playbackRate seeking videoHeight videoWidth volume".split(" "),
        qo = ["loop", "playbackRate"],
        ro = ["pause", "play"],
        so = {
      getAssetUri: 2,
      getAudioLanguages: 4,
      getAudioLanguagesAndRoles: 4,
      getBufferFullness: 1,
      getBufferedInfo: 2,
      getExpiration: 2,
      getKeyStatuses: 2,
      getPlaybackRate: 2,
      getTextLanguages: 4,
      getTextLanguagesAndRoles: 4,
      getImageTracks: 2,
      getThumbnails: 2,
      isAudioOnly: 10,
      isBuffering: 1,
      isInProgress: 1,
      isLive: 10,
      isTextTrackVisible: 1,
      keySystem: 10,
      seekRange: 1,
      getLoadMode: 10,
      getManifestType: 10
    },
        to = {
      getConfiguration: 4,
      getStats: 5,
      getTextTracks: 2,
      getVariantTracks: 2
    },
        uo = {
      getPlayheadTimeAsDate: 1,
      getPresentationStartTimeAsDate: 20
    },
        vo = [["getConfiguration", "configure"]],
        wo = [["isTextTrackVisible", "setTextTrackVisibility"]],
        xo = "addChaptersTrack addTextTrackAsync addThumbnailsTrack cancelTrickPlay configure getChapters getChaptersTracks resetConfiguration retryStreaming selectAudioLanguage selectTextLanguage selectTextTrack selectVariantTrack selectVariantsByLabel setTextTrackVisibility trickPlay updateStartTime goToLive".split(" "),
        yo = ["attach", "attachCanvas", "detach", "load", "unload"];

    function zo(a, b, c, d, e, f, g) {
      var h = this;
      this.I = a;
      this.M = g;
      this.j = new Fd(b);
      this.N = c;
      this.C = !1;
      this.u = d;
      this.H = e;
      this.K = f;
      this.h = this.m = !1;
      this.L = "";
      this.s = null;

      this.D = function () {
        return Ao(h);
      };

      this.G = function (k, l) {
        k = mo(l);

        switch (k.type) {
          case "event":
            var m = k.targetName,
                n = Pa(k.event);
            h.u(m, n);
            break;

          case "update":
            m = k.update;

            for (n in m) {
              k = h.g[n] || {};

              for (var r in m[n]) k[r] = m[n][r];
            }

            h.C && (h.N(), h.C = !1);
            break;

          case "asyncComplete":
            if (n = k.id, r = k.error, k = h.i[n], delete h.i[n], k) if (r) {
              n = new P(r.severity, r.category, r.code);

              for (m in r) n[m] = r[m];

              k.reject(n);
            } else k.resolve();
        }
      };

      this.g = {
        video: {},
        player: {}
      };
      this.J = 0;
      this.i = {};
      this.l = null;
      Bo.add(this);
    }

    p = zo.prototype;

    p.destroy = function () {
      Bo.delete(this);
      Co(this);
      Do && Eo(this);
      this.j && (this.j.stop(), this.j = null);
      this.H = this.u = null;
      this.h = this.m = !1;
      this.G = this.D = this.l = this.i = this.g = this.s = null;
      return Promise.resolve();
    };

    p.Fa = function () {
      return this.h;
    };

    p.Be = function () {
      return this.L;
    };

    p.init = function () {
      if (this.I.length) if (window.chrome && chrome.cast && chrome.cast.isAvailable) {
        this.m = !0;
        this.j.Ma();
        var a = new chrome.cast.SessionRequest(this.I, [], null, this.M, null);
        a = new chrome.cast.ApiConfig(a, function (b) {
          for (var c = t(Bo), d = c.next(); !d.done; d = c.next()) Fo(d.value, b);
        }, function (b) {
          for (var c = t(Bo), d = c.next(); !d.done; d = c.next()) d = d.value, Go = "available" == b, d.j.Ma();
        }, "origin_scoped");
        chrome.cast.initialize(a, function () {}, function () {});
        Go && this.j.R(Ho);
        (a = Do) && a.status != chrome.cast.SessionStatus.STOPPED ? Fo(this, a) : Do = null;
      } else window.__onGCastApiAvailable !== Io && (Jo = window.__onGCastApiAvailable || null, window.__onGCastApiAvailable = Io);
    };

    p.fg = function (a) {
      this.s = a;
      this.h && Ko(this, {
        type: "appData",
        appData: this.s
      });
    };

    p.cast = function (a) {
      var b = this;
      return K(function (c) {
        if (!b.m) throw new P(1, 8, 8E3);
        if (!Go) throw new P(1, 8, 8001);
        if (b.h) throw new P(1, 8, 8002);
        b.l = new lf();
        chrome.cast.requestSession(function (d) {
          return Lo(b, a, d);
        }, function (d) {
          return Mo(b, d);
        });
        return D(c, b.l, 0);
      });
    };

    function No(a) {
      if (a.h) {
        var b = a.K();
        chrome.cast.requestSession(function (c) {
          return Lo(a, b, c);
        }, function (c) {
          return Mo(a, c);
        });
      }
    }

    p.Fc = function () {
      if (this.h) {
        Co(this);

        if (Do) {
          Eo(this);

          try {
            Do.stop(function () {}, function () {});
          } catch (a) {}

          Do = null;
        }

        Ao(this);
      }
    };

    p.get = function (a, b) {
      var c = this;

      if ("video" == a) {
        if (ro.includes(b)) return function () {
          return c.bh.apply(c, [a, b].concat(w(Ga.apply(0, arguments))));
        };
      } else if ("player" == a) {
        if (uo[b] && !this.get("player", "isLive")()) return function () {};
        if (xo.includes(b)) return function () {
          return c.bh.apply(c, [a, b].concat(w(Ga.apply(0, arguments))));
        };
        if (yo.includes(b)) return function () {
          return c.Vi.apply(c, [a, b].concat(w(Ga.apply(0, arguments))));
        };
        if (so[b] || to[b]) return function () {
          return c.g[a][b];
        };
      }

      return this.g[a][b];
    };

    p.set = function (a, b, c) {
      this.g[a][b] = c;
      Ko(this, {
        type: "set",
        targetName: a,
        property: b,
        value: c
      });
    };

    function Lo(a, b, c) {
      Do = c;
      c.addUpdateListener(a.D);
      c.addMessageListener("urn:x-cast:com.google.shaka.v2", a.G);
      Ao(a);
      Ko(a, {
        type: "init",
        initState: b,
        appData: a.s
      });
      a.l.resolve();
    }

    function Mo(a, b) {
      var c = 8003;

      switch (b.code) {
        case "cancel":
          c = 8004;
          break;

        case "timeout":
          c = 8005;
          break;

        case "receiver_unavailable":
          c = 8006;
      }

      a.l.reject(new P(2, 8, c, b));
    }

    p.bh = function (a, b) {
      Ko(this, {
        type: "call",
        targetName: a,
        methodName: b,
        args: Ga.apply(2, arguments)
      });
    };

    p.Vi = function (a, b) {
      var c = Ga.apply(2, arguments),
          d = new lf(),
          e = this.J.toString();
      this.J++;
      this.i[e] = d;

      try {
        Ko(this, {
          type: "asyncCall",
          targetName: a,
          methodName: b,
          args: c,
          id: e
        });
      } catch (f) {
        d.reject(f);
      }

      return d;
    };

    function Fo(a, b) {
      var c = a.K();
      a.l = new lf();
      a.C = !0;
      Lo(a, c, b);
    }

    function Eo(a) {
      var b = Do;
      b.removeUpdateListener(a.D);
      b.removeMessageListener("urn:x-cast:com.google.shaka.v2", a.G);
    }

    function Ao(a) {
      var b = Do ? "connected" == Do.status : !1;

      if (a.h && !b) {
        a.H();

        for (var c in a.g) a.g[c] = {};

        Co(a);
      }

      a.h = b;
      a.L = b ? Do.receiver.friendlyName : "";
      a.j.Ma();
    }

    function Co(a) {
      for (var b in a.i) {
        var c = a.i[b];
        delete a.i[b];
        c.reject(new P(1, 7, 7E3));
      }
    }

    function Ko(a, b) {
      b = lo(b);
      var c = Do;

      try {
        c.sendMessage("urn:x-cast:com.google.shaka.v2", b, function () {}, Ya);
      } catch (d) {
        throw b = new P(2, 8, 8005, d), c = new N("error", new Map().set("detail", b)), a.u("player", c), a.Fc(), b;
      }
    }

    var Ho = .02,
        Go = !1,
        Do = null,
        Jo = null,
        Bo = new Set();

    function Io(a) {
      Jo ? window.__onGCastApiAvailable = Jo : delete window.__onGCastApiAvailable;
      Jo = null;
      if (a) for (var b = t(Bo), c = b.next(); !c.done; c = b.next()) c.value.init();
      "function" === typeof window.__onGCastApiAvailable && window.__onGCastApiAvailable(a);
    }

    ;

    function Oo(a, b, c, d) {
      d = void 0 === d ? !1 : d;
      db.call(this);
      var e = this;
      this.i = a;
      this.h = b;
      this.m = this.s = this.j = this.u = this.l = null;
      this.G = c;
      this.D = d;
      this.C = new Map();
      this.g = new zo(c, function () {
        return Po(e);
      }, function () {
        return Qo(e);
      }, function (f, g) {
        return Ro(e, f, g);
      }, function () {
        return So(e);
      }, function () {
        return To(e);
      }, d);
      Uo(this);
    }

    pa(Oo, db);
    p = Oo.prototype;

    p.destroy = function (a) {
      a && this.g.Fc();
      this.m && (this.m.release(), this.m = null);
      a = [];
      this.h && (a.push(this.h.destroy()), this.h = null);
      this.g && (a.push(this.g.destroy()), this.g = null);
      this.u = this.l = this.i = null;
      db.prototype.release.call(this);
      return Promise.all(a);
    };

    p.Yb = function () {
      return this.l;
    };

    p.Hc = function () {
      return this.u;
    };

    p.Ze = function () {
      return this.g.m && Go;
    };

    p.Fa = function () {
      return this.g.Fa();
    };

    p.Be = function () {
      return this.g.Be();
    };

    p.cast = function () {
      var a = this,
          b;
      return K(function (c) {
        return 1 == c.g ? (b = To(a), D(c, a.g.cast(b), 2)) : a.h ? D(c, a.h.Tc(), 0) : c.return();
      });
    };

    p.fg = function (a) {
      this.g.fg(a);
    };

    p.oh = function () {
      No(this.g);
    };

    p.Fc = function () {
      this.g.Fc();
    };

    p.Cg = function (a, b) {
      b = void 0 === b ? !1 : b;
      var c = this;
      return K(function (d) {
        if (1 == d.g) {
          if (a == c.G && b == c.D) return d.return();
          c.G = a;
          c.D = b;
          c.g.Fc();
          return D(d, c.g.destroy(), 2);
        }

        c.g = null;
        c.g = new zo(a, function () {
          return Po(c);
        }, function () {
          return Qo(c);
        }, function (e, f) {
          return Ro(c, e, f);
        }, function () {
          return So(c);
        }, function () {
          return To(c);
        }, b);
        c.g.init();
        F(d);
      });
    };

    function Uo(a) {
      a.g.init();
      a.m = new Jf();

      for (var b = t(oo), c = b.next(); !c.done; c = b.next()) a.m.o(a.i, c.value, function (f) {
        a.g.Fa() || (f = Pa(f), a.j.dispatchEvent(f));
      });

      for (var d in Ra) a.m.o(a.h, Ra[d], function (f) {
        a.g.Fa() || a.s.dispatchEvent(f);
      });

      a.l = {};
      b = {};

      for (var e in a.i) b.Yc = e, Object.defineProperty(a.l, b.Yc, {
        configurable: !1,
        enumerable: !0,
        get: function (f) {
          return function () {
            return Vo(a, f.Yc);
          };
        }(b),
        set: function (f) {
          return function (g) {
            var h = f.Yc;
            a.g.Fa() ? a.g.set("video", h, g) : a.i[h] = g;
          };
        }(b)
      }), b = {
        Yc: b.Yc
      };

      a.u = {};
      Wo(a, function (f) {
        Object.defineProperty(a.u, f, {
          configurable: !1,
          enumerable: !0,
          get: function () {
            return Xo(a, f);
          }
        });
      });
      Yo(a);
      a.j = new db();
      a.j.me = a.l;
      a.s = new db();
      a.s.me = a.u;
    }

    function Yo(a) {
      var b = new Map();
      Wo(a, function (c, d) {
        b.has(d) ? (d = b.get(d), c.length < d.length ? a.C.set(c, d) : a.C.set(d, c)) : b.set(d, c);
      });
    }

    function Wo(a, b) {
      function c(k) {
        return "constructor" == k || "function" != typeof d[k] ? !1 : !e.has(k);
      }

      var d = a.h,
          e = new Set(),
          f;

      for (f in d) c(f) && (e.add(f), b(f, d[f]));

      a = Object.getPrototypeOf(d);

      for (f = Object.getPrototypeOf({}); a && a != f;) {
        for (var g = t(Object.getOwnPropertyNames(a)), h = g.next(); !h.done; h = g.next()) h = h.value, c(h) && (e.add(h), b(h, d[h]));

        a = Object.getPrototypeOf(a);
      }
    }

    function To(a) {
      var b = {
        video: {},
        player: {},
        playerAfterLoad: {},
        manifest: a.h.yf(),
        startTime: null
      };
      a.i.pause();

      for (var c = t(qo), d = c.next(); !d.done; d = c.next()) d = d.value, b.video[d] = a.i[d];

      a.i.ended || (b.startTime = a.i.currentTime);
      c = t(vo);

      for (d = c.next(); !d.done; d = c.next()) {
        var e = d.value;
        d = e[1];
        e = a.h[e[0]]();
        b.player[d] = e;
      }

      c = t(wo);

      for (d = c.next(); !d.done; d = c.next()) e = d.value, d = e[1], e = a.h[e[0]](), b.playerAfterLoad[d] = e;

      return b;
    }

    function Po(a) {
      var b = new N("caststatuschanged");
      a.dispatchEvent(b);
    }

    function Qo(a) {
      var b = new N(a.l.paused ? "pause" : "play");
      a.j.dispatchEvent(b);
    }

    function So(a) {
      for (var b = t(vo), c = b.next(); !c.done; c = b.next()) {
        var d = c.value;
        c = d[1];
        d = a.g.get("player", d[0])();
        a.h[c](d);
      }

      var e = a.g.get("player", "getAssetUri")();
      c = a.g.get("video", "ended");
      b = Promise.resolve();
      var f = a.i.autoplay;
      d = null;
      c || (d = a.g.get("video", "currentTime"));
      e && (a.i.autoplay = !1, b = a.h.load(e, d));
      var g = {};
      c = t(qo);

      for (d = c.next(); !d.done; d = c.next()) d = d.value, g[d] = a.g.get("video", d);

      b.then(function () {
        if (a.i) {
          for (var h = t(qo), k = h.next(); !k.done; k = h.next()) k = k.value, a.i[k] = g[k];

          h = t(wo);

          for (k = h.next(); !k.done; k = h.next()) {
            var l = k.value;
            k = l[1];
            l = a.g.get("player", l[0])();
            a.h[k](l);
          }

          a.i.autoplay = f;
          e && a.i.play();
        }
      }, function (h) {
        h = new Map().set("detail", h);
        h = new N("error", h);
        a.h.dispatchEvent(h);
      });
    }

    function Vo(a, b) {
      if ("addEventListener" == b) return function (d, e, f) {
        return a.j.addEventListener(d, e, f);
      };
      if ("removeEventListener" == b) return function (d, e, f) {
        return a.j.removeEventListener(d, e, f);
      };

      if (a.g.Fa() && 0 == Object.keys(a.g.g.video).length) {
        var c = a.i[b];
        if ("function" != typeof c) return c;
      }

      return a.g.Fa() ? a.g.get("video", b) : (b = a.i[b], "function" == typeof b && (b = b.bind(a.i)), b);
    }

    function Xo(a, b) {
      a.C.has(b) && (b = a.C.get(b));
      if ("addEventListener" == b) return function (c, d, e) {
        return a.s.addEventListener(c, d, e);
      };
      if ("removeEventListener" == b) return function (c, d, e) {
        return a.s.removeEventListener(c, d, e);
      };
      if ("getMediaElement" == b) return function () {
        return a.l;
      };
      if ("getSharedConfiguration" == b) return a.g.get("player", "getConfiguration");
      if ("getNetworkingEngine" == b) return function () {
        return a.h.Tb();
      };
      if ("getDrmEngine" == b) return function () {
        return a.h.s;
      };
      if ("getAdManager" == b) return function () {
        return a.h.ae();
      };
      if ("setVideoContainer" == b) return function (c) {
        return a.h.mg(c);
      };

      if (a.g.Fa()) {
        if ("getManifest" == b || "drmInfo" == b) return function () {
          Ua(b + "() does not work while casting!");
          return null;
        };
        if ("attach" == b || "detach" == b) return function () {
          Ua(b + "() does not work while casting!");
          return Promise.resolve();
        };
      }

      return a.g.Fa() && 0 == Object.keys(a.g.g.video).length && (so[b] || to[b]) || !a.g.Fa() ? a.h[b].bind(a.h) : a.g.get("player", b);
    }

    function Ro(a, b, c) {
      a.g.Fa() && ("video" == b ? a.j.dispatchEvent(c) : "player" == b && a.s.dispatchEvent(c));
    }

    M("shaka.cast.CastProxy", Oo);
    Oo.prototype.changeReceiverId = Oo.prototype.Cg;
    Oo.prototype.forceDisconnect = Oo.prototype.Fc;
    Oo.prototype.suggestDisconnect = Oo.prototype.oh;
    Oo.prototype.setAppData = Oo.prototype.fg;
    Oo.prototype.cast = Oo.prototype.cast;
    Oo.prototype.receiverName = Oo.prototype.Be;
    Oo.prototype.isCasting = Oo.prototype.Fa;
    Oo.prototype.canCast = Oo.prototype.Ze;
    Oo.prototype.getPlayer = Oo.prototype.Hc;
    Oo.prototype.getVideo = Oo.prototype.Yb;
    Oo.prototype.destroy = Oo.prototype.destroy;

    function Zo(a, b, c, d) {
      db.call(this);
      var e = this;
      this.g = a;
      this.h = b;
      this.j = new Jf();
      this.J = {
        video: a,
        player: b
      };

      this.G = c || function () {};

      this.K = d || function (f) {
        return f;
      };

      this.i = null;
      this.H = !1;
      this.s = !0;
      this.m = 0;
      this.D = !1;
      this.C = !0;
      this.u = this.l = null;
      this.I = new Fd(function () {
        $o(e);
      });
      ap(this);
    }

    pa(Zo, db);
    p = Zo.prototype;

    p.isConnected = function () {
      return this.H;
    };

    p.Ai = function () {
      return this.s;
    };

    p.fj = function (a) {
      this.i = a;
    };

    p.Fh = function () {
      this.i = null;
    };

    p.gj = function (a) {
      this.i || (this.i = {
        metadataType: cast.receiver.media.MetadataType.GENERIC
      });
      this.i.title = a;
    };

    p.ej = function (a) {
      this.i || (this.i = {
        metadataType: cast.receiver.media.MetadataType.GENERIC
      });
      this.i.images = [{
        url: a
      }];
    };

    p.dj = function (a) {
      this.i || (this.i = {});
      this.i.artist = a;
      this.i.metadataType = cast.receiver.media.MetadataType.MUSIC_TRACK;
    };

    p.destroy = function () {
      var a = this,
          b,
          c;
      return K(function (d) {
        if (1 == d.g) return a.j && (a.j.release(), a.j = null), b = [], a.h && (b.push(a.h.destroy()), a.h = null), a.I && (a.I.stop(), a.I = null), a.g = null, a.J = null, a.G = null, a.H = !1, a.s = !0, a.l = null, a.u = null, db.prototype.release.call(a), D(d, Promise.all(b), 2);
        c = cast.receiver.CastReceiverManager.getInstance();
        c.stop();
        F(d);
      });
    };

    function ap(a) {
      var b = cast.receiver.CastReceiverManager.getInstance();

      b.onSenderConnected = function () {
        return bp(a);
      };

      b.onSenderDisconnected = function () {
        return bp(a);
      };

      b.onSystemVolumeChanged = function () {
        var e = cast.receiver.CastReceiverManager.getInstance().getSystemVolume();
        e && cp(a, {
          type: "update",
          update: {
            video: {
              volume: e.level,
              muted: e.muted
            }
          }
        }, a.l);
        cp(a, {
          type: "event",
          targetName: "video",
          event: {
            type: "volumechange"
          }
        }, a.l);
      };

      a.u = b.getCastMessageBus("urn:x-cast:com.google.cast.media");

      a.u.onMessage = function (e) {
        return dp(a, e);
      };

      a.l = b.getCastMessageBus("urn:x-cast:com.google.shaka.v2");

      a.l.onMessage = function (e) {
        return ep(a, e);
      };

      b.start();
      b = t(oo);

      for (var c = b.next(); !c.done; c = b.next()) a.j.o(a.g, c.value, function (e) {
        return fp(a, "video", e);
      });

      for (var d in Ra) a.j.o(a.h, Ra[d], function (e) {
        return fp(a, "player", e);
      });

      cast.__platform__ && cast.__platform__.canDisplayType('video/mp4; codecs="avc1.640028"; width=3840; height=2160') ? a.h.ig(3840, 2160) : a.h.ig(1920, 1080);
      a.j.o(a.g, "loadeddata", function () {
        a.D = !0;
      });
      a.j.o(a.h, "loading", function () {
        a.s = !1;
        gp(a);
      });
      a.j.o(a.g, "playing", function () {
        a.s = !1;
        gp(a);
      });
      a.j.o(a.g, "pause", function () {
        gp(a);
      });
      a.j.o(a.h, "unloading", function () {
        a.s = !0;
        gp(a);
      });
      a.j.o(a.g, "ended", function () {
        new Fd(function () {
          a.g && a.g.ended && (a.s = !0, gp(a));
        }).R(hp);
      });
    }

    function bp(a) {
      a.m = 0;
      a.C = !0;
      a.H = 0 != cast.receiver.CastReceiverManager.getInstance().getSenders().length;
      gp(a);
    }

    function gp(a) {
      var b;
      K(function (c) {
        if (1 == c.g) return D(c, Promise.resolve(), 2);
        if (!a.h) return c.return();
        b = new N("caststatuschanged");
        a.dispatchEvent(b);
        ip(a) || jp(a);
        F(c);
      });
    }

    function kp(a, b, c) {
      var d, e, f, g, h, k, l, m, n, r;
      K(function (q) {
        switch (q.g) {
          case 1:
            for (d in b.player) e = b.player[d], a.h[d](e);

            a.G(c);
            f = a.g.autoplay;
            return b.manifest ? (a.g.autoplay = !1, ta(q, 5), D(q, a.h.load(b.manifest, b.startTime), 7)) : D(q, Promise.resolve(), 3);

          case 7:
            va(q, 3);
            break;

          case 5:
            return g = wa(q), h = new Map().set("detail", g), k = new N("error", h), a.h && a.h.dispatchEvent(k), q.return();

          case 3:
            if (!a.h) return q.return();

            for (l in b.video) m = b.video[l], a.g[l] = m;

            for (n in b.playerAfterLoad) r = b.playerAfterLoad[n], a.h[n](r);

            a.g.autoplay = f;
            b.manifest && (a.g.play(), jp(a));
            F(q);
        }
      });
    }

    function fp(a, b, c) {
      a.h && ($o(a), cp(a, {
        type: "event",
        targetName: b,
        event: c
      }, a.l));
    }

    function $o(a) {
      a.I.R(lp);

      for (var b = {
        video: {},
        player: {}
      }, c = t(po), d = c.next(); !d.done; d = c.next()) d = d.value, b.video[d] = a.g[d];

      if (a.h.S()) for (var e in uo) 0 == a.m % uo[e] && (b.player[e] = a.h[e]());

      for (var f in so) 0 == a.m % so[f] && (b.player[f] = a.h[f]());

      if (c = cast.receiver.CastReceiverManager.getInstance().getSystemVolume()) b.video.volume = c.level, b.video.muted = c.muted;
      cp(a, {
        type: "update",
        update: b
      }, a.l);

      for (var g in to) 0 == a.m % to[g] && (b = {
        player: {}
      }, b.player[g] = a.h[g](), cp(a, {
        type: "update",
        update: b
      }, a.l));

      a.D && (a.m += 1);
      ip(a);
    }

    function ip(a) {
      return a.C && (a.g.duration || a.h.S()) ? (mp(a), a.C = !1, !0) : !1;
    }

    function mp(a, b) {
      var c = {
        contentId: a.h.yf(),
        streamType: a.h.S() ? "LIVE" : "BUFFERED",
        contentType: ""
      };
      a.h.S() || (c.duration = a.g.duration);
      a.i && (c.metadata = a.i);
      jp(a, void 0 === b ? 0 : b, c);
    }

    function ep(a, b) {
      var c = mo(b.data);

      switch (c.type) {
        case "init":
          a.m = 0;
          a.D = !1;
          a.C = !0;
          kp(a, c.initState, c.appData);
          $o(a);
          break;

        case "appData":
          a.G(c.appData);
          break;

        case "set":
          var d = c.targetName,
              e = c.property;
          c = c.value;
          if ("video" == d) if (b = cast.receiver.CastReceiverManager.getInstance(), "volume" == e) {
            b.setSystemVolumeLevel(c);
            break;
          } else if ("muted" == e) {
            b.setSystemVolumeMuted(c);
            break;
          }
          a.J[d][e] = c;
          break;

        case "call":
          d = a.J[c.targetName];
          d[c.methodName].apply(d, c.args);
          break;

        case "asyncCall":
          d = c.targetName;
          e = c.methodName;
          "player" == d && "load" == e && (a.m = 0, a.D = !1);
          var f = c.id,
              g = b.senderId;
          b = a.J[d];
          c = b[e].apply(b, c.args);
          "player" == d && "load" == e && (c = c.then(function () {
            a.C = !0;
          }));
          c.then(function () {
            return np(a, g, f, null);
          }, function (h) {
            return np(a, g, f, h);
          });
      }
    }

    function dp(a, b) {
      var c = mo(b.data);

      switch (c.type) {
        case "PLAY":
          a.g.play();
          jp(a);
          break;

        case "PAUSE":
          a.g.pause();
          jp(a);
          break;

        case "SEEK":
          b = c.currentTime;
          var d = c.resumeState;
          null != b && (a.g.currentTime = Number(b));
          d && "PLAYBACK_START" == d ? (a.g.play(), jp(a)) : d && "PLAYBACK_PAUSE" == d && (a.g.pause(), jp(a));
          break;

        case "STOP":
          a.h.Tc().then(function () {
            a.h && jp(a);
          });
          break;

        case "GET_STATUS":
          mp(a, Number(c.requestId));
          break;

        case "VOLUME":
          d = c.volume;
          b = d.level;
          d = d.muted;
          var e = a.g.volume,
              f = a.g.muted;
          null != b && (a.g.volume = Number(b));
          null != d && (a.g.muted = d);
          e == a.g.volume && f == a.g.muted || jp(a);
          break;

        case "LOAD":
          a.m = 0;
          a.D = !1;
          a.C = !1;
          b = c.media;
          d = c.currentTime;
          e = a.K(b.contentId);
          f = c.autoplay || !0;
          a.G(b.customData);
          f && (a.g.autoplay = !0);
          a.h.load(e, d).then(function () {
            a.h && mp(a);
          }).catch(function (g) {
            var h = "LOAD_FAILED";
            7 == g.category && 7E3 == g.code && (h = "LOAD_CANCELLED");
            cp(a, {
              requestId: Number(c.requestId),
              type: h
            }, a.u);
          });
          break;

        default:
          cp(a, {
            requestId: Number(c.requestId),
            type: "INVALID_REQUEST",
            reason: "INVALID_COMMAND"
          }, a.u);
      }
    }

    function np(a, b, c, d) {
      a.h && cp(a, {
        type: "asyncComplete",
        id: c,
        error: d
      }, a.l, b);
    }

    function cp(a, b, c, d) {
      a.H && (a = lo(b), d ? c.getCastChannel(d).send(a) : c.broadcast(a));
    }

    function jp(a, b, c) {
      c = void 0 === c ? null : c;
      var d = {
        mediaSessionId: 0,
        playbackRate: a.g.playbackRate,
        playerState: a.s ? op : a.h.wd() ? pp : a.g.paused ? qp : rp,
        currentTime: a.g.currentTime,
        supportedMediaCommands: 63,
        volume: {
          level: a.g.volume,
          muted: a.g.muted
        }
      };
      c && (d.media = c);
      cp(a, {
        requestId: void 0 === b ? 0 : b,
        type: "MEDIA_STATUS",
        status: [d]
      }, a.u);
    }

    M("shaka.cast.CastReceiver", Zo);
    Zo.prototype.destroy = Zo.prototype.destroy;
    Zo.prototype.setContentArtist = Zo.prototype.dj;
    Zo.prototype.setContentImage = Zo.prototype.ej;
    Zo.prototype.setContentTitle = Zo.prototype.gj;
    Zo.prototype.clearContentMetadata = Zo.prototype.Fh;
    Zo.prototype.setContentMetadata = Zo.prototype.fj;
    Zo.prototype.isIdle = Zo.prototype.Ai;
    Zo.prototype.isConnected = Zo.prototype.isConnected;
    var lp = .5,
        hp = 5,
        op = "IDLE",
        rp = "PLAYING",
        pp = "BUFFERING",
        qp = "PAUSED";

    function sp(a, b, c, d, e) {
      if (d >= e) return null;

      for (var f = -1, g = -1, h = 0; h < c.length; h++) if (c[h].some(function (A) {
        return null != A && "" != A.g.trim();
      })) {
        f = h;
        break;
      }

      for (h = c.length - 1; 0 <= h; h--) if (c[h].some(function (A) {
        return null != A && "" != A.g.trim();
      })) {
        g = h;
        break;
      }

      if (-1 === f || -1 === g) return null;

      for (var k = h = !1, l = "white", m = "black", n = tp(d, e, h, k, l, m); f <= g; f++) {
        for (var r = c[f], q = -1, u = -1, v = 0; v < r.length; v++) if (null != r[v] && "" !== r[v].g.trim()) {
          q = v;
          break;
        }

        for (v = r.length - 1; 0 <= v; v--) if (null != r[v] && "" !== r[v].g.trim()) {
          u = v;
          break;
        }

        if (-1 === q || -1 === u) r = up(d, e), a.nestedCues.push(r);else {
          for (; q <= u; q++) if (v = r[q]) {
            var y = v.l,
                z = v.i,
                x = v.j,
                B = v.h;
            if (y != h || z != k || x != l || B != m) n.payload && a.nestedCues.push(n), n = tp(d, e, y, z, x, B), h = y, k = z, l = x, m = B;
            n.payload += v.g;
          } else n.payload += " ";

          n.payload && a.nestedCues.push(n);
          f !== g && (n = up(d, e), a.nestedCues.push(n));
          n = tp(d, e, h, k, l, m);
        }
      }

      return a.nestedCues.length ? {
        cue: a,
        stream: b
      } : null;
    }

    function tp(a, b, c, d, e, f) {
      a = new Ac(a, b, "");
      c && a.textDecoration.push("underline");
      d && (a.fontStyle = "italic");
      a.color = e;
      a.backgroundColor = f;
      return a;
    }

    function up(a, b) {
      a = new Ac(a, b, "");
      a.lineBreak = !0;
      return a;
    }

    function vp(a, b, c, d, e) {
      this.g = a;
      this.l = b;
      this.i = c;
      this.h = d;
      this.j = e;
    }

    ;

    function wp(a, b) {
      this.i = [];
      this.g = 1;
      this.h = 0;
      this.C = a;
      this.u = b;
      this.j = this.m = !1;
      this.l = "white";
      this.s = "black";
      xp(this);
    }

    function yp(a, b, c) {
      var d = "CC" + (a.C << 1 | a.u + 1),
          e = new Ac(b, c, "");
      e.lineInterpretation = 1;
      var f = zp.get(a.g);
      f && (e.line = f);
      return sp(e, d, a.i, b, c);
    }

    function xp(a) {
      Ap(a, 0, 15);
      a.g = 1;
    }

    function Bp(a, b, c) {
      if (!(32 > c || 127 < c)) {
        var d = "";

        switch (b) {
          case Cp:
            d = Dp.has(c) ? Dp.get(c) : String.fromCharCode(c);
            break;

          case Ep:
            d = Fp.get(c);
            break;

          case Gp:
            a.i[a.g].pop();
            d = Hp.get(c);
            break;

          case Ip:
            a.i[a.g].pop(), d = Jp.get(c);
        }

        d && a.i[a.g].push(new vp(d, a.m, a.j, a.s, a.l));
      }
    }

    function Kp(a, b, c, d) {
      if (!(0 > c || 0 > b)) if (b >= c) for (--d; 0 <= d; d--) a.i[b + d] = a.i[c + d].map(function (f) {
        return f;
      });else for (var e = 0; e < d; e++) a.i[b + e] = a.i[c + e].map(function (f) {
        return f;
      });
    }

    function Ap(a, b, c) {
      for (var d = 0; d <= c; d++) a.i[b + d] = [];
    }

    var Cp = 0,
        Ep = 1,
        Gp = 2,
        Ip = 3,
        Dp = new Map([[39, "\u2019"], [42, "\u00e1"], [92, "\u00e9"], [92, "\u00e9"], [94, "\u00ed"], [95, "\u00f3"], [96, "\u00fa"], [123, "\u00e7"], [124, "\u00f7"], [125, "\u00d1"], [126, "\u00f1"], [127, "\u2588"]]),
        Fp = new Map([[48, "\u00ae"], [49, "\u00b0"], [50, "\u00bd"], [51, "\u00bf"], [52, "\u2122"], [53, "\u00a2"], [54, "\u00a3"], [55, "\u266a"], [56, "\u00e0"], [57, "\u2800"], [58, "\u00e8"], [59, "\u00e2"], [60, "\u00ea"], [61, "\u00ee"], [62, "\u00f4"], [63, "\u00fb"]]),
        Hp = new Map([[32, "\u00c1"], [33, "\u00c9"], [34, "\u00d3"], [35, "\u00da"], [36, "\u00dc"], [37, "\u00fc"], [38, "\u2018"], [39, "\u00a1"], [40, "*"], [41, "'"], [42, "\u2500"], [43, "\u00a9"], [44, "\u2120"], [45, "\u00b7"], [46, "\u201c"], [47, "\u201d"], [48, "\u00c0"], [49, "\u00c2"], [50, "\u00c7"], [51, "\u00c8"], [52, "\u00ca"], [53, "\u00cb"], [54, "\u00eb"], [55, "\u00ce"], [56, "\u00cf"], [57, "\u00ef"], [58, "\u00d4"], [59, "\u00d9"], [60, "\u00f9"], [61, "\u00db"], [62, "\u00ab"], [63, "\u00bb"]]),
        Jp = new Map([[32, "\u00c3"], [33, "\u00e3"], [34, "\u00cd"], [35, "\u00cc"], [36, "\u00ec"], [37, "\u00d2"], [38, "\u00f2"], [39, "\u00d5"], [40, "\u00f5"], [41, "{"], [42, "}"], [43, "\\"], [44, "^"], [45, "_"], [46, "|"], [47, "~"], [48, "\u00c4"], [49, "\u00e4"], [50, "\u00d6"], [51, "\u00f6"], [52, "\u00df"], [53, "\u00a5"], [54, "\u00a4"], [55, "\u2502"], [56, "\u00c5"], [57, "\u00e5"], [58, "\u00d8"], [59, "\u00f8"], [60, "\u250c"], [61, "\u2510"], [62, "\u2514"], [63, "\u2518"]]),
        zp = new Map([[1, 10], [2, 15.33], [3, 20.66], [4, 26], [5, 31.33], [6, 36.66], [7, 42], [8, 47.33], [9, 52.66], [10, 58], [11, 63.33], [12, 68.66], [13, 74], [14, 79.33], [15, 84.66]]);

    function Lp(a, b) {
      this.h = Mp;
      this.s = new wp(a, b);
      this.i = new wp(a, b);
      this.g = this.j = new wp(a, b);
      this.l = 0;
      this.m = null;
    }

    function Np(a, b, c) {
      a.g = a.i;
      var d = a.g,
          e = null;
      a.h !== Op && a.h !== Pp && (e = yp(d, a.l, c), c = a.i, c.g = 0 < c.h ? c.h : 0, Ap(c, 0, 15), c = a.j, c.g = 0 < c.h ? c.h : 0, Ap(c, 0, 15), d.g = 15);
      a.h = Op;
      d.h = b;
      return e;
    }

    function Qp(a) {
      a.h = Rp;
      a.g = a.j;
      a.g.h = 0;
    }

    function Sp(a) {
      Va("Cea608DataChannel", "CEA-608 text mode entered, but is unsupported");
      a.g = a.s;
      a.h = Pp;
    }

    var Mp = 0,
        Rp = 1,
        Op = 3,
        Pp = 4,
        Tp = "black green blue cyan red yellow magenta black".split(" "),
        Up = "white green blue cyan red yellow magenta white_italics".split(" ");

    function Vp(a, b) {
      this.K = b;
      this.N = a;
      this.L = this.l = !1;
      this.m = this.s = this.I = this.M = this.J = 0;
      this.H = Wp;
      this.i = [];
      this.g = this.h = this.j = 0;
      this.G = this.C = !1;
      this.D = "white";
      this.u = "black";
      Xp(this);
    }

    function Xp(a) {
      a.i = [];

      for (var b = 0; 16 > b; b++) a.i.push(Yp());
    }

    function Yp() {
      for (var a = [], b = 0; 42 > b; b++) a.push(null);

      return a;
    }

    function Zp(a, b) {
      $p(a) && (a.i[a.h][a.g] = new vp(b, a.G, a.C, a.u, a.D), a.g++);
    }

    function $p(a) {
      var b = a.g < a.m && 0 <= a.g;
      return a.h < a.s && 0 <= a.h && b;
    }

    Vp.prototype.isVisible = function () {
      return this.l;
    };

    function aq(a, b, c) {
      var d = new Ac(a.j, b, "");
      d.textAlign = a.H === bq ? "left" : a.H === cq ? "right" : Ec;
      var e = d.region;
      a.K && (e.id += "svc" + a.K);
      e.id += "win" + a.N;
      e.height = a.s;
      e.width = a.m;
      e.heightUnits = 2;
      e.widthUnits = 2;
      e.viewportAnchorX = a.J;
      e.viewportAnchorY = a.M;
      e.viewportAnchorUnits = a.L ? Vc : 2;

      switch (a.I) {
        case dq:
          e.regionAnchorX = 0;
          e.regionAnchorY = 0;
          break;

        case eq:
          e.regionAnchorX = 50;
          e.regionAnchorY = 0;
          break;

        case fq:
          e.regionAnchorX = 100;
          e.regionAnchorY = 0;
          break;

        case gq:
          e.regionAnchorX = 0;
          e.regionAnchorY = 50;
          break;

        case hq:
          e.regionAnchorX = 50;
          e.regionAnchorY = 50;
          break;

        case iq:
          e.regionAnchorX = 100;
          e.regionAnchorY = 50;
          break;

        case jq:
          e.regionAnchorX = 0;
          e.regionAnchorY = 100;
          break;

        case kq:
          e.regionAnchorX = 50;
          e.regionAnchorY = 100;
          break;

        case lq:
          e.regionAnchorX = 100, e.regionAnchorY = 100;
      }

      if (c = sp(d, "svc" + c, a.i, a.j, b)) a.j = b;
      return c;
    }

    var bq = 0,
        cq = 1,
        Wp = 2,
        dq = 0,
        eq = 1,
        fq = 2,
        gq = 3,
        hq = 4,
        iq = 5,
        jq = 6,
        kq = 7,
        lq = 8;

    function mq() {
      this.i = [];
      this.h = null;
      this.g = 0;
    }

    function nq(a, b) {
      3 === b.type ? (a.g = 2 * (b.value & 63) - 1, a.h = []) : a.h && (0 < a.g && (a.h.push(b), a.g--), 0 === a.g && (a.i.push(new oq(a.h)), a.h = null, a.g = 0));
    }

    function oq(a) {
      this.g = 0;
      this.h = a;
    }

    oq.prototype.wa = function () {
      return this.g < this.h.length;
    };

    oq.prototype.Ea = function () {
      return this.g;
    };

    function pq(a) {
      if (!a.wa()) throw new P(2, 2, 3E3);
      return a.h[a.g++];
    }

    oq.prototype.skip = function (a) {
      if (this.g + a > this.h.length) throw new P(2, 2, 3E3);
      this.g += a;
    };

    function qq(a) {
      this.i = a;
      this.h = [null, null, null, null, null, null, null, null];
      this.g = null;
    }

    function rq(a, b, c, d) {
      if (128 <= c && 135 >= c) d = c & 7, a.h[d] && (a.g = a.h[d]);else {
        if (136 === c) {
          c = pq(b).value;
          b = null;
          c = t(sq(a, c));

          for (var e = c.next(); !e.done; e = c.next()) e = a.h[e.value], e.isVisible() && (b = aq(e, d, a.i)), Xp(e);

          return b;
        }

        if (137 === c) for (b = pq(b).value, b = t(sq(a, b)), c = b.next(); !c.done; c = b.next()) c = a.h[c.value], c.isVisible() || (c.j = d), c.l = !0;else {
          if (138 === c) {
            c = pq(b).value;
            b = null;
            c = t(sq(a, c));

            for (e = c.next(); !e.done; e = c.next()) e = a.h[e.value], e.isVisible() && (b = aq(e, d, a.i)), e.l = !1;

            return b;
          }

          if (139 === c) {
            c = pq(b).value;
            b = null;
            c = t(sq(a, c));

            for (e = c.next(); !e.done; e = c.next()) e = a.h[e.value], e.isVisible() ? b = aq(e, d, a.i) : e.j = d, e.l = !e.l;

            return b;
          }

          if (140 === c) return b = pq(b).value, tq(a, b, d);
          if (143 === c) return d = tq(a, 255, d), uq(a), d;
          if (144 === c) b.skip(1), d = pq(b).value, a.g && (a.g.C = 0 < (d & 128), a.g.G = 0 < (d & 64));else if (145 === c) d = pq(b).value, c = pq(b).value, b.skip(1), a.g && (b = vq((c & 48) >> 4, (c & 12) >> 2, c & 3), a.g.D = vq((d & 48) >> 4, (d & 12) >> 2, d & 3), a.g.u = b);else if (146 === c) d = pq(b).value, b = pq(b).value, a.g && (a = a.g, a.h = d & 15, a.g = b & 63);else if (151 === c) b.skip(1), b.skip(1), d = pq(b).value, b.skip(1), a.g && (a.g.H = d & 3);else if (152 <= c && 159 >= c) {
            c = (c & 15) - 8;
            e = null !== a.h[c];

            if (!e) {
              var f = new Vp(c, a.i);
              f.j = d;
              a.h[c] = f;
            }

            d = pq(b).value;
            f = pq(b).value;
            var g = pq(b).value,
                h = pq(b).value,
                k = pq(b).value;
            b = pq(b).value;
            e && 0 === (b & 7) || (b = a.h[c], b.h = 0, b.g = 0, b.G = !1, b.C = !1, b.D = "white", b.u = "black");
            b = a.h[c];
            b.l = 0 < (d & 32);
            b.M = f & 127;
            b.J = g;
            b.I = (h & 240) >> 4;
            b.L = 0 < (f & 128);
            b.s = (h & 15) + 1;
            b.m = (k & 63) + 1;
            a.g = a.h[c];
          }
        }
      }
      return null;
    }

    function sq(a, b) {
      for (var c = [], d = 0; 8 > d; d++) 1 === (b & 1) && a.h[d] && c.push(d), b >>= 1;

      return c;
    }

    function tq(a, b, c) {
      var d = null;
      b = t(sq(a, b));

      for (var e = b.next(); !e.done; e = b.next()) {
        e = e.value;
        var f = a.h[e];
        f.isVisible() && (d = aq(f, c, a.i));
        a.h[e] = null;
      }

      return d;
    }

    function uq(a) {
      a.g = null;
      a.h = [null, null, null, null, null, null, null, null];
    }

    function vq(a, b, c) {
      var d = {
        0: 0,
        1: 0,
        2: 1,
        3: 1
      };
      a = d[a];
      b = d[b];
      c = d[c];
      return wq[a << 2 | b << 1 | c];
    }

    var xq = new Map([[32, " "], [33, "\u00a0"], [37, "\u2026"], [42, "\u0160"], [44, "\u0152"], [48, "\u2588"], [49, "\u2018"], [50, "\u2019"], [51, "\u201c"], [52, "\u201d"], [53, "\u2022"], [57, "\u2122"], [58, "\u0161"], [60, "\u0153"], [61, "\u2120"], [63, "\u0178"], [118, "\u215b"], [119, "\u215c"], [120, "\u215d"], [121, "\u215e"], [122, "\u2502"], [123, "\u2510"], [124, "\u2514"], [125, "\u2500"], [126, "\u2518"], [127, "\u250c"]]),
        wq = "black blue green cyan red magenta yellow white".split(" ");

    function yq() {
      this.h = [];
      this.g = [];
      this.i = new mq();
      this.l = 0;
      this.m = new Map([["CC1", new Lp(0, 0)], ["CC2", new Lp(0, 1)], ["CC3", new Lp(1, 0)], ["CC4", new Lp(1, 1)]]);
      this.u = this.s = 0;
      this.j = new Map();
      this.D = !0;
      this.C = new Set();
      zq(this);
    }

    yq.prototype.clear = function () {
      this.l = 0;
      this.h = [];
      this.g = [];
      var a = this.i;
      a.i = [];
      a.h = [];
      a.g = 0;
      zq(this);
      a = t(this.j.values());

      for (var b = a.next(); !b.done; b = a.next()) uq(b.value);
    };

    function zq(a) {
      a.s = 0;
      a.u = 0;

      for (var b = t(a.m.values()), c = b.next(); !c.done; c = b.next()) c = c.value, c.h = Mp, c.g = c.j, c.m = null, xp(c.i), xp(c.j), xp(c.s);

      a.D = !0;
    }

    yq.prototype.extract = function (a, b) {
      if (this.D) {
        for (var c = t(this.m.values()), d = c.next(); !d.done; d = c.next()) d.value.l = b;

        this.D = !1;
      }

      a = new Zf(a, 0);
      if (!(8 > a.getLength()) && 181 === a.qa() && 49 === a.Ra() && 1195456820 === a.O() && 3 === a.qa() && (c = a.qa(), 0 !== (c & 64))) for (c &= 31, a.skip(1), d = 0; d < c; d++) {
        var e = a.qa(),
            f = (e & 4) >> 2,
            g = a.qa(),
            h = a.qa();
        f && (e &= 3, 0 === e || 1 === e ? this.h.push({
          pts: b,
          type: e,
          fb: g,
          Db: h,
          order: this.h.length
        }) : (this.g.push({
          pts: b,
          type: e,
          value: g,
          order: this.g.length
        }), this.g.push({
          pts: b,
          type: 2,
          value: h,
          order: this.g.length
        })));
      }
    };

    yq.prototype.decode = function () {
      function a(e, f) {
        return e.pts - f.pts || e.order - f.order;
      }

      var b = [];
      this.h.sort(a);
      this.g.sort(a);

      for (var c = t(this.h), d = c.next(); !d.done; d = c.next()) (d = Aq(this, d.value)) && b.push(d);

      c = t(this.g);

      for (d = c.next(); !d.done; d = c.next()) nq(this.i, d.value);

      c = t(this.i.i);

      for (d = c.next(); !d.done; d = c.next()) d = Bq(this, d.value), b.push.apply(b, w(d));

      this.i.i = [];
      this.h = [];
      this.g = [];
      return b;
    };

    function Aq(a, b) {
      var c = b.type;

      if (16 === (b.fb & 112)) {
        var d = b.fb >> 3 & 1;
        0 === c ? a.s = d : a.u = d;
      }

      d = "CC" + (c << 1 | (c ? a.u : a.s) + 1);
      c = a.m.get(d);
      if (255 === b.fb && 255 === b.Db || !b.fb && !b.Db || !Cq(b.fb) || !Cq(b.Db)) return 45 <= ++a.l && zq(a), null;
      a.l = 0;
      b.fb &= 127;
      b.Db &= 127;
      if (!b.fb && !b.Db) return null;
      a.C.add(d);
      a = null;
      if (16 === (b.fb & 112)) a: {
        d = b.fb;
        a = b.Db;
        if (c.m === (d << 8 | a)) c.m = null;else if (c.m = d << 8 | a, 16 === (d & 240) && 64 === (a & 192)) {
          b = [11, 11, 1, 2, 3, 4, 12, 13, 14, 15, 5, 6, 7, 8, 9, 10][(d & 7) << 1 | a >> 5 & 1];
          var e = (a & 30) >> 1;
          d = "white";
          var f = !1;
          7 > e ? d = Up[e] : 7 === e && (f = !0);
          a = 1 === (a & 1);
          c.h !== Pp && (e = c.g, c.h === Op && b !== e.g && (c = 1 + b - e.h, Kp(e, c, 1 + e.g - e.h, e.h), Ap(e, 0, c - 1), Ap(e, b + 1, 15 - b)), e.g = b, e.m = a, e.j = f, e.l = d, e.s = "black");
        } else if (17 === (d & 247) && 32 === (a & 240)) c.g.m = !1, c.g.j = !1, c.g.l = "white", Bp(c.g, Cp, 32), d = !1, b = Up[(a & 14) >> 1], "white_italics" === b && (b = "white", d = !0), c.g.m = 1 === (a & 1), c.g.j = d, c.g.l = b;else if (16 === (d & 247) && 32 === (a & 240) || 23 === (d & 247) && 45 === (a & 255)) b = "black", 0 === (d & 7) && (b = Tp[(a & 14) >> 1]), c.g.s = b;else if (17 === (d & 247) && 48 === (a & 240)) Bp(c.g, Ep, a);else if (18 === (d & 246) && 32 === (a & 224)) Bp(c.g, d & 1 ? Ip : Gp, a);else if (20 === (d & 246) && 32 === (a & 240)) {
          a = b.pts;
          d = null;

          switch (b.Db) {
            case 32:
              Qp(c);
              break;

            case 33:
              c = c.g;
              c.i[c.g].pop();
              break;

            case 37:
              d = Np(c, 2, a);
              break;

            case 38:
              d = Np(c, 3, a);
              break;

            case 39:
              d = Np(c, 4, a);
              break;

            case 40:
              Bp(c.g, Cp, 32);
              break;

            case 41:
              c.h = 2;
              c.g = c.i;
              c.g.h = 0;
              c.l = a;
              break;

            case 42:
              xp(c.s);
              Sp(c);
              break;

            case 43:
              Sp(c);
              break;

            case 44:
              b = c.i;
              d = null;
              c.h !== Pp && (d = yp(b, c.l, a));
              Ap(b, 0, 15);
              break;

            case 45:
              b = c.g;
              c.h !== Op ? d = null : (d = yp(b, c.l, a), f = b.g - b.h + 1, Kp(b, f - 1, f, b.h), Ap(b, 0, f - 1), Ap(b, b.g, 15 - b.g), c.l = a);
              break;

            case 46:
              Ap(c.j, 0, 15);
              break;

            case 47:
              b = null, c.h !== Pp && (b = yp(c.i, c.l, a)), d = c.j, c.j = c.i, c.i = d, Qp(c), c.l = a, d = b;
          }

          a = d;
          break a;
        }
        a = null;
      } else d = b.Db, Bp(c.g, Cp, b.fb), Bp(c.g, Cp, d);
      return a;
    }

    function Bq(a, b) {
      var c = [];

      try {
        for (; b.wa();) {
          var d = pq(b).value,
              e = (d & 224) >> 5,
              f = d & 31;
          7 === e && 0 != f && (e = pq(b).value & 63);

          if (0 != e) {
            a.C.add("svc" + e);
            a.j.has(e) || a.j.set(e, new qq(e));

            for (var g = a.j.get(e), h = b.Ea(); b.Ea() - h < f;) {
              e = b;
              var k = pq(e),
                  l = k.value,
                  m = k.pts;

              if (16 === l) {
                var n = pq(e);
                l = l << 16 | n.value;
              }

              if (0 <= l && 31 >= l) {
                var r = m;

                if (g.g) {
                  var q = g.g;
                  e = null;

                  switch (l) {
                    case 8:
                      !$p(q) || 0 >= q.g && 0 >= q.h || (0 >= q.g ? (q.g = q.m - 1, q.h--) : q.g--, q.i[q.h][q.g] = null);
                      break;

                    case 13:
                      q.isVisible() && (e = aq(q, r, g.i));

                      if (q.h + 1 >= q.s) {
                        r = q;

                        for (var u = 0, v = 1; 16 > v; v++, u++) r.i[u] = r.i[v];

                        for (v = 0; 1 > v; v++, u++) r.i[u] = Yp();
                      } else q.h++;

                      q.g = 0;
                      break;

                    case 14:
                      q.isVisible() && (e = aq(q, r, g.i));
                      q.i[q.h] = Yp();
                      q.g = 0;
                      break;

                    case 12:
                      q.isVisible() && (e = aq(q, r, g.i)), Xp(q), r = q, r.h = 0, r.g = 0;
                  }

                  var y = e;
                } else y = null;
              } else if (128 <= l && 159 >= l) y = rq(g, e, l, m);else {
                if (4096 <= l && 4127 >= l) r = l & 255, 8 <= r && 15 >= r ? e.skip(1) : 16 <= r && 23 >= r ? e.skip(2) : 24 <= r && 31 >= r && e.skip(3);else if (4224 <= l && 4255 >= l) r = l & 255, 128 <= r && 135 >= r ? e.skip(4) : 136 <= r && 143 >= r && e.skip(5);else if (32 <= l && 127 >= l) e = l, g.g && (127 === e ? Zp(g.g, "\u266a") : Zp(g.g, String.fromCharCode(e)));else if (160 <= l && 255 >= l) g.g && Zp(g.g, String.fromCharCode(l));else if (4128 <= l && 4223 >= l) {
                  if (e = l & 255, g.g) if (xq.has(e)) {
                    var z = xq.get(e);
                    Zp(g.g, z);
                  } else Zp(g.g, "_");
                } else 4256 <= l && 4351 >= l && g.g && (160 != (l & 255) ? Zp(g.g, "_") : Zp(g.g, "[CC]"));
                y = null;
              }

              (e = y) && c.push(e);
            }
          }
        }
      } catch (x) {
        if (x instanceof P && 3E3 === x.code) Va("CEA708_INVALID_DATA", "Buffer read out of bounds / invalid CEA-708 Data.");else throw x;
      }

      return c;
    }

    function Cq(a) {
      for (var b = 0; a;) b ^= a & 1, a >>= 1;

      return 1 === b;
    }

    yq.prototype.getStreams = function () {
      return Array.from(this.C);
    };

    M("shaka.cea.CeaDecoder", yq);

    vc = function () {
      return new yq();
    };

    function Dq(a) {
      for (var b = [], c = a, d = a = 0; d < c.length;) 2 == a && 3 == c[d] ? (a = 0, c = [].concat(w(c)), c.splice(d, 1), c = new Uint8Array(c)) : 0 == c[d] ? a++ : a = 0, d++;

      a = c;

      for (d = 0; d < a.length;) {
        for (c = 0; 255 == a[d];) c += 255, d++;

        c += a[d++];

        for (var e = 0; 255 == a[d];) e += 255, d++;

        e += a[d++];
        4 == c && b.push(a.subarray(d, d + e));
        d += e;
      }

      return b;
    }

    ;

    function Eq() {
      this.j = new Map();
      this.i = this.h = 0;
      this.g = Fq;
    }

    Eq.prototype.init = function (a) {
      function b(f) {
        f = f.name;
        f in Gq && (c.g = Gq[f]);
      }

      var c = this,
          d = [],
          e = [];
      new bg().box("moov", gg).box("mvex", gg).W("trex", function (f) {
        var g = f.reader;
        g.skip(4);
        g.skip(4);
        f = g.O();
        g = g.O();
        c.h = f;
        c.i = g;
      }).box("trak", gg).W("tkhd", function (f) {
        f = ii(f.reader, f.version);
        d.push(f.trackId);
      }).box("mdia", gg).W("mdhd", function (f) {
        f = fi(f.reader, f.version);
        e.push(f.timescale);
      }).box("minf", gg).box("stbl", gg).W("stsd", ig).box("avc1", b).box("avc3", b).box("hev1", b).box("hvc1", b).box("dvh1", b).box("dvhe", b).box("encv", jg).box("sinf", gg).box("frma", function (f) {
        f = li(f.reader).va;
        f in Gq && (c.g = Gq[f]);
      }).parse(a, !0);
      if (!d.length || !e.length || d.length != e.length) throw new P(2, 2, 2010);
      this.g == Fq && Ua("Unable to determine bitstream format for CEA parsing!");
      d.forEach(function (f, g) {
        c.j.set(f, e[g]);
      });
    };

    Eq.prototype.parse = function (a) {
      var b = this;
      if (this.g == Fq) return [];
      var c = [],
          d = this.h,
          e = this.i,
          f = 0,
          g = [],
          h = null,
          k = 9E4;
      new bg().box("moof", function (l) {
        f = l.start;
        g = [];
        gg(l);
      }).box("traf", gg).W("trun", function (l) {
        l = gi(l.reader, l.version, l.flags);
        g.push(l);
      }).W("tfhd", function (l) {
        l = di(l.reader, l.flags);
        d = l.Hg || b.h;
        e = l.Ih || b.i;
        l = l.trackId;
        b.j.has(l) && (k = b.j.get(l));
      }).W("tfdt", function (l) {
        h = ei(l.reader, l.version).baseMediaDecodeTime;
      }).box("mdat", function (l) {
        if (null === h) throw Ua("Unable to find base media decode time for CEA captions!"), new P(2, 2, 2010);
        Hq(b, l.reader, h, k, d, e, f - l.start - 8, g, c);
      }).parse(a, !1);
      return c;
    };

    function Hq(a, b, c, d, e, f, g, h, k) {
      var l = 0,
          m = f,
          n = h.map(function (u) {
        return u.dh;
      });
      n = [].concat.apply([], w(n));
      n.length && (m = n[0].sampleSize || f);

      for (b.skip(g + h[0].Hh); b.wa();) {
        g = b.O();
        var r = b.qa(),
            q = null;
        q = !1;
        h = 1;

        switch (a.g) {
          case Iq:
            q = r & 31;
            q = 6 == q;
            break;

          case Jq:
            h = 2;
            b.skip(1);
            q = r >> 1 & 63;
            q = 39 == q || 40 == q;
            break;

          default:
            return;
        }

        if (q) for (r = 0, l < n.length && (r = n[l].Ce || 0), r = (c + r) / d, h = t(Dq(b.Kb(g - h))), q = h.next(); !q.done; q = h.next()) k.push({
          packet: q.value,
          pts: r
        });else try {
          b.skip(g - h);
        } catch (u) {
          break;
        }
        m -= g + 4;
        0 == m && (c = l < n.length ? c + (n[l].cg || e) : c + e, l++, l < n.length ? m = n[l].sampleSize || f : m = f);
      }
    }

    M("shaka.cea.Mp4CeaParser", Eq);
    var Fq = 0,
        Iq = 1,
        Jq = 2,
        Gq = {
      avc1: Iq,
      avc3: Iq,
      hev1: Jq,
      hvc1: Jq,
      dvh1: Jq,
      dvhe: Jq
    };

    uc["video/mp4"] = function () {
      return new Eq();
    };

    function Kq() {}

    Kq.prototype.init = function () {};

    Kq.prototype.parse = function (a) {
      var b = [];
      a = nc(a);
      if (!Ci(a)) return b;
      a = new wi().parse(a);
      var c = a.pd(),
          d = a.ie();
      a = [];

      switch (c.video) {
        case "avc":
          a.push(6);
          break;

        case "hvc":
          a.push(39), a.push(40);
      }

      if (!a.length) return b;
      c = t(d);

      for (d = c.next(); !d.done; d = c.next()) if (d = d.value, a.includes(d.type) && null != d.time) for (var e = t(Dq(d.data)), f = e.next(); !f.done; f = e.next()) b.push({
        packet: f.value,
        pts: d.time
      });

      return b;
    };

    M("shaka.cea.TsCeaParser", Kq);

    uc["video/mp2t"] = function () {
      return new Kq();
    };

    function Lq(a, b, c) {
      var d = Mq(a),
          e = null;
      a = [];
      var f = [],
          g = null,
          h = new Set(d.map(function (k) {
        return k.keyId;
      }));
      h.delete(null);
      if (1 < h.size) throw new P(2, 4, 4010);

      if (!b) {
        f = d.filter(function (k) {
          return "urn:mpeg:dash:sea:2012" == k.Gd;
        });
        if (1 < f.length) throw new P(2, 4, 4050);
        f.length && (g = Nq(f[0]));
        f = d.filter(function (k) {
          return "urn:mpeg:dash:mp4protection:2011" == k.Gd ? (e = k.init || e, !1) : "urn:mpeg:dash:sea:2012" != k.Gd;
        });
        f.length && (a = Oq(e, f, c, h), 0 == a.length && (a = [Ib("", e)]));
      }

      if (d.length && !g && (b || !f.length)) for (a = [], b = t(Object.values(c)), c = b.next(); !c.done; c = b.next()) c = c.value, "org.w3.clearkey" != c && a.push(Ib(c, e));
      if (h = Array.from(h)[0] || null) for (b = t(a), c = b.next(); !c.done; c = b.next()) for (c = t(c.value.initData), d = c.next(); !d.done; d = c.next()) d.value.keyId = h;
      return {
        Gg: h,
        hk: e,
        drmInfos: a,
        We: g,
        Kg: !0
      };
    }

    function Pq(a, b, c, d) {
      var e = Lq(a, c, d);

      if (b.Kg) {
        a = 1 == b.drmInfos.length && !b.drmInfos[0].keySystem;
        c = 0 == e.drmInfos.length;
        if (0 == b.drmInfos.length || a && !c) b.drmInfos = e.drmInfos;
        b.Kg = !1;
      } else if (0 < e.drmInfos.length && (b.drmInfos = b.drmInfos.filter(function (f) {
        return e.drmInfos.some(function (g) {
          return g.keySystem == f.keySystem;
        });
      }), 0 == b.drmInfos.length)) throw new P(2, 4, 4008);

      return e.Gg || b.Gg;
    }

    function Qq(a) {
      var b = 0,
          c = rc(a),
          d = c.getUint32(b, !0);
      if (d != a.byteLength) return [];

      a: {
        a = b + 6;

        for (b = []; a < c.byteLength - 1;) {
          d = c.getUint16(a, !0);
          a += 2;
          var e = c.getUint16(a, !0);
          a += 2;

          if (0 != (e & 1) || e + a > c.byteLength) {
            c = [];
            break a;
          }

          var f = nc(c, a, e);
          b.push({
            type: d,
            value: f
          });
          a += e;
        }

        c = b;
      }

      return c;
    }

    function Rq(a) {
      a = t(a.getElementsByTagName("DATA"));

      for (var b = a.next(); !b.done; b = a.next()) {
        b = t(b.value.childNodes);

        for (var c = b.next(); !c.done; c = b.next()) if (c = c.value, c instanceof Element && "LA_URL" == c.tagName) return c.textContent;
      }

      return "";
    }

    function Sq(a) {
      var b = yg(a.node, "https://dashif.org/CPS", "Laurl");
      if (b && b.textContent) return b.textContent;
      a = yg(a.node, "urn:microsoft:playready", "pro");
      if (!a) return "";
      a = qg(a.textContent);
      a = Qq(a).filter(function (c) {
        return c.type === Tq;
      })[0];
      if (!a) return "";
      a = Uf(a.value, !0);
      return (a = Pg(a, "WRMHEADER")) ? Rq(a) : "";
    }

    function Oq(a, b, c, d) {
      var e = [];
      b = t(b);

      for (var f = b.next(); !f.done; f = b.next()) {
        f = f.value;
        var g = c[f.Gd];

        if (g) {
          var h;

          if (h = yg(f.node, "urn:microsoft:playready", "pro")) {
            h = qg(h.textContent);
            var k = new Uint8Array([154, 4, 240, 121, 152, 64, 66, 134, 171, 146, 230, 91, 224, 136, 95, 149]);
            h = [{
              initData: vg(h, k, new Set(), 0),
              initDataType: "cenc",
              keyId: f.keyId
            }];
          } else h = null;

          k = null;
          if ("urn:uuid:e2719d58-a985-b3c9-781a-b030af78d30e" === f.Gd) if (k = d, 0 == k.size) k = null;else {
            var l = new Uint8Array([16, 119, 239, 236, 192, 178, 77, 2, 172, 227, 60, 30, 82, 226, 251, 75]),
                m = new Uint8Array([]);
            k = [{
              initData: vg(m, l, k, 1),
              initDataType: "cenc",
              keyId: f.keyId
            }];
          }
          h = Ib(g, f.init || a || h || k);
          if (g = Uq.get(g)) h.licenseServerUri = g(f);
          e.push(h);
        }
      }

      return e;
    }

    function Mq(a) {
      var b = [];
      a = t(a);

      for (var c = a.next(); !c.done; c = a.next()) (c = Vq(c.value)) && b.push(c);

      return b;
    }

    function Vq(a) {
      var b = a.getAttribute("schemeIdUri"),
          c = Bg(a, "urn:mpeg:cenc:2013", "default_KID"),
          d = zg(a, "urn:mpeg:cenc:2013", "pssh").map(Dg);
      if (!b) return null;
      b = b.toLowerCase();
      if (c && (c = c.replace(/-/g, "").toLowerCase(), c.includes(" "))) throw new P(2, 4, 4009);
      var e = [];

      try {
        e = d.map(function (f) {
          return {
            initDataType: "cenc",
            initData: qg(f),
            keyId: null
          };
        });
      } catch (f) {
        throw new P(2, 4, 4007);
      }

      return {
        node: a,
        Gd: b,
        keyId: c,
        init: 0 < e.length ? e : null
      };
    }

    function Nq(a) {
      if (!window.crypto || !window.crypto.subtle) throw Ua("Web Crypto API is not available to decrypt AES-128. (Web Crypto only exists in secure origins like https)"), new P(2, 4, 4042);
      var b = yg(a.node, "urn:mpeg:dash:schema:sea:2012", "SegmentEncryption");
      if (!b) throw new P(2, 4, 4051);
      if ("urn:mpeg:dash:sea:aes128-cbc:2013" != b.getAttribute("schemeIdUri")) throw new P(2, 4, 4051);
      b = yg(a.node, "urn:mpeg:dash:schema:sea:2012", "CryptoPeriod");
      if (!b) throw new P(2, 4, 4051);
      a = b.getAttribute("IV");
      b = b.getAttribute("keyUriTemplate");
      if (!a || !b) throw new P(2, 4, 4051);
      a = rg(a.substr(2));
      if (16 != a.byteLength) throw new P(2, 4, 4048);
      return {
        Gi: b,
        iv: a
      };
    }

    var Tq = 1,
        Uq = new Map().set("com.widevine.alpha", function (a) {
      var b = yg(a.node, "https://dashif.org/CPS", "Laurl");
      return b && b.textContent ? b.textContent : (a = yg(a.node, "urn:microsoft", "laurl")) ? a.getAttribute("licenseUrl") || "" : "";
    }).set("com.microsoft.playready", Sq).set("com.microsoft.playready.recommendation", Sq).set("com.microsoft.playready.software", Sq).set("com.microsoft.playready.hardware", Sq).set("org.w3.clearkey", function (a) {
      var b = yg(a.node, "https://dashif.org/CPS", "Laurl");
      return b && b.textContent ? b.textContent : (a = yg(a.node, "http://dashif.org/guidelines/clearKey", "Laurl")) && "EME-1.0" === a.getAttribute("Lic_type") && a.textContent ? a.textContent : "";
    });

    function Wq(a, b, c, d, e, f) {
      var g = {
        RepresentationID: b,
        Number: c,
        SubNumber: d,
        Bandwidth: e,
        Time: f
      };
      return a.replace(/\$(RepresentationID|Number|SubNumber|Bandwidth|Time)?(?:%0([0-9]+)([diouxX]))?\$/g, function (h, k, l, m) {
        if ("$$" == h) return "$";
        var n = g[k];
        if (null == n) return h;
        "RepresentationID" == k && l && (l = void 0);
        "Time" == k && "bigint" != typeof n && (.2 <= Math.abs(n - Math.round(n)) && Ua("Calculated $Time$ values must be close to integers"), n = Math.round(n));

        switch (m) {
          case void 0:
          case "d":
          case "i":
          case "u":
            h = n.toString();
            break;

          case "o":
            h = n.toString(8);
            break;

          case "x":
            h = n.toString(16);
            break;

          case "X":
            h = n.toString(16).toUpperCase();
            break;

          default:
            h = n.toString();
        }

        l = window.parseInt(l, 10) || 1;
        return Array(Math.max(0, l - h.length) + 1).join("0") + h;
      });
    }

    function Xq(a, b) {
      var c = Yq(a, b, "timescale"),
          d = 1;
      c && (d = Kg(c) || 1);
      var e = Yq(a, b, "duration");
      c = Kg(e || "");
      "image" == a.P.contentType && (c = Mg(e || ""));
      c && (c /= d);
      var f = Yq(a, b, "startNumber");
      e = Number(Yq(a, b, "presentationTimeOffset")) || 0;
      var g = Lg(f || "");
      if (null == f || null == g) g = 1;
      var h = Zq(a, b, "SegmentTimeline");
      b = null;

      if (h) {
        b = d;
        a = a.ma.duration || Infinity;
        f = g;
        h = xg(h, "S");

        for (var k = [], l = -e, m = 0; m < h.length; ++m) {
          var n = h[m],
              r = h[m + 1],
              q = Fg(n, "t", Lg),
              u = Fg(n, "d", Lg),
              v = Fg(n, "r", Jg);
          n = Fg(n, "k", Jg) || 0;
          null != q && (q -= e);
          if (!u) break;
          q = null != q ? q : l;
          v = v || 0;
          if (0 > v) if (r) {
            r = Fg(r, "t", Lg);
            if (null == r) break;else if (q >= r) break;
            v = Math.ceil((r - q) / u) - 1;
          } else {
            if (Infinity == a) break;else if (q / b >= a) break;
            v = Math.ceil((a * b - q) / u) - 1;
          }
          0 < k.length && q != l && (k[k.length - 1].end = q / b);

          for (r = 0; r <= v; ++r) l = q + u, k.push({
            start: q / b,
            end: l / b,
            ug: q,
            ub: n,
            bj: k.length + f
          }), q = l;
        }

        b = k;
      }

      return {
        timescale: d,
        La: c,
        Kd: g,
        Mb: e / d || 0,
        sg: e,
        timeline: b
      };
    }

    function $q(a, b) {
      return [b(a.P), b(a.Ca), b(a.Ia)].filter(Bd);
    }

    function Yq(a, b, c) {
      b = $q(a, b);
      a = null;
      b = t(b);

      for (var d = b.next(); !d.done && !(a = d.value.getAttribute(c)); d = b.next());

      return a;
    }

    function Zq(a, b, c) {
      b = $q(a, b);
      a = null;
      b = t(b);

      for (var d = b.next(); !d.done && !(a = wg(d.value, c)); d = b.next());

      return a;
    }

    function ar(a, b, c, d, e, f) {
      for (var g = Bg(a, "http://www.w3.org/1999/xlink", "href"), h = Bg(a, "http://www.w3.org/1999/xlink", "actuate") || "onRequest", k = t(Array.from(a.attributes)), l = k.next(); !l.done; l = k.next()) l = l.value, "http://www.w3.org/1999/xlink" == l.namespaceURI && a.removeAttributeNS(l.namespaceURI, l.localName);

      if (5 <= f) return nf(new P(2, 4, 4028));
      if ("onLoad" != h) return nf(new P(2, 4, 4027));
      var m = Hb([d], [g]);
      return e.request(0, zf(m, b)).Da(function (n) {
        n = Rg(n.data, a.tagName);
        if (!n) return nf(new P(2, 4, 4001, g));

        for (; a.childNodes.length;) a.removeChild(a.childNodes[0]);

        for (; n.childNodes.length;) {
          var r = n.childNodes[0];
          n.removeChild(r);
          a.appendChild(r);
        }

        n = t(Array.from(n.attributes));

        for (r = n.next(); !r.done; r = n.next()) a.setAttributeNode(r.value.cloneNode(!1));

        return br(a, b, c, m[0], e, f + 1);
      });
    }

    function br(a, b, c, d, e, f) {
      f = void 0 === f ? 0 : f;

      if (Bg(a, "http://www.w3.org/1999/xlink", "href")) {
        var g = ar(a, b, c, d, e, f);
        c && (g = g.Da(void 0, function () {
          return br(a, b, c, d, e, f);
        }));
        return g;
      }

      g = [];

      for (var h = t(Array.from(a.childNodes)), k = h.next(); !k.done; k = h.next()) k = k.value, k instanceof Element && ("urn:mpeg:dash:resolve-to-zero:2013" == Bg(k, "http://www.w3.org/1999/xlink", "href") ? a.removeChild(k) : "SegmentTimeline" != k.tagName && g.push(br(k, b, c, d, e, f)));

      return rf(g).Da(function () {
        return a;
      });
    }

    ;

    function cr(a, b, c, d, e, f, g) {
      var h,
          k = new bg().W("sidx", function (l) {
        h = dr(b, d, e, f, g, c, l);
      });
      a && k.parse(a);
      if (h) return h;
      throw new P(2, 3, 3004);
    }

    function dr(a, b, c, d, e, f, g) {
      var h = [];
      g.reader.skip(4);
      var k = g.reader.O();
      if (0 == k) throw new P(2, 3, 3005);

      if (0 == g.version) {
        var l = g.reader.O();
        var m = g.reader.O();
      } else l = g.reader.Rc(), m = g.reader.Rc();

      g.reader.skip(2);
      var n = g.reader.Ra();
      a = a + g.size + m;

      for (m = 0; m < n; m++) {
        var r = g.reader.O(),
            q = (r & 2147483648) >>> 31;
        r &= 2147483647;
        var u = g.reader.O();
        g.reader.skip(4);
        if (1 == q) throw new P(2, 3, 3006);
        h.push(new Ph(l / k + c, (l + u) / k + c, function () {
          return f;
        }, a, a + r - 1, b, c, d, e));
        l += u;
        a += r;
      }

      g.parser.stop();
      return h;
    }

    ;

    function er(a) {
      this.h = rc(a);
      this.g = new Zf(this.h, 0);
    }

    er.prototype.wa = function () {
      return this.g.wa();
    };

    function fr(a) {
      var b = gr(a);
      if (7 < b.length) throw new P(2, 3, 3002);
      var c = 0;
      b = t(b);

      for (var d = b.next(); !d.done; d = b.next()) c = 256 * c + d.value;

      b = gr(a);

      a: {
        d = t(hr);

        for (var e = d.next(); !e.done; e = d.next()) if (lc(b, new Uint8Array(e.value))) {
          d = !0;
          break a;
        }

        d = !1;
      }

      if (d) b = a.h.byteLength - a.g.Ea();else {
        if (8 == b.length && b[1] & 224) throw new P(2, 3, 3001);

        for (e = d = 0; e < b.length; e++) {
          var f = b[e];
          d = 0 == e ? f & (1 << 8 - b.length) - 1 : 256 * d + f;
        }

        b = d;
      }
      b = a.g.Ea() + b <= a.h.byteLength ? b : a.h.byteLength - a.g.Ea();
      d = rc(a.h, a.g.Ea(), b);
      a.g.skip(b);
      return new ir(c, d);
    }

    function gr(a) {
      var b = a.g.Ea(),
          c = a.g.qa();
      if (0 == c) throw new P(2, 3, 3002);
      c = 8 - Math.floor(Math.log2(c));
      a.g.skip(c - 1);
      return nc(a.h, b, c);
    }

    var hr = [[255], [127, 255], [63, 255, 255], [31, 255, 255, 255], [15, 255, 255, 255, 255], [7, 255, 255, 255, 255, 255], [3, 255, 255, 255, 255, 255, 255], [1, 255, 255, 255, 255, 255, 255, 255]];

    function ir(a, b) {
      this.id = a;
      this.g = b;
    }

    function jr(a) {
      if (8 < a.g.byteLength) throw new P(2, 3, 3002);
      if (8 == a.g.byteLength && a.g.getUint8(0) & 224) throw new P(2, 3, 3001);

      for (var b = 0, c = 0; c < a.g.byteLength; c++) {
        var d = a.g.getUint8(c);
        b = 256 * b + d;
      }

      return b;
    }

    ;

    function kr(a, b, c, d, e, f, g, h, k) {
      function l() {
        return e;
      }

      var m = [];
      a = new er(a.g);

      for (var n = null, r = null; a.wa();) {
        var q = fr(a);

        if (187 == q.id) {
          var u = lr(q);
          u && (q = c * u.kj, u = b + u.Ti, null != n && m.push(new Ph(n + g, q + g, l, r, u - 1, f, g, h, k)), n = q, r = u);
        }
      }

      null != n && m.push(new Ph(n + g, d + g, l, r, null, f, g, h, k));
      return m;
    }

    function lr(a) {
      var b = new er(a.g);
      a = fr(b);
      if (179 != a.id) throw new P(2, 3, 3013);
      a = jr(a);
      b = fr(b);
      if (183 != b.id) throw new P(2, 3, 3012);
      b = new er(b.g);

      for (var c = 0; b.wa();) {
        var d = fr(b);

        if (241 == d.id) {
          c = jr(d);
          break;
        }
      }

      return {
        kj: a,
        Ti: c
      };
    }

    ;

    function mr(a, b, c) {
      b = Zq(a, b, "Initialization");
      if (!b) return null;
      var d = a.P.sb(),
          e = b.getAttribute("sourceURL");
      e && (d = Hb(d, [e]));
      e = 0;
      var f = null;
      if (b = Fg(b, "range", Ig)) e = b.start, f = b.end;
      return new Nh(function () {
        return d;
      }, e, f, nr(a), null, null, c);
    }

    function or(a, b, c) {
      var d = Number(Yq(a, pr, "presentationTimeOffset")) || 0,
          e = Yq(a, pr, "timescale"),
          f = 1;
      e && (f = Kg(e) || 1);
      var g = d / f || 0,
          h = mr(a, pr, c);
      qr(a, h);
      var k = Dd(a);
      return {
        Gc: function () {
          var l = Zq(k, pr, "RepresentationIndex");
          var m = k.P.sb();
          l && (l = l.getAttribute("sourceURL")) && (m = Hb(m, [l]));
          l = rr(k);
          return sr(k, b, h, m, l.start, l.end, g);
        }
      };
    }

    function sr(a, b, c, d, e, f, g) {
      var h, k, l, m, n, r, q, u, v, y, z, x, B, A, C;
      return K(function (E) {
        if (1 == E.g) return h = a.presentationTimeline, k = !a.Rb || !a.ma.Ff, l = a.ma.start, m = a.ma.duration, n = a.P.mimeType.split("/")[1], r = b, q = null, u = [r(d, e, f, !1), "webm" == n ? r(c.ba(), c.cb, c.Ja, !0) : null], r = null, D(E, Promise.all(u), 2);
        v = E.h;
        y = v[0];
        z = v[1] || null;
        x = null;
        B = l - g;
        A = l;
        C = m ? l + m : Infinity;
        if ("mp4" == n) var H = cr(y, e, d, c, B, A, C);else {
          H = new er(z);
          if (440786851 != fr(H).id) throw new P(2, 3, 3008);
          var G = fr(H);
          if (408125543 != G.id) throw new P(2, 3, 3009);
          H = G.g.byteOffset;
          G = new er(G.g);

          for (var I = null; G.wa();) {
            var J = fr(G);

            if (357149030 == J.id) {
              I = J;
              break;
            }
          }

          if (!I) throw new P(2, 3, 3010);
          I = new er(I.g);
          J = 1E6;

          for (G = null; I.wa();) {
            var L = fr(I);
            if (2807729 == L.id) J = jr(L);else if (17545 == L.id) if (4 == L.g.byteLength) G = L.g.getFloat32(0);else if (8 == L.g.byteLength) G = L.g.getFloat64(0);else throw new P(2, 3, 3003);
          }

          if (null == G) throw new P(2, 3, 3011);
          I = J / 1E9;
          G *= I;
          J = fr(new er(y));
          if (475249515 != J.id) throw new P(2, 3, 3007);
          H = kr(J, H, I, G, d, c, B, A, C);
        }
        x = H;
        h.Bd(x);
        q = new Oj(x);
        k && q.Ec(A, C, !0);
        return E.return(q);
      });
    }

    function pr(a) {
      return a.Id;
    }

    function rr(a) {
      var b = Zq(a, pr, "RepresentationIndex");
      a = Yq(a, pr, "indexRange");
      a = Ig(a || "");
      b && (a = Fg(b, "range", Ig, a));
      return a;
    }

    function qr(a, b) {
      tr(a, b);
      if (!rr(a)) throw new P(2, 4, 4002);
    }

    function tr(a, b) {
      var c = a.P.mimeType.split("/")[1];
      if (a.P.contentType != Mb && "mp4" != c && "webm" != c) throw new P(2, 4, 4006);
      if ("webm" == c && !b) throw new P(2, 4, 4005);
    }

    function nr(a) {
      var b = a.P;
      return {
        bandwidth: a.bandwidth,
        audioSamplingRate: b.audioSamplingRate,
        codecs: b.codecs,
        contentType: b.contentType,
        frameRate: b.frameRate || null,
        height: b.height || null,
        mimeType: b.mimeType,
        channelsCount: b.xe,
        pixelAspectRatio: b.pixelAspectRatio || null,
        width: b.width || null
      };
    }

    ;

    function ur(a, b, c) {
      var d = mr(a, vr, c),
          e = wr(a);
      if (!e.La && !e.timeline && 1 < e.Oc.length) throw new P(2, 4, 4002);
      if (!e.La && !a.ma.duration && !e.timeline && 1 == e.Oc.length) throw new P(2, 4, 4002);
      if (e.timeline && 0 == e.timeline.length) throw new P(2, 4, 4002);
      var f = null,
          g = null;
      a.Ia.id && a.P.id && (g = b[a.Ia.id + "," + a.P.id]) && (f = g.segmentIndex);
      var h = xr(a.ma.start, a.ma.duration, a.P.sb, e, d, c);
      b = !f;
      f ? f.zd(h, a.presentationTimeline.Hb()) : f = new Oj(h);
      a.presentationTimeline.Bd(h);
      a.Rb && a.ma.Ff || f.Ec(a.ma.start, a.ma.duration ? a.ma.start + a.ma.duration : Infinity, b);
      g && (g.segmentIndex = f);
      return {
        Gc: function () {
          f && 0 != f.mc() || f.se(h);
          return Promise.resolve(f);
        }
      };
    }

    function vr(a) {
      return a.ac;
    }

    function wr(a) {
      var b = yr(a);
      a = Xq(a, vr);
      var c = a.Kd;
      0 == c && (c = 1);
      var d = 0;
      a.La ? d = a.La * (c - 1) : a.timeline && 0 < a.timeline.length && (d = a.timeline[0].start);
      return {
        La: a.La,
        startTime: d,
        Kd: c,
        Mb: a.Mb,
        timeline: a.timeline,
        Oc: b
      };
    }

    function xr(a, b, c, d, e, f) {
      var g = d.Oc.length;
      d.timeline && d.timeline.length != d.Oc.length && (g = Math.min(d.timeline.length, d.Oc.length));

      for (var h = a - d.Mb, k = b ? a + b : Infinity, l = [], m = d.startTime, n = {}, r = 0; r < g; n = {
        gd: n.gd,
        dd: n.dd
      }, r++) {
        n.dd = d.Oc[r];
        var q = void 0;
        q = null != d.La ? m + d.La : d.timeline ? d.timeline[r].end : m + b;
        n.gd = null;
        l.push(new Ph(a + m, a + q, function (u) {
          return function () {
            null == u.gd && (u.gd = Hb(c(), [u.dd.Li]));
            return u.gd;
          };
        }(n), n.dd.start, n.dd.end, e, h, a, k, [], "", null, null, Qh, f));
        m = q;
      }

      return l;
    }

    function yr(a) {
      return [a.P.ac, a.Ca.ac, a.Ia.ac].filter(Bd).map(function (b) {
        return xg(b, "SegmentURL");
      }).reduce(function (b, c) {
        return 0 < b.length ? b : c;
      }).map(function (b) {
        b.getAttribute("indexRange") && !a.Rg && (a.Rg = !0);
        var c = b.getAttribute("media");
        b = Fg(b, "mediaRange", Ig, {
          start: 0,
          end: null
        });
        return {
          Li: c,
          start: b.start,
          end: b.end
        };
      });
    }

    ;

    function zr(a, b, c, d, e, f, g) {
      var h = Ar(a, g),
          k = Br(a);
      Cr(k);
      var l = Dd(a);
      if (k.vd) return tr(a, h), {
        Gc: function () {
          var u = Wq(k.vd, l.P.id, null, null, l.bandwidth || null, null);
          u = Hb(l.P.sb(), [u]);
          return sr(l, b, h, u, 0, null, k.Mb);
        }
      };
      if (k.La) return d || "image" === a.Ca.contentType || (a.presentationTimeline.Qf(k.La), a.presentationTimeline.we(a.ma.start)), {
        Gc: function () {
          return Dr(l, k, e, h, f, g);
        }
      };
      var m = null;
      d = d = null;
      a.Ia.id && a.P.id && (d = a.Ia.id + "," + a.P.id, d = c[d]) && (m = d.segmentIndex);
      var n = a.ma.start,
          r = a.ma.duration ? n + a.ma.duration : Infinity,
          q = !(a.Rb && a.ma.Ff);
      m ? (c = m, Er(c, k, n, r, q, h), c.rb(a.presentationTimeline.Hb())) : m = new Fr(k, a.P.id, a.bandwidth, a.P.sb, n, r, h, q, g, a.P.dg);
      k.timeline && "image" !== a.Ca.contentType && a.presentationTimeline.Zg(k.timeline, n);
      d && a.Rb && (d.segmentIndex = m);
      return {
        Gc: function () {
          m instanceof Fr && 0 == m.mc() && Er(m, k, n, r, q, h);
          return Promise.resolve(m);
        }
      };
    }

    function Gr(a) {
      return a.Jd;
    }

    function Br(a) {
      var b = Xq(a, Gr),
          c = Yq(a, Gr, "media");
      a = Yq(a, Gr, "index");
      return {
        La: b.La,
        timescale: b.timescale,
        Kd: b.Kd,
        Mb: b.Mb,
        sg: b.sg,
        timeline: b.timeline,
        Pc: c,
        vd: a
      };
    }

    function Cr(a) {
      var b = a.vd ? 1 : 0;
      b += a.timeline ? 1 : 0;
      b += a.La ? 1 : 0;
      if (0 == b) throw new P(2, 4, 4002);
      1 != b && (a.vd && (a.timeline = null), a.La = null);
      if (!a.vd && !a.Pc) throw new P(2, 4, 4002);
    }

    function Dr(a, b, c, d, e, f) {
      function g(J) {
        var L = (J - u) * q,
            O = L + b.Mb,
            Q = L + m;
        L = Q + q;
        var V = Math.min(L, k());
        Q = new Ph(Q, V, function () {
          var U = O * v;
          "BigInt" in window && U > Number.MAX_SAFE_INTEGER && (U = BigInt(O) * BigInt(v));
          U = Wq(y, x, J, null, z, U);
          return Hb(B(), [U]);
        }, 0, null, d, A, m, k(), [], "", null, null, Qh, f);
        Q.i = L;
        return Q;
      }

      function h() {
        var J = [Math.max(l.Hb(), m), Math.min(l.Vb(), k())].map(function (L) {
          return L - m;
        });
        return [Math.ceil(J[0] / q), Math.ceil(J[1] / q) - 1].map(function (L) {
          return L + u;
        });
      }

      function k() {
        var J = null != n && e[n] || r;
        return J ? m + J : Infinity;
      }

      var l = a.presentationTimeline,
          m = a.ma.start,
          n = a.Ia.id,
          r = a.ma.duration,
          q = b.La,
          u = b.Kd,
          v = b.timescale,
          y = b.Pc,
          z = a.bandwidth || null,
          x = a.P.id,
          B = a.P.sb,
          A = m - b.Mb,
          C = h();
      a = a.Rb ? Math.max(C[0], C[1] - c + 1) : C[0];
      C = C[1];
      c = [];

      for (var E = a; E <= C; ++E) {
        var H = g(E);
        c.push(H);
      }

      var G = new Oj(c);
      c = l.Vb() < k();
      E = l.S();

      if (c || E) {
        var I = Math.max(a, C + 1);
        G.Ie(q, function () {
          var J = l.Hb();
          G.rb(J);
          var L = t(h());
          L.next();
          L = L.next().value;

          for (var O = []; I <= L;) {
            var Q = g(I);
            O.push(Q);
            I++;
          }

          return J > k() && !O.length ? null : O;
        });
      }

      return Promise.resolve(G);
    }

    function Ar(a, b) {
      var c = Yq(a, Gr, "initialization");
      if (!c) return null;
      var d = a.P.id,
          e = a.bandwidth || null,
          f = a.P.sb;
      return new Nh(function () {
        var g = Wq(c, d, null, null, e, null);
        return Hb(f(), [g]);
      }, 0, null, nr(a), null, null, b);
    }

    function Fr(a, b, c, d, e, f, g, h, k, l) {
      Oj.call(this, []);
      this.h = a;
      this.H = b;
      this.D = c;
      this.G = d;
      this.i = e;
      this.m = f;
      this.u = g;
      this.C = k;
      this.I = l;
      h && Hr(this);
    }

    pa(Fr, Oj);
    p = Fr.prototype;

    p.mc = function () {
      return this.h ? this.h.timeline.length : 0;
    };

    p.release = function () {
      Oj.prototype.release.call(this);
      this.h = null;
    };

    p.rb = function (a) {
      if (this.h) {
        for (var b = 0, c = this.h.timeline, d = 0; d < c.length; d += 1) if (c[d].end + this.i <= a) b += 1;else break;

        0 < b && (this.h.timeline = c.slice(b), this.g.length >= b && (this.g = this.g.slice(b)), this.j += b, 0 === this.mc() && this.release());
      }
    };

    function Er(a, b, c, d, e, f) {
      a.u = f;

      if (a.h) {
        c = a.h.timeline;
        a.h.Pc = b.Pc;
        var g = c[c.length - 1];
        b = b.timeline.filter(function (h) {
          return h.start >= g.end;
        });
        0 < b.length && a.h.timeline.push.apply(a.h.timeline, w(b));
        a.m !== d && (a.m = d);
      } else a.h = b, a.i = c, a.m = d;

      e && Hr(a);
    }

    function Hr(a) {
      if (!a.s) {
        for (var b = a.h.timeline; b.length;) if (b[b.length - 1].start >= a.m) b.pop();else break;

        a.rb(a.i);
        0 !== b.length && Infinity !== a.m && (b[b.length - 1].end = a.m - a.i);
      }
    }

    p.find = function (a) {
      if (this.h && this.h.timeline && this.h.timeline.length && a < this.h.timeline[0].start + this.i) return this.j;
      if (!this.h) return null;
      var b = this.h.timeline;
      if (a < this.i || a > this.m) return null;

      for (var c = b.length - 1, d = 0; d < b.length; d++) {
        var e = b[d],
            f = e.start + this.i;
        e = e.end + this.i;
        d < c && (e = b[d + 1].start + this.i);
        if (a >= f && a < e) return d + this.j;
      }

      return null;
    };

    p.get = function (a) {
      var b = this;
      a -= this.j;
      if (0 > a || a >= this.mc() || !this.h) return null;
      var c = this.g[a];

      if (!c) {
        var d = this.h.Pc,
            e = this.h.timeline[a],
            f = e.bj,
            g = this.h.sg + e.ug;
        c = this.i - this.h.Mb;

        for (var h = [], k = (e.end - e.start) / e.ub, l = {}, m = 0; m < e.ub; l = {
          hd: l.hd,
          Se: l.Se
        }, m++) {
          var n = e.start + k * m,
              r = n + k;
          l.Se = m + 1;
          l.hd = null;
          n = new Ph(this.i + n, this.i + r, function (q) {
            return function () {
              if (!b.h) return [];
              null == q.hd && (q.hd = Ir(b.h.Pc, b.H, f, b.D, g, q.Se, b.G));
              return q.hd;
            };
          }(l), 0, null, this.u, c, this.i, this.m, [], "", null, null, Qh, this.C);
          0 == this.I ? 0 < m && n.qe() : 0 != m % this.I && n.qe();
          h.push(n);
        }

        c = new Ph(this.i + e.start, this.i + e.end, function () {
          return 0 < e.ub ? [] : Ir(d, b.H, f, b.D, g, null, b.G);
        }, 0, null, this.u, c, this.i, this.m, h, "", null, null, Qh, this.C, 0 < e.ub);
        this.g[a] = c;
      }

      return c;
    };

    function Ir(a, b, c, d, e, f, g) {
      a = Wq(a, b, c, f, d || null, e);
      return Hb(g(), [a]).map(function (h) {
        return h.toString();
      });
    }

    ;

    function Jr(a) {
      this.s = null;
      this.C = a;
      this.I = new tf();
      this.j = [];
      this.h = null;
      this.m = [];
      this.D = null;
      this.H = [];
      this.G = 300;
      this.l = new Map();
      this.i = new Map();
      this.g = null;
      this.u = "UNKNOWN";
    }

    Jr.prototype.configure = function (a) {
      this.s = a;
    };

    Jr.prototype.destroy = function () {
      this.C = this.s = null;
      this.j = [];
      this.h = null;
      this.m = [];
      this.H = [];
      this.l.clear();
      null != this.g && (this.g.stop(), this.g = null);
      return this.I.destroy();
    };

    Jr.prototype.setManifestType = function (a) {
      this.u = a;
    };

    function Kr(a, b) {
      var c, d, e, f, g, h, k;
      return K(function (l) {
        if (1 == l.g) return c = Hb(a.j, [Lr(a, b)]), d = zf(c, a.s.retryParameters), e = a.C.networkingEngine.request(8, d), uf(a.I, e), ta(l, 2), D(l, e.promise, 4);
        if (2 != l.g) return f = l.h, g = Tf(f.data), h = JSON.parse(g), 1 == h.VERSION && Mr(a, h, f.uri), va(l, 0);
        if ((k = wa(l)) && 7001 == k.code) return l.return();
        null != a.g && (a.g.stop(), a.g = null);
        a.g = new Fd(function () {
          Kr(a, b);
        });
        a.g.R(a.G);
        F(l);
      });
    }

    function Lr(a, b) {
      if (!a.m.length) return b;
      b = new kb(b);
      var c = a.D || a.m[0],
          d = Math.round(a.C.getBandwidthEstimate()),
          e = b.g;
      "DASH" == a.u ? (e.add("_DASH_pathway", c), e.add("_DASH_throughput", String(d))) : "HLS" == a.u && (e.add("_HLS_pathway", c), e.add("_HLS_throughput", String(d)));
      Fb(e) && pb(b, e);
      return b.toString();
    }

    function Mr(a, b, c) {
      null != a.g && (a.g.stop(), a.g = null);
      var d = b["RELOAD-URI"] || c;
      a.g = new Fd(function () {
        Kr(a, d);
      });
      if (c = b.TTL) a.G = c;
      a.g.R(a.G);
      a.m = b["PATHWAY-PRIORITY"] || [];
      a.H = b["PATHWAY-CLONES"] || [];
    }

    function Nr(a, b, c, d) {
      var e = a.l.get(b);
      e || (e = new Map());
      e.set(c, d);
      a.l.set(b, e);
    }

    function Or(a, b, c) {
      c = void 0 === c ? !1 : c;
      b = a.l.get(b) || new Map();

      for (var d = [], e = {}, f = t(a.m), g = f.next(); !g.done; e = {
        ec: e.ec
      }, g = f.next()) if (e.ec = g.value, g = b.get(e.ec)) d.push({
        Wf: e.ec,
        location: g
      });else if (g = a.H.find(function (k) {
        return function (l) {
          return l.Bj == k.ec;
        };
      }(e))) {
        var h = b.get(g["BASE-ID"]);
        h && (g["URI-REPLACEMENT"].uh ? (h = new kb(h), nb(h, g["URI-REPLACEMENT"].uh), d.push({
          Wf: e.ec,
          location: h.toString()
        })) : d.push({
          Wf: e.ec,
          location: h
        }));
      }

      e = Date.now();
      f = t(a.i.keys());

      for (g = f.next(); !g.done; g = f.next()) g = g.value, h = a.i.get(g), e > h && a.i.delete(g);

      d = d.filter(function (k) {
        for (var l = t(a.i.keys()), m = l.next(); !m.done; m = l.next()) if (m.value.includes(new kb(k.location).Eb)) return !1;

        return !0;
      });
      d.length && (a.D = d[0].Wf);
      d = d.map(function (k) {
        return k.location;
      });
      if (!d.length && a.h) for (e = t(a.h.split(",")), g = e.next(); !g.done; g = e.next()) if (f = b.get(g.value)) a.D = a.h, d.push(f);
      if (!d.length) for (b = t(b.values()), e = b.next(); !e.done; e = b.next()) d.push(e.value);
      return c ? d : Hb(a.j, d);
    }

    ;

    function Pr() {
      this.j = [];
      this.h = [];
      this.g = [];
      this.l = [];
      this.i = [];
      this.m = !1;
      this.s = new Set();
    }

    p = Pr.prototype;

    p.release = function () {
      for (var a = t(this.h.concat(this.g, this.l, this.i)), b = a.next(); !b.done; b = a.next()) b = b.value, b.segmentIndex && b.segmentIndex.release();

      this.h = [];
      this.g = [];
      this.l = [];
      this.i = [];
      this.j = [];
    };

    p.pi = function () {
      return this.j;
    };

    p.Cf = function () {
      return this.l.slice();
    };

    p.Wh = function () {
      return this.i;
    };

    p.Dg = function (a, b) {
      var c,
          d,
          e,
          f,
          g = this,
          h,
          k,
          l,
          m,
          n,
          r,
          q,
          u,
          v,
          y,
          z,
          x,
          B,
          A,
          C,
          E,
          H,
          G,
          I,
          J,
          L,
          O,
          Q,
          V,
          U,
          oa,
          la,
          Qa,
          Xa,
          qb;
      return K(function (lb) {
        if (1 == lb.g) {
          h = Nb;
          Qr(a);
          if (!b && 1 == a.length) return k = a[0], g.h = k.audioStreams, g.g = k.videoStreams, g.l = k.textStreams, g.i = k.imageStreams, lb.F(2);
          l = -1;

          for (m = 0; m < a.length; m++) n = a[m], g.s.has(n.id) || (g.s.add(n.id), -1 == l && (l = m));

          if (-1 == l) return lb.return();

          for (var wb = [], Aa = [], ib = [], rb = [], Eb = t(a), cb = Eb.next(); !cb.done; cb = Eb.next()) cb = cb.value, wb.push(cb.audioStreams), Aa.push(cb.videoStreams), ib.push(cb.textStreams), rb.push(cb.imageStreams);

          c = wb;
          d = Aa;
          e = ib;
          f = rb;
          r = c;
          q = d;
          u = e;
          v = f;
          y = t(u);

          for (z = y.next(); !z.done; z = y.next()) x = z.value, x.push(Rr(h.sa));

          B = t(v);

          for (A = B.next(); !A.done; A = B.next()) C = A.value, C.push(Rr(h.kd));

          return D(lb, Promise.all([Ur(g, g.h, r, l, Vr, Wr), Ur(g, g.g, q, l, Vr, Wr), Ur(g, g.l, u, l, Vr, Wr), Ur(g, g.i, v, l, Vr, Wr)]), 2);
        }

        E = 0;
        H = [];
        if (g.g.length && g.h.length) for (Q = t(g.h), V = Q.next(); !V.done; V = Q.next()) for (U = V.value, oa = t(g.g), la = oa.next(); !la.done; la = oa.next()) Qa = la.value, Xa = Eh(U.drmInfos, Qa.drmInfos), U.drmInfos.length && Qa.drmInfos.length && !Xa.length || (qb = E++, H.push({
          id: qb,
          language: U.language,
          disabledUntilTime: 0,
          primary: U.primary,
          audio: U,
          video: Qa,
          bandwidth: (U.bandwidth || 0) + (Qa.bandwidth || 0),
          drmInfos: Xa,
          allowedByApplication: !0,
          allowedByKeySystem: !0,
          decodingInfos: []
        }));else for (G = g.g.length ? g.g : g.h, I = t(G), J = I.next(); !J.done; J = I.next()) L = J.value, O = E++, H.push({
          id: O,
          language: L.language,
          disabledUntilTime: 0,
          primary: L.primary,
          audio: L.type == h.T ? L : null,
          video: L.type == h.ia ? L : null,
          bandwidth: L.bandwidth || 0,
          drmInfos: L.drmInfos,
          allowedByApplication: !0,
          allowedByKeySystem: !0,
          decodingInfos: []
        });
        g.j = H;
        F(lb);
      });
    };

    function Qr(a) {
      a = t(a);

      for (var b = a.next(); !b.done; b = a.next()) b = b.value, b.videoStreams = Xr(b.videoStreams, function (c, d) {
        return c.id !== d.id && c.fastSwitching == d.fastSwitching && c.width === d.width && c.frameRate === d.frameRate && c.codecs === d.codecs && c.mimeType === d.mimeType && c.label === d.label && yc(c.roles, d.roles) && Rf(c.closedCaptions, d.closedCaptions) && c.bandwidth === d.bandwidth;
      }), b.audioStreams = Xr(b.audioStreams, function (c, d) {
        return c.id !== d.id && c.fastSwitching == d.fastSwitching && c.channelsCount === d.channelsCount && c.language === d.language && c.bandwidth === d.bandwidth && c.label === d.label && c.codecs === d.codecs && c.mimeType === d.mimeType && yc(c.roles, d.roles) && c.audioSamplingRate === d.audioSamplingRate && c.primary === d.primary;
      }), b.textStreams = Xr(b.textStreams, function (c, d) {
        return c.id !== d.id && c.language === d.language && c.label === d.label && c.codecs === d.codecs && c.mimeType === d.mimeType && c.bandwidth === d.bandwidth && yc(c.roles, d.roles);
      }), b.imageStreams = Xr(b.imageStreams, function (c, d) {
        return c.id !== d.id && c.width === d.width && c.codecs === d.codecs && c.mimeType === d.mimeType;
      });
    }

    function Xr(a, b) {
      var c = [],
          d = {};
      a = t(a);

      for (var e = a.next(); !e.done; d = {
        Sd: d.Sd
      }, e = a.next()) d.Sd = e.value, c.some(function (f) {
        return function (g) {
          return b(f.Sd, g);
        };
      }(d)) || c.push(d.Sd);

      return c;
    }

    function Yr(a) {
      var b, c, d, e, f, g, h, k, l, m, n, r, q, u, v, y, z, x, B, A, C, E, H, G, I, J, L, O;
      return K(function (Q) {
        switch (Q.g) {
          case 1:
            b = Nb;
            if (1 == a.length) return Q.return(a[0]);
            c = a.map(function (V) {
              return V.filter(function (U) {
                return U.type == b.T;
              });
            });
            d = a.map(function (V) {
              return V.filter(function (U) {
                return U.type == b.ia;
              });
            });
            e = a.map(function (V) {
              return V.filter(function (U) {
                return U.type == b.sa;
              });
            });
            f = a.map(function (V) {
              return V.filter(function (U) {
                return U.type == b.kd;
              });
            });
            g = t(e);

            for (h = g.next(); !h.done; h = g.next()) k = h.value, k.push(Zr(b.sa));

            l = t(f);

            for (m = l.next(); !m.done; m = l.next()) n = m.value, n.push(Zr(b.kd));

            r = new Pr();
            return D(Q, Ur(r, [], c, 0, $r, as), 2);

          case 2:
            return q = Q.h, D(Q, Ur(r, [], d, 0, $r, as), 3);

          case 3:
            return u = Q.h, D(Q, Ur(r, [], e, 0, $r, as), 4);

          case 4:
            return v = Q.h, D(Q, Ur(r, [], f, 0, $r, as), 5);

          case 5:
            y = Q.h;
            z = 0;
            if (u.length && q.length) for (E = t(q), H = E.next(); !H.done; H = E.next()) for (G = H.value, I = t(u), J = I.next(); !J.done; J = I.next()) L = J.value, O = z++, L.variantIds.push(O), G.variantIds.push(O);else for (x = u.concat(q), B = t(x), A = B.next(); !A.done; A = B.next()) C = A.value, C.variantIds = [z++];
            return Q.return(u.concat(q).concat(v).concat(y));
        }
      });
    }

    function Ur(a, b, c, d, e, f) {
      var g, h, k, l, m, n, r, q, u, v, y, z, x, B, A, C, E, H, G, I, J;
      return K(function (L) {
        switch (L.g) {
          case 1:
            g = Nb;
            h = [];

            for (k = 0; k < c.length; k++) k >= d ? h.push(new Set(c[k])) : h.push(new Set());

            l = t(b);
            m = l.next();

          case 2:
            if (m.done) {
              L.F(4);
              break;
            }

            n = m.value;
            return D(L, bs(a, n, c, d, f, h), 5);

          case 5:
            r = L.h;
            if (!r) throw new P(2, 4, 4037);
            m = l.next();
            L.F(2);
            break;

          case 4:
            q = t(h);

            for (u = q.next(); !u.done; u = q.next()) for (v = u.value, y = t(v), z = y.next(); !z.done; z = y.next()) x = z.value, (B = cs(a, x, c, e, f, h)) && b.push(B);

            A = t(h);

            for (u = A.next(); !u.done; u = A.next()) for (C = u.value, E = {}, H = t(C), z = H.next(); !z.done; E = {
              fc: E.fc
            }, z = H.next()) if (E.fc = z.value, G = E.fc.type == g.sa && !E.fc.language, I = E.fc.type == g.kd && !E.fc.tilesLayout, !G && !I && (J = b.some(function (O) {
              return function (Q) {
                return ds(a, O.fc, Q);
              };
            }(E)))) throw new P(2, 4, 4037);

            return L.return(b);
        }
      });
    }

    function bs(a, b, c, d, e, f) {
      return K(function (g) {
        if (1 == g.g) return es(a, c, b), b.matchedStreams ? b.segmentIndex ? D(g, fs(b, d), 2) : g.F(2) : g.return(!1);
        gs(b, d, e, f);
        return g.return(!0);
      });
    }

    function fs(a, b) {
      var c, d, e, f, g, h, k;
      return K(function (l) {
        if (1 == l.g) {
          c = [];
          d = a.matchedStreams;
          e = t(d);

          for (f = e.next(); !f.done; f = e.next()) g = f.value, c.push(g.createSegmentIndex()), g.trickModeVideo && !g.trickModeVideo.segmentIndex && c.push(g.trickModeVideo.createSegmentIndex());

          return D(l, Promise.all(c), 2);
        }

        if (a.segmentIndex instanceof Sj) for (h = {}, k = b; k < d.length; h = {
          zb: h.zb
        }, k++) h.zb = d[k], h.zb.segmentIndex && (Pj(h.zb.segmentIndex, function (m) {
          return function (n) {
            n.codecs = m.zb.codecs;
            n.mimeType = m.zb.mimeType;
            n.ka && (n.ka.codecs = m.zb.codecs, n.ka.mimeType = m.zb.mimeType);
          };
        }(h)), a.segmentIndex.h.push(h.zb.segmentIndex));
        F(l);
      });
    }

    function cs(a, b, c, d, e, f) {
      var g = d(b);
      es(a, c, g);
      g.createSegmentIndex && (g.createSegmentIndex = function () {
        return K(function (h) {
          if (g.segmentIndex) return h.F(0);
          g.segmentIndex = new Sj();
          return D(h, fs(g, 0), 0);
        });
      });
      if (!g.matchedStreams || !g.matchedStreams.length) return null;
      gs(g, 0, e, f);
      return g;
    }

    function gs(a, b, c, d) {
      for (var e = a.matchedStreams; b < e.length; b++) {
        var f = e[b];
        c(a, f);
        var g = !0;
        "audio" == a.type && 0 == Wb(a.language, f.language) && (g = !1);

        if (g) {
          d[b].delete(f);
          g = new Set(a.codecs.split(","));
          f = t(f.codecs.split(","));

          for (var h = f.next(); !h.done; h = f.next()) g.add(h.value);

          a.codecs = Array.from(g).join(",");
        }
      }
    }

    function Vr(a) {
      var b = Object.assign({}, a);
      b.originalId = null;

      b.createSegmentIndex = function () {
        return Promise.resolve();
      };

      b.closeSegmentIndex = function () {
        b.segmentIndex && (b.segmentIndex.release(), b.segmentIndex = null);
        if (b.matchedStreams) for (var c = t(b.matchedStreams), d = c.next(); !d.done; d = c.next()) d = d.value, d.segmentIndex && (d.segmentIndex.release(), d.segmentIndex = null);
      };

      b.segmentIndex = null;
      b.emsgSchemeIdUris = [];
      b.keyIds = new Set();
      b.closedCaptions = null;
      b.trickModeVideo = null;
      return b;
    }

    function $r(a) {
      a = Object.assign({}, a);
      a.keyIds = new Set();
      a.segments = [];
      a.variantIds = [];
      a.closedCaptions = null;
      return a;
    }

    function Wr(a, b) {
      a.roles = Array.from(new Set(a.roles.concat(b.roles)));
      b.emsgSchemeIdUris && (a.emsgSchemeIdUris = Array.from(new Set(a.emsgSchemeIdUris.concat(b.emsgSchemeIdUris))));

      a.keyIds = function (f, g) {
        return new Set([].concat(w(f), w(g)));
      }(a.keyIds, b.keyIds);

      null == a.originalId ? a.originalId = b.originalId : a.originalId += "," + (b.originalId || "");
      var c = Eh(a.drmInfos, b.drmInfos);
      if (b.drmInfos.length && a.drmInfos.length && !c.length) throw new P(2, 4, 4038);
      a.drmInfos = c;
      a.encrypted = a.encrypted || b.encrypted;

      if (b.closedCaptions) {
        a.closedCaptions || (a.closedCaptions = new Map());
        c = t(b.closedCaptions);

        for (var d = c.next(); !d.done; d = c.next()) {
          var e = t(d.value);
          d = e.next().value;
          e = e.next().value;
          a.closedCaptions.set(d, e);
        }
      }

      b.trickModeVideo ? (a.trickModeVideo || (a.trickModeVideo = Vr(b.trickModeVideo), a.trickModeVideo.createSegmentIndex = function () {
        a.trickModeVideo.segmentIndex = a.segmentIndex.clone();
        return Promise.resolve();
      }), Wr(a.trickModeVideo, b.trickModeVideo)) : a.trickModeVideo && Wr(a.trickModeVideo, b);
    }

    function as(a, b) {
      a.roles = Array.from(new Set(a.roles.concat(b.roles)));
      var c = b.keyIds;
      c = new Set([].concat(w(a.keyIds), w(c)));
      a.keyIds = c;
      a.encrypted = a.encrypted && b.encrypted;
      a.segments.push.apply(a.segments, w(b.segments));
      if (b.closedCaptions) for (a.closedCaptions || (a.closedCaptions = new Map()), b = t(b.closedCaptions), c = b.next(); !c.done; c = b.next()) {
        var d = t(c.value);
        c = d.next().value;
        d = d.next().value;
        a.closedCaptions.set(c, d);
      }
    }

    function es(a, b, c) {
      var d = [];
      b = t(b);

      for (var e = b.next(); !e.done; e = b.next()) {
        e = hs(a, e.value, c);
        if (!e) return;
        d.push(e);
      }

      c.matchedStreams = d;
    }

    function hs(a, b, c) {
      var d = {
        audio: function (h, k) {
          return ds(a, h, k);
        },
        video: function (h, k) {
          return ds(a, h, k);
        },
        text: is,
        image: js
      }[c.type],
          e = {
        audio: ks,
        video: ls,
        text: ms,
        image: ns
      }[c.type],
          f = null;
      b = t(b);

      for (var g = b.next(); !g.done; g = b.next()) g = g.value, !d(c, g) || f && !e(c, f, g) || (f = g);

      return f;
    }

    function os(a, b) {
      function c(d) {
        if (!ps.has(d)) {
          var e = ld(d);
          ps.set(d, e);
        }

        return ps.get(d);
      }

      return a.mimeType != b.mimeType ? !1 : c(a.codecs) == c(b.codecs);
    }

    function ds(a, b, c) {
      return !os(b, c) && !a.m || b.drmInfos && !Dh(b.drmInfos, c.drmInfos) ? !1 : !0;
    }

    function is(a, b) {
      return a.language ? b.language ? 0 == Wb(a.language, b.language) || b.kind != a.kind ? !1 : !0 : !0 : !1;
    }

    function js(a) {
      return a.tilesLayout ? !0 : !1;
    }

    function ks(a, b, c) {
      if (a.id == c.id) return !0;
      var d = os(a, b),
          e = os(a, c);
      if (d && !e) return !1;
      if (!d && e) return !0;
      d = Wb(a.language, b.language);
      e = Wb(a.language, c.language);
      if (e > d) return !0;
      if (e < d) return !1;
      if (a.roles.length) return d = b.roles.filter(function (f) {
        return a.roles.includes(f);
      }), e = c.roles.filter(function (f) {
        return a.roles.includes(f);
      }), e.length > d.length ? !0 : e.length < d.length ? !1 : c.roles.length < b.roles.length;
      if (!c.roles.length && b.roles.length) return !0;
      if (c.roles.length && !b.roles.length) return !1;
      if (!b.primary && c.primary) return !0;
      if (b.primary && !c.primary) return !1;
      d = qs(a.channelsCount, b.channelsCount, c.channelsCount);
      if (d == rs) return !0;
      if (d == ss) return !1;
      d = qs(a.audioSamplingRate, b.audioSamplingRate, c.audioSamplingRate);
      return d == rs ? !0 : d == ss ? !1 : a.bandwidth && ts(a.bandwidth, b.bandwidth, c.bandwidth) == rs ? !0 : !1;
    }

    function ls(a, b, c) {
      if (a.id == c.id) return !0;
      var d = os(a, b),
          e = os(a, c);
      if (d && !e) return !1;
      if (!d && e) return !0;
      d = qs(a.width * a.height, b.width * b.height, c.width * c.height);
      if (d == rs) return !0;
      if (d == ss) return !1;

      if (a.frameRate) {
        d = qs(a.frameRate, b.frameRate, c.frameRate);
        if (d == rs) return !0;
        if (d == ss) return !1;
      }

      return a.bandwidth && ts(a.bandwidth, b.bandwidth, c.bandwidth) == rs ? !0 : !1;
    }

    function ms(a, b, c) {
      if (a.id == c.id) return !0;
      var d = Wb(a.language, b.language),
          e = Wb(a.language, c.language);
      if (e > d) return !0;
      if (e < d) return !1;
      if (!b.primary && c.primary) return !0;
      if (b.primary && !c.primary) return !1;

      if (a.roles.length) {
        d = b.roles.filter(function (f) {
          return a.roles.includes(f);
        });
        e = c.roles.filter(function (f) {
          return a.roles.includes(f);
        });
        if (e.length > d.length) return !0;
        if (e.length < d.length) return !1;
      } else {
        if (!c.roles.length && b.roles.length) return !0;
        if (c.roles.length && !b.roles.length) return !1;
      }

      return c.mimeType != a.mimeType || c.codecs != a.codecs || b.mimeType == a.mimeType && b.codecs == a.codecs ? !1 : !0;
    }

    function ns(a, b, c) {
      return a.id == c.id ? !0 : qs(a.width * a.height, b.width * b.height, c.width * c.height) == rs ? !0 : !1;
    }

    function Zr(a) {
      return {
        id: 0,
        originalId: "",
        groupId: null,
        primary: !1,
        type: a,
        mimeType: "",
        codecs: "",
        language: "",
        originalLanguage: null,
        label: null,
        width: null,
        height: null,
        encrypted: !1,
        keyIds: new Set(),
        segments: [],
        variantIds: [],
        roles: [],
        forced: !1,
        channelsCount: null,
        audioSamplingRate: null,
        spatialAudio: !1,
        closedCaptions: null,
        external: !1,
        fastSwitching: !1
      };
    }

    function Rr(a) {
      return {
        id: 0,
        originalId: "",
        groupId: null,
        createSegmentIndex: function () {
          return Promise.resolve();
        },
        segmentIndex: new Oj([]),
        mimeType: "",
        codecs: "",
        encrypted: !1,
        drmInfos: [],
        keyIds: new Set(),
        language: "",
        originalLanguage: null,
        label: null,
        type: a,
        primary: !1,
        trickModeVideo: null,
        emsgSchemeIdUris: null,
        roles: [],
        forced: !1,
        channelsCount: null,
        audioSamplingRate: null,
        spatialAudio: !1,
        closedCaptions: null,
        accessibilityPurpose: null,
        external: !1,
        fastSwitching: !1
      };
    }

    function qs(a, b, c) {
      if (b == a && a != c) return ss;
      if (c == a && a != b) return rs;

      if (b > a) {
        if (c <= a || c - a < b - a) return rs;
        if (c - a > b - a) return ss;
      } else {
        if (c > a) return ss;
        if (a - c < a - b) return rs;
        if (a - c > a - b) return ss;
      }

      return us;
    }

    function ts(a, b, c) {
      b = Math.abs(a - b);
      a = Math.abs(a - c);
      return a < b ? rs : b < a ? ss : us;
    }

    M("shaka.util.PeriodCombiner", Pr);
    Pr.prototype.combinePeriods = Pr.prototype.Dg;
    Pr.prototype.getImageStreams = Pr.prototype.Wh;
    Pr.prototype.getTextStreams = Pr.prototype.Cf;
    Pr.prototype.getVariants = Pr.prototype.pi;
    var rs = 1,
        us = 0,
        ss = -1,
        ps = new Map();

    function vs() {
      var a = this;
      this.i = this.h = null;
      this.s = [];
      this.j = null;
      this.K = 1;
      this.m = {};
      this.M = {};
      this.l = new Pr();
      this.H = 0;
      this.J = new cc(5);
      this.I = new Fd(function () {
        ws(a);
      });
      this.G = new tf();
      this.C = null;
      this.L = [];
      this.D = Infinity;
      this.u = !1;
      this.g = null;
    }

    p = vs.prototype;

    p.configure = function (a) {
      this.h = a;
      this.g && this.g.configure(this.h);
      this.l && (this.l.m = this.h.dash.multiTypeVariantsAllowed && hc());
    };

    p.start = function (a, b) {
      var c = this,
          d;
      return K(function (e) {
        if (1 == e.g) return c.u = b.isLowLatencyMode(), c.s = [a], c.i = b, D(e, xs(c), 2);
        d = e.h;
        c.i && ys(c, d);
        if (!c.i) throw new P(2, 7, 7001);
        return e.return(c.j);
      });
    };

    p.stop = function () {
      for (var a = t(Object.values(this.m)), b = a.next(); !b.done; b = a.next()) b = b.value, b.segmentIndex && b.segmentIndex.release();

      this.l && this.l.release();
      this.h = this.i = null;
      this.s = [];
      this.j = null;
      this.m = {};
      this.l = null;
      null != this.I && (this.I.stop(), this.I = null);
      this.g && this.g.destroy();
      return this.G.destroy();
    };

    p.update = function () {
      var a = this,
          b;
      return K(function (c) {
        if (1 == c.g) return ta(c, 2), D(c, xs(a), 4);
        if (2 != c.g) return va(c, 0);
        b = wa(c);
        if (!a.i || !b) return c.return();
        a.i.onError(b);
        F(c);
      });
    };

    p.onExpirationUpdated = function () {};

    p.onInitialVariantChosen = function (a) {
      if (this.j && this.j.presentationTimeline.S()) {
        var b = a.video || a.audio;

        if (b && b.segmentIndex) {
          a = this.j.presentationTimeline.Vb();
          var c = b.segmentIndex.find(a);
          null != c && (b = b.segmentIndex.get(c)) && (this.H = b.endTime - a, ys(this, 0));
        }
      }
    };

    p.banLocation = function (a) {
      this.g && this.g.i.set(a, Date.now() + 6E4);
    };

    function xs(a) {
      var b, c, d, e, f, g, h;
      return K(function (k) {
        if (1 == k.g) return b = a.s, 1 < a.s.length && a.g && (c = Or(a.g, "Location", !0), c.length && (b = c)), d = zf(b, a.h.retryParameters), e = Date.now(), D(k, zs(a, d, 0, {
          type: 4
        }), 2);

        if (3 != k.g) {
          f = k.h;
          if (!a.i) return k.return(0);
          f.uri && f.uri != f.originalUri && !a.s.includes(f.uri) && a.s.unshift(f.uri);
          return D(k, As(a, f.data, f.uri), 3);
        }

        g = Date.now();
        h = (g - e) / 1E3;
        a.J.sample(1, h);
        return k.return(h);
      });
    }

    function As(a, b, c) {
      var d, e, f, g, h;
      return K(function (k) {
        if (1 == k.g) {
          d = Rg(b, "MPD");
          if (!d) throw new P(2, 4, 4001, c);
          if (e = a.h.dash.disableXlinkProcessing) return k.return(Bs(a, d, c));
          f = a.h.dash.xlinkFailGracefully;
          g = br(d, a.h.retryParameters, f, c, a.i.networkingEngine);
          uf(a.G, g);
          return D(k, g.promise, 2);
        }

        h = k.h;
        return k.return(Bs(a, h, c));
      });
    }

    function Bs(a, b, c) {
      var d, e, f, g, h, k, l, m, n, r, q, u, v, y, z, x, B, A, C, E, H, G, I, J, L, O, Q, V, U, oa, la, Qa, Xa, qb, lb, wb, Aa, ib, rb, Eb, cb, xb, Ud, wd, Vd, Dc, Wd, hi, Ye, Xd, Lc, jd, kg, lg, sl, Sr, Tr;
      return K(function (kd) {
        switch (kd.g) {
          case 1:
            (d = a.h.dash.manifestPreprocessor) && d(b);
            a.g && a.g.l.clear();
            e = [c];
            f = [];
            g = new Map();
            h = xg(b, "Location");
            k = t(h);

            for (l = k.next(); !l.done; l = k.next()) if (m = l.value, n = m.getAttribute("serviceLocation"), r = Dg(m)) q = Hb(e, [r])[0], n && (a.g ? Nr(a.g, "Location", n, q) : g.set(n, q)), f.push(q);

            a.g ? (u = Or(a.g, "Location", !0), 0 < u.length && (e = a.s = u)) : f.length && (e = a.s = f);
            v = Promise.resolve();

            if ((y = wg(b, "ContentSteering")) && a.i) {
              z = y.getAttribute("defaultServiceLocation");
              if (a.g) a.g.j = e, a.g.h = z;else if (a.g = new Jr(a.i), a.g.configure(a.h), a.g.setManifestType("DASH"), a.g.j = e, a.g.h = z, x = Dg(y)) (B = Fg(y, "queryBeforeStart", Ng, !1)) ? v = Kr(a.g, x) : Kr(a.g, x);
              A = t(g.keys());

              for (C = A.next(); !C.done; C = A.next()) E = C.value, H = g.get(E), Nr(a.g, "Location", E, H);
            }

            G = xg(b, "BaseURL");
            J = !1;
            if (a.g) for (L = t(G), O = L.next(); !O.done; O = L.next()) Q = O.value, V = Q.getAttribute("serviceLocation"), U = Dg(Q), V && U && (Nr(a.g, "BaseURL", V, U), J = !0);
            J && a.g || (oa = G.map(Dg), I = Hb(e, oa));

            la = function () {
              return a.g && J ? Or(a.g, "BaseURL") : I ? I : [];
            };

            Qa = 0;
            G && G.length && (Qa = Fg(G[0], "availabilityTimeOffset", Mg) || 0);
            Xa = a.h.dash.ignoreMinBufferTime;
            qb = 0;
            Xa || (qb = Fg(b, "minBufferTime", Hg) || 0);
            a.H = Fg(b, "minimumUpdatePeriod", Hg, -1);
            lb = Fg(b, "availabilityStartTime", Gg);
            wb = Fg(b, "timeShiftBufferDepth", Hg);
            Aa = a.h.dash.ignoreSuggestedPresentationDelay;
            ib = null;
            Aa || (ib = Fg(b, "suggestedPresentationDelay", Hg));
            rb = a.h.dash.ignoreMaxSegmentDuration;
            Eb = null;
            rb || (Eb = Fg(b, "maxSegmentDuration", Hg));
            cb = b.getAttribute("type") || "static";
            if (a.j) for (xb = a.j.presentationTimeline, Ud = t(Object.values(a.m)), wd = Ud.next(); !wd.done; wd = Ud.next()) Vd = wd.value, Vd.segmentIndex && Vd.segmentIndex.rb(xb.Hb());else Dc = a.h.defaultPresentationDelay || 1.5 * qb, Wd = null != ib ? ib : Dc, xb = new sj(lb, Wd, a.h.dash.autoCorrectDrift);
            xb.Sc("static" == cb);
            (hi = xb.S()) && !isNaN(a.h.availabilityWindowOverride) && (wb = a.h.availabilityWindowOverride);
            null == wb && (wb = Infinity);
            xb.Fe(wb);
            Ye = b.getAttribute("profiles") || "";
            Xd = {
              Rb: "static" != cb,
              presentationTimeline: xb,
              Ia: null,
              ma: null,
              Ca: null,
              P: null,
              bandwidth: 0,
              Rg: !1,
              Dc: Qa,
              profiles: Ye.split(",")
            };
            Lc = Cs(a, Xd, la, b);
            jd = Lc.duration;
            kg = Lc.periods;
            "static" != cb && Lc.Ig || xb.bb(jd || Infinity);
            a.D && !a.u && (lg = a.i.isAutoLowLatencyMode()) && (a.i.enableLowLatencyMode(), a.u = a.i.isLowLatencyMode());
            a.u ? xb.fh(a.D) : a.D && Ua("Low-latency DASH live stream detected, but low-latency streaming mode is not enabled in Shaka Player. Set streaming.lowLatencyMode configuration to true, and see https://bit.ly/3clctcj for details.");
            xb.Qf(Eb || 1);
            return D(kd, a.l.Dg(kg, Xd.Rb), 2);

          case 2:
            return D(kd, v, 3);

          case 3:
            a.u && (qb = 0);

            if (a.j) {
              a.j.variants = a.l.j;
              sl = a.l.Cf();
              0 < sl.length && (a.j.textStreams = sl);
              a.j.imageStreams = a.l.i;
              a.i.filter(a.j);
              kd.F(4);
              break;
            }

            a.j = {
              presentationTimeline: xb,
              variants: a.l.j,
              textStreams: a.l.Cf(),
              imageStreams: a.l.i,
              offlineSessionIds: [],
              minBufferTime: qb || 0,
              sequenceMode: a.h.dash.sequenceMode,
              ignoreManifestTimestampsInSegmentsMode: !1,
              type: "DASH",
              serviceDescription: Ds(b)
            };

            if (!xb.qh()) {
              kd.F(5);
              break;
            }

            Sr = xg(b, "UTCTiming");
            return D(kd, Es(a, la, Sr), 6);

          case 6:
            Tr = kd.h;
            if (!a.i) return kd.return();
            xb.gh(Tr);

          case 5:
            xb.oe();

          case 4:
            a.i.makeTextStreamsForClosedCaptions(a.j), F(kd);
        }
      });
    }

    function Ds(a) {
      a = wg(a, "ServiceDescription");
      if (!a) return null;
      var b = wg(a, "Latency"),
          c = wg(a, "PlaybackRate");

      if (b && b.getAttribute("max") || c) {
        a = b && b.getAttribute("max") ? parseInt(b.getAttribute("max"), 10) / 1E3 : null;
        var d = c ? parseFloat(c.getAttribute("max")) : null;
        b = b && b.getAttribute("min") ? parseInt(b.getAttribute("min"), 10) / 1E3 : null;
        c = c ? parseFloat(c.getAttribute("min")) : null;
        return {
          maxLatency: a,
          maxPlaybackRate: d,
          minLatency: b,
          minPlaybackRate: c
        };
      }

      return null;
    }

    function Cs(a, b, c, d) {
      var e = Fg(d, "mediaPresentationDuration", Hg),
          f = [],
          g = 0;
      d = xg(d, "Period");

      for (var h = 0; h < d.length; h++) {
        var k = d[h],
            l = d[h + 1],
            m = Fg(k, "start", Hg, g),
            n = k.id,
            r = Fg(k, "duration", Hg),
            q = null;

        if (l) {
          var u = Fg(l, "start", Hg);
          null != u && (q = u - m);
        } else null != e && (q = e - m);

        null == q && (q = r);

        if (!(null !== a.C && null !== n && null !== m && m < a.C) || a.L.includes(n) || h + 1 == d.length) {
          null !== m && (null === a.C || m > a.C) && (a.C = m);
          g = Fs(a, b, c, {
            start: m,
            duration: q,
            node: k,
            Ff: null == q || !l
          });
          f.push(g);
          b.Ia.id && q && (a.M[b.Ia.id] = q);

          if (null == q) {
            g = null;
            break;
          }

          g = m + q;
        }
      }

      a.L = f.map(function (v) {
        return v.id;
      });
      return null != e ? {
        periods: f,
        duration: e,
        Ig: !1
      } : {
        periods: f,
        duration: g,
        Ig: !0
      };
    }

    function Fs(a, b, c, d) {
      b.Ia = Gs(a, d.node, null, c);
      b.ma = d;
      b.Ia.Dc = b.Dc;
      b.Ia.id || (b.Ia.id = "__shaka_period_" + d.start);
      var e = xg(d.node, "EventStream");
      c = b.presentationTimeline.Hb();
      e = t(e);

      for (var f = e.next(); !f.done; f = e.next()) Hs(a, d.start, d.duration, f.value, c);

      c = xg(d.node, "AdaptationSet").map(function (m) {
        return Is(a, b, m);
      }).filter(Bd);

      if (b.Rb) {
        d = [];
        e = t(c);

        for (f = e.next(); !f.done; f = e.next()) {
          f = t(f.value.Xi);

          for (var g = f.next(); !g.done; g = f.next()) d.push(g.value);
        }

        if (d.length != new Set(d).size) throw new P(2, 4, 4018);
      }

      d = c.filter(function (m) {
        return !m.qg;
      });
      c = c.filter(function (m) {
        return m.qg;
      });
      c = t(c);

      for (e = c.next(); !e.done; e = c.next()) {
        e = e.value;
        f = e.qg.split(" ");
        g = t(d);

        for (var h = g.next(); !h.done; h = g.next()) {
          var k = h.value;

          if (f.includes(k.id)) {
            h = {};
            k = t(k.streams);

            for (var l = k.next(); !l.done; h = {
              Td: h.Td
            }, l = k.next()) h.Td = l.value, h.Td.trickModeVideo = e.streams.find(function (m) {
              return function (n) {
                return ld(m.Td.codecs) == ld(n.codecs);
              };
            }(h));
          }
        }
      }

      c = Js(a.h.disableAudio, d, "audio");
      e = Js(a.h.disableVideo, d, "video");
      f = Js(a.h.disableText, d, Mb);
      d = Js(a.h.disableThumbnails, d, "image");
      if (0 === e.length && 0 === c.length) throw new P(2, 4, 4004);
      return {
        id: b.Ia.id,
        audioStreams: c,
        videoStreams: e,
        textStreams: f,
        imageStreams: d
      };
    }

    function Js(a, b, c) {
      return a || !b.length ? [] : b.reduce(function (d, e) {
        if (e.contentType != c) return d;
        d.push.apply(d, w(e.streams));
        return d;
      }, []);
    }

    function Is(a, b, c) {
      function d(G) {
        switch (G) {
          case 1:
          case 6:
          case 13:
          case 14:
          case 15:
            return "SDR";

          case 16:
            return "PQ";

          case 18:
            return "HLG";
        }
      }

      b.Ca = Gs(a, c, b.Ia, null);
      var e = !1,
          f = xg(c, "Role"),
          g = f.map(function (G) {
        return G.getAttribute("value");
      }).filter(Bd),
          h = void 0,
          k = b.Ca.contentType == Mb;
      k && (h = "subtitle");
      f = t(f);

      for (var l = f.next(); !l.done; l = f.next()) {
        l = l.value;
        var m = l.getAttribute("schemeIdUri");
        if (null == m || "urn:mpeg:dash:role:2011" == m) switch (l = l.getAttribute("value"), l) {
          case "main":
            e = !0;
            break;

          case "caption":
          case "subtitle":
            h = l;
        }
      }

      var n;
      m = xg(c, "EssentialProperty");
      f = null;
      var r = !1;
      l = !1;
      m = t(m);

      for (var q = m.next(); !q.done; q = m.next()) {
        q = q.value;
        var u = q.getAttribute("schemeIdUri");
        "http://dashif.org/guidelines/trickmode" == u ? f = q.getAttribute("value") : "urn:mpeg:mpegB:cicp:TransferCharacteristics" == u ? n = d(parseInt(q.getAttribute("value"), 10)) : "urn:mpeg:mpegB:cicp:ColourPrimaries" != u && "urn:mpeg:mpegB:cicp:MatrixCoefficients" != u && ("urn:mpeg:dash:ssr:2023" == u ? r = !0 : l = !0);
      }

      m = xg(c, "SupplementalProperty");
      m = t(m);

      for (q = m.next(); !q.done; q = m.next()) q = q.value, "urn:mpeg:mpegB:cicp:TransferCharacteristics" == q.getAttribute("schemeIdUri") && (n = d(parseInt(q.getAttribute("value"), 10)));

      m = xg(c, "Accessibility");
      var v = new Map(),
          y;
      m = t(m);

      for (q = m.next(); !q.done; q = m.next()) if (u = q.value, q = u.getAttribute("schemeIdUri"), u = u.getAttribute("value"), "urn:scte:dash:cc:cea-608:2015" == q) {
        if (q = 1, null != u) {
          u = u.split(";");

          for (var z = t(u), x = z.next(); !x.done; x = z.next()) {
            var B = x.value,
                A = x = void 0;
            B.includes("=") ? (B = B.split("="), x = B[0].startsWith("CC") ? B[0] : "CC" + B[0], A = B[1] || "und") : (x = "CC" + q, 2 == u.length ? q += 2 : q++, A = B);
            v.set(x, Qb(A));
          }
        } else v.set("CC1", "und");
      } else if ("urn:scte:dash:cc:cea-708:2015" == q) {
        if (q = 1, null != u) for (u = t(u.split(";")), x = u.next(); !x.done; x = u.next()) x = x.value, B = z = void 0, x.includes("=") ? (x = x.split("="), z = "svc" + x[0], B = x[1].split(",")[0].split(":").pop()) : (z = "svc" + q, q++, B = x), v.set(z, Qb(B));else v.set("svc1", "und");
      } else "urn:mpeg:dash:role:2011" == q ? null != u && (g.push(u), "captions" == u && (h = "caption")) : "urn:tva:metadata:cs:AudioPurposeCS:2007" == q && ("1" == u ? y = "visually impaired" : "2" == u && (y = "hard of hearing"));

      if (l) return null;
      l = xg(c, "ContentProtection");
      var C = Lq(l, a.h.dash.ignoreDrmInfo, a.h.dash.keySystemsByURI),
          E = Qb(b.Ca.language || "und"),
          H = c.getAttribute("label");
      (l = xg(c, "Label")) && l.length && (l = l[0], l.textContent && (H = l.textContent));
      l = xg(c, "Representation");
      c = l.map(function (G) {
        if (G = Ks(a, b, C, h, E, H, e, g, v, G, y)) G.hdr = G.hdr || n, G.fastSwitching = r;
        return G;
      }).filter(function (G) {
        return !!G;
      });

      if (0 == c.length) {
        f = "image" == b.Ca.contentType;
        if (a.h.dash.ignoreEmptyAdaptationSet || k || f) return null;
        throw new P(2, 4, 4003);
      }

      if (!b.Ca.contentType || "application" == b.Ca.contentType) for (b.Ca.contentType = Ls(c[0].mimeType, c[0].codecs), k = t(c), q = k.next(); !q.done; q = k.next()) q.value.type = b.Ca.contentType;
      k = b.Ca.id || "__fake__" + a.K++;
      m = t(c);

      for (q = m.next(); !q.done; q = m.next()) {
        q = q.value;
        u = t(C.drmInfos);

        for (z = u.next(); !z.done; z = u.next()) z = z.value, z.keyIds = z.keyIds && q.keyIds ? new Set([].concat(w(z.keyIds), w(q.keyIds))) : z.keyIds || q.keyIds;

        a.h.dash.enableAudioGroups && (q.groupId = k);
      }

      l = l.map(function (G) {
        return G.getAttribute("id");
      }).filter(Bd);
      return {
        id: k,
        contentType: b.Ca.contentType,
        language: E,
        ik: e,
        streams: c,
        drmInfos: C.drmInfos,
        qg: f,
        Xi: l
      };
    }

    function Ks(a, b, c, d, e, f, g, h, k, l, m) {
      b.P = Gs(a, l, b.Ca, null);
      a.D = Math.min(a.D, b.P.Dc);
      if (!Ms(b.P)) return null;
      var n = b.ma.start;
      b.bandwidth = Fg(l, "bandwidth", Kg) || 0;
      var r = b.P.contentType,
          q = r == Mb || "application" == r;
      r = "image" == r;

      try {
        var u = void 0;

        if (c.We) {
          var v = b.P.sb,
              y = Hb(v(), [c.We.Gi]),
              z = zf(y, a.h.retryParameters);
          u = {
            method: "AES-128",
            iv: c.We.iv,
            firstMediaSequenceNumber: 0,
            fetchKey: function () {
              var I, J, L;
              return K(function (O) {
                if (1 == O.g) return D(O, zs(a, z, 6), 2);

                if (3 != O.g) {
                  I = O.h;
                  if (!I.data || 16 != I.data.byteLength) throw new P(2, 4, 4049);
                  J = {
                    name: "AES-CBC"
                  };
                  L = u;
                  return D(O, window.crypto.subtle.importKey("raw", I.data, J, !0, ["decrypt"]), 3);
                }

                L.cryptoKey = O.h;
                u.fetchKey = void 0;
                F(O);
              });
            }
          };
        }

        v = function (I, J, L, O) {
          return Ns(a, I, J, L, O);
        };

        if (b.P.Id) var x = or(b, v, u);else if (b.P.ac) x = ur(b, a.m, u);else if (b.P.Jd) x = zr(b, v, a.m, !!a.j, a.h.dash.initialSegmentLimit, a.M, u);else {
          var B = b.ma.duration || 0,
              A = b.P.sb;
          x = {
            Gc: function () {
              return Promise.resolve(Rj(n, B, A()));
            }
          };
        }
      } catch (I) {
        if ((q || r) && 4002 == I.code) return null;
        throw I;
      }

      v = xg(l, "ContentProtection");
      v = Pq(v, c, a.h.dash.ignoreDrmInfo, a.h.dash.keySystemsByURI);
      v = new Set(v ? [v] : []);
      y = !1;
      xg(l, "SupplementalProperty").some(function (I) {
        return "tag:dolby.com,2018:dash:EC3_ExtensionType:2018" == I.getAttribute("schemeIdUri") && "JOC" == I.getAttribute("value");
      }) && (y = !0);
      var C = !1;
      q && (C = h.includes("forced_subtitle") || h.includes("forced-subtitle"));
      var E;
      if (r && ((l = xg(l, "EssentialProperty").find(function (I) {
        return ["http://dashif.org/thumbnail_tile", "http://dashif.org/guidelines/thumbnail_tile"].includes(I.getAttribute("schemeIdUri"));
      })) && (E = l.getAttribute("value")), !E)) return null;
      var H;
      l = b.P.codecs;
      b.profiles.includes("http://dashif.org/guidelines/dash-if-uhd#hevc-hdr-pq10") && (l.includes("hvc1.2.4.L153.B0") || l.includes("hev1.2.4.L153.B0")) && (H = "PQ");
      l = b.P.id ? b.Ia.id + "," + b.P.id : "";
      var G = l && a.m[l] ? a.m[l] : {
        id: a.K++,
        originalId: b.P.id,
        groupId: null,
        createSegmentIndex: function () {
          return Promise.resolve();
        },
        closeSegmentIndex: function () {
          G.segmentIndex && (G.segmentIndex.release(), G.segmentIndex = null);
        },
        segmentIndex: null,
        mimeType: b.P.mimeType,
        codecs: b.P.codecs,
        frameRate: b.P.frameRate,
        pixelAspectRatio: b.P.pixelAspectRatio,
        bandwidth: b.bandwidth,
        width: b.P.width,
        height: b.P.height,
        kind: d,
        encrypted: 0 < c.drmInfos.length,
        drmInfos: c.drmInfos,
        keyIds: v,
        language: e,
        originalLanguage: b.Ca.language,
        label: f,
        type: b.Ca.contentType,
        primary: g,
        trickModeVideo: null,
        emsgSchemeIdUris: b.P.emsgSchemeIdUris,
        roles: h,
        forced: C,
        channelsCount: b.P.xe,
        audioSamplingRate: b.P.audioSamplingRate,
        spatialAudio: y,
        closedCaptions: k,
        hdr: H,
        videoLayout: void 0,
        tilesLayout: E,
        matchedStreams: [],
        accessibilityPurpose: m,
        external: !1,
        fastSwitching: !1
      };

      G.createSegmentIndex = function () {
        var I;
        return K(function (J) {
          if (1 == J.g) {
            if (G.segmentIndex) return J.F(0);
            I = G;
            return D(J, x.Gc(), 3);
          }

          I.segmentIndex = J.h;
          F(J);
        });
      };

      l && b.Rb && !a.m[l] && (a.m[l] = G);
      return G;
    }

    function ws(a) {
      var b, c;
      K(function (d) {
        switch (d.g) {
          case 1:
            return b = 0, ta(d, 2), D(d, xs(a), 4);

          case 4:
            b = d.h;
            va(d, 3);
            break;

          case 2:
            if (c = wa(d), a.i) {
              if (a.h.raiseFatalErrorOnManifestUpdateRequestFailure) return a.i.onError(c), d.return();
              c.severity = 1;
              a.i.onError(c);
            }

          case 3:
            if (!a.i) return d.return();
            a.i.onManifestUpdated();
            ys(a, b);
            F(d);
        }
      });
    }

    function ys(a, b) {
      0 >= a.H || a.I.R(Math.max(a.H - b, dc(a.J)));
    }

    function Gs(a, b, c, d) {
      c = c || {
        contentType: "",
        mimeType: "",
        codecs: "",
        emsgSchemeIdUris: [],
        frameRate: void 0,
        pixelAspectRatio: void 0,
        xe: null,
        audioSamplingRate: null,
        Dc: 0,
        dg: 0
      };
      d = d || c.sb;
      var e = b.getAttribute("id"),
          f = xg(b, "BaseURL"),
          g,
          h = !1;
      if (a.g) for (var k = t(f), l = k.next(); !l.done; l = k.next()) {
        var m = l.value;
        l = m.getAttribute("serviceLocation");
        m = Dg(m);
        l && m && (Nr(a.g, e, l, m), h = !0);
      }
      h && a.g || (g = f.map(Dg));
      k = b.getAttribute("contentType") || c.contentType;
      l = b.getAttribute("mimeType") || c.mimeType;
      m = b.getAttribute("codecs") || c.codecs;
      var n = Fg(b, "frameRate", Og) || c.frameRate,
          r = b.getAttribute("sar") || c.pixelAspectRatio,
          q = Os(xg(b, "InbandEventStream"), c.emsgSchemeIdUris),
          u = xg(b, "AudioChannelConfiguration");
      u = Ps(u) || c.xe;
      var v = Fg(b, "audioSamplingRate", Lg) || c.audioSamplingRate;
      k || (k = Ls(l, m));
      var y = wg(b, "SegmentBase"),
          z = wg(b, "SegmentTemplate"),
          x = y ? Fg(y, "availabilityTimeOffset", Mg) || 0 : 0,
          B = z ? Fg(z, "availabilityTimeOffset", Mg) || 0 : 0,
          A = f && f.length ? Fg(f[0], "availabilityTimeOffset", Mg) || 0 : 0;
      x = c.Dc + A + x + B;
      B = null;
      (A = wg(b, "SegmentSequenceProperties")) && (A = wg(A, "SAP")) && (B = Fg(A, "cadence", Jg));
      return {
        sb: function () {
          return Hb(d(), f.length ? a.g && h ? Or(a.g, e) : g ? g : [] : []);
        },
        Id: y || c.Id,
        ac: wg(b, "SegmentList") || c.ac,
        Jd: z || c.Jd,
        width: Fg(b, "width", Lg) || c.width,
        height: Fg(b, "height", Lg) || c.height,
        contentType: k,
        mimeType: l,
        codecs: m,
        frameRate: n,
        pixelAspectRatio: r,
        emsgSchemeIdUris: q,
        id: e,
        language: b.getAttribute("lang"),
        xe: u,
        audioSamplingRate: v,
        Dc: x,
        dg: B || c.dg
      };
    }

    function Os(a, b) {
      b = b.slice();
      a = t(a);

      for (var c = a.next(); !c.done; c = a.next()) c = c.value.getAttribute("schemeIdUri"), b.includes(c) || b.push(c);

      return b;
    }

    function Ps(a) {
      a = t(a);

      for (var b = a.next(); !b.done; b = a.next()) {
        var c = b.value;
        if (b = c.getAttribute("schemeIdUri")) if (c = c.getAttribute("value")) switch (b) {
          case "urn:mpeg:dash:outputChannelPositionList:2012":
            return c.trim().split(/ +/).length;

          case "urn:mpeg:dash:23003:3:audio_channel_configuration:2011":
          case "urn:dts:dash:audio_channel_configuration:2012":
            b = parseInt(c, 10);
            if (!b) continue;
            return b;

          case "tag:dolby.com,2014:dash:audio_channel_configuration:2011":
          case "urn:dolby:dash:audio_channel_configuration:2011":
            b = parseInt(c, 16);
            if (!b) continue;

            for (a = 0; b;) b & 1 && ++a, b >>= 1;

            return a;

          case "urn:mpeg:mpegB:cicp:ChannelConfiguration":
            if (b = [0, 1, 2, 3, 4, 5, 6, 8, 2, 3, 4, 7, 8, 24, 8, 12, 10, 12, 14, 12, 14], (c = parseInt(c, 10)) && 0 < c && c < b.length) return b[c];
        }
      }

      return null;
    }

    function Ms(a) {
      var b = a.Id ? 1 : 0;
      b += a.ac ? 1 : 0;
      b += a.Jd ? 1 : 0;
      if (0 == b) return a.contentType == Mb || "application" == a.contentType ? !0 : !1;
      1 != b && (a.Id && (a.ac = null), a.Jd = null);
      return !0;
    }

    function Qs(a, b, c, d) {
      var e, f, g, h, k, l;
      return K(function (m) {
        if (1 == m.g) return e = Hb(b(), [c]), f = zf(e, a.h.retryParameters), f.method = d, g = a.i.networkingEngine.request(4, f), uf(a.G, g), D(m, g.promise, 2);
        h = m.h;

        if ("HEAD" == d) {
          if (!h.headers || !h.headers.date) return m.return(0);
          k = h.headers.date;
        } else k = Tf(h.data);

        l = Date.parse(k);
        return isNaN(l) ? m.return(0) : m.return(l - Date.now());
      });
    }

    function Es(a, b, c) {
      var d, e, f, g, h, k, l, m;
      return K(function (n) {
        switch (n.g) {
          case 1:
            d = c.map(function (r) {
              return {
                scheme: r.getAttribute("schemeIdUri"),
                value: r.getAttribute("value")
              };
            }), e = a.h.dash.clockSyncUri, !d.length && e && d.push({
              scheme: "urn:mpeg:dash:utc:http-head:2014",
              value: e
            }), f = t(d), g = f.next();

          case 2:
            if (g.done) {
              n.F(4);
              break;
            }

            h = g.value;
            ta(n, 5);
            k = h.scheme;
            l = h.value;

            switch (k) {
              case "urn:mpeg:dash:utc:http-head:2014":
              case "urn:mpeg:dash:utc:http-head:2012":
                return n.F(7);

              case "urn:mpeg:dash:utc:http-xsdate:2014":
              case "urn:mpeg:dash:utc:http-iso:2014":
              case "urn:mpeg:dash:utc:http-xsdate:2012":
              case "urn:mpeg:dash:utc:http-iso:2012":
                return n.F(8);

              case "urn:mpeg:dash:utc:direct:2014":
              case "urn:mpeg:dash:utc:direct:2012":
                return m = Date.parse(l), n.return(isNaN(m) ? 0 : m - Date.now());

              case "urn:mpeg:dash:utc:http-ntp:2014":
              case "urn:mpeg:dash:utc:ntp:2014":
              case "urn:mpeg:dash:utc:sntp:2014":
                Ua("NTP UTCTiming scheme is not supported");
                break;

              default:
                Ua("Unrecognized scheme in UTCTiming element", k);
            }

            n.F(9);
            break;

          case 7:
            return D(n, Qs(a, b, l, "HEAD"), 10);

          case 10:
            return n.return(n.h);

          case 8:
            return D(n, Qs(a, b, l, "GET"), 11);

          case 11:
            return n.return(n.h);

          case 9:
            va(n, 3);
            break;

          case 5:
            wa(n);

          case 3:
            g = f.next();
            n.F(2);
            break;

          case 4:
            return Ua("A UTCTiming element should always be given in live manifests! This content may not play on clients with bad clocks!"), n.return(0);
        }
      });
    }

    function Hs(a, b, c, d, e) {
      var f = d.getAttribute("schemeIdUri") || "",
          g = d.getAttribute("value") || "",
          h = Fg(d, "timescale", Lg) || 1;
      d = t(xg(d, "Event"));

      for (var k = d.next(); !k.done; k = d.next()) {
        k = k.value;
        var l = Fg(k, "presentationTime", Lg) || 0,
            m = Fg(k, "duration", Lg) || 0;
        l = l / h + b;
        m = l + m / h;
        null != c && (l = Math.min(l, b + c), m = Math.min(m, b + c));
        m < e || (k = {
          schemeIdUri: f,
          value: g,
          startTime: l,
          endTime: m,
          id: k.getAttribute("id") || "",
          eventElement: k
        }, a.i.onTimelineRegionAdded(k));
      }
    }

    function Ns(a, b, c, d, e) {
      var f, g, h, k;
      return K(function (l) {
        if (1 == l.g) return f = Ff, g = e ? 0 : 1, h = ok(b, c, d, a.h.retryParameters), D(l, zs(a, h, f, {
          type: g
        }), 2);
        k = l.h;
        return l.return(k.data);
      });
    }

    function Ls(a, b) {
      b = fd(a, b);
      return rd(b) ? Mb : a.split("/")[0];
    }

    function zs(a, b, c, d) {
      b = a.i.networkingEngine.request(c, b, d);
      uf(a.G, b);
      return b.promise;
    }

    M("shaka.dash.DashParser", vs);

    Ih["application/dash+xml"] = function () {
      return new vs();
    };

    Ih["video/vnd.mpeg.dash.mpd"] = function () {
      return new vs();
    };

    function Rs() {}

    M("shaka.dependencies", Rs);

    Rs.has = function (a) {
      return Ss.has(a);
    };

    Rs.add = function (a, b) {
      if (!Ts[a]) throw Error(a + " is not supported");
      a == Us ? Le("mux.js", "mux.js is no longer used in Shaka Player.") : Ss.set(a, function () {
        return b;
      });
    };

    var Us = "muxjs",
        Ts = {
      jk: Us,
      ISOBoxer: "ISOBoxer"
    };
    Rs.Allowed = Ts;
    var Ss = new Map([["ISOBoxer", function () {
      return window.ISOBoxer;
    }]]);

    function Vs(a, b, c) {
      this.type = a;
      this.g = b;
      this.segments = c || null;
    }

    function Ws(a, b, c, d) {
      this.id = a;
      this.name = b;
      this.g = c;
      this.value = void 0 === d ? null : d;
    }

    Ws.prototype.toString = function (a) {
      function b(e) {
        return e.name + "=" + (isNaN(Number(e.value)) ? '"' + e.value + '"' : e.value);
      }

      var c = "#" + this.name,
          d = this.g ? this.g.filter(function (e) {
        return a ? !a.has(e.name) : !0;
      }).map(b) : [];
      this.value && d.unshift(this.value);
      0 < d.length && (c += ":" + d.join(","));
      return c;
    };

    function Xs(a) {
      var b = new Set().add("AUDIO").add("VIDEO").add("SUBTITLES").add("PATHWAY-ID").add("GROUP-ID").add("URI");
      return a.toString(b);
    }

    Ws.prototype.getAttribute = function (a) {
      var b = this.g.filter(function (c) {
        return c.name == a;
      });
      return b.length ? b[0] : null;
    };

    function Y(a, b, c) {
      return (a = a.getAttribute(b)) ? a.value : c || null;
    }

    function Ys(a, b) {
      a = a.getAttribute(b);
      if (!a) throw new P(2, 4, 4023, b);
      return a.value;
    }

    function Zs(a, b, c) {
      c = void 0 === c ? [] : c;
      this.g = b;
      this.h = a;
      this.ub = c;
    }

    function $s(a, b) {
      this.name = a;
      this.value = b;
    }

    ;

    function at(a, b) {
      return a.filter(function (c) {
        return c.name == b;
      });
    }

    function bt(a, b) {
      return a.filter(function (c) {
        return Ys(c, "TYPE") == b;
      });
    }

    function ct(a, b) {
      a = at(a, b);
      return a.length ? a[0] : null;
    }

    function dt(a, b, c) {
      c = void 0 === c ? 0 : c;
      return (a = ct(a, b)) ? Number(a.value) : c;
    }

    function et(a, b, c) {
      return b ? ft(a, [b], c) : [];
    }

    function ft(a, b, c) {
      if (!b.length) return [];
      b = Hb(a, b);
      a = [];
      b = t(b);

      for (var d = b.next(); !d.done; d = b.next()) {
        var e = a,
            f = e.push;
        var g = d.value;

        if ((d = c) && d.size) {
          g = String(g).replace(/%7B/g, "{").replace(/%7D/g, "}");
          var h = g.match(/{\$\w*}/g);

          if (h) {
            h = t(h);

            for (var k = h.next(); !k.done; k = h.next()) {
              k = k.value;
              var l = k.slice(2, k.length - 1),
                  m = d.get(l);
              if (m) g = g.replace(k, m);else throw new P(2, 4, 4039, l);
            }
          }

          d = g;
        } else d = g;

        f.call(e, d);
      }

      return a;
    }

    ;

    function gt(a) {
      this.h = a || "";
      this.g = 0;
    }

    function ht(a) {
      it(a, /[ \t]+/gm);
    }

    function it(a, b) {
      b.lastIndex = a.g;
      b = b.exec(a.h);
      b = null == b ? null : {
        position: b.index,
        length: b[0].length,
        results: b
      };
      if (a.g == a.h.length || null == b || b.position != a.g) return null;
      a.g += b.length;
      return b.results;
    }

    function jt(a) {
      return a.g == a.h.length ? null : (a = it(a, /[^ \t\n]*/gm)) ? a[0] : null;
    }

    ;

    function kt() {
      this.g = 0;
    }

    function lt(a, b) {
      b = Tf(b);
      b = b.replace(/\r\n|\r(?=[^\n]|$)/gm, "\n").trim();
      var c = b.split(/\n+/m);
      if (!/^#EXTM3U($|[ \t\n])/m.test(c[0])) throw new P(2, 4, 4015);
      b = 0;

      for (var d = !0, e = t(c), f = e.next(); !f.done; f = e.next()) if (f = f.value, /^#(?!EXT)/m.test(f) || d) d = !1;else if (f = mt(a, f), --a.g, nt.includes(f.name)) {
        b = 1;
        break;
      } else "EXT-X-STREAM-INF" == f.name && (d = !0);

      e = [];
      d = !0;

      for (f = 0; f < c.length; f++) {
        var g = c[f],
            h = c[f + 1];
        if (/^#(?!EXT)/m.test(g) || d) d = !1;else {
          g = mt(a, g);

          if (ot.includes(g.name)) {
            if (1 != b) throw new P(2, 4, 4017);
            g = c.splice(f, c.length - f);
            c = [];
            d = [];
            f = [];
            h = null;
            g = t(g);

            for (var k = g.next(); !k.done; k = g.next()) k = k.value, /^(#EXT)/.test(k) ? (k = mt(a, k), nt.includes(k.name) ? e.push(k) : "EXT-X-MAP" == k.name ? h = k : "EXT-X-PART" == k.name ? f.push(k) : "EXT-X-PRELOAD-HINT" == k.name ? "PART" == Y(k, "TYPE") ? f.push(k) : "MAP" == Y(k, "TYPE") && (k.name = "EXT-X-MAP", h = k) : d.push(k)) : /^#(?!EXT)/m.test(k) || (k = k.trim(), h && d.push(h), c.push(new Zs(k, d, f)), d = [], f = []);

            f.length && (h && d.push(h), c.push(new Zs("", d, f)));
            return new Vs(b, e, c);
          }

          e.push(g);
          "EXT-X-STREAM-INF" == g.name && (g.g.push(new $s("URI", h)), d = !0);
        }
      }

      return new Vs(b, e);
    }

    function mt(a, b) {
      a = a.g++;
      var c = b.match(/^#(EXT[^:]*)(?::(.*))?$/);
      if (!c) throw new P(2, 4, 4016, b);
      b = c[1];
      var d = c[2];
      c = [];
      var e;

      if (d) {
        d = new gt(d);
        var f;
        (f = it(d, /^([^,=]+)(?:,|$)/g)) && (e = f[1]);

        for (var g = /([^=]+)=(?:"([^"]*)"|([^",]*))(?:,|$)/g; f = it(d, g);) c.push(new $s(f[1], f[2] || f[3])), ht(d);
      }

      return new Ws(a, b, c, e);
    }

    var nt = "EXT-X-TARGETDURATION EXT-X-MEDIA-SEQUENCE EXT-X-DISCONTINUITY-SEQUENCE EXT-X-PLAYLIST-TYPE EXT-X-I-FRAMES-ONLY EXT-X-ENDLIST EXT-X-SERVER-CONTROL EXT-X-SKIP EXT-X-PART-INF".split(" "),
        ot = "EXTINF EXT-X-BYTERANGE EXT-X-DISCONTINUITY EXT-X-PROGRAM-DATE-TIME EXT-X-KEY EXT-X-DATERANGE EXT-X-MAP".split(" ");

    function pt() {}

    function qt(a) {
      try {
        var b = rt(a);
        return pf({
          uri: a,
          originalUri: a,
          data: b.data,
          headers: {
            "content-type": b.contentType
          }
        });
      } catch (c) {
        return nf(c);
      }
    }

    function rt(a) {
      var b = a.split(":");
      if (2 > b.length || "data" != b[0]) throw new P(2, 1, 1004, a);
      b = b.slice(1).join(":").split(",");
      if (2 > b.length) throw new P(2, 1, 1004, a);
      var c = b[0];
      a = window.decodeURIComponent(b.slice(1).join(","));
      b = c.split(";");
      c = b[0];
      var d = !1;
      1 < b.length && "base64" == b[b.length - 1] && (d = !0, b.pop());
      var e;
      d ? e = qg(a) : e = Xf(a);
      return {
        data: e,
        contentType: c
      };
    }

    M("shaka.net.DataUriPlugin", pt);
    pt.parse = qt;
    wf("data", qt);

    function st(a) {
      var b = od(a),
          c = b.split("/")[0];
      a = pd(a);
      return {
        type: c,
        mimeType: b,
        codecs: a,
        language: null,
        height: null,
        width: null,
        channelCount: null,
        sampleRate: null,
        closedCaptions: new Map()
      };
    }

    function tt(a, b) {
      function c(v) {
        return d(v.name);
      }

      function d(v) {
        v = v.toLowerCase();

        switch (v) {
          case "avc1":
          case "avc3":
            e.push(v + ".42E01E");
            g = !0;
            break;

          case "hev1":
          case "hvc1":
            e.push(v + ".1.6.L93.90");
            g = !0;
            break;

          case "dvh1":
          case "dvhe":
            e.push(v + ".05.04");
            g = !0;
            break;

          case "vp09":
            e.push(v + ".00.10.08");
            g = !0;
            break;

          case "av01":
            e.push(v + ".0.01M.08");
            g = !0;
            break;

          case "mp4a":
            e.push("mp4a.40.2");
            f = !0;
            break;

          case "ac-3":
          case "ec-3":
          case "opus":
          case "flac":
            e.push(v), f = !0;
        }
      }

      var e = [],
          f = !1,
          g = !1,
          h = null,
          k = null,
          l = null,
          m = null,
          n = null;
      new bg().box("moov", gg).box("trak", gg).W("tkhd", function (v) {
        v = ii(v.reader, v.version);
        k = String(v.height);
        l = String(v.width);
      }).box("mdia", gg).W("mdhd", function (v) {
        h = fi(v.reader, v.version).language;
      }).box("minf", gg).box("stbl", gg).W("stsd", ig).box("mp4a", function (v) {
        var y = v.reader;
        y.skip(6);
        y.skip(2);
        y.skip(8);
        var z = y.Ra();
        y.skip(2);
        y.skip(2);
        y.skip(2);
        y = y.Ra() + y.Ra() / 65536;
        m = z;
        n = y;
        v.reader.wa() ? gg(v) : c(v);
      }).box("esds", function (v) {
        v = ji(v.reader);
        e.push(v.va);
        f = !0;
      }).box("ac-3", c).box("ec-3", c).box("opus", c).box("Opus", c).box("fLaC", c).box("avc1", function (v) {
        v = ki(v.reader, v.name);
        e.push(v.va);
        g = !0;
      }).box("avc3", function (v) {
        v = ki(v.reader, v.name);
        e.push(v.va);
        g = !0;
      }).box("hev1", c).box("hvc1", c).box("dvh1", c).box("dvhe", c).box("vp09", c).box("av01", c).box("enca", jg).box("encv", jg).box("sinf", gg).box("frma", function (v) {
        v = li(v.reader).va;
        d(v);
      }).parse(a || b, !0);
      if (!e.length) return null;
      var r = f && !g,
          q = new Map();

      if (g) {
        var u = new tc("video/mp4");
        a && u.init(a);
        u.i(b);
        a = t(u.j());

        for (b = a.next(); !b.done; b = a.next()) b = b.value, q.set(b, b);

        u.h();
      }

      return {
        type: r ? "audio" : "video",
        mimeType: r ? "audio/mp4" : "video/mp4",
        codecs: ut(e).join(", "),
        language: h,
        height: k,
        width: l,
        channelCount: m,
        sampleRate: n,
        closedCaptions: q
      };
    }

    function ut(a) {
      var b = new Set(),
          c = [];
      a = t(a);

      for (var d = a.next(); !d.done; d = a.next()) {
        d = d.value;
        var e = nd(d);
        b.has(e) || (c.push(d), b.add(e));
      }

      return c;
    }

    ;

    function vt() {
      var a = this;
      this.g = this.h = null;
      this.C = 1;
      this.s = new Map();
      this.J = new Map();
      this.L = new Map();
      this.L.set("video", new Map());
      this.L.set("audio", new Map());
      this.L.set(Mb, new Map());
      this.L.set("image", new Map());
      this.Aa = new Set();
      this.i = new Map();
      this.l = null;
      this.Z = "";
      this.ha = new kt();
      this.K = -1;
      this.U = Infinity;
      this.$ = this.Ua = !1;
      this.u = new Fd(function () {
        wt(a);
      });
      this.ua = xt;
      this.G = null;
      this.ra = 0;
      this.m = Infinity;
      this.za = this.aa = this.M = 0;
      this.N = new tf();
      this.H = new Map();
      this.I = new Map();
      this.V = new Map();
      this.Ta = this.D = !1;
      this.Na = new cc(5);
      this.j = null;
    }

    p = vt.prototype;

    p.configure = function (a) {
      this.g = a;
      this.j && this.j.configure(this.g);
    };

    p.start = function (a, b) {
      var c = this,
          d;
      return K(function (e) {
        return 1 == e.g ? (c.h = b, c.D = b.isLowLatencyMode(), D(e, yt(c, [a]), 2)) : 3 != e.g ? (d = e.h, c.Z = d.uri, D(e, zt(c, d.data, a), 3)) : e.return(c.G);
      });
    };

    p.stop = function () {
      this.u && (this.u.stop(), this.u = null);
      var a = [];
      this.N && (a.push(this.N.destroy()), this.N = null);
      this.g = this.h = null;
      this.Aa.clear();
      this.G = null;
      this.i.clear();
      this.J.clear();
      this.I.clear();
      this.s.clear();
      this.V.clear();
      this.j && this.j.destroy();
      return Promise.all(a);
    };

    p.update = function () {
      var a = this,
          b,
          c,
          d,
          e,
          f,
          g,
          h,
          k,
          l;
      return K(function (m) {
        if (1 == m.g) {
          if (!At(a)) return m.return();
          b = [];
          c = Array.from(a.i.values());
          a.m = Infinity;
          d = c.filter(function (n) {
            return n.stream.segmentIndex;
          });
          e = t(d);

          for (f = e.next(); !f.done; f = e.next()) g = f.value, b.push(Bt(a, g));

          return D(m, Promise.all(b), 2);
        }

        Ct(a, d.map(function (n) {
          return n.stream;
        }));
        h = d.some(function (n) {
          return 0 == n.td;
        });
        d.length && !h && (k = Dt, Et(a, k.wh), l = d.map(function (n) {
          return n.Ib;
        }), a.l.bb(Math.min.apply(Math, w(l))), a.h.updateDuration());
        h && Ft(a);
        F(m);
      });
    };

    function Gt(a, b) {
      return At(a) ? a.L.get(b.type) : b.re;
    }

    function Bt(a, b) {
      var c, d, e, f, g, h, k, l, m, n, r, q, u, v, y, z, x, B, A, C, E, H, G, I, J, L, O, Q, V, U;
      return K(function (oa) {
        if (1 == oa.g) {
          c = [];
          d = t(b.ba());

          for (e = d.next(); !e.done; e = d.next()) f = e.value, g = new kb(f), h = g.g, b.Wd && (0 <= b.mb && h.add("_HLS_msn", String(b.mb)), 0 <= b.ob && h.add("_HLS_part", String(b.ob))), b.Xd && h.add("_HLS_skip", "YES"), Fb(h) && pb(g, h), c.push(g.toString());

          return D(oa, yt(a, c, !0), 2);
        }

        k = oa.h;
        if (!b.stream.segmentIndex) return oa.return();
        l = lt(a.ha, k.data);
        if (1 != l.type) throw new P(2, 4, 4017);
        m = k.uri;
        m == k.originalUri || b.ba().includes(m) || b.ah.push(m);
        n = at(l.g, "EXT-X-DEFINE");
        r = Ht(a, n, m);
        q = b.stream;
        u = Gt(a, b);
        v = It(l, q.mimeType);
        y = v.keyIds;
        z = v.drmInfos;

        x = function (la, Qa) {
          return la.size === Qa.size && [].concat(w(la)).every(function (Xa) {
            return Qa.has(Xa);
          });
        };

        x(q.keyIds, y) || (q.keyIds = y, q.drmInfos = z, a.h.newDrmInfo(q));
        B = Jt(a, l, q, u, r, b.ba);
        A = B.segments;
        C = B.bandwidth;
        q.bandwidth = C;
        q.segmentIndex.zd(A, a.l.Hb());
        A.length && (E = dt(l.g, "EXT-X-MEDIA-SEQUENCE", 0), G = (H = ct(l.g, "EXT-X-SKIP")) ? Number(Y(H, "SKIPPED-SEGMENTS")) : 0, I = Kt(E, A), J = I.mb, L = I.ob, b.mb = J + G, b.ob = L, O = u.get(E), q.segmentIndex.rb(O));
        Q = A[0];
        b.uc = Q.startTime;
        V = A[A.length - 1];
        b.Ib = V.endTime;
        if (U = ct(l.g, "EXT-X-ENDLIST")) b.td = !0;
        Lt(a, l);
        F(oa);
      });
    }

    p.onExpirationUpdated = function () {};

    p.onInitialVariantChosen = function () {};

    p.banLocation = function (a) {
      this.j && this.j.i.set(a, Date.now() + 6E4);
    };

    function Mt(a, b) {
      for (var c = -1 == a.K, d = t(b), e = d.next(); !e.done; e = d.next()) {
        e = e.value;
        var f = e.stream.segmentIndex,
            g = Gt(a, e);

        if (f = f.g[0] || null) {
          g = t(g);

          for (var h = g.next(); !h.done; h = g.next()) {
            h = t(h.value);
            var k = h.next().value;

            if (h.next().value == f.startTime) {
              c && (a.K = Math.max(a.K, k));
              e.ef = k;
              break;
            }
          }
        }
      }

      if (!(0 > a.K)) for (b = t(b), e = b.next(); !e.done; e = b.next()) if (c = e.value, d = c.stream.segmentIndex) if (d.g.splice(0, a.K - c.ef), d = d.g[0] || null) d = -d.startTime, c.stream.segmentIndex.offset(d), Nt(a, c, d);
    }

    function Ot(a, b) {
      if (Infinity == a.U) {
        b = t(b);

        for (var c = b.next(); !c.done; c = b.next()) {
          var d = c.value.stream.segmentIndex.g[0] || null;
          null != d && null != d.h && (a.U = Math.min(a.U, d.h));
        }
      }

      b = a.U;
      if (Infinity != b) for (d = t(a.i.values()), c = d.next(); !c.done; c = d.next()) {
        c = c.value;
        var e = c.stream.segmentIndex;

        if (null != e) {
          var f = e.g[0] || null;
          if (null == f.h) Ta("Missing EXT-X-PROGRAM-DATE-TIME for stream", c.ba(), "Expect AV sync issues!");else for (Nt(a, c, f.h - b - f.startTime), c = t(e), e = c.next(); !e.done; e = c.next()) e.value.ng(b);
        }
      }
    }

    function Nt(a, b, c) {
      b.uc += c;
      b.Ib += c;
      a = Gt(a, b);

      for (var d = t(a), e = d.next(); !e.done; e = d.next()) {
        var f = t(e.value);
        e = f.next().value;
        f = f.next().value;
        a.set(e, f + c);
      }

      b.ba();
    }

    function zt(a, b, c) {
      var d, e, f, g, h, k, l, m, n, r, q, u, v, y, z, x, B, A, C, E, H, G, I, J, L, O, Q, V, U, oa;
      return K(function (la) {
        switch (la.g) {
          case 1:
            d = lt(a.ha, b);
            e = at(d.g, "EXT-X-DEFINE");
            f = [];
            g = [];
            h = [];
            if (1 == d.type) return v = function () {
              return [c];
            }, D(la, Pt(a, d, v), 6);
            Qt(a, e);
            k = at(d.g, "EXT-X-MEDIA");
            l = at(d.g, "EXT-X-STREAM-INF");
            m = at(d.g, "EXT-X-IMAGE-STREAM-INF");
            n = at(d.g, "EXT-X-I-FRAME-STREAM-INF");
            r = at(d.g, "EXT-X-SESSION-KEY");
            q = at(d.g, "EXT-X-SESSION-DATA");
            u = at(d.g, "EXT-X-CONTENT-STEERING");
            Rt(a, q);
            return D(la, St(a, u), 4);

          case 4:
            return Tt(a, l), Ut(a, k), f = Vt(a, l, r, k), g = Wt(a, k), D(la, Xt(a, m, n), 5);

          case 5:
            h = la.h;
            la.F(3);
            break;

          case 6:
            return y = la.h, z = y.type, x = y.mimeType, B = y.codecs, A = y.language, C = y.height, E = y.width, H = y.channelCount, G = y.sampleRate, I = y.closedCaptions, D(la, Yt(a, a.C++, d, v, c, B, z, A, !0, "Media Playlist", H, I, null, !1, G, !1, x), 7);

          case 7:
            J = la.h, a.i.set(c, J), "video" == z && Zt(J.stream, E, C, null, null, null), f.push({
              id: 0,
              language: Qb(A || "und"),
              disabledUntilTime: 0,
              primary: !0,
              audio: "audio" == z ? J.stream : null,
              video: "video" == z ? J.stream : null,
              bandwidth: J.stream.bandwidth || 0,
              allowedByApplication: !0,
              allowedByKeySystem: !0,
              decodingInfos: []
            });

          case 3:
            if (!a.h) throw new P(2, 7, 7001);
            a.l = new sj(null, 0);
            a.l.Sc(!0);
            1 == d.type && (At(a) && ($t(a, d), L = a.m, a.u.R(L)), O = Array.from(a.i.values()), au(a, O), Ft(a));
            a.G = {
              presentationTimeline: a.l,
              variants: f,
              textStreams: g,
              imageStreams: h,
              offlineSessionIds: [],
              minBufferTime: 0,
              sequenceMode: a.g.hls.sequenceMode,
              ignoreManifestTimestampsInSegmentsMode: a.g.hls.ignoreManifestTimestampsInSegmentsMode,
              type: "HLS",
              serviceDescription: null
            };

            if (a.$ || !a.g.hls.disableCodecGuessing) {
              la.F(8);
              break;
            }

            Q = [];
            V = t(a.G.variants);

            for (U = V.next(); !U.done; U = V.next()) oa = U.value, oa.audio && "" === oa.audio.codecs && Q.push(oa.audio.createSegmentIndex()), oa.video && "" === oa.video.codecs && Q.push(oa.video.createSegmentIndex());

            return D(la, Promise.all(Q), 8);

          case 8:
            a.h.makeTextStreamsForClosedCaptions(a.G), F(la);
        }
      });
    }

    function Pt(a, b, c) {
      var d, e, f, g, h, k, l, m, n, r, q, u, v, y, z, x, B, A;
      return K(function (C) {
        switch (C.g) {
          case 1:
            d = st(a.g.hls.mediaPlaylistFullMimeType);
            if (!b.segments.length) return C.return(d);
            e = Math.trunc((b.segments.length - 1) / 2);
            f = b.segments[e];
            g = et(c(), b.segments[0].h);
            h = g[0];
            k = new kb(h);
            l = k.Va.split(".").pop();
            if (m = bu[l]) return C.return(st(m));
            n = Ff;
            r = null;
            q = cu(a, b, f.g, c);
            a.V.clear();

            if (!q) {
              C.F(2);
              break;
            }

            u = zf(q.ba(), a.g.retryParameters);
            return D(C, du(a, u, n, {
              type: 0
            }), 3);

          case 3:
            v = C.h, r = v.data;

          case 2:
            return y = zf(g, a.g.retryParameters), D(C, du(a, y, n, {
              type: 1
            }), 4);

          case 4:
            z = C.h;
            (x = z.headers["content-type"]) && (x = x.split(";")[0].toLowerCase());

            if ("ts" == l || "video/mp2t" == x) {
              var E = z.data;
              var H = nc(E);
              H = new wi().parse(H);
              var G = H.pd();
              H = H.Ef();
              var I = [],
                  J = !1,
                  L = !1;

              switch (G.audio) {
                case "aac":
                  I.push("mp4a.40.2");
                  J = !0;
                  break;

                case "mp3":
                  I.push("mp4a.40.34");
                  J = !0;
                  break;

                case "ac3":
                  I.push("ac-3");
                  J = !0;
                  break;

                case "ec3":
                  I.push("ec-3"), J = !0;
              }

              switch (G.video) {
                case "avc":
                  H.va ? I.push(H.va) : I.push("avc1.42E01E");
                  L = !0;
                  break;

                case "hvc":
                  H.va ? I.push(H.va) : I.push("hvc1.1.6.L93.90"), L = !0;
              }

              if (I.length) {
                G = J && !L;
                J = new Map();

                if (L) {
                  L = new tc("video/mp2t");
                  L.i(E);
                  E = t(L.j());

                  for (var O = E.next(); !O.done; O = E.next()) O = O.value, J.set(O, O);

                  L.h();
                }

                H = {
                  type: G ? "audio" : "video",
                  mimeType: "video/mp2t",
                  codecs: I.join(", "),
                  language: null,
                  height: H.height,
                  width: H.width,
                  channelCount: null,
                  sampleRate: null,
                  closedCaptions: J
                };
              } else H = null;

              if (B = H) return C.return(B);
            } else if ("mp4" == l || "cmfv" == l || "m4s" == l || "video/mp4" == x || "audio/mp4" == x || "video/iso.segment" == x) if (A = tt(r, z.data)) return C.return(A);

            return C.return(d);
        }
      });
    }

    function Ft(a) {
      if (At(a)) {
        if (a.ua == eu) {
          for (var b, c = b = Infinity, d = t(a.i.values()), e = d.next(); !e.done; e = d.next()) e = e.value, e.stream.segmentIndex && "text" != e.stream.type && (b = Math.min(b, e.Ib), c = Math.min(c, e.uc));

          b -= c;
          a.g.hls.useSafariBehaviorForLive && (b = a.l.m);
          isNaN(a.g.availabilityWindowOverride) || (b = a.g.availabilityWindowOverride);
          a.l.Fe(b);
        }
      } else a.l.bb(fu(a));

      a.l.oe();
    }

    function Qt(a, b) {
      var c = new kb(a.Z).g;
      b = t(b);

      for (var d = b.next(); !d.done; d = b.next()) {
        var e = d.value;
        d = Y(e, "NAME");
        var f = Y(e, "VALUE");
        e = Y(e, "QUERYPARAM");
        d && f && (a.s.has(d) || a.s.set(d, f));
        e && (d = c.get(e)[0]) && !a.s.has(d) && a.s.set(e, d);
      }
    }

    function Ht(a, b, c) {
      c = new kb(c).g;
      var d = new Map();
      b = t(b);

      for (var e = b.next(); !e.done; e = b.next()) {
        var f = e.value,
            g = Y(f, "NAME"),
            h = Y(f, "VALUE");
        e = Y(f, "QUERYPARAM");
        f = Y(f, "IMPORT");
        g && h && (d.has(g) || d.set(g, h));
        e && (g = c.get(e)[0]) && !d.has(g) && d.set(e, g);
        f && (e = a.s.get(f)) && d.set(f, e);
      }

      return d;
    }

    function Tt(a, b) {
      b = t(b);

      for (var c = b.next(); !c.done; c = b.next()) {
        var d = c.value,
            e = Y(d, "AUDIO");
        c = Y(d, "VIDEO");
        var f = Y(d, "SUBTITLES");
        d = gu(a, d);

        if (f) {
          var g = Kb(Mb, d);
          a.I.set(f, g);
          xc(d, g);
        }

        e && (f = Kb("audio", d), f || (f = a.g.hls.defaultAudioCodec), a.I.set(e, f));
        c && (e = Kb("video", d), e || (e = a.g.hls.defaultVideoCodec), a.I.set(c, e));
      }
    }

    function Rt(a, b) {
      b = t(b);

      for (var c = b.next(); !c.done; c = b.next()) {
        var d = c.value,
            e = Y(d, "DATA-ID");
        c = Y(d, "URI");
        var f = Y(d, "LANGUAGE");
        d = Y(d, "VALUE");
        e = new Map().set("id", e);
        c && e.set("uri", et([a.Z], c, a.s)[0]);
        f && e.set("language", f);
        d && e.set("value", d);
        c = new N("sessiondata", e);
        if (a.h) a.h.onEvent(c);
      }
    }

    function St(a, b) {
      var c, d, e, f, g, h;
      return K(function (k) {
        if (!a.h || !a.g) return k.return();
        d = t(b);

        for (e = d.next(); !e.done; e = d.next()) if (f = e.value, g = Y(f, "PATHWAY-ID"), h = Y(f, "SERVER-URI"), g && h) {
          a.j = new Jr(a.h);
          a.j.configure(a.g);
          a.j.j = [a.Z];
          a.j.setManifestType("HLS");
          a.j.h = g;
          c = Kr(a.j, h);
          break;
        }

        return D(k, c, 0);
      });
    }

    function Wt(a, b) {
      var c = bt(b, "SUBTITLES");
      b = c.map(function (g) {
        if (a.g.disableText) return null;

        try {
          return hu(a, [g], new Map()).stream;
        } catch (h) {
          if (a.g.hls.ignoreTextStreamFailures) return null;
          throw h;
        }
      });
      c = t(c);

      for (var d = c.next(); !d.done; d = c.next()) {
        var e = Ys(d.value, "GROUP-ID");
        if (d = a.I.get(e)) if (e = a.J.get(e)) {
          e = t(e);

          for (var f = e.next(); !f.done; f = e.next()) f = f.value, f.stream.codecs = d, f.stream.mimeType = iu(Mb, d) || ju(Mb);
        }
      }

      return b.filter(function (g) {
        return g;
      });
    }

    function Xt(a, b, c) {
      var d, e;
      return K(function (f) {
        if (1 == f.g) return d = b.map(function (g) {
          var h, k, l;
          return K(function (m) {
            if (1 == m.g) {
              if (h = a.g.disableThumbnails) return m.return(null);
              ta(m, 2);
              return D(m, ku(a, g), 4);
            }

            if (2 != m.g) return k = m.h, m.return(k.stream);
            l = wa(m);
            if (a.g.hls.ignoreImageStreamFailures) return m.return(null);
            throw l;
          });
        }).concat(c.map(function (g) {
          if (a.g.disableThumbnails) return null;

          try {
            var h = Ys(g, "URI"),
                k = Y(g, "CODECS") || "";
            if (a.i.has(h)) var l = a.i.get(h);else {
              var m = Y(g, "LANGUAGE"),
                  n = Y(g, "NAME"),
                  r = Y(g, "CHARACTERISTICS"),
                  q = lu(a, a.C++, [h], k, "image", m, !1, n, null, null, r, !1, null, !1),
                  u = Y(g, "RESOLUTION"),
                  v = t(u ? u.split("x") : [null, null]),
                  y = v.next().value,
                  z = v.next().value;
              q.stream.width = Number(y) || void 0;
              q.stream.height = Number(z) || void 0;
              var x = Y(g, "BANDWIDTH");
              x && (q.stream.bandwidth = Number(x));
              a.i.set(h, q);
              l = q;
            }
            g = l;
            return "mjpg" !== g.stream.codecs ? null : g.stream;
          } catch (B) {
            if (a.g.hls.ignoreImageStreamFailures) return null;
            throw B;
          }
        })), D(f, Promise.all(d), 2);
        e = f.h;
        return f.return(e.filter(function (g) {
          return g;
        }));
      });
    }

    function mu(a, b, c) {
      b = b.filter(function (h) {
        var k = Y(h, "URI") || "";
        return "SUBTITLES" != Y(h, "TYPE") && "" != k;
      });
      var d = {};
      b = t(b);

      for (var e = b.next(); !e.done; e = b.next()) {
        e = e.value;
        var f = Xs(e);
        d[f] ? d[f].push(e) : d[f] = [e];
      }

      for (var g in d) hu(a, d[g], c);
    }

    function Vt(a, b, c, d) {
      var e = [],
          f = new Set();

      if (0 < c.length) {
        c = t(c);

        for (var g = c.next(); !g.done; g = c.next()) {
          g = g.value;
          var h = Ys(g, "METHOD");

          if ("NONE" != h && "AES-128" != h && (h = Y(g, "KEYFORMAT") || "identity", g = (h = nu[h]) ? h(g, "") : null)) {
            if (g.keyIds) {
              h = t(g.keyIds);

              for (var k = h.next(); !k.done; k = h.next()) f.add(k.value);
            }

            e.push(g);
          }
        }
      }

      c = {};
      b = t(b);

      for (g = b.next(); !g.done; g = b.next()) g = g.value, h = Xs(g), c[h] ? c[h].push(g) : c[h] = [g];

      b = [];

      for (var l in c) {
        k = c[l];
        var m = k[0];
        g = Y(m, "FRAME-RATE");
        h = Number(Y(m, "AVERAGE-BANDWIDTH")) || Number(Ys(m, "BANDWIDTH"));
        var n = Y(m, "RESOLUTION"),
            r = t(n ? n.split("x") : [null, null]);
        n = r.next().value;
        r = r.next().value;
        var q = Y(m, "VIDEO-RANGE");
        (m = Y(m, "REQ-VIDEO-LAYOUT")) && m.includes(",") && (m = m.split(",").filter(function (u) {
          return "CH-STEREO" == u || "CH-MONO" == u;
        })[0]);
        m = m || "CH-MONO";
        k = ou(a, k, d);
        b.push.apply(b, w(pu(a, k.audio, k.video, h, n, r, g, q, m, e, f)));
      }

      return b.filter(function (u) {
        return null != u;
      });
    }

    function ou(a, b, c) {
      for (var d = {
        audio: [],
        video: []
      }, e = new Map(), f = [], g = !1, h = !1, k = t(b), l = k.next(); !l.done; l = k.next()) {
        var m = l.value;
        l = Y(m, "AUDIO");
        var n = Y(m, "VIDEO"),
            r = l || n;
        r && (f.includes(r) || f.push(r), (m = Y(m, "PATHWAY-ID")) && e.set(r, m), l ? g = !0 : n && (h = !0));
      }

      f.length && c.length && (k = c.filter(function (v) {
        return f.includes(Ys(v, "GROUP-ID"));
      }), mu(a, k, e));
      k = (e = f.sort().join(",")) && a.J.has(e) ? a.J.get(e) : [];
      g ? d.audio.push.apply(d.audio, w(k)) : h && d.video.push.apply(d.video, w(k));
      l = !1;
      var q = b.map(function (v) {
        return Ys(v, "URI");
      });
      h = d.audio.find(function (v) {
        return v && v.ba().find(function (y) {
          return q.includes(y);
        });
      });
      g = gu(a, b[0]);
      n = Kb("video", g);
      (r = Kb("audio", g)) && !n ? (h = "audio", l = 0 < d.audio.length) : !d.audio.length && !d.video.length && r && n ? (h = "video", g = [[n, r].join()]) : d.audio.length && h ? (h = "audio", l = !0) : h = d.video.length && !d.audio.length ? "audio" : "video";

      if (!l) {
        var u = m = r = n = l = null;
        !k.length && (c = c.find(function (v) {
          var y = Y(v, "URI") || "",
              z = Y(v, "TYPE");
          v = Ys(v, "GROUP-ID");
          return "SUBTITLES" != z && "" == y && f.includes(v);
        })) && (l = Y(c, "LANGUAGE"), n = Y(c, "NAME"), r = qu(c), ru(c), m = Y(c, "CHARACTERISTICS"), u = su(c));
        a = tu(a, b, g, h, l, n, r, m, u);
        e && (a.stream.groupId = e);
        d[a.stream.type] = [a];
      }

      return d;
    }

    function gu(a, b) {
      var c = Y(b, "CODECS") || "";
      a.$ = 0 < c.length;
      a.$ || a.g.hls.disableCodecGuessing || (b = [], a.g.disableVideo || b.push(a.g.hls.defaultVideoCodec), a.g.disableAudio || b.push(a.g.hls.defaultAudioCodec), c = b.join(","));
      a = new Set();
      b = [];
      c = t(c.split(/\s*,\s*/));

      for (var d = c.next(); !d.done; d = c.next()) {
        d = d.value;
        var e = nd(d);
        a.has(e) || (b.push(d), a.add(e));
      }

      return b;
    }

    function qu(a) {
      return (a = Y(a, "CHANNELS")) ? parseInt(a.split("/")[0], 10) : null;
    }

    function su(a) {
      return (a = Y(a, "SAMPLE-RATE")) ? parseInt(a, 10) : null;
    }

    function ru(a) {
      return (a = Y(a, "CHANNELS")) ? a.includes("/JOC") : !1;
    }

    function pu(a, b, c, d, e, f, g, h, k, l, m) {
      for (var n = t(c), r = n.next(); !r.done; r = n.next()) Zt(r.value.stream, e, f, g, h, k);

      e = a.g.disableAudio;
      if (!b.length || e) b = [null];
      e = a.g.disableVideo;
      if (!c.length || e) c = [null];
      e = [];
      b = t(b);

      for (f = b.next(); !f.done; f = b.next()) for (f = f.value, g = t(c), h = g.next(); !h.done; h = g.next()) {
        var q = h.value;
        if (h = f ? f.stream : null) h.drmInfos = l, h.keyIds = m;
        if (k = q ? q.stream : null) k.drmInfos = l, k.keyIds = m;
        n = f ? f.stream.drmInfos : null;
        r = q ? q.stream.drmInfos : null;
        q = q ? q.ba().sort().join(",") : "";
        var u = f ? f.ba().sort().join(",") : "";
        q = q + " - " + u;
        h && k && !Dh(n, r) || a.Aa.has(q) || (h = {
          id: a.C++,
          language: h ? h.language : "und",
          disabledUntilTime: 0,
          primary: !!h && h.primary || !!k && k.primary,
          audio: h,
          video: k,
          bandwidth: d,
          allowedByApplication: !0,
          allowedByKeySystem: !0,
          decodingInfos: []
        }, e.push(h), a.Aa.add(q));
      }

      return e;
    }

    function Ut(a, b) {
      b = bt(b, "CLOSED-CAPTIONS");
      b = t(b);

      for (var c = b.next(); !c.done; c = b.next()) {
        var d = c.value,
            e = Y(d, "LANGUAGE");
        c = Qb(e || "und");
        e || (e = Y(d, "NAME")) && (c = e);
        e = Ys(d, "GROUP-ID");
        d = Ys(d, "INSTREAM-ID").replace("SERVICE", "svc");
        a.H.get(e) || a.H.set(e, new Map());
        a.H.get(e).set(d, c);
      }
    }

    function hu(a, b, c) {
      for (var d = [], e = [], f = new Map(), g = t(b), h = g.next(); !h.done; h = g.next()) {
        var k = h.value;
        h = Ys(k, "URI");
        k = Ys(k, "GROUP-ID");
        d.push(h);
        e.push(k);
        f.set(k, h);
      }

      g = e.sort().join(",");
      h = b[0];
      b = "";
      k = Ys(h, "TYPE").toLowerCase();
      "subtitles" == k && (k = Mb);
      if (k == Mb) b = Y(h, "CODECS") || "";else {
        e = t(e);

        for (var l = e.next(); !l.done; l = e.next()) if (l = l.value, a.I.has(l)) {
          b = a.I.get(l);
          break;
        }
      }
      e = d.sort().join(",");
      if (a.i.has(e)) return a.i.get(e);
      l = a.C++;

      if (a.j) {
        f = t(f);

        for (var m = f.next(); !m.done; m = f.next()) {
          var n = t(m.value);
          m = n.next().value;
          n = n.next().value;
          (m = c.get(m)) && Nr(a.j, l, m, n);
        }
      }

      c = Y(h, "LANGUAGE");
      f = Y(h, "NAME");
      m = "YES" == Y(h, "DEFAULT");
      n = "audio" == k ? qu(h) : null;
      var r = "audio" == k ? ru(h) : !1,
          q = Y(h, "CHARACTERISTICS"),
          u = "YES" == Y(h, "FORCED");
      h = "audio" == k ? su(h) : null;
      d = lu(a, l, d, b, k, c, m, f, n, null, q, u, h, r);
      d.stream && (d.stream.groupId = g);
      a.J.has(g) ? a.J.get(g).push(d) : a.J.set(g, [d]);
      a.i.set(e, d);
      return d;
    }

    function ku(a, b) {
      var c, d, e, f, g, h, k, l, m, n;
      return K(function (r) {
        if (1 == r.g) {
          c = Ys(b, "URI");
          d = Y(b, "CODECS", "jpeg") || "";
          if (a.i.has(c)) return r.return(a.i.get(c));
          e = Y(b, "LANGUAGE");
          f = Y(b, "NAME");
          g = Y(b, "CHARACTERISTICS");
          h = lu(a, a.C++, [c], d, "image", e, !1, f, null, null, g, !1, null, !1);
          return (k = Y(b, "RESOLUTION")) ? D(r, h.stream.createSegmentIndex(), 3) : r.F(2);
        }

        2 != r.g && (l = h.stream.segmentIndex.get(0), m = l.tilesLayout) && (h.stream.width = Number(k.split("x")[0]) * Number(m.split("x")[0]), h.stream.height = Number(k.split("x")[1]) * Number(m.split("x")[1]));
        if (n = Y(b, "BANDWIDTH")) h.stream.bandwidth = Number(n);
        a.i.set(c, h);
        return r.return(h);
      });
    }

    function tu(a, b, c, d, e, f, g, h, k) {
      for (var l = a.C++, m = [], n = t(b), r = n.next(); !r.done; r = n.next()) {
        var q = r.value;
        r = Ys(q, "URI");
        q = Y(q, "PATHWAY-ID");
        a.j && q && Nr(a.j, l, q, r);
        m.push(r);
      }

      n = m.sort().join(",");
      if (a.i.has(n)) return a.i.get(n);

      a: {
        b = Y(b[0], "CLOSED-CAPTIONS");

        if ("video" == d) {
          if (b && "NONE" != b) {
            b = a.H.get(b);
            break a;
          }

          if (!b && a.H.size) for (b = t(a.H.keys()).next(); !b.done;) {
            b = a.H.get(b.value);
            break a;
          }
        }

        b = null;
      }

      c = Jb(d, c);
      d = lu(a, l, m, c, d, e, !1, f, g, b, h, !1, k, !1);
      a.i.set(n, d);
      return d;
    }

    function lu(a, b, c, d, e, f, g, h, k, l, m, n, r, q) {
      function u(C) {
        var E, H, G, I, J, L, O, Q, V, U, oa, la, Qa, Xa, qb, lb, wb;
        return K(function (Aa) {
          switch (Aa.g) {
            case 1:
              return E = x.ba(), D(Aa, yt(a, x.ba(), !0), 2);

            case 2:
              H = Aa.h;
              if (C.aborted) return Aa.return();
              G = H.uri;
              G == H.originalUri || E.includes(G) || z.push(G);
              I = lt(a.ha, H.data);
              J = void 0;

              if (a.$ || !a.g.hls.disableCodecGuessing) {
                Aa.F(3);
                break;
              }

              return D(Aa, Pt(a, I, v), 4);

            case 4:
              L = Aa.h, J = L.mimeType, d = L.codecs;

            case 3:
              return O = At(a), D(Aa, Yt(a, 0, I, v, G, d, e, f, g, h, k, l, m, n, r, q, J), 5);

            case 5:
              Q = Aa.h;
              if (C.aborted) return Aa.return();
              V = Q.stream;
              At(a) && !O && $t(a, I);
              x.uc = Q.uc;
              x.Ib = Q.Ib;
              x.Xd = Q.Xd;
              x.Wd = Q.Wd;
              x.td = Q.td;
              x.re = Q.re;
              x.mb = Q.mb;
              x.ob = Q.ob;
              x.Mf = !0;
              y.segmentIndex = V.segmentIndex;
              y.encrypted = V.encrypted;
              y.drmInfos = V.drmInfos;
              y.keyIds = V.keyIds;
              y.mimeType = V.mimeType;
              y.bandwidth = V.bandwidth;
              y.codecs = V.codecs || y.codecs;
              y.drmInfos.length && a.h.newDrmInfo(y);
              U = Nb;
              if (e == U.ia || e == U.T) for (oa = t(a.i.values()), la = oa.next(); !la.done; la = oa.next()) Qa = la.value, Qa.Mf || Qa.type != e || (Qa.stream.mimeType = V.mimeType);
              e == U.sa && (Xa = V.segmentIndex.get(0)) && Xa.ka && (y.mimeType = "application/mp4");
              uu(a) && (a.Ua ? au(a, [x]) : (a.Ua = !0, qb = Array.from(a.i.values()), lb = qb.filter(function (ib) {
                return ib.stream.segmentIndex;
              }), au(a, lb), Ft(a), wb = a.m, 0 < wb && a.u.R(wb)));
              F(Aa);
          }
        });
      }

      function v() {
        return a.j && 1 < c.length ? Or(a.j, b) : z.concat(ft([a.Z], c, a.s));
      }

      var y = vu(a, d, e, f, g, h, k, l, m, n, r, q),
          z = [],
          x = {
        stream: y,
        type: e,
        ah: z,
        ba: v,
        uc: 0,
        Ib: 0,
        re: new Map(),
        Xd: !1,
        Wd: !1,
        td: !1,
        ef: -1,
        mb: -1,
        ob: -1,
        Mf: !1
      },
          B = null,
          A = new AbortController();

      y.createSegmentIndex = function () {
        if (B) return B;
        A = new AbortController();
        return B = new Promise(function (C) {
          C(u(A.signal));
        });
      };

      y.closeSegmentIndex = function () {
        B && !y.segmentIndex && A.abort();
        y.segmentIndex && (y.segmentIndex.release(), y.segmentIndex = null);
        B = null;
      };

      return x;
    }

    function fu(a) {
      var b = Infinity;
      a = t(a.i.values());

      for (var c = a.next(); !c.done; c = a.next()) c = c.value, c.stream.segmentIndex && "text" != c.stream.type && (b = Math.min(b, c.Ib));

      return b;
    }

    function Ct(a, b) {
      var c = [];
      b = t(b);

      for (var d = b.next(); !d.done; d = b.next()) d = d.value, d.segmentIndex && Pj(d.segmentIndex, function (e) {
        c.push(e);
      });

      a.l.Bd(c);
    }

    function au(a, b) {
      if (!At(a)) for (var c = fu(a), d = t(b), e = d.next(); !e.done; e = d.next()) e.value.stream.segmentIndex.Ec(0, c);
      Ct(a, b.map(function (f) {
        return f.stream;
      }));
      a.g.hls.ignoreManifestProgramDateTime ? Mt(a, b) : Ot(a, b);
    }

    function uu(a) {
      if (!a.G) return !1;
      var b = [],
          c = [];
      a = t(a.G.variants);

      for (var d = a.next(); !d.done; d = a.next()) d = d.value, d.video && b.push(d.video), d.audio && c.push(d.audio);

      return 0 < b.length && !b.some(function (e) {
        return e.segmentIndex;
      }) || 0 < c.length && !c.some(function (e) {
        return e.segmentIndex;
      }) ? !1 : !0;
    }

    function Yt(a, b, c, d, e, f, g, h, k, l, m, n, r, q, u, v, y) {
      var z, x, B, A, C, E, H, G, I, J, L, O, Q, V, U, oa, la, Qa, Xa, qb, lb, wb, Aa;
      return K(function (ib) {
        if (1 == ib.g) {
          if (1 != c.type) throw new P(2, 4, 4017);
          z = at(c.g, "EXT-X-DEFINE");
          x = Ht(a, z, e);
          var rb = ct(c.g, "EXT-X-PLAYLIST-TYPE"),
              Eb = ct(c.g, "EXT-X-ENDLIST");
          Eb = rb && "VOD" == rb.value || Eb;
          rb = rb && "EVENT" == rb.value && !Eb;
          rb = !Eb && !rb;
          Eb ? Et(a, xt) : rb ? Et(a, eu) : Et(a, wu);
          At(a) && Lt(a, c);
          return y ? ib.F(2) : D(ib, xu(a, g, f, c, x, d), 3);
        }

        2 != ib.g && (y = ib.h);
        B = It(c, y);
        A = B.drmInfos;
        C = B.keyIds;
        E = B.encrypted;
        H = B.Bh;
        if (E && !A.length && !H) throw new P(2, 4, 4026);
        G = vu(a, f, g, h, k, l, m, n, r, q, u, v);
        G.encrypted = E;
        G.drmInfos = A;
        G.keyIds = C;
        G.mimeType = y;
        I = At(a) ? a.L.get(g) : new Map();
        J = Jt(a, c, G, I, x, d);
        L = J.segments;
        O = J.bandwidth;
        G.bandwidth = O;
        At(a) && Lt(a, c);
        Q = L[0].startTime;
        V = L[L.length - 1];
        U = V.endTime;
        oa = new Oj(L);
        G.segmentIndex = oa;
        Qa = (la = ct(c.g, "EXT-X-SERVER-CONTROL")) ? null != la.getAttribute("CAN-SKIP-UNTIL") : !1;
        Xa = la ? null != la.getAttribute("CAN-BLOCK-RELOAD") : !1;
        qb = dt(c.g, "EXT-X-MEDIA-SEQUENCE", 0);
        lb = Kt(qb, L);
        wb = lb.mb;
        Aa = lb.ob;
        return ib.return({
          stream: G,
          type: g,
          ah: [],
          ba: d,
          uc: Q,
          Ib: U,
          Xd: Qa,
          Wd: Xa,
          td: !1,
          ef: -1,
          mb: wb,
          ob: Aa,
          re: I,
          Mf: !1
        });
      });
    }

    function Kt(a, b) {
      a = a + b.length - 1;
      var c = -1;
      if (!b.length) return a++, {
        mb: a,
        ob: c
      };
      b = b[b.length - 1];
      var d = b.g;
      if (!b.g.length) return a++, b.s && (c = 0), {
        mb: a,
        ob: c
      };
      c = d.length - 1;
      d[d.length - 1].m || (a++, c = 0);
      return {
        mb: a,
        ob: c
      };
    }

    function vu(a, b, c, d, e, f, g, h, k, l, m, n) {
      var r = iu(c, b) || ju(c),
          q = [];

      if (k) {
        k = t(k.split(","));

        for (var u = k.next(); !u.done; u = k.next()) q.push(u.value);
      }

      k = void 0;
      u = null;
      c == Mb ? k = q.includes("public.accessibility.transcribes-spoken-dialog") && q.includes("public.accessibility.describes-music-and-sound") ? "caption" : "subtitle" : q.includes("public.accessibility.describes-video") && (u = "visually impaired");
      q.length || "subtitle" !== k || q.push("subtitle");
      return {
        id: a.C++,
        originalId: f,
        groupId: null,
        createSegmentIndex: function () {
          return Promise.resolve();
        },
        segmentIndex: null,
        mimeType: r,
        codecs: b,
        kind: c == Mb ? "subtitle" : void 0,
        encrypted: !1,
        drmInfos: [],
        keyIds: new Set(),
        language: Qb(d || "und"),
        originalLanguage: d,
        label: f,
        type: c,
        primary: e,
        trickModeVideo: null,
        emsgSchemeIdUris: null,
        frameRate: void 0,
        pixelAspectRatio: void 0,
        width: void 0,
        height: void 0,
        bandwidth: void 0,
        roles: q,
        forced: l,
        channelsCount: g,
        audioSamplingRate: m,
        spatialAudio: n,
        closedCaptions: h,
        hdr: void 0,
        videoLayout: void 0,
        tilesLayout: void 0,
        accessibilityPurpose: u,
        external: !1,
        fastSwitching: !1
      };
    }

    function It(a, b) {
      var c = [];

      if (a.segments) {
        a = t(a.segments);

        for (var d = a.next(); !d.done; d = a.next()) d = at(d.value.g, "EXT-X-KEY"), c.push.apply(c, w(d));
      }

      d = a = !1;
      var e = [],
          f = new Set();
      c = t(c);

      for (var g = c.next(); !g.done; g = c.next()) {
        g = g.value;
        var h = Ys(g, "METHOD");
        if ("NONE" != h) if (a = !0, "AES-128" == h) d = !0;else if (h = Y(g, "KEYFORMAT") || "identity", g = (h = nu[h]) ? h(g, b) : null) {
          if (g.keyIds) {
            h = t(g.keyIds);

            for (var k = h.next(); !k.done; k = h.next()) f.add(k.value);
          }

          e.push(g);
        }
      }

      return {
        drmInfos: e,
        keyIds: f,
        encrypted: a,
        Bh: d
      };
    }

    function yu(a, b, c, d, e) {
      if (!window.crypto || !window.crypto.subtle) throw Ua("Web Crypto API is not available to decrypt AES-128. (Web Crypto only exists in secure origins like https)"), new P(2, 4, 4042);
      var f = 0,
          g = Y(b, "IV", "");

      if (g) {
        var h = rg(g.substr(2));
        if (16 != h.byteLength) throw new P(2, 4, 4048);
      } else f = dt(c.g, "EXT-X-MEDIA-SEQUENCE", 0);

      var k = {
        method: "AES-128",
        iv: h,
        firstMediaSequenceNumber: f,
        fetchKey: function () {
          var l, m, n, r, q;
          return K(function (u) {
            if (1 == u.g) return l = et(d(), Ys(b, "URI"), e), m = zf([l], a.g.retryParameters), D(u, du(a, m, 6), 2);

            if (3 != u.g) {
              n = u.h;
              if (!n.data || 16 != n.data.byteLength) throw new P(2, 4, 4049);
              r = {
                name: "AES-CBC"
              };
              q = k;
              return D(u, window.crypto.subtle.importKey("raw", n.data, r, !0, ["decrypt"]), 3);
            }

            q.cryptoKey = u.h;
            k.fetchKey = void 0;
            F(u);
          });
        }
      };
      return k;
    }

    function Lt(a, b) {
      var c = Infinity,
          d = b.segments;
      if (d.length) for (var e = d.length - 1; 0 <= e;) {
        var f = ct(d[e].g, "EXTINF");

        if (f) {
          c = Number(f.value.split(",")[0]);
          break;
        }

        e--;
      }
      d = ct(b.g, "EXT-X-TARGETDURATION");
      if (!d) throw new P(2, 4, 4024, "EXT-X-TARGETDURATION");
      d = Number(d.value);
      if (e = ct(b.g, "EXT-X-PART-INF")) a.M = Number(Ys(e, "PART-TARGET"));
      b = ct(b.g, "EXT-X-SERVER-CONTROL");
      a.D && a.M ? (a.m = a.Ta ? 5 * a.M <= c ? Math.min(a.M, a.m) : Math.min(c, a.m) : Math.min(a.M, a.m), a.za = b ? Number(Ys(b, "PART-HOLD-BACK")) : 0) : (a.m = Math.min(c, a.m), c = b ? b.getAttribute("HOLD-BACK") : null, a.aa = c ? Number(c.value) : 0);
      a.ra = Math.max(d, a.ra);
    }

    function $t(a, b) {
      if (a.g.defaultPresentationDelay) b = a.g.defaultPresentationDelay;else if (a.za) b = a.za;else if (a.aa) b = a.aa;else {
        b = b.segments.length;
        var c = a.g.hls.liveSegmentsDelay;
        c > b - 2 && (c = Math.max(1, b - 2));
        b = a.ra * c;
      }
      a.l.kh(0);
      a.l.hh(b);
      a.l.Sc(!1);
    }

    function cu(a, b, c, d, e) {
      var f = ct(c, "EXT-X-MAP");
      if (!f) return null;
      var g = Ys(f, "URI"),
          h = et(d(), g, e);
      g = [h.toString(), Y(f, "BYTERANGE", "")].join("-");

      if (!a.V.has(g)) {
        var k = void 0,
            l = null;
        c = t(c);

        for (var m = c.next(); !m.done; m = c.next()) m = m.value, "EXT-X-KEY" == m.name ? "AES-128" == Ys(m, "METHOD") && m.id < f.id && (k = yu(a, m, b, d, e)) : "EXT-X-BYTERANGE" == m.name && m.id < f.id && (l = m);

        b = zu(h, f, l, k);
        a.V.set(g, b);
      }

      return a.V.get(g);
    }

    function zu(a, b, c, d) {
      var e = 0,
          f = null;
      b = Y(b, "BYTERANGE");
      !b && c && (b = c.value);
      b && (e = b.split("@"), f = Number(e[0]), e = Number(e[1]), f = e + f - 1, d && (c = f + 1 - e, c % 16 && (f += 16 - c % 16)));
      return new Nh(function () {
        return a;
      }, e, f, null, null, null, d);
    }

    function Au(a, b, c, d, e, f, g, h, k) {
      var l = d.g,
          m = ct(l, "EXTINF"),
          n = 0,
          r = 0,
          q = null;
      d.ub.length && !a.D && Ua("Low-latency HLS live stream detected, but low-latency streaming mode is not enabled in Shaka Player. Set streaming.lowLatencyMode configuration to true, and see https://bit.ly/3clctcj for details.");
      var u = null;

      if (!a.g.hls.ignoreManifestProgramDateTime) {
        var v = ct(l, "EXT-X-PROGRAM-DATE-TIME");
        v && v.value && (u = Gg(v.value));
      }

      var y = Qh;
      ct(l, "EXT-X-GAP") && (y = 2);

      if (!m) {
        if (0 == d.ub.length) throw new P(2, 4, 4024, "EXTINF");
        if (!a.D) return null;
      }

      var z = [];
      v = !1;
      var x = null,
          B = !1,
          A = !1;

      if (a.D && d.ub.length) {
        n = ("video/mp4" == g.mimeType || "audio/mp4" == g.mimeType) && window.ReadableStream && a.g.hls.allowLowLatencyByteRangeOptimization;

        for (var C = u, E = {}, H = 0; H < d.ub.length; E = {
          fd: E.fd,
          Qd: E.Qd
        }, H++) {
          var G = d.ub[H],
              I = 0 == H ? c : z[z.length - 1],
              J = 0 == H ? e : I.endTime,
              L = Number(Y(G, "DURATION")) || a.M;

          if (L) {
            var O = J + L,
                Q = 0,
                V = null;
            "EXT-X-PRELOAD-HINT" == G.name ? (Q = (Q = Y(G, "BYTERANGE-START")) ? Number(Q) : 0, (I = Y(G, "BYTERANGE-LENGTH")) ? V = Q + Number(I) - 1 : Q && (V = Number.MAX_SAFE_INTEGER)) : (Q = Y(G, "BYTERANGE"), V = t(Bu(I, Q)), Q = V.next().value, V = V.next().value);
            E.Qd = Y(G, "URI");

            if (E.Qd) {
              I = Qh;
              "YES" == Y(G, "GAP") && (I = 2, B = !0);
              E.fd = null;

              var U = function (la) {
                return function () {
                  null == la.fd && (la.fd = et(h(), la.Qd, f));
                  return la.fd;
                };
              }(E);

              n && 0 <= Q && null != V && (x = U, v = !0);
              J = new Ph(J, O, U, Q, V, b, 0, 0, Infinity, [], "", null, C, I, k);
              "EXT-X-PRELOAD-HINT" == G.name && (J.Nf(), A = !0);
              "YES" != Y(G, "INDEPENDENT") && 0 < H && J.qe();
              z.push(J);
              C && (C += L);
            }
          }
        }
      }

      if (m) {
        m = Number(m.value.split(",")[0]);
        if (0 == m) return null;
        n = e + m;
      } else if (z.length) n = z[z.length - 1].endTime;else return null;

      v && (B || 0 != z[0].cb ? (v = !1, x = null) : z = []);
      (m = ct(l, "EXT-X-BYTERANGE")) ? (q = t(Bu(c, m.value)), r = q.next().value, q = q.next().value) : z.length && (r = z[0].cb, q = z[z.length - 1].Ja);
      c = "";
      m = null;
      "image" == g.type && (c = "1x1", g = ct(l, "EXT-X-TILES")) && (c = Ys(g, "LAYOUT"), (g = Y(g, "DURATION")) && (m = Number(g)));
      var oa = null;
      b = new Ph(e, n, function () {
        if (x) return x();
        null == oa && (oa = et(h(), d.h, f));
        return oa || [];
      }, r, q, b, 0, 0, Infinity, z, c, m, u, y, k, 0 < z.length && !!d.h);
      v && (a.Ta = !0, b.Ug(), A && b.Nf());
      return b;
    }

    function Bu(a, b) {
      var c = 0,
          d = null;
      b && (c = b.split("@"), b = Number(c[0]), c = c[1] ? Number(c[1]) : a.Ja + 1, d = c + b - 1);
      return [c, d];
    }

    function Jt(a, b, c, d, e, f) {
      var g = b.segments,
          h = void 0,
          k = dt(b.g, "EXT-X-DISCONTINUITY-SEQUENCE", 0),
          l = dt(b.g, "EXT-X-MEDIA-SEQUENCE", 0),
          m = ct(b.g, "EXT-X-SKIP"),
          n = m ? Number(Y(m, "SKIPPED-SEGMENTS")) : 0,
          r = l + n,
          q = 0;
      At(a) && d.has(r) && (q = d.get(r));
      var u = [],
          v = null;
      m = [];

      for (var y = 0; y < g.length; y++) {
        var z = g[y],
            x = 0 == y ? q : v.endTime;
        r = l + n + y;
        ct(z.g, "EXT-X-DISCONTINUITY") && k++;
        var B = t(z.g);

        for (var A = B.next(); !A.done; A = B.next()) A = A.value, "EXT-X-KEY" == A.name && ("AES-128" == Ys(A, "METHOD") ? h = yu(a, A, b, f, e) : h = void 0);

        d.set(r, x);
        B = cu(a, b, z.g, f, e);
        !a.D && a.h.isAutoLowLatencyMode() && (a.h.enableLowLatencyMode(), a.D = a.h.isLowLatencyMode());
        if (x = Au(a, B, v, z, x, e, c, f, h)) (v = dt(z.g, "EXT-X-BITRATE")) ? m.push({
          bitrate: v,
          duration: x.endTime - x.startTime
        }) : m.length && (v = m.pop(), v.duration += x.endTime - x.startTime, m.push(v)), v = x, x.j = k, a.g.hls.ignoreManifestProgramDateTime && null != a.K && r < a.K || u.push(x);
      }

      b = void 0;
      m.length && (b = m.reduce(function (C, E) {
        return C + E.duration;
      }, 0), b = Math.round(m.reduce(function (C, E) {
        return C + E.bitrate * E.duration;
      }, 0) / b * 1E3));
      if (m = u.some(function (C) {
        return null != C.h;
      })) for (c = {}, d = 0; d < u.length; c = {
        Wc: c.Wc,
        Vc: c.Vc,
        Md: c.Md,
        Ob: c.Ob,
        Uc: c.Uc
      }, d++) if (c.Ob = u[d], null == c.Ob.h) for (c.Vc = 0, c.Wc = d, e = function (C) {
        return function () {
          var E = u[C.Wc];

          if (E) {
            if (null != E.h) return E.h + C.Vc;
            C.Vc -= E.endTime - E.startTime;
            C.Wc += 1;
          }

          return null;
        };
      }(c), c.Uc = 0, c.Md = d, f = function (C) {
        return function () {
          var E = u[C.Md];

          if (E) {
            E != C.Ob && (C.Uc += E.endTime - E.startTime);
            if (null != E.h) return E.h + C.Uc;
            --C.Md;
          }

          return null;
        };
      }(c); null == c.Ob.h;) c.Ob.h = f(), null == c.Ob.h && (c.Ob.h = e());
      if (m) for (c = t(u), d = c.next(); !d.done; d = c.next()) for (e = d.value, d = e.h, e = t(e.g), f = e.next(); !f.done; f = e.next()) f = f.value, f.h = d, d += f.endTime - f.startTime;
      a = a.U;
      if (m && Infinity != a) for (m = t(u), d = m.next(); !d.done; d = m.next()) d.value.ng(a);
      return {
        segments: u,
        bandwidth: b
      };
    }

    function iu(a, b) {
      if (a == Mb) {
        if ("vtt" == b || "wvtt" == b) return "text/vtt";
        if (b && "" !== b) return "application/mp4";
      }

      return "image" != a || b && "jpeg" != b ? "audio" == a && "mp4a.40.34" == b ? "audio/mpeg" : "mjpg" == b ? "application/mp4" : null : "image/jpeg";
    }

    function ju(a) {
      return a == Mb ? "text/vtt" : Cu[a].mp4;
    }

    function xu(a, b, c, d, e, f) {
      var g, h, k, l, m, n, r, q, u, v, y, z, x;
      return K(function (B) {
        switch (B.g) {
          case 1:
            g = Ff;
            h = Math.trunc((d.segments.length - 1) / 2);
            k = et(f(), d.segments[h].h, e);
            l = new kb(k[0]);
            m = l.Va.split(".").pop();
            n = Cu[b];
            if ((r = n[m]) || (r = bu[m]) || (r = iu(b, c))) return B.return(r);
            u = 1;
            v = zf(k, a.g.retryParameters);
            ta(B, 2);
            v.method = "HEAD";
            return D(B, du(a, v, g, {
              type: u
            }), 4);

          case 4:
            y = B.h;
            q = y.headers["content-type"];
            va(B, 3);
            break;

          case 2:
            z = wa(B);

            if (!z || 1002 != z.code) {
              B.F(3);
              break;
            }

            v.method = "GET";
            return D(B, du(a, v, g, {
              type: u
            }), 6);

          case 6:
            x = B.h, q = x.headers["content-type"];

          case 3:
            return q ? B.return(q.split(";")[0]) : B.return(ju(b));
        }
      });
    }

    function Zt(a, b, c, d, e, f) {
      a && (a.width = Number(b) || void 0, a.height = Number(c) || void 0, a.frameRate = Number(d) || void 0, a.hdr = e || void 0, a.videoLayout = f || void 0);
    }

    function yt(a, b, c) {
      return du(a, zf(b, a.g.retryParameters), 0, {
        type: c ? 2 : 3
      });
    }

    function wt(a) {
      var b, c, d, e, f, g;
      K(function (h) {
        switch (h.g) {
          case 1:
            if (!a.h) return h.return();
            ta(h, 2);
            b = Date.now();
            return D(h, a.update(), 4);

          case 4:
            c = Date.now();
            At(a) && (d = (c - b) / 1E3, a.Na.sample(1, d), e = a.m, f = Math.max(0, e - dc(a.Na)), a.u.R(f));
            va(h, 3);
            break;

          case 2:
            g = wa(h);
            if (!a.h) return h.return();
            if (a.g.raiseFatalErrorOnManifestUpdateRequestFailure) return a.h.onError(g), h.return();
            g.severity = 1;
            a.h.onError(g);
            a.u.R(.1);

          case 3:
            if (!a.h) return h.return();
            a.h.onManifestUpdated();
            F(h);
        }
      });
    }

    function At(a) {
      return a.ua != xt;
    }

    function Et(a, b) {
      a.ua = b;
      a.l && a.l.Sc(!At(a));
      At(a) || a.u.stop();
    }

    function du(a, b, c, d) {
      if (!a.N) throw new P(2, 7, 7001);
      b = a.h.networkingEngine.request(c, b, d);
      uf(a.N, b);
      return b.promise;
    }

    M("shaka.hls.HlsParser", vt);
    var bu = {
      aac: "audio/aac",
      ac3: "audio/ac3",
      ec3: "audio/ec3",
      mp3: "audio/mpeg"
    },
        Cu = {
      audio: {
        mp4: "audio/mp4",
        mp4a: "audio/mp4",
        m4s: "audio/mp4",
        m4i: "audio/mp4",
        m4a: "audio/mp4",
        m4f: "audio/mp4",
        cmfa: "audio/mp4",
        ts: "video/mp2t",
        tsa: "video/mp2t"
      },
      video: {
        mp4: "video/mp4",
        mp4v: "video/mp4",
        m4s: "video/mp4",
        m4i: "video/mp4",
        m4v: "video/mp4",
        m4f: "video/mp4",
        cmfv: "video/mp4",
        ts: "video/mp2t",
        tsv: "video/mp2t"
      },
      text: {
        mp4: "application/mp4",
        m4s: "application/mp4",
        m4i: "application/mp4",
        m4f: "application/mp4",
        cmft: "application/mp4",
        vtt: "text/vtt",
        webvtt: "text/vtt",
        ttml: "application/ttml+xml"
      },
      image: {
        jpg: "image/jpeg",
        png: "image/png",
        svg: "image/svg+xml",
        webp: "image/webp",
        avif: "image/avif"
      }
    },
        nu = {
      "com.apple.streamingkeydelivery": function (a, b) {
        if ("video/mp2t" == b) throw new P(2, 4, 4040);
        if (window.shakaMediaKeysPolyfill) throw new P(2, 4, 4041);
        return Ib("com.apple.fps", [{
          initDataType: "sinf",
          initData: new Uint8Array(0),
          keyId: null
        }]);
      },
      "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed": function (a) {
        var b = Ys(a, "METHOD");
        if (!["SAMPLE-AES", "SAMPLE-AES-CTR"].includes(b)) return null;
        b = Ys(a, "URI");
        b = rt(b);
        b = nc(b.data);
        b = Ib("com.widevine.alpha", [{
          initDataType: "cenc",
          initData: b
        }]);
        if (a = Y(a, "KEYID")) b.keyIds = new Set([a.toLowerCase().substr(2)]);
        return b;
      },
      "com.microsoft.playready": function (a) {
        var b = Ys(a, "METHOD");
        if (!["SAMPLE-AES", "SAMPLE-AES-CTR"].includes(b)) return null;
        a = Ys(a, "URI");
        a = rt(a);
        a = nc(a.data);
        b = new Uint8Array([154, 4, 240, 121, 152, 64, 66, 134, 171, 146, 230, 91, 224, 136, 95, 149]);
        a = vg(a, b, new Set(), 0);
        return Ib("com.microsoft.playready", [{
          initDataType: "cenc",
          initData: a
        }]);
      },
      identity: function (a) {
        a = Ys(a, "METHOD");
        return ["SAMPLE-AES", "SAMPLE-AES-CTR"].includes(a) ? Ib("org.w3.clearkey", null) : null;
      }
    },
        xt = "VOD",
        wu = "EVENT",
        eu = "LIVE",
        Dt = {
      wh: xt,
      vj: wu,
      Dj: eu
    };

    Ih["application/x-mpegurl"] = function () {
      return new vt();
    };

    Ih["application/vnd.apple.mpegurl"] = function () {
      return new vt();
    };

    function Du(a) {
      var b = 0,
          c = rc(a),
          d = c.getUint32(b, !0);
      if (d != a.byteLength) return [];

      a: {
        a = b + 6;

        for (b = []; a < c.byteLength - 1;) {
          d = c.getUint16(a, !0);
          a += 2;
          var e = c.getUint16(a, !0);
          a += 2;

          if (0 != (e & 1) || e + a > c.byteLength) {
            c = [];
            break a;
          }

          var f = nc(c, a, e);
          b.push({
            type: d,
            value: f
          });
          a += e;
        }

        c = b;
      }

      return c;
    }

    function Eu(a) {
      if (a = Fu(a)) a: {
        a = t(a.getElementsByTagName("DATA"));

        for (var b = a.next(); !b.done; b = a.next()) if (b = wg(b.value, "LA_URL")) {
          a = b.textContent;
          break a;
        }

        a = "";
      } else a = "";
      return a;
    }

    function Fu(a) {
      a = qg(a.textContent);
      a = Du(a).filter(function (b) {
        return b.type === Gu;
      })[0];
      if (!a) return null;
      a = Uf(a.value, !0);
      return (a = Pg(a, "WRMHEADER")) ? a : null;
    }

    var Gu = 1,
        Hu = new Map().set("com.microsoft.playready", Eu).set("com.microsoft.playready.recommendation", Eu).set("com.microsoft.playready.software", Eu).set("com.microsoft.playready.hardware", Eu);

    function Iu(a) {
      if (!Ju) {
        Ju = !0;
        var b = new Uint8Array([105, 115, 111, 109]),
            c = new Uint8Array([97, 118, 99, 49]),
            d = new Uint8Array([0, 0, 0, 1]);
        Ku = Lu("ftyp", b, d, b, c);
        b = Lu("dref", Mu);
        Nu = Lu("dinf", b);
      }

      this.g = a;
    }

    function Ou(a) {
      for (var b = [], c = t(a.g), d = c.next(); !d.done; d = c.next()) {
        var e = b,
            f = e.push;
        var g = d.value;
        d = Lu;
        var h = g.id + 1;
        var k = g.stream.width || 0,
            l = g.stream.height || 0;
        "audio" == g.type && (l = k = 0);
        var m = g.duration * g.timescale,
            n = Math.floor(m / (Pu + 1));
        m = Math.floor(m % (Pu + 1));
        h = new Uint8Array([1, 0, 0, 7, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 3].concat(w(Qu(h, 4)), [0, 0, 0, 0], w(Qu(n, 4)), w(Qu(m, 4)), [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 64, 0, 0, 0], w(Qu(k, 2)), [0, 0], w(Qu(l, 2)), [0, 0]));
        h = Lu("tkhd", h);
        k = Lu;
        n = g.duration * g.timescale;
        l = Math.floor(n / (Pu + 1));
        n = Math.floor(n % (Pu + 1));
        m = g.stream.language;
        m = m.charCodeAt(0) - 96 << 10 | m.charCodeAt(1) - 96 << 5 | m.charCodeAt(2) - 96;
        l = new Uint8Array([1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 3].concat(w(Qu(g.timescale, 4)), w(Qu(l, 4)), w(Qu(n, 4)), w(Qu(m, 2)), [0, 0]));
        l = Lu("mdhd", l);
        n = g;
        m = new Uint8Array([]);

        switch (n.type) {
          case "video":
            m = Ru;
            break;

          case "audio":
            m = Su;
        }

        n = Lu("hdlr", m);

        a: {
          switch (g.type) {
            case "video":
              g = Lu("minf", Lu("vmhd", Tu), Nu, Uu(g));
              break a;

            case "audio":
              g = Lu("minf", Lu("smhd", Vu), Nu, Uu(g));
              break a;
          }

          g = new Uint8Array([]);
        }

        g = k("mdia", l, n, g);
        d = d("trak", h, g);
        f.call(e, d);
      }

      b = tg.apply(ng, w(b));
      f = a.g[0];
      c = Lu;
      d = f.duration * f.timescale;
      e = Math.floor(d / (Pu + 1));
      d = Math.floor(d % (Pu + 1));
      e = new Uint8Array([1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 3].concat(w(Qu(f.timescale, 4)), w(Qu(e, 4)), w(Qu(d, 4)), [0, 1, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 64, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 255, 255, 255, 255]));
      e = Lu("mvhd", e);
      d = [];
      a = t(a.g);

      for (k = a.next(); !k.done; k = a.next()) g = d, h = g.push, k = new Uint8Array([0, 0, 0, 0].concat(w(Qu(k.value.id + 1, 4)), [0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1])), k = Lu("trex", k), h.call(g, k);

      a = tg.apply(ng, w(d));
      a = Lu("mvex", a);
      d = [];

      if (f.encrypted) {
        f = t(f.stream.drmInfos);

        for (g = f.next(); !g.done; g = f.next()) if (g = g.value, g.initData) for (g = t(g.initData), h = g.next(); !h.done; h = g.next()) d.push(h.value.initData);

        f = tg.apply(ng, w(d));
      } else f = new Uint8Array([]);

      a = c("moov", e, b, a, f);
      b = new Uint8Array(Ku.byteLength + a.byteLength);
      b.set(Ku);
      b.set(a, Ku.byteLength);
      return b;
    }

    function Uu(a) {
      var b = Lu,
          c = new Uint8Array([]);

      switch (a.type) {
        case "video":
          if (a.codecs.includes("avc1")) {
            c = a.stream.width || 0;
            var d = a.stream.height || 0;
            if (0 < a.Ba.byteLength) var e = Lu("avcC", a.Ba);else {
              e = Lu;

              for (var f = 7, g = [], h = [], k = 0, l = 0, m = 0, n = 0; n < a.eb.length; n++) {
                var r = Wu(a.eb[n]);

                switch (r[0] & 31) {
                  case 7:
                    g.push(r);
                    f += r.length + 2;
                    break;

                  case 8:
                    h.push(r), f += r.length + 2;
                }
              }

              0 < g.length && (k = g[0][1], m = g[0][2], l = g[0][3]);
              f = new Uint8Array(f);
              n = 0;
              f[n++] = 1;
              f[n++] = k;
              f[n++] = m;
              f[n++] = l;
              f[n++] = 255;
              f[n++] = 224 | g.length;

              for (k = 0; k < g.length; k++) f[n++] = (g[k].length & 65280) >> 8, f[n++] = g[k].length & 255, f.set(g[k], n), n += g[k].length;

              f[n++] = h.length;

              for (g = 0; g < h.length; g++) f[n++] = (h[g].length & 65280) >> 8, f[n++] = h[g].length & 255, f.set(h[g], n), n += h[g].length;

              e = e("avcC", f);
            }
            c = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0].concat(w(Qu(c, 2)), w(Qu(d, 2)), [0, 72, 0, 0, 0, 72, 0, 0, 0, 0, 0, 0, 0, 1, 19, 118, 105, 100, 101, 111, 106, 115, 45, 99, 111, 110, 116, 114, 105, 98, 45, 104, 108, 115, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 24, 17, 17]));
            d = "avc1";
            h = new Uint8Array([]);
            a.encrypted && (h = Xu(a), d = "encv");
            c = Lu(d, c, e, h);
          } else a.codecs.includes("hvc1") && (d = a.stream.width || 0, e = a.stream.height || 0, c = new Uint8Array([]), 0 < a.Ba.byteLength && (c = Lu("hvcC", a.Ba)), d = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0].concat(w(Qu(d, 2)), w(Qu(e, 2)), [0, 72, 0, 0, 0, 72, 0, 0, 0, 0, 0, 0, 0, 1, 19, 118, 105, 100, 101, 111, 106, 115, 45, 99, 111, 110, 116, 114, 105, 98, 45, 104, 108, 115, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 24, 17, 17])), e = "hvc1", h = new Uint8Array([]), a.encrypted && (h = Xu(a), e = "encv"), c = Lu(e, d, c, h));

          break;

        case "audio":
          if (a.codecs.includes("mp3")) a = Lu(".mp3", Yu(a));else if (a.codecs.includes("ac-3")) c = Lu("dac3", a.oa), d = "ac-3", e = new Uint8Array([]), a.encrypted && (e = Xu(a), d = "enca"), a = Lu(d, Yu(a), c, e);else if (a.codecs.includes("ec-3")) c = Lu("dec3", a.oa), d = "ec-3", e = new Uint8Array([]), a.encrypted && (e = Xu(a), d = "enca"), a = Lu(d, Yu(a), c, e);else {
            if (0 < a.oa.byteLength) c = Lu("esds", a.oa);else {
              c = Lu;
              d = a.id + 1;
              e = a.stream.channelsCount || 2;
              g = a.stream.audioSamplingRate || 44100;
              k = Jb("audio", a.codecs.split(","));
              l = {
                96E3: 0,
                88200: 1,
                64E3: 2,
                48E3: 3,
                44100: 4,
                32E3: 5,
                24E3: 6,
                22050: 7,
                16E3: 8,
                12E3: 9,
                11025: 10,
                8E3: 11,
                7350: 12
              };
              h = l[g];
              if ("mp4a.40.5" === k || "mp4a.40.29" === k) h = l[2 * g];
              g = parseInt(k.split(".").pop(), 10);
              d = new Uint8Array([0, 0, 0, 0, 3, 25].concat(w(Qu(d, 2)), [0, 4, 17, 64, 21, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 5, 2, g << 3 | h >>> 1, h << 7 | e << 3, 6, 1, 2]));
              c = c("esds", d);
            }
            d = "mp4a";
            e = new Uint8Array([]);
            a.encrypted && (e = Xu(a), d = "enca");
            a = Lu(d, Yu(a), c, e);
          }
          c = a;
      }

      a = Lu("stsd", Zu, c);
      return b("stbl", a, Lu("stts", $u), Lu("stsc", av), Lu("stsz", bv), Lu("stco", cv));
    }

    function Yu(a) {
      return new Uint8Array([0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, a.stream.channelsCount || 2, 0, 16, 0, 0, 0, 0].concat(w(Qu(a.stream.audioSamplingRate || 44100, 2)), [0, 0]));
    }

    function Xu(a) {
      var b = Lu;
      var c = a.codecs.substring(0, a.codecs.indexOf("."));

      for (var d = 0, e = 0; e < c.length; e += 1) d |= c.charCodeAt(e) << 8 * (c.length - e - 1);

      c = new Uint8Array([].concat(w(Qu(d, 4))));
      c = Lu("frma", c);
      d = new Uint8Array([0, 0, 0, 0, 99, 101, 110, 99, 0, 1, 0, 0]);
      d = Lu("schm", d);
      e = Lu;
      var f = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
      a = t(a.stream.drmInfos);

      for (var g = a.next(); !g.done; g = a.next()) if ((g = g.value) && g.keyIds && g.keyIds.size) {
        g = t(g.keyIds);

        for (var h = g.next(); !h.done; h = g.next()) f = Wu(h.value);
      }

      a = new Uint8Array([0, 0, 0, 0, 0, 0, 1, 8]);
      f = Lu("tenc", a, f);
      return b("sinf", c, d, e("schi", f));
    }

    function dv(a) {
      var b = [];
      a = t(a.g);

      for (var c = a.next(); !c.done; c = a.next()) {
        c = c.value;
        var d = b.push,
            e = d.apply;
        var f = Lu;
        var g = new Uint8Array([0, 0, 0, 0].concat(w(Qu(c.data ? c.data.vb : 0, 4))));
        g = Lu("mfhd", g);
        var h;
        var k = c.data ? c.data.ab : [];
        var l = new Uint8Array(4 + k.length);

        for (h = 0; h < k.length; h++) {
          var m = k[h].flags;
          l[h + 4] = m.Xa << 4 | m.Za << 2 | m.Ya;
        }

        k = Lu("sdtp", l);
        var n = k.length + 92;
        l = Lu;
        h = new Uint8Array([0, 0, 0, 58].concat(w(Qu(c.id + 1, 4)), [0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]));
        h = Lu("tfhd", h);
        m = c.data ? c.data.baseMediaDecodeTime : 0;
        var r = Math.floor(m % (Pu + 1));
        m = new Uint8Array([1, 0, 0, 0].concat(w(Qu(Math.floor(m / (Pu + 1)), 4)), w(Qu(r, 4))));
        m = Lu("tfdt", m);
        var q = n;
        n = c.data ? c.data.ab : [];
        r = n.length;
        var u = 12 + 16 * r,
            v = new Uint8Array(u);
        q += 8 + u;
        v.set(["video" === c.type ? 1 : 0, 0, 15, 1].concat(w(Qu(r, 4)), w(Qu(q, 4))), 0);

        for (q = 0; q < r; q++) {
          var y = n[q];
          u = Qu(y.duration, 4);
          var z = Qu(y.size, 4),
              x = y.flags;
          y = Qu(y.gb, 4);
          v.set([].concat(w(u), w(z), [x.ib << 2 | x.Xa, x.Za << 6 | x.Ya << 4 | x.jb, x.Wa & 61440, x.Wa & 15], w(y)), 12 + 16 * q);
        }

        n = Lu("trun", v);
        k = l("traf", h, m, n, k);
        f = f("moof", g, k);
        e.call(d, b, [f, ev(c)]);
      }

      return tg.apply(ng, w(b));
    }

    function ev(a) {
      a = (a.data ? a.data.ab : []).map(function (b) {
        return b.data;
      });
      a = tg.apply(ng, w(a));
      return Lu("mdat", a);
    }

    function Qu(a, b) {
      var c = [];

      for (--b; 0 <= b; b--) c.push(a >> 8 * b & 255);

      return c;
    }

    function Wu(a) {
      for (var b = new Uint8Array(a.length / 2), c = 0; c < a.length / 2; c += 1) b[c] = parseInt(String(a[2 * c] + a[2 * c + 1]), 16);

      return b;
    }

    function Lu(a) {
      var b = Ga.apply(1, arguments),
          c = fv[a];
      c || (c = [a.charCodeAt(0), a.charCodeAt(1), a.charCodeAt(2), a.charCodeAt(3)], fv[a] = c);

      for (var d = 8, e = b.length - 1; 0 <= e; e--) d += b[e].byteLength;

      e = new Uint8Array(d);
      e[0] = d >> 24 & 255;
      e[1] = d >> 16 & 255;
      e[2] = d >> 8 & 255;
      e[3] = d & 255;
      e.set(c, 4);
      c = 0;

      for (d = 8; c < b.length; c++) e.set(b[c], d), d += b[c].byteLength;

      return e;
    }

    var Ju = !1,
        Pu = Math.pow(2, 32) - 1,
        fv = {},
        Ru = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 118, 105, 100, 101, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 86, 105, 100, 101, 111, 72, 97, 110, 100, 108, 101, 114, 0]),
        Su = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 115, 111, 117, 110, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 83, 111, 117, 110, 100, 72, 97, 110, 100, 108, 101, 114, 0]),
        $u = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0]),
        av = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0]),
        cv = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0]),
        bv = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]),
        Tu = new Uint8Array([0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0]),
        Vu = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0]),
        Zu = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 1]),
        Ku = new Uint8Array([]),
        Mu = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 12, 117, 114, 108, 32, 0, 0, 0, 1]),
        Nu = new Uint8Array([]);

    function gv() {
      var a = this;
      this.h = this.g = null;
      this.l = [];
      this.j = null;
      this.u = 1;
      this.i = null;
      this.D = new cc(5);
      this.s = new Fd(function () {
        hv(a);
      });
      this.C = new tf();
      this.m = new Map();
    }

    p = gv.prototype;

    p.configure = function (a) {
      this.g = a;
    };

    p.start = function (a, b) {
      var c = this;
      return K(function (d) {
        if (1 == d.g) return c.l = [a], c.h = b, D(d, iv(c), 2);
        if (!c.h) throw new P(2, 7, 7001);
        return d.return(c.j);
      });
    };

    function hv(a) {
      var b;
      K(function (c) {
        switch (c.g) {
          case 1:
            return ta(c, 2), D(c, iv(a), 4);

          case 4:
            va(c, 3);
            break;

          case 2:
            b = wa(c), a.h && (b.severity = 1, a.h.onError(b));

          case 3:
            if (!a.h) return c.return();
            F(c);
        }
      });
    }

    p.stop = function () {
      this.g = this.h = null;
      this.l = [];
      this.j = null;
      null != this.s && (this.s.stop(), this.s = null);
      this.m.clear();
      return this.C.destroy();
    };

    p.update = function () {
      var a = this,
          b;
      return K(function (c) {
        if (1 == c.g) return ta(c, 2), D(c, iv(a), 4);
        if (2 != c.g) return va(c, 0);
        b = wa(c);
        if (!a.h || !b) return c.return();
        a.h.onError(b);
        F(c);
      });
    };

    p.onExpirationUpdated = function () {};

    p.onInitialVariantChosen = function () {};

    p.banLocation = function () {};

    function iv(a) {
      var b, c, d, e, f, g, h;
      return K(function (k) {
        if (1 == k.g) return b = zf(a.l, a.g.retryParameters), c = a.h.networkingEngine, d = Date.now(), e = c.request(0, b, {
          type: 5
        }), uf(a.C, e), D(k, e.promise, 2);
        f = k.h;
        if (!a.h) return k.return();
        f.uri && !a.l.includes(f.uri) && a.l.unshift(f.uri);
        var l = f.uri,
            m = Rg(f.data, "SmoothStreamingMedia");
        if (!m) throw new P(2, 4, 4046, l);
        (l = a.g.mss.manifestPreprocessor) && l(m);
        a.i || (a.i = new sj(null, 0));
        if (l = Fg(m, "IsLive", Ng, !1)) throw new P(2, 4, 4047);
        a.i.Sc(!l);
        var n = Fg(m, "TimeScale", Lg, 1E7),
            r = Fg(m, "DVRWindowLength", Lg);
        l && (0 === r || isNaN(r)) && (r = Infinity);
        var q = Fg(m, "CanSeek", Ng, !1);
        0 === r && q && (r = Infinity);
        q = null;
        r && 0 < r && (q = r / n);
        l && !isNaN(a.g.availabilityWindowOverride) && (q = a.g.availabilityWindowOverride);
        null == q && (q = Infinity);
        a.i.Fe(q);
        r = Fg(m, "Duration", Lg, Infinity);
        l || a.i.bb(r / n);
        l = {
          variants: [],
          textStreams: [],
          timescale: n,
          duration: r / n
        };
        q = xg(m, "Protection");
        var u;
        n = a.g.mss.keySystemsBySystemId;
        r = [];
        q = t(q);

        for (u = q.next(); !u.done; u = q.next()) r = r.concat(xg(u.value, "ProtectionHeader"));

        if (r.length) {
          q = [];

          for (u = 0; u < r.length; u++) {
            var v = r[u],
                y = v.getAttribute("SystemID").toLowerCase(),
                z = n[y];

            if (z) {
              var x = Fu(v);
              if (x) a: {
                x = t(x.getElementsByTagName("DATA"));

                for (var B = x.next(); !B.done; B = x.next()) if (B = wg(B.value, "KID")) {
                  x = qg(B.textContent);
                  x = new Uint8Array([x[3], x[2], x[1], x[0], x[5], x[4], x[7], x[6]].concat(w(x.slice(8))));
                  x = sg(x);
                  break a;
                }

                x = null;
              } else x = null;
              B = qg(v.textContent);
              y = rg(y.replace(/-/g, ""));
              y = [{
                initData: vg(B, y, new Set(), 0),
                initDataType: "cenc",
                keyId: x
              }];
              y = Ib(z, y);
              x && y.keyIds.add(x);
              if (z = Hu.get(z)) y.licenseServerUri = z(v);
              q.push(y);
            }
          }

          n = q;
        } else n = [];

        u = n;
        q = [];
        n = [];
        r = [];
        m = xg(m, "StreamIndex");
        m = t(m);

        for (v = m.next(); !v.done; v = m.next()) {
          v = v.value;
          z = xg(v, "QualityLevel");
          y = l.timescale;
          x = l.duration;
          B = xg(v, "c");

          for (var A = [], C = 0, E = 0; E < B.length; ++E) {
            var H = B[E],
                G = B[E + 1],
                I = Fg(H, "t", Lg),
                J = Fg(H, "d", Lg);
            H = Fg(H, "r", Jg);
            if (!J) break;
            I = null != I ? I : C;
            H = H || 0;
            if (0 > H) if (G) {
              G = Fg(G, "t", Lg);
              if (null == G) break;else if (I >= G) break;
              H = Math.ceil((G - I) / J) - 1;
            } else {
              if (Infinity == x) break;else if (I / y >= x) break;
              H = Math.ceil((x * y - I) / J) - 1;
            }

            for (G = 0; G <= H; ++G) C = I + J, A.push({
              start: I / y,
              end: C / y,
              ug: I
            }), I = C;
          }

          y = A;
          z = t(z);

          for (x = z.next(); !x.done; x = z.next()) (x = jv(a, v, x.value, y, u, l)) && ("audio" != x.type || a.g.disableAudio ? "video" != x.type || a.g.disableVideo ? x.type != Mb || a.g.disableText || r.push(x) : n.push(x) : q.push(x));
        }

        m = [];
        q = t(0 < q.length ? q : [null]);

        for (u = q.next(); !u.done; u = q.next()) for (u = u.value, v = t(0 < n.length ? n : [null]), x = v.next(); !x.done; x = v.next()) z = m, y = z.push, x = x.value, B = 0, u && u.bandwidth && 0 < u.bandwidth && (B += u.bandwidth), x && x.bandwidth && 0 < x.bandwidth && (B += x.bandwidth), x = {
          id: a.u++,
          language: u ? u.language : "und",
          disabledUntilTime: 0,
          primary: !!u && u.primary || !!x && x.primary,
          audio: u,
          video: x,
          bandwidth: B,
          allowedByApplication: !0,
          allowedByKeySystem: !0,
          decodingInfos: []
        }, y.call(z, x);

        l.variants = m;
        l.textStreams = r;
        a.j ? (a.j.variants = l.variants, a.j.textStreams = l.textStreams, a.h.filter(a.j)) : (a.j = {
          presentationTimeline: a.i,
          variants: l.variants,
          textStreams: l.textStreams,
          imageStreams: [],
          offlineSessionIds: [],
          minBufferTime: 0,
          sequenceMode: a.g.mss.sequenceMode,
          ignoreManifestTimestampsInSegmentsMode: !1,
          type: "MSS",
          serviceDescription: null
        }, a.i.oe());
        Promise.resolve();
        g = Date.now();
        h = (g - d) / 1E3;
        a.D.sample(1, h);
        F(k);
      });
    }

    function jv(a, b, c, d, e, f) {
      var g = b.getAttribute("Type");
      if ("audio" !== g && "video" !== g && "text" !== g) return Ua("Ignoring unrecognized type:", g), null;
      var h = b.getAttribute("Language"),
          k = a.u++,
          l = Fg(c, "Bitrate", Kg),
          m = Fg(c, "MaxWidth", Kg),
          n = Fg(c, "MaxHeight", Kg),
          r = Fg(c, "Channels", Kg),
          q = Fg(c, "SamplingRate", Kg),
          u = f.duration;
      d.length && (u = d[d.length - 1].end - d[0].start);
      var v = a.i.getDuration();
      a.i.bb(Math.min(u, v));
      var y = {
        id: k,
        originalId: b.getAttribute("Name") || String(k),
        groupId: null,
        createSegmentIndex: function () {
          return Promise.resolve();
        },
        closeSegmentIndex: function () {
          return Promise.resolve();
        },
        segmentIndex: null,
        mimeType: "",
        codecs: "",
        frameRate: void 0,
        pixelAspectRatio: void 0,
        bandwidth: l || 0,
        width: m || void 0,
        height: n || void 0,
        kind: "",
        encrypted: 0 < e.length,
        drmInfos: e,
        keyIds: new Set(),
        language: Qb(h || "und"),
        originalLanguage: h,
        label: "",
        type: "",
        primary: !1,
        trickModeVideo: null,
        emsgSchemeIdUris: [],
        roles: [],
        forced: !1,
        channelsCount: r,
        audioSamplingRate: q,
        spatialAudio: !1,
        closedCaptions: null,
        hdr: void 0,
        videoLayout: void 0,
        tilesLayout: void 0,
        matchedStreams: [],
        mssPrivateData: {
          duration: u,
          timescale: f.timescale,
          codecPrivateData: null
        },
        accessibilityPurpose: null,
        external: !1,
        fastSwitching: !1
      };
      if (e = b.getAttribute("Subtype")) (e = kv[e]) && y.roles.push(e), "main" === e && (y.primary = !0);
      e = c.getAttribute("FourCC");
      if (null === e || "" === e) e = b.getAttribute("FourCC");
      if (!e) if ("audio" === g) e = "AAC";else if ("video" === g) return Ua('FourCC is not defined whereas it is required for a QualityLevel element for a StreamIndex of type "video"'), null;
      if (!lv.includes(e.toUpperCase())) return Ua("Codec not supported:", e), null;
      c = mv(c, g, e, y);
      y.mssPrivateData.codecPrivateData = c;

      switch (g) {
        case "audio":
          if (!c) return Ua("Quality unsupported without CodecPrivateData", g), null;
          y.type = "audio";
          y.mimeType = "mss/audio/mp4";
          y.codecs = nv(e, c);
          break;

        case "video":
          if (!c) return Ua("Quality unsupported without CodecPrivateData", g), null;
          y.type = "video";
          y.mimeType = "mss/video/mp4";
          y.codecs = ov(c);
          break;

        case "text":
          if (y.type = Mb, y.mimeType = "application/mp4", "TTML" === e || "DFXP" === e) y.codecs = "stpp";
      }

      y.createSegmentIndex = function () {
        if (y.segmentIndex) return Promise.resolve();
        if (a.m.has(y.id)) var z = a.m.get(y.id);else z = [], "video" == y.type && (z = y.mssPrivateData.codecPrivateData.split("00000001").slice(1)), z = {
          id: y.id,
          type: y.type,
          codecs: y.codecs,
          encrypted: y.encrypted,
          timescale: y.mssPrivateData.timescale,
          duration: y.mssPrivateData.duration,
          eb: z,
          oa: new Uint8Array([]),
          Ba: new Uint8Array([]),
          data: null,
          stream: y
        }, z = Ou(new Iu([z])), a.m.set(y.id, z);
        z = pv(a, new Nh(function () {
          return [];
        }, 0, null, null, void 0, z), y, b, d);
        y.segmentIndex = new Oj(z);
        return Promise.resolve();
      };

      y.closeSegmentIndex = function () {
        y.segmentIndex && (y.segmentIndex.release(), y.segmentIndex = null);
      };

      return y;
    }

    function mv(a, b, c, d) {
      if (a = a.getAttribute("CodecPrivateData")) return a;
      if ("audio" !== b) return null;
      b = d.channelsCount || 2;
      a = d.audioSamplingRate || 44100;
      var e = {
        96E3: 0,
        88200: 1,
        64E3: 2,
        48E3: 3,
        44100: 4,
        32E3: 5,
        24E3: 6,
        22050: 7,
        16E3: 8,
        12E3: 9,
        11025: 10,
        8E3: 11,
        7350: 12
      };
      d = e[a];
      if ("AACH" === c) return c = new Uint8Array(4), a = e[2 * a], c[0] = 40 | d >> 1, c[1] = d << 7 | b << 3 | a >> 1, c[2] = a << 7 | 8, c[3] = 0, b = new Uint16Array(2), b[0] = (c[0] << 8) + c[1], b[1] = (c[2] << 8) + c[3], b[0].toString(16) + b[1].toString(16);
      c = new Uint8Array(2);
      c[0] = 16 | d >> 1;
      c[1] = d << 7 | b << 3;
      b = new Uint16Array(1);
      b[0] = (c[0] << 8) + c[1];
      return b[0].toString(16);
    }

    function nv(a, b) {
      var c = 0;
      "AACH" === a && (c = 5);
      b ? 0 === c && (c = (parseInt(b.substr(0, 2), 16) & 248) >> 3) : (c = 2, "AACH" === a && (c = 5));
      return "mp4a.40." + c;
    }

    function ov(a) {
      var b = /00000001[0-9]7/.exec(a);
      return b.length && a ? "avc1." + a.substr(a.indexOf(b[0]) + 10, 6) : "";
    }

    function pv(a, b, c, d, e) {
      var f = d.getAttribute("Url").replace("{bitrate}", String(c.bandwidth));
      d = [];
      var g = {};
      e = t(e);

      for (var h = e.next(); !h.done; g = {
        ed: g.ed
      }, h = e.next()) g.ed = h.value, d.push(new Ph(g.ed.start, g.ed.end, function (k) {
        return function () {
          return Hb(a.l, [f.replace("{start time}", String(k.ed.ug))]);
        };
      }(g), 0, null, b, 0, 0, c.mssPrivateData.duration));

      return d;
    }

    M("shaka.mss.MssParser", gv);
    var lv = "AAC AACL AACH AACP AVC1 H264 TTML DFXP".split(" "),
        kv = {
      CAPT: "main",
      SUBT: "alternate",
      DESC: "main"
    };

    Ih["application/vnd.ms-sstr+xml"] = function () {
      return new gv();
    };

    function qv(a, b, c, d, e, f) {
      if (200 <= c && 299 >= c && 202 != c) return {
        uri: e || d,
        originalUri: d,
        data: b,
        status: c,
        headers: a,
        fromCache: !!a["x-shaka-from-cache"]
      };
      e = null;

      try {
        e = Wf(b);
      } catch (g) {}

      throw new P(401 == c || 403 == c ? 2 : 1, 1, 1001, d, c, e, a, f);
    }

    ;

    function rv() {}

    function sv(a, b, c, d, e) {
      var f = new tv();
      Pf(b.headers).forEach(function (l, m) {
        f.append(m, l);
      });
      var g = new uv(),
          h = {
        Ag: !1,
        ph: !1
      };
      a = vv(a, c, {
        body: b.body || void 0,
        headers: f,
        method: b.method,
        signal: g.signal,
        credentials: b.allowCrossSiteCredentials ? "include" : void 0
      }, h, d, e, b.streamDataCallback);
      a = new mf(a, function () {
        h.Ag = !0;
        g.abort();
        return Promise.resolve();
      });

      if (b = b.retryParameters.timeout) {
        var k = new Fd(function () {
          h.ph = !0;
          g.abort();
        });
        k.R(b / 1E3);
        a.finally(function () {
          k.stop();
        });
      }

      return a;
    }

    function vv(a, b, c, d, e, f, g) {
      var h, k, l, m, n, r, q, u, v, y, z, x, B;
      return K(function (A) {
        switch (A.g) {
          case 1:
            return h = wv, k = xv, r = n = 0, q = Date.now(), ta(A, 2), D(A, h(a, c), 4);

          case 4:
            l = A.h;
            f(yv(l.headers));

            if ("HEAD" == c.method) {
              A.F(5);
              break;
            }

            u = l.clone().body.getReader();
            y = (v = l.headers.get("Content-Length")) ? parseInt(v, 10) : 0;

            z = function (C) {
              function E() {
                var H, G;
                return K(function (I) {
                  switch (I.g) {
                    case 1:
                      return ta(I, 2), D(I, u.read(), 4);

                    case 4:
                      H = I.h;
                      va(I, 3);
                      break;

                    case 2:
                      return wa(I), I.return();

                    case 3:
                      if (H.done) {
                        I.F(5);
                        break;
                      }

                      n += H.value.byteLength;

                      if (!g) {
                        I.F(5);
                        break;
                      }

                      return D(I, g(H.value), 5);

                    case 5:
                      G = Date.now();
                      if (100 < G - q || H.done) e(G - q, n - r, y - n), r = n, q = G;
                      H.done ? C.close() : (C.enqueue(H.value), E());
                      F(I);
                  }
                });
              }

              E();
            };

            new k({
              start: z
            });
            return D(A, l.arrayBuffer(), 6);

          case 6:
            m = A.h;

          case 5:
            va(A, 3);
            break;

          case 2:
            x = wa(A);
            if (d.Ag) throw new P(1, 1, 7001, a, b);
            if (d.ph) throw new P(1, 1, 1003, a, b);
            throw new P(1, 1, 1002, a, x, b);

          case 3:
            return B = yv(l.headers), A.return(qv(B, m, l.status, a, l.url, b));
        }
      });
    }

    function yv(a) {
      var b = {};
      a.forEach(function (c, d) {
        b[d.trim()] = c;
      });
      return b;
    }

    function zv() {
      if (window.ReadableStream) try {
        new ReadableStream({});
      } catch (a) {
        return !1;
      } else return !1;

      if (window.Response) {
        if (!new Response("").body) return !1;
      } else return !1;

      return !(!window.fetch || !window.AbortController);
    }

    M("shaka.net.HttpFetchPlugin", rv);
    rv.isSupported = zv;
    rv.parse = sv;
    var wv = window.fetch,
        uv = window.AbortController,
        xv = window.ReadableStream,
        tv = window.Headers;
    zv() && (wf("http", sv, 2, !0), wf("https", sv, 2, !0), wf("blob", sv, 2, !0));

    function Av() {}

    function Bv(a, b, c, d, e) {
      var f = new Cv(),
          g = Date.now(),
          h = 0,
          k = new Promise(function (l, m) {
        f.open(b.method, a, !0);
        f.responseType = "arraybuffer";
        f.timeout = b.retryParameters.timeout;
        f.withCredentials = b.allowCrossSiteCredentials;

        f.onabort = function () {
          m(new P(1, 1, 7001, a, c));
        };

        var n = !1;

        f.onreadystatechange = function () {
          if (2 == f.readyState && !n) {
            var q = Dv(f);
            e(q);
            n = !0;
          }
        };

        f.onload = function () {
          var q = Dv(f),
              u = f.response;

          try {
            var v = qv(q, u, f.status, a, f.responseURL, c);
            l(v);
          } catch (y) {
            m(y);
          }
        };

        f.onerror = function (q) {
          m(new P(1, 1, 1002, a, q, c));
        };

        f.ontimeout = function () {
          m(new P(1, 1, 1003, a, c));
        };

        f.onprogress = function (q) {
          var u = Date.now();
          if (100 < u - g || q.lengthComputable && q.loaded == q.total) d(u - g, q.loaded - h, q.total - q.loaded), h = q.loaded, g = u;
        };

        for (var r in b.headers) f.setRequestHeader(r.toLowerCase(), b.headers[r]);

        f.send(b.body);
      });
      return new mf(k, function () {
        f.abort();
        return Promise.resolve();
      });
    }

    function Dv(a) {
      var b = a.getAllResponseHeaders().trim().split("\r\n");
      a = {};
      b = t(b);

      for (var c = b.next(); !c.done; c = b.next()) c = c.value.split(": "), a[c[0].toLowerCase()] = c.slice(1).join(": ");

      return a;
    }

    M("shaka.net.HttpXHRPlugin", Av);
    Av.parse = Bv;
    var Cv = window.XMLHttpRequest;
    wf("http", Bv, 1, !0);
    wf("https", Bv, 1, !0);
    wf("blob", Bv, 1, !0);

    function Ev(a, b, c, d) {
      this.g = a;
      this.i = b;
      this.groupId = c;
      this.h = d;
    }

    function Fv(a) {
      return a.ba().map(function (b) {
        return "{" + encodeURI(b) + "}";
      }).join("") + ":" + a.cb + ":" + a.Ja;
    }

    function Gv(a, b) {
      return ok(a.g.ba(), a.g.cb, a.g.Ja, b.streaming.retryParameters);
    }

    ;

    function Hv() {
      this.h = this.j = this.i = 0;
      this.g = new Map();
      this.l = 0;
    }

    function Iv(a, b) {
      a.i += b;
      var c = a.l;
      a.l++;
      a.g.set(c, b);
      return c;
    }

    Hv.prototype.close = function (a, b) {
      if (this.g.has(a)) {
        var c = this.g.get(a);
        this.g.delete(a);
        this.j += c;
        this.h += b;
      }
    };

    function Jv(a) {
      var b = this;
      this.s = a;
      this.j = new Map();
      this.i = new Hf(function () {
        return Kv(b).catch(function () {});
      });
      this.h = [];

      this.m = function () {};

      this.l = function () {};

      this.g = new Hv();
    }

    Jv.prototype.destroy = function () {
      return this.i.destroy();
    };

    function Lv(a, b, c) {
      a.m = b;
      a.l = c;
    }

    function Kv(a) {
      var b = a.h.map(function (c) {
        return c();
      });
      a.h = [];
      return Promise.all(b);
    }

    function Mv(a, b, c, d, e, f) {
      If(a.i);
      var g = (a.j.get(b) || Promise.resolve()).then(function () {
        var h, k, l, m, n, r, q;
        return K(function (u) {
          if (1 == u.g) return D(u, Nv(a, c), 2);
          h = u.h;
          if (a.i.g) throw new P(2, 9, 7001);
          if (e) for (m in k = nc(h), l = new ug(k), l.data) n = Number(m), r = l.data[n], q = l.g[n], a.l(r, q);
          a.g.close(d, h.byteLength);
          var v = a.g;
          a.m(0 == v.i ? 0 : v.j / v.i, a.g.h);
          return u.return(f(h));
        });
      });
      a.j.set(b, g);
    }

    function Ov(a) {
      return K(function (b) {
        return 1 == b.g ? D(b, Promise.all(a.j.values()), 2) : b.return(a.g.h);
      });
    }

    function Nv(a, b) {
      var c, d, e, f;
      return K(function (g) {
        if (1 == g.g) return c = Ff, d = a.s.request(c, b), e = function () {
          return d.abort();
        }, a.h.push(e), D(g, d.promise, 2);
        f = g.h;
        xc(a.h, e);
        return g.return(f.data);
      });
    }

    ;

    function Pv(a, b) {
      var c = this;
      this.i = a;
      this.h = a.objectStore(b);
      this.g = new lf();

      a.onabort = function (d) {
        d.preventDefault();
        c.g.reject();
      };

      a.onerror = function (d) {
        d.preventDefault();
        c.g.reject();
      };

      a.oncomplete = function () {
        c.g.resolve();
      };
    }

    Pv.prototype.abort = function () {
      var a = this;
      return K(function (b) {
        if (1 == b.g) {
          try {
            a.i.abort();
          } catch (c) {}

          ta(b, 2);
          return D(b, a.g, 4);
        }

        if (2 != b.g) return va(b, 0);
        wa(b);
        F(b);
      });
    };

    function Qv(a, b) {
      return new Promise(function (c, d) {
        var e = a.h.openCursor();
        e.onerror = d;

        e.onsuccess = function () {
          var f;
          return K(function (g) {
            if (1 == g.g) {
              if (null == e.result) return c(), g.return();
              f = e.result;
              return D(g, b(f.key, f.value, f), 2);
            }

            f.continue();
            F(g);
          });
        };
      });
    }

    Pv.prototype.store = function () {
      return this.h;
    };

    Pv.prototype.promise = function () {
      return this.g;
    };

    function Rv(a) {
      this.h = a;
      this.g = [];
    }

    Rv.prototype.destroy = function () {
      return Promise.all(this.g.map(function (a) {
        return a.abort();
      }));
    };

    function Sv(a, b) {
      return Tv(a, b, "readwrite");
    }

    function Tv(a, b, c) {
      c = a.h.transaction([b], c);
      var d = new Pv(c, b);
      a.g.push(d);
      d.promise().then(function () {
        xc(a.g, d);
      }, function () {
        xc(a.g, d);
      });
      return d;
    }

    ;

    function Uv(a, b, c) {
      this.h = new Rv(a);
      this.i = b;
      this.g = c;
    }

    p = Uv.prototype;

    p.destroy = function () {
      return this.h.destroy();
    };

    p.hasFixedKeySpace = function () {
      return !0;
    };

    p.addSegments = function () {
      return Vv(this.i);
    };

    p.removeSegments = function (a, b) {
      return Wv(this, this.i, a, b);
    };

    p.getSegments = function (a) {
      var b = this,
          c;
      return K(function (d) {
        if (1 == d.g) return D(d, Xv(b, b.i, a), 2);
        c = d.h;
        return d.return(c.map(function (e) {
          return b.Eg(e);
        }));
      });
    };

    p.addManifests = function () {
      return Vv(this.g);
    };

    p.updateManifest = function () {
      return Promise.reject(new P(2, 9, 9016, "Cannot modify values in " + this.g));
    };

    function Yv(a, b, c) {
      a = Sv(a.h, a.g);
      var d = a.store();

      d.get(b).onsuccess = function () {
        d.put(c, b);
      };

      return a.promise();
    }

    p.updateManifestExpiration = function (a, b) {
      var c = Sv(this.h, this.g),
          d = c.store();

      d.get(a).onsuccess = function (e) {
        if (e = e.target.result) e.expiration = b, d.put(e, a);
      };

      return c.promise();
    };

    p.removeManifests = function (a, b) {
      return Wv(this, this.g, a, b);
    };

    p.getManifests = function (a) {
      var b = this,
          c;
      return K(function (d) {
        if (1 == d.g) return D(d, Xv(b, b.g, a), 2);
        c = d.h;
        return d.return(Promise.all(c.map(function (e) {
          return b.nd(e);
        })));
      });
    };

    p.getAllManifests = function () {
      var a = this,
          b,
          c;
      return K(function (d) {
        return 1 == d.g ? (b = Tv(a.h, a.g, "readonly"), c = new Map(), D(d, Qv(b, function (e, f) {
          var g;
          return K(function (h) {
            if (1 == h.g) return D(h, a.nd(f), 2);
            g = h.h;
            c.set(e, g);
            F(h);
          });
        }), 2)) : 3 != d.g ? D(d, b.promise(), 3) : d.return(c);
      });
    };

    p.Eg = function (a) {
      return a;
    };

    p.nd = function (a) {
      return Promise.resolve(a);
    };

    function Vv(a) {
      return Promise.reject(new P(2, 9, 9011, "Cannot add new value to " + a));
    }

    p.add = function (a, b) {
      var c = this,
          d,
          e,
          f,
          g,
          h,
          k,
          l;
      return K(function (m) {
        if (1 == m.g) {
          d = Sv(c.h, a);
          e = d.store();
          f = [];
          g = {};
          h = t(b);

          for (k = h.next(); !k.done; g = {
            Rd: g.Rd
          }, k = h.next()) l = k.value, g.Rd = e.add(l), g.Rd.onsuccess = function (n) {
            return function () {
              f.push(n.Rd.result);
            };
          }(g);

          return D(m, d.promise(), 2);
        }

        return m.return(f);
      });
    };

    function Wv(a, b, c, d) {
      a = Sv(a.h, b);
      b = a.store();
      var e = {};
      c = t(c);

      for (var f = c.next(); !f.done; e = {
        Pd: e.Pd
      }, f = c.next()) e.Pd = f.value, b.delete(e.Pd).onsuccess = function (g) {
        return function () {
          return d(g.Pd);
        };
      }(e);

      return a.promise();
    }

    function Xv(a, b, c) {
      var d, e, f, g, h, k, l;
      return K(function (m) {
        if (1 == m.g) {
          d = Tv(a.h, b, "readonly");
          e = d.store();
          f = {};
          g = [];
          h = {};
          k = t(c);

          for (l = k.next(); !l.done; h = {
            cd: h.cd,
            Zc: h.Zc
          }, l = k.next()) h.Zc = l.value, h.cd = e.get(h.Zc), h.cd.onsuccess = function (n) {
            return function () {
              void 0 == n.cd.result && g.push(n.Zc);
              f[n.Zc] = n.cd.result;
            };
          }(h);

          return D(m, d.promise(), 2);
        }

        if (g.length) throw new P(2, 9, 9012, "Could not find values for " + g);
        return m.return(c.map(function (n) {
          return f[n];
        }));
      });
    }

    ;

    function Zv(a) {
      this.g = new Rv(a);
    }

    Zv.prototype.destroy = function () {
      return this.g.destroy();
    };

    Zv.prototype.getAll = function () {
      var a = this,
          b,
          c;
      return K(function (d) {
        return 1 == d.g ? (b = Tv(a.g, "session-ids", "readonly"), c = [], D(d, Qv(b, function (e, f) {
          c.push(f);
        }), 2)) : 3 != d.g ? D(d, b.promise(), 3) : d.return(c);
      });
    };

    Zv.prototype.add = function (a) {
      var b = Sv(this.g, "session-ids"),
          c = b.store();
      a = t(a);

      for (var d = a.next(); !d.done; d = a.next()) c.add(d.value);

      return b.promise();
    };

    Zv.prototype.remove = function (a) {
      var b = this,
          c;
      return K(function (d) {
        return 1 == d.g ? (c = Sv(b.g, "session-ids"), D(d, Qv(c, function (e, f, g) {
          a.includes(f.sessionId) && g.delete();
        }), 2)) : D(d, c.promise(), 0);
      });
    };

    function $v() {
      this.g = new Map();
    }

    $v.prototype.destroy = function () {
      for (var a = [], b = t(this.g.values()), c = b.next(); !c.done; c = b.next()) a.push(c.value.destroy());

      this.g.clear();
      return Promise.all(a);
    };

    $v.prototype.init = function () {
      var a = this;
      aw.forEach(function (e, f) {
        (e = e()) && a.g.set(f, e);
      });

      for (var b = [], c = t(this.g.values()), d = c.next(); !d.done; d = c.next()) b.push(d.value.init());

      return Promise.all(b);
    };

    function bw(a) {
      var b = null;
      a.g.forEach(function (c, d) {
        c.getCells().forEach(function (e, f) {
          e.hasFixedKeySpace() || b || (b = {
            path: {
              kb: d,
              Oa: f
            },
            Oa: e
          });
        });
      });
      if (b) return b;
      throw new P(2, 9, 9013, "Could not find a cell that supports add-operations");
    }

    function cw(a, b) {
      a.g.forEach(function (c, d) {
        c.getCells().forEach(function (e, f) {
          b({
            kb: d,
            Oa: f
          }, e);
        });
      });
    }

    function dw(a, b, c) {
      a = a.g.get(b);
      if (!a) throw new P(2, 9, 9013, "Could not find mechanism with name " + b);
      b = a.getCells().get(c);
      if (!b) throw new P(2, 9, 9013, "Could not find cell with name " + c);
      return b;
    }

    function ew(a, b) {
      a.g.forEach(function (c) {
        b(c.getEmeSessionCell());
      });
    }

    function fw(a) {
      var b = Array.from(a.g.keys());
      if (!b.length) throw new P(2, 9, 9E3, "No supported storage mechanisms found");
      return a.g.get(b[0]).getEmeSessionCell();
    }

    function gw(a) {
      var b, c, d;
      return K(function (e) {
        return 1 == e.g ? (b = Array.from(a.g.values()), c = 0 < b.length, c || (d = aw, d.forEach(function (f) {
          (f = f()) && b.push(f);
        })), D(e, Promise.all(b.map(function (f) {
          return f.erase();
        })), 2)) : c ? e.F(0) : D(e, Promise.all(b.map(function (f) {
          return f.destroy();
        })), 0);
      });
    }

    function hw(a, b) {
      aw.set(a, b);
    }

    M("shaka.offline.StorageMuxer", $v);

    $v.unregister = function (a) {
      aw.delete(a);
    };

    $v.register = hw;
    $v.prototype.destroy = $v.prototype.destroy;
    var aw = new Map();

    function iw() {
      Uv.apply(this, arguments);
    }

    pa(iw, Uv);

    iw.prototype.updateManifestExpiration = function (a, b) {
      var c = this,
          d,
          e,
          f;
      return K(function (g) {
        d = Sv(c.h, c.g);
        e = d.store();
        f = new lf();

        e.get(a).onsuccess = function (h) {
          (h = h.target.result) ? (h.expiration = b, e.put(h), f.resolve()) : f.reject(new P(2, 9, 9012, "Could not find values for " + a));
        };

        return D(g, Promise.all([d.promise(), f]), 0);
      });
    };

    iw.prototype.nd = function (a) {
      var b, c, d, e, f, g;
      return K(function (h) {
        if (1 == h.g) {
          b = [];

          for (c = 0; c < a.periods.length; ++c) d = c == a.periods.length - 1 ? a.duration : a.periods[c + 1].startTime, e = d - a.periods[c].startTime, f = jw(a.periods[c], e), b.push(f);

          return D(h, Yr(b), 2);
        }

        g = h.h;
        return h.return({
          creationTime: 0,
          originalManifestUri: a.originalManifestUri,
          duration: a.duration,
          size: a.size,
          expiration: null == a.expiration ? Infinity : a.expiration,
          streams: g,
          sessionIds: a.sessionIds,
          drmInfo: a.drmInfo,
          appMetadata: a.appMetadata,
          sequenceMode: !1
        });
      });
    };

    function jw(a, b) {
      kw(a);

      for (var c = t(a.streams), d = c.next(); !d.done; d = c.next());

      return a.streams.map(function (e) {
        return lw(e, a.startTime, b);
      });
    }

    function lw(a, b, c) {
      var d = a.initSegmentUri ? mw(a.initSegmentUri) : null,
          e = b + a.presentationTimeOffset,
          f = b + c;
      return {
        id: a.id,
        originalId: null,
        groupId: null,
        primary: a.primary,
        type: a.contentType,
        mimeType: a.mimeType,
        codecs: a.codecs,
        frameRate: a.frameRate,
        pixelAspectRatio: void 0,
        hdr: void 0,
        videoLayout: void 0,
        kind: a.kind,
        language: a.language,
        originalLanguage: a.language || null,
        label: a.label,
        width: a.width,
        height: a.height,
        initSegmentKey: d,
        encrypted: a.encrypted,
        keyIds: new Set([a.keyId]),
        segments: a.segments.map(function (g) {
          var h = mw(g.uri);
          return {
            startTime: b + g.startTime,
            endTime: b + g.endTime,
            dataKey: h,
            initSegmentKey: d,
            appendWindowStart: b,
            appendWindowEnd: f,
            timestampOffset: e,
            tilesLayout: ""
          };
        }),
        variantIds: a.variantIds,
        roles: [],
        forced: !1,
        audioSamplingRate: null,
        channelsCount: null,
        spatialAudio: !1,
        closedCaptions: null,
        tilesLayout: void 0,
        external: !1,
        fastSwitching: !1
      };
    }

    iw.prototype.Eg = function (a) {
      return {
        data: a.data
      };
    };

    function mw(a) {
      var b;
      if ((b = /^offline:[0-9]+\/[0-9]+\/([0-9]+)$/.exec(a)) || (b = /^offline:segment\/([0-9]+)$/.exec(a))) return Number(b[1]);
      throw new P(2, 9, 9004, "Could not parse uri " + a);
    }

    function kw(a) {
      var b = a.streams.filter(function (h) {
        return "audio" == h.contentType;
      });
      a = a.streams.filter(function (h) {
        return "video" == h.contentType;
      });

      if (!b.every(function (h) {
        return h.variantIds;
      }) || !a.every(function (h) {
        return h.variantIds;
      })) {
        for (var c = t(b), d = c.next(); !d.done; d = c.next()) d.value.variantIds = [];

        c = t(a);

        for (d = c.next(); !d.done; d = c.next()) d.value.variantIds = [];

        c = 0;

        if (a.length && !b.length) {
          var e = c++,
              f = t(a);

          for (d = f.next(); !d.done; d = f.next()) d.value.variantIds.push(e);
        }

        if (!a.length && b.length) for (e = c++, f = t(b), d = f.next(); !d.done; d = f.next()) d.value.variantIds.push(e);
        if (a.length && b.length) for (b = t(b), d = b.next(); !d.done; d = b.next()) for (d = d.value, e = t(a), f = e.next(); !f.done; f = e.next()) {
          f = f.value;
          var g = c++;
          d.variantIds.push(g);
          f.variantIds.push(g);
        }
      }
    }

    ;

    function nw() {
      Uv.apply(this, arguments);
    }

    pa(nw, Uv);

    nw.prototype.nd = function (a) {
      var b, c, d, e, f, g;
      return K(function (h) {
        if (1 == h.g) {
          b = [];

          for (c = 0; c < a.periods.length; ++c) {
            d = c == a.periods.length - 1 ? a.duration : a.periods[c + 1].startTime;
            e = d - a.periods[c].startTime;

            for (var k = a.periods[c], l = [], m = t(k.streams), n = m.next(); !n.done; n = m.next()) n = n.value, 0 != n.variantIds.length && l.push(ow(n, k.startTime, k.startTime + e));

            f = l;
            b.push(f);
          }

          return D(h, Yr(b), 2);
        }

        g = h.h;
        return h.return({
          appMetadata: a.appMetadata,
          creationTime: 0,
          drmInfo: a.drmInfo,
          duration: a.duration,
          expiration: null == a.expiration ? Infinity : a.expiration,
          originalManifestUri: a.originalManifestUri,
          sessionIds: a.sessionIds,
          size: a.size,
          streams: g,
          sequenceMode: !1
        });
      });
    };

    function ow(a, b, c) {
      return {
        id: a.id,
        originalId: a.originalId,
        groupId: null,
        primary: a.primary,
        type: a.contentType,
        mimeType: a.mimeType,
        codecs: a.codecs,
        frameRate: a.frameRate,
        pixelAspectRatio: a.pixelAspectRatio,
        hdr: void 0,
        videoLayout: void 0,
        kind: a.kind,
        language: a.language,
        originalLanguage: a.language || null,
        label: a.label,
        width: a.width,
        height: a.height,
        encrypted: a.encrypted,
        keyIds: new Set([a.keyId]),
        segments: a.segments.map(function (d) {
          return {
            startTime: b + d.startTime,
            endTime: b + d.endTime,
            initSegmentKey: a.initSegmentKey,
            appendWindowStart: b,
            appendWindowEnd: c,
            timestampOffset: b - a.presentationTimeOffset,
            dataKey: d.dataKey,
            tilesLayout: ""
          };
        }),
        variantIds: a.variantIds,
        roles: [],
        forced: !1,
        audioSamplingRate: null,
        channelsCount: null,
        spatialAudio: !1,
        closedCaptions: null,
        tilesLayout: void 0,
        external: !1,
        fastSwitching: !1
      };
    }

    ;

    function pw() {
      Uv.apply(this, arguments);
    }

    pa(pw, Uv);
    p = pw.prototype;

    p.hasFixedKeySpace = function () {
      return !1;
    };

    p.addSegments = function (a) {
      return this.add(this.i, a);
    };

    p.addManifests = function (a) {
      return this.add(this.g, a);
    };

    p.updateManifest = function (a, b) {
      return Yv(this, a, b);
    };

    p.nd = function (a) {
      null == a.expiration && (a.expiration = Infinity);
      return Promise.resolve(a);
    };

    function qw() {
      this.m = this.j = this.i = this.h = this.g = this.l = null;
    }

    p = qw.prototype;

    p.init = function () {
      var a = this,
          b = new lf(),
          c = !1,
          d = new Fd(function () {
        c = !0;
        b.reject(new P(2, 9, 9017));
      });
      d.R(5);
      var e = window.indexedDB.open("shaka_offline_db", 5);

      e.onsuccess = function () {
        if (!c) {
          var f = e.result;
          a.l = f;
          var g = f.objectStoreNames;
          g = g.contains("manifest") && g.contains("segment") ? new iw(f, "segment", "manifest") : null;
          a.g = g;
          g = f.objectStoreNames;
          g = g.contains("manifest-v2") && g.contains("segment-v2") ? new nw(f, "segment-v2", "manifest-v2") : null;
          a.h = g;
          g = f.objectStoreNames;
          g = g.contains("manifest-v3") && g.contains("segment-v3") ? new nw(f, "segment-v3", "manifest-v3") : null;
          a.i = g;
          g = f.objectStoreNames;
          g = g.contains("manifest-v5") && g.contains("segment-v5") ? new pw(f, "segment-v5", "manifest-v5") : null;
          a.j = g;
          f = f.objectStoreNames.contains("session-ids") ? new Zv(f) : null;
          a.m = f;
          d.stop();
          b.resolve();
        }
      };

      e.onupgradeneeded = function () {
        for (var f = e.result, g = t(["segment-v5", "manifest-v5", "session-ids"]), h = g.next(); !h.done; h = g.next()) h = h.value, f.objectStoreNames.contains(h) || f.createObjectStore(h, {
          autoIncrement: !0
        });
      };

      e.onerror = function (f) {
        c || (b.reject(new P(2, 9, 9001, e.error)), d.stop(), f.preventDefault());
      };

      return b;
    };

    p.destroy = function () {
      var a = this;
      return K(function (b) {
        switch (b.g) {
          case 1:
            if (!a.g) {
              b.F(2);
              break;
            }

            return D(b, a.g.destroy(), 2);

          case 2:
            if (!a.h) {
              b.F(4);
              break;
            }

            return D(b, a.h.destroy(), 4);

          case 4:
            if (!a.i) {
              b.F(6);
              break;
            }

            return D(b, a.i.destroy(), 6);

          case 6:
            if (!a.j) {
              b.F(8);
              break;
            }

            return D(b, a.j.destroy(), 8);

          case 8:
            if (!a.m) {
              b.F(10);
              break;
            }

            return D(b, a.m.destroy(), 10);

          case 10:
            a.l && a.l.close(), F(b);
        }
      });
    };

    p.getCells = function () {
      var a = new Map();
      this.g && a.set("v1", this.g);
      this.h && a.set("v2", this.h);
      this.i && a.set("v3", this.i);
      this.j && a.set("v5", this.j);
      return a;
    };

    p.getEmeSessionCell = function () {
      return this.m;
    };

    p.erase = function () {
      var a = this;
      return K(function (b) {
        switch (b.g) {
          case 1:
            if (!a.g) {
              b.F(2);
              break;
            }

            return D(b, a.g.destroy(), 2);

          case 2:
            if (!a.h) {
              b.F(4);
              break;
            }

            return D(b, a.h.destroy(), 4);

          case 4:
            if (!a.i) {
              b.F(6);
              break;
            }

            return D(b, a.i.destroy(), 6);

          case 6:
            if (!a.j) {
              b.F(8);
              break;
            }

            return D(b, a.j.destroy(), 8);

          case 8:
            return a.l && a.l.close(), D(b, rw(), 10);

          case 10:
            return a.l = null, a.g = null, a.h = null, a.i = null, a.j = null, D(b, a.init(), 0);
        }
      });
    };

    function rw() {
      var a = new lf(),
          b = window.indexedDB.deleteDatabase("shaka_offline_db");

      b.onblocked = function () {};

      b.onsuccess = function () {
        a.resolve();
      };

      b.onerror = function (c) {
        a.reject(new P(2, 9, 9001, b.error));
        c.preventDefault();
      };

      return a;
    }

    hw("idb", function () {
      return Ld("CrKey") || Kd() || !window.indexedDB ? null : new qw();
    });

    function sw(a, b, c, d) {
      this.g = a;
      this.i = b;
      this.h = c;
      this.l = d;
      this.j = ["offline:", a, "/", b, "/", c, "/", d].join("");
    }

    sw.prototype.kb = function () {
      return this.i;
    };

    sw.prototype.Oa = function () {
      return this.h;
    };

    sw.prototype.key = function () {
      return this.l;
    };

    sw.prototype.toString = function () {
      return this.j;
    };

    function tw(a) {
      a = /^offline:([a-z]+)\/([^/]+)\/([^/]+)\/([0-9]+)$/.exec(a);
      if (null == a) return null;
      var b = a[1];
      if ("manifest" != b && "segment" != b) return null;
      var c = a[2];
      if (!c) return null;
      var d = a[3];
      return d && null != b ? new sw(b, c, d, Number(a[4])) : null;
    }

    ;

    function uw(a, b) {
      this.h = a;
      this.g = b;
    }

    function vw(a, b) {
      var c = new sj(null, 0);
      c.bb(b.duration);
      var d = b.streams.filter(function (l) {
        return "audio" == l.type;
      }),
          e = b.streams.filter(function (l) {
        return "video" == l.type;
      });
      d = ww(a, d, e, c);
      e = b.streams.filter(function (l) {
        return l.type == Mb;
      }).map(function (l) {
        return xw(a, l, c);
      });
      var f = b.streams.filter(function (l) {
        return "image" == l.type;
      }).map(function (l) {
        return xw(a, l, c);
      }),
          g = b.drmInfo ? [b.drmInfo] : [];
      if (b.drmInfo) for (var h = t(d.values()), k = h.next(); !k.done; k = h.next()) k = k.value, k.audio && k.audio.encrypted && (k.audio.drmInfos = g), k.video && k.video.encrypted && (k.video.drmInfos = g);
      return {
        presentationTimeline: c,
        minBufferTime: 2,
        offlineSessionIds: b.sessionIds,
        variants: Array.from(d.values()),
        textStreams: e,
        imageStreams: f,
        sequenceMode: b.sequenceMode || !1,
        ignoreManifestTimestampsInSegmentsMode: !1,
        type: b.type || "UNKNOWN",
        serviceDescription: null
      };
    }

    function ww(a, b, c, d) {
      for (var e = new Set(), f = t(b), g = f.next(); !g.done; g = f.next()) {
        var h = t(g.value.variantIds);

        for (g = h.next(); !g.done; g = h.next()) e.add(g.value);
      }

      f = t(c);

      for (g = f.next(); !g.done; g = f.next()) for (h = t(g.value.variantIds), g = h.next(); !g.done; g = h.next()) e.add(g.value);

      f = new Map();
      e = t(e);

      for (g = e.next(); !g.done; g = e.next()) g = g.value, f.set(g, {
        id: g,
        language: "",
        disabledUntilTime: 0,
        primary: !1,
        audio: null,
        video: null,
        bandwidth: 0,
        allowedByApplication: !0,
        allowedByKeySystem: !0,
        decodingInfos: []
      });

      b = t(b);

      for (e = b.next(); !e.done; e = b.next()) for (e = e.value, g = xw(a, e, d), h = t(e.variantIds), e = h.next(); !e.done; e = h.next()) e = f.get(e.value), e.language = g.language, e.primary = e.primary || g.primary, e.audio = g;

      c = t(c);

      for (b = c.next(); !b.done; b = c.next()) for (e = b.value, b = xw(a, e, d), g = t(e.variantIds), e = g.next(); !e.done; e = g.next()) e = f.get(e.value), e.primary = e.primary || b.primary, e.video = b;

      return f;
    }

    function xw(a, b, c) {
      var d = b.segments.map(function (e) {
        return yw(a, e);
      });
      c.Bd(d);
      return {
        id: b.id,
        originalId: b.originalId,
        groupId: b.groupId,
        createSegmentIndex: function () {
          return Promise.resolve();
        },
        segmentIndex: new Oj(d),
        mimeType: b.mimeType,
        codecs: b.codecs,
        width: b.width || void 0,
        height: b.height || void 0,
        frameRate: b.frameRate,
        pixelAspectRatio: b.pixelAspectRatio,
        hdr: b.hdr,
        videoLayout: b.videoLayout,
        kind: b.kind,
        encrypted: b.encrypted,
        drmInfos: [],
        keyIds: b.keyIds,
        language: b.language,
        originalLanguage: b.originalLanguage || null,
        label: b.label,
        type: b.type,
        primary: b.primary,
        trickModeVideo: null,
        emsgSchemeIdUris: null,
        roles: b.roles,
        forced: b.forced,
        channelsCount: b.channelsCount,
        audioSamplingRate: b.audioSamplingRate,
        spatialAudio: b.spatialAudio,
        closedCaptions: b.closedCaptions,
        tilesLayout: b.tilesLayout,
        accessibilityPurpose: null,
        external: b.external,
        fastSwitching: b.fastSwitching
      };
    }

    function yw(a, b) {
      var c = new sw("segment", a.h, a.g, b.dataKey);
      return new Ph(b.startTime, b.endTime, function () {
        return [c.toString()];
      }, 0, null, null != b.initSegmentKey ? zw(a, b.initSegmentKey) : null, b.timestampOffset, b.appendWindowStart, b.appendWindowEnd, [], b.tilesLayout || "");
    }

    function zw(a, b) {
      var c = new sw("segment", a.h, a.g, b);
      return new Nh(function () {
        return [c.toString()];
      }, 0, null);
    }

    ;

    function Aw() {
      this.g = null;
    }

    p = Aw.prototype;

    p.configure = function () {};

    p.start = function (a, b) {
      var c = this,
          d,
          e,
          f,
          g,
          h,
          k,
          l;
      return K(function (m) {
        switch (m.g) {
          case 1:
            d = tw(a);
            c.g = d;
            if (null == d || "manifest" != d.g) throw new P(2, 1, 9004, a);
            e = new $v();
            ua(m, 2);
            return D(m, e.init(), 4);

          case 4:
            return D(m, dw(e, d.kb(), d.Oa()), 5);

          case 5:
            return f = m.h, D(m, f.getManifests([d.key()]), 6);

          case 6:
            return g = m.h, h = g[0], k = new uw(d.kb(), d.Oa()), l = vw(k, h), b.makeTextStreamsForClosedCaptions(l), m.return(l);

          case 2:
            return xa(m), D(m, e.destroy(), 7);

          case 7:
            ya(m, 0);
        }
      });
    };

    p.stop = function () {
      return Promise.resolve();
    };

    p.update = function () {};

    p.onExpirationUpdated = function (a, b) {
      var c = this,
          d,
          e,
          f,
          g,
          h,
          k,
          l;
      return K(function (m) {
        switch (m.g) {
          case 1:
            return d = c.g, e = new $v(), ta(m, 2, 3), D(m, e.init(), 5);

          case 5:
            return D(m, dw(e, d.kb(), d.Oa()), 6);

          case 6:
            return f = m.h, D(m, f.getManifests([d.key()]), 7);

          case 7:
            g = m.h;
            h = g[0];
            k = h.sessionIds.includes(a);
            l = void 0 == h.expiration || h.expiration > b;

            if (!k || !l) {
              m.F(3);
              break;
            }

            return D(m, f.updateManifestExpiration(d.key(), b), 3);

          case 3:
            return xa(m), D(m, e.destroy(), 10);

          case 10:
            ya(m, 0);
            break;

          case 2:
            wa(m), m.F(3);
        }
      });
    };

    p.onInitialVariantChosen = function () {};

    p.banLocation = function () {};

    Ih["application/x-offline-manifest"] = function () {
      return new Aw();
    };

    function Bw() {}

    function Cw(a) {
      var b = tw(a);
      b && "manifest" == b.g ? (a = {
        uri: a,
        originalUri: a,
        data: new ArrayBuffer(0),
        headers: {
          "content-type": "application/x-offline-manifest"
        }
      }, a = pf(a)) : a = b && "segment" == b.g ? Dw(b.key(), b) : nf(new P(2, 1, 9004, a));
      return a;
    }

    function Dw(a, b) {
      var c = new $v();
      return pf(void 0).Da(function () {
        return c.init();
      }).Da(function () {
        return dw(c, b.kb(), b.Oa());
      }).Da(function (d) {
        return d.getSegments([b.key()]);
      }).Da(function (d) {
        return {
          uri: b,
          data: d[0].data,
          headers: {}
        };
      }).finally(function () {
        return c.destroy();
      });
    }

    M("shaka.offline.OfflineScheme", Bw);
    Bw.plugin = Cw;
    wf("offline", Cw);

    function Ew(a, b, c) {
      var d, e, f, g, h, k;
      return K(function (l) {
        switch (l.g) {
          case 1:
            d = [];

            for (var m = [], n = t(c), r = n.next(); !r.done; r = n.next()) {
              r = r.value;

              for (var q = !1, u = t(m), v = u.next(); !v.done; v = u.next()) if (v = v.value, Fw(v.info, r)) {
                v.sessionIds.push(r.sessionId);
                q = !0;
                break;
              }

              q || m.push({
                info: r,
                sessionIds: [r.sessionId]
              });
            }

            e = t(m);
            f = e.next();

          case 2:
            if (f.done) {
              l.F(4);
              break;
            }

            g = f.value;
            h = Gw(a, b, g);
            return D(l, h, 5);

          case 5:
            k = l.h;
            d = d.concat(k);
            f = e.next();
            l.F(2);
            break;

          case 4:
            return l.return(d);
        }
      });
    }

    function Gw(a, b, c) {
      var d, e;
      return K(function (f) {
        switch (f.g) {
          case 1:
            return d = new Sg({
              vc: b,
              onError: function () {},
              ze: function () {},
              onExpirationUpdated: function () {},
              onEvent: function () {}
            }), ta(f, 2), d.configure(a), D(f, $g(d, c.info.keySystem, c.info.licenseUri, c.info.serverCertificate, c.info.audioCapabilities, c.info.videoCapabilities), 4);

          case 4:
            va(f, 3);
            break;

          case 2:
            return wa(f), D(f, d.destroy(), 5);

          case 5:
            return f.return([]);

          case 3:
            return ta(f, 6), D(f, kh(d), 8);

          case 8:
            va(f, 7);
            break;

          case 6:
            return wa(f), D(f, d.destroy(), 9);

          case 9:
            return f.return([]);

          case 7:
            return e = [], D(f, Promise.all(c.sessionIds.map(function (g) {
              return K(function (h) {
                if (1 == h.g) return ta(h, 2), D(h, lh(d, g), 4);
                if (2 != h.g) return e.push(g), va(h, 0);
                wa(h);
                F(h);
              });
            })), 10);

          case 10:
            return D(f, d.destroy(), 11);

          case 11:
            return f.return(e);
        }
      });
    }

    function Fw(a, b) {
      function c(d, e) {
        return d.robustness == e.robustness && d.contentType == e.contentType;
      }

      return a.keySystem == b.keySystem && a.licenseUri == b.licenseUri && yc(a.audioCapabilities, b.audioCapabilities, c) && yc(a.videoCapabilities, b.videoCapabilities, c);
    }

    ;

    function Hw(a, b, c) {
      var d = b.presentationTimeline.getDuration();
      b = Iw(b);
      return {
        offlineUri: null,
        originalManifestUri: a,
        duration: d,
        size: 0,
        expiration: Infinity,
        tracks: b,
        appMetadata: c,
        isIncomplete: !1
      };
    }

    function Jw(a, b) {
      var c = vw(new uw(a.kb(), a.Oa()), b),
          d = b.appMetadata || {};
      c = Iw(c);
      return {
        offlineUri: a.toString(),
        originalManifestUri: b.originalManifestUri,
        duration: b.duration,
        size: b.size,
        expiration: b.expiration,
        tracks: c,
        appMetadata: d,
        isIncomplete: b.isIncomplete || !1
      };
    }

    function Iw(a) {
      var b = [],
          c = Ce(a.variants);
      c = t(c);

      for (var d = c.next(); !d.done; d = c.next()) b.push(te(d.value));

      a = t(a.textStreams);

      for (c = a.next(); !c.done; c = a.next()) b.push(ue(c.value));

      return b;
    }

    ;

    function Kw() {
      this.g = {};
    }

    function Lw(a, b) {
      var c = b.audio,
          d = b.video;
      c && !d && (a.g[c.id] = c.bandwidth || b.bandwidth);
      !c && d && (a.g[d.id] = d.bandwidth || b.bandwidth);

      if (c && d) {
        var e = c.bandwidth || 393216,
            f = d.bandwidth || b.bandwidth - e;
        0 >= f && (f = b.bandwidth);
        a.g[c.id] = e;
        a.g[d.id] = f;
      }
    }

    function Mw(a, b) {
      a.g[b.id] = b.bandwidth || 2048;
    }

    function Nw(a, b) {
      a = a.g[b];
      null == a && (a = 0);
      return a;
    }

    ;

    function Ow(a) {
      var b = this;
      if (a && a.constructor != W) throw new P(2, 9, 9008);
      this.g = this.h = null;
      a ? (this.h = a.h, this.g = a.Tb()) : (this.h = $l(), this.g = new vf());
      this.i = [];
      this.j = [];
      var c = !a;
      this.l = new Hf(function () {
        var d, e, f, g, h;
        return K(function (k) {
          switch (k.g) {
            case 1:
              return D(k, Promise.all(b.j.map(function (l) {
                return Kv(l);
              })), 2);

            case 2:
              d = function () {};

              e = [];
              f = t(b.i);

              for (g = f.next(); !g.done; g = f.next()) h = g.value, e.push(h.then(d, d));

              return D(k, Promise.all(e), 3);

            case 3:
              if (!c) {
                k.F(4);
                break;
              }

              return D(k, b.g.destroy(), 4);

            case 4:
              b.h = null, b.g = null, F(k);
          }
        });
      });
    }

    function Pw() {
      if (Gd()) a: {
        var a = t(aw.values());

        for (var b = a.next(); !b.done; b = a.next()) if (b = b.value, b = b()) {
          b.destroy();
          a = !0;
          break a;
        }

        a = !1;
      } else a = !1;
      return a;
    }

    p = Ow.prototype;

    p.destroy = function () {
      return this.l.destroy();
    };

    p.configure = function (a, b) {
      2 == arguments.length && "string" == typeof a && (a = Ql(a, b));
      return bm(this.h, a);
    };

    p.getConfiguration = function () {
      var a = $l();
      bm(a, this.h, $l());
      return a;
    };

    p.Tb = function () {
      return this.g;
    };

    p.store = function (a, b, c) {
      var d = this,
          e = this.getConfiguration(),
          f = new Jv(this.g);
      this.j.push(f);
      b = Qw(this, a, b || {}, function () {
        var g;
        return K(function (h) {
          if (1 == h.g) return c ? h.F(2) : D(h, Vk(a, d.g, e.manifest.retryParameters), 3);
          2 != h.g && (c = h.h);
          g = Hh(a, c || null);
          return h.return(g());
        });
      }, e, f);
      b = new mf(b, function () {
        return Kv(f);
      });
      b.finally(function () {
        xc(d.j, f);
      });
      return Rw(this, b);
    };

    function Qw(a, b, c, d, e, f) {
      var g, h, k, l, m, n, r, q, u, v, y, z, x, B;
      return K(function (A) {
        switch (A.g) {
          case 1:
            return Sw(), h = g = null, k = new $v(), n = m = l = null, ta(A, 2, 3), D(A, d(), 5);

          case 5:
            return g = A.h, D(A, Tw(a, b, g, e), 6);

          case 6:
            r = A.h;
            Uw(a);
            q = !r.presentationTimeline.S() && !r.presentationTimeline.rc();
            if (!q) throw new P(2, 9, 9005, b);
            return D(A, Vw(a, r, function (C) {
              n = n || C;
            }, e), 7);

          case 7:
            h = A.h;
            Uw(a);
            if (n) throw n;
            return D(A, Ww(r, h, e), 8);

          case 8:
            return D(A, k.init(), 9);

          case 9:
            return Uw(a), D(A, bw(k), 10);

          case 10:
            return l = A.h, Uw(a), u = Xw(h, r, b, c, e, f), v = u.Ii, y = u.pg, D(A, l.Oa.addManifests([v]), 11);

          case 11:
            z = A.h;
            Uw(a);
            m = z[0];
            Uw(a);
            if (n) throw n;
            return D(A, Yw(a, y, m, v, f, e, l.Oa, r, h), 12);

          case 12:
            return Uw(a), x = new sw("manifest", l.path.kb, l.path.Oa, m), A.return(Jw(x, v));

          case 3:
            return xa(A), D(A, k.destroy(), 13);

          case 13:
            if (!g) {
              A.F(14);
              break;
            }

            return D(A, g.stop(), 14);

          case 14:
            if (!h) {
              A.F(16);
              break;
            }

            return D(A, h.destroy(), 16);

          case 16:
            ya(A, 0);
            break;

          case 2:
            B = wa(A);

            if (null == m) {
              A.F(18);
              break;
            }

            return D(A, Zw(m), 18);

          case 18:
            throw n || B;
        }
      });
    }

    function Yw(a, b, c, d, e, f, g, h, k) {
      var l, m, n, r, q, u, v, y, z, x;
      return K(function (B) {
        switch (B.g) {
          case 1:
            l = {};
            m = 0;

            n = function (A, C) {
              var E, H, G, I, J, L, O;
              return K(function (Q) {
                if (1 == Q.g) {
                  E = {};
                  H = t(A);

                  for (G = H.next(); !G.done; E = {
                    dc: E.dc
                  }, G = H.next()) E.dc = G.value, I = Gv(E.dc, f), J = E.dc.i, L = E.dc.h, O = function (V) {
                    return function (U) {
                      var oa, la, Qa;
                      return K(function (Xa) {
                        if (1 == Xa.g) return D(Xa, g.addSegments([{
                          data: U
                        }]), 2);
                        oa = Xa.h;
                        Uw(a);
                        la = V.dc.g;
                        Qa = Fv(la);
                        l[Qa] = oa[0];
                        m += U.byteLength;
                        F(Xa);
                      });
                    };
                  }(E), Mv(e, E.dc.groupId, I, J, L, O);

                  return D(Q, Ov(e), 2);
                }

                if (!C) return Q.F(0);
                Uw(a);
                $w(h, d, k, f);
                return D(Q, g.updateManifest(c, d), 0);
              });
            };

            r = !1;
            ta(B, 2);

            if (!ax(h) || !r || bx(h)) {
              B.F(4);
              break;
            }

            return D(B, n(b.filter(function (A) {
              return A.h;
            }), !0), 5);

          case 5:
            return Uw(a), b = b.filter(function (A) {
              return !A.h;
            }), q = l, u = m, l = {}, m = 0, D(B, cx(g, c, d, q, u, function () {
              return Uw(a);
            }), 6);

          case 6:
            Uw(a);

          case 4:
            if (r) {
              B.F(7);
              break;
            }

            return D(B, n(b, !1), 8);

          case 8:
            return Uw(a), v = l, y = m, l = {}, m = 0, D(B, cx(g, c, d, v, y, function () {
              return Uw(a);
            }), 9);

          case 9:
            Uw(a);

          case 7:
            va(B, 0);
            break;

          case 2:
            return z = wa(B), x = Object.values(l), D(B, g.removeSegments(x, function () {}), 10);

          case 10:
            throw z;
        }
      });
    }

    function Zw(a) {
      var b, c, d, e;
      return K(function (f) {
        switch (f.g) {
          case 1:
            return b = new $v(), D(f, b.init(), 2);

          case 2:
            return D(f, bw(b), 3);

          case 3:
            return c = f.h, d = new sw("manifest", c.path.kb, c.path.Oa, a), D(f, b.destroy(), 4);

          case 4:
            return e = new Ow(), D(f, e.remove(d.toString()), 0);
        }
      });
    }

    function cx(a, b, c, d, e, f) {
      var g, h, k, l, m, n, r, q, u, v, y;
      return K(function (z) {
        switch (z.g) {
          case 1:
            g = !1;
            ta(z, 2);
            h = !0;
            k = t(c.streams);

            for (l = k.next(); !l.done; l = k.next()) for (m = l.value, n = t(m.segments), r = n.next(); !r.done; r = n.next()) q = r.value, u = q.pendingSegmentRefId ? d[q.pendingSegmentRefId] : null, null != u && (q.dataKey = u, q.pendingSegmentRefId = void 0), u = q.pendingInitSegmentRefId ? d[q.pendingInitSegmentRefId] : null, null != u && (q.initSegmentKey = u, q.pendingInitSegmentRefId = void 0), q.pendingSegmentRefId && (h = !1), q.pendingInitSegmentRefId && (h = !1);

            c.size += e;
            h && (c.isIncomplete = !1);
            return D(z, a.updateManifest(b, c), 4);

          case 4:
            g = !0;
            f();
            va(z, 0);
            break;

          case 2:
            return v = wa(z), D(z, Zw(b), 5);

          case 5:
            if (g) {
              z.F(6);
              break;
            }

            y = Object.values(d);
            return D(z, a.removeSegments(y, function () {}), 6);

          case 6:
            throw v;
        }
      });
    }

    function Ww(a, b, c) {
      var d, e, f, g, h, k, l, m, n, r, q, u, v, y, z, x, B, A, C, E, H, G, I, J, L, O, Q, V;
      return K(function (U) {
        switch (U.g) {
          case 1:
            return d = {
              width: Infinity,
              height: Infinity
            }, be(a, c.restrictions, d), D(U, ee(b, a, c.offline.usePersistentLicense), 2);

          case 2:
            e = [];
            f = c.preferredDecodingAttributes;
            g = c.preferredVideoCodecs;
            h = c.preferredAudioCodecs;
            $d(a, g, h, f);
            k = t(a.variants);

            for (l = k.next(); !l.done; l = k.next()) m = l.value, e.push(te(m));

            n = t(a.textStreams);

            for (r = n.next(); !r.done; r = n.next()) q = r.value, e.push(ue(q));

            u = t(a.imageStreams);

            for (v = u.next(); !v.done; v = u.next()) y = v.value, e.push(ve(y));

            return D(U, c.offline.trackSelectionCallback(e), 3);

          case 3:
            z = U.h;
            x = a.presentationTimeline.getDuration();
            B = 0;
            A = t(z);

            for (C = A.next(); !C.done; C = A.next()) E = C.value, H = E.bandwidth * x / 8, B += H;

            ta(U, 4);
            return D(U, c.offline.downloadSizeCallback(B), 6);

          case 6:
            G = U.h;
            if (!G) throw new P(2, 9, 9014);
            va(U, 5);
            break;

          case 4:
            I = wa(U);
            if (I instanceof P) throw I;
            throw new P(2, 9, 9015);

          case 5:
            J = new Set();
            L = new Set();
            O = new Set();
            Q = t(z);

            for (C = Q.next(); !C.done; C = Q.next()) V = C.value, "variant" == V.type && J.add(V.id), "text" == V.type && L.add(V.id), "image" == V.type && O.add(V.id);

            a.variants = a.variants.filter(function (oa) {
              return J.has(oa.id);
            });
            a.textStreams = a.textStreams.filter(function (oa) {
              return L.has(oa.id);
            });
            a.imageStreams = a.imageStreams.filter(function (oa) {
              return O.has(oa.id);
            });
            dx(a);
            F(U);
        }
      });
    }

    function Xw(a, b, c, d, e, f) {
      var g = Hw(c, b, d),
          h = e.offline.progressCallback;
      Lv(f, function (q, u) {
        g.size = u;
        h(g, q);
      }, function (q, u) {
        k && e.offline.usePersistentLicense && l == u && hh(a, "cenc", q);
      });
      var k = ax(b) && !bx(b),
          l = null;
      k && (l = ex.get(a.g.keySystem));

      for (var m = new Kw(), n = t(b.textStreams), r = n.next(); !r.done; r = n.next()) m.g[r.value.id] = 52;

      n = t(b.imageStreams);

      for (r = n.next(); !r.done; r = n.next()) Mw(m, r.value);

      r = t(b.variants);

      for (n = r.next(); !n.done; n = r.next()) Lw(m, n.value);

      m = fx(f, m, b, e);
      f = m.streams;
      m = m.pg;
      r = a.g;
      n = e.offline.usePersistentLicense;
      r && n && (r.initData = []);
      return {
        Ii: {
          creationTime: Date.now(),
          originalManifestUri: c,
          duration: b.presentationTimeline.getDuration(),
          size: 0,
          expiration: a.rd(),
          streams: f,
          sessionIds: n ? rh(a) : [],
          drmInfo: r,
          appMetadata: d,
          isIncomplete: !0,
          sequenceMode: b.sequenceMode,
          type: b.type
        },
        pg: m
      };
    }

    function ax(a) {
      return a.variants.some(function (b) {
        var c = b.audio && b.audio.encrypted;
        return b.video && b.video.encrypted || c;
      });
    }

    function bx(a) {
      return a.variants.some(function (b) {
        return (b.video ? b.video.drmInfos : []).concat(b.audio ? b.audio.drmInfos : []).some(function (c) {
          return c.initData && c.initData.length;
        });
      });
    }

    function $w(a, b, c, d) {
      b.expiration = c.rd();
      c = rh(c);
      b.sessionIds = d.offline.usePersistentLicense ? c : [];
      if (ax(a) && d.offline.usePersistentLicense && !c.length) throw new P(2, 9, 9007);
    }

    p.remove = function (a) {
      return gx(this, hx(this, a));
    };

    function hx(a, b) {
      var c, d, e, f, g, h;
      return K(function (k) {
        switch (k.g) {
          case 1:
            Sw();
            c = tw(b);
            if (null == c || "manifest" != c.g) throw new P(2, 9, 9004, b);
            d = c;
            e = new $v();
            ua(k, 2);
            return D(k, e.init(), 4);

          case 4:
            return D(k, dw(e, d.kb(), d.Oa()), 5);

          case 5:
            return f = k.h, D(k, f.getManifests([d.key()]), 6);

          case 6:
            return g = k.h, h = g[0], D(k, Promise.all([ix(a, h, e), jx(f, d, h)]), 2);

          case 2:
            return xa(k), D(k, e.destroy(), 8);

          case 8:
            ya(k, 0);
        }
      });
    }

    function kx(a, b) {
      for (var c = [], d = t(a.streams), e = d.next(); !e.done; e = d.next()) e = e.value, b && "video" == e.type ? c.push({
        contentType: fd(e.mimeType, e.codecs),
        robustness: a.drmInfo.videoRobustness
      }) : b || "audio" != e.type || c.push({
        contentType: fd(e.mimeType, e.codecs),
        robustness: a.drmInfo.audioRobustness
      });

      return c;
    }

    function ix(a, b, c) {
      return K(function (d) {
        return D(d, lx(a.g, a.h.drm, c, b), 0);
      });
    }

    function jx(a, b, c) {
      function d() {}

      var e = mx(c);
      Jw(b, c);
      return Promise.all([a.removeSegments(e, d), a.removeManifests([b.key()], d)]);
    }

    p.Wi = function () {
      return gx(this, nx(this));
    };

    function nx(a) {
      var b, c, d, e, f, g, h, k, l, m;
      return K(function (n) {
        switch (n.g) {
          case 1:
            return Sw(), b = a.g, c = a.h.drm, d = new $v(), e = !1, ua(n, 2), D(n, d.init(), 4);

          case 4:
            f = [], ew(d, function (r) {
              return f.push(r);
            }), g = t(f), h = g.next();

          case 5:
            if (h.done) {
              n.F(2);
              break;
            }

            k = h.value;
            return D(n, k.getAll(), 8);

          case 8:
            return l = n.h, D(n, Ew(c, b, l), 9);

          case 9:
            return m = n.h, D(n, k.remove(m), 10);

          case 10:
            m.length != l.length && (e = !0);
            h = g.next();
            n.F(5);
            break;

          case 2:
            return xa(n), D(n, d.destroy(), 11);

          case 11:
            ya(n, 3);
            break;

          case 3:
            return n.return(!e);
        }
      });
    }

    p.list = function () {
      return gx(this, ox());
    };

    function ox() {
      var a, b, c;
      return K(function (d) {
        switch (d.g) {
          case 1:
            return Sw(), a = [], b = new $v(), ua(d, 2), D(d, b.init(), 4);

          case 4:
            return c = Promise.resolve(), cw(b, function (e, f) {
              c = c.then(function () {
                var g;
                return K(function (h) {
                  if (1 == h.g) return D(h, f.getAllManifests(), 2);
                  g = h.h;
                  g.forEach(function (k, l) {
                    k = Jw(new sw("manifest", e.kb, e.Oa, l), k);
                    a.push(k);
                  });
                  F(h);
                });
              });
            }), D(d, c, 2);

          case 2:
            return xa(d), D(d, b.destroy(), 6);

          case 6:
            ya(d, 3);
            break;

          case 3:
            return d.return(a);
        }
      });
    }

    function Tw(a, b, c, d) {
      var e, f, g, h, k;
      return K(function (l) {
        if (1 == l.g) return e = null, f = a.g, g = {
          networkingEngine: f,
          filter: function () {
            return Promise.resolve();
          },
          makeTextStreamsForClosedCaptions: function () {},
          onTimelineRegionAdded: function () {},
          onEvent: function () {},
          onError: function (m) {
            e = m;
          },
          isLowLatencyMode: function () {
            return !1;
          },
          isAutoLowLatencyMode: function () {
            return !1;
          },
          enableLowLatencyMode: function () {},
          updateDuration: function () {},
          newDrmInfo: function () {},
          onManifestUpdated: function () {},
          getBandwidthEstimate: function () {
            return d.abr.defaultBandwidthEstimate;
          }
        }, c.configure(d.manifest), Uw(a), D(l, c.start(b, g), 2);
        if (3 != l.g) return h = l.h, Uw(a), k = px(h), D(l, Promise.all(eb(k, function (m) {
          return m.createSegmentIndex();
        })), 3);
        Uw(a);
        if (e) throw e;
        return l.return(h);
      });
    }

    function Vw(a, b, c, d) {
      var e;
      return K(function (f) {
        return 1 == f.g ? (e = new Sg({
          vc: a.g,
          onError: c,
          ze: function () {},
          onExpirationUpdated: function () {},
          onEvent: function () {}
        }), e.configure(d.drm), D(f, Xg(e, b.variants, d.offline.usePersistentLicense), 2)) : 3 != f.g ? D(f, jh(e), 3) : f.return(e);
      });
    }

    function fx(a, b, c, d) {
      var e = new Map(),
          f = px(c),
          g = new Map();
      f = t(f);

      for (var h = f.next(); !h.done; h = f.next()) {
        h = h.value;
        var k = qx(a, b, c, h, d, e);
        g.set(h.id, k);
      }

      a = t(c.variants);

      for (b = a.next(); !b.done; b = a.next()) b = b.value, b.audio && g.get(b.audio.id).variantIds.push(b.id), b.video && g.get(b.video.id).variantIds.push(b.id);

      return {
        streams: Array.from(g.values()),
        pg: Array.from(e.values())
      };
    }

    function qx(a, b, c, d, e, f) {
      var g = {
        id: d.id,
        originalId: d.originalId,
        groupId: d.groupId,
        primary: d.primary,
        type: d.type,
        mimeType: d.mimeType,
        codecs: d.codecs,
        frameRate: d.frameRate,
        pixelAspectRatio: d.pixelAspectRatio,
        hdr: d.hdr,
        videoLayout: d.videoLayout,
        kind: d.kind,
        language: d.language,
        originalLanguage: d.originalLanguage,
        label: d.label,
        width: d.width || null,
        height: d.height || null,
        encrypted: d.encrypted,
        keyIds: d.keyIds,
        segments: [],
        variantIds: [],
        roles: d.roles,
        forced: d.forced,
        channelsCount: d.channelsCount,
        audioSamplingRate: d.audioSamplingRate,
        spatialAudio: d.spatialAudio,
        closedCaptions: d.closedCaptions,
        tilesLayout: d.tilesLayout,
        external: d.external,
        fastSwitching: d.fastSwitching
      },
          h = e.offline.numberOfParallelDownloads,
          k = 0;
      rx(d, c.presentationTimeline.Hb(), function (l) {
        var m = Fv(l),
            n = void 0;

        if (!f.has(m)) {
          var r = l.endTime - l.startTime;
          r = Nw(b, d.id) * r;
          r = Iv(a.g, r);
          f.set(m, new Ev(l, r, k, !1));
        }

        l.ka && (n = Fv(l.ka), f.has(n) || (r = .5 * Nw(b, d.id), r = Iv(a.g, r), f.set(n, new Ev(l.ka, r, k, !0))));
        g.segments.push({
          pendingInitSegmentRefId: n,
          initSegmentKey: n ? 0 : null,
          startTime: l.startTime,
          endTime: l.endTime,
          appendWindowStart: l.appendWindowStart,
          appendWindowEnd: l.appendWindowEnd,
          timestampOffset: l.timestampOffset,
          tilesLayout: l.tilesLayout,
          pendingSegmentRefId: m,
          dataKey: 0
        });
        k = (k + 1) % h;
      });
      return g;
    }

    function rx(a, b, c) {
      b = a.segmentIndex.find(b);
      if (null != b) for (var d = a.segmentIndex.get(b); d;) c(d), d = a.segmentIndex.get(++b);
    }

    function Uw(a) {
      if (a.l.g) throw new P(2, 9, 7001);
    }

    function Sw() {
      if (!Pw()) throw new P(2, 9, 9E3);
    }

    function gx(a, b) {
      return K(function (c) {
        if (1 == c.g) return a.i.push(b), ua(c, 2), D(c, b, 4);
        if (2 != c.g) return c.return(c.h);
        xa(c);
        xc(a.i, b);
        return ya(c, 0);
      });
    }

    function Rw(a, b) {
      var c = b.promise;
      a.i.push(c);
      return b.finally(function () {
        xc(a.i, c);
      });
    }

    function mx(a) {
      var b = new Set();
      a = t(a.streams);

      for (var c = a.next(); !c.done; c = a.next()) {
        c = t(c.value.segments);

        for (var d = c.next(); !d.done; d = c.next()) d = d.value, null != d.initSegmentKey && b.add(d.initSegmentKey), b.add(d.dataKey);
      }

      return Array.from(b);
    }

    function lx(a, b, c, d) {
      var e, f, g;
      return K(function (h) {
        if (1 == h.g) {
          if (!d.drmInfo) return h.return();
          e = fw(c);
          f = d.sessionIds.map(function (k) {
            return {
              sessionId: k,
              keySystem: d.drmInfo.keySystem,
              licenseUri: d.drmInfo.licenseServerUri,
              serverCertificate: d.drmInfo.serverCertificate,
              audioCapabilities: kx(d, !1),
              videoCapabilities: kx(d, !0)
            };
          });
          return D(h, Ew(b, a, f), 2);
        }

        return 3 != h.g ? (g = h.h, D(h, e.remove(g), 3)) : D(h, e.add(f.filter(function (k) {
          return !g.includes(k.sessionId);
        })), 0);
      });
    }

    function px(a) {
      for (var b = new Set(), c = t(a.textStreams), d = c.next(); !d.done; d = c.next()) b.add(d.value);

      c = t(a.imageStreams);

      for (d = c.next(); !d.done; d = c.next()) b.add(d.value);

      a = t(a.variants);

      for (c = a.next(); !c.done; c = a.next()) c = c.value, c.audio && b.add(c.audio), c.video && b.add(c.video);

      return b;
    }

    function dx(a) {
      a.variants.map(function (f) {
        return f.video;
      });
      var b = new Set(a.variants.map(function (f) {
        return f.audio;
      }));
      a = a.textStreams;

      for (var c = t(b), d = c.next(); !d.done; d = c.next()) {
        d = t(b);

        for (var e = d.next(); !e.done; e = d.next());
      }

      b = t(a);

      for (c = b.next(); !c.done; c = b.next()) for (c = t(a), d = c.next(); !d.done; d = c.next());
    }

    M("shaka.offline.Storage", Ow);

    Ow.deleteAll = function () {
      var a;
      return K(function (b) {
        return 1 == b.g ? (a = new $v(), ua(b, 2), D(b, gw(a), 2)) : 5 != b.g ? (xa(b), D(b, a.destroy(), 5)) : ya(b, 0);
      });
    };

    Ow.prototype.list = Ow.prototype.list;
    Ow.prototype.removeEmeSessions = Ow.prototype.Wi;
    Ow.prototype.remove = Ow.prototype.remove;
    Ow.prototype.store = Ow.prototype.store;
    Ow.prototype.getNetworkingEngine = Ow.prototype.Tb;
    Ow.prototype.getConfiguration = Ow.prototype.getConfiguration;
    Ow.prototype.configure = Ow.prototype.configure;
    Ow.prototype.destroy = Ow.prototype.destroy;
    Ow.support = Pw;
    var ex = new Map().set("org.w3.clearkey", "1077efecc0b24d02ace33c1e52e2fb4b").set("com.widevine.alpha", "edef8ba979d64acea3c827dcd51d21ed").set("com.microsoft.playready", "9a04f07998404286ab92e65be0885f95").set("com.microsoft.playready.recommendation", "9a04f07998404286ab92e65be0885f95").set("com.microsoft.playready.software", "9a04f07998404286ab92e65be0885f95").set("com.microsoft.playready.hardware", "9a04f07998404286ab92e65be0885f95").set("com.adobe.primetime", "f239e769efa348509c16a903c6932efb");
    Kn.offline = Pw;

    function sx() {}

    function tx() {
      for (var a = t(ux), b = a.next(); !b.done; b = a.next()) {
        b = b.value;

        try {
          b.callback();
        } catch (c) {
          Ua("Error installing polyfill!", c);
        }
      }
    }

    function vx(a, b) {
      a = {
        priority: b || 0,
        callback: a
      };

      for (b = 0; b < ux.length; b++) if (ux[b].priority < a.priority) {
        ux.splice(b, 0, a);
        return;
      }

      ux.push(a);
    }

    M("shaka.polyfill", sx);
    sx.register = vx;
    sx.installAll = tx;
    var ux = [];

    function wx() {
      this.g = new xx();
    }

    function yx() {
      window.AbortController || (window.AbortController = wx, window.AbortSignal = xx);
    }

    wx.prototype.abort = function (a) {
      var b = this.g;

      if (!b.h) {
        b.h = !0;
        b.g = a;
        void 0 === b.g && (b.g = new DOMException("signal is aborted without reason", "AbortError"));
        a = new N("abort");
        if (b.onabort) b.onabort(a);
        b.dispatchEvent(a);
      }
    };

    da.Object.defineProperties(wx.prototype, {
      signal: {
        configurable: !0,
        enumerable: !0,
        get: function () {
          return this.g;
        }
      }
    });
    sx.AbortController = wx;
    wx.install = yx;

    function xx() {
      db.call(this);
      this.h = !1;
      this.g = void 0;
      this.onabort = null;
    }

    pa(xx, db);
    da.Object.defineProperties(xx.prototype, {
      aborted: {
        configurable: !0,
        enumerable: !0,
        get: function () {
          return this.h;
        }
      },
      reason: {
        configurable: !0,
        enumerable: !0,
        get: function () {
          return this.g;
        }
      }
    });
    vx(yx);

    function zx() {}

    function Ax() {
      if (!Object.getOwnPropertyDescriptor(Element.prototype, "ariaHidden")) for (var a = t(["ariaHidden", "ariaLabel", "ariaPressed", "ariaSelected"]), b = a.next(); !b.done; b = a.next()) Bx(b.value);
    }

    function Bx(a) {
      var b = "aria-" + a.toLowerCase().replace(/^aria/, "");
      Object.defineProperty(Element.prototype, a, {
        get: function () {
          return this.getAttribute(b);
        },
        set: function (c) {
          null == c || void 0 == c ? this.removeAttribute(b) : this.setAttribute(b, c);
        }
      });
    }

    sx.Aria = zx;
    zx.install = Ax;
    vx(Ax);

    function Cx() {}

    function Dx() {
      Ex();
    }

    sx.EncryptionScheme = Cx;
    Cx.install = Dx;
    vx(Dx, -2);

    function Fx() {}

    function Gx() {
      if (window.Document) {
        var a = Element.prototype;
        a.requestFullscreen = a.requestFullscreen || a.mozRequestFullScreen || a.msRequestFullscreen || a.webkitRequestFullscreen;
        a = Document.prototype;
        a.exitFullscreen = a.exitFullscreen || a.mozCancelFullScreen || a.msExitFullscreen || a.webkitCancelFullScreen;
        "fullscreenElement" in document || (Object.defineProperty(document, "fullscreenElement", {
          get: function () {
            return document.mozFullScreenElement || document.msFullscreenElement || document.webkitCurrentFullScreenElement || document.webkitFullscreenElement;
          }
        }), Object.defineProperty(document, "fullscreenEnabled", {
          get: function () {
            return document.mozFullScreenEnabled || document.msFullscreenEnabled || document.webkitFullscreenEnabled;
          }
        }));
        document.addEventListener("webkitfullscreenchange", Hx);
        document.addEventListener("webkitfullscreenerror", Hx);
        document.addEventListener("mozfullscreenchange", Hx);
        document.addEventListener("mozfullscreenerror", Hx);
        document.addEventListener("MSFullscreenChange", Hx);
        document.addEventListener("MSFullscreenError", Hx);
      }
    }

    function Hx(a) {
      var b = a.type.replace(/^(webkit|moz|MS)/, "").toLowerCase(),
          c = document.createEvent("Event");
      c.initEvent(b, a.bubbles, a.cancelable);
      a.target.dispatchEvent(c);
    }

    sx.Fullscreen = Fx;
    Fx.install = Gx;
    vx(Gx);

    function Ix() {}

    function Jx() {
      var a = !0;
      if (Qd() || Ld("PlayStation 5") || Rd() || Ld("Web0S") || Md() || Ld("CrKey") || Ld("PC=EOS") || Ld("Hisense") || Ld("VIDAA")) a = !1;
      a && navigator.mediaCapabilities || (navigator.mediaCapabilities || (navigator.mediaCapabilities = {}), Kx = navigator.mediaCapabilities, navigator.mediaCapabilities.decodingInfo = Lx);
    }

    function Lx(a) {
      var b, c, d, e, f, g, h, k, l, m, n, r, q, u, v, y, z, x, B;
      return K(function (A) {
        switch (A.g) {
          case 1:
            b = {
              supported: !1,
              powerEfficient: !0,
              smooth: !0,
              keySystemAccess: null,
              configuration: a
            };
            if (!a) return A.return(b);
            c = a.video;
            d = a.audio;

            if ("media-source" == a.type) {
              if (!Gd()) return A.return(b);

              if (c) {
                if (Ld("CrKey")) {
                  if (window.cast && cast.__platform__ && cast.__platform__.canDisplayType) {
                    var C = c.contentType;
                    c.width && c.height && (C += "; width=" + c.width + "; height=" + c.height);
                    c.framerate && (C += "; framerate=" + c.framerate);
                    "pq" === c.transferFunction && (C += "; eotf=smpte2084");
                    e = cast.__platform__.canDisplayType(C);
                  } else e = fc(c.contentType);
                } else Md() ? (f = c.contentType, c.width && c.height && (f += "; width=" + c.width, f += "; height=" + c.height), c.framerate && (f += "; framerate=" + c.framerate), c.bitrate && (f += "; bitrate=" + c.bitrate), e = fc(f)) : e = fc(c.contentType);
                if (!e) return A.return(b);
              }

              if (d && (g = d.contentType, h = fc(g), !h)) return A.return(b);
            } else if ("file" == a.type) {
              if (c && (k = c.contentType, l = Hd(k), !l) || d && (m = d.contentType, n = Hd(m), !n)) return A.return(b);
            } else return A.return(b);

            if (!a.keySystemConfiguration) return b.supported = !0, A.return(Promise.resolve(b));
            r = a.keySystemConfiguration;
            q = [];
            u = [];
            r.audio && (v = {
              robustness: r.audio.robustness || "",
              contentType: a.audio.contentType
            }, q.push(v));
            r.video && (y = {
              robustness: r.video.robustness || "",
              contentType: a.video.contentType
            }, u.push(y));
            z = {
              initDataTypes: [r.initDataType],
              distinctiveIdentifier: r.distinctiveIdentifier,
              persistentState: r.persistentState,
              sessionTypes: r.sessionTypes
            };
            q.length && (z.audioCapabilities = q);
            u.length && (z.videoCapabilities = u);
            x = (a.video ? a.video.contentType : "") + "#" + (a.audio ? a.audio.contentType : "") + "#" + a.keySystemConfiguration.keySystem;
            ta(A, 3);

            if (x in Mx) {
              B = Mx[x];
              A.F(5);
              break;
            }

            return D(A, navigator.requestMediaKeySystemAccess(r.keySystem, [z]), 6);

          case 6:
            B = A.h, Mx[x] = B;

          case 5:
            va(A, 4);
            break;

          case 3:
            wa(A);

          case 4:
            B && (b.supported = !0, b.keySystemAccess = B);

          case 2:
            return A.return(b);
        }
      });
    }

    sx.MediaCapabilities = Ix;
    Ix.install = Jx;
    var Kx = null;
    Ix.originalMcap = Kx;
    var Mx = {};
    Ix.memoizedMediaKeySystemAccessRequests_ = Mx;
    vx(Jx, -1);

    function Nx() {}

    function Ox() {
      var a = Sd();
      window.MediaSource && (window.cast && cast.__platform__ && cast.__platform__.canDisplayType ? Px() : a ? 10 >= a ? window.MediaSource = null : 12 >= a ? (Qx(), Rx()) : 15 >= a && Qx() : Jd() ? Sx() : (Od() || Nd() || Ld("Tizen 4")) && Tx());
      window.MediaSource && MediaSource.isTypeSupported('video/webm; codecs="vp9"') && !MediaSource.isTypeSupported('video/webm; codecs="vp09.00.10.08"') && Ux();
    }

    function Qx() {
      var a = MediaSource.prototype.addSourceBuffer;

      MediaSource.prototype.addSourceBuffer = function () {
        var b = a.apply(this, Ga.apply(0, arguments));

        b.abort = function () {};

        return b;
      };
    }

    function Rx() {
      var a = SourceBuffer.prototype.remove;

      SourceBuffer.prototype.remove = function (b, c) {
        return a.call(this, b, c - .001);
      };
    }

    function Sx() {
      var a = MediaSource.isTypeSupported;

      MediaSource.isTypeSupported = function (b) {
        return "mp2t" != b.split(";")[0].split("/")[1] && a(b);
      };
    }

    function Tx() {
      var a = MediaSource.isTypeSupported;

      MediaSource.isTypeSupported = function (b) {
        return "opus" != nd(b) && a(b);
      };
    }

    function Px() {
      var a = MediaSource.isTypeSupported;

      MediaSource.isTypeSupported = function (b) {
        var c = b.split(/ *; */);
        c.shift();
        return c.some(function (d) {
          return d.startsWith("codecs=");
        }) ? cast.__platform__.canDisplayType(b) : a(b);
      };
    }

    function Ux() {
      var a = MediaSource.isTypeSupported;
      Ld("Web0S") || (MediaSource.isTypeSupported = function (b) {
        var c = b.split(/ *; */),
            d = c.findIndex(function (g) {
          return g.startsWith("codecs=");
        });
        if (0 > d) return a(b);
        var e = c[d].replace("codecs=", "").replace(/"/g, "").split(/\s*,\s*/),
            f = e.findIndex(function (g) {
          return g.startsWith("vp09");
        });
        0 <= f && (e[f] = "vp9", c[d] = 'codecs="' + e.join(",") + '"', b = c.join("; "));
        return a(b);
      });
    }

    sx.MediaSource = Nx;
    Nx.install = Ox;
    vx(Ox);

    function Vx() {}

    function Wx() {
      screen.orientation && screen.orientation.unlock || (void 0 != screen.orientation ? Xx() : void 0 != window.orientation && Yx());
    }

    function Xx() {
      void 0 === screen.orientation.lock && (screen.orientation.lock = function () {
        return Promise.resolve();
      });
      void 0 === screen.orientation.unlock && (screen.orientation.unlock = function () {});
    }

    function Yx() {
      function a() {
        switch (window.orientation) {
          case -90:
            b.type = "landscape-secondary";
            b.angle = 270;
            break;

          case 0:
            b.type = "portrait-primary";
            b.angle = 0;
            break;

          case 90:
            b.type = "landscape-primary";
            b.angle = 90;
            break;

          case 180:
            b.type = "portrait-secondary", b.angle = 180;
        }
      }

      var b = new Zx();
      screen.orientation = b;
      a();
      window.addEventListener("orientationchange", function () {
        a();
        var c = new N("change");
        b.dispatchEvent(c);
      });
    }

    sx.Orientation = Vx;
    Vx.install = Wx;

    function Zx() {
      db.call(this);
      this.type = "";
      this.angle = 0;
    }

    pa(Zx, db);

    Zx.prototype.lock = function (a) {
      function b(d) {
        return screen.lockOrientation ? screen.lockOrientation(d) : screen.mozLockOrientation ? screen.mozLockOrientation(d) : screen.msLockOrientation ? screen.msLockOrientation(d) : !1;
      }

      var c = !1;

      switch (a) {
        case "natural":
          c = b("default");
          break;

        case "any":
          c = !0;
          this.unlock();
          break;

        default:
          c = b(a);
      }

      if (c) return Promise.resolve();
      a = Error("screen.orientation.lock() is not available on this device");
      a.name = "NotSupportedError";
      a.code = DOMException.NOT_SUPPORTED_ERR;
      return Promise.reject(a);
    };

    Zx.prototype.unlock = function () {
      screen.unlockOrientation ? screen.unlockOrientation() : screen.mozUnlockOrientation ? screen.mozUnlockOrientation() : screen.msUnlockOrientation && screen.msUnlockOrientation();
    };

    vx(Wx);

    function $x() {}

    var ay, by, cy, dy, ey, fy;

    function gy(a, b) {
      try {
        var c = new hy(a, b);
        return Promise.resolve(c);
      } catch (d) {
        return Promise.reject(d);
      }
    }

    function iy(a) {
      var b = this.mediaKeys;
      b && b != a && jy(b, null);
      delete this.mediaKeys;
      return (this.mediaKeys = a) ? jy(a, this) : Promise.resolve();
    }

    function ky(a) {
      a = nc(a.initData);
      if (rc(a).getUint32(0, !0) + 4 != a.byteLength) throw new RangeError("Malformed FairPlay init data");
      a = Uf(a.subarray(4), !0);
      a = Xf(a);
      var b = new Event("encrypted");
      b.initDataType = "skd";
      b.initData = oc(a);
      this.dispatchEvent(b);
    }

    sx.PatchedMediaKeysApple = $x;

    $x.uninstall = function () {
      ay && (ay = !1, Object.defineProperty(HTMLMediaElement.prototype, "mediaKeys", by), HTMLMediaElement.prototype.setMediaKeys = cy, window.MediaKeys = dy, window.MediaKeySystemAccess = ey, navigator.requestMediaKeySystemAccess = fy, by = fy = cy = ey = dy = null, window.shakaMediaKeysPolyfill = !1);
    };

    $x.install = function (a) {
      if (window.HTMLVideoElement && window.WebKitMediaKeys) {
        if (void 0 === a ? 0 : a) ay = !0, by = Object.getOwnPropertyDescriptor(HTMLMediaElement.prototype, "mediaKeys"), cy = HTMLMediaElement.prototype.setMediaKeys, dy = window.MediaKeys, ey = window.MediaKeySystemAccess, fy = navigator.requestMediaKeySystemAccess;
        delete HTMLMediaElement.prototype.mediaKeys;
        HTMLMediaElement.prototype.mediaKeys = null;
        HTMLMediaElement.prototype.setMediaKeys = iy;
        window.MediaKeys = ly;
        window.MediaKeySystemAccess = hy;
        navigator.requestMediaKeySystemAccess = gy;
        window.shakaMediaKeysPolyfill = !0;
      }
    };

    function hy(a, b) {
      this.keySystem = a;
      if (a.startsWith("com.apple.fps")) for (a = t(b), b = a.next(); !b.done; b = a.next()) {
        var c = b.value;
        if ("required" == c.persistentState) b = null;else {
          b = {
            audioCapabilities: [],
            videoCapabilities: [],
            persistentState: "optional",
            distinctiveIdentifier: "optional",
            initDataTypes: c.initDataTypes,
            sessionTypes: ["temporary"],
            label: c.label
          };
          var d = !1,
              e = !1;
          if (c.audioCapabilities) for (var f = t(c.audioCapabilities), g = f.next(); !g.done; g = f.next()) g = g.value, g.contentType && (d = !0, WebKitMediaKeys.isTypeSupported(this.keySystem, g.contentType.split(";")[0]) && (b.audioCapabilities.push(g), e = !0));
          if (c.videoCapabilities) for (c = t(c.videoCapabilities), g = c.next(); !g.done; g = c.next()) f = g.value, f.contentType && (d = !0, WebKitMediaKeys.isTypeSupported(this.keySystem, f.contentType.split(";")[0]) && (b.videoCapabilities.push(f), e = !0));
          d || (e = WebKitMediaKeys.isTypeSupported(this.keySystem, "video/mp4"));
          b = e ? b : null;
        }

        if (b) {
          this.g = b;
          return;
        }
      }
      a = Error("Unsupported keySystem");
      a.name = "NotSupportedError";
      a.code = DOMException.NOT_SUPPORTED_ERR;
      throw a;
    }

    hy.prototype.createMediaKeys = function () {
      var a = new ly(this.keySystem);
      return Promise.resolve(a);
    };

    hy.prototype.getConfiguration = function () {
      return this.g;
    };

    function ly(a) {
      this.h = new WebKitMediaKeys(a);
      this.g = new Jf();
    }

    ly.prototype.createSession = function (a) {
      a = a || "temporary";
      if ("temporary" != a) throw new TypeError("Session type " + a + " is unsupported on this platform.");
      return new my(this.h, a);
    };

    ly.prototype.setServerCertificate = function () {
      return Promise.resolve(!1);
    };

    function jy(a, b) {
      a.g.Lb();
      if (!b) return Promise.resolve();
      a.g.o(b, "webkitneedkey", ky);

      try {
        return zj(b, HTMLMediaElement.HAVE_METADATA, a.g, function () {
          b.webkitSetMediaKeys(a.h);
        }), Promise.resolve();
      } catch (c) {
        return Promise.reject(c);
      }
    }

    ly.prototype.getStatusForPolicy = function () {
      return Promise.resolve("usable");
    };

    function my(a) {
      db.call(this);
      this.i = null;
      this.l = a;
      this.g = this.h = null;
      this.j = new Jf();
      this.sessionId = "";
      this.expiration = NaN;
      this.closed = new lf();
      this.keyStatuses = new ny();
    }

    pa(my, db);
    p = my.prototype;

    p.generateRequest = function (a, b) {
      var c = this;
      this.h = new lf();

      try {
        var d = this.l.createSession("video/mp4", nc(b));
        this.i = d;
        this.sessionId = d.sessionId || "";
        this.j.o(this.i, "webkitkeymessage", function (e) {
          c.h && (c.h.resolve(), c.h = null);
          e = new Map().set("messageType", void 0 == c.keyStatuses.nc() ? "license-request" : "license-renewal").set("message", oc(e.message));
          e = new N("message", e);
          c.dispatchEvent(e);
        });
        this.j.o(d, "webkitkeyadded", function () {
          c.g && (oy(c, "usable"), c.g.resolve(), c.g = null);
        });
        this.j.o(d, "webkitkeyerror", function () {
          var e = Error("EME PatchedMediaKeysApple key error");
          e.errorCode = c.i.error;
          if (null != c.h) c.h.reject(e), c.h = null;else if (null != c.g) c.g.reject(e), c.g = null;else switch (c.i.error.code) {
            case WebKitMediaKeyError.MEDIA_KEYERR_OUTPUT:
            case WebKitMediaKeyError.MEDIA_KEYERR_HARDWARECHANGE:
              oy(c, "output-not-allowed");
              break;

            default:
              oy(c, "internal-error");
          }
        });
        oy(this, "status-pending");
      } catch (e) {
        this.h.reject(e);
      }

      return this.h;
    };

    p.load = function () {
      return Promise.reject(Error("MediaKeySession.load not yet supported"));
    };

    p.update = function (a) {
      this.g = new lf();

      try {
        this.i.update(nc(a));
      } catch (b) {
        this.g.reject(b);
      }

      return this.g;
    };

    p.close = function () {
      try {
        this.i.close(), this.closed.resolve(), this.j.Lb();
      } catch (a) {
        this.closed.reject(a);
      }

      return this.closed;
    };

    p.remove = function () {
      return Promise.reject(Error("MediaKeySession.remove is only applicable for persistent licenses, which are not supported on this platform"));
    };

    function oy(a, b) {
      var c = a.keyStatuses;
      c.size = void 0 == b ? 0 : 1;
      c.g = b;
      b = new N("keystatuseschange");
      a.dispatchEvent(b);
    }

    function ny() {
      this.size = 0;
      this.g = void 0;
    }

    p = ny.prototype;

    p.nc = function () {
      return this.g;
    };

    p.forEach = function (a) {
      this.g && a(this.g, Fh.value());
    };

    p.get = function (a) {
      if (this.has(a)) return this.g;
    };

    p.has = function (a) {
      var b = Fh.value();
      return this.g && lc(a, b) ? !0 : !1;
    };

    p.entries = function () {};

    p.keys = function () {};

    p.values = function () {};

    function py() {}

    function qy() {
      !window.HTMLVideoElement || navigator.requestMediaKeySystemAccess && MediaKeySystemAccess.prototype.getConfiguration || (navigator.requestMediaKeySystemAccess = ry, delete HTMLMediaElement.prototype.mediaKeys, HTMLMediaElement.prototype.mediaKeys = null, HTMLMediaElement.prototype.setMediaKeys = sy, window.MediaKeys = ty, window.MediaKeySystemAccess = uy, window.shakaMediaKeysPolyfill = !0);
    }

    function ry() {
      return Promise.reject(Error("The key system specified is not supported."));
    }

    function sy(a) {
      return null == a ? Promise.resolve() : Promise.reject(Error("MediaKeys not supported."));
    }

    sx.PatchedMediaKeysNop = py;
    py.install = qy;

    function ty() {
      throw new TypeError("Illegal constructor.");
    }

    ty.prototype.createSession = function () {};

    ty.prototype.setServerCertificate = function () {};

    ty.prototype.getStatusForPolicy = function () {
      return Promise.resolve("usable");
    };

    function uy() {
      this.keySystem = "";
      throw new TypeError("Illegal constructor.");
    }

    uy.prototype.getConfiguration = function () {};

    uy.prototype.createMediaKeys = function () {};

    vx(qy, -10);

    function vy() {}

    function wy() {
      if (!(!window.HTMLVideoElement || navigator.requestMediaKeySystemAccess && MediaKeySystemAccess.prototype.getConfiguration)) {
        if (HTMLMediaElement.prototype.webkitGenerateKeyRequest) xy = "webkit";else if (!HTMLMediaElement.prototype.generateKeyRequest) return;
        navigator.requestMediaKeySystemAccess = yy;
        delete HTMLMediaElement.prototype.mediaKeys;
        HTMLMediaElement.prototype.mediaKeys = null;
        HTMLMediaElement.prototype.setMediaKeys = zy;
        window.MediaKeys = Ay;
        window.MediaKeySystemAccess = By;
        window.shakaMediaKeysPolyfill = !0;
      }
    }

    function Cy(a) {
      var b = xy;
      return b ? b + a.charAt(0).toUpperCase() + a.slice(1) : a;
    }

    function yy(a, b) {
      try {
        var c = new By(a, b);
        return Promise.resolve(c);
      } catch (d) {
        return Promise.reject(d);
      }
    }

    function zy(a) {
      var b = this.mediaKeys;
      b && b != a && Dy(b, null);
      delete this.mediaKeys;
      (this.mediaKeys = a) && Dy(a, this);
      return Promise.resolve();
    }

    sx.PatchedMediaKeysWebkit = vy;
    vy.install = wy;

    function By(a, b) {
      this.g = this.keySystem = a;
      var c = !1;
      "org.w3.clearkey" == a && (this.g = "webkit-org.w3.clearkey", c = !1);
      var d = !1;
      var e = document.getElementsByTagName("video");
      e = e.length ? e[0] : document.createElement("video");
      b = t(b);

      for (var f = b.next(); !f.done; f = b.next()) {
        f = f.value;
        var g = {
          audioCapabilities: [],
          videoCapabilities: [],
          persistentState: "optional",
          distinctiveIdentifier: "optional",
          initDataTypes: f.initDataTypes,
          sessionTypes: ["temporary"],
          label: f.label
        },
            h = !1;
        if (f.audioCapabilities) for (var k = t(f.audioCapabilities), l = k.next(); !l.done; l = k.next()) l = l.value, l.contentType && (h = !0, e.canPlayType(l.contentType.split(";")[0], this.g) && (g.audioCapabilities.push(l), d = !0));
        if (f.videoCapabilities) for (k = t(f.videoCapabilities), l = k.next(); !l.done; l = k.next()) l = l.value, l.contentType && (h = !0, e.canPlayType(l.contentType, this.g) && (g.videoCapabilities.push(l), d = !0));
        h || (d = e.canPlayType("video/mp4", this.g) || e.canPlayType("video/webm", this.g));
        "required" == f.persistentState && (c ? (g.persistentState = "required", g.sessionTypes = ["persistent-license"]) : d = !1);

        if (d) {
          this.h = g;
          return;
        }
      }

      c = "Unsupported keySystem";
      if ("org.w3.clearkey" == a || "com.widevine.alpha" == a) c = "None of the requested configurations were supported.";
      a = Error(c);
      a.name = "NotSupportedError";
      a.code = DOMException.NOT_SUPPORTED_ERR;
      throw a;
    }

    By.prototype.createMediaKeys = function () {
      var a = new Ay(this.g);
      return Promise.resolve(a);
    };

    By.prototype.getConfiguration = function () {
      return this.h;
    };

    function Ay(a) {
      this.l = a;
      this.h = null;
      this.g = new Jf();
      this.i = [];
      this.j = new Map();
    }

    function Dy(a, b) {
      a.h = b;
      a.g.Lb();
      var c = xy;
      b && (a.g.o(b, c + "needkey", function (d) {
        var e = new CustomEvent("encrypted");
        e.initDataType = "cenc";
        e.initData = oc(d.initData);
        a.h.dispatchEvent(e);
      }), a.g.o(b, c + "keymessage", function (d) {
        var e = Ey(a, d.sessionId);
        e && (d = new Map().set("messageType", void 0 == e.keyStatuses.nc() ? "licenserequest" : "licenserenewal").set("message", d.message), d = new N("message", d), e.h && (e.h.resolve(), e.h = null), e.dispatchEvent(d));
      }), a.g.o(b, c + "keyadded", function (d) {
        if (d = Ey(a, d.sessionId)) Fy(d, "usable"), d.g && d.g.resolve(), d.g = null;
      }), a.g.o(b, c + "keyerror", function (d) {
        var e = Ey(a, d.sessionId);

        if (e) {
          var f = Error("EME v0.1b key error"),
              g = d.errorCode;
          g.systemCode = d.systemCode;
          f.errorCode = g;
          !d.sessionId && e.h ? (45 == d.systemCode && (f.message = "Unsupported session type."), e.h.reject(f), e.h = null) : d.sessionId && e.g ? (e.g.reject(f), e.g = null) : (f = d.systemCode, d.errorCode.code == MediaKeyError.MEDIA_KEYERR_OUTPUT ? Fy(e, "output-restricted") : 1 == f ? Fy(e, "expired") : Fy(e, "internal-error"));
        }
      }));
    }

    Ay.prototype.createSession = function (a) {
      a = a || "temporary";
      if ("temporary" != a && "persistent-license" != a) throw new TypeError("Session type " + a + " is unsupported on this platform.");
      var b = this.h || document.createElement("video");
      b.src || (b.src = "about:blank");
      a = new Gy(b, this.l, a);
      this.i.push(a);
      return a;
    };

    Ay.prototype.setServerCertificate = function () {
      return Promise.resolve(!1);
    };

    Ay.prototype.getStatusForPolicy = function () {
      return Promise.resolve("usable");
    };

    function Ey(a, b) {
      var c = a.j.get(b);
      return c ? c : (c = a.i.shift()) ? (c.sessionId = b, a.j.set(b, c), c) : null;
    }

    function Gy(a, b, c) {
      db.call(this);
      this.j = a;
      this.m = !1;
      this.g = this.h = null;
      this.i = b;
      this.l = c;
      this.sessionId = "";
      this.expiration = NaN;
      this.closed = new lf();
      this.keyStatuses = new Hy();
    }

    pa(Gy, db);

    function Iy(a, b, c) {
      if (a.m) return Promise.reject(Error("The session is already initialized."));
      a.m = !0;

      try {
        if ("persistent-license" == a.l) {
          if (c) var d = nc(Xf("LOAD_SESSION|" + c));else {
            var e = Xf("PERSISTENT|");
            d = tg(e, b);
          }
        } else d = nc(b);
      } catch (g) {
        return Promise.reject(g);
      }

      a.h = new lf();
      var f = Cy("generateKeyRequest");

      try {
        a.j[f](a.i, d);
      } catch (g) {
        if ("InvalidStateError" != g.name) return a.h = null, Promise.reject(g);
        new Fd(function () {
          try {
            a.j[f](a.i, d);
          } catch (h) {
            a.h.reject(h), a.h = null;
          }
        }).R(.01);
      }

      return a.h;
    }

    function Jy(a, b, c) {
      if (a.g) a.g.then(function () {
        return Jy(a, b, c);
      }).catch(function () {
        return Jy(a, b, c);
      });else {
        a.g = b;

        if ("webkit-org.w3.clearkey" == a.i) {
          var d = Tf(c);
          var e = JSON.parse(d);
          "oct" != e.keys[0].kty && (a.g.reject(Error("Response is not a valid JSON Web Key Set.")), a.g = null);
          d = qg(e.keys[0].k);
          e = qg(e.keys[0].kid);
        } else d = nc(c), e = null;

        var f = Cy("addKey");

        try {
          a.j[f](a.i, d, e, a.sessionId);
        } catch (g) {
          a.g.reject(g), a.g = null;
        }
      }
    }

    function Fy(a, b) {
      var c = a.keyStatuses;
      c.size = void 0 == b ? 0 : 1;
      c.g = b;
      b = new N("keystatuseschange");
      a.dispatchEvent(b);
    }

    p = Gy.prototype;

    p.generateRequest = function (a, b) {
      return Iy(this, b, null);
    };

    p.load = function (a) {
      return "persistent-license" == this.l ? Iy(this, null, a) : Promise.reject(Error("Not a persistent session."));
    };

    p.update = function (a) {
      var b = new lf();
      Jy(this, b, a);
      return b;
    };

    p.close = function () {
      if ("persistent-license" != this.l) {
        if (!this.sessionId) return this.closed.reject(Error("The session is not callable.")), this.closed;
        var a = Cy("cancelKeyRequest");

        try {
          this.j[a](this.i, this.sessionId);
        } catch (b) {}
      }

      this.closed.resolve();
      return this.closed;
    };

    p.remove = function () {
      return "persistent-license" != this.l ? Promise.reject(Error("Not a persistent session.")) : this.close();
    };

    function Hy() {
      this.size = 0;
      this.g = void 0;
    }

    p = Hy.prototype;

    p.nc = function () {
      return this.g;
    };

    p.forEach = function (a) {
      this.g && a(this.g, Fh.value());
    };

    p.get = function (a) {
      if (this.has(a)) return this.g;
    };

    p.has = function (a) {
      var b = Fh.value();
      return this.g && lc(a, b) ? !0 : !1;
    };

    p.entries = function () {};

    p.keys = function () {};

    p.values = function () {};

    var xy = "";
    vx(wy);

    function Ky() {}

    function Ly() {
      if (window.HTMLVideoElement) {
        var a = HTMLVideoElement.prototype;
        a.requestPictureInPicture && document.exitPictureInPicture || !a.webkitSupportsPresentationMode || (document.pictureInPictureEnabled = !0, document.pictureInPictureElement = null, a.requestPictureInPicture = My, Object.defineProperty(a, "disablePictureInPicture", {
          get: Ny,
          set: Oy,
          enumerable: !0,
          configurable: !0
        }), document.exitPictureInPicture = Py, document.addEventListener("webkitpresentationmodechanged", Qy, !0));
      }
    }

    function Qy(a) {
      a = a.target;

      if ("picture-in-picture" == a.webkitPresentationMode) {
        document.pictureInPictureElement = a;
        var b = new Event("enterpictureinpicture");
        a.dispatchEvent(b);
      } else document.pictureInPictureElement == a && (document.pictureInPictureElement = null), b = new Event("leavepictureinpicture"), a.dispatchEvent(b);
    }

    function My() {
      return this.webkitSupportsPresentationMode("picture-in-picture") ? (this.webkitSetPresentationMode("picture-in-picture"), document.pictureInPictureElement = this, Promise.resolve()) : Promise.reject(Error("PiP not allowed by video element"));
    }

    function Py() {
      var a = document.pictureInPictureElement;
      return a ? (a.webkitSetPresentationMode("inline"), document.pictureInPictureElement = null, Promise.resolve()) : Promise.reject(Error("No picture in picture element found"));
    }

    function Ny() {
      return this.hasAttribute("disablePictureInPicture") ? !0 : !this.webkitSupportsPresentationMode("picture-in-picture");
    }

    function Oy(a) {
      a ? this.setAttribute("disablePictureInPicture", "") : this.removeAttribute("disablePictureInPicture");
    }

    sx.PiPWebkit = Ky;
    Ky.install = Ly;
    vx(Ly);

    function Ry() {}

    function Sy() {
      window.crypto && ("randomUUID" in window.crypto || (window.crypto.randomUUID = Ty));
    }

    function Ty() {
      var a = URL.createObjectURL(new Blob()),
          b = a.toString();
      URL.revokeObjectURL(a);
      return b.substr(b.lastIndexOf("/") + 1);
    }

    sx.RandomUUID = Ry;
    Ry.install = Sy;
    vx(Sy);

    function Uy() {}

    function Vy() {
      navigator.storage && navigator.storage.estimate || !navigator.webkitTemporaryStorage || !navigator.webkitTemporaryStorage.queryUsageAndQuota || ("storage" in navigator || (navigator.storage = {}), navigator.storage.estimate = Wy);
    }

    function Wy() {
      return new Promise(function (a, b) {
        navigator.webkitTemporaryStorage.queryUsageAndQuota(function (c, d) {
          a({
            usage: c,
            quota: d
          });
        }, b);
      });
    }

    sx.StorageEstimate = Uy;
    Uy.install = Vy;
    vx(Vy);

    function Xy() {}

    function Yy() {
      var a = Symbol.prototype;
      "description" in a || Object.defineProperty(a, "description", {
        get: Zy
      });
    }

    function Zy() {
      var a = /\((.*)\)/.exec(this.toString());
      return a ? a[1] : void 0;
    }

    sx.Symbol = Xy;
    Xy.install = Yy;
    vx(Yy);

    function $y() {}

    function az() {
      if (window.HTMLMediaElement) {
        var a = HTMLMediaElement.prototype.play;

        HTMLMediaElement.prototype.play = function () {
          var b = a.apply(this);
          b && b.catch(function () {});
          return b;
        };
      }
    }

    sx.VideoPlayPromise = $y;
    $y.install = az;
    vx(az);

    function bz() {}

    function cz() {
      if (window.HTMLVideoElement) {
        var a = HTMLVideoElement.prototype;
        !a.getVideoPlaybackQuality && ("webkitDroppedFrameCount" in a || Pd()) && (a.getVideoPlaybackQuality = dz);
      }
    }

    function dz() {
      return {
        droppedVideoFrames: this.webkitDroppedFrameCount,
        totalVideoFrames: this.webkitDecodedFrameCount,
        corruptedVideoFrames: 0,
        creationTime: NaN,
        totalFrameDelay: 0
      };
    }

    sx.VideoPlaybackQuality = bz;
    bz.install = cz;
    vx(cz);

    function ez() {}

    function fz() {
      if (!window.VTTCue && window.TextTrackCue) {
        var a = null,
            b = TextTrackCue.length;
        if (3 == b) a = gz;else if (6 == b) a = hz;else {
          try {
            var c = !!gz(1, 2, "");
          } catch (d) {
            c = !1;
          }

          c && (a = gz);
        }
        a && (window.VTTCue = function (d, e, f) {
          return a(d, e, f);
        });
      }
    }

    function gz(a, b, c) {
      return new window.TextTrackCue(a, b, c);
    }

    function hz(a, b, c) {
      return new window.TextTrackCue(a + "-" + b + "-" + c, a, b, c);
    }

    sx.VTTCue = ez;
    ez.install = fz;
    vx(fz);

    function iz() {}

    iz.prototype.parseInit = function () {};

    iz.prototype.setSequenceMode = function () {};

    iz.prototype.setManifestType = function () {};

    iz.prototype.parseMedia = function (a, b) {
      var c = null,
          d = [];
      a = Tf(a).split(/\r?\n/);
      a = t(a);

      for (var e = a.next(); !e.done; e = a.next()) if ((e = e.value) && !/^\s+$/.test(e) && (e = jz.exec(e))) {
        var f = kz.exec(e[1]);
        f = 60 * parseInt(f[1], 10) + parseFloat(f[2].replace(",", "."));
        e = new Ac(f, b.segmentEnd ? b.segmentEnd : f + 2, e[2]);
        c && (c.endTime = f, d.push(c));
        c = e;
      }

      c && d.push(c);
      return d;
    };

    M("shaka.text.LrcTextParser", iz);
    iz.prototype.parseMedia = iz.prototype.parseMedia;
    iz.prototype.setManifestType = iz.prototype.setManifestType;
    iz.prototype.setSequenceMode = iz.prototype.setSequenceMode;
    iz.prototype.parseInit = iz.prototype.parseInit;
    var jz = /^\[(\d{1,2}:\d{1,2}(?:[.,]\d{1,3})?)\](.*)/,
        kz = /^(\d+):(\d{1,2}(?:[.,]\d{1,3})?)$/;

    sd["application/x-subtitle-lrc"] = function () {
      return new iz();
    };

    function lz() {}

    lz.prototype.parseInit = function () {};

    lz.prototype.setSequenceMode = function () {};

    lz.prototype.setManifestType = function () {};

    lz.prototype.parseMedia = function (a, b, c) {
      var d = Tf(a);
      a = [];
      if ("" == d) return a;
      var e = Pg(d, "tt");
      if (!e) throw new P(2, 2, 2005, "Failed to parse TTML.");
      d = e.getElementsByTagName("body")[0];
      if (!d) return [];
      var f = Cg(e, mz, "frameRate"),
          g = Cg(e, mz, "subFrameRate"),
          h = Cg(e, mz, "frameRateMultiplier"),
          k = Cg(e, mz, "tickRate"),
          l = Cg(e, mz, "cellResolution"),
          m = e.getAttribute("xml:space") || "default",
          n = Cg(e, nz, "extent");
      if ("default" != m && "preserve" != m) throw new P(2, 2, 2005, "Invalid xml:space value: " + m);
      m = "default" == m;
      f = new oz(f, g, h, k);
      l = l ? (l = /^(\d+) (\d+)$/.exec(l)) ? {
        hc: parseInt(l[1], 10),
        rows: parseInt(l[2], 10)
      } : null : null;
      g = (g = e.getElementsByTagName("metadata")[0]) ? Ag(g) : [];
      h = Array.from(e.getElementsByTagName("style"));
      e = Array.from(e.getElementsByTagName("region"));
      k = [];

      for (var r = t(e), q = r.next(); !q.done; q = r.next()) {
        var u = q.value;
        q = new Bc();
        var v = u.getAttribute("xml:id");

        if (v) {
          q.id = v;
          var y = null;
          n && (y = pz.exec(n) || qz.exec(n));
          v = y ? Number(y[1]) : null;
          y = y ? Number(y[2]) : null;
          var z, x;
          if (z = rz(u, h, "extent")) z = (x = pz.exec(z)) || qz.exec(z), null != z && (q.width = Number(z[1]), q.height = Number(z[2]), x || (null != v && (q.width = 100 * q.width / v), null != y && (q.height = 100 * q.height / y)), q.widthUnits = x || null != v ? Vc : 0, q.heightUnits = x || null != y ? Vc : 0);
          if (u = rz(u, h, "origin")) z = (x = pz.exec(u)) || qz.exec(u), null != z && (q.viewportAnchorX = Number(z[1]), q.viewportAnchorY = Number(z[2]), x || (null != y && (q.viewportAnchorY = 100 * q.viewportAnchorY / y), null != v && (q.viewportAnchorX = 100 * q.viewportAnchorX / v)), q.viewportAnchorUnits = x || null != v ? Vc : 0);
        } else q = null;

        q && k.push(q);
      }

      if (xg(d, "p").length) throw new P(2, 2, 2001, "<p> can only be inside <div> in TTML");
      n = t(xg(d, "div"));

      for (r = n.next(); !r.done; r = n.next()) if (xg(r.value, "span").length) throw new P(2, 2, 2001, "<span> can only be inside <p> in TTML");

      if (b = sz(d, b, f, g, h, e, k, m, l, null, !1, c)) b.backgroundColor || (b.backgroundColor = "transparent"), a.push(b);
      return a;
    };

    function sz(a, b, c, d, e, f, g, h, k, l, m, n) {
      var r = a.parentNode;
      if (a.nodeType == Node.COMMENT_NODE) return null;

      if (a.nodeType == Node.TEXT_NODE) {
        if (!m) return null;
        var q = document.createElement("span");
        q.textContent = a.textContent;
      } else q = a;

      for (var u = null, v = t(tz), y = v.next(); !y.done && !(u = uz(q, "backgroundImage", d, "#", y.value)[0]); y = v.next());

      v = null;
      var z = Cg(q, tz, "backgroundImage");
      n && z && !z.startsWith("#") && (y = new kb(n), z = new kb(z), (y = y.resolve(z).toString()) && (v = y));
      if ("p" == a.nodeName || u || v) m = !0;
      a = m;
      y = "default" == (q.getAttribute("xml:space") || (h ? "default" : "preserve"));
      z = Array.from(q.childNodes).every(function (C) {
        return C.nodeType == Node.TEXT_NODE;
      });
      h = [];
      if (!z) for (var x = t(q.childNodes), B = x.next(); !B.done; B = x.next()) (B = sz(B.value, b, c, d, e, f, g, y, k, q, m, n)) && h.push(B);
      d = null != l;
      n = /\S/.test(q.textContent);
      B = q.hasAttribute("begin") || q.hasAttribute("end") || q.hasAttribute("dur");
      if (!(B || n || "br" == q.tagName || 0 != h.length || d && !y)) return null;
      x = vz(q, c);
      n = x.start;

      for (x = x.end; r && r.nodeType == Node.ELEMENT_NODE && "tt" != r.tagName;) x = wz(r, c, n, x), n = x.start, x = x.end, r = r.parentNode;

      null == n && (n = 0);
      n += b.periodStart;
      x = null == x ? Infinity : x + b.periodStart;
      n = Math.max(n, b.segmentStart);
      x = Math.min(x, b.segmentEnd);
      if (!B && 0 < h.length) for (n = Infinity, x = 0, b = t(h), c = b.next(); !c.done; c = b.next()) c = c.value, n = Math.min(n, c.startTime), x = Math.max(x, c.endTime);
      if ("br" == q.tagName) return e = new Ac(n, x, ""), e.lineBreak = !0, e;
      b = "";
      z && (b = q.textContent, y && (b = b.trim(), b = b.replace(/\s+/g, " ")));
      b = new Ac(n, x, b);
      b.nestedCues = h;
      m || (b.isContainer = !0);
      k && (b.cellResolution = k);
      k = uz(q, "region", f, "")[0];

      if (q.hasAttribute("region") && k && k.getAttribute("xml:id")) {
        var A = k.getAttribute("xml:id");
        b.region = g.filter(function (C) {
          return C.id == A;
        })[0];
      }

      g = k;
      l && d && !q.getAttribute("region") && !q.getAttribute("style") && (g = uz(l, "region", f, "")[0]);
      xz(b, q, g, u, v, e, a, 0 == h.length);
      return b;
    }

    function xz(a, b, c, d, e, f, g, h) {
      g = g || h;
      "rtl" == yz(b, c, f, "direction", g) && (a.direction = "rtl");
      h = yz(b, c, f, "writingMode", g);
      "tb" == h || "tblr" == h ? a.writingMode = "vertical-lr" : "tbrl" == h ? a.writingMode = "vertical-rl" : "rltb" == h || "rl" == h ? a.direction = "rtl" : h && (a.direction = Fc);
      (h = yz(b, c, f, "textAlign", !0)) ? (a.positionAlign = zz[h], a.lineAlign = Az[h], a.textAlign = Pc[h.toUpperCase()]) : a.textAlign = Ec;
      if (h = yz(b, c, f, "displayAlign", !0)) a.displayAlign = Qc[h.toUpperCase()];
      if (h = yz(b, c, f, "color", g)) a.color = h;
      if (h = yz(b, c, f, "backgroundColor", g)) a.backgroundColor = h;
      if (h = yz(b, c, f, "border", g)) a.border = h;
      if (h = yz(b, c, f, "fontFamily", g)) switch (h) {
        case "monospaceSerif":
          a.fontFamily = "Courier New,Liberation Mono,Courier,monospace";
          break;

        case "proportionalSansSerif":
          a.fontFamily = "Arial,Helvetica,Liberation Sans,sans-serif";
          break;

        case "sansSerif":
          a.fontFamily = "sans-serif";
          break;

        case "monospaceSansSerif":
          a.fontFamily = "Consolas,monospace";
          break;

        case "proportionalSerif":
          a.fontFamily = "serif";
          break;

        default:
          a.fontFamily = h;
      }
      (h = yz(b, c, f, "fontWeight", g)) && "bold" == h && (a.fontWeight = 700);
      h = yz(b, c, f, "wrapOption", g);
      a.wrapLine = h && "noWrap" == h ? !1 : !0;
      (h = yz(b, c, f, "lineHeight", g)) && h.match(Bz) && (a.lineHeight = h);
      (h = yz(b, c, f, "fontSize", g)) && (h.match(Bz) || h.match(Cz)) && (a.fontSize = h);
      if (h = yz(b, c, f, "fontStyle", g)) a.fontStyle = Uc[h.toUpperCase()];
      d ? (e = d.getAttribute("imageType") || d.getAttribute("imagetype"), h = d.getAttribute("encoding"), d = d.textContent.trim(), "PNG" == e && "Base64" == h && d && (a.backgroundImage = "data:image/png;base64," + d)) : e && (a.backgroundImage = e);
      if (d = yz(b, c, f, "textOutline", g)) d = d.split(" "), d[0].match(Bz) ? a.textStrokeColor = a.color : (a.textStrokeColor = d[0], d.shift()), d[0] && d[0].match(Bz) ? a.textStrokeWidth = d[0] : a.textStrokeColor = "";
      (d = yz(b, c, f, "letterSpacing", g)) && d.match(Bz) && (a.letterSpacing = d);
      (d = yz(b, c, f, "linePadding", g)) && d.match(Bz) && (a.linePadding = d);
      if (d = yz(b, c, f, "opacity", g)) a.opacity = parseFloat(d);
      (d = rz(c, f, "textDecoration")) && Dz(a, d);
      (d = Ez(b, f, "textDecoration")) && Dz(a, d);
      if (d = yz(b, c, f, "textCombine", g)) a.textCombineUpright = d;

      switch (yz(b, c, f, "ruby", g)) {
        case "container":
          a.rubyTag = "ruby";
          break;

        case "text":
          a.rubyTag = "rt";
      }
    }

    function Dz(a, b) {
      b = t(b.split(" "));

      for (var c = b.next(); !c.done; c = b.next()) switch (c.value) {
        case "underline":
          a.textDecoration.includes("underline") || a.textDecoration.push("underline");
          break;

        case "noUnderline":
          a.textDecoration.includes("underline") && xc(a.textDecoration, "underline");
          break;

        case "lineThrough":
          a.textDecoration.includes("lineThrough") || a.textDecoration.push("lineThrough");
          break;

        case "noLineThrough":
          a.textDecoration.includes("lineThrough") && xc(a.textDecoration, "lineThrough");
          break;

        case "overline":
          a.textDecoration.includes("overline") || a.textDecoration.push("overline");
          break;

        case "noOverline":
          a.textDecoration.includes("overline") && xc(a.textDecoration, "overline");
      }
    }

    function yz(a, b, c, d, e) {
      e = void 0 === e ? !0 : e;
      return (a = Ez(a, c, d)) ? a : e ? rz(b, c, d) : null;
    }

    function rz(a, b, c) {
      if (!a) return null;
      var d = Cg(a, nz, c);
      return d ? d : Fz(a, b, c);
    }

    function Ez(a, b, c) {
      var d = Cg(a, nz, c);
      return d ? d : Fz(a, b, c);
    }

    function Fz(a, b, c) {
      a = uz(a, "style", b, "");

      for (var d = null, e = 0; e < a.length; e++) {
        var f = Bg(a[e], "urn:ebu:tt:style", c);
        f || (f = Cg(a[e], nz, c));
        f || (f = Ez(a[e], b, c));
        f && (d = f);
      }

      return d;
    }

    function uz(a, b, c, d, e) {
      var f = [];
      if (!a || 1 > c.length) return f;
      var g = a;

      for (a = null; g && !(a = e ? Bg(g, e, b) : g.getAttribute(b)) && (g = g.parentNode, g instanceof Element););

      if (b = a) for (b = t(b.split(" ")), e = b.next(); !e.done; e = b.next()) for (e = e.value, a = t(c), g = a.next(); !g.done; g = a.next()) if (g = g.value, d + g.getAttribute("xml:id") == e) {
        f.push(g);
        break;
      }
      return f;
    }

    function wz(a, b, c, d) {
      a = vz(a, b);
      null == c ? c = a.start : null != a.start && (c += a.start);
      null == d ? d = a.end : null != a.start && (d += a.start);
      return {
        start: c,
        end: d
      };
    }

    function vz(a, b) {
      var c = Gz(a.getAttribute("begin"), b),
          d = Gz(a.getAttribute("end"), b);
      a = Gz(a.getAttribute("dur"), b);
      null == d && null != a && (d = c + a);
      return {
        start: c,
        end: d
      };
    }

    function Gz(a, b) {
      var c = null;

      if (Hz.test(a)) {
        a = Hz.exec(a);
        c = Number(a[1]);
        var d = Number(a[2]),
            e = Number(a[3]),
            f = Number(a[4]);
        f += (Number(a[5]) || 0) / b.h;
        e += f / b.frameRate;
        c = e + 60 * d + 3600 * c;
      } else if (Iz.test(a)) c = Jz(Iz, a);else if (Kz.test(a)) c = Jz(Kz, a);else if (Lz.test(a)) a = Lz.exec(a), c = Number(a[1]) / b.frameRate;else if (Mz.test(a)) a = Mz.exec(a), c = Number(a[1]) / b.g;else if (Nz.test(a)) c = Jz(Nz, a);else if (a) throw new P(2, 2, 2001, "Could not parse cue time range in TTML");

      return c;
    }

    function Jz(a, b) {
      a = a.exec(b);
      return null == a || "" == a[0] ? null : (Number(a[4]) || 0) / 1E3 + (Number(a[3]) || 0) + 60 * (Number(a[2]) || 0) + 3600 * (Number(a[1]) || 0);
    }

    M("shaka.text.TtmlTextParser", lz);
    lz.prototype.parseMedia = lz.prototype.parseMedia;
    lz.prototype.setManifestType = lz.prototype.setManifestType;
    lz.prototype.setSequenceMode = lz.prototype.setSequenceMode;
    lz.prototype.parseInit = lz.prototype.parseInit;

    function oz(a, b, c, d) {
      this.frameRate = Number(a) || 30;
      this.h = Number(b) || 1;
      this.g = Number(d);
      0 == this.g && (this.g = a ? this.frameRate * this.h : 1);
      c && (a = /^(\d+) (\d+)$/g.exec(c)) && (this.frameRate *= Number(a[1]) / Number(a[2]));
    }

    var pz = /^(\d{1,2}(?:\.\d+)?|100(?:\.0+)?)% (\d{1,2}(?:\.\d+)?|100(?:\.0+)?)%$/,
        Cz = /^(\d{1,2}(?:\.\d+)?|100)%$/,
        Bz = /^(\d+px|\d+em|\d*\.?\d+c)$/,
        qz = /^(\d+)px (\d+)px$/,
        Hz = /^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/,
        Iz = /^(?:(\d{2,}):)?(\d{2}):(\d{2})$/,
        Kz = /^(?:(\d{2,}):)?(\d{2}):(\d{2}\.\d{2,})$/,
        Lz = /^(\d*(?:\.\d*)?)f$/,
        Mz = /^(\d*(?:\.\d*)?)t$/,
        Nz = RegExp("^(?:(\\d*(?:\\.\\d*)?)h)?(?:(\\d*(?:\\.\\d*)?)m)?(?:(\\d*(?:\\.\\d*)?)s)?(?:(\\d*(?:\\.\\d*)?)ms)?$"),
        Az = {
      left: Ic,
      center: "center",
      right: "end",
      start: Ic,
      end: "end"
    },
        zz = {
      left: "line-left",
      center: "center",
      right: "line-right"
    },
        mz = ["http://www.w3.org/ns/ttml#parameter", "http://www.w3.org/2006/10/ttaf1#parameter"],
        nz = ["http://www.w3.org/ns/ttml#styling", "http://www.w3.org/2006/10/ttaf1#styling"],
        tz = ["http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt", "http://www.smpte-ra.org/schemas/2052-1/2013/smpte-tt"];

    sd["application/ttml+xml"] = function () {
      return new lz();
    };

    function Oz() {
      this.g = new lz();
    }

    Oz.prototype.parseInit = function (a) {
      var b = !1;
      new bg().box("moov", gg).box("trak", gg).box("mdia", gg).box("minf", gg).box("stbl", gg).W("stsd", ig).box("stpp", function (c) {
        b = !0;
        c.parser.stop();
      }).parse(a);
      if (!b) throw new P(2, 2, 2007);
    };

    Oz.prototype.setSequenceMode = function () {};

    Oz.prototype.setManifestType = function () {};

    Oz.prototype.parseMedia = function (a, b, c) {
      var d = this,
          e = !1,
          f = [];
      new bg().box("mdat", mg(function (g) {
        e = !0;
        f = f.concat(d.g.parseMedia(g, b, c));
      })).parse(a, !1);
      if (!e) throw new P(2, 2, 2007);
      return f;
    };

    M("shaka.text.Mp4TtmlParser", Oz);
    Oz.prototype.parseMedia = Oz.prototype.parseMedia;
    Oz.prototype.setManifestType = Oz.prototype.setManifestType;
    Oz.prototype.setSequenceMode = Oz.prototype.setSequenceMode;
    Oz.prototype.parseInit = Oz.prototype.parseInit;

    sd['application/mp4; codecs="stpp"'] = function () {
      return new Oz();
    };

    sd['application/mp4; codecs="stpp.ttml"'] = function () {
      return new Oz();
    };

    sd['application/mp4; codecs="stpp.ttml.im1t"'] = function () {
      return new Oz();
    };

    sd['application/mp4; codecs="stpp.TTML.im1t"'] = function () {
      return new Oz();
    };

    function Pz() {
      this.h = !1;
      this.g = "UNKNOWN";
    }

    Pz.prototype.parseInit = function () {};

    Pz.prototype.setSequenceMode = function (a) {
      this.h = a;
    };

    Pz.prototype.setManifestType = function (a) {
      this.g = a;
    };

    Pz.prototype.parseMedia = function (a, b) {
      a = Tf(a);
      a = a.replace(/\r\n|\r(?=[^\n]|$)/gm, "\n");
      var c = a.split(/\n{2,}/m);
      if (!/^WEBVTT($|[ \t\n])/m.test(c[0])) throw new P(2, 2, 2E3);
      a = b.vttOffset;

      if (c[0].includes("X-TIMESTAMP-MAP") && this.h) {
        var d = c[0].match(/LOCAL:((?:(\d{1,}):)?(\d{2}):(\d{2})\.(\d{3}))/m),
            e = c[0].match(/MPEGTS:(\d+)/m);

        if (d && e) {
          a = Qz(new gt(d[1]));
          if (null == a) throw new P(2, 2, 2E3);
          e = Number(e[1]);

          for (d = b.segmentStart - b.periodStart; 95443.7176888889 <= d;) d -= 95443.7176888889, e += 8589934592;

          a = b.periodStart + e / 9E4 - a;
        }
      } else c[0].includes("X-TIMESTAMP-MAP") && "HLS" == this.g && (a = b.segmentStart);

      b = [];
      e = t(c[0].split("\n"));

      for (d = e.next(); !d.done; d = e.next()) if (d = d.value, /^Region:/.test(d)) {
        d = new gt(d);
        var f = new Bc();
        jt(d);
        ht(d);

        for (var g = jt(d); g;) {
          var h = f,
              k = g;
          (g = /^id=(.*)$/.exec(k)) ? h.id = g[1] : (g = /^width=(\d{1,2}|100)%$/.exec(k)) ? h.width = Number(g[1]) : (g = /^lines=(\d+)$/.exec(k)) ? (h.height = Number(g[1]), h.heightUnits = 2) : (g = /^regionanchor=(\d{1,2}|100)%,(\d{1,2}|100)%$/.exec(k)) ? (h.regionAnchorX = Number(g[1]), h.regionAnchorY = Number(g[2])) : (g = /^viewportanchor=(\d{1,2}|100)%,(\d{1,2}|100)%$/.exec(k)) ? (h.viewportAnchorX = Number(g[1]), h.viewportAnchorY = Number(g[2])) : /^scroll=up$/.exec(k) && (h.scroll = "up");
          ht(d);
          g = jt(d);
        }

        b.push(f);
      }

      e = new Map();
      Rz(e);
      d = [];
      c = t(c.slice(1));

      for (f = c.next(); !f.done; f = c.next()) {
        f = f.value.split("\n");

        if ((1 != f.length || f[0]) && !/^NOTE($|[ \t])/.test(f[0]) && "STYLE" == f[0]) {
          h = [];
          g = -1;

          for (k = 1; k < f.length; k++) f[k].includes("::cue") && (h.push([]), g = h.length - 1), -1 != g && (h[g].push(f[k]), f[k].includes("}") && (g = -1));

          h = t(h);

          for (g = h.next(); !g.done; g = h.next()) {
            var l = g.value;
            g = "global";
            (k = l[0].match(/\((.*)\)/)) && (g = k.pop());
            k = l.slice(1, -1);
            l[0].includes("}") && (l = /\{(.*?)\}/.exec(l[0])) && (k = l[1].split(";"));
            (l = e.get(g)) || (l = new Ac(0, 0, ""));

            for (var m = !1, n = 0; n < k.length; n++) {
              var r = /^\s*([^:]+):\s*(.*)/.exec(k[n]);

              if (r) {
                var q = r[2].trim().replace(";", "");

                switch (r[1].trim()) {
                  case "background-color":
                  case "background":
                    m = !0;
                    l.backgroundColor = q;
                    break;

                  case "color":
                    m = !0;
                    l.color = q;
                    break;

                  case "font-family":
                    m = !0;
                    l.fontFamily = q;
                    break;

                  case "font-size":
                    m = !0;
                    l.fontSize = q;
                    break;

                  case "font-weight":
                    if (700 <= parseInt(q, 10) || "bold" == q) m = !0, l.fontWeight = 700;
                    break;

                  case "font-style":
                    switch (q) {
                      case "normal":
                        m = !0;
                        l.fontStyle = Mc;
                        break;

                      case "italic":
                        m = !0;
                        l.fontStyle = "italic";
                        break;

                      case "oblique":
                        m = !0, l.fontStyle = "oblique";
                    }

                    break;

                  case "opacity":
                    m = !0;
                    l.opacity = parseFloat(q);
                    break;

                  case "text-combine-upright":
                    m = !0;
                    l.textCombineUpright = q;
                    break;

                  case "text-shadow":
                    m = !0;
                    l.textShadow = q;
                    break;

                  case "white-space":
                    m = !0, l.wrapLine = "noWrap" != q;
                }
              }
            }

            m && e.set(g, l);
          }
        }

        m = a;
        if (1 == f.length && !f[0] || /^NOTE($|[ \t])/.test(f[0]) || "STYLE" == f[0] || "REGION" == f[0]) f = null;else if (h = null, f[0].includes("--\x3e") || (h = f[0], f.splice(0, 1)), g = new gt(f[0]), k = Qz(g), n = it(g, /[ \t]+--\x3e[ \t]+/g), l = Qz(g), null == k || null == n || null == l) Ua("Failed to parse VTT time code. Cue skipped:", h, f), f = null;else {
          k += m;
          l += m;
          f = f.slice(1).join("\n").trim();
          e.has("global") ? (m = e.get("global").clone(), m.startTime = k, m.endTime = l, m.payload = "") : m = new Ac(k, l, "");
          ht(g);

          for (k = jt(g); k;) Sz(m, k, b), ht(g), k = jt(g);

          Tz(f, m, e);
          null != h && (m.id = h);
          f = m;
        }
        f && d.push(f);
      }

      return d;
    };

    function Rz(a) {
      for (var b = t(Object.entries(Sc)), c = b.next(); !c.done; c = b.next()) {
        var d = t(c.value);
        c = d.next().value;
        d = d.next().value;
        var e = new Ac(0, 0, "");
        e.color = d;
        a.set("." + c, e);
      }

      b = t(Object.entries(Tc));

      for (c = b.next(); !c.done; c = b.next()) d = t(c.value), c = d.next().value, d = d.next().value, e = new Ac(0, 0, ""), e.backgroundColor = d, a.set("." + c, e);
    }

    function Tz(a, b, c) {
      0 === c.size && Rz(c);

      a: {
        for (var d = [], e = -1, f = "", g = 0; g < a.length; g++) if ("/" === a[g] && 0 < g && "<" === a[g - 1]) {
          var h = a.indexOf(">", g);
          if (h <= g) break a;

          if ((h = a.substring(g + 1, h)) && "c" === h) {
            var k = d.pop();
            k ? k === h ? (f += "/" + h + ">", g += h.length + 1) : k.startsWith("c.") ? (g += h.length + 1, f += "/" + k + ">") : f += a[g] : f += a[g];
          } else f += a[g];
        } else "<" === a[g] ? (e = g + 1, "c" != a[e] && (e = -1)) : ">" === a[g] && 0 < e && (d.push(a.substr(e, g - e)), e = -1), f += a[g];

        a = f;
      }

      d = a;
      a = [];
      f = -1;

      for (e = 0; e < d.length; e++) "<" === d[e] ? f = e + 1 : ">" === d[e] && 0 < f && (f = d.substr(f, e - f), f.match(Uz) && a.push(f), f = -1);

      a = t(a);

      for (e = a.next(); !e.done; e = a.next()) e = e.value, d = d.replace("<" + e + ">", '<div time="' + e + '">'), d += "</div>";

      a = d;

      a: {
        e = a;
        f = [];
        g = -1;
        a = "";
        d = !1;

        for (h = 0; h < e.length; h++) if ("/" === e[h]) {
          k = e.indexOf(">", h);

          if (-1 === k) {
            a = e;
            break a;
          }

          if ((k = e.substring(h + 1, k)) && "v" == k) {
            d = !0;
            var l = null;
            f.length && (l = f[f.length - 1]);

            if (l) {
              if (l === k) a += "/" + k + ">";else {
                if (!l.startsWith("v")) {
                  a += e[h];
                  continue;
                }

                a += "/" + l + ">";
              }
              h += k.length + 1;
            } else a += e[h];
          } else a += e[h];
        } else "<" === e[h] ? (g = h + 1, "v" != e[g] && (g = -1)) : ">" === e[h] && 0 < g && (f.push(e.substr(g, h - g)), g = -1), a += e[h];

        e = t(f);

        for (f = e.next(); !f.done; f = e.next()) f = f.value, g = f.replace(" ", ".voice-"), a = a.replace("<" + f + ">", "<" + g + ">"), a = a.replace("</" + f + ">", "</" + g + ">"), d || (a += "</" + g + ">");
      }

      if (d = Pg("<span>" + a + "</span>", "span")) {
        d = d.childNodes;

        if (1 == d.length && (e = d[0], e.nodeType == Node.TEXT_NODE || e.nodeType == Node.CDATA_SECTION_NODE)) {
          b.payload = Vz(a);
          return;
        }

        a = t(d);

        for (d = a.next(); !d.done; d = a.next()) Wz(d.value, b, c);
      } else b.payload = Vz(a);
    }

    function Xz(a, b) {
      return a && 0 < a.length ? a : b;
    }

    function Wz(a, b, c) {
      var d = b.clone();
      d.nestedCues = [];
      d.payload = "";
      d.rubyTag = "";
      d.line = null;
      d.region = new Bc();
      d.position = null;
      d.size = 0;
      if (a.nodeType === Node.ELEMENT_NODE && a.nodeName) for (var e = t(a.nodeName.split(/(?=[ .])+/g)), f = e.next(); !f.done; f = e.next()) {
        var g = f = f.value;

        if (g.startsWith(".voice-")) {
          var h = g.split("-").pop();
          g = 'v[voice="' + h + '"]';
          c.has(g) || (g = "v[voice=" + h + "]");
        }

        c.has(g) && (g = c.get(g)) && (d.backgroundColor = Xz(g.backgroundColor, d.backgroundColor), d.color = Xz(g.color, d.color), d.fontFamily = Xz(g.fontFamily, d.fontFamily), d.fontSize = Xz(g.fontSize, d.fontSize), d.fontWeight = g.fontWeight, d.fontStyle = g.fontStyle, d.opacity = g.opacity, d.rubyTag = g.rubyTag, d.textCombineUpright = g.textCombineUpright, d.textShadow = g.textShadow, d.wrapLine = g.wrapLine);

        switch (f) {
          case "br":
            d = Nc(d.startTime, d.endTime);
            b.nestedCues.push(d);
            return;

          case "b":
            d.fontWeight = 700;
            break;

          case "i":
            d.fontStyle = "italic";
            break;

          case "u":
            d.textDecoration.push("underline");
            break;

          case "font":
            if (f = a.getAttribute("color")) d.color = f;
            break;

          case "div":
            f = a.getAttribute("time");
            if (!f) break;
            if (f = Qz(new gt(f))) d.startTime = f;
            break;

          case "ruby":
          case "rp":
          case "rt":
            d.rubyTag = f;
        }
      }
      e = a.childNodes;
      if (Eg(a) || 1 == e.length && Eg(e[0])) for (e = !0, c = t(a.textContent.split("\n")), a = c.next(); !a.done; a = c.next()) a = a.value, e || (e = Nc(d.startTime, d.endTime), b.nestedCues.push(e)), 0 < a.length && (e = d.clone(), e.payload = Vz(a), b.nestedCues.push(e)), e = !1;else for (b.nestedCues.push(d), b = t(e), a = b.next(); !a.done; a = b.next()) Wz(a.value, d, c);
    }

    function Sz(a, b, c) {
      var d;
      if (d = /^align:(start|middle|center|end|left|right)$/.exec(b)) b = d[1], "middle" == b ? a.textAlign = Ec : a.textAlign = Pc[b.toUpperCase()];else if (d = /^vertical:(lr|rl)$/.exec(b)) a.writingMode = "lr" == d[1] ? "vertical-lr" : "vertical-rl";else if (d = /^size:([\d.]+)%$/.exec(b)) a.size = Number(d[1]);else if (d = /^position:([\d.]+)%(?:,(line-left|line-right|middle|center|start|end|auto))?$/.exec(b)) a.position = Number(d[1]), d[2] && (b = d[2], a.positionAlign = "line-left" == b || "start" == b ? "line-left" : "line-right" == b || "end" == b ? "line-right" : "center" == b || "middle" == b ? "center" : Cc);else if (d = /^region:(.*)$/.exec(b)) {
        if (b = Yz(c, d[1])) a.region = b;
      } else if (c = /^line:([\d.]+)%(?:,(start|end|center))?$/.exec(b)) a.lineInterpretation = 1, a.line = Number(c[1]), c[2] && (a.lineAlign = Rc[c[2].toUpperCase()]);else if (c = /^line:(-?\d+)(?:,(start|end|center))?$/.exec(b)) a.lineInterpretation = Hc, a.line = Number(c[1]), c[2] && (a.lineAlign = Rc[c[2].toUpperCase()]);
    }

    function Yz(a, b) {
      a = a.filter(function (c) {
        return c.id == b;
      });
      return a.length ? a[0] : null;
    }

    function Qz(a) {
      a = it(a, Uz);
      if (null == a) return null;
      var b = Number(a[2]),
          c = Number(a[3]);
      return 59 < b || 59 < c ? null : Number(a[4]) / 1E3 + c + 60 * b + 3600 * (Number(a[1]) || 0);
    }

    function Vz(a) {
      var b = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'",
        "&nbsp;": "\u00a0",
        "&lrm;": "\u200e",
        "&rlm;": "\u200f"
      },
          c = /&(?:amp|lt|gt|quot|#(0+)?39|nbsp|lrm|rlm);/g,
          d = RegExp(c.source);
      return a && d.test(a) ? a.replace(c, function (e) {
        return b[e] || "'";
      }) : a || "";
    }

    M("shaka.text.VttTextParser", Pz);
    Pz.prototype.parseMedia = Pz.prototype.parseMedia;
    Pz.prototype.setManifestType = Pz.prototype.setManifestType;
    Pz.prototype.setSequenceMode = Pz.prototype.setSequenceMode;
    Pz.prototype.parseInit = Pz.prototype.parseInit;
    var Uz = /(?:(\d{1,}):)?(\d{2}):(\d{2})\.(\d{2,3})/g;

    sd["text/vtt"] = function () {
      return new Pz();
    };

    sd['text/vtt; codecs="vtt"'] = function () {
      return new Pz();
    };

    sd['text/vtt; codecs="wvtt"'] = function () {
      return new Pz();
    };

    function Zz() {
      this.g = null;
    }

    Zz.prototype.parseInit = function (a) {
      var b = this,
          c = !1;
      new bg().box("moov", gg).box("trak", gg).box("mdia", gg).W("mdhd", function (d) {
        d = fi(d.reader, d.version);
        b.g = d.timescale;
      }).box("minf", gg).box("stbl", gg).W("stsd", ig).box("wvtt", function () {
        c = !0;
      }).parse(a);
      if (!this.g) throw new P(2, 2, 2008);
      if (!c) throw new P(2, 2, 2008);
    };

    Zz.prototype.setSequenceMode = function () {};

    Zz.prototype.setManifestType = function () {};

    Zz.prototype.parseMedia = function (a, b) {
      if (!a.length) return [];
      if (!this.g) throw new P(2, 2, 2008);
      var c = 0,
          d = [],
          e,
          f = [],
          g = !1,
          h = !1,
          k = !1,
          l = null;
      new bg().box("moof", gg).box("traf", gg).W("tfdt", function (B) {
        g = !0;
        c = ei(B.reader, B.version).baseMediaDecodeTime;
      }).W("tfhd", function (B) {
        l = di(B.reader, B.flags).Hg;
      }).W("trun", function (B) {
        h = !0;
        d = gi(B.reader, B.version, B.flags).dh;
      }).box("mdat", mg(function (B) {
        k = !0;
        e = B;
      })).parse(a, !1);
      if (!k && !g && !h) throw new P(2, 2, 2008);
      a = c;

      for (var m = new Zf(e, 0), n = t(d), r = n.next(); !r.done; r = n.next()) {
        r = r.value;
        var q = r.cg || l,
            u = r.Ce ? c + r.Ce : a;
        a = u + (q || 0);
        var v = 0;

        do {
          var y = m.O();
          v += y;
          var z = m.O(),
              x = null;
          "vttc" == fg(z) ? 8 < y && (x = m.Kb(y - 8)) : m.skip(y - 8);
          q && x && (y = $z(x, b.periodStart + u / this.g, b.periodStart + a / this.g), f.push(y));
        } while (r.sampleSize && v < r.sampleSize);
      }

      return f.filter(Bd);
    };

    function $z(a, b, c) {
      var d, e, f;
      new bg().box("payl", mg(function (g) {
        d = Tf(g);
      })).box("iden", mg(function (g) {
        e = Tf(g);
      })).box("sttg", mg(function (g) {
        f = Tf(g);
      })).parse(a);
      return d ? aA(d, e, f, b, c) : null;
    }

    function aA(a, b, c, d, e) {
      d = new Ac(d, e, "");
      Tz(a, d, new Map());
      b && (d.id = b);
      if (c) for (a = new gt(c), b = jt(a); b;) Sz(d, b, []), ht(a), b = jt(a);
      return d;
    }

    M("shaka.text.Mp4VttParser", Zz);
    Zz.prototype.parseMedia = Zz.prototype.parseMedia;
    Zz.prototype.setManifestType = Zz.prototype.setManifestType;
    Zz.prototype.setSequenceMode = Zz.prototype.setSequenceMode;
    Zz.prototype.parseInit = Zz.prototype.parseInit;

    sd['application/mp4; codecs="wvtt"'] = function () {
      return new Zz();
    };

    function bA() {}

    bA.prototype.parseInit = function () {};

    bA.prototype.setSequenceMode = function () {};

    bA.prototype.setManifestType = function () {};

    bA.prototype.parseMedia = function (a) {
      var b = Tf(a).replace(/\r+/g, "");
      b = b.trim();
      a = [];
      if ("" == b) return a;
      b = t(b.split("\n\n"));

      for (var c = b.next(); !c.done; c = b.next()) {
        c = c.value.split("\n");
        var d = new gt(c[0]),
            e = cA(d),
            f = it(d, /,/g);
        d = cA(d);
        if (null == e || null == f || null == d) throw new P(2, 2, 2001, "Could not parse cue time range in SubViewer");
        a.push(new Ac(e, d, c.slice(1).join("\n").trim()));
      }

      return a;
    };

    function cA(a) {
      a = it(a, /(?:(\d{1,}):)?(\d{2}):(\d{2})\.(\d{2,3})/g);
      if (null == a) return null;
      var b = Number(a[2]),
          c = Number(a[3]);
      return 59 < b || 59 < c ? null : Number(a[4]) / 1E3 + c + 60 * b + 3600 * (Number(a[1]) || 0);
    }

    M("shaka.text.SbvTextParser", bA);
    bA.prototype.parseMedia = bA.prototype.parseMedia;
    bA.prototype.setManifestType = bA.prototype.setManifestType;
    bA.prototype.setSequenceMode = bA.prototype.setSequenceMode;
    bA.prototype.parseInit = bA.prototype.parseInit;

    sd["text/x-subviewer"] = function () {
      return new bA();
    };

    function dA() {
      this.g = new Pz();
    }

    dA.prototype.parseInit = function () {};

    dA.prototype.setSequenceMode = function () {};

    dA.prototype.setManifestType = function () {};

    dA.prototype.parseMedia = function (a, b, c) {
      a = Tf(a);
      a = eA(a);
      a = nc(Xf(a));
      return this.g.parseMedia(a, b, c);
    };

    function eA(a) {
      var b = "WEBVTT\n\n";
      if ("" == a) return b;
      a = a.replace(/\r+/g, "");
      a = a.trim();
      a = t(a.split("\n\n"));

      for (var c = a.next(); !c.done; c = a.next()) c = c.value.split(/\n/), c[0].match(/\d+/) && c.shift(), c[0] = c[0].replace(/,/g, "."), b += c.join("\n").replace(/{b}/g, "<b>").replace(/{\/b}/g, "</b>").replace(/{i}/g, "<i>").replace(/{\/i}/g, "</i>").replace(/{u}/g, "<u>").replace(/{\/u}/g, "</u>") + "\n\n";

      return b;
    }

    M("shaka.text.SrtTextParser", dA);
    dA.srt2webvtt = eA;
    dA.prototype.parseMedia = dA.prototype.parseMedia;
    dA.prototype.setManifestType = dA.prototype.setManifestType;
    dA.prototype.setSequenceMode = dA.prototype.setSequenceMode;
    dA.prototype.parseInit = dA.prototype.parseInit;

    sd["text/srt"] = function () {
      return new dA();
    };

    function fA() {}

    fA.prototype.parseInit = function () {};

    fA.prototype.setSequenceMode = function () {};

    fA.prototype.setManifestType = function () {};

    fA.prototype.parseMedia = function (a) {
      var b = "",
          c = "";
      a = Tf(a).split(/\r?\n\s*\r?\n/);
      a = t(a);

      for (var d = a.next(); !d.done; d = a.next()) {
        var e = gA.exec(d.value);
        e && (d = e[1], e = e[2], "V4 Styles" == d || "V4+ Styles" == d ? b = e : "Events" == d && (c = e));
      }

      a = [];
      d = null;
      b = t(b.split(/\r?\n/));

      for (var f = b.next(); !f.done; f = b.next()) if (e = f.value, !/^\s*;/.test(e) && (f = hA.exec(e))) if (e = f[1].trim(), f = f[2].trim(), "Format" == e) d = f.split(iA);else if ("Style" == e) {
        e = f.split(iA);
        f = {};

        for (var g = 0; g < d.length && g < e.length; g++) f[d[g]] = e[g];

        a.push(f);
      }

      d = [];
      b = null;
      e = {};
      c = t(c.split(/\r?\n/));

      for (f = c.next(); !f.done; e = {
        Re: e.Re
      }, f = c.next()) if (f = f.value, !/^\s*;/.test(f) && (g = hA.exec(f))) if (f = g[1].trim(), g = g[2].trim(), "Format" == f) b = g.split(iA);else if ("Dialogue" == f) {
        g = g.split(iA);
        f = {};

        for (var h = 0; h < b.length && h < g.length; h++) f[b[h]] = g[h];

        h = jA(f.Start);
        var k = jA(f.End);
        g = new Ac(h, k, g.slice(b.length - 1).join(",").replace(/\\N/g, "\n").replace(/\{[^}]+\}/g, ""));
        e.Re = f.Style;
        (f = a.find(function (l) {
          return function (m) {
            return m.Name == l.Re;
          };
        }(e))) && kA(g, f);
        d.push(g);
      }

      return d;
    };

    function kA(a, b) {
      var c = b.Fontname;
      c && (a.fontFamily = c);
      if (c = b.Fontsize) a.fontSize = c + "px";
      if (c = b.PrimaryColour) if (c = lA(c)) a.color = c;
      if (c = b.BackColour) if (c = lA(c)) a.backgroundColor = c;
      b.Bold && (a.fontWeight = 700);
      b.Italic && (a.fontStyle = "italic");
      b.Underline && a.textDecoration.push("underline");
      if (c = b.Spacing) a.letterSpacing = c + "px";
      if (c = b.Alignment) switch (parseInt(c, 10)) {
        case 1:
          a.displayAlign = Jc;
          a.textAlign = "start";
          break;

        case 2:
          a.displayAlign = Jc;
          a.textAlign = Ec;
          break;

        case 3:
          a.displayAlign = Jc;
          a.textAlign = "end";
          break;

        case 5:
          a.displayAlign = "before";
          a.textAlign = "start";
          break;

        case 6:
          a.displayAlign = "before";
          a.textAlign = Ec;
          break;

        case 7:
          a.displayAlign = "before";
          a.textAlign = "end";
          break;

        case 9:
          a.displayAlign = "center";
          a.textAlign = "start";
          break;

        case 10:
          a.displayAlign = "center";
          a.textAlign = Ec;
          break;

        case 11:
          a.displayAlign = "center", a.textAlign = "end";
      }
      if (b = b.AlphaLevel) a.opacity = parseFloat(b);
    }

    function lA(a) {
      a = parseInt(a.replace("&H", ""), 16);
      return 0 <= a ? "rgba(" + (a & 255) + "," + (a >> 8 & 255) + "," + (a >> 16 & 255) + "," + (a >> 24 & 255 ^ 255) / 255 + ")" : null;
    }

    function jA(a) {
      a = mA.exec(a);
      return 3600 * (a[1] ? parseInt(a[1].replace(":", ""), 10) : 0) + 60 * parseInt(a[2], 10) + parseFloat(a[3]);
    }

    M("shaka.text.SsaTextParser", fA);
    fA.prototype.parseMedia = fA.prototype.parseMedia;
    fA.prototype.setManifestType = fA.prototype.setManifestType;
    fA.prototype.setSequenceMode = fA.prototype.setSequenceMode;
    fA.prototype.parseInit = fA.prototype.parseInit;
    var gA = /^\s*\[([^\]]+)\]\r?\n([\s\S]*)/,
        hA = /^\s*([^:]+):\s*(.*)/,
        iA = /\s*,\s*/,
        mA = /^(\d+:)?(\d{1,2}):(\d{1,2}(?:[.]\d{1,3})?)?$/;

    sd["text/x-ssa"] = function () {
      return new fA();
    };

    function nA(a, b) {
      var c = a[b + 1] & 1 ? 7 : 9;
      return b + c <= a.length && (a = ((a[b + 3] & 3) << 11 | a[b + 4] << 3 | (a[b + 5] & 224) >>> 5) - c, 0 < a) ? {
        je: c,
        X: a
      } : null;
    }

    function oA(a, b) {
      var c = [96E3, 88200, 64E3, 48E3, 44100, 32E3, 24E3, 22050, 16E3, 12E3, 11025, 8E3, 7350],
          d = (a[b + 2] & 60) >>> 2;
      if (d > c.length - 1) return null;
      var e = ((a[b + 2] & 192) >>> 6) + 1,
          f = (a[b + 2] & 1) << 2;
      f |= (a[b + 3] & 192) >>> 6;
      return {
        sampleRate: c[d],
        channelCount: f,
        va: "mp4a.40." + e
      };
    }

    function pA(a, b) {
      if (b + 1 < a.length && 255 === a[b] && 240 === (a[b + 1] & 246)) {
        var c = a[b + 1] & 1 ? 7 : 9;
        if (b + c >= a.length) return !1;
        var d = (a[b + 3] & 3) << 11 | a[b + 4] << 3 | (a[b + 5] & 224) >>> 5;
        if (d <= c) return !1;
        b += d;
        return b === a.length || b + 1 < a.length && 255 === a[b] && 240 === (a[b + 1] & 246);
      }

      return !1;
    }

    function qA(a, b) {
      switch (a) {
        case "mp4a.40.2":
          if (1 === b) return new Uint8Array([0, 200, 0, 128, 35, 128]);
          if (2 === b) return new Uint8Array([33, 0, 73, 144, 2, 25, 0, 35, 128]);
          if (3 === b) return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 142]);
          if (4 === b) return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 128, 44, 128, 8, 2, 56]);
          if (5 === b) return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 56]);
          if (6 === b) return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 0, 178, 0, 32, 8, 224]);
          break;

        default:
          if (1 === b) return new Uint8Array([1, 64, 34, 128, 163, 78, 230, 128, 186, 8, 0, 0, 0, 28, 6, 241, 193, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
          if (2 === b || 3 === b) return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
      }

      return null;
    }

    ;

    function rA(a) {
      this.i = a;
      this.h = 0;
      this.g = new Map();
    }

    p = rA.prototype;

    p.destroy = function () {
      this.g.clear();
    };

    p.isSupported = function (a) {
      return "audio/aac" == a.toLowerCase().split(";")[0] ? fc(this.convertCodecs("audio", a)) : !1;
    };

    p.convertCodecs = function (a, b) {
      return "audio/aac" == b.toLowerCase().split(";")[0] ? 'audio/mp4; codecs="' + (pd(b) || "mp4a.40.2") + '"' : b;
    };

    p.getOriginalMimeType = function () {
      return this.i;
    };

    p.transmux = function (a, b, c, d) {
      for (var e = nc(a), f = ci(e), g = f.length; g < e.length && !pA(e, g); g++);

      a = 1E3 * c.endTime;
      f = bi(f);
      f.length && c && (c = f.find(function (l) {
        return "com.apple.streaming.transportStreamTimestamp" === l.description;
      })) && (a = c.data);
      c = oA(e, g);
      if (!c) return Promise.reject(new P(2, 3, 3018));
      b.audioSamplingRate = c.sampleRate;
      b.channelsCount = c.channelCount;

      for (f = []; g < e.length;) {
        var h = nA(e, g);
        if (!h) return Promise.reject(new P(2, 3, 3018));
        var k = h.je + h.X;
        g + k <= e.length && f.push({
          data: e.subarray(g + h.je, g + k),
          size: h.X,
          duration: 1024,
          gb: 0,
          flags: {
            ib: 0,
            Za: 0,
            Ya: 0,
            Wa: 0,
            Xa: 2,
            jb: 0
          }
        });
        g += k;
      }

      e = c.sampleRate;
      a = Math.floor(a * e / 1E3);
      d = {
        id: b.id,
        type: "audio",
        codecs: c.va,
        encrypted: b.encrypted && 0 < b.drmInfos.length,
        timescale: e,
        duration: d,
        eb: [],
        oa: new Uint8Array([]),
        Ba: new Uint8Array([]),
        data: {
          vb: this.h,
          baseMediaDecodeTime: a,
          ab: f
        },
        stream: b
      };
      a = new Iu([d]);
      this.g.has(b.id) ? d = this.g.get(b.id) : (d = Ou(a), this.g.set(b.id, d));
      b = dv(a);
      this.h++;
      b = tg(d, b);
      return Promise.resolve(b);
    };

    M("shaka.transmuxer.AacTransmuxer", rA);
    rA.prototype.transmux = rA.prototype.transmux;
    rA.prototype.getOriginalMimeType = rA.prototype.getOriginalMimeType;
    rA.prototype.convertCodecs = rA.prototype.convertCodecs;
    rA.prototype.isSupported = rA.prototype.isSupported;
    rA.prototype.destroy = rA.prototype.destroy;
    Yc("audio/aac", function () {
      return new rA("audio/aac");
    }, dd);

    function sA(a, b) {
      if (b + 8 > a.length || 11 !== a[b] || 119 !== a[b + 1]) return null;
      var c = a[b + 4] >> 6;
      if (3 <= c) return null;
      var d = a[b + 4] & 63,
          e = 2 * [64, 69, 96, 64, 70, 96, 80, 87, 120, 80, 88, 120, 96, 104, 144, 96, 105, 144, 112, 121, 168, 112, 122, 168, 128, 139, 192, 128, 140, 192, 160, 174, 240, 160, 175, 240, 192, 208, 288, 192, 209, 288, 224, 243, 336, 224, 244, 336, 256, 278, 384, 256, 279, 384, 320, 348, 480, 320, 349, 480, 384, 417, 576, 384, 418, 576, 448, 487, 672, 448, 488, 672, 512, 557, 768, 512, 558, 768, 640, 696, 960, 640, 697, 960, 768, 835, 1152, 768, 836, 1152, 896, 975, 1344, 896, 976, 1344, 1024, 1114, 1536, 1024, 1115, 1536, 1152, 1253, 1728, 1152, 1254, 1728, 1280, 1393, 1920, 1280, 1394, 1920][3 * d + c];
      if (b + e > a.length) return null;
      var f = a[b + 6] >> 5,
          g = 0;
      2 === f ? g += 2 : (f & 1 && 1 !== f && (g += 2), f & 4 && (g += 2));
      g = (a[b + 6] << 8 | a[b + 7]) >> 12 - g & 1;
      var h = a[b + 5] & 7;
      a = new Uint8Array([c << 6 | a[b + 5] >> 3 << 1 | h >> 2, (h & 3) << 6 | f << 3 | g << 2 | d >> 4, d << 4 & 224]);
      return {
        sampleRate: [48E3, 44100, 32E3][c],
        channelCount: [2, 1, 2, 3, 3, 4, 4, 5][f] + g,
        oa: a,
        X: e
      };
    }

    function tA(a, b) {
      if (11 === a[b] && 119 === a[b + 1]) {
        var c = 0,
            d = 5;
        b += d;

        for (var e, f; 0 < d;) {
          f = a[b];
          var g = Math.min(d, 8),
              h = 8 - g;
          e = 4278190080 >>> 24 + h << h;
          e = (f & e) >> h;
          c = c ? c << g | e : e;
          b += 1;
          d -= g;
        }

        if (16 > c) return !0;
      }

      return !1;
    }

    ;

    function uA(a) {
      this.i = a;
      this.h = 0;
      this.g = new Map();
    }

    p = uA.prototype;

    p.destroy = function () {
      this.g.clear();
    };

    p.isSupported = function (a) {
      return "audio/ac3" == a.toLowerCase().split(";")[0] ? fc(this.convertCodecs("audio", a)) : !1;
    };

    p.convertCodecs = function (a, b) {
      return "audio/ac3" == b.toLowerCase().split(";")[0] ? 'audio/mp4; codecs="ac-3"' : b;
    };

    p.getOriginalMimeType = function () {
      return this.i;
    };

    p.transmux = function (a, b, c, d) {
      a = nc(a);

      for (var e = ci(a), f = e.length; f < a.length && !tA(a, f); f++);

      var g = 1E3 * c.endTime;
      e = bi(e);
      e.length && c && (c = e.find(function (l) {
        return "com.apple.streaming.transportStreamTimestamp" === l.description;
      })) && (g = c.data);
      c = 0;
      e = new Uint8Array([]);

      for (var h = []; f < a.length;) {
        var k = sA(a, f);
        if (!k) return Promise.reject(new P(2, 3, 3018));
        b.audioSamplingRate = k.sampleRate;
        b.channelsCount = k.channelCount;
        c = k.sampleRate;
        e = k.oa;
        h.push({
          data: a.subarray(f, f + k.X),
          size: k.X,
          duration: 1536,
          gb: 0,
          flags: {
            ib: 0,
            Za: 0,
            Ya: 0,
            Wa: 0,
            Xa: 2,
            jb: 0
          }
        });
        f += k.X;
      }

      a = Math.floor(g * c / 1E3);
      d = {
        id: b.id,
        type: "audio",
        codecs: "ac-3",
        encrypted: b.encrypted && 0 < b.drmInfos.length,
        timescale: c,
        duration: d,
        eb: [],
        oa: e,
        Ba: new Uint8Array([]),
        data: {
          vb: this.h,
          baseMediaDecodeTime: a,
          ab: h
        },
        stream: b
      };
      a = new Iu([d]);
      this.g.has(b.id) ? d = this.g.get(b.id) : (d = Ou(a), this.g.set(b.id, d));
      b = dv(a);
      this.h++;
      b = tg(d, b);
      return Promise.resolve(b);
    };

    M("shaka.transmuxer.Ac3Transmuxer", uA);
    uA.prototype.transmux = uA.prototype.transmux;
    uA.prototype.getOriginalMimeType = uA.prototype.getOriginalMimeType;
    uA.prototype.convertCodecs = uA.prototype.convertCodecs;
    uA.prototype.isSupported = uA.prototype.isSupported;
    uA.prototype.destroy = uA.prototype.destroy;
    Yc("audio/ac3", function () {
      return new uA("audio/ac3");
    }, dd);

    function vA(a, b) {
      if (b + 8 > a.length || 2935 !== (a[b] << 8 | a[b + 1] << 0)) return null;
      var c = new mi(a.subarray(b + 2));
      oi(c, 2);
      oi(c, 3);
      var d = pi(c, 11) + 1 << 1,
          e = pi(c, 2);

      if (3 == e) {
        e = pi(c, 2);
        e = [24E3, 22060, 16E3][e];
        var f = 3;
      } else e = [48E3, 44100, 32E3][e], f = pi(c, 2);

      var g = pi(c, 3),
          h = pi(c, 1);
      c = pi(c, 5);
      if (b + d > a.byteLength) return null;
      a = Math.floor(d * e / (16 * [1, 2, 3, 6][f]));
      a = new Uint8Array([(a & 8160) >> 5, (a & 31) << 3, e << 6 | c << 1 | 0, 0 | g << 1 | h << 0, 0]);
      return {
        sampleRate: e,
        channelCount: [2, 1, 2, 3, 3, 4, 4, 5][g] + h,
        oa: a,
        X: d
      };
    }

    ;

    function wA(a) {
      this.i = a;
      this.h = 0;
      this.g = new Map();
    }

    p = wA.prototype;

    p.destroy = function () {
      this.g.clear();
    };

    p.isSupported = function (a) {
      return "audio/ec3" == a.toLowerCase().split(";")[0] ? fc(this.convertCodecs("audio", a)) : !1;
    };

    p.convertCodecs = function (a, b) {
      return "audio/ec3" == b.toLowerCase().split(";")[0] ? 'audio/mp4; codecs="ec-3"' : b;
    };

    p.getOriginalMimeType = function () {
      return this.i;
    };

    p.transmux = function (a, b, c, d) {
      a = nc(a);

      for (var e = ci(a), f = e.length; f < a.length && 2935 !== (a[f] << 8 | a[f + 1] << 0); f++);

      var g = 1E3 * c.endTime;
      e = bi(e);
      e.length && c && (c = e.find(function (l) {
        return "com.apple.streaming.transportStreamTimestamp" === l.description;
      })) && (g = c.data);
      c = 0;
      e = new Uint8Array([]);

      for (var h = []; f < a.length;) {
        var k = vA(a, f);
        if (!k) return Promise.reject(new P(2, 3, 3018));
        b.audioSamplingRate = k.sampleRate;
        b.channelsCount = k.channelCount;
        c = k.sampleRate;
        e = k.oa;
        h.push({
          data: a.subarray(f, f + k.X),
          size: k.X,
          duration: 1536,
          gb: 0,
          flags: {
            ib: 0,
            Za: 0,
            Ya: 0,
            Wa: 0,
            Xa: 2,
            jb: 0
          }
        });
        f += k.X;
      }

      a = Math.floor(g * c / 1E3);
      d = {
        id: b.id,
        type: "audio",
        codecs: "ec-3",
        encrypted: b.encrypted && 0 < b.drmInfos.length,
        timescale: c,
        duration: d,
        eb: [],
        oa: e,
        Ba: new Uint8Array([]),
        data: {
          vb: this.h,
          baseMediaDecodeTime: a,
          ab: h
        },
        stream: b
      };
      a = new Iu([d]);
      this.g.has(b.id) ? d = this.g.get(b.id) : (d = Ou(a), this.g.set(b.id, d));
      b = dv(a);
      this.h++;
      b = tg(d, b);
      return Promise.resolve(b);
    };

    M("shaka.transmuxer.Ec3Transmuxer", wA);
    wA.prototype.transmux = wA.prototype.transmux;
    wA.prototype.getOriginalMimeType = wA.prototype.getOriginalMimeType;
    wA.prototype.convertCodecs = wA.prototype.convertCodecs;
    wA.prototype.isSupported = wA.prototype.isSupported;
    wA.prototype.destroy = wA.prototype.destroy;
    Yc("audio/ec3", function () {
      return new wA("audio/ec3");
    }, dd);

    function xA(a) {
      if (!a.length) return null;
      var b = a.find(function (m) {
        return 7 == m.type;
      });
      a = a.find(function (m) {
        return 8 == m.type;
      });
      if (!b || !a) return null;
      var c = new mi(b.data),
          d = ti(c);
      ti(c);
      ti(c);
      ri(c);

      if (yA.includes(d) && (d = R(c), 3 === d && oi(c, 1), ri(c), ri(c), oi(c, 1), S(c))) {
        d = 3 !== d ? 8 : 12;

        for (var e = 0; e < d; e++) S(c) && (6 > e ? ui(c, 16) : ui(c, 64));
      }

      ri(c);
      d = R(c);
      if (0 === d) R(c);else if (1 === d) for (oi(c, 1), ri(c), ri(c), d = R(c), e = 0; e < d; e++) ri(c);
      ri(c);
      oi(c, 1);
      d = R(c);
      var f = R(c),
          g = pi(c, 1);
      0 === g && oi(c, 1);
      oi(c, 1);
      var h = e = 0,
          k = 0,
          l = 0;
      S(c) && (e = R(c), h = R(c), k = R(c), l = R(c));
      c = (2 - g) * (f + 1) * 16 - 2 * k - 2 * l;
      d = 16 * (d + 1) - 2 * e - 2 * h;
      e = [];
      b = b.fullData;
      e.push(b.byteLength >>> 8 & 255);
      e.push(b.byteLength & 255);
      e = e.concat.apply(e, w(b));
      b = [];
      a = a.fullData;
      b.push(a.byteLength >>> 8 & 255);
      b.push(a.byteLength & 255);
      b = b.concat.apply(b, w(a));
      a = new Uint8Array([1, e[3], e[4], e[5], 255, 225].concat(e, [1], b));
      return {
        height: c,
        width: d,
        Ba: a
      };
    }

    function zA(a) {
      var b = !1,
          c = [],
          d = a.find(function (k) {
        return 7 == k.type;
      }),
          e = !1;
      a = t(a);

      for (var f = a.next(); !f.done; f = a.next()) {
        f = f.value;
        var g = !1;

        switch (f.type) {
          case 1:
            g = e = !0;
            var h = f.data;
            d && 4 < h.length && (h = vi(new mi(h)), 2 === h || 4 === h || 7 === h || 9 === h) && (b = !0);
            break;

          case 5:
            b = g = e = !0;
            break;

          case 6:
            g = !0;
            break;

          case 7:
            g = !0;
            break;

          case 8:
            g = !0;
            break;

          case 9:
            e = g = !0;
            break;

          case 12:
            g = !0;
            break;

          default:
            g = !1;
        }

        e && g && (g = f.fullData.byteLength, h = new Uint8Array(4), h[0] = g >> 24 & 255, h[1] = g >> 16 & 255, h[2] = g >> 8 & 255, h[3] = g & 255, c.push(tg(h, f.fullData)));
      }

      return c.length ? {
        data: tg.apply(ng, w(c)),
        yd: b
      } : null;
    }

    var yA = [100, 110, 122, 244, 44, 83, 86, 118, 128, 138, 139, 134];

    function AA(a) {
      if (!a.length) return null;
      var b = a.find(function (g) {
        return 32 == g.type;
      }),
          c = a.find(function (g) {
        return 33 == g.type;
      }),
          d = a.find(function (g) {
        return 34 == g.type;
      });
      if (!b || !c || !d) return null;
      var e = BA(b.fullData);
      a = CA(c.fullData);
      var f = DA(d.fullData);
      b = EA(b.fullData, c.fullData, d.fullData, {
        Rf: e.Rf,
        og: e.og,
        vf: a.vf,
        wf: a.wf,
        nf: a.nf,
        uf: a.uf,
        pf: a.pf,
        qf: a.qf,
        rf: a.rf,
        tf: a.tf,
        gf: a.gf,
        hf: a.hf,
        jf: a.jf,
        kf: a.kf,
        lf: a.lf,
        mf: a.mf,
        cf: a.cf,
        ue: a.ue,
        bf: a.bf,
        Ye: a.Ye,
        Xe: a.Xe,
        Uf: f.Uf
      });
      return {
        height: a.height,
        width: a.width,
        Ba: b
      };
    }

    function BA(a) {
      var b = new mi(a, !0);
      ti(b);
      ti(b);
      pi(b, 4);
      pi(b, 2);
      pi(b, 6);
      a = pi(b, 3);
      b = S(b);
      return {
        Rf: a + 1,
        og: b
      };
    }

    function CA(a) {
      a = new mi(a, !0);
      ti(a);
      ti(a);
      var b = 0,
          c = 0,
          d = 0,
          e = 0;
      pi(a, 4);
      var f = pi(a, 3);
      S(a);

      for (var g = pi(a, 2), h = pi(a, 1), k = pi(a, 5), l = ti(a), m = ti(a), n = ti(a), r = ti(a), q = ti(a), u = ti(a), v = ti(a), y = ti(a), z = ti(a), x = ti(a), B = ti(a), A = [], C = [], E = 0; E < f; E++) A.push(S(a)), C.push(S(a));

      if (0 < f) for (E = f; 8 > E; E++) pi(a, 2);

      for (E = 0; E < f; E++) A[E] && pi(a, 88), C[E] && ti(a);

      R(a);
      A = R(a);
      3 == A && pi(a, 1);
      C = R(a);
      E = R(a);
      S(a) && (b += R(a), c += R(a), d += R(a), e += R(a));
      var H = R(a),
          G = R(a),
          I = R(a);
      if (S(a)) for (var J = 0; J <= f; J++) R(a), R(a), R(a);else R(a), R(a), R(a);
      R(a);
      R(a);
      R(a);
      R(a);
      R(a);
      R(a);
      if (S(a) && S(a)) for (J = 0; 4 > J; J++) for (var L = 0; L < (3 === J ? 2 : 6); L++) if (S(a)) {
        var O = Math.min(64, 1 << 4 + (J << 1));
        1 < J && si(a);

        for (var Q = 0; Q < O; Q++) si(a);
      } else R(a);
      S(a);
      S(a);
      S(a) && (ti(a), R(a), R(a), S(a));
      J = R(a);

      for (O = L = 0; O < J; O++) if (Q = !1, 0 !== O && (Q = S(a)), Q) {
        O === J && R(a);
        S(a);
        R(a);

        for (var V = Q = 0; V <= L; V++) {
          var U = S(a),
              oa = !1;
          U || (oa = S(a));
          (U || oa) && Q++;
        }

        L = Q;
      } else {
        V = R(a);
        Q = R(a);
        L = V + Q;

        for (U = 0; U < V; U++) R(a), S(a);

        for (V = 0; V < Q; V++) R(a), S(a);
      }

      if (S(a)) for (J = R(a), L = 0; L < J; L++) {
        for (O = 0; O < I + 4; O++) pi(a, 1);

        pi(a, 1);
      }
      I = 0;
      S(a);
      S(a);

      if (S(a)) {
        S(a) && 255 === ti(a) && (pi(a, 16), pi(a, 16));
        S(a) && S(a);
        S(a) && (pi(a, 3), S(a), S(a) && (ti(a), ti(a), ti(a)));
        S(a) && (R(a), R(a));
        S(a);
        S(a);
        S(a);
        if (J = S(a)) R(a), R(a), R(a), R(a);

        if (S(a) && (pi(a, 32), pi(a, 32), S(a) && R(a), S(a))) {
          O = !1;
          J = S(a);
          L = S(a);

          if (J || L) {
            if (O = S(a)) ti(a), pi(a, 5), S(a), pi(a, 5);
            pi(a, 4);
            pi(a, 4);
            O && pi(a, 4);
            pi(a, 5);
            pi(a, 5);
            pi(a, 5);
          }

          for (Q = 0; Q <= f; Q++) {
            U = !0;
            V = 1;
            S(a) || (U = S(a));
            oa = !1;
            U ? R(a) : oa = S(a);
            oa || (V = R(a) + 1);

            if (J) {
              for (U = 0; U < V; U++) R(a), R(a), O && (R(a), R(a));

              S(a);
            }

            if (L) {
              for (U = 0; U < V; U++) R(a), R(a), O && (R(a), R(a));

              S(a);
            }
          }
        }

        S(a) && (S(a), S(a), S(a), I = R(a), R(a), R(a), R(a), R(a));
      }

      return {
        nf: B,
        vf: g,
        wf: h,
        uf: k,
        pf: l,
        qf: m,
        rf: n,
        tf: r,
        gf: q,
        hf: u,
        jf: v,
        kf: y,
        lf: z,
        mf: x,
        ue: I,
        cf: 0,
        bf: A,
        Ye: H,
        Xe: G,
        width: C - (b + c) * (1 === A || 2 === A ? 2 : 1),
        height: E - (d + e) * (1 === A ? 2 : 1)
      };
    }

    function DA(a) {
      var b = new mi(a, !0);
      ti(b);
      ti(b);
      R(b);
      R(b);
      S(b);
      S(b);
      pi(b, 3);
      S(b);
      S(b);
      R(b);
      R(b);
      si(b);
      S(b);
      S(b);
      S(b) && R(b);
      si(b);
      si(b);
      S(b);
      S(b);
      S(b);
      S(b);
      a = S(b);
      b = S(b);
      var c = 1;
      b && a ? c = 0 : b ? c = 3 : a && (c = 2);
      return {
        Uf: c
      };
    }

    function EA(a, b, c, d) {
      var e = new Uint8Array(23 + (5 + a.byteLength) + (5 + b.byteLength) + (5 + c.byteLength));
      e[0] = 1;
      e[1] = (d.vf & 3) << 6 | (d.wf ? 1 : 0) << 5 | d.uf & 31;
      e[2] = d.pf;
      e[3] = d.qf;
      e[4] = d.rf;
      e[5] = d.tf;
      e[6] = d.gf;
      e[7] = d.hf;
      e[8] = d.jf;
      e[9] = d.kf;
      e[10] = d.lf;
      e[11] = d.mf;
      e[12] = d.nf;
      e[13] = 240 | (d.ue & 3840) >> 8;
      e[14] = d.ue & 255;
      e[15] = 252 | d.Uf & 3;
      e[16] = 252 | d.bf & 3;
      e[17] = 248 | d.Ye & 7;
      e[18] = 248 | d.Xe & 7;
      e[19] = 0;
      e[20] = 0;
      e[21] = (d.cf & 3) << 6 | (d.Rf & 7) << 3 | (d.og ? 1 : 0) << 2 | 3;
      e[22] = 3;
      e[23] = 160;
      e[24] = 0;
      e[25] = 1;
      e[26] = (a.byteLength & 65280) >> 8;
      e[27] = (a.byteLength & 255) >> 0;
      e.set(a, 28);
      e[23 + (5 + a.byteLength)] = 161;
      e[a.byteLength + 29] = 0;
      e[a.byteLength + 30] = 1;
      e[a.byteLength + 31] = (b.byteLength & 65280) >> 8;
      e[a.byteLength + 32] = (b.byteLength & 255) >> 0;
      e.set(b, a.byteLength + 33);
      e[23 + (a.byteLength + 10 + b.byteLength)] = 162;
      e[a.byteLength + 10 + b.byteLength + 24] = 0;
      e[a.byteLength + 10 + b.byteLength + 25] = 1;
      e[a.byteLength + 10 + b.byteLength + 26] = (c.byteLength & 65280) >> 8;
      e[a.byteLength + 10 + b.byteLength + 27] = (c.byteLength & 255) >> 0;
      e.set(c, a.byteLength + 10 + b.byteLength + 28);
      return e;
    }

    ;

    function FA(a, b) {
      var c = a[b + 1] >> 3 & 3,
          d = a[b + 1] >> 1 & 3,
          e = a[b + 2] >> 4 & 15,
          f = a[b + 2] >> 2 & 3;

      if (1 !== c && 0 !== e && 15 !== e && 3 !== f) {
        var g = a[b + 3] >> 6;
        e = 1E3 * GA[14 * (3 === c ? 3 - d : 3 === d ? 3 : 4) + e - 1];
        f = HA[3 * (3 === c ? 0 : 2 === c ? 1 : 2) + f];
        c = IA[c][d];
        var h = JA[d],
            k = Math.floor(c * e / f + (a[b + 2] >> 1 & 1)) * h,
            l = (navigator.userAgent || "").match(/Chrome\/(\d+)/i);
        (l = l ? parseInt(l[1], 10) : 0) && 87 >= l && 2 === d && 224E3 <= e && 0 === g && (a[b + 3] |= 128);
        return {
          sampleRate: f,
          channelCount: 3 === g ? 1 : 2,
          X: k,
          aj: 8 * c * h
        };
      }

      return null;
    }

    function KA(a, b) {
      return 255 === a[b] && 224 === (a[b + 1] & 224) && 0 !== (a[b + 1] & 6);
    }

    var GA = [32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160],
        HA = [44100, 48E3, 32E3, 22050, 24E3, 16E3, 11025, 12E3, 8E3],
        IA = [[0, 72, 144, 12], [0, 0, 0, 0], [0, 72, 144, 12], [0, 144, 144, 12]],
        JA = [0, 1, 1, 4];

    function LA(a) {
      this.i = a;
      this.h = 0;
      this.g = new Map();
    }

    p = LA.prototype;

    p.destroy = function () {
      this.g.clear();
    };

    p.isSupported = function (a) {
      return "audio/mpeg" == a.toLowerCase().split(";")[0] ? fc(this.convertCodecs("audio", a)) : !1;
    };

    p.convertCodecs = function (a, b) {
      return "audio/mpeg" == b.toLowerCase().split(";")[0] ? 'audio/mp4; codecs="mp3"' : b;
    };

    p.getOriginalMimeType = function () {
      return this.i;
    };

    p.transmux = function (a, b, c, d) {
      a = nc(a);

      for (c = ci(a).length; c < a.length; c++) {
        var e = c;

        if (e + 1 < a.length && KA(a, e)) {
          var f = FA(a, e),
              g = 4;
          f && f.X && (g = f.X);
          e += g;
          e = e === a.length || e + 1 < a.length && KA(a, e);
        } else e = !1;

        if (e) break;
      }

      var h;

      for (e = []; c < a.length;) {
        f = FA(a, c);
        if (!f) return Promise.reject(new P(2, 3, 3018));
        h || (h = f);
        c + f.X <= a.length && e.push({
          data: a.subarray(c, c + f.X),
          size: f.X,
          duration: 1152,
          gb: 0,
          flags: {
            ib: 0,
            Za: 0,
            Ya: 0,
            Wa: 0,
            Xa: 2,
            jb: 0
          }
        });
        c += f.X;
      }

      if (!h) return Promise.reject(new P(2, 3, 3018));
      a = 9E4 * h.aj / h.sampleRate * this.h;
      d = {
        id: b.id,
        type: "audio",
        codecs: "mp3",
        encrypted: b.encrypted && 0 < b.drmInfos.length,
        timescale: h.sampleRate,
        duration: d,
        eb: [],
        oa: new Uint8Array([]),
        Ba: new Uint8Array([]),
        data: {
          vb: this.h,
          baseMediaDecodeTime: a,
          ab: e
        },
        stream: b
      };
      h = new Iu([d]);
      this.g.has(b.id) ? d = this.g.get(b.id) : (d = Ou(h), this.g.set(b.id, d));
      b = dv(h);
      this.h++;
      b = tg(d, b);
      return Promise.resolve(b);
    };

    M("shaka.transmuxer.Mp3Transmuxer", LA);
    LA.prototype.transmux = LA.prototype.transmux;
    LA.prototype.getOriginalMimeType = LA.prototype.getOriginalMimeType;
    LA.prototype.convertCodecs = LA.prototype.convertCodecs;
    LA.prototype.isSupported = LA.prototype.isSupported;
    LA.prototype.destroy = LA.prototype.destroy;
    Yc("audio/mpeg", function () {
      return new LA("audio/mpeg");
    }, dd);

    function MA(a) {
      this.h = a;
      this.g = null;
    }

    p = MA.prototype;

    p.destroy = function () {};

    p.isSupported = function (a) {
      if ("video/mp2t" != a.toLowerCase().split(";")[0]) return !1;
      var b = pd(a).split(","),
          c = Kb("audio", b);
      b = Kb("video", b);
      return !c || b || "mp3" != ld(c) ? !1 : fc(this.convertCodecs("audio", a));
    };

    p.convertCodecs = function (a, b) {
      return "video/mp2t" == b.toLowerCase().split(";")[0] ? "audio/mpeg" : b;
    };

    p.getOriginalMimeType = function () {
      return this.h;
    };

    p.transmux = function (a, b, c, d, e) {
      this.g ? this.g.clearData() : this.g = new wi();
      a = nc(a);
      a = this.g.parse(a);
      if ("mp3" != a.pd().audio || "audio" != e) return Promise.reject(new P(2, 3, 3018));
      e = new Uint8Array([]);
      a = t(a.kc());

      for (b = a.next(); !b.done; b = a.next()) if (b = b.value.data) for (c = 0; c < b.length;) (d = FA(b, c)) ? (c + d.X <= b.length && (e = tg(e, b.subarray(c, c + d.X))), c += d.X) : c++;

      return Promise.resolve(e);
    };

    M("shaka.transmuxer.MpegTsTransmuxer", MA);
    MA.prototype.transmux = MA.prototype.transmux;
    MA.prototype.getOriginalMimeType = MA.prototype.getOriginalMimeType;
    MA.prototype.convertCodecs = MA.prototype.convertCodecs;
    MA.prototype.isSupported = MA.prototype.isSupported;
    MA.prototype.destroy = MA.prototype.destroy;
    Yc("video/mp2t", function () {
      return new MA("video/mp2t");
    }, cd);
    /*
    @license
    MSS Transmuxer
    Copyright 2015 Dash Industry Forum
    SPDX-License-Identifier: BSD-3-Clause
    */

    function NA(a) {
      this.h = a;
      (this.g = Ss.get("ISOBoxer")()) && OA(this);
    }

    function OA(a) {
      function b() {
        this._procFullBox();

        this.flags & 1 && (this._procField("AlgorithmID", "uint", 24), this._procField("IV_size", "uint", 8), this._procFieldArray("KID", 16, "uint", 8));

        this._procField("sample_count", "uint", 32);

        this._procEntries("entry", this.sample_count, function (c) {
          this._procEntryField(c, "InitializationVector", "data", 8);

          this.flags & 2 && (this._procEntryField(c, "NumberOfEntries", "uint", 16), this._procSubEntries(c, "clearAndCryptedData", c.NumberOfEntries, function (d) {
            this._procEntryField(d, "BytesOfClearData", "uint", 16);

            this._procEntryField(d, "BytesOfEncryptedData", "uint", 32);
          }));
        });
      }

      a.g.addBoxProcessor("saio", function () {
        this._procFullBox();

        this.flags & 1 && (this._procField("aux_info_type", "uint", 32), this._procField("aux_info_type_parameter", "uint", 32));

        this._procField("entry_count", "uint", 32);

        this._procFieldArray("offset", this.entry_count, "uint", 1 === this.version ? 64 : 32);
      });
      a.g.addBoxProcessor("saiz", function () {
        this._procFullBox();

        this.flags & 1 && (this._procField("aux_info_type", "uint", 32), this._procField("aux_info_type_parameter", "uint", 32));

        this._procField("default_sample_info_size", "uint", 8);

        this._procField("sample_count", "uint", 32);

        0 === this.default_sample_info_size && this._procFieldArray("sample_info_size", this.sample_count, "uint", 8);
      });
      a.g.addBoxProcessor("senc", b);
      a.g.addBoxProcessor("uuid", function () {
        for (var c = !0, d = 0; 16 > d; d++) this.usertype[d] !== PA[d] && (c = !1);

        c && (this._parsing && (this.type = "sepiff"), b.call(this));
      });
    }

    p = NA.prototype;

    p.destroy = function () {};

    p.isSupported = function (a, b) {
      var c = a.startsWith("mss/");
      if (!this.g || !c) return !1;
      if (b) return fc(this.convertCodecs(b, a));
      b = this.convertCodecs("audio", a);
      a = this.convertCodecs("video", a);
      return fc(b) || fc(a);
    };

    p.convertCodecs = function (a, b) {
      return b.replace("mss/", "");
    };

    p.getOriginalMimeType = function () {
      return this.h;
    };

    p.transmux = function (a, b, c) {
      if (!c) return Promise.resolve(nc(a));
      if (!b.mssPrivateData) return Promise.reject(new P(2, 3, 3020));

      try {
        var d,
            e = this.g.parseBuffer(a),
            f = e.fetch("tfhd");
        f.track_ID = b.id + 1;
        var g = e.fetch("tfdt"),
            h = e.fetch("traf");
        null === g && (g = this.g.createFullBox("tfdt", h, f), g.version = 1, g.flags = 0, g.baseMediaDecodeTime = Math.floor(c.startTime * b.mssPrivateData.timescale));
        var k = e.fetch("trun"),
            l = e.fetch("tfxd");
        l && l._parent.boxes.splice(l._parent.boxes.indexOf(l), 1);
        var m = e.fetch("tfrf");
        m && m._parent.boxes.splice(m._parent.boxes.indexOf(m), 1);
        var n = e.fetch("sepiff");

        if (null !== n) {
          n.type = "senc";
          n.usertype = void 0;
          var r = e.fetch("saio");

          if (null === r) {
            r = this.g.createFullBox("saio", h);
            r.version = 0;
            r.flags = 0;
            r.entry_count = 1;
            r.offset = [0];
            var q = this.g.createFullBox("saiz", h);
            q.version = 0;
            q.flags = 0;
            q.sample_count = n.sample_count;
            q.default_sample_info_size = 0;
            q.sample_info_size = [];
            if (n.flags & 2) for (d = 0; d < n.sample_count; d += 1) q.sample_info_size[d] = 10 + 6 * n.entry[d].NumberOfEntries;else q.default_sample_info_size = 8;
          }
        }

        f.flags &= 16777214;
        f.flags |= 131072;
        k.flags |= 1;
        var u = e.fetch("moof");
        k.data_offset = u.getLength() + 8;
        var v = e.fetch("saio");
        null !== v && (v.offset[0] = QA(u, "traf") + QA(h, "senc") + 16);
        var y = nc(e.write());
        return Promise.resolve(y);
      } catch (z) {
        return z instanceof P ? Promise.reject(z) : Promise.reject(new P(2, 3, 3022));
      }
    };

    function QA(a, b) {
      for (var c = 8, d = 0; d < a.boxes.length && a.boxes[d].type !== b; d++) c += a.boxes[d].size;

      return c;
    }

    M("shaka.transmuxer.MssTransmuxer", NA);
    NA.prototype.transmux = NA.prototype.transmux;
    NA.prototype.getOriginalMimeType = NA.prototype.getOriginalMimeType;
    NA.prototype.convertCodecs = NA.prototype.convertCodecs;
    NA.prototype.isSupported = NA.prototype.isSupported;
    NA.prototype.destroy = NA.prototype.destroy;
    var PA = new Uint8Array([162, 57, 79, 82, 90, 155, 79, 20, 162, 68, 108, 66, 124, 100, 141, 244]);
    Yc("mss/audio/mp4", function () {
      return new NA("mss/audio/mp4");
    }, dd);
    Yc("mss/video/mp4", function () {
      return new NA("mss/video/mp4");
    }, dd);

    function RA(a) {
      this.j = a;
      this.g = 0;
      this.h = new Map();
      this.i = null;
    }

    p = RA.prototype;

    p.destroy = function () {
      this.h.clear();
    };

    p.isSupported = function (a, b) {
      if ("video/mp2t" != a.toLowerCase().split(";")[0]) return !1;
      var c = a;
      b && (c = this.convertCodecs(b, a));
      var d = pd(c).split(",");
      c = Kb("audio", d);
      d = Kb("video", d);
      if (c && (c = ld(c), !SA.includes(c)) || d && (c = ld(d), !TA.includes(c))) return !1;
      if (b) return fc(this.convertCodecs(b, a));
      b = this.convertCodecs("audio", a);
      a = this.convertCodecs("video", a);
      return fc(b) || fc(a);
    };

    p.convertCodecs = function (a, b) {
      return "video/mp2t" == b.toLowerCase().split(";")[0] ? (b = pd(b).replace("mp4a.40.34", "mp3").split(",").map(this.Sh).join(","), "audio" == a ? 'audio/mp4; codecs="' + b + '"' : 'video/mp4; codecs="' + b + '"') : b;
    };

    p.Sh = function (a) {
      if (a.includes("avc1")) {
        var b = a.split(".");
        if (3 == b.length) return a = b.shift() + ".", a += parseInt(b.shift(), 10).toString(16), a += ("000" + parseInt(b.shift(), 10).toString(16)).slice(-4);
      }

      return a;
    };

    p.getOriginalMimeType = function () {
      return this.j;
    };

    p.transmux = function (a, b, c, d, e) {
      this.i ? this.i.clearData() : this.i = new wi();
      a = nc(a);
      var f = this.i.parse(a);
      a = [];
      var g = f.pd();

      try {
        var h = null;

        if ("video" == e) {
          switch (g.video) {
            case "avc":
              var k = [],
                  l = null,
                  m = [],
                  n = f.Jc();
              if (!n.length) throw new P(2, 3, 3023);

              for (var r = 0; r < n.length; r++) {
                var q = n[r],
                    u = q.nalus;
                m.push.apply(m, w(u));
                var v = zA(u);

                if (v) {
                  null == l && (l = q.dts);
                  var y = void 0;
                  y = r + 1 < n.length ? (n[r + 1].dts || 0) - (q.dts || 0) : 1 < n.length ? (q.dts || 0) - (n[r - 1].dts || 0) : 9E4 * (c.endTime - c.startTime);
                  k.push({
                    data: v.data,
                    size: v.data.byteLength,
                    duration: y,
                    gb: Math.round((q.pts || 0) - (q.dts || 0)),
                    flags: {
                      ib: 0,
                      Za: 0,
                      Ya: 0,
                      Wa: 0,
                      Xa: v.yd ? 2 : 1,
                      jb: v.yd ? 0 : 1
                    }
                  });
                }
              }

              var z = xA(m);
              if (!z || null == l) throw new P(2, 3, 3018);
              b.height = z.height;
              b.width = z.width;
              h = {
                id: b.id,
                type: "video",
                codecs: "avc1",
                encrypted: b.encrypted && 0 < b.drmInfos.length,
                timescale: 9E4,
                duration: d,
                eb: [],
                oa: new Uint8Array([]),
                Ba: z.Ba,
                data: {
                  vb: this.g,
                  baseMediaDecodeTime: l,
                  ab: k
                },
                stream: b
              };
              break;

            case "hvc":
              n = [];
              q = null;
              u = [];
              k = f.Jc();
              if (!k.length) throw new P(2, 3, 3023);

              for (v = 0; v < k.length; v++) {
                l = k[v];
                m = l.nalus;
                u.push.apply(u, w(m));
                z = !1;
                var x = [],
                    B = !1;
                r = t(m);

                for (y = r.next(); !y.done; y = r.next()) {
                  var A = y.value;

                  switch (A.type) {
                    case 1:
                    case 0:
                      var C = B = !0;
                      break;

                    case 19:
                    case 20:
                    case 21:
                      z = C = B = !0;
                      break;

                    case 32:
                      C = !0;
                      break;

                    case 33:
                      C = !0;
                      break;

                    case 34:
                      C = !0;
                      break;

                    case 35:
                      B = C = !0;
                      break;

                    case 39:
                    case 40:
                      C = !0;
                      break;

                    default:
                      C = !1;
                  }

                  if (B && C) {
                    var E = A.fullData.byteLength,
                        H = new Uint8Array(4);
                    H[0] = E >> 24 & 255;
                    H[1] = E >> 16 & 255;
                    H[2] = E >> 8 & 255;
                    H[3] = E & 255;
                    x.push(tg(H, A.fullData));
                  }
                }

                var G = x.length ? {
                  data: tg.apply(ng, w(x)),
                  yd: z
                } : null;
                G && (null == q && null != l.dts && (q = l.dts), z = void 0, z = v + 1 < k.length ? (k[v + 1].dts || 0) - (l.dts || 0) : 1 < k.length ? (l.dts || 0) - (k[v - 1].dts || 0) : 9E4 * (c.endTime - c.startTime), n.push({
                  data: G.data,
                  size: G.data.byteLength,
                  duration: z,
                  gb: Math.round((l.pts || 0) - (l.dts || 0)),
                  flags: {
                    ib: 0,
                    Za: 0,
                    Ya: 0,
                    Wa: 0,
                    Xa: G.yd ? 2 : 1,
                    jb: G.yd ? 0 : 1
                  }
                }));
              }

              var I = AA(u);
              if (!I || null == q) throw new P(2, 3, 3018);
              b.height = I.height;
              b.width = I.width;
              h = {
                id: b.id,
                type: "video",
                codecs: "hvc1",
                encrypted: b.encrypted && 0 < b.drmInfos.length,
                timescale: 9E4,
                duration: d,
                eb: [],
                oa: new Uint8Array([]),
                Ba: I.Ba,
                data: {
                  vb: this.g,
                  baseMediaDecodeTime: q,
                  ab: n
                },
                stream: b
              };
          }

          h && (a.push(h), h = null);
        }

        if ("audio" == e) {
          switch (g.audio) {
            case "aac":
              for (var J = [], L, O = null, Q = t(f.kc()), V = Q.next(); !V.done; V = Q.next()) {
                var U = V.value,
                    oa = U.data;

                if (oa) {
                  var la = 0;
                  L = oA(oa, la);
                  if (!L) throw new P(2, 3, 3018);
                  b.audioSamplingRate = L.sampleRate;
                  b.channelsCount = L.channelCount;
                  null == O && null !== U.pts && (O = U.pts);

                  for (; la < oa.length;) {
                    var Qa = nA(oa, la);

                    if (Qa) {
                      var Xa = Qa.je + Qa.X;
                      la + Xa <= oa.length && J.push({
                        data: oa.subarray(la + Qa.je, la + Xa),
                        size: Qa.X,
                        duration: 1024,
                        gb: 0,
                        flags: {
                          ib: 0,
                          Za: 0,
                          Ya: 0,
                          Wa: 0,
                          Xa: 2,
                          jb: 0
                        }
                      });
                      la += Xa;
                    } else la++;
                  }
                }
              }

              if (!L || null == O) {
                if (!f.Jc().length) throw new P(2, 3, 3018);
                O = 9E4 * c.startTime;
                var qb = Kb("audio", b.codecs.split(","));
                if (!qb || !b.channelsCount || !b.audioSamplingRate) throw new P(2, 3, 3018);
                L = {
                  sampleRate: b.audioSamplingRate,
                  channelCount: b.channelsCount,
                  va: qb
                };
                var lb = qA(qb, b.channelsCount);
                if (!lb) throw new P(2, 3, 3018);
                var wb = O + 9E4 * (c.endTime - c.startTime);

                for (f = O; f < wb;) J.push({
                  data: lb,
                  size: lb.byteLength,
                  duration: 1024,
                  gb: 0,
                  flags: {
                    ib: 0,
                    Za: 0,
                    Ya: 0,
                    Wa: 0,
                    Xa: 2,
                    jb: 0
                  }
                }), f += 1024 / L.sampleRate * 9E4;
              }

              var Aa = L.sampleRate;
              f = O / 9E4 * Aa;
              h = {
                id: b.id,
                type: "audio",
                codecs: L.va,
                encrypted: b.encrypted && 0 < b.drmInfos.length,
                timescale: Aa,
                duration: d,
                eb: [],
                oa: new Uint8Array([]),
                Ba: new Uint8Array([]),
                data: {
                  vb: this.g,
                  baseMediaDecodeTime: f,
                  ab: J
                },
                stream: b
              };
              break;

            case "ac3":
              L = [];
              Aa = 0;
              J = new Uint8Array([]);
              O = null;
              la = t(f.kc());

              for (var ib = la.next(); !ib.done; ib = la.next()) {
                var rb = ib.value,
                    Eb = rb.data;
                null == O && null !== rb.pts && (O = rb.pts);

                for (f = 0; f < Eb.length;) {
                  var cb = sA(Eb, f);
                  cb ? (b.audioSamplingRate = cb.sampleRate, b.channelsCount = cb.channelCount, Aa = cb.sampleRate, J = cb.oa, L.push({
                    data: Eb.subarray(f, f + cb.X),
                    size: cb.X,
                    duration: 1536,
                    gb: 0,
                    flags: {
                      ib: 0,
                      Za: 0,
                      Ya: 0,
                      Wa: 0,
                      Xa: 2,
                      jb: 0
                    }
                  }), f += cb.X) : f++;
                }
              }

              if (0 == Aa || 0 == J.byteLength || null == O) throw new P(2, 3, 3018);
              f = O / 9E4 * Aa;
              h = {
                id: b.id,
                type: "audio",
                codecs: "ac-3",
                encrypted: b.encrypted && 0 < b.drmInfos.length,
                timescale: Aa,
                duration: d,
                eb: [],
                oa: J,
                Ba: new Uint8Array([]),
                data: {
                  vb: this.g,
                  baseMediaDecodeTime: f,
                  ab: L
                },
                stream: b
              };
              break;

            case "ec3":
              L = [];
              Aa = 0;
              O = new Uint8Array([]);
              J = null;

              for (var xb = t(f.kc()), Ud = xb.next(); !Ud.done; Ud = xb.next()) {
                var wd = Ud.value,
                    Vd = wd.data;
                null == J && null !== wd.pts && (J = wd.pts);

                for (f = 0; f < Vd.length;) {
                  var Dc = vA(Vd, f);
                  Dc ? (b.audioSamplingRate = Dc.sampleRate, b.channelsCount = Dc.channelCount, Aa = Dc.sampleRate, O = Dc.oa, L.push({
                    data: Vd.subarray(f, f + Dc.X),
                    size: Dc.X,
                    duration: 1536,
                    gb: 0,
                    flags: {
                      ib: 0,
                      Za: 0,
                      Ya: 0,
                      Wa: 0,
                      Xa: 2,
                      jb: 0
                    }
                  }), f += Dc.X) : f++;
                }
              }

              if (0 == Aa || 0 == O.byteLength || null == J) throw new P(2, 3, 3018);
              f = J / 9E4 * Aa;
              h = {
                id: b.id,
                type: "audio",
                codecs: "ec-3",
                encrypted: b.encrypted && 0 < b.drmInfos.length,
                timescale: Aa,
                duration: d,
                eb: [],
                oa: O,
                Ba: new Uint8Array([]),
                data: {
                  vb: this.g,
                  baseMediaDecodeTime: f,
                  ab: L
                },
                stream: b
              };
              break;

            case "mp3":
              L = [];
              var Wd;
              Aa = null;

              for (var hi = t(f.kc()), Ye = hi.next(); !Ye.done; Ye = hi.next()) {
                var Xd = Ye.value,
                    Lc = Xd.data;
                if (Lc) for (null == Aa && null !== Xd.pts && (Aa = Xd.pts), f = 0; f < Lc.length;) {
                  var jd = FA(Lc, f);
                  jd ? (Wd || (Wd = jd), f + jd.X <= Lc.length && L.push({
                    data: Lc.subarray(f, f + jd.X),
                    size: jd.X,
                    duration: 1152,
                    gb: 0,
                    flags: {
                      ib: 0,
                      Za: 0,
                      Ya: 0,
                      Wa: 0,
                      Xa: 2,
                      jb: 0
                    }
                  }), f += jd.X) : f++;
                }
              }

              if (!Wd || null == Aa) throw new P(2, 3, 3018);
              var kg = Wd.sampleRate;
              f = Aa / 9E4 * kg;
              h = {
                id: b.id,
                type: "audio",
                codecs: "mp3",
                encrypted: b.encrypted && 0 < b.drmInfos.length,
                timescale: kg,
                duration: d,
                eb: [],
                oa: new Uint8Array([]),
                Ba: new Uint8Array([]),
                data: {
                  vb: this.g,
                  baseMediaDecodeTime: f,
                  ab: L
                },
                stream: b
              };
          }

          h && a.push(h);
        }
      } catch (lg) {
        return lg && 3023 == lg.code ? Promise.resolve(new Uint8Array([])) : Promise.reject(lg);
      }

      if (!a.length) return Promise.reject(new P(2, 3, 3018));
      a = new Iu(a);
      this.h.has(b.id) ? d = this.h.get(b.id) : (d = Ou(a), this.h.set(b.id, d));
      b = dv(a);
      this.g++;
      b = tg(d, b);
      return Promise.resolve(b);
    };

    M("shaka.transmuxer.TsTransmuxer", RA);
    RA.prototype.transmux = RA.prototype.transmux;
    RA.prototype.getOriginalMimeType = RA.prototype.getOriginalMimeType;
    RA.prototype.convertCodecs = RA.prototype.convertCodecs;
    RA.prototype.isSupported = RA.prototype.isSupported;
    RA.prototype.destroy = RA.prototype.destroy;
    var SA = ["aac", "ac-3", "ec-3", "mp3"],
        TA = ["avc", "hevc"];
    Yc("video/mp2t", function () {
      return new RA("video/mp2t");
    }, bd);
    /*
    @license
    EME Encryption Scheme Polyfill
    Copyright 2019 Google LLC
    SPDX-License-Identifier: Apache-2.0
    */

    function UA() {}

    var VA;

    function WA() {
      VA ? console.debug("EmeEncryptionSchemePolyfill: Already installed.") : navigator.requestMediaKeySystemAccess && MediaKeySystemAccess.prototype.getConfiguration ? (VA = navigator.requestMediaKeySystemAccess, console.debug("EmeEncryptionSchemePolyfill: Waiting to detect encryptionScheme support."), navigator.requestMediaKeySystemAccess = XA) : console.debug("EmeEncryptionSchemePolyfill: EME not found");
    }

    function XA(a, b) {
      var c = this,
          d;
      return K(function (e) {
        if (1 == e.g) return console.assert(c == navigator, 'bad "this" for requestMediaKeySystemAccess'), D(e, VA.call(c, a, b), 2);
        d = e.h;
        if (YA(d)) return console.debug("EmeEncryptionSchemePolyfill: Native encryptionScheme support found."), navigator.requestMediaKeySystemAccess = VA, e.return(d);
        console.debug("EmeEncryptionSchemePolyfill: No native encryptionScheme support found. Patching encryptionScheme support.");
        navigator.requestMediaKeySystemAccess = ZA;
        return e.return(ZA.call(c, a, b));
      });
    }

    function ZA(a, b) {
      var c = this,
          d,
          e,
          f,
          g,
          h,
          k,
          l,
          m,
          n,
          r;
      return K(function (q) {
        if (1 == q.g) {
          console.assert(c == navigator, 'bad "this" for requestMediaKeySystemAccess');
          d = $A(a);
          e = [];
          f = t(b);

          for (g = f.next(); !g.done; g = f.next()) h = g.value, k = aB(h.videoCapabilities, d), l = aB(h.audioCapabilities, d), h.videoCapabilities && h.videoCapabilities.length && !k.length || h.audioCapabilities && h.audioCapabilities.length && !l.length || (m = Object.assign({}, h), m.videoCapabilities = k, m.audioCapabilities = l, e.push(m));

          if (!e.length) throw n = Error("Unsupported keySystem or supportedConfigurations."), n.name = "NotSupportedError", n.code = DOMException.NOT_SUPPORTED_ERR, n;
          return D(q, VA.call(c, a, e), 2);
        }

        r = q.h;
        return q.return(new bB(r, d));
      });
    }

    function aB(a, b) {
      return a ? a.filter(function (c) {
        return !c.encryptionScheme || c.encryptionScheme == b;
      }) : a;
    }

    M("EmeEncryptionSchemePolyfill", UA);
    UA.install = WA;

    function cB() {}

    var dB;

    function eB() {
      dB ? console.debug("McEncryptionSchemePolyfill: Already installed.") : navigator.mediaCapabilities ? (dB = navigator.mediaCapabilities.decodingInfo, console.debug("McEncryptionSchemePolyfill: Waiting to detect encryptionScheme support."), navigator.mediaCapabilities.decodingInfo = fB) : console.debug("McEncryptionSchemePolyfill: MediaCapabilities not found");
    }

    function fB(a) {
      var b = this,
          c,
          d,
          e;
      return K(function (f) {
        switch (f.g) {
          case 1:
            return console.assert(b == navigator.mediaCapabilities, 'bad "this" for decodingInfo'), D(f, dB.call(b, a), 2);

          case 2:
            c = f.h;
            if (!a.keySystemConfiguration) return f.return(c);
            if ((d = c.keySystemAccess) && YA(d)) return console.debug("McEncryptionSchemePolyfill: Native encryptionScheme support found."), navigator.mediaCapabilities.decodingInfo = dB, f.return(c);
            console.debug("McEncryptionSchemePolyfill: No native encryptionScheme support found. Patching encryptionScheme support.");
            navigator.mediaCapabilities.decodingInfo = gB;

            if (d) {
              f.F(3);
              break;
            }

            e = c;
            return D(f, hB(a), 4);

          case 4:
            return e.keySystemAccess = f.h, f.return(c);

          case 3:
            return f.return(gB.call(b, a));
        }
      });
    }

    function gB(a) {
      var b = this,
          c,
          d,
          e,
          f,
          g,
          h,
          k,
          l;
      return K(function (m) {
        switch (m.g) {
          case 1:
            return console.assert(b == navigator.mediaCapabilities, 'bad "this" for decodingInfo'), c = null, a.keySystemConfiguration && (d = a.keySystemConfiguration, e = d.keySystem, f = d.audio && d.audio.encryptionScheme, g = d.video && d.video.encryptionScheme, c = $A(e), h = {
              powerEfficient: !1,
              smooth: !1,
              supported: !1,
              keySystemAccess: null,
              configuration: a
            }, f && f != c || g && g != c) ? m.return(h) : D(m, dB.call(b, a), 2);

          case 2:
            k = m.h;

            if (k.keySystemAccess) {
              k.keySystemAccess = new bB(k.keySystemAccess, c);
              m.F(3);
              break;
            }

            if (!a.keySystemConfiguration) {
              m.F(3);
              break;
            }

            l = k;
            return D(m, hB(a), 5);

          case 5:
            l.keySystemAccess = m.h;

          case 3:
            return m.return(k);
        }
      });
    }

    function hB(a) {
      var b, c;
      return K(function (d) {
        if (1 == d.g) {
          var e = a.keySystemConfiguration,
              f = [],
              g = [];
          e.audio && f.push({
            robustness: e.audio.robustness || "",
            contentType: a.audio.contentType
          });
          e.video && g.push({
            robustness: e.video.robustness || "",
            contentType: a.video.contentType
          });
          e = {
            initDataTypes: e.initDataType ? [e.initDataType] : [],
            distinctiveIdentifier: e.distinctiveIdentifier,
            persistentState: e.persistentState,
            sessionTypes: e.sessionTypes
          };
          f.length && (e.audioCapabilities = f);
          g.length && (e.videoCapabilities = g);
          b = e;
          return D(d, navigator.requestMediaKeySystemAccess(a.keySystemConfiguration.keySystem, [b]), 2);
        }

        c = d.h;
        return d.return(c);
      });
    }

    M("McEncryptionSchemePolyfill", cB);
    cB.install = eB;

    function bB(a, b) {
      this.h = a;
      this.g = b;
      this.keySystem = a.keySystem;
    }

    bB.prototype.getConfiguration = function () {
      var a = this.h.getConfiguration();
      if (a.videoCapabilities) for (var b = t(a.videoCapabilities), c = b.next(); !c.done; c = b.next()) c.value.encryptionScheme = this.g;
      if (a.audioCapabilities) for (b = t(a.audioCapabilities), c = b.next(); !c.done; c = b.next()) c.value.encryptionScheme = this.g;
      return a;
    };

    bB.prototype.createMediaKeys = function () {
      return this.h.createMediaKeys();
    };

    function $A(a) {
      if (a.startsWith("com.widevine") || a.startsWith("com.microsoft") || a.startsWith("com.chromecast") || a.startsWith("com.adobe") || a.startsWith("org.w3")) return "cenc";
      if (a.startsWith("com.apple")) return "cbcs-1-9";
      console.warn("EmeEncryptionSchemePolyfill: Unknown key system:", a, "Please contribute!");
      return null;
    }

    function YA(a) {
      a = a.getConfiguration();
      var b = a.audioCapabilities && a.audioCapabilities[0];
      return (a = a.videoCapabilities && a.videoCapabilities[0] || b) && void 0 !== a.encryptionScheme ? !0 : !1;
    }

    function iB() {}

    function Ex() {
      WA();
      eB();
    }

    M("EncryptionSchemePolyfills", iB);
    iB.install = Ex;
    "undefined" !== typeof module && module.exports && (module.exports = iB);
    /*
    @license
    Copyright 2013 Ali Al Dallal
    Licensed under the MIT license.
    Permission is hereby granted, free of charge, to any person obtaining a copy
    of this software and associated documentation files (the "Software"), to deal
    in the Software without restriction, including without limitation the rights
    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the Software is
    furnished to do so, subject to the following conditions:
    The above copyright notice and this permission notice shall be included in
    all copies or substantial portions of the Software.
    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
    SOFTWARE.
    */

    for (var jB = {
      ach: {
        A: "Lwo",
        B: "Acholi"
      },
      ady: {
        A: "\u0410\u0434\u044b\u0433\u044d\u0431\u0437\u044d",
        B: "Adyghe"
      },
      af: {
        A: "Afrikaans",
        B: "Afrikaans"
      },
      "af-NA": {
        A: "Afrikaans (Namibia)",
        B: "Afrikaans (Namibia)"
      },
      "af-ZA": {
        A: "Afrikaans (South Africa)",
        B: "Afrikaans (South Africa)"
      },
      ak: {
        A: "T\u0255\u0265i",
        B: "Akan"
      },
      ar: {
        A: "\u0627\u0644\u0639\u0631\u0628\u064a\u0629",
        B: "Arabic"
      },
      "ar-AR": {
        A: "\u0627\u0644\u0639\u0631\u0628\u064a\u0629",
        B: "Arabic"
      },
      "ar-MA": {
        A: "\u0627\u0644\u0639\u0631\u0628\u064a\u0629",
        B: "Arabic (Morocco)"
      },
      "ar-SA": {
        A: "\u0627\u0644\u0639\u0631\u0628\u064a\u0629 (\u0627\u0644\u0633\u0639\u0648\u062f\u064a\u0629)",
        B: "Arabic (Saudi Arabia)"
      },
      "ay-BO": {
        A: "Aymar aru",
        B: "Aymara"
      },
      az: {
        A: "Az\u0259rbaycan dili",
        B: "Azerbaijani"
      },
      "az-AZ": {
        A: "Az\u0259rbaycan dili",
        B: "Azerbaijani"
      },
      "be-BY": {
        A: "\u0411\u0435\u043b\u0430\u0440\u0443\u0441\u043a\u0430\u044f",
        B: "Belarusian"
      },
      bg: {
        A: "\u0411\u044a\u043b\u0433\u0430\u0440\u0441\u043a\u0438",
        B: "Bulgarian"
      },
      "bg-BG": {
        A: "\u0411\u044a\u043b\u0433\u0430\u0440\u0441\u043a\u0438",
        B: "Bulgarian"
      },
      bn: {
        A: "\u09ac\u09be\u0982\u09b2\u09be",
        B: "Bengali"
      },
      "bn-IN": {
        A: "\u09ac\u09be\u0982\u09b2\u09be (\u09ad\u09be\u09b0\u09a4)",
        B: "Bengali (India)"
      },
      "bn-BD": {
        A: "\u09ac\u09be\u0982\u09b2\u09be(\u09ac\u09be\u0982\u09b2\u09be\u09a6\u09c7\u09b6)",
        B: "Bengali (Bangladesh)"
      },
      "bs-BA": {
        A: "Bosanski",
        B: "Bosnian"
      },
      ca: {
        A: "Catal\u00e0",
        B: "Catalan"
      },
      "ca-ES": {
        A: "Catal\u00e0",
        B: "Catalan"
      },
      cak: {
        A: "Maya Kaqchikel",
        B: "Kaqchikel"
      },
      "ck-US": {
        A: "\u13e3\u13b3\u13a9 (tsalagi)",
        B: "Cherokee"
      },
      cs: {
        A: "\u010ce\u0161tina",
        B: "Czech"
      },
      "cs-CZ": {
        A: "\u010ce\u0161tina",
        B: "Czech"
      },
      cy: {
        A: "Cymraeg",
        B: "Welsh"
      },
      "cy-GB": {
        A: "Cymraeg",
        B: "Welsh"
      },
      da: {
        A: "Dansk",
        B: "Danish"
      },
      "da-DK": {
        A: "Dansk",
        B: "Danish"
      },
      de: {
        A: "Deutsch",
        B: "German"
      },
      "de-AT": {
        A: "Deutsch (\u00d6sterreich)",
        B: "German (Austria)"
      },
      "de-DE": {
        A: "Deutsch (Deutschland)",
        B: "German (Germany)"
      },
      "de-CH": {
        A: "Deutsch (Schweiz)",
        B: "German (Switzerland)"
      },
      dsb: {
        A: "Dolnoserb\u0161\u0107ina",
        B: "Lower Sorbian"
      },
      el: {
        A: "\u0395\u03bb\u03bb\u03b7\u03bd\u03b9\u03ba\u03ac",
        B: "Greek"
      },
      "el-GR": {
        A: "\u0395\u03bb\u03bb\u03b7\u03bd\u03b9\u03ba\u03ac",
        B: "Greek (Greece)"
      },
      en: {
        A: "English",
        B: "English"
      },
      "en-GB": {
        A: "English (UK)",
        B: "English (UK)"
      },
      "en-AU": {
        A: "English (Australia)",
        B: "English (Australia)"
      },
      "en-CA": {
        A: "English (Canada)",
        B: "English (Canada)"
      },
      "en-IE": {
        A: "English (Ireland)",
        B: "English (Ireland)"
      },
      "en-IN": {
        A: "English (India)",
        B: "English (India)"
      },
      "en-PI": {
        A: "English (Pirate)",
        B: "English (Pirate)"
      },
      "en-UD": {
        A: "English (Upside Down)",
        B: "English (Upside Down)"
      },
      "en-US": {
        A: "English (US)",
        B: "English (US)"
      },
      "en-ZA": {
        A: "English (South Africa)",
        B: "English (South Africa)"
      },
      "en@pirate": {
        A: "English (Pirate)",
        B: "English (Pirate)"
      },
      eo: {
        A: "Esperanto",
        B: "Esperanto"
      },
      "eo-EO": {
        A: "Esperanto",
        B: "Esperanto"
      },
      es: {
        A: "Espa\u00f1ol",
        B: "Spanish"
      },
      "es-AR": {
        A: "Espa\u00f1ol (Argentine)",
        B: "Spanish (Argentina)"
      },
      "es-419": {
        A: "Espa\u00f1ol (Latinoam\u00e9rica)",
        B: "Spanish (Latin America)"
      },
      "es-CL": {
        A: "Espa\u00f1ol (Chile)",
        B: "Spanish (Chile)"
      },
      "es-CO": {
        A: "Espa\u00f1ol (Colombia)",
        B: "Spanish (Colombia)"
      },
      "es-EC": {
        A: "Espa\u00f1ol (Ecuador)",
        B: "Spanish (Ecuador)"
      },
      "es-ES": {
        A: "Espa\u00f1ol (Espa\u00f1a)",
        B: "Spanish (Spain)"
      },
      "es-LA": {
        A: "Espa\u00f1ol (Latinoam\u00e9rica)",
        B: "Spanish (Latin America)"
      },
      "es-NI": {
        A: "Espa\u00f1ol (Nicaragua)",
        B: "Spanish (Nicaragua)"
      },
      "es-MX": {
        A: "Espa\u00f1ol (M\u00e9xico)",
        B: "Spanish (Mexico)"
      },
      "es-US": {
        A: "Espa\u00f1ol (Estados Unidos)",
        B: "Spanish (United States)"
      },
      "es-VE": {
        A: "Espa\u00f1ol (Venezuela)",
        B: "Spanish (Venezuela)"
      },
      et: {
        A: "eesti keel",
        B: "Estonian"
      },
      "et-EE": {
        A: "Eesti (Estonia)",
        B: "Estonian (Estonia)"
      },
      eu: {
        A: "Euskara",
        B: "Basque"
      },
      "eu-ES": {
        A: "Euskara",
        B: "Basque"
      },
      fa: {
        A: "\u0641\u0627\u0631\u0633\u06cc",
        B: "Persian"
      },
      "fa-IR": {
        A: "\u0641\u0627\u0631\u0633\u06cc",
        B: "Persian"
      },
      "fb-LT": {
        A: "Leet Speak",
        B: "Leet"
      },
      ff: {
        A: "Fulah",
        B: "Fulah"
      },
      fi: {
        A: "Suomi",
        B: "Finnish"
      },
      "fi-FI": {
        A: "Suomi",
        B: "Finnish"
      },
      "fo-FO": {
        A: "F\u00f8royskt",
        B: "Faroese"
      },
      fr: {
        A: "Fran\u00e7ais",
        B: "French"
      },
      "fr-CA": {
        A: "Fran\u00e7ais (Canada)",
        B: "French (Canada)"
      },
      "fr-FR": {
        A: "Fran\u00e7ais (France)",
        B: "French (France)"
      },
      "fr-BE": {
        A: "Fran\u00e7ais (Belgique)",
        B: "French (Belgium)"
      },
      "fr-CH": {
        A: "Fran\u00e7ais (Suisse)",
        B: "French (Switzerland)"
      },
      "fy-NL": {
        A: "Frysk",
        B: "Frisian (West)"
      },
      ga: {
        A: "Gaeilge",
        B: "Irish"
      },
      "ga-IE": {
        A: "Gaeilge (Gaelic)",
        B: "Irish (Gaelic)"
      },
      gl: {
        A: "Galego",
        B: "Galician"
      },
      "gl-ES": {
        A: "Galego",
        B: "Galician"
      },
      "gn-PY": {
        A: "Ava\u00f1e'\u1ebd",
        B: "Guarani"
      },
      "gu-IN": {
        A: "\u0a97\u0ac1\u0a9c\u0ab0\u0abe\u0aa4\u0ac0",
        B: "Gujarati"
      },
      "gx-GR": {
        A: "\u1f19\u03bb\u03bb\u03b7\u03bd\u03b9\u03ba\u03ae \u1f00\u03c1\u03c7\u03b1\u03af\u03b1",
        B: "Classical Greek"
      },
      he: {
        A: "\u05e2\u05d1\u05e8\u05d9\u05ea\u200f",
        B: "Hebrew"
      },
      "he-IL": {
        A: "\u05e2\u05d1\u05e8\u05d9\u05ea\u200f",
        B: "Hebrew"
      },
      hi: {
        A: "\u0939\u093f\u0928\u094d\u0926\u0940",
        B: "Hindi"
      },
      "hi-IN": {
        A: "\u0939\u093f\u0928\u094d\u0926\u0940",
        B: "Hindi"
      },
      hr: {
        A: "Hrvatski",
        B: "Croatian"
      },
      "hr-HR": {
        A: "Hrvatski",
        B: "Croatian"
      },
      hsb: {
        A: "Hornjoserb\u0161\u0107ina",
        B: "Upper Sorbian"
      },
      ht: {
        A: "Krey\u00f2l",
        B: "Haitian Creole"
      },
      hu: {
        A: "Magyar",
        B: "Hungarian"
      },
      "hu-HU": {
        A: "Magyar",
        B: "Hungarian"
      },
      "hy-AM": {
        A: "\u0540\u0561\u0575\u0565\u0580\u0565\u0576",
        B: "Armenian"
      },
      id: {
        A: "Bahasa Indonesia",
        B: "Indonesian"
      },
      "id-ID": {
        A: "Bahasa Indonesia",
        B: "Indonesian"
      },
      is: {
        A: "\u00cdslenska",
        B: "Icelandic"
      },
      "is-IS": {
        A: "\u00cdslenska (Iceland)",
        B: "Icelandic (Iceland)"
      },
      it: {
        A: "Italiano",
        B: "Italian"
      },
      "it-IT": {
        A: "Italiano",
        B: "Italian"
      },
      ja: {
        A: "\u65e5\u672c\u8a9e",
        B: "Japanese"
      },
      "ja-JP": {
        A: "\u65e5\u672c\u8a9e",
        B: "Japanese"
      },
      "jv-ID": {
        A: "Basa Jawa",
        B: "Javanese"
      },
      "ka-GE": {
        A: "\u10e5\u10d0\u10e0\u10d7\u10e3\u10da\u10d8",
        B: "Georgian"
      },
      "kk-KZ": {
        A: "\u049a\u0430\u0437\u0430\u049b\u0448\u0430",
        B: "Kazakh"
      },
      km: {
        A: "\u1797\u17b6\u179f\u17b6\u1781\u17d2\u1798\u17c2\u179a",
        B: "Khmer"
      },
      "km-KH": {
        A: "\u1797\u17b6\u179f\u17b6\u1781\u17d2\u1798\u17c2\u179a",
        B: "Khmer"
      },
      kab: {
        A: "Taqbaylit",
        B: "Kabyle"
      },
      kn: {
        A: "\u0c95\u0ca8\u0ccd\u0ca8\u0ca1",
        B: "Kannada"
      },
      "kn-IN": {
        A: "\u0c95\u0ca8\u0ccd\u0ca8\u0ca1 (India)",
        B: "Kannada (India)"
      },
      ko: {
        A: "\ud55c\uad6d\uc5b4",
        B: "Korean"
      },
      "ko-KR": {
        A: "\ud55c\uad6d\uc5b4 (\u97e9\u56fd)",
        B: "Korean (Korea)"
      },
      ku: {
        A: "Kurd\u00ee",
        B: "Kurdish"
      },
      "ku-TR": {
        A: "Kurd\u00ee",
        B: "Kurdish"
      },
      la: {
        A: "Latin",
        B: "Latin"
      },
      "la-VA": {
        A: "Latin",
        B: "Latin"
      },
      lb: {
        A: "L\u00ebtzebuergesch",
        B: "Luxembourgish"
      },
      "li-NL": {
        A: "L\u00e8mb\u00f6rgs",
        B: "Limburgish"
      },
      lt: {
        A: "Lietuvi\u0173",
        B: "Lithuanian"
      },
      "lt-LT": {
        A: "Lietuvi\u0173",
        B: "Lithuanian"
      },
      lv: {
        A: "Latvie\u0161u",
        B: "Latvian"
      },
      "lv-LV": {
        A: "Latvie\u0161u",
        B: "Latvian"
      },
      mai: {
        A: "\u092e\u0948\u0925\u093f\u0932\u0940, \u09ae\u09c8\u09a5\u09bf\u09b2\u09c0",
        B: "Maithili"
      },
      "mg-MG": {
        A: "Malagasy",
        B: "Malagasy"
      },
      mk: {
        A: "\u041c\u0430\u043a\u0435\u0434\u043e\u043d\u0441\u043a\u0438",
        B: "Macedonian"
      },
      "mk-MK": {
        A: "\u041c\u0430\u043a\u0435\u0434\u043e\u043d\u0441\u043a\u0438 (\u041c\u0430\u043a\u0435\u0434\u043e\u043d\u0441\u043a\u0438)",
        B: "Macedonian (Macedonian)"
      },
      ml: {
        A: "\u0d2e\u0d32\u0d2f\u0d3e\u0d33\u0d02",
        B: "Malayalam"
      },
      "ml-IN": {
        A: "\u0d2e\u0d32\u0d2f\u0d3e\u0d33\u0d02",
        B: "Malayalam"
      },
      "mn-MN": {
        A: "\u041c\u043e\u043d\u0433\u043e\u043b",
        B: "Mongolian"
      },
      mr: {
        A: "\u092e\u0930\u093e\u0920\u0940",
        B: "Marathi"
      },
      "mr-IN": {
        A: "\u092e\u0930\u093e\u0920\u0940",
        B: "Marathi"
      },
      ms: {
        A: "Bahasa Melayu",
        B: "Malay"
      },
      "ms-MY": {
        A: "Bahasa Melayu",
        B: "Malay"
      },
      mt: {
        A: "Malti",
        B: "Maltese"
      },
      "mt-MT": {
        A: "Malti",
        B: "Maltese"
      },
      my: {
        A: "\u1017\u1019\u102c\u1005\u1000\u102c",
        B: "Burmese"
      },
      nb: {
        A: "Norsk (bokm\u00e5l)",
        B: "Norwegian (bokmal)"
      },
      "nb-NO": {
        A: "Norsk (bokm\u00e5l)",
        B: "Norwegian (bokmal)"
      },
      ne: {
        A: "\u0928\u0947\u092a\u093e\u0932\u0940",
        B: "Nepali"
      },
      "ne-NP": {
        A: "\u0928\u0947\u092a\u093e\u0932\u0940",
        B: "Nepali"
      },
      nl: {
        A: "Nederlands",
        B: "Dutch"
      },
      "nl-BE": {
        A: "Nederlands (Belgi\u00eb)",
        B: "Dutch (Belgium)"
      },
      "nl-NL": {
        A: "Nederlands (Nederland)",
        B: "Dutch (Netherlands)"
      },
      "nn-NO": {
        A: "Norsk (nynorsk)",
        B: "Norwegian (nynorsk)"
      },
      no: {
        A: "Norsk",
        B: "Norwegian"
      },
      oc: {
        A: "Occitan",
        B: "Occitan"
      },
      "or-IN": {
        A: "\u0b13\u0b21\u0b3c\u0b3f\u0b06",
        B: "Oriya"
      },
      pa: {
        A: "\u0a2a\u0a70\u0a1c\u0a3e\u0a2c\u0a40",
        B: "Punjabi"
      },
      "pa-IN": {
        A: "\u0a2a\u0a70\u0a1c\u0a3e\u0a2c\u0a40 (\u0a2d\u0a3e\u0a30\u0a24 \u0a28\u0a42\u0a70)",
        B: "Punjabi (India)"
      },
      pl: {
        A: "Polski",
        B: "Polish"
      },
      "pl-PL": {
        A: "Polski",
        B: "Polish"
      },
      "ps-AF": {
        A: "\u067e\u069a\u062a\u0648",
        B: "Pashto"
      },
      pt: {
        A: "Portugu\u00eas",
        B: "Portuguese"
      },
      "pt-BR": {
        A: "Portugu\u00eas (Brasil)",
        B: "Portuguese (Brazil)"
      },
      "pt-PT": {
        A: "Portugu\u00eas (Portugal)",
        B: "Portuguese (Portugal)"
      },
      "qu-PE": {
        A: "Qhichwa",
        B: "Quechua"
      },
      "rm-CH": {
        A: "Rumantsch",
        B: "Romansh"
      },
      ro: {
        A: "Rom\u00e2n\u0103",
        B: "Romanian"
      },
      "ro-RO": {
        A: "Rom\u00e2n\u0103",
        B: "Romanian"
      },
      ru: {
        A: "\u0420\u0443\u0441\u0441\u043a\u0438\u0439",
        B: "Russian"
      },
      "ru-RU": {
        A: "\u0420\u0443\u0441\u0441\u043a\u0438\u0439",
        B: "Russian"
      },
      "sa-IN": {
        A: "\u0938\u0902\u0938\u094d\u0915\u0943\u0924\u092e\u094d",
        B: "Sanskrit"
      },
      "se-NO": {
        A: "Davvis\u00e1megiella",
        B: "Northern S\u00e1mi"
      },
      "si-LK": {
        A: "\u0db4\u0dc5\u0dcf\u0dad",
        B: "Sinhala (Sri Lanka)"
      },
      sk: {
        A: "Sloven\u010dina",
        B: "Slovak"
      },
      "sk-SK": {
        A: "Sloven\u010dina (Slovakia)",
        B: "Slovak (Slovakia)"
      },
      sl: {
        A: "Sloven\u0161\u010dina",
        B: "Slovenian"
      },
      "sl-SI": {
        A: "Sloven\u0161\u010dina",
        B: "Slovenian"
      },
      "so-SO": {
        A: "Soomaaliga",
        B: "Somali"
      },
      sq: {
        A: "Shqip",
        B: "Albanian"
      },
      "sq-AL": {
        A: "Shqip",
        B: "Albanian"
      },
      sr: {
        A: "\u0421\u0440\u043f\u0441\u043a\u0438",
        B: "Serbian"
      },
      "sr-RS": {
        A: "\u0421\u0440\u043f\u0441\u043a\u0438 (Serbia)",
        B: "Serbian (Serbia)"
      },
      su: {
        A: "Basa Sunda",
        B: "Sundanese"
      },
      sv: {
        A: "Svenska",
        B: "Swedish"
      },
      "sv-SE": {
        A: "Svenska",
        B: "Swedish"
      },
      sw: {
        A: "Kiswahili",
        B: "Swahili"
      },
      "sw-KE": {
        A: "Kiswahili",
        B: "Swahili (Kenya)"
      },
      ta: {
        A: "\u0ba4\u0bae\u0bbf\u0bb4\u0bcd",
        B: "Tamil"
      },
      "ta-IN": {
        A: "\u0ba4\u0bae\u0bbf\u0bb4\u0bcd",
        B: "Tamil"
      },
      te: {
        A: "\u0c24\u0c46\u0c32\u0c41\u0c17\u0c41",
        B: "Telugu"
      },
      "te-IN": {
        A: "\u0c24\u0c46\u0c32\u0c41\u0c17\u0c41",
        B: "Telugu"
      },
      tg: {
        A: "\u0437\u0430\u0431\u043e\u0301\u043d\u0438 \u0442\u043e\u04b7\u0438\u043a\u04e3\u0301",
        B: "Tajik"
      },
      "tg-TJ": {
        A: "\u0442\u043e\u04b7\u0438\u043a\u04e3",
        B: "Tajik"
      },
      th: {
        A: "\u0e20\u0e32\u0e29\u0e32\u0e44\u0e17\u0e22",
        B: "Thai"
      },
      "th-TH": {
        A: "\u0e20\u0e32\u0e29\u0e32\u0e44\u0e17\u0e22 (\u0e1b\u0e23\u0e30\u0e40\u0e17\u0e28\u0e44\u0e17\u0e22)",
        B: "Thai (Thailand)"
      },
      tl: {
        A: "Filipino",
        B: "Filipino"
      },
      "tl-PH": {
        A: "Filipino",
        B: "Filipino"
      },
      tlh: {
        A: "tlhIngan-Hol",
        B: "Klingon"
      },
      tr: {
        A: "T\u00fcrk\u00e7e",
        B: "Turkish"
      },
      "tr-TR": {
        A: "T\u00fcrk\u00e7e",
        B: "Turkish"
      },
      "tt-RU": {
        A: "\u0442\u0430\u0442\u0430\u0440\u0447\u0430",
        B: "Tatar"
      },
      uk: {
        A: "\u0423\u043a\u0440\u0430\u0457\u043d\u0441\u044c\u043a\u0430",
        B: "Ukrainian"
      },
      "uk-UA": {
        A: "\u0423\u043a\u0440\u0430\u0457\u043d\u0441\u044c\u043a\u0430",
        B: "Ukrainian"
      },
      ur: {
        A: "\u0627\u0631\u062f\u0648",
        B: "Urdu"
      },
      "ur-PK": {
        A: "\u0627\u0631\u062f\u0648",
        B: "Urdu"
      },
      uz: {
        A: "O'zbek",
        B: "Uzbek"
      },
      "uz-UZ": {
        A: "O'zbek",
        B: "Uzbek"
      },
      vi: {
        A: "Ti\u1ebfng Vi\u1ec7t",
        B: "Vietnamese"
      },
      "vi-VN": {
        A: "Ti\u1ebfng Vi\u1ec7t",
        B: "Vietnamese"
      },
      "xh-ZA": {
        A: "isiXhosa",
        B: "Xhosa"
      },
      yi: {
        A: "\u05d9\u05d9\u05b4\u05d3\u05d9\u05e9",
        B: "Yiddish"
      },
      "yi-DE": {
        A: "\u05d9\u05d9\u05b4\u05d3\u05d9\u05e9 (German)",
        B: "Yiddish (German)"
      },
      zh: {
        A: "\u4e2d\u6587",
        B: "Chinese"
      },
      "zh-HANS": {
        A: "\u4e2d\u6587\u7b80\u4f53",
        B: "Chinese Simplified"
      },
      "zh-HANT": {
        A: "\u4e2d\u6587\u7e41\u9ad4",
        B: "Chinese Traditional"
      },
      "zh-CN": {
        A: "\u4e2d\u6587\uff08\u4e2d\u56fd\uff09",
        B: "Chinese Simplified (China)"
      },
      "zh-HK": {
        A: "\u4e2d\u6587\uff08\u9999\u6e2f\uff09",
        B: "Chinese Traditional (Hong Kong)"
      },
      "zh-SG": {
        A: "\u4e2d\u6587\uff08\u65b0\u52a0\u5761\uff09",
        B: "Chinese Simplified (Singapore)"
      },
      "zh-TW": {
        A: "\u4e2d\u6587\uff08\u53f0\u7063\uff09",
        B: "Chinese Traditional (Taiwan)"
      },
      "zu-ZA": {
        A: "isiZulu",
        B: "Zulu"
      }
    }, kB = t(Object.keys(jB)), lB = kB.next(); !lB.done; lB = kB.next()) {
      var mB = lB.value;
      jB[mB.toLowerCase()] = jB[mB];
    }

    ;

    function nB(a, b) {
      var c = this;
      this.parent = a;
      this.controls = b;
      this.eventManager = new Jf();
      this.localization = this.controls.Aa;
      this.player = this.controls.Hc();
      this.video = this.controls.Yb();
      this.adManager = this.player.ae();
      this.ad = b.getAd();
      this.eventManager.o(this.adManager, "ad-started", function (d) {
        c.ad = d.ad;
      });
      this.eventManager.o(this.adManager, "ad-stopped", function () {
        c.ad = null;
      });
    }

    nB.prototype.release = function () {
      this.eventManager.release();
      this.ad = this.adManager = this.video = this.player = this.localization = this.eventManager = this.controls = this.parent = null;
    };

    M("shaka.ui.Element", nB);
    nB.prototype.release = nB.prototype.release;

    function oB(a) {
      return pB(a, "shaka-back-to-overflow-button");
    }

    function pB(a, b) {
      a = a.getElementsByClassName(b);
      return a.length ? a[0] : null;
    }

    function qB(a) {
      a && (a = pB(a, "shaka-chosen-item")) && a.parentElement.focus();
    }

    function rB() {
      var a = T("i");
      a.classList.add("material-icons-round");
      a.classList.add("shaka-chosen-item");
      a.textContent = "done";
      a.ariaHidden = "true";
      return a;
    }

    function sB(a, b) {
      a && (b ? a.classList.remove("shaka-hidden") : a.classList.add("shaka-hidden"));
    }

    function tB(a, b) {
      var c = Math.floor(a / 3600),
          d = Math.floor(a / 60 % 60);
      a = Math.floor(a % 60);
      10 > a && (a = "0" + a);
      a = d + ":" + a;
      b && (10 > d && (a = "0" + a), a = c + ":" + a);
      return a;
    }

    ;

    function uB(a, b) {
      nB.call(this, a, b);
      var c = this;
      this.i = T("div");
      this.i.classList.add("shaka-ad-counter");
      this.parent.appendChild(this.i);
      this.h = T("span");
      this.h.classList.add("shaka-ad-counter-span");
      this.i.appendChild(this.h);
      this.g = new Fd(function () {
        var d = Math.round(c.ad.getRemainingTime()),
            e = c.ad.getDuration();
        -1 != d && -1 != e && (0 < d ? (d = tB(e - d, !1) + " / " + tB(e, !1), 1 < c.ad.getSequenceLength() ? c.h.textContent = d : (e = c.localization.resolve("AD_TIME"), c.h.textContent = e.replace("[AD_TIME]", d))) : (c.g.stop(), c.h.textContent = ""));
      });
      this.eventManager.o(this.localization, "locale-updated", function () {});
      this.eventManager.o(this.localization, "locale-changed", function () {});
      this.eventManager.o(this.adManager, "ad-started", function () {
        c.g.Ma();
        c.g.ya(.5);
      });
      this.eventManager.o(this.adManager, "ad-stopped", function () {
        c.g.stop();
        c.h.textContent = "";
      });
      this.ad && (this.g.Ma(), this.g.ya(.5));
    }

    pa(uB, nB);

    uB.prototype.release = function () {
      this.g.stop();
      this.g = null;
      nB.prototype.release.call(this);
    };

    M("shaka.ui.AdCounter", uB);

    function vB(a, b) {
      nB.call(this, a, b);
      var c = this;
      this.g = T("div");
      this.g.classList.add("shaka-ad-position");
      sB(this.g, !1);
      this.parent.appendChild(this.g);
      this.h = T("span");
      this.h.classList.add("shaka-ad-position-span");
      this.g.appendChild(this.h);
      this.eventManager.o(this.localization, "locale-updated", function () {
        c.ad && wB(c);
      });
      this.eventManager.o(this.localization, "locale-changed", function () {
        c.ad && wB(c);
      });
      this.eventManager.o(this.adManager, "ad-started", function () {
        wB(c);
      });
      this.eventManager.o(this.adManager, "ad-stopped", function () {
        c.h.textContent = "";
        sB(c.g, !1);
      });
      this.ad && wB(this);
    }

    pa(vB, nB);

    function wB(a) {
      var b = a.ad.getSequenceLength();

      if (1 < b) {
        var c = a.ad.getPositionInSequence();
        a.h.textContent = a.localization.resolve("AD_PROGRESS").replace("[AD_ON]", String(c)).replace("[NUM_ADS]", String(b));
        sB(a.g, !0);
      }
    }

    M("shaka.ui.AdPosition", vB);

    function xB(a, b) {
      nB.call(this, a, b);
      var c = this;
      this.button = el();
      this.parent.appendChild(this.button);
      this.eventManager.o(this.localization, "locale-updated", function () {
        c.g();
      });
      this.eventManager.o(this.localization, "locale-changed", function () {
        c.g();
      });
      this.eventManager.o(this.video, "play", function () {
        c.g();
        c.h();
      });
      this.eventManager.o(this.video, "pause", function () {
        c.g();
        c.h();
      });
      this.eventManager.o(this.video, "seeking", function () {
        c.g();
        c.h();
      });
      this.eventManager.o(this.adManager, "ad-paused", function () {
        c.g();
        c.h();
      });
      this.eventManager.o(this.adManager, "ad-resumed", function () {
        c.g();
        c.h();
      });
      this.eventManager.o(this.adManager, "ad-started", function () {
        c.g();
        c.h();
      });
      this.eventManager.o(this.button, "click", function () {
        c.ad && c.ad.isLinear() ? yB(c.controls) : zB(c.controls);
      });
      this.ad && (this.g(), this.h());
    }

    pa(xB, nB);

    xB.prototype.isPaused = function () {
      if (this.ad && this.ad.isLinear()) var a = this.ad.isPaused();else a = this.controls, a = a.u.paused && !a.V;
      return a;
    };

    xB.prototype.g = function () {};

    xB.prototype.h = function () {};

    M("shaka.ui.PlayButton", xB);

    function AB(a, b) {
      xB.call(this, a, b);
      this.button.classList.add("shaka-play-button");
      this.button.classList.add("shaka-no-propagation");
      this.h();
      this.g();
    }

    pa(AB, xB);

    AB.prototype.h = function () {
      this.isPaused() ? this.button.setAttribute("icon", "play") : this.button.setAttribute("icon", "pause");
    };

    AB.prototype.g = function () {
      var a = this.isPaused() ? "PLAY" : "PAUSE";
      this.button.ariaLabel = this.localization.resolve(a);
    };

    M("shaka.ui.BigPlayButton", AB);

    function BB(a, b) {
      nB.call(this, a, b);
      var c = this;
      this.j = this.controls.g;
      this.h = this.controls.h;
      this.i = [];
      this.g = T("div");
      this.g.classList.add("shaka-no-propagation");
      this.g.classList.add("shaka-context-menu");
      this.g.classList.add("shaka-hidden");
      this.h.appendChild(this.g);
      this.eventManager.o(this.h, "contextmenu", function (d) {
        if (c.g.classList.contains("shaka-hidden")) {
          d.preventDefault();
          var e = c.h.getBoundingClientRect();
          c.g.style.left = d.clientX - e.left + "px";
          c.g.style.top = d.clientY - e.top + "px";
          sB(c.g, !0);
        } else sB(c.g, !1);
      });
      this.eventManager.o(window, "click", function () {
        sB(c.g, !1);
      });
      CB(this);
    }

    pa(BB, nB);

    BB.prototype.release = function () {
      this.h = null;

      for (var a = t(this.i), b = a.next(); !b.done; b = a.next()) b.value.release();

      this.i = [];
      nB.prototype.release.call(this);
    };

    function DB(a, b) {
      EB.set(a, b);
    }

    function CB(a) {
      for (var b = t(a.j.contextMenuElements), c = b.next(); !c.done; c = b.next()) {
        c = c.value;
        var d = EB.get(c);
        d ? a.i.push(d.create(a.g, a.controls)) : Ua("Unrecognized context menu element:", c);
      }
    }

    M("shaka.ui.ContextMenu", BB);
    BB.registerElement = DB;
    var EB = new Map();

    function FB(a, b) {
      nB.call(this, a, b);
      var c = this;
      this.m = null;
      this.s = !1;
      this.j = new Fd(function () {
        0 != parseInt(c.h.textContent, 10) && (c.video.currentTime = c.controls.Af() + parseInt(c.h.textContent, 10));
        c.g.style.opacity = "0";
        c.s = !1;
        c.h.textContent = "0s";
      });
      this.g = T("div");
      this.parent.appendChild(this.g);
      this.eventManager.o(this.g, "touchstart", function (d) {
        c.controls.ld() ? (d.preventDefault(), c.controls.pc()) : 0 < c.controls.g.tapSeekDistance && ((d.preventDefault(), d = c.controls.g.tapSeekDistance, c.s) ? c.m + 1E3 > Date.now() && (c.j.stop(), c.m = Date.now(), c.h.textContent = (c.l ? parseInt(c.h.textContent, 10) - d : parseInt(c.h.textContent, 10) + d).toString() + "s", c.g.style.opacity = "1", c.j.R(1)) : (c.s = !0, c.m = Date.now(), c.j.R(1)));
      });
      this.h = T("span");
      this.h.textContent = "0s";
      this.g.appendChild(this.h);
      this.i = T("span");
      this.i.classList.add("shaka-forward-rewind-container-icon");
      this.g.appendChild(this.i);
      this.l = !1;
    }

    pa(FB, nB);
    M("shaka.ui.HiddenSeekButton", FB);

    function GB(a, b) {
      FB.call(this, a, b);
      this.g.classList.add("shaka-fast-foward-container");
      this.i.textContent = "fast_forward";
      this.l = !1;
    }

    pa(GB, FB);
    M("shaka.ui.HiddenFastForwardButton", GB);

    function HB(a, b) {
      FB.call(this, a, b);
      this.g.classList.add("shaka-rewind-container");
      this.i.textContent = "fast_rewind";
      this.l = !0;
    }

    pa(HB, FB);
    M("shaka.ui.HiddenRewindButton", HB);

    function IB(a, b, c, d) {
      nB.call(this, a, b);
      var e = this;
      this.container = T("div");
      this.container.classList.add("shaka-range-container");
      this.container.classList.add.apply(this.container.classList, w(c));
      this.h = !1;
      this.bar = document.createElement("input");
      this.J = new Fd(function () {
        e.onChangeEnd();
        e.h = !1;
      });
      this.bar.classList.add("shaka-range-element");
      this.bar.classList.add.apply(this.bar.classList, w(d));
      this.bar.type = "range";
      this.bar.step = "any";
      this.bar.min = "0";
      this.bar.max = "1";
      this.bar.value = "0";
      this.container.appendChild(this.bar);
      this.parent.appendChild(this.container);
      this.eventManager.o(this.bar, "mousedown", function () {
        e.controls.sc() && (e.h = !0, e.onChangeStart());
      });
      this.eventManager.o(this.bar, "touchstart", function (f) {
        e.controls.sc() && (e.h = !0, JB(e, f), e.onChangeStart());
      });
      this.eventManager.o(this.bar, "input", function () {
        e.onChange();
      });
      this.eventManager.o(this.bar, "touchmove", function (f) {
        e.h && (JB(e, f), e.onChange());
      });
      this.eventManager.o(this.bar, "touchend", function (f) {
        e.h && (e.h = !1, JB(e, f), e.onChangeEnd());
      });
      this.eventManager.o(this.bar, "touchcancel", function (f) {
        e.h && (e.h = !1, JB(e, f), e.onChangeEnd());
      });
      this.eventManager.o(this.bar, "mouseup", function () {
        e.h && (e.h = !1, e.onChangeEnd());
      });
      this.eventManager.o(this.bar, "blur", function () {
        e.h && (e.h = !1, e.onChangeEnd());
      });
      this.eventManager.o(this.bar, "contextmenu", function (f) {
        f.preventDefault();
        f.stopPropagation();
      });
    }

    pa(IB, nB);
    p = IB.prototype;

    p.release = function () {
      this.J && (this.J.stop(), this.J = null);
      nB.prototype.release.call(this);
    };

    p.setRange = function (a, b) {
      this.bar.min = a;
      this.bar.max = b;
    };

    p.onChangeStart = function () {};

    p.onChange = function () {};

    p.onChangeEnd = function () {};

    p.changeTo = function (a) {
      this.h || (this.h = !0, this.onChangeStart());
      var b = parseFloat(this.bar.min),
          c = parseFloat(this.bar.max);
      this.bar.value = a > c ? c : a < b ? b : a;
      this.onChange();
      this.J.R(.5);
    };

    p.getValue = function () {
      return parseFloat(this.bar.value);
    };

    p.setValue = function (a) {
      this.h || (this.bar.value = a);
    };

    function JB(a, b) {
      b.preventDefault();
      var c = b.changedTouches[0],
          d = a.bar.getBoundingClientRect();
      b = parseFloat(a.bar.min);
      var e = parseFloat(a.bar.max);
      c = b + (e - b) / d.width * (c.clientX - d.left);
      c < b ? c = b : c > e && (c = e);
      a.bar.value = c;
    }

    M("shaka.ui.RangeElement", IB);
    IB.prototype.setValue = IB.prototype.setValue;
    IB.prototype.getValue = IB.prototype.getValue;
    IB.prototype.changeTo = IB.prototype.changeTo;
    IB.prototype.onChangeEnd = IB.prototype.onChangeEnd;
    IB.prototype.onChange = IB.prototype.onChange;
    IB.prototype.onChangeStart = IB.prototype.onChangeStart;
    IB.prototype.setRange = IB.prototype.setRange;

    function KB(a, b) {
      IB.call(this, a, b, ["shaka-seek-bar-container"], ["shaka-seek-bar", "shaka-no-propagation", "shaka-show-controls-on-mouse-over"]);
      var c = this;
      this.G = T("div");
      this.G.classList.add("shaka-ad-markers");
      this.container.insertBefore(this.G, this.container.childNodes[0]);
      this.m = this.controls.g;
      this.u = new Fd(function () {
        var d = c.getValue();
        c.player.S() || d == c.video.duration && (d -= .001);
        c.video.currentTime = d;
      });
      this.K = new Fd(function () {
        LB(c);
      });
      this.I = new Jf();
      this.H = T("div");
      this.H.id = "shaka-player-ui-chapters-container";
      this.container.appendChild(this.H);
      MB(this);
      this.M = !1;
      this.i = T("div");
      this.i.id = "shaka-player-ui-thumbnail-container";
      this.g = T("img");
      this.g.id = "shaka-player-ui-thumbnail-image";
      this.g.draggable = !1;
      this.C = T("div");
      this.C.id = "shaka-player-ui-thumbnail-time";
      this.i.appendChild(this.g);
      this.i.appendChild(this.C);
      this.container.appendChild(this.i);
      this.j = this.l = null;
      this.L = !1;
      this.s = new Fd(function () {
        NB(c);
      });
      this.D = [];
      this.eventManager.o(this.localization, "locale-updated", function () {
        return OB(c);
      });
      this.eventManager.o(this.localization, "locale-changed", function () {
        return OB(c);
      });
      this.eventManager.o(this.adManager, "ad-started", function () {
        PB(c) || sB(c.container, !1);
      });
      this.eventManager.o(this.adManager, "ad-stopped", function () {
        PB(c) && sB(c.container, !0);
      });
      this.eventManager.o(this.adManager, "ad-cue-points-changed", function (d) {
        c.D = d.cuepoints;
        QB(c);
      });
      this.eventManager.o(this.player, "unloading", function () {
        c.D = [];
        QB(c);
        c.j && (c.j.abort(), c.j = null);
        c.l = null;
        NB(c);
      });
      this.eventManager.o(this.bar, "mousemove", function (d) {
        if (c.player.be().length) {
          var e = c.bar.getBoundingClientRect(),
              f = parseFloat(c.bar.min);
          d = d.clientX - e.left;
          RB(c, d, Math.round(f + (parseFloat(c.bar.max) - f) / e.width * d));
        } else NB(c);
      });
      this.eventManager.o(this.container, "mouseleave", function () {
        c.s.stop();
        c.s.R(.25);
      });
      this.setValue(this.video.currentTime);
      this.update();
      OB(this);
      this.ad && sB(this.container, !1);
    }

    pa(KB, IB);
    p = KB.prototype;

    p.release = function () {
      this.u && (this.u.stop(), this.u = null, this.K.stop(), this.K = null);
      this.I.release();
      IB.prototype.release.call(this);
    };

    p.onChangeStart = function () {
      this.M = !this.video.paused;
      this.controls.kg(!0);
      this.video.pause();
      this.s.stop();
      this.L = !0;
    };

    p.onChange = function () {
      if (this.video.duration) if (this.update(), this.u.R(.125), this.player.be().length) {
        var a = parseFloat(this.bar.min),
            b = parseFloat(this.bar.max),
            c = this.bar.getBoundingClientRect(),
            d = Math.round(this.getValue());
        RB(this, (d - a) / ((b - a) / c.width), d);
      } else NB(this);
    };

    p.onChangeEnd = function () {
      this.u.Ma();
      this.controls.kg(!1);
      this.M && this.video.play();
      this.L && (this.L = !1, this.s.stop(), this.s.R(.25));
    };

    p.isShowing = function () {
      return !this.container.classList.contains("shaka-hidden");
    };

    p.update = function () {
      var a = this.m.seekBarColors,
          b = this.getValue(),
          c = this.video.buffered.length,
          d = c ? this.video.buffered.start(0) : 0,
          e = c ? this.video.buffered.end(c - 1) : 0,
          f = this.player.Ga(),
          g = f.end - f.start;
      this.setRange(f.start, f.end);
      PB(this) ? (sB(this.container, !0), 0 == c ? this.container.style.background = a.base : (c = (Math.max(d, f.start) - f.start) / g || 0, e = (Math.min(e, f.end) - f.start) / g || 0, b = (Math.min(Math.max(b, f.start), f.end) - f.start) / g || 0, this.container.style.background = "linear-gradient(" + ["to right", (this.m.showUnbufferedStart ? a.base : a.played) + " " + 100 * c + "%", a.played + " " + 100 * c + "%", a.played + " " + 100 * b + "%", a.buffered + " " + 100 * b + "%", a.buffered + " " + 100 * e + "%", a.base + " " + 100 * e + "%"].join() + ")")) : sB(this.container, !1);
    };

    function LB(a) {
      if (a.D.length) {
        for (var b = a.player.Ga(), c = b.end - b.start, d = ["to right"], e = [], f = a.m.seekBarColors.adBreaks, g = !1, h = t(a.D), k = h.next(); !k.done; k = h.next()) if (k = k.value, -1 != k.start || k.end || (g = !0), k.start >= b.start && k.start < b.end && !(k.end && k.end > b.end)) {
          var l = (k.start - b.start) / c || 0,
              m = l + .01;
          k.end && (m = (k.end - b.start) / c || 0);
          e.push({
            start: l,
            end: m
          });
        }

        b = t(e);

        for (k = b.next(); !k.done; k = b.next()) c = k.value, d.push("transparent " + 100 * c.start + "%"), d.push(f + " " + 100 * c.start + "%"), d.push(f + " " + 100 * c.end + "%"), d.push("transparent " + 100 * c.end + "%");

        g && (d.push("transparent 99%"), d.push(f + " 99%"));
        a.G.style.background = "linear-gradient(" + d.join(",") + ")";
      } else a.G.style.background = "transparent";
    }

    function QB(a) {
      LB(a);
      var b = a.player.Ga();
      b = b.end - b.start;
      a.player.S() && 5 < b && a.K.ya(1);
    }

    function PB(a) {
      var b = a.player.Ga();
      b = b.end - b.start;
      return a.player.S() && 5 > b ? !1 : null == a.ad || !a.ad.isLinear();
    }

    function OB(a) {
      a.bar.ariaLabel = a.localization.resolve("SEEK");
    }

    function RB(a, b, c) {
      var d, e, f, g, h, k, l, m, n, r, q, u, v, y, z, x, B, A;
      K(function (C) {
        switch (C.g) {
          case 1:
            d = SB(a);
            if (!d) return NB(a), C.return();
            0 > c && (c = 0);
            e = a.player.Ga();
            f = Math.max(Math.ceil(e.start), Math.min(Math.floor(e.end), c));
            return D(C, a.player.Df(d.id, f), 2);

          case 2:
            g = C.h;
            if (!g || !g.uris.length) return NB(a), C.return();
            a.player.S() ? (h = e.end - c, a.C.textContent = 1 > h ? a.localization.resolve("LIVE") : "-" + TB(h)) : a.C.textContent = TB(c);
            k = -10;
            l = a.i.clientWidth;
            m = Math.floor(9 * l / 16);
            a.i.style.height = m + "px";
            a.i.style.top = -(m - k) + "px";
            n = Math.min(a.bar.offsetWidth - l, Math.max(0, b - l / 2));
            a.i.style.left = n + "px";
            a.i.style.visibility = "visible";
            r = g.uris[0].split("#xywh=")[0];

            if (a.l && r === a.l.uris[0].split("#xywh=")[0] && g.segment.Wb() == a.l.segment.Wb() && g.segment.Sb() == a.l.segment.Sb()) {
              C.F(3);
              break;
            }

            a.l = g;
            a.j && (a.j.abort(), a.j = null);

            if ("mjpg" != d.codecs && !r.startsWith("offline:")) {
              C.F(4);
              break;
            }

            a.g.src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg"/>';
            ta(C, 5);
            q = Ff;
            u = ok(g.segment.ba(), g.segment.Wb(), g.segment.Sb(), a.player.getConfiguration().streaming.retryParameters);
            a.j = a.player.Tb().request(q, u, {
              type: 1
            });
            return D(C, a.j.promise, 7);

          case 7:
            v = C.h;
            a.j = null;
            "mjpg" == d.codecs ? (y = new bg().box("mdat", mg(function (E) {
              r = URL.createObjectURL(new Blob([E], {
                type: "image/jpeg"
              }));
            })), y.parse(v.data, !1)) : (z = d.mimeType || "image/jpeg", x = new Blob([v.data], {
              type: z
            }), r = URL.createObjectURL(x));
            va(C, 4);
            break;

          case 5:
            B = wa(C);
            if (7001 == B.code) return C.return();
            throw B;

          case 4:
            try {
              a.i.removeChild(a.g);
            } catch (E) {}

            a.g = T("img");
            a.g.id = "shaka-player-ui-thumbnail-image";
            a.g.draggable = !1;
            a.g.src = r;

            a.g.onload = function () {
              r.startsWith("blob:") && URL.revokeObjectURL(r);
            };

            a.i.insertBefore(a.g, a.i.firstChild);

          case 3:
            A = l / g.width, g.imageHeight ? a.g.height = g.imageHeight : g.sprite || (a.g.style.height = "100%", a.g.style.objectFit = "contain"), g.imageWidth ? a.g.width = g.imageWidth : g.sprite || (a.g.style.width = "100%", a.g.style.objectFit = "contain"), a.g.style.left = "-" + A * g.positionX + "px", a.g.style.top = "-" + A * g.positionY + "px", a.g.style.transform = "scale(" + A + ")", a.g.style.transformOrigin = "left top", m = Math.floor(l * g.height / g.width), a.i.style.height = m + "px", a.i.style.top = -(m - k) + "px", F(C);
        }
      });
    }

    function SB(a) {
      var b = a.player.be();
      if (!b.length) return null;

      for (var c = {}, d = t(["image/avif", "image/webp", "image/jpeg", "image/png", "image/svg+xml"]), e = d.next(); !e.done; c = {
        Ne: c.Ne,
        Le: c.Le
      }, e = d.next()) if (c.Ne = e.value, c.Le = a.player.getStats().estimatedBandwidth, (e = b.filter(function (f) {
        return function (g) {
          return g.mimeType.toLowerCase() === f.Ne && g.bandwidth < .01 * f.Le;
        };
      }(c)).sort(function (f, g) {
        return g.bandwidth - f.bandwidth;
      })) && e.length) return e[0];

      return b.find(function (f) {
        return "application/mp4" == f.mimeType && "mjpg" == f.codecs;
      }) || b[0];
    }

    function NB(a) {
      a.i.style.visibility = "hidden";
      a.C.textContent = "";
    }

    function TB(a) {
      var b = Math.round(a);
      a = Math.floor(b / 3600);
      var c = Math.floor((b - 3600 * a) / 60);
      b = b - 3600 * a - 60 * c;
      10 > b && (b = "0" + b);
      return 0 < a ? (10 > c && (c = "0" + c), a + ":" + c + ":" + b) : c + ":" + b;
    }

    function MB(a) {
      function b() {
        for (var f = "und", g = [], h = t(Array.from(a.localization.g)), k = h.next(); !k.done && (f = k.value, g = a.player.zf(f), !g.length); k = h.next());

        g.length || (f = "und", g = a.player.zf(f));
        h = f !== d;
        k = e.length !== g.length || !e.some(function (l, m) {
          m = g.at(m);
          return c(l, m) || g.some(function (n) {
            return c(l, n);
          });
        });
        d = f;
        e = g;
        g.length ? (h || k) && UB(a, e) : VB(a);
      }

      function c(f, g) {
        return !f && !g || f.id === g.id && f.title === g.title && f.startTime === g.startTime && f.endTime === g.endTime;
      }

      var d = "und",
          e = [];
      b();
      a.eventManager.o(a.player, "unloading", function () {
        VB(a);
        d = "und";
        e = [];
      });
      a.eventManager.o(a.player, "trackschanged", b);
      a.eventManager.o(a.localization, "locale-updated", function () {
        b();
      });
      a.eventManager.o(a.localization, "locale-changed", function () {
        b();
      });
    }

    function UB(a, b) {
      VB(a);
      var c = a.player.Ga(),
          d = [];
      b = t(b);

      for (var e = b.next(); !e.done; e = b.next()) if (e = e.value, !(e.startTime >= c.end)) {
        var f = e.startTime > c.start ? e.startTime : c.start,
            g = e.endTime < c.end ? e.endTime : c.end;
        d.push({
          start: f,
          end: g,
          size: g - f,
          title: e.title,
          id: e.id
        });
      }

      if (!(2 > d.length)) {
        c = d.reduce(function (k, l) {
          return k += l.size;
        }, 0);
        var h = [];
        d = t(d);

        for (e = d.next(); !e.done; e = d.next()) b = e.value, e = T("div"), e.classList.add("shaka-chapter"), e.style.width = 100 * b.size / c + "%", a.H.appendChild(e), f = T("div"), f.style.borderColor = a.m.seekBarColors.chapterMarks, e.appendChild(f), f = T("p"), f.classList.add("shaka-chapter-label", "shaka-hidden"), f.style.color = a.m.seekBarColors.chapterLabels, f.innerText = b.title, e.appendChild(f), h.push({
          start: b.start,
          end: b.end,
          $d: f
        });

        a.I.o(a.bar, "pointermove", function (k) {
          if (k.target) {
            var l = k.target;
            k = k.offsetX / l.clientWidth;
            l = parseInt(l.getAttribute("max"), 10);
            l *= k;
            k = t(h);

            for (var m = k.next(); !m.done; m = k.next()) m = m.value, (m.start <= l && l < m.end) === m.$d.classList.contains("shaka-hidden") && m.$d.classList.toggle("shaka-hidden");
          }
        }, {
          passive: !0
        });
        a.I.o(a.bar, "pointerout", function () {
          for (var k = t(h), l = k.next(); !l.done; l = k.next()) l = l.value, l.$d.classList.contains("shaka-hidden") || l.$d.classList.add("shaka-hidden");
        }, {
          passive: !0
        });
      }
    }

    function VB(a) {
      a.I.Lb();
      fl(a.H);
    }

    M("shaka.ui.SeekBar", KB);

    function WB() {}

    WB.prototype.create = function (a, b) {
      return new KB(a, b);
    };

    KB.Factory = WB;

    function Z(a, b, c, d) {
      db.call(this);
      var e = this;
      this.N = !0;
      this.g = d;
      this.C = new Oo(c, a, this.g.castReceiverAppId, this.g.castAndroidReceiverCompatible);
      this.ua = !0;
      this.u = this.C.Yb();
      this.s = c;
      this.G = this.C.Hc();
      this.ra = a;
      this.j = b;
      this.Ta = this.G.ae();
      this.l = this.m = null;
      this.V = !1;
      this.H = [];
      this.Qb = [];
      this.Cb = !1;
      this.Z = new Fd(function () {
        e.j.style.cursor = "none";
        e.Cb = !1;
        XB(e);
      });
      this.aa = new Fd(function () {
        e.h.removeAttribute("shown");
        e.I.R(2);
      });
      this.I = new Fd(function () {
        for (var f = t(e.H), g = f.next(); !g.done; g = f.next()) sB(g.value, !1);
      });
      this.Na = new Fd(function () {
        e.sc() && YB(e);
      });
      this.J = null;
      this.D = [];
      this.Aa = ZB();
      this.i = new Jf();
      this.configure(this.g);
      $B(this);
      this.ha = new Set();
      aC(this);
      this.Na.ya(.125);
      this.i.o(this.Aa, "locale-changed", function (f) {
        e.Ta.setLocale(f.locales[0]);
      });
    }

    pa(Z, db);
    p = Z.prototype;

    p.destroy = function () {
      var a = this;
      return K(function (b) {
        switch (b.g) {
          case 1:
            if (document.pictureInPictureElement != a.s) {
              b.F(2);
              break;
            }

            return D(b, document.exitPictureInPicture(), 2);

          case 2:
            a.i && (a.i.release(), a.i = null);
            a.Z && (a.Z.stop(), a.Z = null);
            a.aa && (a.aa.stop(), a.aa = null);
            a.I && (a.I.stop(), a.I = null);
            a.Na && (a.Na.stop(), a.Na = null);
            bC(a);
            a.h && (a.j.removeChild(a.h), a.h = null);

            if (!a.C) {
              b.F(4);
              break;
            }

            return D(b, a.C.destroy(), 5);

          case 5:
            a.C = null;

          case 4:
            if (!a.ra) {
              b.F(6);
              break;
            }

            return D(b, a.ra.destroy(), 7);

          case 7:
            a.ra = null;

          case 6:
            a.G = null, a.s = null, a.u = null, a.Aa = null, a.ha.clear(), db.prototype.release.call(a), F(b);
        }
      });
    };

    function bC(a) {
      for (var b = t(a.D), c = b.next(); !c.done; c = b.next()) c.value.release();

      a.D = [];
    }

    function cC(a, b) {
      dC.set(a, b);
    }

    p.Ch = function (a) {
      this.ua = a;
      aC(this);
    };

    p.Hi = function () {
      XB(this);
    };

    p.configure = function (a) {
      this.g = a;
      this.C.Cg(a.castReceiverAppId, a.castAndroidReceiverCompatible);
      this.l && (this.l = null);
      this.yb && (this.yb = null);
      this.Ua && (this.Ua = null);
      this.h ? (fl(this.h), bC(this)) : (eC(this), fC(this));
      this.j.classList.add("shaka-video-container");
      this.s.classList.add("shaka-video");
      gC(this);
      this.g.addBigPlayButton && hC(this);
      this.g.customContextMenu && (this.Ua = new BB(this.U, this), this.D.push(this.Ua));
      this.$ || iC(this);
      this.g.seekOnTaps && (jC(this), kC(this));
      this.Bb = T("div");
      this.Bb.classList.add("shaka-server-side-ad-container");
      this.h.appendChild(this.Bb);
      lC(this);
      this.H = Array.from(this.j.getElementsByClassName("shaka-settings-menu"));
      this.H.push.apply(this.H, w(Array.from(this.j.getElementsByClassName("shaka-overflow-menu"))));
      mC(this);
      this.Qb = Array.from(this.j.getElementsByClassName("shaka-show-controls-on-mouse-over"));
      XB(this);
      a = t(this.j.getElementsByClassName("shaka-no-propagation"));

      for (var b = a.next(); !b.done; b = a.next()) {
        b = b.value;

        var c = function (d) {
          return d.stopPropagation();
        };

        this.i.o(b, "click", c);
        this.i.o(b, "dblclick", c);
      }
    };

    p.gg = function (a) {
      (this.N = a) ? (this.j.setAttribute("shaka-controls", "true"), this.s.tabIndex = -1, this.s.controls = !1) : this.j.removeAttribute("shaka-controls");
      XB(this);
    };

    p.ih = function (a) {
      this.s.controls = a;
      this.s.tabIndex = a ? 0 : -1;
      a && this.gg(!1);
    };

    p.getAd = function () {
      return this.m;
    };

    p.Nh = function () {
      return this.C;
    };

    p.Zh = function () {
      return this.Aa;
    };

    p.ri = function () {
      return this.j;
    };

    p.Yb = function () {
      return this.u;
    };

    p.Yh = function () {
      return this.s;
    };

    p.Hc = function () {
      return this.G;
    };

    p.Xh = function () {
      return this.ra;
    };

    p.Rh = function () {
      return this.h;
    };

    p.ji = function () {
      return this.Bb;
    };

    p.Oh = function () {
      return this.M;
    };

    p.Ph = function () {
      return this.g;
    };

    p.Fi = function () {
      return this.V;
    };

    p.kg = function (a) {
      this.V = a;
    };

    p.zi = function () {
      return this.ua;
    };

    p.Af = function () {
      return this.l ? this.l.getValue() : this.u.currentTime;
    };

    p.jh = function (a) {
      this.J = a;
    };

    p.ld = function () {
      return this.H.some(function (a) {
        return !a.classList.contains("shaka-hidden");
      });
    };

    p.pc = function () {
      this.I.Ma();
    };

    p.xd = function () {
      return document.fullscreenEnabled || this.s.webkitSupportsFullscreen ? !0 : !1;
    };

    p.Mc = function () {
      if (document.fullscreenEnabled) return !!document.fullscreenElement;
      var a = this.s;
      return a.webkitSupportsFullscreen ? a.webkitDisplayingFullscreen : !1;
    };

    function nC(a) {
      var b, c, d;
      return K(function (e) {
        switch (e.g) {
          case 1:
            ta(e, 2);

            if (!document.fullscreenEnabled) {
              b = a.s;
              b.webkitSupportsFullscreen && b.webkitEnterFullscreen();
              e.F(4);
              break;
            }

            if (!document.pictureInPictureElement) {
              e.F(5);
              break;
            }

            return D(e, document.exitPictureInPicture(), 5);

          case 5:
            return c = a.g.fullScreenElement, D(e, c.requestFullscreen({
              navigationUI: "hide"
            }), 7);

          case 7:
            if (!a.g.forceLandscapeOnFullscreen || !screen.orientation) {
              e.F(4);
              break;
            }

            ta(e, 9);
            return D(e, screen.orientation.lock("landscape"), 11);

          case 11:
            va(e, 4, 2);
            break;

          case 9:
            wa(e, 2);

          case 4:
            va(e, 0);
            break;

          case 2:
            d = wa(e), a.dispatchEvent(new N("error", new Map().set("detail", d))), F(e);
        }
      });
    }

    function oC(a) {
      var b;
      return K(function (c) {
        if (!document.fullscreenEnabled) return b = a.s, b.webkitSupportsFullscreen && b.webkitExitFullscreen(), c.F(0);
        screen.orientation && screen.orientation.unlock();
        return D(c, document.exitFullscreen(), 0);
      });
    }

    p.Ge = function () {
      var a = this;
      return K(function (b) {
        return a.Mc() ? D(b, oC(a), 0) : D(b, nC(a), 0);
      });
    };

    p.Nc = function () {
      return "documentPictureInPicture" in window && this.g.preferDocumentPictureInPicture || document.pictureInPictureEnabled ? !this.s.disablePictureInPicture : !1;
    };

    p.Hf = function () {
      return "documentPictureInPicture" in window && this.g.preferDocumentPictureInPicture ? !!window.documentPictureInPicture.window : !!document.pictureInPictureElement;
    };

    p.He = function () {
      var a = this,
          b,
          c;
      return K(function (d) {
        if (1 == d.g) return ta(d, 2), "documentPictureInPicture" in window && a.g.preferDocumentPictureInPicture ? D(d, pC(a), 5) : document.pictureInPictureElement ? D(d, document.exitPictureInPicture(), 5) : (document.fullscreenElement && document.exitFullscreen(), b = a.s, D(d, b.requestPictureInPicture(), 5));
        if (2 != d.g) return va(d, 0);
        c = wa(d);
        a.dispatchEvent(new N("error", new Map().set("detail", c)));
        F(d);
      });
    };

    function pC(a) {
      var b, c, d, e, f, g;
      return K(function (h) {
        if (1 == h.g) {
          if (window.documentPictureInPicture.window) return window.documentPictureInPicture.window.close(), h.return();
          b = a.j;
          c = b.getBoundingClientRect();
          return D(h, window.documentPictureInPicture.requestWindow({
            width: c.width,
            height: c.height
          }), 2);
        }

        d = h.h;
        qC(d);
        e = b.parentNode || document.body;
        f = a.j.cloneNode(!0);
        f.style.visibility = "hidden";
        f.style.height = getComputedStyle(b).height;
        e.appendChild(f);
        g = document.createElement("style");
        g.append("[data-shaka-player-container] {\n      width: 100% !important; max-height: 100%}");
        d.document.head.append(g);
        d.document.body.append(b);
        a.i.na(d, "pagehide", function () {
          f.replaceWith(b);
        });
        F(h);
      });
    }

    function qC(a) {
      var b = [].concat(w(document.styleSheets)).map(function (d) {
        try {
          return [].concat(w(d.cssRules)).map(function (f) {
            return f.cssText;
          }).join("");
        } catch (f) {
          var e = document.createElement("link");
          e.rel = "stylesheet";
          e.type = d.type;
          e.media = d.media;
          e.href = d.href;
          a.document.head.appendChild(e);
        }

        return "";
      }).filter(Boolean).join("\n"),
          c = document.createElement("style");
      c.textContent = b;
      a.document.head.appendChild(c);
    }

    p.nh = function () {
      sB(this.K, !0);
      sB(this.M, !0);
      this.h.setAttribute("ad-active", "true");
    };

    p.Pg = function () {
      sB(this.K, !1);
      sB(this.M, !1);
      this.h.removeAttribute("ad-active");
    };

    function zB(a) {
      a.N && a.u.duration && (a.G.$e(), a.u.paused && !a.V ? a.u.play() : a.u.pause());
    }

    function yB(a) {
      a.m && a.m.isPaused() ? a.m.play() : a.m && a.m.pause();
    }

    function eC(a) {
      a.h = T("div");
      a.h.classList.add("shaka-controls-container");
      a.j.appendChild(a.h);
      a.j.setAttribute("shaka-controls", "true");
      a.i.o(a.h, "touchstart", function (b) {
        a.u.duration && (a.sc() ? a.J = Date.now() : (rC(a, b), b.cancelable && b.preventDefault()));
      }, {
        passive: !1
      });
      a.i.o(a.h, "click", function () {
        sC(a);
      });
      a.i.o(a.h, "dblclick", function () {
        a.g.doubleClickForFullscreen && a.xd() && a.Ge();
      });
    }

    function hC(a) {
      var b = T("div");
      b.classList.add("shaka-play-button-container");
      a.h.appendChild(b);
      a.yb = new AB(b, a);
      a.D.push(a.yb);
    }

    function gC(a) {
      var b = T("div");
      b.classList.add("shaka-scrim-container");
      a.h.appendChild(b);
    }

    function tC(a) {
      a.K = T("div");
      a.K.classList.add("shaka-ad-controls");
      var b = null != a.m && a.m.isLinear();
      sB(a.K, b);
      a.L.appendChild(a.K);
      b = new vB(a.K, a);
      a.D.push(b);
      b = new uB(a.K, a);
      a.D.push(b);
    }

    function iC(a) {
      a.$ = T("div");
      a.$.classList.add("shaka-spinner-container");
      a.j.appendChild(a.$);
      var b = T("div");
      b.classList.add("shaka-spinner");
      a.$.appendChild(b);
      a = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      a.classList.add("shaka-spinner-svg");
      a.setAttribute("viewBox", "0 0 30 30");
      b.appendChild(a);
      b = document.createElementNS("http://www.w3.org/2000/svg", "circle");
      b.classList.add("shaka-spinner-path");
      b.setAttribute("cx", "15");
      b.setAttribute("cy", "15");
      b.setAttribute("r", "14.5");
      b.setAttribute("fill", "none");
      b.setAttribute("stroke-width", "1");
      b.setAttribute("stroke-miterlimit", "10");
      a.appendChild(b);
    }

    function jC(a) {
      var b = T("div");
      b.classList.add("shaka-hidden-fast-forward-container");
      a.h.appendChild(b);
      a.ic = new GB(b, a);
      a.D.push(a.ic);
    }

    function kC(a) {
      var b = T("div");
      b.classList.add("shaka-hidden-rewind-container");
      a.h.appendChild(b);
      a.Kc = new HB(b, a);
      a.D.push(a.Kc);
    }

    function lC(a) {
      a.L = T("div");
      a.L.classList.add("shaka-bottom-controls");
      a.L.classList.add("shaka-no-propagation");
      a.h.appendChild(a.L);
      a.i.o(a.L, "click", function (d) {
        d.target.closest(".shaka-overflow-button") || a.pc();
      });
      tC(a);
      a.U = T("div");
      a.U.classList.add("shaka-controls-button-panel");
      a.U.classList.add("shaka-show-controls-on-mouse-over");
      a.g.enableTooltips && a.U.classList.add("shaka-tooltips-on");
      a.L.appendChild(a.U);

      for (var b = t(a.g.controlPanelElements), c = b.next(); !c.done; c = b.next()) c = c.value, dC.get(c) ? (c = dC.get(c).create(a.U, a), a.D.push(c)) : Ua("Unrecognized control panel element requested:", c);
    }

    function mC(a) {
      if (a.g.addSeekBar) a.l = uC.create(a.L, a), a.D.push(a.l);else {
        a = t(a.H);

        for (var b = a.next(); !b.done; b = a.next()) b.value.classList.add("shaka-low-position");
      }
    }

    function fC(a) {
      a.M = T("div");
      a.M.classList.add("shaka-client-side-ad-container");
      sB(a.M, !1);
      a.i.o(a.M, "click", function () {
        sC(a);
      });
      a.j.appendChild(a.M);
    }

    function $B(a) {
      a.i.o(a.G, "buffering", function () {
        a.N && sB(a.$, a.G.wd());
      });
      a.N && sB(a.$, a.G.wd());
      a.i.o(window, "keydown", function (b) {
        vC(a, b);
      });
      a.i.o(window, "click", function () {
        return a.pc();
      });
      a.i.o(a, "submenuopen", function () {
        a.pc();
      });
      a.i.o(a.u, "play", function () {
        XB(a);
      });
      a.i.o(a.u, "pause", function () {
        XB(a);
      });
      a.i.o(a.j, "mousemove", function (b) {
        rC(a, b);
      });
      a.i.o(a.j, "touchmove", function (b) {
        rC(a, b);
      }, {
        passive: !0
      });
      a.i.o(a.j, "touchend", function (b) {
        rC(a, b);
      }, {
        passive: !0
      });
      a.i.o(a.j, "mouseleave", function () {
        a.J || a.Z.Ma();
      });
      a.i.o(a.C, "caststatuschanged", function () {
        aC(a);
      });
      a.i.o(a.j, "keydown", function (b) {
        var c = document.activeElement,
            d = c && c.classList ? c.classList.contains("shaka-volume-bar") : !1,
            e = c && c.classList && c.classList.contains("shaka-seek-bar");
        a.h.contains(c) && rC(a, b);

        if (a.g.enableKeyboardPlaybackControls) {
          c = a.g.keyboardSeekDistance;
          var f = a.g.keyboardLargeSeekDistance;

          switch (b.key) {
            case "ArrowLeft":
              a.l && !d && 0 < c && (b.preventDefault(), wC(a, a.l.getValue() - c));
              break;

            case "ArrowRight":
              a.l && !d && 0 < c && (b.preventDefault(), wC(a, a.l.getValue() + c));
              break;

            case "PageDown":
              a.l && e && 0 < c && (b.preventDefault(), wC(a, a.l.getValue() - f));
              break;

            case "PageUp":
              a.l && e && 0 < c && (b.preventDefault(), wC(a, a.l.getValue() + f));
              break;

            case "Home":
              a.l && wC(a, a.G.Ga().start);
              break;

            case "End":
              a.l && wC(a, a.G.Ga().end);
              break;

            case "f":
              a.xd() && a.Ge();
              break;

            case "m":
              a.m && a.m.isLinear() ? a.m.setMuted(!a.m.isMuted()) : a.s.muted = !a.s.muted;
              break;

            case "p":
              a.Nc() && a.He();
              break;

            case " ":
              e && xC(a);
          }
        }
      });
      a.i.o(a.j, "keyup", function (b) {
        a.ha.delete(b.key);
      });
      a.i.o(a.Ta, "ad-started", function (b) {
        a.m = b.ad;
        a.nh();
      });
      a.i.o(a.Ta, "ad-stopped", function () {
        a.m = null;
        a.Pg();
      });
      screen.orientation && a.i.o(screen.orientation, "change", function () {
        return K(function (b) {
          return D(b, yC(a), 0);
        });
      });
    }

    function yC(a) {
      return K(function (b) {
        return a.u && 0 != a.u.readyState && !a.C.Fa() && a.g.enableFullscreenOnRotation && a.xd() ? screen.orientation.type.includes("landscape") && !a.Mc() ? D(b, nC(a), 0) : screen.orientation.type.includes("portrait") && a.Mc() ? D(b, oC(a), 0) : b.F(0) : b.return();
      });
    }

    function rC(a, b) {
      "mousemove" == b.type && (a.h.classList.remove("shaka-keyboard-navigation"), XB(a));
      "touchstart" == b.type || "touchmove" == b.type || "touchend" == b.type || "keyup" == b.type ? a.J = Date.now() : a.J + 1E3 < Date.now() && (a.J = null);
      a.J && "mousemove" == b.type || (a.j.style.cursor = "", a.Cb = !0, a.I.stop(), a.sc() || (YB(a), XB(a)), a.Z.stop(), "touchend" != b.type && "keyup" != b.type && a.J || a.Z.R(3));
    }

    function zC(a) {
      return window.matchMedia("hover: hover").matches ? a.Qb.some(function (b) {
        return b.matches(":hover");
      }) : !1;
    }

    function XB(a) {
      var b = a.m ? a.m.isPaused() : !1,
          c = a.u.paused && !a.V,
          d = a.h.classList.contains("shaka-keyboard-navigation");
      b || (!a.m || !a.m.isLinear()) && c || a.Cb || d || zC(a) ? (YB(a), a.h.setAttribute("shown", "true"), a.aa.stop()) : a.aa.R(a.g.fadeDelay);
    }

    function sC(a) {
      a.N && (a.ld() ? a.I.Ma() : a.g.singleClickForPlayAndPause && xC(a));
    }

    function xC(a) {
      a.m && a.m.isLinear() ? yB(a) : zB(a);
    }

    function aC(a) {
      var b = a.C.Fa();
      a.dispatchEvent(new N("caststatuschanged", new Map().set("newStatus", b)));
      b ? a.h.setAttribute("casting", "true") : a.h.removeAttribute("casting");
    }

    p.sc = function () {
      return this.N ? null != this.h.getAttribute("shown") || null != this.h.getAttribute("casting") : !1;
    };

    function wC(a, b) {
      a.l.changeTo(b);
      a.sc() && YB(a);
    }

    function YB(a) {
      if (a.l) if (a.l.setValue(a.u.currentTime), a.l.update(), a.l.isShowing()) for (var b = t(a.H), c = b.next(); !c.done; c = b.next()) c.value.classList.remove("shaka-low-position");else for (b = t(a.H), c = b.next(); !c.done; c = b.next()) c.value.classList.add("shaka-low-position");
      a.dispatchEvent(new N("timeandseekrangeupdated"));
    }

    function vC(a, b) {
      a.ha.add(b.key);
      var c = a.ld();
      "Tab" == b.key && (a.h.classList.add("shaka-keyboard-navigation"), XB(a), a.i.o(window, "mousedown", function () {
        a.i.bc(window, "mousedown");
      }));
      "Escape" == b.key && a.I.Ma();
      c && a.ha.has("Tab") && AC(a, b);
    }

    function AC(a, b) {
      var c = a.H.filter(function (f) {
        return !f.classList.contains("shaka-hidden");
      });

      if (c.length) {
        var d = c[0];

        if (d.childNodes.length) {
          for (c = d.firstElementChild; c && c.classList.contains("shaka-hidden");) c = c.nextElementSibling;

          for (d = d.lastElementChild; d && d.classList.contains("shaka-hidden");) d = d.previousElementSibling;

          var e = document.activeElement;
          a.ha.has("Shift") ? e == c && (b.preventDefault(), d.focus()) : e == d && (b.preventDefault(), c.focus());
        }
      }
    }

    function ZB() {
      var a = new Zb("en");
      a.xa("ar", new Map([["AD_DURATION", "\u0645\u062f\u0629 \u0627\u0644\u0625\u0639\u0644\u0627\u0646"], ["AD_PROGRESS", "\u0627\u0644\u0625\u0639\u0644\u0627\u0646 [AD_ON] \u0645\u0646 [NUM_ADS]"], ["AD_TIME", "\u0627\u0644\u0625\u0639\u0644\u0627\u0646: [AD_TIME]"], ["AUTO_QUALITY", "\u062a\u0644\u0642\u0627\u0626\u064a"], ["BACK", "\u0631\u062c\u0648\u0639"], ["CAPTIONS", "\u0627\u0644\u062a\u0631\u062c\u0645\u0629 \u0648\u0627\u0644\u0634\u0631\u062d"], ["CAST", "\u0625\u0631\u0633\u0627\u0644..."], ["ENTER_LOOP_MODE", "\u062a\u0643\u0631\u0627\u0631 \u0627\u0644\u0641\u064a\u062f\u064a\u0648 \u0627\u0644\u062d\u0627\u0644\u064a"], ["ENTER_PICTURE_IN_PICTURE", '\u0627\u0644\u062f\u062e\u0648\u0644 \u0641\u064a \u0648\u0636\u0639 "\u0646\u0627\u0641\u0630\u0629 \u0636\u0645\u0646 \u0646\u0627\u0641\u0630\u0629"'], ["EXIT_FULL_SCREEN", "\u0625\u0646\u0647\u0627\u0621 \u0648\u0636\u0639 \u0645\u0644\u0621 \u0627\u0644\u0634\u0627\u0634\u0629"], ["EXIT_LOOP_MODE", "\u0625\u064a\u0642\u0627\u0641 \u062a\u0643\u0631\u0627\u0631 \u0627\u0644\u0641\u064a\u062f\u064a\u0648 \u0627\u0644\u062d\u0627\u0644\u064a"], ["EXIT_PICTURE_IN_PICTURE", '\u0627\u0644\u062e\u0631\u0648\u062c \u0645\u0646 \u0648\u0636\u0639 "\u0646\u0627\u0641\u0630\u0629 \u0636\u0645\u0646 \u0646\u0627\u0641\u0630\u0629"'], ["FAST_FORWARD", "\u062a\u0642\u062f\u064a\u0645 \u0633\u0631\u064a\u0639"], ["FULL_SCREEN", "\u0645\u0644\u0621 \u0627\u0644\u0634\u0627\u0634\u0629"], ["LANGUAGE", "\u0627\u0644\u0644\u063a\u0629"], ["LIVE", "\u0645\u0628\u0627\u0634\u0631"], ["LOOP", "\u062a\u0643\u0631\u0627\u0631"], ["MORE_SETTINGS", "\u0645\u0632\u064a\u062f \u0645\u0646 \u0627\u0644\u0625\u0639\u062f\u0627\u062f\u0627\u062a"], ["MULTIPLE_LANGUAGES", "\u0644\u063a\u0627\u062a \u0645\u062a\u0639\u062f\u062f\u0629"], ["MUTE", "\u0643\u062a\u0645 \u0627\u0644\u0635\u0648\u062a"], ["NOT_APPLICABLE", "\u063a\u064a\u0631 \u0633\u0627\u0631\u064d"], ["OFF", "\u0625\u064a\u0642\u0627\u0641"], ["ON", "\u062a\u0634\u063a\u064a\u0644"], ["PAUSE", "\u0625\u064a\u0642\u0627\u0641 \u0645\u0624\u0642\u062a"], ["PICTURE_IN_PICTURE", "\u0646\u0627\u0641\u0630\u0629 \u0636\u0645\u0646 \u0627\u0644\u0646\u0627\u0641\u0630\u0629"], ["PLAY", "\u0627\u0644\u062a\u0634\u063a\u064a\u0644"], ["PLAYBACK_RATE", "\u0633\u0631\u0639\u0629 \u0627\u0644\u062a\u0634\u063a\u064a\u0644"], ["RESOLUTION", "\u062f\u0631\u062c\u0629 \u0627\u0644\u062f\u0642\u0629"], ["REWIND", "\u062a\u0631\u062c\u064a\u0639"], ["SEEK", "\u0627\u0644\u0628\u062d\u062b \u0628\u0627\u0644\u062a\u0645\u0631\u064a\u0631"], ["SKIP_AD", "\u062a\u062e\u0637\u0651\u064a \u0627\u0644\u0625\u0639\u0644\u0627\u0646"], ["SKIP_TO_LIVE", "\u0627\u0644\u0627\u0646\u062a\u0642\u0627\u0644 \u0625\u0644\u0649 \u0628\u062b \u0645\u0628\u0627\u0634\u0631"], ["UNDETERMINED_LANGUAGE", "\u063a\u064a\u0631 \u0645\u062d\u062f\u062f"], ["UNMUTE", "\u0625\u0639\u0627\u062f\u0629 \u0627\u0644\u0635\u0648\u062a"], ["UNRECOGNIZED_LANGUAGE", "\u063a\u064a\u0631 \u0645\u0639\u0631\u0648\u0641"], ["VOLUME", "\u0645\u0633\u062a\u0648\u0649 \u0627\u0644\u0635\u0648\u062a"]]));
      a.xa("de", new Map([["AD_DURATION", "Dauer der Werbeanzeige"], ["AD_PROGRESS", "Werbung\u00a0[AD_ON] von\u00a0[NUM_ADS]"], ["AD_TIME", "Werbeanzeige: [AD_TIME]"], ["AUTO_QUALITY", "Automatisch"], ["BACK", "Zur\u00fcck"], ["CAPTIONS", "Untertitel"], ["CAST", "Streamen..."], ["ENTER_LOOP_MODE", "In Endlosschleife spielen"], ["ENTER_PICTURE_IN_PICTURE", "Bild-im-Bild-Modus aktivieren"], ["EXIT_FULL_SCREEN", "Vollbildmodus beenden"], ["EXIT_LOOP_MODE", "Endlosschleife stoppen"], ["EXIT_PICTURE_IN_PICTURE", "Bild-im-Bild-Modus beenden"], ["FAST_FORWARD", "Vorspulen"], ["FULL_SCREEN", "Vollbildmodus"], ["LANGUAGE", "Sprache"], ["LIVE", "Live"], ["LOOP", "Schleife"], ["MORE_SETTINGS", "Weitere Einstellungen"], ["MULTIPLE_LANGUAGES", "Mehrere Sprachen"], ["MUTE", "Stummschalten"], ["NOT_APPLICABLE", "Nicht zutreffend"], ["OFF", "Aus"], ["ON", "Ein"], ["PAUSE", "Pause"], ["PICTURE_IN_PICTURE", "Bild im Bild"], ["PLAY", "Wiedergabe"], ["PLAYBACK_RATE", "Geschwindigkeit"], ["RESOLUTION", "Aufl\u00f6sung"], ["REWIND", "Zur\u00fcckspulen"], ["SEEK", "Suche"], ["SKIP_AD", "\u00dcberspringen"], ["SKIP_TO_LIVE", "Zum Live-Videostream wechseln"], ["UNDETERMINED_LANGUAGE", "Unbestimmt"], ["UNMUTE", "Stummschaltung aufheben"], ["UNRECOGNIZED_LANGUAGE", "Unbekannt"], ["VOLUME", "Lautst\u00e4rke"]]));
      a.xa("en", new Map([["AD_DURATION", "Ad duration"], ["AD_PROGRESS", "Ad [AD_ON] of [NUM_ADS]"], ["AD_TIME", "Ad: [AD_TIME]"], ["AIRPLAY", "AirPlay"], ["AUTO_QUALITY", "Auto"], ["BACK", "Back"], ["CAPTIONS", "Captions"], ["CAST", "Cast..."], ["ENTER_LOOP_MODE", "Loop the current video"], ["ENTER_PICTURE_IN_PICTURE", "Enter Picture-in-Picture"], ["EXIT_FULL_SCREEN", "Exit full screen"], ["EXIT_LOOP_MODE", "Stop looping the current video"], ["EXIT_PICTURE_IN_PICTURE", "Exit Picture-in-Picture"], ["FAST_FORWARD", "Fast-forward"], ["FULL_SCREEN", "Full screen"], ["LANGUAGE", "Language"], ["LIVE", "Live"], ["LOOP", "Loop"], ["MORE_SETTINGS", "More settings"], ["MULTIPLE_LANGUAGES", "Multiple languages"], ["MUTE", "Mute"], ["NOT_APPLICABLE", "Not applicable"], ["OFF", "Off"], ["ON", "On"], ["PAUSE", "Pause"], ["PICTURE_IN_PICTURE", "Picture-in-Picture"], ["PLAY", "Play"], ["PLAYBACK_RATE", "Playback speed"], ["QUALITY", "Quality"], ["REPLAY", "Replay"], ["RESOLUTION", "Resolution"], ["REWIND", "Rewind"], ["SEEK", "Seek"], ["SKIP_AD", "Skip Ad"], ["SKIP_TO_LIVE", "Skip ahead to live"], ["STATISTICS", "Statistics"], ["SUBTITLE_FORCED", "Forced"], ["SURROUND", "Surround"], ["UNDETERMINED_LANGUAGE", "Undetermined"], ["UNMUTE", "Unmute"], ["UNRECOGNIZED_LANGUAGE", "Unrecognized"], ["VOLUME", "Volume"]]));
      a.xa("en-GB", new Map([["AD_DURATION", "Ad duration"], ["AD_PROGRESS", "Ad [AD_ON] of [NUM_ADS]"], ["AD_TIME", "Ad: [AD_TIME]"], ["AUTO_QUALITY", "Auto"], ["BACK", "Back"], ["CAPTIONS", "Captions"], ["CAST", "Cast..."], ["ENTER_LOOP_MODE", "Loop the current video"], ["ENTER_PICTURE_IN_PICTURE", "Enter picture-in-picture"], ["EXIT_FULL_SCREEN", "Exit full screen"], ["EXIT_LOOP_MODE", "Stop looping the current video"], ["EXIT_PICTURE_IN_PICTURE", "Exit picture-in-picture"], ["FAST_FORWARD", "Fast-forward"], ["FULL_SCREEN", "Full screen"], ["LANGUAGE", "Language"], ["LIVE", "Live"], ["LOOP", "Loop"], ["MORE_SETTINGS", "More settings"], ["MULTIPLE_LANGUAGES", "Multiple languages"], ["MUTE", "Mute"], ["NOT_APPLICABLE", "Not applicable"], ["OFF", "Off"], ["ON", "On"], ["PAUSE", "Pause"], ["PICTURE_IN_PICTURE", "Picture-in-picture"], ["PLAY", "Play"], ["PLAYBACK_RATE", "Playback speed"], ["RESOLUTION", "Resolution"], ["REWIND", "Rewind"], ["SEEK", "Seek"], ["SKIP_AD", "Skip ad"], ["SKIP_TO_LIVE", "Skip ahead to live"], ["UNDETERMINED_LANGUAGE", "Undetermined"], ["UNMUTE", "Unmute"], ["UNRECOGNIZED_LANGUAGE", "Unrecognised"], ["VOLUME", "volume"]]));
      a.xa("es", new Map([["AD_DURATION", "Duraci\u00f3n del anuncio"], ["AD_PROGRESS", "Anuncio [AD_ON] de [NUM_ADS]"], ["AD_TIME", "Anuncio: [AD_TIME]"], ["AUTO_QUALITY", "Autom\u00e1tico"], ["BACK", "Atr\u00e1s"], ["CAPTIONS", "Subt\u00edtulos"], ["CAST", "Enviar..."], ["ENTER_LOOP_MODE", "Reproducir en bucle el v\u00eddeo actual"], ["ENTER_PICTURE_IN_PICTURE", "Activar el modo imagen en imagen"], ["EXIT_FULL_SCREEN", "Salir del modo de pantalla completa"], ["EXIT_LOOP_MODE", "Dejar de reproducir en bucle el v\u00eddeo actual"], ["EXIT_PICTURE_IN_PICTURE", "Salir del modo imagen en imagen"], ["FAST_FORWARD", "Avanzar r\u00e1pidamente"], ["FULL_SCREEN", "Pantalla completa"], ["LANGUAGE", "Idioma"], ["LIVE", "En directo"], ["LOOP", "Reproducir en bucle"], ["MORE_SETTINGS", "M\u00e1s ajustes"], ["MULTIPLE_LANGUAGES", "Varios idiomas"], ["MUTE", "Silenciar"], ["NOT_APPLICABLE", "No aplicable"], ["OFF", "Desactivado"], ["ON", "Activado"], ["PAUSE", "Pausar"], ["PICTURE_IN_PICTURE", "Imagen en imagen"], ["PLAY", "Reproducir"], ["PLAYBACK_RATE", "Velocidad de reproducci\u00f3n"], ["RESOLUTION", "Resoluci\u00f3n"], ["REWIND", "Rebobinar"], ["SEEK", "Buscar"], ["SKIP_AD", "Saltar anuncio"], ["SKIP_TO_LIVE", "Ir al v\u00eddeo en directo"], ["SUBTITLE_FORCED", "Forzado"], ["SURROUND", "Envolvente"], ["UNDETERMINED_LANGUAGE", "Sin especificar"], ["UNMUTE", "Activar sonido"], ["UNRECOGNIZED_LANGUAGE", "No reconocida"], ["VOLUME", "Volumen"]]));
      a.xa("es-419", new Map([["AD_DURATION", "Duraci\u00f3n del anuncio"], ["AD_PROGRESS", "Anuncio [AD_ON] de [NUM_ADS]"], ["AD_TIME", "Anuncio: [AD_TIME]"], ["AUTO_QUALITY", "Autom\u00e1tico"], ["BACK", "Atr\u00e1s"], ["CAPTIONS", "Subt\u00edtulos"], ["CAST", "Transmitir..."], ["ENTER_LOOP_MODE", "Repetir indefinidamente el video actual"], ["ENTER_PICTURE_IN_PICTURE", "Ingresar al modo de pantalla en pantalla"], ["EXIT_FULL_SCREEN", "Salir de pantalla completa"], ["EXIT_LOOP_MODE", "Detener la repetici\u00f3n indefinida del video actual"], ["EXIT_PICTURE_IN_PICTURE", "Salir del modo de pantalla en pantalla"], ["FAST_FORWARD", "Avanzar"], ["FULL_SCREEN", "Pantalla completa"], ["LANGUAGE", "Idioma"], ["LIVE", "En directo"], ["LOOP", "Repetir indefinidamente"], ["MORE_SETTINGS", "M\u00e1s opciones de configuraci\u00f3n"], ["MULTIPLE_LANGUAGES", "Varios idiomas"], ["MUTE", "Silenciar"], ["NOT_APPLICABLE", "No aplicable"], ["OFF", "Desactivado"], ["ON", "Activado"], ["PAUSE", "Detener"], ["PICTURE_IN_PICTURE", "Pantalla en pantalla"], ["PLAY", "Reproducir"], ["PLAYBACK_RATE", "Velocidad de reproducci\u00f3n"], ["RESOLUTION", "Resoluci\u00f3n"], ["REWIND", "Retroceder"], ["SEEK", "Buscar"], ["SKIP_AD", "Omitir anuncio"], ["SKIP_TO_LIVE", "Adelantar hasta la transmisi\u00f3n en vivo"], ["SUBTITLE_FORCED", "Forzado"], ["SURROUND", "Envolvente"], ["UNDETERMINED_LANGUAGE", "Sin especificar"], ["UNMUTE", "Dejar de silenciar"], ["UNRECOGNIZED_LANGUAGE", "No reconocida"], ["VOLUME", "Volumen"]]));
      a.xa("fr", new Map([["AD_DURATION", "Dur\u00e9e de l'annonce"], ["AD_PROGRESS", "Annonce\u00a0[AD_ON] sur\u00a0[NUM_ADS]"], ["AD_TIME", "Annonce\u00a0: [AD_TIME]"], ["AUTO_QUALITY", "Automatique"], ["BACK", "Retour"], ["CAPTIONS", "Sous-titres"], ["CAST", "Caster\u2026"], ["ENTER_LOOP_MODE", "Lire en boucle la vid\u00e9o en cours"], ["ENTER_PICTURE_IN_PICTURE", "Utiliser le mode Picture-in-Picture"], ["EXIT_FULL_SCREEN", "Quitter le mode plein \u00e9cran"], ["EXIT_LOOP_MODE", "Arr\u00eater la lecture en boucle de la vid\u00e9o en cours"], ["EXIT_PICTURE_IN_PICTURE", "Quitter le mode\u00a0PIP (Picture-in-picture)"], ["FAST_FORWARD", "Avance rapide"], ["FULL_SCREEN", "Plein \u00e9cran"], ["LANGUAGE", "Langue"], ["LIVE", "En direct"], ["LOOP", "R\u00e9p\u00e9ter"], ["MORE_SETTINGS", "Plus de param\u00e8tres"], ["MULTIPLE_LANGUAGES", "Plusieurs langues"], ["MUTE", "Couper le son"], ["NOT_APPLICABLE", "Non applicable"], ["OFF", "D\u00e9sactiv\u00e9e"], ["ON", "Activ\u00e9e"], ["PAUSE", "Pause"], ["PICTURE_IN_PICTURE", "Picture-in-Picture"], ["PLAY", "Visionner"], ["PLAYBACK_RATE", "Vitesse de lecture"], ["RESOLUTION", "R\u00e9solution"], ["REWIND", "Retour arri\u00e8re"], ["SEEK", "Chercher"], ["SKIP_AD", "Passer l'annonce"], ["SKIP_TO_LIVE", "Acc\u00e9der \u00e0 la partie la plus r\u00e9cente du direct"], ["UNDETERMINED_LANGUAGE", "Langue ind\u00e9termin\u00e9e"], ["UNMUTE", "R\u00e9activer le son"], ["UNRECOGNIZED_LANGUAGE", "Non reconnu"], ["VOLUME", "Volume"]]));
      a.xa("it", new Map([["AD_DURATION", "Durata dell'annuncio"], ["AD_PROGRESS", "Annuncio [AD_ON] di [NUM_ADS]"], ["AD_TIME", "Annuncio: [AD_TIME]"], ["AUTO_QUALITY", "Automatica"], ["BACK", "Indietro"], ["CAPTIONS", "Sottotitoli"], ["CAST", "Trasmetti..."], ["ENTER_LOOP_MODE", "Riproduci in loop il video corrente"], ["ENTER_PICTURE_IN_PICTURE", "Attiva Picture in picture"], ["EXIT_FULL_SCREEN", "Esci da schermo intero"], ["EXIT_LOOP_MODE", "Interrompi riproduzione in loop del video corrente"], ["EXIT_PICTURE_IN_PICTURE", "Esci da Picture in picture"], ["FAST_FORWARD", "Avanti veloce"], ["FULL_SCREEN", "Schermo intero"], ["LANGUAGE", "Lingua"], ["LIVE", "Dal vivo"], ["LOOP", "Riproduci in loop"], ["MORE_SETTINGS", "Altre impostazioni"], ["MULTIPLE_LANGUAGES", "Pi\u00f9 lingue"], ["MUTE", "Disattiva audio"], ["NOT_APPLICABLE", "Non applicabile"], ["OFF", "Disattivo"], ["ON", "Attivo"], ["PAUSE", "Metti in pausa"], ["PICTURE_IN_PICTURE", "Picture in picture"], ["PLAY", "Riproduci"], ["PLAYBACK_RATE", "Velocit\u00e0 di riproduzione"], ["RESOLUTION", "Risoluzione"], ["REWIND", "Riavvolgi"], ["SEEK", "Cerca"], ["SKIP_AD", "Salta annuncio"], ["SKIP_TO_LIVE", "Passa alla trasmissione dal vivo"], ["UNDETERMINED_LANGUAGE", "Indeterminata"], ["UNMUTE", "Riattiva audio"], ["UNRECOGNIZED_LANGUAGE", "Non riconosciuto"], ["VOLUME", "Volume"]]));
      a.xa("ja", new Map([["AD_DURATION", "\u5e83\u544a\u518d\u751f\u6642\u9593"], ["AD_PROGRESS", "[AD_ON] \u756a\u76ee\u306e\u5e83\u544a\uff08\u5168 [NUM_ADS] \u500b\uff09"], ["AD_TIME", "\u5e83\u544a: [AD_TIME]"], ["AUTO_QUALITY", "\u81ea\u52d5"], ["BACK", "\u623b\u308b"], ["CAPTIONS", "\u5b57\u5e55"], ["CAST", "\u30ad\u30e3\u30b9\u30c8..."], ["ENTER_LOOP_MODE", "\u73fe\u5728\u306e\u52d5\u753b\u3092\u30eb\u30fc\u30d7\u518d\u751f"], ["ENTER_PICTURE_IN_PICTURE", "\u30d4\u30af\u30c1\u30e3\u30fc \u30a4\u30f3 \u30d4\u30af\u30c1\u30e3\u30fc\u3092\u958b\u59cb"], ["EXIT_FULL_SCREEN", "\u5168\u753b\u9762\u8868\u793a\u3092\u7d42\u4e86"], ["EXIT_LOOP_MODE", "\u73fe\u5728\u306e\u52d5\u753b\u306e\u30eb\u30fc\u30d7\u518d\u751f\u3092\u505c\u6b62"], ["EXIT_PICTURE_IN_PICTURE", "\u30d4\u30af\u30c1\u30e3\u30fc \u30a4\u30f3 \u30d4\u30af\u30c1\u30e3\u30fc\u3092\u7d42\u4e86"], ["FAST_FORWARD", "\u65e9\u9001\u308a"], ["FULL_SCREEN", "\u5168\u753b\u9762\u8868\u793a"], ["LANGUAGE", "\u8a00\u8a9e"], ["LIVE", "\u30e9\u30a4\u30d6"], ["LOOP", "\u30eb\u30fc\u30d7"], ["MORE_SETTINGS", "\u8a73\u7d30\u8a2d\u5b9a"], ["MULTIPLE_LANGUAGES", "\u591a\u8a00\u8a9e"], ["MUTE", "\u30df\u30e5\u30fc\u30c8"], ["NOT_APPLICABLE", "\u8a72\u5f53\u306a\u3057"], ["OFF", "\u30aa\u30d5"], ["ON", "\u30aa\u30f3"], ["PAUSE", "\u4e00\u6642\u505c\u6b62"], ["PICTURE_IN_PICTURE", "\u30d4\u30af\u30c1\u30e3\u30fc \u30a4\u30f3 \u30d4\u30af\u30c1\u30e3\u30fc"], ["PLAY", "\u518d\u751f"], ["PLAYBACK_RATE", "\u518d\u751f\u901f\u5ea6"], ["RESOLUTION", "\u89e3\u50cf\u5ea6"], ["REWIND", "\u5dfb\u304d\u623b\u3057"], ["SEEK", "\u30b7\u30fc\u30af\u518d\u751f"], ["SKIP_AD", "\u5e83\u544a\u3092\u30b9\u30ad\u30c3\u30d7"], ["SKIP_TO_LIVE", "\u30e9\u30a4\u30d6\u914d\u4fe1\u307e\u3067\u30b9\u30ad\u30c3\u30d7"], ["UNDETERMINED_LANGUAGE", "\u4e0d\u660e"], ["UNMUTE", "\u30df\u30e5\u30fc\u30c8\u3092\u89e3\u9664"], ["UNRECOGNIZED_LANGUAGE", "\u4e0d\u660e"], ["VOLUME", "\u97f3\u91cf"]]));
      a.xa("ko", new Map([["AD_DURATION", "\uad11\uace0 \uae30\uac04"], ["AD_PROGRESS", "\uad11\uace0 [AD_ON]/[NUM_ADS]"], ["AD_TIME", "\uad11\uace0: [AD_TIME]"], ["AUTO_QUALITY", "\uc790\ub3d9"], ["BACK", "\ub4a4\ub85c"], ["CAPTIONS", "\uc790\ub9c9"], ["CAST", "\uc804\uc1a1..."], ["ENTER_LOOP_MODE", "\ud604\uc7ac \ub3d9\uc601\uc0c1 \ubc18\ubcf5 \uc7ac\uc0dd"], ["ENTER_PICTURE_IN_PICTURE", "PIP \ubaa8\ub4dc \uc2dc\uc791"], ["EXIT_FULL_SCREEN", "\uc804\uccb4\ud654\uba74 \ub2eb\uae30"], ["EXIT_LOOP_MODE", "\ud604\uc7ac \ub3d9\uc601\uc0c1 \ubc18\ubcf5 \uc7ac\uc0dd \uc911\uc9c0"], ["EXIT_PICTURE_IN_PICTURE", "PIP \ubaa8\ub4dc \uc885\ub8cc"], ["FAST_FORWARD", "\ube68\ub9ac \uac10\uae30"], ["FULL_SCREEN", "\uc804\uccb4\ud654\uba74"], ["LANGUAGE", "\uc5b8\uc5b4"], ["LIVE", "\uc2e4\uc2dc\uac04"], ["LOOP", "\ubc18\ubcf5 \uc7ac\uc0dd"], ["MORE_SETTINGS", "\uc124\uc815 \ub354\ubcf4\uae30"], ["MULTIPLE_LANGUAGES", "\uc5ec\ub7ec \uc5b8\uc5b4"], ["MUTE", "\uc74c\uc18c\uac70"], ["NOT_APPLICABLE", "\ud574\ub2f9 \uc0ac\ud56d \uc5c6\uc74c"], ["OFF", "\uc0ac\uc6a9 \uc548\ud568"], ["ON", "\uc0ac\uc6a9"], ["PAUSE", "\uc77c\uc2dc\uc911\uc9c0"], ["PICTURE_IN_PICTURE", "PIP \ubaa8\ub4dc"], ["PLAY", "\uc7ac\uc0dd"], ["PLAYBACK_RATE", "\uc7ac\uc0dd \uc18d\ub3c4"], ["RESOLUTION", "\ud574\uc0c1\ub3c4"], ["REWIND", "\ub418\uac10\uae30"], ["SEEK", "\ucc3e\uae30"], ["SKIP_AD", "\uad11\uace0 \uac74\ub108\ub6f0\uae30"], ["SKIP_TO_LIVE", "\ub77c\uc774\ube0c \ub3d9\uc601\uc0c1\uc73c\ub85c \uac74\ub108\ub6f0\uae30"], ["UNDETERMINED_LANGUAGE", "\ubbf8\uc815"], ["UNMUTE", "\uc74c\uc18c\uac70 \ud574\uc81c"], ["UNRECOGNIZED_LANGUAGE", "\uc54c \uc218 \uc5c6\uc74c"], ["VOLUME", "\ubcfc\ub968"]]));
      a.xa("nl", new Map([["AD_DURATION", "Advertentieduur"], ["AD_PROGRESS", "Advertentie [AD_ON] van [NUM_ADS]"], ["AD_TIME", "Advertentie: [AD_TIME]"], ["AUTO_QUALITY", "Automatisch"], ["BACK", "Terug"], ["CAPTIONS", "Ondertiteling"], ["CAST", "Casten..."], ["ENTER_LOOP_MODE", "De huidige video lussen"], ["ENTER_PICTURE_IN_PICTURE", "Scherm-in-scherm openen"], ["EXIT_FULL_SCREEN", "Volledig scherm sluiten"], ["EXIT_LOOP_MODE", "De huidige video niet meer lussen"], ["EXIT_PICTURE_IN_PICTURE", "Scherm-in-scherm afsluiten"], ["FAST_FORWARD", "Vooruitspoelen"], ["FULL_SCREEN", "Volledig scherm"], ["LANGUAGE", "Taal"], ["LIVE", "Live"], ["LOOP", "Lussen"], ["MORE_SETTINGS", "Meer instellingen"], ["MULTIPLE_LANGUAGES", "Meerdere talen"], ["MUTE", "Dempen"], ["NOT_APPLICABLE", "Niet van toepassing"], ["OFF", "Uit"], ["ON", "Aan"], ["PAUSE", "Onderbreken"], ["PICTURE_IN_PICTURE", "Scherm-in-scherm"], ["PLAY", "Afspelen"], ["PLAYBACK_RATE", "Afspeelsnelheid"], ["RESOLUTION", "Resolutie"], ["REWIND", "Terugspoelen"], ["SEEK", "Zoeken"], ["SKIP_AD", "Advertentie overslaan"], ["SKIP_TO_LIVE", "Doorgaan naar live"], ["UNDETERMINED_LANGUAGE", "Onbepaald"], ["UNMUTE", "Dempen opheffen"], ["UNRECOGNIZED_LANGUAGE", "Onbekend"], ["VOLUME", "Volume"]]));
      a.xa("pl", new Map([["AD_DURATION", "Czas trwania reklamy"], ["AD_PROGRESS", "Reklama\u00a0[AD_ON] z\u00a0[NUM_ADS]"], ["AD_TIME", "Reklama: [AD_TIME]"], ["AUTO_QUALITY", "Automatycznie"], ["BACK", "Wstecz"], ["CAPTIONS", "Napisy"], ["CAST", "Przesy\u0142aj..."], ["ENTER_LOOP_MODE", "Odtwarzaj bie\u017c\u0105cy film w\u00a0p\u0119tli"], ["ENTER_PICTURE_IN_PICTURE", "W\u0142\u0105cz tryb obrazu w\u00a0obrazie"], ["EXIT_FULL_SCREEN", "Zamknij pe\u0142ny ekran"], ["EXIT_LOOP_MODE", "Wy\u0142\u0105cz odtwarzanie bie\u017c\u0105cego filmu w\u00a0p\u0119tli"], ["EXIT_PICTURE_IN_PICTURE", "Wy\u0142\u0105cz tryb obrazu w\u00a0obrazie"], ["FAST_FORWARD", "Przewi\u0144 do przodu"], ["FULL_SCREEN", "Pe\u0142ny ekran"], ["LANGUAGE", "J\u0119zyk"], ["LIVE", "Na \u017cywo"], ["LOOP", "Odtwarzaj w\u00a0p\u0119tli"], ["MORE_SETTINGS", "Wi\u0119cej ustawie\u0144"], ["MULTIPLE_LANGUAGES", "Wiele j\u0119zyk\u00f3w"], ["MUTE", "Wycisz"], ["NOT_APPLICABLE", "Nie dotyczy"], ["OFF", "Wy\u0142\u0105czone"], ["ON", "W\u0142\u0105czone"], ["PAUSE", "Wstrzymaj"], ["PICTURE_IN_PICTURE", "Obraz w\u00a0obrazie"], ["PLAY", "Odtw\u00f3rz"], ["PLAYBACK_RATE", "Szybko\u015b\u0107 odtwarzania"], ["RESOLUTION", "Rozdzielczo\u015b\u0107"], ["REWIND", "Przewi\u0144 do ty\u0142u"], ["SEEK", "Szukaj"], ["SKIP_AD", "Pomi\u0144 reklam\u0119"], ["SKIP_TO_LIVE", "Przejd\u017a do transmisji na \u017cywo"], ["UNDETERMINED_LANGUAGE", "Nie okre\u015blono"], ["UNMUTE", "Wy\u0142\u0105cz wyciszenie"], ["UNRECOGNIZED_LANGUAGE", "Nierozpoznany"], ["VOLUME", "G\u0142o\u015bno\u015b\u0107"]]));
      a.xa("pt-BR", new Map([["AD_DURATION", "Dura\u00e7\u00e3o do an\u00fancio"], ["AD_PROGRESS", "An\u00fancio [AD_ON] de [NUM_ADS]"], ["AD_TIME", "An\u00fancio: [AD_TIME]"], ["AUTO_QUALITY", "Autom\u00e1tica"], ["BACK", "Voltar"], ["CAPTIONS", "Legendas"], ["CAST", "Transmitir..."], ["ENTER_LOOP_MODE", "Repetir o v\u00eddeo atual"], ["ENTER_PICTURE_IN_PICTURE", "Entrar no modo picture-in-picture"], ["EXIT_FULL_SCREEN", "Sair do modo tela cheia"], ["EXIT_LOOP_MODE", "Parar repeti\u00e7\u00e3o do v\u00eddeo atual"], ["EXIT_PICTURE_IN_PICTURE", "Sair de picture-in-picture"], ["FAST_FORWARD", "Avan\u00e7ar"], ["FULL_SCREEN", "Tela cheia"], ["LANGUAGE", "Idioma"], ["LIVE", "Ao vivo"], ["LOOP", "Repetir"], ["MORE_SETTINGS", "Mais defini\u00e7\u00f5es"], ["MULTIPLE_LANGUAGES", "V\u00e1rios idiomas"], ["MUTE", "Desativar som"], ["NOT_APPLICABLE", "N\u00e3o relevante"], ["OFF", "Desativado"], ["ON", "Ativado"], ["PAUSE", "Pausar"], ["PICTURE_IN_PICTURE", "Picture-in-picture"], ["PLAY", "Reproduzir"], ["PLAYBACK_RATE", "Velocidade da reprodu\u00e7\u00e3o"], ["RESOLUTION", "Resolu\u00e7\u00e3o"], ["REWIND", "Retroceder"], ["SEEK", "Procurar"], ["SKIP_AD", "Pular an\u00fancio"], ["SKIP_TO_LIVE", "Pular para transmiss\u00e3o ao vivo"], ["UNDETERMINED_LANGUAGE", "Indeterminado"], ["UNMUTE", "Ativar som"], ["UNRECOGNIZED_LANGUAGE", "N\u00e3o reconhecido"], ["VOLUME", "Volume"]]));
      a.xa("ru", new Map([["AD_DURATION", "\u041f\u0440\u043e\u0434\u043e\u043b\u0436\u0438\u0442\u0435\u043b\u044c\u043d\u043e\u0441\u0442\u044c \u0440\u0435\u043a\u043b\u0430\u043c\u044b"], ["AD_PROGRESS", "\u0420\u0435\u043a\u043b\u0430\u043c\u0430 [AD_ON] \u0438\u0437 [NUM_ADS]"], ["AD_TIME", "\u0420\u0435\u043a\u043b\u0430\u043c\u0430: [AD_TIME]"], ["AUTO_QUALITY", "\u0410\u0432\u0442\u043e"], ["BACK", "\u041d\u0430\u0437\u0430\u0434"], ["CAPTIONS", "\u0421\u0443\u0431\u0442\u0438\u0442\u0440\u044b"], ["CAST", "\u0422\u0440\u0430\u043d\u0441\u043b\u0438\u0440\u043e\u0432\u0430\u0442\u044c..."], ["ENTER_LOOP_MODE", "\u0417\u0430\u0446\u0438\u043a\u043b\u0438\u0442\u044c \u0442\u0435\u043a\u0443\u0449\u0435\u0435 \u0432\u0438\u0434\u0435\u043e"], ["ENTER_PICTURE_IN_PICTURE", '\u041f\u0435\u0440\u0435\u0439\u0442\u0438 \u0432 \u0440\u0435\u0436\u0438\u043c "\u041a\u0430\u0440\u0442\u0438\u043d\u043a\u0430 \u0432 \u043a\u0430\u0440\u0442\u0438\u043d\u043a\u0435"'], ["EXIT_FULL_SCREEN", "\u041e\u0431\u044b\u0447\u043d\u044b\u0439 \u0440\u0435\u0436\u0438\u043c"], ["EXIT_LOOP_MODE", "\u041e\u0442\u043c\u0435\u043d\u0438\u0442\u044c \u0437\u0430\u0446\u0438\u043a\u043b\u0438\u0432\u0430\u043d\u0438\u0435 \u0442\u0435\u043a\u0443\u0449\u0435\u0433\u043e \u0432\u0438\u0434\u0435\u043e"], ["EXIT_PICTURE_IN_PICTURE", '\u0412\u044b\u0439\u0442\u0438 \u0438\u0437 \u0440\u0435\u0436\u0438\u043c\u0430 "\u041a\u0430\u0440\u0442\u0438\u043d\u043a\u0430 \u0432 \u043a\u0430\u0440\u0442\u0438\u043d\u043a\u0435"'], ["FAST_FORWARD", "\u041f\u0435\u0440\u0435\u043c\u043e\u0442\u043a\u0430 \u0432\u043f\u0435\u0440\u0435\u0434"], ["FULL_SCREEN", "\u041f\u043e\u043b\u043d\u043e\u044d\u043a\u0440\u0430\u043d\u043d\u044b\u0439 \u0440\u0435\u0436\u0438\u043c"], ["LANGUAGE", "\u042f\u0437\u044b\u043a"], ["LIVE", "\u041f\u0440\u044f\u043c\u043e\u0439 \u044d\u0444\u0438\u0440"], ["LOOP", "\u0417\u0430\u0446\u0438\u043a\u043b\u0438\u0442\u044c"], ["MORE_SETTINGS", "\u0414\u043e\u043f\u043e\u043b\u043d\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0435 \u043d\u0430\u0441\u0442\u0440\u043e\u0439\u043a\u0438"], ["MULTIPLE_LANGUAGES", "\u041d\u0435\u0441\u043a\u043e\u043b\u044c\u043a\u043e \u044f\u0437\u044b\u043a\u043e\u0432"], ["MUTE", "\u041e\u0442\u043a\u043b\u044e\u0447\u0438\u0442\u044c \u0437\u0432\u0443\u043a"], ["NOT_APPLICABLE", "\u041d\u0435\u043f\u0440\u0438\u043c\u0435\u043d\u0438\u043c\u043e"], ["OFF", "\u0412\u044b\u043a\u043b."], ["ON", "\u0412\u043a\u043b."], ["PAUSE", "\u041f\u0430\u0443\u0437\u0430"], ["PICTURE_IN_PICTURE", "\u041a\u0430\u0440\u0442\u0438\u043d\u043a\u0430 \u0432 \u043a\u0430\u0440\u0442\u0438\u043d\u043a\u0435"], ["PLAY", "\u0412\u043e\u0441\u043f\u0440\u043e\u0438\u0437\u0432\u0435\u0441\u0442\u0438"], ["PLAYBACK_RATE", "\u0421\u043a\u043e\u0440\u043e\u0441\u0442\u044c \u0432\u043e\u0441\u043f\u0440\u043e\u0438\u0437\u0432\u0435\u0434\u0435\u043d\u0438\u044f"], ["RESOLUTION", "\u0420\u0430\u0437\u0440\u0435\u0448\u0435\u043d\u0438\u0435"], ["REWIND", "\u041f\u0435\u0440\u0435\u043c\u043e\u0442\u0430\u0442\u044c \u043d\u0430\u0437\u0430\u0434"], ["SEEK", "\u041f\u0435\u0440\u0435\u043c\u043e\u0442\u043a\u0430"], ["SKIP_AD", "\u041f\u0440\u043e\u043f\u0443\u0441\u0442\u0438\u0442\u044c"], ["SKIP_TO_LIVE", "\u041f\u0440\u043e\u043f\u0443\u0441\u0442\u0438\u0442\u044c \u0438 \u043f\u0435\u0440\u0435\u0439\u0442\u0438 \u043a \u043f\u0440\u044f\u043c\u043e\u0439 \u0442\u0440\u0430\u043d\u0441\u043b\u044f\u0446\u0438\u0438"], ["UNDETERMINED_LANGUAGE", "\u041d\u0435 \u0443\u043a\u0430\u0437\u0430\u043d\u043e"], ["UNMUTE", "\u0412\u043a\u043b\u044e\u0447\u0438\u0442\u044c \u0437\u0432\u0443\u043a"], ["UNRECOGNIZED_LANGUAGE", "\u041d\u0435 \u0440\u0430\u0441\u043f\u043e\u0437\u043d\u0430\u043d\u043e"], ["VOLUME", "\u0413\u0440\u043e\u043c\u043a\u043e\u0441\u0442\u044c"]]));
      a.xa("th", new Map([["AD_DURATION", "\u0e23\u0e30\u0e22\u0e30\u0e40\u0e27\u0e25\u0e32\u0e42\u0e06\u0e29\u0e13\u0e32"], ["AD_PROGRESS", "\u0e42\u0e06\u0e29\u0e13\u0e32 [AD_ON] \u0e08\u0e32\u0e01 [NUM_ADS] \u0e23\u0e32\u0e22\u0e01\u0e32\u0e23"], ["AD_TIME", "\u0e42\u0e06\u0e29\u0e13\u0e32: [AD_TIME]"], ["AUTO_QUALITY", "\u0e2d\u0e31\u0e15\u0e42\u0e19\u0e21\u0e31\u0e15\u0e34"], ["BACK", "\u0e01\u0e25\u0e31\u0e1a"], ["CAPTIONS", "\u0e04\u0e33\u0e1a\u0e23\u0e23\u0e22\u0e32\u0e22"], ["CAST", "\u0e41\u0e04\u0e2a\u0e15\u0e4c..."], ["ENTER_LOOP_MODE", "\u0e27\u0e19\u0e0b\u0e49\u0e33\u0e27\u0e34\u0e14\u0e35\u0e42\u0e2d\u0e1b\u0e31\u0e08\u0e08\u0e38\u0e1a\u0e31\u0e19"], ["ENTER_PICTURE_IN_PICTURE", "\u0e40\u0e02\u0e49\u0e32\u0e2a\u0e39\u0e48\u0e01\u0e32\u0e23\u0e41\u0e2a\u0e14\u0e07\u0e20\u0e32\u0e1e\u0e0b\u0e49\u0e2d\u0e19\u0e20\u0e32\u0e1e"], ["EXIT_FULL_SCREEN", "\u0e2d\u0e2d\u0e01\u0e08\u0e32\u0e01\u0e01\u0e32\u0e23\u0e41\u0e2a\u0e14\u0e07\u0e41\u0e1a\u0e1a\u0e40\u0e15\u0e47\u0e21\u0e2b\u0e19\u0e49\u0e32\u0e08\u0e2d"], ["EXIT_LOOP_MODE", "\u0e2b\u0e22\u0e38\u0e14\u0e27\u0e19\u0e0b\u0e49\u0e33\u0e27\u0e34\u0e14\u0e35\u0e42\u0e2d\u0e1b\u0e31\u0e08\u0e08\u0e38\u0e1a\u0e31\u0e19"], ["EXIT_PICTURE_IN_PICTURE", "\u0e2d\u0e2d\u0e01\u0e08\u0e32\u0e01\u0e01\u0e32\u0e23\u0e41\u0e2a\u0e14\u0e07\u0e20\u0e32\u0e1e\u0e0b\u0e49\u0e2d\u0e19\u0e20\u0e32\u0e1e"], ["FAST_FORWARD", "\u0e01\u0e23\u0e2d\u0e44\u0e1b\u0e02\u0e49\u0e32\u0e07\u0e2b\u0e19\u0e49\u0e32"], ["FULL_SCREEN", "\u0e40\u0e15\u0e47\u0e21\u0e2b\u0e19\u0e49\u0e32\u0e08\u0e2d"], ["LANGUAGE", "\u0e20\u0e32\u0e29\u0e32"], ["LIVE", "\u0e2a\u0e14"], ["LOOP", "\u0e25\u0e39\u0e1b"], ["MORE_SETTINGS", "\u0e01\u0e32\u0e23\u0e15\u0e31\u0e49\u0e07\u0e04\u0e48\u0e32\u0e40\u0e1e\u0e34\u0e48\u0e21\u0e40\u0e15\u0e34\u0e21"], ["MULTIPLE_LANGUAGES", "\u0e2b\u0e25\u0e32\u0e22\u0e20\u0e32\u0e29\u0e32"], ["MUTE", "\u0e1b\u0e34\u0e14\u0e40\u0e2a\u0e35\u0e22\u0e07"], ["NOT_APPLICABLE", "\u0e44\u0e21\u0e48\u0e40\u0e01\u0e35\u0e48\u0e22\u0e27\u0e02\u0e49\u0e2d\u0e07"], ["OFF", "\u0e1b\u0e34\u0e14"], ["ON", "\u0e40\u0e1b\u0e34\u0e14"], ["PAUSE", "\u0e2b\u0e22\u0e38\u0e14\u0e0a\u0e31\u0e48\u0e27\u0e04\u0e23\u0e32\u0e27"], ["PICTURE_IN_PICTURE", "\u0e01\u0e32\u0e23\u0e41\u0e2a\u0e14\u0e07\u0e20\u0e32\u0e1e\u0e0b\u0e49\u0e2d\u0e19\u0e20\u0e32\u0e1e"], ["PLAY", "\u0e40\u0e25\u0e48\u0e19"], ["PLAYBACK_RATE", "\u0e04\u0e27\u0e32\u0e21\u0e40\u0e23\u0e47\u0e27\u0e43\u0e19\u0e01\u0e32\u0e23\u0e40\u0e25\u0e48\u0e19"], ["RESOLUTION", "\u0e04\u0e27\u0e32\u0e21\u0e25\u0e30\u0e40\u0e2d\u0e35\u0e22\u0e14"], ["REWIND", "\u0e01\u0e23\u0e2d\u0e01\u0e25\u0e31\u0e1a"], ["SEEK", "\u0e04\u0e49\u0e19\u0e2b\u0e32"], ["SKIP_AD", "\u0e02\u0e49\u0e32\u0e21\u0e42\u0e06\u0e29\u0e13\u0e32"], ["SKIP_TO_LIVE", "\u0e02\u0e49\u0e32\u0e21\u0e44\u0e1b\u0e17\u0e35\u0e48\u0e01\u0e32\u0e23\u0e16\u0e48\u0e32\u0e22\u0e17\u0e2d\u0e14\u0e2a\u0e14"], ["UNDETERMINED_LANGUAGE", "\u0e44\u0e21\u0e48\u0e01\u0e33\u0e2b\u0e19\u0e14"], ["UNMUTE", "\u0e40\u0e1b\u0e34\u0e14\u0e40\u0e2a\u0e35\u0e22\u0e07"], ["UNRECOGNIZED_LANGUAGE", "\u0e17\u0e35\u0e48\u0e44\u0e21\u0e48\u0e23\u0e39\u0e49\u0e08\u0e31\u0e01"], ["VOLUME", "\u0e23\u0e30\u0e14\u0e31\u0e1a\u0e40\u0e2a\u0e35\u0e22\u0e07"]]));
      a.xa("tr", new Map([["AD_DURATION", "Reklam s\u00fcresi"], ["AD_PROGRESS", "[AD_ON]/[NUM_ADS] reklam"], ["AD_TIME", "Reklam: [AD_TIME]"], ["AUTO_QUALITY", "Otomatik"], ["BACK", "Geri"], ["CAPTIONS", "Altyaz\u0131lar"], ["CAST", "Yay\u0131nla..."], ["ENTER_LOOP_MODE", "Mevcut videoyu d\u00f6ng\u00fcye al"], ["ENTER_PICTURE_IN_PICTURE", "Pencere i\u00e7inde Pencere moduna gir"], ["EXIT_FULL_SCREEN", "Tam ekrandan \u00e7\u0131k"], ["EXIT_LOOP_MODE", "Mevcut videonun d\u00f6ng\u00fcs\u00fcn\u00fc durdur"], ["EXIT_PICTURE_IN_PICTURE", "Pencere \u0130\u00e7inde Pencereden \u00c7\u0131k"], ["FAST_FORWARD", "\u0130leri sar"], ["FULL_SCREEN", "Tam ekran"], ["LANGUAGE", "Dil"], ["LIVE", "Canl\u0131"], ["LOOP", "D\u00f6ng\u00fc"], ["MORE_SETTINGS", "Daha fazla ayar"], ["MULTIPLE_LANGUAGES", "Birden \u00e7ok dil"], ["MUTE", "Sesi kapat"], ["NOT_APPLICABLE", "Ge\u00e7erli de\u011fil"], ["OFF", "Kapal\u0131"], ["ON", "A\u00e7\u0131k"], ["PAUSE", "Duraklat"], ["PICTURE_IN_PICTURE", "Pencere \u0130\u00e7inde Pencere"], ["PLAY", "Oynat"], ["PLAYBACK_RATE", "\u00c7alma h\u0131z\u0131"], ["RESOLUTION", "\u00c7\u00f6z\u00fcn\u00fcrl\u00fck"], ["REWIND", "Geri sar"], ["SEEK", "Ara"], ["SKIP_AD", "Reklam\u0131 Atla"], ["SKIP_TO_LIVE", "Canl\u0131 yay\u0131na atla"], ["UNDETERMINED_LANGUAGE", "Belirsiz"], ["UNMUTE", "Sesi a\u00e7"], ["UNRECOGNIZED_LANGUAGE", "Tan\u0131nmayan"], ["VOLUME", "Ses"]]));
      a.xa("zh", new Map([["AD_DURATION", "\u5e7f\u544a\u6301\u7eed\u65f6\u95f4"], ["AD_PROGRESS", "\u5e7f\u544a [AD_ON]/[NUM_ADS]"], ["AD_TIME", "\u5e7f\u544a\uff1a[AD_TIME]"], ["AUTO_QUALITY", "\u81ea\u52a8"], ["BACK", "\u8fd4\u56de"], ["CAPTIONS", "\u5b57\u5e55"], ["CAST", "\u6295\u5c04\u2026"], ["ENTER_LOOP_MODE", "\u5faa\u73af\u64ad\u653e\u5f53\u524d\u89c6\u9891"], ["ENTER_PICTURE_IN_PICTURE", "\u8fdb\u5165\u201c\u753b\u4e2d\u753b\u201d\u6a21\u5f0f"], ["EXIT_FULL_SCREEN", "\u9000\u51fa\u5168\u5c4f\u6a21\u5f0f"], ["EXIT_LOOP_MODE", "\u505c\u6b62\u5faa\u73af\u64ad\u653e\u5f53\u524d\u89c6\u9891"], ["EXIT_PICTURE_IN_PICTURE", "\u9000\u51fa\u201c\u753b\u4e2d\u753b\u201d\u6a21\u5f0f"], ["FAST_FORWARD", "\u5feb\u8fdb"], ["FULL_SCREEN", "\u5168\u5c4f"], ["LANGUAGE", "\u8bed\u8a00"], ["LIVE", "\u76f4\u64ad"], ["LOOP", "\u5faa\u73af\u64ad\u653e"], ["MORE_SETTINGS", "\u66f4\u591a\u8bbe\u7f6e"], ["MULTIPLE_LANGUAGES", "\u591a\u79cd\u8bed\u8a00"], ["MUTE", "\u9759\u97f3"], ["NOT_APPLICABLE", "\u4e0d\u9002\u7528"], ["OFF", "\u5173\u95ed"], ["ON", "\u5f00\u542f"], ["PAUSE", "\u6682\u505c"], ["PICTURE_IN_PICTURE", "\u753b\u4e2d\u753b"], ["PLAY", "\u64ad\u653e"], ["PLAYBACK_RATE", "\u64ad\u653e\u901f\u5ea6"], ["RESOLUTION", "\u5206\u8fa8\u7387"], ["REWIND", "\u5feb\u9000"], ["SEEK", "\u8fdb\u5ea6"], ["SKIP_AD", "\u8df3\u8fc7\u5e7f\u544a"], ["SKIP_TO_LIVE", "\u8df3\u81f3\u5f53\u524d\u76f4\u64ad"], ["UNDETERMINED_LANGUAGE", "\u672a\u786e\u5b9a"], ["UNMUTE", "\u53d6\u6d88\u9759\u97f3"], ["UNRECOGNIZED_LANGUAGE", "\u65e0\u6cd5\u8bc6\u522b"], ["VOLUME", "\u97f3\u91cf"]]));
      a.xa("zh-TW", new Map([["AD_DURATION", "\u5ee3\u544a\u9577\u5ea6"], ["AD_PROGRESS", "\u5ee3\u544a [AD_ON]/[NUM_ADS]"], ["AD_TIME", "\u5ee3\u544a\uff1a[AD_TIME]"], ["AUTO_QUALITY", "\u81ea\u52d5"], ["BACK", "\u8fd4\u56de"], ["CAPTIONS", "\u5b57\u5e55"], ["CAST", "\u6295\u653e..."], ["ENTER_LOOP_MODE", "\u5faa\u74b0\u64ad\u653e\u76ee\u524d\u7684\u5f71\u7247"], ["ENTER_PICTURE_IN_PICTURE", "\u9032\u5165\u5b50\u6bcd\u756b\u9762"], ["EXIT_FULL_SCREEN", "\u9000\u51fa\u5168\u87a2\u5e55\u6a21\u5f0f"], ["EXIT_LOOP_MODE", "\u505c\u6b62\u5faa\u74b0\u64ad\u653e\u76ee\u524d\u7684\u5f71\u7247"], ["EXIT_PICTURE_IN_PICTURE", "\u96e2\u958b\u5b50\u6bcd\u756b\u9762"], ["FAST_FORWARD", "\u5feb\u8f49"], ["FULL_SCREEN", "\u5168\u87a2\u5e55"], ["LANGUAGE", "\u8a9e\u8a00"], ["LIVE", "\u76f4\u64ad"], ["LOOP", "\u5faa\u74b0\u64ad\u653e"], ["MORE_SETTINGS", "\u986f\u793a\u66f4\u591a\u8a2d\u5b9a"], ["MULTIPLE_LANGUAGES", "\u591a\u7a2e\u8a9e\u8a00"], ["MUTE", "\u975c\u97f3"], ["NOT_APPLICABLE", "\u4e0d\u9069\u7528"], ["OFF", "\u95dc\u9589"], ["ON", "\u958b\u555f"], ["PAUSE", "\u66ab\u505c"], ["PICTURE_IN_PICTURE", "\u5b50\u6bcd\u756b\u9762"], ["PLAY", "\u64ad\u653e"], ["PLAYBACK_RATE", "\u64ad\u653e\u901f\u5ea6"], ["RESOLUTION", "\u89e3\u6790\u5ea6"], ["REWIND", "\u5012\u8f49"], ["SEEK", "\u641c\u5c0b"], ["SKIP_AD", "\u7565\u904e\u5ee3\u544a"], ["SKIP_TO_LIVE", "\u8df3\u81f3\u5f53\u524d\u76f4\u64ad"], ["UNDETERMINED_LANGUAGE", "\u4e0d\u660e"], ["UNMUTE", "\u53d6\u6d88\u975c\u97f3"], ["UNRECOGNIZED_LANGUAGE", "\u7121\u6cd5\u8fa8\u8b58"], ["VOLUME", "\u97f3\u91cf"]]));
      a.Bg(navigator.languages || []);
      return a;
    }

    M("shaka.ui.Controls", Z);
    Z.prototype.isOpaque = Z.prototype.sc;
    Z.prototype.hideAdUI = Z.prototype.Pg;
    Z.prototype.showAdUI = Z.prototype.nh;
    Z.prototype.togglePiP = Z.prototype.He;
    Z.prototype.isPiPEnabled = Z.prototype.Hf;
    Z.prototype.isPiPAllowed = Z.prototype.Nc;
    Z.prototype.toggleFullScreen = Z.prototype.Ge;
    Z.prototype.isFullScreenEnabled = Z.prototype.Mc;
    Z.prototype.isFullScreenSupported = Z.prototype.xd;
    Z.prototype.hideSettingsMenus = Z.prototype.pc;
    Z.prototype.anySettingsMenusAreOpen = Z.prototype.ld;
    Z.prototype.setLastTouchEventTime = Z.prototype.jh;
    Z.prototype.getDisplayTime = Z.prototype.Af;
    Z.prototype.isCastAllowed = Z.prototype.zi;
    Z.prototype.setSeeking = Z.prototype.kg;
    Z.prototype.isSeeking = Z.prototype.Fi;
    Z.prototype.getConfig = Z.prototype.Ph;
    Z.prototype.getClientSideAdContainer = Z.prototype.Oh;
    Z.prototype.getServerSideAdContainer = Z.prototype.ji;
    Z.prototype.getControlsContainer = Z.prototype.Rh;
    Z.prototype.getLocalPlayer = Z.prototype.Xh;
    Z.prototype.getPlayer = Z.prototype.Hc;
    Z.prototype.getLocalVideo = Z.prototype.Yh;
    Z.prototype.getVideo = Z.prototype.Yb;
    Z.prototype.getVideoContainer = Z.prototype.ri;
    Z.prototype.getLocalization = Z.prototype.Zh;
    Z.prototype.getCastProxy = Z.prototype.Nh;
    Z.prototype.getAd = Z.prototype.getAd;
    Z.prototype.setEnabledNativeControls = Z.prototype.ih;
    Z.prototype.setEnabledShakaControls = Z.prototype.gg;
    Z.prototype.configure = Z.prototype.configure;
    Z.prototype.loadComplete = Z.prototype.Hi;
    Z.prototype.allowCast = Z.prototype.Ch;

    Z.registerSeekBar = function (a) {
      uC = a;
    };

    Z.registerElement = cC;
    Z.prototype.destroy = Z.prototype.destroy;
    var dC = new Map(),
        uC = new WB();

    function BC(a, b) {
      nB.call(this, a, b);
      var c = this;
      this.l = this.controls.g;
      this.j = this.controls.h;
      this.i = [];
      this.g = el();
      this.g.classList.add("shaka-overflow-menu-button");
      this.g.classList.add("shaka-no-propagation");
      this.g.classList.add("material-icons-round");
      this.g.classList.add("shaka-tooltip");
      this.g.textContent = "more_vert";
      this.parent.appendChild(this.g);
      this.h = T("div");
      this.h.classList.add("shaka-overflow-menu");
      this.h.classList.add("shaka-no-propagation");
      this.h.classList.add("shaka-show-controls-on-mouse-over");
      this.h.classList.add("shaka-hidden");
      this.j.appendChild(this.h);
      CC(this);
      this.eventManager.o(this.localization, "locale-updated", function () {
        DC(c);
      });
      this.eventManager.o(this.localization, "locale-changed", function () {
        DC(c);
      });
      this.eventManager.o(this.adManager, "ad-started", function () {
        c.ad && c.ad.isLinear() && sB(c.g, !1);
      });
      this.eventManager.o(this.adManager, "ad-stopped", function () {
        sB(c.g, !0);
      });
      this.eventManager.o(this.controls, "submenuopen", function () {
        sB(c.h, !1);
      });
      this.eventManager.o(this.h, "touchstart", function (d) {
        c.controls.jh(Date.now());
        d.stopPropagation();
      });
      this.eventManager.o(this.g, "click", function () {
        EC(c);
      });
      DC(this);
      this.ad && this.ad.isLinear() && sB(this.g, !1);
    }

    pa(BC, nB);

    BC.prototype.release = function () {
      this.j = null;

      for (var a = t(this.i), b = a.next(); !b.done; b = a.next()) b.value.release();

      this.i = [];
      nB.prototype.release.call(this);
    };

    function FC(a, b) {
      GC.set(a, b);
    }

    function CC(a) {
      for (var b = t(a.l.overflowMenuButtons), c = b.next(); !c.done; c = b.next()) c = c.value, GC.get(c) ? (c = GC.get(c), a.i.push(c.create(a.h, a.controls))) : Ua("Unrecognized overflow menu element requested:", c);
    }

    function EC(a) {
      if (a.controls.ld()) a.controls.pc();else {
        sB(a.h, !0);
        XB(a.controls);

        var b = function (c) {
          return 0 == c.classList.contains("shaka-hidden");
        };

        gb(a.h.childNodes, b) && hb(a.h.childNodes, b)[0].focus();
      }
    }

    function DC(a) {
      a.g.ariaLabel = a.localization.resolve("MORE_SETTINGS");
    }

    M("shaka.ui.OverflowMenu", BC);
    BC.registerElement = FC;

    function HC() {}

    HC.prototype.create = function (a, b) {
      return new BC(a, b);
    };

    cC("overflow_menu", new HC());
    var GC = new Map();

    function IC(a, b) {
      nB.call(this, a, b);
      var c = this;
      this.g = el();
      this.g.classList.add("shaka-airplay-button");
      this.g.classList.add("shaka-tooltip");
      this.g.ariaPressed = "false";
      this.h = T("i");
      this.h.classList.add("material-icons-round");
      this.h.textContent = "airplay";
      this.g.appendChild(this.h);
      window.WebKitPlaybackTargetAvailabilityEvent || this.g.classList.add("shaka-hidden");
      a = T("label");
      a.classList.add("shaka-overflow-button-label");
      a.classList.add("shaka-overflow-menu-only");
      this.j = T("span");
      a.appendChild(this.j);
      this.i = T("span");
      this.i.classList.add("shaka-current-selection-span");
      a.appendChild(this.i);
      this.g.appendChild(a);
      this.parent.appendChild(this.g);
      JC(this);
      KC(this);
      this.eventManager.o(this.localization, "locale-updated", function () {
        JC(c);
      });
      this.eventManager.o(this.localization, "locale-changed", function () {
        JC(c);
      });
      this.eventManager.o(this.g, "click", function () {
        c.controls.Yb().webkitShowPlaybackTargetPicker();
      });
      a = this.controls.Yb();
      this.eventManager.o(a, "webkitplaybacktargetavailabilitychanged", function (d) {
        var e = c.player.ee() == ln;
        sB(c.g, "available" == d.availability && e);
      });
      this.eventManager.o(a, "webkitcurrentplaybacktargetiswirelesschanged", function () {
        KC(c);
      });
    }

    pa(IC, nB);

    function KC(a) {
      var b = a.controls.Yb();
      a.g.ariaPressed = b && b.webkitCurrentPlaybackTargetIsWireless ? "true" : "false";
    }

    function JC(a) {
      a.g.ariaLabel = a.localization.resolve("AIRPLAY");
      a.j.textContent = a.localization.resolve("AIRPLAY");
    }

    M("shaka.ui.AirPlayButton", IC);

    function LC() {}

    LC.prototype.create = function (a, b) {
      return new IC(a, b);
    };

    FC("airplay", new LC());
    cC("airplay", new LC());

    function MC(a, b, c) {
      this.i = a;
      this.j = b;
      this.h = NC(this);
      b.dataset.shakaPlayerContainer = "";
      b.ui = this;
      this.Gf() && b.classList.add("shaka-mobile");
      this.g = new Z(a, b, c, this.h);
      this.configure({});
      c.controls || a.mg(b);
      b.ui = this;
      c.ui = this;
    }

    p = MC.prototype;

    p.destroy = function () {
      var a = this;
      return K(function (b) {
        if (1 == b.g) return a.g ? D(b, a.g.destroy(), 2) : b.F(2);
        if (4 != b.g) return a.g = null, a.i ? D(b, a.i.destroy(), 4) : b.F(4);
        a.i = null;
        F(b);
      });
    };

    p.Gf = function () {
      return /(?:iPhone|iPad|iPod|Android)/.test(navigator.userAgent) ? !0 : Qd() && 1 < navigator.maxTouchPoints;
    };

    p.getConfiguration = function () {
      var a = NC(this);
      Pl(a, this.h, NC(this), {}, "");
      return a;
    };

    p.configure = function (a, b) {
      2 == arguments.length && "string" == typeof a && (a = Ql(a, b));
      Pl(this.h, a, NC(this), {}, "");
      this.h.castReceiverAppId && !this.h.overflowMenuButtons.includes("cast") && this.h.overflowMenuButtons.push("cast");
      this.g.configure(this.h);
      this.g.dispatchEvent(new N("uiupdated"));
    };

    p.Qh = function () {
      return this.g;
    };

    p.hj = function (a) {
      this.g.gg(a);
    };

    function NC(a) {
      var b = {
        controlPanelElements: "play_pause time_and_duration spacer mute volume fullscreen overflow_menu".split(" "),
        overflowMenuButtons: "captions quality language picture_in_picture cast playback_rate".split(" "),
        statisticsList: "width height corruptedFrames decodedFrames droppedFrames drmTimeSeconds licenseTime liveLatency loadLatency bufferingTime manifestTimeSeconds estimatedBandwidth streamBandwidth maxSegmentDuration pauseTime playTime completionPercent".split(" "),
        contextMenuElements: ["loop", "picture_in_picture", "statistics"],
        playbackRates: [.5, .75, 1, 1.25, 1.5, 1.75, 2],
        fastForwardRates: [2, 4, 8, 1],
        rewindRates: [-1, -2, -4, -8],
        addSeekBar: !0,
        addBigPlayButton: !1,
        customContextMenu: !1,
        castReceiverAppId: "",
        castAndroidReceiverCompatible: !1,
        clearBufferOnQualityChange: !0,
        showUnbufferedStart: !1,
        seekBarColors: {
          base: "rgba(255, 255, 255, 0.3)",
          buffered: "rgba(255, 255, 255, 0.54)",
          played: "rgb(255, 255, 255)",
          adBreaks: "rgb(255, 204, 0)",
          chapterMarks: "rgb(27, 27, 27)",
          chapterLabels: "rgb(255, 255, 255)"
        },
        volumeBarColors: {
          base: "rgba(255, 255, 255, 0.54)",
          level: "rgb(255, 255, 255)"
        },
        trackLabelFormat: OC,
        fadeDelay: 0,
        doubleClickForFullscreen: !0,
        singleClickForPlayAndPause: !0,
        enableKeyboardPlaybackControls: !0,
        enableFullscreenOnRotation: !0,
        forceLandscapeOnFullscreen: !0,
        enableTooltips: !1,
        keyboardSeekDistance: 5,
        keyboardLargeSeekDistance: 60,
        fullScreenElement: a.j,
        preferDocumentPictureInPicture: !0,
        showAudioChannelCountVariants: !0,
        seekOnTaps: !0,
        tapSeekDistance: 10
      };
      "remote" in HTMLMediaElement.prototype ? b.overflowMenuButtons.push("remote") : window.WebKitPlaybackTargetAvailabilityEvent && b.overflowMenuButtons.push("airplay");
      a.Gf() && (b.addBigPlayButton = !0, b.controlPanelElements = b.controlPanelElements.filter(function (c) {
        return "play_pause" != c && "volume" != c;
      }));
      return b;
    }

    function PC() {
      var a, b, c, d, e, f, g, h, k, l, m, n, r, q, u, v, y, z, x, B, A;
      return K(function (C) {
        switch (C.g) {
          case 1:
            tx();
            if (!tm()) return QC("shaka-ui-load-failed", RC), C.return();
            a = document.querySelectorAll("[data-shaka-player-container]");
            b = document.querySelectorAll("[data-shaka-player]");
            c = document.querySelectorAll("[data-shaka-player-canvas]");

            if (!b.length && !a.length) {
              C.F(2);
              break;
            }

            if (b.length && !a.length) {
              d = t(b);

              for (e = d.next(); !e.done; e = d.next()) if (f = e.value, !f.ui) {
                g = document.createElement("div");
                h = f.parentElement;
                h.replaceChild(g, f);
                g.appendChild(f);
                k = null;
                l = t(c);

                for (m = l.next(); !m.done; m = l.next()) if (n = m.value, n.parentElement == g) {
                  k = n;
                  break;
                }

                k || (k = document.createElement("canvas"), k.classList.add("shaka-canvas-container"), g.appendChild(k));
                SC(g, f, k);
              }

              C.F(2);
              break;
            }

            r = t(a);
            q = r.next();

          case 4:
            if (q.done) {
              C.F(2);
              break;
            }

            u = q.value;

            if (u.ui) {
              C.F(5);
              break;
            }

            v = null;
            y = t(b);

            for (e = y.next(); !e.done; e = y.next()) if (z = e.value, z.parentElement == u) {
              v = z;
              break;
            }

            v || (v = document.createElement("video"), v.setAttribute("playsinline", ""), u.appendChild(v));
            x = null;
            B = t(c);

            for (m = B.next(); !m.done; m = B.next()) if (A = m.value, A.parentElement == u) {
              x = A;
              break;
            }

            x || (x = document.createElement("canvas"), x.classList.add("shaka-canvas-container"), u.appendChild(x));
            ta(C, 7);
            return D(C, SC(u, v, x), 9);

          case 9:
            va(C, 5);
            break;

          case 7:
            return wa(C), QC("shaka-ui-load-failed", TC), C.return();

          case 5:
            q = r.next();
            C.F(4);
            break;

          case 2:
            QC("shaka-ui-loaded"), F(C);
        }
      });
    }

    function QC(a, b) {
      var c = null;
      void 0 != b && (c = {
        reasonCode: b
      });
      a = new CustomEvent(a, {
        detail: c
      });
      document.dispatchEvent(a);
    }

    function SC(a, b, c) {
      var d, e, f, g, h, k, l, m, n;
      return K(function (r) {
        switch (r.g) {
          case 1:
            d = new W();
            e = new MC(d, a, b);
            d.yg(c);
            f = "";
            g = !1;
            a.dataset && a.dataset.shakaPlayerCastReceiverId ? (f = a.dataset.shakaPlayerCastReceiverId, g = "true" === a.dataset.shakaPlayerCastAndroidReceiverCompatible) : b.dataset && b.dataset.shakaPlayerCastReceiverId && (f = b.dataset.shakaPlayerCastReceiverId, g = "true" === b.dataset.shakaPlayerCastAndroidReceiverCompatible);
            f.length && e.configure({
              castReceiverAppId: f,
              castAndroidReceiverCompatible: g
            });
            b.controls && e.g.ih(!0);
            if (h = b.getAttribute("src")) k = document.createElement("source"), k.setAttribute("src", h), b.appendChild(k), b.removeAttribute("src");
            l = t(b.querySelectorAll("source"));
            m = l.next();

          case 2:
            if (m.done) {
              r.F(4);
              break;
            }

            n = m.value;
            ta(r, 5);
            return D(r, e.g.Hc().load(n.getAttribute("src")), 7);

          case 7:
            r.F(4);
            break;

          case 5:
            wa(r);

          case 3:
            m = l.next();
            r.F(2);
            break;

          case 4:
            return D(r, d.Cc(b), 0);
        }
      });
    }

    M("shaka.ui.Overlay", MC);
    MC.prototype.setEnabled = MC.prototype.hj;
    MC.prototype.getControls = MC.prototype.Qh;
    MC.prototype.configure = MC.prototype.configure;
    MC.prototype.getConfiguration = MC.prototype.getConfiguration;
    MC.prototype.isMobile = MC.prototype.Gf;
    MC.prototype.destroy = MC.prototype.destroy;
    var OC = 0;
    MC.TrackLabelFormat = {
      LANGUAGE: OC,
      ROLE: 1,
      LANGUAGE_ROLE: 2,
      LABEL: 3
    };
    var RC = 0,
        TC = 1;
    MC.FailReasonCode = {
      NO_BROWSER_SUPPORT: RC,
      PLAYER_FAILED_TO_LOAD: TC
    };
    "complete" == document.readyState ? K(function (a) {
      if (1 == a.g) return D(a, Promise.resolve(), 2);
      PC();
      F(a);
    }) : window.addEventListener("load", PC);

    function UC(a, b, c, d, e, f, g, h) {
      function k(H) {
        var G = "";
        5 <= H && (G = " " + f.resolve("SURROUND"));
        return G;
      }

      function l(H, G, I, J) {
        H = [H, G];
        h && null != J && H.push(J);
        I && 3 == g && H.push(I);
        return H.join(": ");
      }

      function m(H) {
        return "variant" == H.type ? H.audioRoles ? H.audioRoles.join(", ") : void 0 : H.roles.join(", ");
      }

      var n = a.find(function (H) {
        return 1 == H.active;
      }),
          r = oB(b);
      fl(b);
      b.appendChild(r);
      r = new Map();

      for (var q = t(a), u = q.next(); !u.done; u = q.next()) u = u.value, r.has(u.language) || r.set(u.language, new Set()), r.get(u.language).add(m(u));

      r = new Set();
      n = n ? l(n.language, m(n), n.label, n.channelsCount) : "";
      q = {};
      a = t(a);

      for (u = a.next(); !u.done; q = {
        pb: q.pb
      }, u = a.next()) {
        q.pb = u.value;
        u = q.pb.language;
        var v = q.pb.forced,
            y = f.resolve("SUBTITLE_FORCED"),
            z = m(q.pb),
            x = q.pb.label,
            B = q.pb.channelsCount,
            A = l(u, z, x, B);

        if (!r.has(A)) {
          r.add(A);
          var C = el();
          C.addEventListener("click", function (H) {
            return function () {
              c(H.pb);
            };
          }(q));
          var E = T("span");
          C.appendChild(E);
          E.textContent = VC(u, f);

          switch (g) {
            case OC:
              h && (E.textContent += k(B));
              v && (E.textContent += " (" + y + ")");
              break;

            case 1:
              h && (E.textContent += k(B));
              z ? E.textContent = z : (Ua("Track #" + q.pb.id + " does not have a role, but the UI is configured to only show role."), E.textContent = "?");
              v && (E.textContent += " (" + y + ")");
              break;

            case 2:
              h && (E.textContent += k(B));
              z && (E.textContent += ": " + z);
              v && (E.textContent += " (" + y + ")");
              break;

            case 3:
              x ? E.textContent = x : (Ua("Track #" + q.pb.id + " does not have a label, but the UI is configured to only show labels."), E.textContent = "?");
          }

          d && A == n && (C.appendChild(rB()), E.classList.add("shaka-chosen-item"), C.ariaSelected = "true", e.textContent = E.textContent);
          b.appendChild(C);
        }
      }
    }

    function VC(a, b) {
      if (!a && !b) return "";

      switch (a) {
        case "mul":
          return b.resolve("MULTIPLE_LANGUAGES");

        case "und":
          return b.resolve("UNDETERMINED_LANGUAGE");

        case "zxx":
          return b.resolve("NOT_APPLICABLE");
      }

      var c = Vb(a);
      return a in jB ? jB[a].A : c in jB ? jB[c].A + " (" + a + ")" : b.resolve("UNRECOGNIZED_LANGUAGE") + " (" + a + ")";
    }

    ;

    function WC(a, b, c) {
      nB.call(this, a, b);
      var d = this;
      XC(this, c);
      YC(this);
      ZC(this);
      this.eventManager.o(this.button, "click", function () {
        d.menu.classList.contains("shaka-hidden") ? (d.controls.dispatchEvent(new N("submenuopen")), sB(d.menu, !0), qB(d.menu)) : sB(d.menu, !1);
      });
    }

    pa(WC, nB);

    function XC(a, b) {
      a.button = el();
      a.button.classList.add("shaka-overflow-button");
      a.icon = T("i");
      a.icon.classList.add("material-icons-round");
      a.icon.textContent = b;
      a.button.appendChild(a.icon);
      b = T("label");
      b.classList.add("shaka-overflow-button-label");
      b.classList.add("shaka-overflow-menu-only");
      a.nameSpan = T("span");
      b.appendChild(a.nameSpan);
      a.currentSelection = T("span");
      a.currentSelection.classList.add("shaka-current-selection-span");
      b.appendChild(a.currentSelection);
      a.button.appendChild(b);
      a.parent.appendChild(a.button);
    }

    function YC(a) {
      a.menu = T("div");
      a.menu.classList.add("shaka-no-propagation");
      a.menu.classList.add("shaka-show-controls-on-mouse-over");
      a.menu.classList.add("shaka-settings-menu");
      a.menu.classList.add("shaka-hidden");
      a.backButton = el();
      a.backButton.classList.add("shaka-back-to-overflow-button");
      a.menu.appendChild(a.backButton);
      a.eventManager.o(a.backButton, "click", function () {
        a.controls.pc();
      });
      var b = T("i");
      b.classList.add("material-icons-round");
      b.textContent = "close";
      a.backButton.appendChild(b);
      a.backSpan = T("span");
      a.backButton.appendChild(a.backSpan);
      a.controls.h.appendChild(a.menu);
    }

    function ZC(a) {
      a.parent.classList.contains("shaka-overflow-menu") && (a.backButton.firstChild.textContent = "arrow_back", a.eventManager.o(a.backButton, "click", function () {
        function b(c) {
          return 0 == c.classList.contains("shaka-hidden");
        }

        sB(a.parent, !0);
        gb(a.parent.childNodes, b) && hb(a.parent.childNodes, b)[0].focus();
        XB(a.controls);
      }));
    }

    M("shaka.ui.SettingsMenu", WC);

    function $C(a, b) {
      WC.call(this, a, b, "language");
      var c = this;
      this.button.classList.add("shaka-language-button");
      this.button.classList.add("shaka-tooltip-status");
      this.menu.classList.add("shaka-audio-languages");
      this.eventManager.o(this.localization, "locale-updated", function () {
        aD(c);
      });
      this.eventManager.o(this.localization, "locale-changed", function () {
        aD(c);
      });
      this.eventManager.o(this.player, "trackschanged", function () {
        var d = 0 < c.player.hb().length;
        sB(c.button, d);
        bD(c);
      });
      this.eventManager.o(this.player, "variantchanged", function () {
        bD(c);
      });
      aD(this);
      bD(this);
    }

    pa($C, WC);

    function bD(a) {
      var b = a.player.hb();
      UC(b, a.menu, function (c) {
        c.channelsCount && a.controls.g.showAudioChannelCountVariants ? a.player.De(c.language, c.roles[0], c.channelsCount) : a.player.De(c.language, c.roles[0]);
      }, !0, a.currentSelection, a.localization, a.controls.g.trackLabelFormat, a.controls.g.showAudioChannelCountVariants);
      qB(a.menu);
      a.controls.dispatchEvent(new N("languageselectionupdated"));
      a.button.setAttribute("shaka-status", a.currentSelection.innerText);
      sB(a.button, 2 < a.menu.getElementsByTagName("button").length);
    }

    function aD(a) {
      a.backButton.ariaLabel = a.localization.resolve("BACK");
      a.button.ariaLabel = a.localization.resolve("LANGUAGE");
      a.nameSpan.textContent = a.localization.resolve("LANGUAGE");
      a.backSpan.textContent = a.localization.resolve("LANGUAGE");
    }

    M("shaka.ui.AudioLanguageSelection", $C);

    function cD() {}

    cD.prototype.create = function (a, b) {
      return new $C(a, b);
    };

    FC("language", new cD());
    cC("language", new cD());

    function dD(a, b) {
      nB.call(this, a, b);
      var c = this;
      this.h = this.controls.C;
      this.g = el();
      this.g.classList.add("shaka-cast-button");
      this.g.classList.add("shaka-tooltip");
      this.g.ariaPressed = "false";
      this.i = T("i");
      this.i.classList.add("material-icons-round");
      this.i.textContent = "cast";
      this.g.appendChild(this.i);
      a = T("label");
      a.classList.add("shaka-overflow-button-label");
      a.classList.add("shaka-overflow-menu-only");
      this.l = T("span");
      a.appendChild(this.l);
      this.j = T("span");
      this.j.classList.add("shaka-current-selection-span");
      a.appendChild(this.j);
      this.g.appendChild(a);
      this.parent.appendChild(this.g);
      eD(this);
      fD(this);
      this.eventManager.o(this.localization, "locale-updated", function () {
        eD(c);
      });
      this.eventManager.o(this.localization, "locale-changed", function () {
        eD(c);
      });
      this.eventManager.o(this.g, "click", function () {
        gD(c);
      });
      this.eventManager.o(this.controls, "caststatuschanged", function () {
        fD(c);
      });
    }

    pa(dD, nB);

    function gD(a) {
      var b;
      K(function (c) {
        if (1 == c.g) {
          if (a.h.Fa()) return a.h.oh(), c.F(0);
          ta(c, 3);
          a.g.disabled = !0;
          return D(c, a.h.cast(), 5);
        }

        if (3 != c.g) return a.g.disabled = !1, va(c, 0);
        b = wa(c);
        a.g.disabled = !1;
        8004 != b.code && a.controls.dispatchEvent(new N("error", new Map().set("detail", b)));
        F(c);
      });
    }

    function fD(a) {
      var b = a.h.Ze() && a.controls.ua,
          c = a.h.Fa();
      sB(a.g, b);
      a.i.textContent = c ? "cast_connected" : "cast";
      b && (a.g.ariaPressed = c ? "true" : "false");
      hD(a);
    }

    function hD(a) {
      a.j.textContent = a.h.Fa() ? a.h.Be() : a.localization.resolve("OFF");
    }

    function eD(a) {
      a.g.ariaLabel = a.localization.resolve("CAST");
      a.l.textContent = a.localization.resolve("CAST");
      hD(a);
    }

    M("shaka.ui.CastButton", dD);

    function iD() {}

    iD.prototype.create = function (a, b) {
      return new dD(a, b);
    };

    FC("cast", new iD());
    cC("cast", new iD());

    function jD(a, b) {
      nB.call(this, a, b);
      var c = this;
      this.g = el();
      this.g.classList.add("material-icons-round");
      this.g.classList.add("shaka-fast-forward-button");
      this.g.classList.add("shaka-tooltip-status");
      this.g.setAttribute("shaka-status", "1x");
      this.g.textContent = "fast_forward";
      this.parent.appendChild(this.g);
      kD(this);
      this.h = this.controls.g.fastForwardRates;
      this.eventManager.o(this.localization, "locale-updated", function () {
        kD(c);
      });
      this.eventManager.o(this.localization, "locale-changed", function () {
        kD(c);
      });
      this.eventManager.o(this.g, "click", function () {
        if (c.video.duration) {
          var d = c.h.indexOf(c.player.Ub()) + 1;
          d = d != c.h.length ? c.h[d] : c.h[0];
          c.player.Ld(d);
          c.g.setAttribute("shaka-status", d + "x");
        }
      });
    }

    pa(jD, nB);

    function kD(a) {
      a.g.ariaLabel = a.localization.resolve("FAST_FORWARD");
    }

    M("shaka.ui.FastForwardButton", jD);

    function lD() {}

    lD.prototype.create = function (a, b) {
      return new jD(a, b);
    };

    cC("fast_forward", new lD());

    function mD(a, b) {
      nB.call(this, a, b);
      var c = this;
      this.h = this.controls.s;
      this.g = el();
      this.g.classList.add("shaka-fullscreen-button");
      this.g.classList.add("material-icons-round");
      this.g.classList.add("shaka-tooltip");
      nD(this);
      this.g.textContent = "fullscreen";
      this.parent.appendChild(this.g);
      oD(this);
      this.eventManager.o(this.localization, "locale-updated", function () {
        oD(c);
      });
      this.eventManager.o(this.localization, "locale-changed", function () {
        oD(c);
      });
      this.eventManager.o(this.g, "click", function () {
        return K(function (d) {
          return D(d, c.controls.Ge(), 0);
        });
      });
      this.eventManager.o(document, "fullscreenchange", function () {
        c.g.textContent = c.controls.Mc() ? "fullscreen_exit" : "fullscreen";
        oD(c);
      });
      this.eventManager.o(this.h, "loadedmetadata", function () {
        nD(c);
      });
      this.eventManager.o(this.h, "loadeddata", function () {
        nD(c);
      });
    }

    pa(mD, nB);

    function nD(a) {
      a.controls.xd() ? a.g.classList.remove("shaka-hidden") : a.g.classList.add("shaka-hidden");
    }

    function oD(a) {
      a.g.ariaLabel = a.localization.resolve(a.controls.Mc() ? "EXIT_FULL_SCREEN" : "FULL_SCREEN");
    }

    M("shaka.ui.FullscreenButton", mD);

    function pD() {}

    pD.prototype.create = function (a, b) {
      return new mD(a, b);
    };

    cC("fullscreen", new pD());

    function qD(a, b) {
      nB.call(this, a, b);
      var c = this;
      this.g = el();
      this.g.classList.add("shaka-loop-button");
      this.g.classList.add("shaka-tooltip");
      this.i = T("i");
      this.i.classList.add("material-icons-round");
      this.i.textContent = "repeat";
      this.g.appendChild(this.i);
      a = T("label");
      a.classList.add("shaka-overflow-button-label");
      a.classList.add("shaka-overflow-menu-only");
      this.j = T("span");
      this.j.textContent = this.localization.resolve("LOOP");
      a.appendChild(this.j);
      this.l = T("span");
      this.l.classList.add("shaka-current-selection-span");
      a.appendChild(this.l);
      this.g.appendChild(a);
      rD(this);
      this.parent.appendChild(this.g);
      this.eventManager.o(this.localization, "locale-updated", function () {
        rD(c);
      });
      this.eventManager.o(this.localization, "locale-changed", function () {
        rD(c);
      });
      this.eventManager.o(this.g, "click", function () {
        c.video.loop = !c.video.loop;
        c.h.Ma();
        c.h.ya(1);
      });
      this.m = this.video.loop;
      this.h = new Fd(function () {
        c.m != c.video.loop && (rD(c), c.m = c.video.loop);
      });
      this.h.ya(1);
    }

    pa(qD, nB);

    qD.prototype.release = function () {
      this.h.stop();
      this.h = null;
      nB.prototype.release.call(this);
    };

    function rD(a) {
      a.j.textContent = a.localization.resolve("LOOP");
      a.l.textContent = a.localization.resolve(a.video.loop ? "ON" : "OFF");
      a.i.textContent = a.video.loop ? "repeat_on" : "repeat";
      a.g.ariaLabel = a.localization.resolve(a.video.loop ? "EXIT_LOOP_MODE" : "ENTER_LOOP_MODE");
    }

    M("shaka.ui.LoopButton", qD);

    function sD() {}

    sD.prototype.create = function (a, b) {
      return new qD(a, b);
    };

    FC("loop", new sD());
    cC("loop", new sD());
    DB("loop", new sD());

    function tD(a, b) {
      nB.call(this, a, b);
      var c = this;
      this.g = el();
      this.g.classList.add("shaka-mute-button");
      this.g.classList.add("material-icons-round");
      this.g.classList.add("shaka-tooltip");
      this.parent.appendChild(this.g);
      uD(this);
      vD(this);
      this.eventManager.o(this.localization, "locale-updated", function () {
        uD(c);
      });
      this.eventManager.o(this.localization, "locale-changed", function () {
        uD(c);
      });
      this.eventManager.o(this.g, "click", function () {
        c.ad && c.ad.isLinear() ? c.ad.setMuted(!c.ad.isMuted()) : c.video.muted = !c.video.muted;
      });
      this.eventManager.o(this.video, "volumechange", function () {
        uD(c);
        vD(c);
      });
      this.eventManager.o(this.adManager, "ad-volume-changed", function () {
        uD(c);
        vD(c);
      });
      this.eventManager.o(this.adManager, "ad-muted", function () {
        uD(c);
        vD(c);
      });
      this.eventManager.o(this.adManager, "ad-stopped", function () {
        c.ad = null;
        uD(c);
        vD(c);
      });
    }

    pa(tD, nB);

    function uD(a) {
      var b = a.ad ? a.ad.isMuted() ? "UNMUTE" : "MUTE" : a.video.muted ? "UNMUTE" : "MUTE";
      a.g.ariaLabel = a.localization.resolve(b);
    }

    function vD(a) {
      var b = a.ad ? a.ad.isMuted() ? "volume_off" : "volume_up" : a.video.muted ? "volume_off" : "volume_up";
      a.g.textContent = b;
    }

    M("shaka.ui.MuteButton", tD);

    function wD() {}

    wD.prototype.create = function (a, b) {
      return new tD(a, b);
    };

    cC("mute", new wD());

    function xD(a, b) {
      nB.call(this, a, b);
      var c = this;
      this.l = this.controls.s;
      this.g = el();
      this.g.classList.add("shaka-pip-button");
      this.g.classList.add("shaka-tooltip");
      this.i = T("i");
      this.i.classList.add("material-icons-round");
      this.i.textContent = "picture_in_picture_alt";
      this.g.appendChild(this.i);
      a = T("label");
      a.classList.add("shaka-overflow-button-label");
      a.classList.add("shaka-overflow-menu-only");
      this.j = T("span");
      this.j.textContent = this.localization.resolve("PICTURE_IN_PICTURE");
      a.appendChild(this.j);
      this.h = T("span");
      this.h.classList.add("shaka-current-selection-span");
      a.appendChild(this.h);
      this.g.appendChild(a);
      yD(this);
      this.parent.appendChild(this.g);
      this.controls.Nc() || sB(this.g, !1);
      this.eventManager.o(this.localization, "locale-updated", function () {
        yD(c);
      });
      this.eventManager.o(this.localization, "locale-changed", function () {
        yD(c);
      });
      this.eventManager.o(this.g, "click", function () {
        c.controls.He();
      });
      this.eventManager.o(this.l, "enterpictureinpicture", function () {
        zD(c);
      });
      this.eventManager.o(this.l, "leavepictureinpicture", function () {
        AD(c);
      });
      this.eventManager.o(this.controls, "caststatuschanged", function (d) {
        d.newStatus ? c.controls.Nc() && sB(c.g, !1) : c.controls.Nc() && sB(c.g, !0);
      });
      this.eventManager.o(this.player, "trackschanged", function () {
        BD(c);
      });
      "documentPictureInPicture" in window && this.eventManager.o(window.documentPictureInPicture, "enter", function (d) {
        zD(c);
        c.eventManager.na(d.window, "pagehide", function () {
          AD(c);
        });
      });
    }

    pa(xD, nB);

    function zD(a) {
      a.i.textContent = "branding_watermark";
      a.g.ariaLabel = a.localization.resolve("EXIT_PICTURE_IN_PICTURE");
      a.h.textContent = a.localization.resolve("ON");
    }

    function AD(a) {
      a.i.textContent = "picture_in_picture_alt";
      a.g.ariaLabel = a.localization.resolve("ENTER_PICTURE_IN_PICTURE");
      a.h.textContent = a.localization.resolve("OFF");
    }

    function yD(a) {
      a.j.textContent = a.localization.resolve("PICTURE_IN_PICTURE");
      var b = a.controls.Hf();
      a.g.ariaLabel = a.localization.resolve(b ? "EXIT_PICTURE_IN_PICTURE" : "ENTER_PICTURE_IN_PICTURE");
      a.h.textContent = a.localization.resolve(b ? "ON" : "OFF");
    }

    function BD(a) {
      K(function (b) {
        if (!a.controls.Nc()) return sB(a.g, !1), b.F(0);
        if (!a.player || !a.player.Lc()) return sB(a.g, !0), b.F(0);
        sB(a.g, !1);
        return a.controls.Hf() ? D(b, a.controls.He(), 0) : b.F(0);
      });
    }

    M("shaka.ui.PipButton", xD);

    function CD() {}

    CD.prototype.create = function (a, b) {
      return new xD(a, b);
    };

    FC("picture_in_picture", new CD());
    cC("picture_in_picture", new CD());
    DB("picture_in_picture", new CD());

    function DD(a, b) {
      WC.call(this, a, b, "slow_motion_video");
      var c = this;
      this.button.classList.add("shaka-playbackrate-button");
      this.menu.classList.add("shaka-playback-rates");
      this.button.classList.add("shaka-tooltip-status");
      this.eventManager.o(this.localization, "locale-updated", function () {
        ED(c);
      });
      this.eventManager.o(this.localization, "locale-changed", function () {
        ED(c);
      });
      this.eventManager.o(this.player, "ratechange", function () {
        FD(c, c.player.Ub());
      });
      this.g = new Map(this.controls.g.playbackRates.map(function (d) {
        return [d + "x", d];
      }));
      ED(this);
      GD(this);
      FD(this, this.player.Ub());
    }

    pa(DD, WC);

    function ED(a) {
      a.backButton.ariaLabel = a.localization.resolve("BACK");
      a.button.ariaLabel = a.localization.resolve("PLAYBACK_RATE");
      a.nameSpan.textContent = a.localization.resolve("PLAYBACK_RATE");
      a.backSpan.textContent = a.localization.resolve("PLAYBACK_RATE");
    }

    function FD(a, b) {
      var c = pB(a.menu, "material-icons-round shaka-chosen-item");

      if (c) {
        var d = c.parentElement;
        d.removeAttribute("aria-selected");
        d.getElementsByTagName("span")[0].classList.remove("shaka-chosen-item");
        d.removeChild(c);
      }

      if (c = Array.from(a.menu.querySelectorAll("span")).find(function (e) {
        return a.g.get(e.textContent) == b;
      })) d = c.parentElement, d.appendChild(rB()), d.ariaSelected = "true", c.classList.add("shaka-chosen-item");
      a.currentSelection.textContent = b + "x";
      a.button.setAttribute("shaka-status", b + "x");
    }

    function GD(a) {
      for (var b = {}, c = t(a.g.keys()), d = c.next(); !d.done; b = {
        $c: b.$c
      }, d = c.next()) {
        b.$c = d.value;
        d = el();
        var e = T("span");
        e.textContent = b.$c;
        d.appendChild(e);
        a.eventManager.o(d, "click", function (f) {
          return function () {
            a.video.playbackRate = a.g.get(f.$c);
            a.video.defaultPlaybackRate = a.g.get(f.$c);
          };
        }(b));
        a.menu.appendChild(d);
      }

      qB(a.menu);
    }

    M("shaka.ui.PlaybackRateSelection", DD);

    function HD() {}

    HD.prototype.create = function (a, b) {
      return new DD(a, b);
    };

    FC("playback_rate", new HD());
    cC("playback_rate", new HD());

    function ID(a, b) {
      nB.call(this, a, b);
      var c = this;
      this.g = el();
      this.g.classList.add("shaka-current-time");
      JD(this, "0:00");
      this.parent.appendChild(this.g);
      this.eventManager.o(this.g, "click", function () {
        c.player.S() && (c.video.currentTime = c.player.Ga().end);
      });
      this.eventManager.o(this.controls, "timeandseekrangeupdated", function () {
        var d = c.controls.V,
            e = c.controls.Af(),
            f = c.player.Ga(),
            g = f.end - f.start;
        c.player.S() ? (e = Math.max(0, Math.floor(f.end - e)), g = 3600 <= g, 1 <= e || d ? (JD(c, "- " + tB(e, g)), c.g.disabled = !1) : (JD(c, c.localization.resolve("LIVE")), c.g.disabled = !0)) : (d = 3600 <= g, e = tB(Math.max(0, e - f.start), d), g && (e += " / " + tB(g, d)), JD(c, e), c.g.disabled = !0);
      });
      this.eventManager.o(this.player, "trackschanged", function () {
        c.player.S() && (c.g.ariaLabel = c.localization.resolve("SKIP_TO_LIVE"));
      });
    }

    pa(ID, nB);

    function JD(a, b) {
      b != a.g.textContent && (a.g.textContent = b);
    }

    M("shaka.ui.PresentationTimeTracker", ID);

    function KD() {}

    KD.prototype.create = function (a, b) {
      return new ID(a, b);
    };

    cC("time_and_duration", new KD());

    function LD(a, b) {
      nB.call(this, a, b);
      var c = this;
      this.g = el();
      this.g.classList.add("shaka-remote-button");
      this.g.classList.add("shaka-tooltip");
      this.g.ariaPressed = "false";
      this.i = T("i");
      this.i.classList.add("material-icons-round");
      a = "cast";
      (b = Sd()) && 13 <= b && (a = "airplay");
      this.i.textContent = a;
      this.g.appendChild(this.i);
      a = T("label");
      a.classList.add("shaka-overflow-button-label");
      a.classList.add("shaka-overflow-menu-only");
      this.l = T("span");
      a.appendChild(this.l);
      this.j = T("span");
      this.j.classList.add("shaka-current-selection-span");
      a.appendChild(this.j);
      this.g.appendChild(a);
      this.parent.appendChild(this.g);
      this.h = -1;
      MD(this);
      sB(this.g, !1);
      !this.video.remote || this.video.disableRemotePlayback ? this.g.classList.add("shaka-hidden") : (this.eventManager.o(this.localization, "locale-updated", function () {
        MD(c);
      }), this.eventManager.o(this.localization, "locale-changed", function () {
        MD(c);
      }), this.eventManager.o(this.controls, "caststatuschanged", function () {
        ND(c);
      }), this.eventManager.o(this.g, "click", function () {
        c.video.remote.prompt();
      }), this.eventManager.o(this.video.remote, "connect", function () {
        ND(c);
      }), this.eventManager.o(this.video.remote, "connecting", function () {
        ND(c);
      }), this.eventManager.o(this.video.remote, "disconnect", function () {
        ND(c);
      }), this.eventManager.o(this.player, "loaded", function () {
        ND(c);
      }), ND(this));
    }

    pa(LD, nB);

    LD.prototype.release = function () {
      this.video.remote && -1 != this.h && this.video.remote.cancelWatchAvailability(this.h).catch(function () {});
      nB.prototype.release.call(this);
    };

    function ND(a) {
      var b, c;
      K(function (d) {
        switch (d.g) {
          case 1:
            if (a.controls.C.Ze() && a.controls.ua) {
              sB(a.g, !1);
              -1 != a.h && (a.video.remote.cancelWatchAvailability(a.h), a.h = -1);
              d.F(0);
              break;
            }

            if ("disconnected" == a.video.remote.state) {
              b = function (e) {
                a.player ? sB(a.g, a.player.ee() == ln && e) : sB(a.g, !1);
              };

              ta(d, 7);

              if (-1 == a.h) {
                d.F(9);
                break;
              }

              return D(d, a.video.remote.cancelWatchAvailability(a.h), 10);
            }

            if (-1 == a.h) {
              d.F(0);
              break;
            }

            return D(d, a.video.remote.cancelWatchAvailability(a.h), 6);

          case 6:
            a.h = -1;
            d.F(0);
            break;

          case 10:
            a.h = -1;

          case 9:
            va(d, 8);
            break;

          case 7:
            wa(d);

          case 8:
            return ta(d, 11), D(d, a.video.remote.watchAvailability(b), 13);

          case 13:
            c = d.h;
            a.h = c;
            va(d, 0);
            break;

          case 11:
            wa(d), b(!0), F(d);
        }
      });
    }

    function MD(a) {
      var b = a.localization.resolve("CAST"),
          c = Sd();
      c && 13 <= c && (b = a.localization.resolve("AIRPLAY"));
      a.g.ariaLabel = b;
      a.l.textContent = b;
    }

    M("shaka.ui.RemoteButton", LD);

    function OD() {}

    OD.prototype.create = function (a, b) {
      return new LD(a, b);
    };

    FC("remote", new OD());
    cC("remote", new OD());

    function PD(a, b) {
      WC.call(this, a, b, "settings");
      var c = this;
      this.button.classList.add("shaka-resolution-button");
      this.button.classList.add("shaka-tooltip-status");
      this.menu.classList.add("shaka-resolutions");
      this.eventManager.o(this.localization, "locale-updated", function () {
        QD(c);
      });
      this.eventManager.o(this.localization, "locale-changed", function () {
        QD(c);
      });
      this.eventManager.o(this.player, "variantchanged", function () {
        RD(c);
      });
      this.eventManager.o(this.player, "trackschanged", function () {
        RD(c);
      });
      this.eventManager.o(this.player, "abrstatuschanged", function () {
        RD(c);
      });
      RD(this);
    }

    pa(PD, WC);

    function RD(a) {
      var b = [];
      a.player.ee() != ln && (b = a.player.hb());
      var c = b.find(function (k) {
        return k.active;
      });
      c && (b = b.filter(function (k) {
        return k.language == c.language && k.channelsCount == c.channelsCount;
      }));
      b = b.filter(function (k, l) {
        var m = -1;
        m = a.player.Lc() ? b.findIndex(function (n) {
          return n.bandwidth == k.bandwidth;
        }) : b.findIndex(function (n) {
          return n.height == k.height && n.frameRate == k.frameRate && n.hdr == k.hdr && n.videoLayout == k.videoLayout;
        });
        return m == l;
      });
      a.player.Lc() ? b.sort(function (k, l) {
        return l.bandwidth - k.bandwidth;
      }) : b.sort(function (k, l) {
        return l.height - k.height;
      });
      var d = oB(a.menu);
      fl(a.menu);
      a.menu.appendChild(d);
      d = a.player.getConfiguration().abr.enabled;

      for (var e = {}, f = t(b), g = f.next(); !g.done; e = {
        Ab: e.Ab
      }, g = f.next()) {
        e.Ab = g.value;
        g = el();
        g.classList.add("explicit-resolution");
        a.eventManager.o(g, "click", function (k) {
          return function () {
            var l = k.Ab;
            a.player.configure({
              abr: {
                enabled: !1
              }
            });
            a.player.Ee(l, a.controls.g.clearBufferOnQualityChange);
          };
        }(e));
        var h = T("span");
        h.textContent = a.player.Lc() && e.Ab.bandwidth ? Math.round(e.Ab.bandwidth / 1E3) + " kbits/s" : e.Ab.height && e.Ab.width ? SD(e.Ab) : "Unknown";
        g.appendChild(h);
        d || e.Ab != c || (g.ariaSelected = "true", g.appendChild(rB()), h.classList.add("shaka-chosen-item"), a.currentSelection.textContent = h.textContent);
        a.menu.appendChild(g);
      }

      e = el();
      e.classList.add("shaka-enable-abr-button");
      a.eventManager.o(e, "click", function () {
        a.player.configure({
          abr: {
            enabled: !0
          }
        });
        RD(a);
      });
      a.g = T("span");
      a.g.classList.add("shaka-auto-span");
      a.g.textContent = a.localization.resolve("AUTO_QUALITY");
      e.appendChild(a.g);
      d && (e.ariaSelected = "true", e.appendChild(rB()), a.g.classList.add("shaka-chosen-item"), a.currentSelection.textContent = a.localization.resolve("AUTO_QUALITY"));
      a.button.setAttribute("shaka-status", a.currentSelection.textContent);
      a.menu.appendChild(e);
      qB(a.menu);
      a.controls.dispatchEvent(new N("resolutionselectionupdated"));
      QD(a);
      sB(a.button, 0 < b.length);
    }

    function SD(a) {
      var b = a.height || 0,
          c = a.width || 0,
          d = b;
      c / b > 16 / 9 && (d = Math.round(9 * c / 16));
      b = d + "p";
      2160 == d && (b = "4K");
      (d = a.frameRate) && (50 <= d || 20 >= d) && (b += Math.round(a.frameRate));
      if ("PQ" == a.hdr || "HLG" == a.hdr) b += " (HDR)";
      "CH-STEREO" == a.videoLayout && (b += " (3D)");
      return b;
    }

    function QD(a) {
      var b = a.player.Lc() ? "QUALITY" : "RESOLUTION";
      a.button.ariaLabel = a.localization.resolve(b);
      a.backButton.ariaLabel = a.localization.resolve(b);
      a.backSpan.textContent = a.localization.resolve(b);
      a.nameSpan.textContent = a.localization.resolve(b);
      a.g.textContent = a.localization.resolve("AUTO_QUALITY");
      a.player.getConfiguration().abr.enabled && (a.currentSelection.textContent = a.localization.resolve("AUTO_QUALITY"));
    }

    M("shaka.ui.ResolutionSelection", PD);

    function TD() {}

    TD.prototype.create = function (a, b) {
      return new PD(a, b);
    };

    FC("quality", new TD());
    cC("quality", new TD());

    function UD(a, b) {
      nB.call(this, a, b);
      var c = this;
      this.g = el();
      this.g.classList.add("material-icons-round");
      this.g.classList.add("shaka-rewind-button");
      this.g.classList.add("shaka-tooltip-status");
      this.g.setAttribute("shaka-status", this.localization.resolve("OFF"));
      this.g.textContent = "fast_rewind";
      this.parent.appendChild(this.g);
      VD(this);
      this.h = this.controls.g.rewindRates;
      this.eventManager.o(this.localization, "locale-updated", function () {
        VD(c);
      });
      this.eventManager.o(this.localization, "locale-changed", function () {
        VD(c);
      });
      this.eventManager.o(this.g, "click", function () {
        if (c.video.duration) {
          var d = c.h.indexOf(c.player.Ub()) + 1;
          d = d != c.h.length ? c.h[d] : c.h[0];
          c.player.Ld(d);
          c.g.setAttribute("shaka-status", d + "x");
        }
      });
    }

    pa(UD, nB);

    function VD(a) {
      a.g.ariaLabel = a.localization.resolve("REWIND");
    }

    M("shaka.ui.RewindButton", UD);

    function WD() {}

    WD.prototype.create = function (a, b) {
      return new UD(a, b);
    };

    cC("rewind", new WD());

    function XD(a, b) {
      nB.call(this, a, b);
      var c = this;
      this.j = T("div");
      this.j.classList.add("shaka-skip-ad-container");
      this.parent.appendChild(this.j);
      this.h = T("div");
      this.h.classList.add("shaka-skip-ad-counter");
      sB(this.h, !1);
      this.j.appendChild(this.h);
      this.g = el();
      this.g.classList.add("shaka-skip-ad-button");
      this.g.disabled = !0;
      sB(this.g, !1);
      this.g.classList.add("shaka-no-propagation");
      this.j.appendChild(this.g);
      YD(this);
      this.i = new Fd(function () {
        var d = Math.round(c.ad.getTimeUntilSkippable());
        0 < d ? c.h.textContent = d : (c.i.stop(), sB(c.h, !1));
      });
      this.eventManager.o(this.localization, "locale-updated", function () {
        YD(c);
      });
      this.eventManager.o(this.localization, "locale-changed", function () {
        YD(c);
      });
      this.eventManager.o(this.adManager, "ad-started", function () {
        ZD(c);
      });
      this.eventManager.o(this.adManager, "ad-skip-state-changed", function () {
        c.ad.canSkipNow() && (c.g.disabled = !1, c.i.stop(), sB(c.h, !1));
      });
      this.eventManager.o(this.adManager, "ad-stopped", function () {
        c.i.stop();
        c.g.disabled = !0;
        sB(c.g, !1);
        sB(c.h, !1);
      });
      this.eventManager.o(this.g, "click", function () {
        c.ad.skip();
      });
      this.ad && ZD(this);
    }

    pa(XD, nB);

    XD.prototype.release = function () {
      this.i.stop();
      this.i = null;
      nB.prototype.release.call(this);
    };

    function YD(a) {
      a.g.textContent = a.localization.resolve("SKIP_AD");
    }

    function ZD(a) {
      a.ad.isSkippable() && (sB(a.g, !0), sB(a.h, !0), a.h.textContent = "", a.i.Ma(), a.i.ya(.5));
    }

    M("shaka.ui.SkipAdButton", XD);

    function $D(a, b) {
      xB.call(this, a, b);
      this.button.classList.add("shaka-small-play-button");
      this.button.classList.add("material-icons-round");
      this.button.classList.add("shaka-tooltip");
      this.h();
      this.g();
    }

    pa($D, xB);

    $D.prototype.h = function () {
      this.button.textContent = this.video.ended ? "replay" : this.isPaused() ? "play_arrow" : "pause";
    };

    $D.prototype.g = function () {
      if (this.video.ended) this.button.ariaLabel = this.localization.resolve("REPLAY");else {
        var a = this.isPaused() ? "PLAY" : "PAUSE";
        this.button.ariaLabel = this.localization.resolve(a);
      }
    };

    M("shaka.ui.SmallPlayButton", $D);

    function aE() {}

    aE.prototype.create = function (a, b) {
      return new $D(a, b);
    };

    cC("play_pause", new aE());

    function bE(a, b) {
      nB.call(this, a, b);
      a = T("div");
      a.classList.add("shaka-spacer");
      a.ariaHidden = "true";
      this.parent.appendChild(a);
    }

    pa(bE, nB);
    M("shaka.ui.Spacer", bE);

    function cE() {}

    cE.prototype.create = function (a, b) {
      return new bE(a, b);
    };

    cC("spacer", new cE());

    function dE(a, b) {
      function c(k) {
        return tB(h.h[k], !1) + " (m)";
      }

      function d(k) {
        return Math.round(h.h[k] / 1E3) + " (kbits/s)";
      }

      function e(k) {
        return h.h[k].toFixed(2) + " (s)";
      }

      function f(k) {
        return h.h[k] + " (frames)";
      }

      function g(k) {
        return h.h[k] + " (px)";
      }

      nB.call(this, a, b);
      var h = this;
      this.i = el();
      this.i.classList.add("shaka-statistics-button");
      this.j = T("i");
      this.j.classList.add("material-icons-round");
      this.j.textContent = "insert_chart_outlined";
      this.i.appendChild(this.j);
      a = T("label");
      a.classList.add("shaka-overflow-button-label");
      this.s = T("span");
      a.appendChild(this.s);
      this.m = T("span");
      this.m.classList.add("shaka-current-selection-span");
      a.appendChild(this.m);
      this.i.appendChild(a);
      this.parent.appendChild(this.i);
      this.g = T("div");
      this.g.classList.add("shaka-no-propagation");
      this.g.classList.add("shaka-show-controls-on-mouse-over");
      this.g.classList.add("shaka-statistics-container");
      this.g.classList.add("shaka-hidden");
      this.controls.h.appendChild(this.g);
      this.D = [];
      this.G = ["stateHistory", "switchHistory"];
      this.h = this.player.getStats();
      this.u = {};
      this.C = {
        width: g,
        height: g,
        completionPercent: function (k) {
          return h.h[k] + " (%)";
        },
        bufferingTime: e,
        drmTimeSeconds: e,
        licenseTime: e,
        liveLatency: e,
        loadLatency: e,
        manifestTimeSeconds: e,
        estimatedBandwidth: d,
        streamBandwidth: d,
        maxSegmentDuration: c,
        pauseTime: c,
        playTime: c,
        corruptedFrames: f,
        decodedFrames: f,
        droppedFrames: f,
        stallsDetected: function (k) {
          return h.h[k] + " (stalls)";
        },
        gapsJumped: function (k) {
          return h.h[k] + " (gaps)";
        }
      };
      this.l = new Fd(function () {
        h.h = h.player.getStats();

        for (var k = t(h.D), l = k.next(); !l.done; l = k.next()) l = l.value, h.u[l].textContent = h.C[l](l);
      });
      eE(this);
      fE(this);
      this.eventManager.o(this.localization, "locale-updated", function () {
        eE(h);
      });
      this.eventManager.o(this.localization, "locale-changed", function () {
        eE(h);
      });
      this.eventManager.o(this.i, "click", function () {
        sB(h.parent, !1);
        h.g.classList.contains("shaka-hidden") ? (h.j.textContent = "insert_chart", h.l.ya(.1), sB(h.g, !0)) : (h.j.textContent = "insert_chart_outlined", h.l.stop(), sB(h.g, !1));
        eE(h);
      });
    }

    pa(dE, nB);

    function eE(a) {
      a.s.textContent = a.localization.resolve("STATISTICS");
      a.i.ariaLabel = a.localization.resolve("STATISTICS");
      a.m.textContent = a.localization.resolve(a.g.classList.contains("shaka-hidden") ? "OFF" : "ON");
    }

    function fE(a) {
      for (var b = t(a.controls.g.statisticsList), c = b.next(); !c.done; c = b.next()) if (c = c.value, c in a.h && !a.G.includes(c)) {
        var d = a.g,
            e = d.appendChild,
            f = a,
            g = T("div"),
            h = T("label");
        h.textContent = c + ":";
        g.appendChild(h);
        h = T("span");
        h.textContent = f.C[c](c);
        g.appendChild(h);
        f.u[c] = h;
        e.call(d, g);
        a.D.push(c);
      } else Ua("Unrecognized statistic element:", c);
    }

    dE.prototype.release = function () {
      this.l.stop();
      this.l = null;
      nB.prototype.release.call(this);
    };

    M("shaka.ui.StatisticsButton", dE);

    function gE() {}

    gE.prototype.create = function (a, b) {
      return new dE(a, b);
    };

    FC("statistics", new gE());
    DB("statistics", new gE());

    function hE(a, b) {
      WC.call(this, a, b, "closed_caption");
      var c = this;
      this.button.classList.add("shaka-caption-button");
      this.button.classList.add("shaka-tooltip-status");
      this.menu.classList.add("shaka-text-languages");
      this.player && this.player.tc() ? this.button.ariaPressed = "true" : this.button.ariaPressed = "false";
      iE(this);
      this.eventManager.o(this.localization, "locale-updated", function () {
        jE(c);
        kE(c);
      });
      this.eventManager.o(this.localization, "locale-changed", function () {
        jE(c);
        kE(c);
      });
      this.eventManager.o(this.player, "texttrackvisibility", function () {
        lE(c);
        kE(c);
      });
      this.eventManager.o(this.player, "textchanged", function () {
        kE(c);
      });
      this.eventManager.o(this.player, "trackschanged", function () {
        mE(c);
      });
      lE(this);
      jE(this);
      kE(this);
      mE(this);
    }

    pa(hE, WC);

    function iE(a) {
      var b = el();
      b.ariaSelected = "true";
      a.menu.appendChild(b);
      b.appendChild(rB());
      a.g = T("span");
      a.g.classList.add("shaka-auto-span");
      b.appendChild(a.g);
    }

    function lE(a) {
      a.player.tc() ? (a.icon.textContent = "closed_caption", a.button.ariaPressed = "true") : (a.icon.textContent = "closed_caption_disabled", a.button.ariaPressed = "false");
      a.controls.dispatchEvent(new N("captionselectionupdated"));
    }

    function kE(a) {
      var b = a.player.Xb();
      UC(b, a.menu, function (c) {
        return nE(a, c);
      }, a.player.tc(), a.currentSelection, a.localization, a.controls.g.trackLabelFormat, a.controls.g.showAudioChannelCountVariants);
      b = el();
      b.classList.add("shaka-turn-captions-off-button");
      a.eventManager.o(b, "click", function () {
        a.player.lg(!1);
        kE(a);
      });
      b.appendChild(a.g);
      a.menu.appendChild(b);
      a.player.tc() || (b.ariaSelected = "true", b.appendChild(rB()), a.g.classList.add("shaka-chosen-item"), a.currentSelection.textContent = a.localization.resolve("OFF"));
      a.button.setAttribute("shaka-status", a.currentSelection.textContent);
      qB(a.menu);
      a.controls.dispatchEvent(new N("captionselectionupdated"));
    }

    function nE(a, b) {
      return K(function (c) {
        a.player.eg(b);
        return D(c, a.player.lg(!0), 0);
      });
    }

    function jE(a) {
      a.button.ariaLabel = a.localization.resolve("CAPTIONS");
      a.backButton.ariaLabel = a.localization.resolve("BACK");
      a.nameSpan.textContent = a.localization.resolve("CAPTIONS");
      a.backSpan.textContent = a.localization.resolve("CAPTIONS");
      a.g.textContent = a.localization.resolve("OFF");
    }

    function mE(a) {
      var b = 0 < a.player.Xb().length;
      sB(a.button, b);
      kE(a);
    }

    M("shaka.ui.TextSelection", hE);

    function oE() {}

    oE.prototype.create = function (a, b) {
      return new hE(a, b);
    };

    FC("captions", new oE());
    cC("captions", new oE());

    function pE(a, b) {
      IB.call(this, a, b, ["shaka-volume-bar-container"], ["shaka-volume-bar"]);
      var c = this;
      this.g = this.controls.g;
      this.setRange(0, 100);
      this.eventManager.o(this.video, "volumechange", function () {
        return qE(c);
      });
      this.eventManager.o(this.adManager, "ad-volume-changed", function () {
        return rE(c);
      });
      this.eventManager.o(this.adManager, "ad-muted", function () {
        return rE(c);
      });
      this.eventManager.o(this.adManager, "ad-stopped", function () {
        return qE(c);
      });
      this.eventManager.o(this.localization, "locale-updated", function () {
        return sE(c);
      });
      this.eventManager.o(this.localization, "locale-changed", function () {
        return sE(c);
      });
      qE(this);
      sE(this);
      if (this.ad) this.onChange();
    }

    pa(pE, IB);

    pE.prototype.onChange = function () {
      this.ad && this.ad.isLinear() ? this.ad.setVolume(this.getValue() / 100) : (this.video.volume = this.getValue() / 100, this.video.muted = 0 == this.video.volume ? !0 : !1);
    };

    function qE(a) {
      a.video.muted ? a.setValue(0) : a.setValue(100 * a.video.volume);
      tE(a);
    }

    function rE(a) {
      var b = a.ad.getVolume();
      a.setValue(100 * b);
      tE(a);
    }

    function tE(a) {
      var b = a.g.volumeBarColors,
          c = ["to right"];
      c.push(b.level + a.getValue() + "%");
      c.push(b.base + a.getValue() + "%");
      c.push(b.base + "100%");
      a.container.style.background = "linear-gradient(" + c.join(",") + ")";
    }

    function sE(a) {
      a.bar.ariaLabel = a.localization.resolve("VOLUME");
    }

    M("shaka.ui.VolumeBar", pE);

    function uE() {}

    uE.prototype.create = function (a, b) {
      return new pE(a, b);
    };

    cC("volume", new uE());
  }).call(exportTo, innerGlobal, innerGlobal, undefined);
  if (typeof exports != "undefined") for (var k in exportTo.shaka) exports[k] = exportTo.shaka[k];else if (typeof define == "function" && define.amd) define(function () {
    return exportTo.shaka;
  });else innerGlobal.shaka = exportTo.shaka;
})();